import { jsx as v, jsxs as F, Fragment as je } from "react/jsx-runtime";
import * as w from "react";
import he, { createContext as Pn, useCallback as ct, useState as pe, useEffect as De, useMemo as En, useContext as Ln, forwardRef as ce, useLayoutEffect as uo, useRef as Me, useImperativeHandle as vS, cloneElement as xD, useId as bS, useDebugValue as yS, memo as E0, Fragment as kD } from "react";
import { twMerge as CD } from "tailwind-merge";
import { cva as Ie } from "class-variance-authority";
import * as fs from "react-dom";
import wS, { flushSync as SD } from "react-dom";
function Soe({ className: t }) {
  return /* @__PURE__ */ v(
    "svg",
    {
      width: "100%",
      height: "100%",
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: t,
      "data-testid": "asterisk-logo",
      children: /* @__PURE__ */ v(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.4563 19.0373C21.0627 16.1745 20.6964 13.6369 20.363 11.0993C20.1771 9.69189 19.9584 8.28449 19.8983 6.87175C19.7671 3.42787 21.6804 1.31676 25.108 0.399817C28.705 -0.56511 31.9139 0.351834 35.1447 1.67928C35.8991 1.98848 35.8225 2.42563 35.6913 3.06536C34.508 7.80347 33.7255 12.6283 33.3516 17.4913C33.3516 17.6672 33.3516 17.8431 33.3516 18.2003C35.0354 17.3207 36.331 16.1105 37.7687 15.1083C39.6109 13.8128 41.2728 12.2721 43.2353 11.1206C46.2966 9.30806 49.5547 9.72922 51.9818 12.2721C54.409 14.8151 55.2618 18.0191 55.9725 21.2923C56.1365 22.0547 55.486 22.0174 55.0432 22.1507C50.0182 23.6702 45.0989 25.5043 40.3161 27.6417C40.1268 27.7422 39.9442 27.8544 39.7695 27.9775C43.1642 29.3689 46.395 30.8776 49.7569 32.0292C55.3875 33.959 55.8413 38.4851 53.6711 42.606C52.4739 44.8717 50.5441 46.4924 48.5324 48.0384C47.953 48.4862 47.5594 48.3689 47.0291 47.8891C43.2353 44.4506 39.0697 41.4545 34.8987 38.4744C34.7231 38.4051 34.5396 38.3568 34.352 38.3305C34.7019 40.8201 35.0518 43.2138 35.3634 45.6074C35.5711 47.2068 35.7898 48.7741 35.8718 50.3628C36.0194 53.2949 34.1006 55.5766 31.2251 56.4722C27.4313 57.6504 23.9764 56.6908 20.527 55.278C19.9803 55.0541 20.0131 54.7449 20.1224 54.2118C21.0026 50.0962 21.7296 45.9486 22.2489 41.7744C22.3692 40.8308 22.4075 39.8765 22.5113 38.6024L15.8858 43.5496C15.0166 44.2 14.142 44.8344 13.2837 45.4902C9.93813 48.0491 6.17711 47.0522 3.6898 44.3493C1.44849 41.9077 0.721427 38.821 0.0162334 35.7396C-0.147765 35.0092 0.497297 34.9559 0.923693 34.8226C4.97445 33.5379 8.95414 32.0611 12.9065 30.5098C13.8194 30.1526 14.705 29.7208 15.8475 29.2143C13.9616 28.1481 12.0974 27.663 10.3481 26.906C7.99749 25.8931 5.48285 25.2427 3.3618 23.7073C2.47613 23.1106 1.7794 22.284 1.35046 21.3211C0.921508 20.3583 0.777461 19.2975 0.934621 18.259C1.43208 13.9941 4.0342 11.1046 7.6203 8.90289C8.21069 8.54038 8.42934 8.99885 8.75187 9.27074C12.5107 12.5436 16.4547 15.6084 20.5652 18.4509L21.4563 19.0373Z",
          fill: "currentcolor"
        }
      )
    }
  );
}
function Toe({ className: t }) {
  return /* @__PURE__ */ F(
    "svg",
    {
      width: "105",
      height: "25",
      viewBox: "0 0 105 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: t,
      "data-testid": "asterisk-knack-logo",
      children: [
        /* @__PURE__ */ v(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M99.4239 10.6748L100.294 10.2932C101.196 9.90296 102.142 9.51528 103.11 9.19905L104.249 8.81748C104.38 8.77043 104.64 8.7504 104.718 8.6476H104.744C104.627 8.21201 104.555 7.70325 104.42 7.26505C104.108 6.25536 103.605 5.35892 102.807 4.83012C102.314 4.50343 101.462 4.32397 100.792 4.60971C100.197 4.8641 99.5869 5.41642 99.0857 5.79712C98.5512 6.20309 98.0271 6.62473 97.49 7.01676L96.9528 7.43231H96.9187C96.907 7.31557 96.9156 7.1977 96.9441 7.08384C97.001 6.74409 96.9896 6.41043 97.0466 6.09158L97.1149 5.44691C97.2438 4.70467 97.3226 3.95808 97.49 3.2411L97.7292 2.10858C97.7634 1.98052 97.837 1.78799 97.823 1.65905C97.2907 1.39657 96.7329 1.18902 96.158 1.03965C95.7839 0.946434 95.2914 0.881968 94.8699 0.952533C93.9551 1.11021 93.2812 1.24612 92.8133 1.84287C92.6131 2.09759 92.4643 2.38838 92.3752 2.69923C92.256 3.11478 92.3243 3.69063 92.4006 4.09921L92.5198 5.04094L92.759 6.80507L92.8869 7.67014C92.7423 7.65359 92.6153 7.49591 92.5119 7.42447C92.249 7.23717 91.9861 7.04551 91.7232 6.85647C90.8951 6.25274 90.1459 5.57933 89.3511 4.94773L88.3101 4.02341L88.2593 4.0147L87.4233 4.60884C86.9764 4.95731 86.6093 5.43646 86.314 5.93215C86.1479 6.22934 86.019 6.5456 85.9302 6.87389C85.8355 7.17535 85.8056 7.49324 85.8425 7.80692C85.8907 8.08918 85.903 8.29042 85.9959 8.51082C86.4524 9.5963 87.9044 9.97439 88.9989 10.4361L90.3212 10.9701L90.9863 11.2315V11.2568C90.9065 11.3535 90.7155 11.3909 90.5937 11.4432C90.2686 11.5826 89.9418 11.7281 89.6035 11.8674C88.9901 12.1201 88.3504 12.3788 87.7178 12.614L86.7539 12.9364L85.4911 13.372L85.7041 14.305C86.0125 15.5891 86.5138 16.6214 87.5048 17.2234C87.9605 17.4996 88.7378 17.6991 89.373 17.4438C89.8331 17.2591 90.1924 16.9368 90.5674 16.6598L92.504 15.1666L93.2208 14.5899C93.269 14.6334 93.2383 14.846 93.2208 14.9549L93.1095 16.0578C92.95 16.9168 92.8895 17.7766 92.7082 18.6025L92.3576 20.3666C92.4716 20.4537 92.6337 20.4947 92.7756 20.553C93.1619 20.7286 93.5612 20.8742 93.97 20.9886C94.3678 21.0879 94.9435 21.1629 95.4123 21.0757C95.8207 20.9965 96.1563 20.959 96.4875 20.8214C97.2648 20.499 98.0306 19.6461 97.8186 18.4126L97.7415 17.7513L97.5662 16.3853L97.2849 14.4513V14.4348C97.4339 14.4644 97.5645 14.6177 97.6775 14.6961C97.9851 14.9131 98.2821 15.1378 98.5818 15.3574C99.7374 16.1971 100.84 17.1066 101.884 18.0807C102.048 18.0554 102.601 17.5475 102.754 17.4273C103.535 16.8114 104.702 15.2607 104.238 13.7683C104.158 13.5209 104.037 13.2885 103.88 13.081C103.555 12.6498 103.024 12.4503 102.489 12.2246L100.057 11.2071L99.119 10.8255V10.8168C99.2129 10.7545 99.3157 10.7066 99.4239 10.6748Z",
            fill: "currentcolor"
          }
        ),
        /* @__PURE__ */ v(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24.7459 5.95669C19.4988 5.95669 16.8139 8.54755 16.8139 13.765V24.5431H21.4835V12.832C21.5186 10.932 22.6227 9.99893 24.6767 9.99893C26.7307 9.99893 27.8313 10.932 27.9399 12.832V22.2293C27.9399 23.6807 28.704 24.4403 30.2331 24.544H32.5307V13.765C32.5658 8.54755 29.9939 5.95669 24.7459 5.95669ZM41.5032 5.95669C37.2638 5.95669 34.8654 7.61192 34.3098 11.0008H38.9322C39.1758 10.1375 40.0792 9.72277 41.7126 9.72277C43.6238 9.72277 44.5973 10.2411 44.7016 11.2778C44.7016 12.2797 43.6939 12.8668 41.7126 13.1073C37.0561 13.5568 33.8586 14.7311 33.7543 19.1184C33.7543 23.1606 36.8125 25.1992 41.2263 24.8533C46.1956 24.5048 49.2538 22.2624 49.2538 17.2175V11.0008C49.1487 7.61453 46.5768 5.95669 41.5032 5.95669ZM44.7697 17.013C44.7697 19.6038 43.2056 21.124 40.6346 21.124C39.1747 21.124 38.4106 20.4332 38.3064 18.9818C38.3064 17.6341 39.2448 16.7708 41.0868 16.4249C42.3464 16.1747 43.5789 15.8045 44.7671 15.3194V17.0121L44.7697 17.013ZM59.0577 9.99506C60.5176 9.99506 61.4903 10.6519 62.0467 11.8951H67.0853C66.2861 7.92167 63.645 5.95282 59.1988 5.95282C53.5346 6.05649 50.7191 9.20055 50.7191 15.4538C50.8584 21.7419 53.7081 24.92 59.2681 24.92C63.5425 25.0237 66.2528 22.6401 67.0871 18.9089H63.61C63.019 18.9038 62.4525 19.143 62.0458 19.5692C61.2817 20.4326 60.3432 20.8821 59.2654 20.8821C56.6936 20.9169 55.4098 19.0857 55.4098 15.4582C55.4098 11.8306 56.6252 9.99506 59.0577 9.99506ZM77.9852 13.6536L84.3733 6.1284H81.1889C80.7268 6.12732 80.2686 6.21181 79.8376 6.37755C79.1611 6.63346 78.5558 7.04621 78.0719 7.58152C77.5918 8.05892 73.085 13.3748 73.085 13.3748V3.26224C73.085 2.05305 72.0773 1.01636 70.8611 1.01636H68.4373V24.5432H73.0815V17.8413C73.0815 17.3578 73.3251 17.0468 73.8115 16.9431C74.4021 16.9431 74.993 17.4615 75.5842 18.4982L78.851 24.5441H84.4109L77.9852 13.6536ZM15.936 6.12847H12.7516C11.4862 6.12847 10.4934 6.72871 9.63553 7.58159C9.15533 8.059 4.64864 13.3749 4.64864 13.3749V3.26231C4.64864 2.05312 3.64093 1.01643 2.42466 1.01643H0V24.5433H4.64426V17.8414C4.64426 17.3579 4.88787 17.0469 5.3742 16.9432C5.96481 16.9432 6.55571 17.4616 7.14691 18.4983L10.4128 24.5433H15.9728L9.5444 13.6615L15.936 6.12847Z",
            fill: "currentcolor"
          }
        )
      ]
    }
  );
}
function Wb(t, e) {
  if (typeof t == "function")
    return t(e);
  t != null && (t.current = e);
}
function Bu(...t) {
  return (e) => {
    let n = !1;
    const r = t.map((i) => {
      const o = Wb(i, e);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : Wb(t[i], null);
        }
      };
  };
}
function Oe(...t) {
  return w.useCallback(Bu(...t), t);
}
// @__NO_SIDE_EFFECTS__
function mi(t) {
  const e = /* @__PURE__ */ ED(t), n = w.forwardRef((r, i) => {
    const { children: o, ...s } = r, a = w.Children.toArray(o), l = a.find(OD);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? w.Children.count(c) > 1 ? w.Children.only(null) : w.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ v(e, { ...s, ref: i, children: w.isValidElement(c) ? w.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ v(e, { ...s, ref: i, children: o });
  });
  return n.displayName = `${t}.Slot`, n;
}
var TD = /* @__PURE__ */ mi("Slot");
// @__NO_SIDE_EFFECTS__
function ED(t) {
  const e = w.forwardRef((n, r) => {
    const { children: i, ...o } = n;
    if (w.isValidElement(i)) {
      const s = ND(i), a = AD(o, i.props);
      return i.type !== w.Fragment && (a.ref = r ? Bu(r, s) : s), w.cloneElement(i, a);
    }
    return w.Children.count(i) > 1 ? w.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var xS = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function MD(t) {
  const e = ({ children: n }) => /* @__PURE__ */ v(je, { children: n });
  return e.displayName = `${t}.Slottable`, e.__radixId = xS, e;
}
function OD(t) {
  return w.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === xS;
}
function AD(t, e) {
  const n = { ...e };
  for (const r in e) {
    const i = t[r], o = e[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...a) => {
      o(...a), i(...a);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function ND(t) {
  var r, i;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (i = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : i.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
function kS(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number") r += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var i = t.length;
    for (e = 0; e < i; e++) t[e] && (n = kS(t[e])) && (r && (r += " "), r += n);
  } else for (n in t) t[n] && (r && (r += " "), r += n);
  return r;
}
function CS() {
  for (var t, e, n = 0, r = "", i = arguments.length; n < i; n++) (t = arguments[n]) && (e = kS(t)) && (r && (r += " "), r += e);
  return r;
}
function I(...t) {
  return CD(CS(t));
}
const RD = {
  intent: {
    primary: ["bg-brand-accent", "text-white", "hover:bg-brand-accent-muted"],
    "primary-gradient": [
      "bg-action-gradient",
      "text-white",
      "transition-all",
      "duration-400",
      "hover:bg-animation"
    ],
    destructive: ["bg-action-destructive-primary", "hover:bg-red-800", "text-white"],
    destructiveSecondary: [
      "bg-action-secondary",
      "border",
      "border-destructive",
      "text-destructive",
      "hover:bg-subtle",
      "hover:border-destructive",
      "hover:text-destructive-emphasis"
    ],
    secondary: [
      "bg-action-secondary",
      "text-emphasis",
      "border",
      "border-subtle",
      "hover:bg-subtle",
      "hover:border-gray-400",
      "hover:text-emphasis",
      "disabled:text-subtle"
    ],
    minimal: ["text-emphasis", "hover:bg-brand-muted", "focus:bg-muted"],
    minimalStandalone: [
      "text-default",
      "hover:text-emphasis",
      "focus:text-emphasis",
      "focus:bg-muted"
    ],
    link: ["text-default", "underline", "underline-offset-[3px]", "focus:bg-muted"],
    "outline-gradient": ["bg-action-gradient"]
  },
  size: {
    default: ["h-10", "p-3"],
    xs: ["h-6", "px-1"],
    sm: ["h-8", "px-2"],
    lg: ["h-11", "px-8"]
  }
}, DD = {
  name: "button-outline-gradient-icon",
  base: [
    "bg-base",
    "hover:bg-subtle",
    "flex",
    "items-center",
    "border-2",
    "border-transparent",
    "bg-clip-padding"
  ],
  config: {}
}, jb = {
  name: "button",
  base: [
    "cursor-pointer",
    "inline-flex",
    "items-center",
    "justify-center",
    "appearance-none",
    "font-medium",
    "focus:outline-none",
    "focus:outline-default",
    "focus-visible:ring-2",
    "focus-visible:ring-gray-400",
    "disabled:opacity-50",
    "disabled:pointer-events-none"
  ],
  config: {
    variants: RD,
    defaultVariants: {
      intent: "primary-gradient",
      size: "default"
    }
  }
}, Ub = Ie(jb.base, jb.config), ID = {
  name: "button-icon",
  base: ["h-4", "w-4", "flex-none"],
  config: {}
}, _D = {
  name: "button-icon-left",
  base: ["mr-2"],
  config: {}
}, PD = {
  name: "button-icon-right",
  base: ["ml-2"],
  config: {}
}, LD = [
  {
    name: "Fira Sans",
    folder: "fira-sans/v4.202",
    variations: [
      "black-italic",
      "black",
      "bold-italic",
      "bold",
      "extra-bold-italic",
      "extra-bold",
      "extra-light-italic",
      "extra-light",
      "italic",
      "light-italic",
      "light",
      "medium-italic",
      "medium",
      "regular",
      "semibold-italic",
      "semibold",
      "thin-italic",
      "thin"
    ]
  },
  {
    name: "Inter",
    folder: "inter/v4.0.0",
    variations: ["variable-font-slnt-wght"]
  },
  {
    name: "Lato",
    folder: "lato/v2.010",
    variations: [
      "black-italic",
      "black",
      "bold-italic",
      "bold",
      "italic",
      "light-italic",
      "light",
      "regular",
      "thin-italic",
      "thin"
    ]
  },
  {
    name: "Libre Franklin",
    folder: "libre-franklin/v4.015",
    variations: ["variable-font-wght"]
  },
  {
    name: "Merriweather Sans",
    folder: "merriweather-sans/v1.006",
    variations: ["variable-font-wght"]
  },
  {
    name: "Nunito",
    folder: "nunito/v1.0.0",
    variations: ["variable-font-wght"]
  },
  {
    name: "Nunito Sans",
    folder: "nunito-sans/v1.0.0",
    variations: ["variable-font-ytlc-opsz-wdth-wght"]
  },
  {
    name: "Open Sans",
    folder: "open-sans/v3.003",
    variations: ["variable-font-wdth-wght"]
  },
  {
    name: "PT Sans",
    folder: "pt-sans/v1.0.0",
    variations: ["bold-italic", "bold", "italic", "regular"]
  },
  {
    name: "Roboto",
    folder: "roboto/v2.138",
    variations: [
      "black-italic",
      "black",
      "bold-italic",
      "bold",
      "italic",
      "light-italic",
      "light",
      "medium-italic",
      "medium",
      "regular",
      "thin-italic",
      "thin"
    ]
  },
  {
    name: "Rubik",
    folder: "rubik/v2.300",
    variations: ["variable-font-wght"]
  },
  {
    name: "Source Sans 3",
    folder: "source-sans-3/v3.052",
    variations: ["variable-font-wght"]
  }
], FD = "https://cdn.knack.com/assets/fonts/", $D = (t) => {
  if (t.includes("variable"))
    return { fontWeight: "100 900", fontStyle: "normal, italic" };
  const e = {
    thin: "100",
    "extra-light": "200",
    light: "300",
    regular: "400",
    medium: "500",
    semibold: "600",
    bold: "700",
    "extra-bold": "800",
    black: "900",
    heavy: "900"
  }, n = t.split("-");
  let r = "400", i = "normal";
  return n.length === 2 ? (r = e[n[0]] || r, i = n[1] === "italic" ? "italic" : "normal") : r = e[n[0]] || r, { fontWeight: r, fontStyle: i };
}, Gd = (t, e, n) => {
  const r = e.includes("variable") ? `${n}-variations` : n;
  return `url('${FD}${t}/${e}.${n}') format('${r}')`;
}, BD = (t, e) => {
  const { fontWeight: n, fontStyle: r } = $D(e);
  return `@font-face {
    font-family: '${t.name}';
    font-style: ${r};
    font-weight: ${n};
    src: ${Gd(t.folder, e, "woff2")},
         ${Gd(t.folder, e, "woff")},
         ${Gd(t.folder, e, "ttf")};
  }`;
}, SS = (t) => {
  const e = LD.find((n) => n.name === t);
  return e ? e.variations.map((n) => BD(e, n)).join(`
`) : SS("Inter");
};
function VD(t, e) {
  try {
    if (new URL(t.url).protocol !== "https:")
      throw new Error("Invalid URL protocol. Only HTTPS is allowed.");
    const r = document.createElement("link");
    return r.rel = "stylesheet", r.href = t.url, r.type = "text/css", r.crossOrigin = "anonymous", r.id = e, r;
  } catch (n) {
    return console.error(`Error trying to import external font stylesheet from '${t.url}'`, n), null;
  }
}
const zD = (t, e) => {
  if (typeof t == "string") {
    const n = document.createElement("style");
    return n.id = e, n.textContent = SS(t), n;
  }
  return VD(t, e);
};
var HD = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, wr = function(t) {
  return typeof t == "string" ? t.length > 0 : typeof t == "number";
}, bt = function(t, e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = Math.pow(10, e)), Math.round(n * t) / n + 0;
}, Mn = function(t, e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = 1), t > n ? n : t > e ? t : e;
}, TS = function(t) {
  return (t = isFinite(t) ? t % 360 : 0) > 0 ? t : t + 360;
}, qb = function(t) {
  return { r: Mn(t.r, 0, 255), g: Mn(t.g, 0, 255), b: Mn(t.b, 0, 255), a: Mn(t.a) };
}, Yd = function(t) {
  return { r: bt(t.r), g: bt(t.g), b: bt(t.b), a: bt(t.a, 3) };
}, WD = /^#([0-9a-f]{3,8})$/i, gl = function(t) {
  var e = t.toString(16);
  return e.length < 2 ? "0" + e : e;
}, ES = function(t) {
  var e = t.r, n = t.g, r = t.b, i = t.a, o = Math.max(e, n, r), s = o - Math.min(e, n, r), a = s ? o === e ? (n - r) / s : o === n ? 2 + (r - e) / s : 4 + (e - n) / s : 0;
  return { h: 60 * (a < 0 ? a + 6 : a), s: o ? s / o * 100 : 0, v: o / 255 * 100, a: i };
}, MS = function(t) {
  var e = t.h, n = t.s, r = t.v, i = t.a;
  e = e / 360 * 6, n /= 100, r /= 100;
  var o = Math.floor(e), s = r * (1 - n), a = r * (1 - (e - o) * n), l = r * (1 - (1 - e + o) * n), c = o % 6;
  return { r: 255 * [r, a, s, s, l, r][c], g: 255 * [l, r, r, a, s, s][c], b: 255 * [s, s, l, r, r, a][c], a: i };
}, Kb = function(t) {
  return { h: TS(t.h), s: Mn(t.s, 0, 100), l: Mn(t.l, 0, 100), a: Mn(t.a) };
}, Gb = function(t) {
  return { h: bt(t.h), s: bt(t.s), l: bt(t.l), a: bt(t.a, 3) };
}, Yb = function(t) {
  return MS((n = (e = t).s, { h: e.h, s: (n *= ((r = e.l) < 50 ? r : 100 - r) / 100) > 0 ? 2 * n / (r + n) * 100 : 0, v: r + n, a: e.a }));
  var e, n, r;
}, Ks = function(t) {
  return { h: (e = ES(t)).h, s: (i = (200 - (n = e.s)) * (r = e.v) / 100) > 0 && i < 200 ? n * r / 100 / (i <= 100 ? i : 200 - i) * 100 : 0, l: i / 2, a: e.a };
  var e, n, r, i;
}, jD = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, UD = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, qD = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, KD = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Zb = { string: [[function(t) {
  var e = WD.exec(t);
  return e ? (t = e[1]).length <= 4 ? { r: parseInt(t[0] + t[0], 16), g: parseInt(t[1] + t[1], 16), b: parseInt(t[2] + t[2], 16), a: t.length === 4 ? bt(parseInt(t[3] + t[3], 16) / 255, 2) : 1 } : t.length === 6 || t.length === 8 ? { r: parseInt(t.substr(0, 2), 16), g: parseInt(t.substr(2, 2), 16), b: parseInt(t.substr(4, 2), 16), a: t.length === 8 ? bt(parseInt(t.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(t) {
  var e = qD.exec(t) || KD.exec(t);
  return e ? e[2] !== e[4] || e[4] !== e[6] ? null : qb({ r: Number(e[1]) / (e[2] ? 100 / 255 : 1), g: Number(e[3]) / (e[4] ? 100 / 255 : 1), b: Number(e[5]) / (e[6] ? 100 / 255 : 1), a: e[7] === void 0 ? 1 : Number(e[7]) / (e[8] ? 100 : 1) }) : null;
}, "rgb"], [function(t) {
  var e = jD.exec(t) || UD.exec(t);
  if (!e) return null;
  var n, r, i = Kb({ h: (n = e[1], r = e[2], r === void 0 && (r = "deg"), Number(n) * (HD[r] || 1)), s: Number(e[3]), l: Number(e[4]), a: e[5] === void 0 ? 1 : Number(e[5]) / (e[6] ? 100 : 1) });
  return Yb(i);
}, "hsl"]], object: [[function(t) {
  var e = t.r, n = t.g, r = t.b, i = t.a, o = i === void 0 ? 1 : i;
  return wr(e) && wr(n) && wr(r) ? qb({ r: Number(e), g: Number(n), b: Number(r), a: Number(o) }) : null;
}, "rgb"], [function(t) {
  var e = t.h, n = t.s, r = t.l, i = t.a, o = i === void 0 ? 1 : i;
  if (!wr(e) || !wr(n) || !wr(r)) return null;
  var s = Kb({ h: Number(e), s: Number(n), l: Number(r), a: Number(o) });
  return Yb(s);
}, "hsl"], [function(t) {
  var e = t.h, n = t.s, r = t.v, i = t.a, o = i === void 0 ? 1 : i;
  if (!wr(e) || !wr(n) || !wr(r)) return null;
  var s = function(a) {
    return { h: TS(a.h), s: Mn(a.s, 0, 100), v: Mn(a.v, 0, 100), a: Mn(a.a) };
  }({ h: Number(e), s: Number(n), v: Number(r), a: Number(o) });
  return MS(s);
}, "hsv"]] }, Jb = function(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n][0](t);
    if (r) return [r, e[n][1]];
  }
  return [null, void 0];
}, GD = function(t) {
  return typeof t == "string" ? Jb(t.trim(), Zb.string) : typeof t == "object" && t !== null ? Jb(t, Zb.object) : [null, void 0];
}, Zd = function(t, e) {
  var n = Ks(t);
  return { h: n.h, s: Mn(n.s + 100 * e, 0, 100), l: n.l, a: n.a };
}, Jd = function(t) {
  return (299 * t.r + 587 * t.g + 114 * t.b) / 1e3 / 255;
}, Xb = function(t, e) {
  var n = Ks(t);
  return { h: n.h, s: n.s, l: Mn(n.l + 100 * e, 0, 100), a: n.a };
}, Qb = function() {
  function t(e) {
    this.parsed = GD(e)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return t.prototype.isValid = function() {
    return this.parsed !== null;
  }, t.prototype.brightness = function() {
    return bt(Jd(this.rgba), 2);
  }, t.prototype.isDark = function() {
    return Jd(this.rgba) < 0.5;
  }, t.prototype.isLight = function() {
    return Jd(this.rgba) >= 0.5;
  }, t.prototype.toHex = function() {
    return e = Yd(this.rgba), n = e.r, r = e.g, i = e.b, s = (o = e.a) < 1 ? gl(bt(255 * o)) : "", "#" + gl(n) + gl(r) + gl(i) + s;
    var e, n, r, i, o, s;
  }, t.prototype.toRgb = function() {
    return Yd(this.rgba);
  }, t.prototype.toRgbString = function() {
    return e = Yd(this.rgba), n = e.r, r = e.g, i = e.b, (o = e.a) < 1 ? "rgba(" + n + ", " + r + ", " + i + ", " + o + ")" : "rgb(" + n + ", " + r + ", " + i + ")";
    var e, n, r, i, o;
  }, t.prototype.toHsl = function() {
    return Gb(Ks(this.rgba));
  }, t.prototype.toHslString = function() {
    return e = Gb(Ks(this.rgba)), n = e.h, r = e.s, i = e.l, (o = e.a) < 1 ? "hsla(" + n + ", " + r + "%, " + i + "%, " + o + ")" : "hsl(" + n + ", " + r + "%, " + i + "%)";
    var e, n, r, i, o;
  }, t.prototype.toHsv = function() {
    return e = ES(this.rgba), { h: bt(e.h), s: bt(e.s), v: bt(e.v), a: bt(e.a, 3) };
    var e;
  }, t.prototype.invert = function() {
    return kn({ r: 255 - (e = this.rgba).r, g: 255 - e.g, b: 255 - e.b, a: e.a });
    var e;
  }, t.prototype.saturate = function(e) {
    return e === void 0 && (e = 0.1), kn(Zd(this.rgba, e));
  }, t.prototype.desaturate = function(e) {
    return e === void 0 && (e = 0.1), kn(Zd(this.rgba, -e));
  }, t.prototype.grayscale = function() {
    return kn(Zd(this.rgba, -1));
  }, t.prototype.lighten = function(e) {
    return e === void 0 && (e = 0.1), kn(Xb(this.rgba, e));
  }, t.prototype.darken = function(e) {
    return e === void 0 && (e = 0.1), kn(Xb(this.rgba, -e));
  }, t.prototype.rotate = function(e) {
    return e === void 0 && (e = 15), this.hue(this.hue() + e);
  }, t.prototype.alpha = function(e) {
    return typeof e == "number" ? kn({ r: (n = this.rgba).r, g: n.g, b: n.b, a: e }) : bt(this.rgba.a, 3);
    var n;
  }, t.prototype.hue = function(e) {
    var n = Ks(this.rgba);
    return typeof e == "number" ? kn({ h: e, s: n.s, l: n.l, a: n.a }) : bt(n.h);
  }, t.prototype.isEqual = function(e) {
    return this.toHex() === kn(e).toHex();
  }, t;
}(), kn = function(t) {
  return t instanceof Qb ? t : new Qb(t);
};
const P = {
  black: "#000000",
  white: "#FFFFFF",
  brand: {
    DEFAULT: "#982A86",
    50: "#FBEFF9",
    100: "#E7C8E2",
    200: "#D3A0CB",
    300: "#C079B4",
    400: "#AC519D",
    500: "#982A86",
    600: "#7A226B",
    700: "#5B1950",
    800: "#3D1136",
    900: "#2E0D28"
  },
  pink: {
    DEFAULT: "#FF349A",
    50: "#FFEBF5",
    100: "#FFD6EB",
    200: "#FFC2E1",
    300: "#FF85C2",
    400: "#FF5DAE",
    500: "#FF349A",
    600: "#CE2A7C",
    700: "#9D1F5F",
    800: "#6D1541",
    900: "#3C0A24"
  },
  orange: {
    DEFAULT: "#FA816E",
    50: "#FFF2F1",
    100: "#FEE6E2",
    200: "#FDCDC5",
    300: "#FCB3A8",
    400: "#FB9A8B",
    500: "#FA816E",
    600: "#D46958",
    700: "#AF5143",
    800: "#893A2D",
    900: "#642218"
  },
  gray: {
    DEFAULT: "#898088",
    50: "#FAFAFA",
    100: "#F4F4F5",
    200: "#E7E4E6",
    250: "#E0DCDF",
    300: "#D3CFD2",
    400: "#A9A2A8",
    500: "#898088",
    550: "#7B7079",
    600: "#6B6169",
    700: "#564D54",
    800: "#3F3B3E",
    850: "#302C2F",
    875: "#252224",
    900: "#1B181B",
    950: "#100E10"
  },
  red: {
    DEFAULT: "#F44336",
    50: "#fef2f2",
    100: "#FEE6E8",
    400: "#E1999F",
    500: "#DC2618",
    600: "#D12E3C",
    700: "#b91c1b",
    800: "#A72530"
  },
  green: {
    DEFAULT: "#4CAF50",
    50: "#effdf4",
    100: "#E4F4E9",
    400: "#5BB97B",
    600: "#1A7037",
    700: "#17803d",
    800: "#145229"
  },
  yellow: {
    DEFAULT: "#FFC107",
    50: "#fffbeb",
    100: "#FEF4D7",
    300: "#E3BC82",
    400: "#D69B43",
    600: "#8B5E23",
    700: "#b4540a",
    800: "#744816"
  },
  blue: {
    100: "#D0E8F1",
    600: "#2563EB",
    800: "#214E5E"
  },
  purple: {
    600: "#9333EA"
  },
  "illustration-purple": {
    DEFAULT: "#F3E9FF",
    50: "#F3E9FF",
    100: "#DED5E9"
  },
  "illustration-blue": {
    DEFAULT: "#E3EFFC",
    50: "#E3EFFC",
    100: "#D0DBE6"
  },
  "illustration-green": {
    DEFAULT: "#DAFAEC",
    50: "#DAFAEC",
    100: "#C8E4D8"
  },
  "illustration-yellow": {
    DEFAULT: "#FCF9DE",
    50: "#FCF9DE",
    100: "#E7E3CB"
  },
  "illustration-orange": {
    DEFAULT: "#F6DDD5",
    50: "#F6DDD5",
    100: "#E1CAC3"
  },
  "illustration-pink": {
    DEFAULT: "#F8D3DF",
    50: "#F8D3DF",
    100: "#E3C1CC"
  }
};
var ii = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ki(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Xd = {}, Qd = {}, vl = { exports: {} }, ey;
function YD() {
  if (ey) return vl.exports;
  ey = 1;
  var t = String, e = function() {
    return { isColorSupported: !1, reset: t, bold: t, dim: t, italic: t, underline: t, inverse: t, hidden: t, strikethrough: t, black: t, red: t, green: t, yellow: t, blue: t, magenta: t, cyan: t, white: t, gray: t, bgBlack: t, bgRed: t, bgGreen: t, bgYellow: t, bgBlue: t, bgMagenta: t, bgCyan: t, bgWhite: t, blackBright: t, redBright: t, greenBright: t, yellowBright: t, blueBright: t, magentaBright: t, cyanBright: t, whiteBright: t, bgBlackBright: t, bgRedBright: t, bgGreenBright: t, bgYellowBright: t, bgBlueBright: t, bgMagentaBright: t, bgCyanBright: t, bgWhiteBright: t };
  };
  return vl.exports = e(), vl.exports.createColors = e, vl.exports;
}
var ty;
function ZD() {
  return ty || (ty = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function e(l, c) {
      for (var u in c) Object.defineProperty(l, u, {
        enumerable: !0,
        get: c[u]
      });
    }
    e(t, {
      dim: function() {
        return s;
      },
      default: function() {
        return a;
      }
    });
    const n = /* @__PURE__ */ r(/* @__PURE__ */ YD());
    function r(l) {
      return l && l.__esModule ? l : {
        default: l
      };
    }
    let i = /* @__PURE__ */ new Set();
    function o(l, c, u) {
      typeof process < "u" && process.env.JEST_WORKER_ID || u && i.has(u) || (u && i.add(u), console.warn(""), c.forEach((d) => console.warn(l, "-", d)));
    }
    function s(l) {
      return n.default.dim(l);
    }
    const a = {
      info(l, c) {
        o(n.default.bold(n.default.cyan("info")), ...Array.isArray(l) ? [
          l
        ] : [
          c,
          l
        ]);
      },
      warn(l, c) {
        o(n.default.bold(n.default.yellow("warn")), ...Array.isArray(l) ? [
          l
        ] : [
          c,
          l
        ]);
      },
      risk(l, c) {
        o(n.default.bold(n.default.magenta("risk")), ...Array.isArray(l) ? [
          l
        ] : [
          c,
          l
        ]);
      }
    };
  }(Qd)), Qd;
}
var ny;
function JD() {
  return ny || (ny = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const e = /* @__PURE__ */ n(ZD());
    function n(o) {
      return o && o.__esModule ? o : {
        default: o
      };
    }
    function r({ version: o, from: s, to: a }) {
      e.default.warn(`${s}-color-renamed`, [
        `As of Tailwind CSS ${o}, \`${s}\` has been renamed to \`${a}\`.`,
        "Update your configuration file to silence this warning."
      ]);
    }
    const i = {
      inherit: "inherit",
      current: "currentColor",
      transparent: "transparent",
      black: "#000",
      white: "#fff",
      slate: {
        50: "#f8fafc",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b",
        600: "#475569",
        700: "#334155",
        800: "#1e293b",
        900: "#0f172a",
        950: "#020617"
      },
      gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827",
        950: "#030712"
      },
      zinc: {
        50: "#fafafa",
        100: "#f4f4f5",
        200: "#e4e4e7",
        300: "#d4d4d8",
        400: "#a1a1aa",
        500: "#71717a",
        600: "#52525b",
        700: "#3f3f46",
        800: "#27272a",
        900: "#18181b",
        950: "#09090b"
      },
      neutral: {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#e5e5e5",
        300: "#d4d4d4",
        400: "#a3a3a3",
        500: "#737373",
        600: "#525252",
        700: "#404040",
        800: "#262626",
        900: "#171717",
        950: "#0a0a0a"
      },
      stone: {
        50: "#fafaf9",
        100: "#f5f5f4",
        200: "#e7e5e4",
        300: "#d6d3d1",
        400: "#a8a29e",
        500: "#78716c",
        600: "#57534e",
        700: "#44403c",
        800: "#292524",
        900: "#1c1917",
        950: "#0c0a09"
      },
      red: {
        50: "#fef2f2",
        100: "#fee2e2",
        200: "#fecaca",
        300: "#fca5a5",
        400: "#f87171",
        500: "#ef4444",
        600: "#dc2626",
        700: "#b91c1c",
        800: "#991b1b",
        900: "#7f1d1d",
        950: "#450a0a"
      },
      orange: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#fed7aa",
        300: "#fdba74",
        400: "#fb923c",
        500: "#f97316",
        600: "#ea580c",
        700: "#c2410c",
        800: "#9a3412",
        900: "#7c2d12",
        950: "#431407"
      },
      amber: {
        50: "#fffbeb",
        100: "#fef3c7",
        200: "#fde68a",
        300: "#fcd34d",
        400: "#fbbf24",
        500: "#f59e0b",
        600: "#d97706",
        700: "#b45309",
        800: "#92400e",
        900: "#78350f",
        950: "#451a03"
      },
      yellow: {
        50: "#fefce8",
        100: "#fef9c3",
        200: "#fef08a",
        300: "#fde047",
        400: "#facc15",
        500: "#eab308",
        600: "#ca8a04",
        700: "#a16207",
        800: "#854d0e",
        900: "#713f12",
        950: "#422006"
      },
      lime: {
        50: "#f7fee7",
        100: "#ecfccb",
        200: "#d9f99d",
        300: "#bef264",
        400: "#a3e635",
        500: "#84cc16",
        600: "#65a30d",
        700: "#4d7c0f",
        800: "#3f6212",
        900: "#365314",
        950: "#1a2e05"
      },
      green: {
        50: "#f0fdf4",
        100: "#dcfce7",
        200: "#bbf7d0",
        300: "#86efac",
        400: "#4ade80",
        500: "#22c55e",
        600: "#16a34a",
        700: "#15803d",
        800: "#166534",
        900: "#14532d",
        950: "#052e16"
      },
      emerald: {
        50: "#ecfdf5",
        100: "#d1fae5",
        200: "#a7f3d0",
        300: "#6ee7b7",
        400: "#34d399",
        500: "#10b981",
        600: "#059669",
        700: "#047857",
        800: "#065f46",
        900: "#064e3b",
        950: "#022c22"
      },
      teal: {
        50: "#f0fdfa",
        100: "#ccfbf1",
        200: "#99f6e4",
        300: "#5eead4",
        400: "#2dd4bf",
        500: "#14b8a6",
        600: "#0d9488",
        700: "#0f766e",
        800: "#115e59",
        900: "#134e4a",
        950: "#042f2e"
      },
      cyan: {
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4",
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63",
        950: "#083344"
      },
      sky: {
        50: "#f0f9ff",
        100: "#e0f2fe",
        200: "#bae6fd",
        300: "#7dd3fc",
        400: "#38bdf8",
        500: "#0ea5e9",
        600: "#0284c7",
        700: "#0369a1",
        800: "#075985",
        900: "#0c4a6e",
        950: "#082f49"
      },
      blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
        950: "#172554"
      },
      indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81",
        950: "#1e1b4b"
      },
      violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6fe",
        300: "#c4b5fd",
        400: "#a78bfa",
        500: "#8b5cf6",
        600: "#7c3aed",
        700: "#6d28d9",
        800: "#5b21b6",
        900: "#4c1d95",
        950: "#2e1065"
      },
      purple: {
        50: "#faf5ff",
        100: "#f3e8ff",
        200: "#e9d5ff",
        300: "#d8b4fe",
        400: "#c084fc",
        500: "#a855f7",
        600: "#9333ea",
        700: "#7e22ce",
        800: "#6b21a8",
        900: "#581c87",
        950: "#3b0764"
      },
      fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f5d0fe",
        300: "#f0abfc",
        400: "#e879f9",
        500: "#d946ef",
        600: "#c026d3",
        700: "#a21caf",
        800: "#86198f",
        900: "#701a75",
        950: "#4a044e"
      },
      pink: {
        50: "#fdf2f8",
        100: "#fce7f3",
        200: "#fbcfe8",
        300: "#f9a8d4",
        400: "#f472b6",
        500: "#ec4899",
        600: "#db2777",
        700: "#be185d",
        800: "#9d174d",
        900: "#831843",
        950: "#500724"
      },
      rose: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337",
        950: "#4c0519"
      },
      get lightBlue() {
        return r({
          version: "v2.2",
          from: "lightBlue",
          to: "sky"
        }), this.sky;
      },
      get warmGray() {
        return r({
          version: "v3.0",
          from: "warmGray",
          to: "stone"
        }), this.stone;
      },
      get trueGray() {
        return r({
          version: "v3.0",
          from: "trueGray",
          to: "neutral"
        }), this.neutral;
      },
      get coolGray() {
        return r({
          version: "v3.0",
          from: "coolGray",
          to: "gray"
        }), this.gray;
      },
      get blueGray() {
        return r({
          version: "v3.0",
          from: "blueGray",
          to: "slate"
        }), this.slate;
      }
    };
  }(Xd)), Xd;
}
var ef, ry;
function OS() {
  if (ry) return ef;
  ry = 1;
  let t = JD();
  return ef = (t.__esModule ? t : { default: t }).default, ef;
}
var XD = OS();
const g = /* @__PURE__ */ ki(XD), Gp = {
  "gradient-1": {
    angle: "135deg",
    colors: ["#86307B", "#E61875"],
    offsets: ["0%", "87.50%"]
  },
  "gradient-2": {
    angle: "135deg",
    colors: [P.brand[400], P.pink[400]],
    offsets: ["0%", "87.50%"]
  },
  "gradient-2-secondary": {
    angle: "90deg",
    colors: [P.brand[600], P.pink[400]],
    offsets: ["-18.36%", "101.49%"]
  },
  "gradient-3": {
    angle: "131deg",
    colors: [P.brand[500], P.orange[500]],
    offsets: ["0%", "100%"]
  },
  "action-gradient": {
    angle: "90deg",
    colors: ["#86307b", "#e61875", "#ac519d", "#ff5dae"],
    offsets: ["-6.36%", "33%", "52%", "101.49%"]
  }
}, AS = {};
Object.keys(Gp).forEach((t) => {
  const e = Gp[t], n = e.colors.map(
    (r, i) => ` ${r} ${e.offsets[i]}`
  );
  AS[t] = `linear-gradient(${e.angle},${n})`;
});
const J = {
  gradients: AS,
  light: {
    bg: {
      base: P.white,
      "brand-accent": P.brand[500],
      "brand-accent-muted": P.brand[400],
      "brand-subtle": P.brand[100],
      "brand-muted": P.brand[50],
      card: P.white,
      input: P.white,
      default: P.gray[50],
      muted: P.gray[100],
      navigation: P.gray[100],
      subtle: P.gray[200],
      emphasis: P.gray[250],
      intense: P.gray[700],
      inverted: P.gray[900],
      destructive: P.red[100],
      overlay: "rgb(63 59 62 / 0.8)",
      success: P.green[100],
      warning: P.yellow[100],
      menu: P.white,
      action: P.gray[300],
      pressed: P.gray[300],
      "selection-muted": P.gray[200],
      "selection-subtle": P.gray[300],
      "action-secondary": P.white,
      "action-destructive-primary": P.red[600],
      "action-destructive-secondary": P.white,
      "success-secondary": P.green[400],
      "illustration-purple": P["illustration-purple"][50],
      "illustration-blue": P["illustration-blue"][50],
      "illustration-green": P["illustration-green"][50],
      "illustration-yellow": P["illustration-yellow"][50],
      "illustration-orange": P["illustration-orange"][50],
      "illustration-pink": P["illustration-pink"][50]
    },
    // Content aliases are assigned to text classes in the TailWind plugin
    content: {
      muted: P.gray[400],
      inverted: P.white,
      subtle: P.gray[550],
      default: P.gray[700],
      emphasis: P.gray[900],
      "success-default": P.green[600],
      "success-emphasis": P.green[700],
      "warning-default": P.yellow[600],
      "warning-emphasis": P.yellow[700],
      destructive: P.red[600],
      "destructive-emphasis": P.red[700],
      "destructive-muted": P.red[400],
      selection: P.gray[900],
      "brand-default": P.brand[500],
      // 'rte-# colors are inverted in UI, so the order is inverted here as well.
      "rte-6": P.gray[900],
      "rte-5": P.gray[700],
      "rte-4": P.gray[550],
      "rte-3": P.gray[400],
      "rte-2": P.gray[200],
      "rte-1": P.white,
      "rte-red": P.red[500],
      "rte-orange": P.orange[600],
      "rte-green": P.green[600],
      "rte-blue": P.blue[600],
      "rte-purple": P.purple[600],
      "rte-pink": P.pink[600]
    },
    border: {
      subtle: P.gray[200],
      default: P.gray[300],
      emphasis: P.gray[500],
      destructive: P.red[600],
      "destructive-emphasis": P.red[800],
      success: P.green[400],
      selection: P.gray[300],
      "brand-default": P.brand[500],
      "brand-subtle": P.brand[200]
    },
    ring: {
      default: P.gray[900],
      destructive: P.red[600]
    },
    stroke: {
      subtle: P.gray[200],
      default: P.gray[300],
      emphasis: P.gray[400],
      destructive: P.red[400]
    }
  },
  dark: {
    bg: {
      base: P.black,
      "brand-accent": P.brand[600],
      "brand-accent-muted": P.brand[500],
      "brand-subtle": P.brand[500],
      "brand-muted": P.brand[700],
      card: P.gray[875],
      input: P.gray[900],
      default: P.gray[950],
      muted: P.gray[900],
      navigation: P.gray[800],
      subtle: P.gray[800],
      emphasis: P.gray[700],
      intense: P.gray[300],
      inverted: P.gray[50],
      destructive: P.red[800],
      overlay: "rgb(63 59 62 / 0.8)",
      success: P.green[600],
      warning: P.yellow[600],
      menu: P.gray[875],
      action: P.gray[600],
      pressed: P.gray[700],
      "selection-muted": P.gray[700],
      "selection-subtle": P.gray[600],
      "action-secondary": P.gray[800],
      "action-destructive-primary": P.red[800],
      "action-destructive-secondary": P.gray[875],
      "success-secondary": P.green[700],
      "illustration-purple": P["illustration-purple"][100],
      "illustration-blue": P["illustration-blue"][100],
      "illustration-green": P["illustration-green"][100],
      "illustration-yellow": P["illustration-yellow"][100],
      "illustration-orange": P["illustration-orange"][100],
      "illustration-pink": P["illustration-pink"][100]
    },
    content: {
      brand: P.brand[200],
      muted: P.gray[500],
      inverted: P.gray[900],
      subtle: P.gray[400],
      default: P.gray[200],
      emphasis: P.white,
      "success-default": P.green[400],
      "success-emphasis": P.green[50],
      "warning-default": P.yellow[300],
      "warning-emphasis": P.yellow[50],
      destructive: P.red[400],
      "destructive-emphasis": P.red[50],
      "destructive-muted": P.red[800],
      selection: P.gray[200],
      "brand-default": P.brand[400],
      // 'rte-# colors are inverted in UI, so the order is inverted here as well.
      "rte-6": P.white,
      "rte-5": P.gray[200],
      "rte-4": P.gray[400],
      "rte-3": P.gray[550],
      "rte-2": P.gray[700],
      "rte-1": P.gray[900],
      "rte-red": P.red[500],
      "rte-orange": P.orange[600],
      "rte-green": P.green[600],
      "rte-blue": P.blue[600],
      "rte-purple": P.purple[600],
      "rte-pink": P.pink[600]
    },
    border: {
      subtle: P.gray[850],
      default: P.gray[700],
      emphasis: P.gray[400],
      destructive: P.red[400],
      "destructive-emphasis": P.red[800],
      success: P.green[400],
      selection: P.gray[800],
      "brand-default": P.brand[400],
      "brand-subtle": P.brand[200]
    },
    ring: {
      default: P.gray[50],
      destructive: P.red[600]
    },
    stroke: {
      subtle: P.gray[200],
      default: P.gray[300],
      emphasis: P.gray[400],
      destructive: P.red[400]
    }
  },
  charts: {
    light: {
      monochromatic: [
        P.brand[600],
        P.brand[300],
        g.pink[600],
        g.pink[400],
        g.orange[500],
        g.gray[400],
        g.gray[600],
        g.gray[700]
      ],
      highContrast: [
        P.brand[600],
        g.pink[600],
        g.orange[500],
        P.brand[300],
        g.gray[500],
        g.blue[400],
        g.green[400],
        g.green[700],
        g.pink[400],
        g.pink[200],
        g.orange[700],
        g.yellow[300],
        g.lime[600],
        g.teal[500]
      ]
    },
    dark: {
      monochromatic: [
        P.brand[400],
        P.brand[200],
        g.pink[600],
        g.pink[400],
        g.orange[500],
        g.gray[300],
        g.gray[400],
        g.gray[500]
      ],
      highContrast: [
        P.brand[300],
        g.pink[600],
        g.orange[500],
        P.brand[100],
        g.gray[500],
        g.blue[300],
        g.green[400],
        g.green[700],
        g.pink[500],
        g.pink[300],
        g.orange[700],
        g.yellow[300],
        g.lime[500],
        g.teal[500]
      ]
    }
  }
}, QD = {
  gradients: J.gradients,
  light: {
    bg: {
      ...J.light.bg,
      base: g.stone[50],
      subtle: g.stone[300],
      muted: g.stone[200],
      navigation: g.stone[100],
      "brand-accent": g.amber[600],
      "brand-accent-muted": g.amber[500],
      "brand-subtle": g.amber[200],
      "brand-muted": g.amber[100],
      "action-destructive-primary": g.red[500],
      overlay: "rgb(87 83 78 / 0.8)"
    },
    content: {
      ...J.light.content,
      emphasis: g.stone[900],
      default: g.stone[700],
      subtle: g.stone[500],
      muted: g.stone[400],
      brand: g.amber[700],
      destructive: g.red[500],
      "destructive-emphasis": g.red[800],
      "brand-default": g.amber[500]
    },
    border: {
      ...J.light.border,
      default: g.stone[300],
      emphasis: g.stone[500],
      subtle: g.stone[200],
      destructive: g.red[600],
      "destructive-emphasis": g.red[600],
      "brand-default": g.amber[400],
      "brand-subtle": g.blue[300]
    },
    ring: {
      ...J.light.ring,
      default: g.amber[500],
      destructive: g.red[200]
    },
    stroke: {
      ...J.light.stroke
    }
  },
  dark: {
    bg: {
      ...J.dark.bg,
      base: g.stone[900],
      card: g.stone[800],
      subtle: g.stone[600],
      muted: g.stone[700],
      navigation: g.stone[800],
      "brand-accent": g.amber[600],
      "brand-accent-muted": g.amber[500],
      "brand-subtle": g.amber[700],
      "brand-muted": g.amber[900],
      "action-secondary": g.stone[800],
      "action-destructive-primary": g.red[500],
      "action-destructive-secondary": g.stone[800],
      overlay: "rgb(87 83 78 / 0.8)",
      input: g.stone[800],
      menu: g.stone[800]
    },
    content: {
      ...J.dark.content,
      default: g.stone[200],
      subtle: g.stone[300],
      muted: g.stone[400],
      brand: g.amber[300],
      destructive: g.red[400],
      "destructive-emphasis": g.red[50],
      "brand-default": g.amber[400]
    },
    border: {
      ...J.dark.border,
      default: g.stone[500],
      emphasis: g.stone[400],
      subtle: g.stone[700],
      destructive: g.red[400],
      "destructive-emphasis": g.red[300],
      "brand-default": g.amber[500],
      "brand-subtle": g.amber[300]
    },
    ring: {
      ...J.dark.ring,
      default: g.amber[400],
      destructive: g.red[600]
    },
    stroke: {
      ...J.dark.stroke
    }
  },
  charts: {
    light: {
      monochromatic: [
        g.amber[600],
        g.amber[400],
        g.amber[800],
        g.green[500],
        g.green[800],
        g.stone[400],
        g.stone[500],
        g.stone[700]
      ],
      highContrast: [
        g.amber[500],
        g.amber[700],
        g.lime[600],
        g.indigo[800],
        g.violet[500],
        g.zinc[500],
        g.blue[500],
        g.cyan[800],
        g.pink[700],
        g.rose[400],
        g.teal[500],
        g.green[700],
        g.fuchsia[500],
        g.purple[800]
      ]
    },
    dark: {
      monochromatic: [
        g.amber[500],
        g.amber[300],
        g.amber[600],
        g.green[300],
        g.emerald[500],
        g.stone[300],
        g.stone[400],
        g.stone[500]
      ],
      highContrast: [
        g.amber[300],
        g.amber[600],
        g.lime[500],
        g.indigo[700],
        g.violet[500],
        g.zinc[400],
        g.blue[500],
        g.cyan[400],
        g.rose[300],
        g.pink[600],
        g.emerald[500],
        g.green[700],
        g.fuchsia[600],
        g.purple[400]
      ]
    }
  }
}, eI = {
  gradients: J.gradients,
  light: {
    bg: {
      ...J.light.bg,
      base: g.slate[50],
      subtle: g.slate[200],
      muted: g.slate[100],
      navigation: g.slate[100],
      "brand-accent": g.blue[500],
      "brand-accent-muted": g.blue[400],
      "brand-subtle": g.blue[200],
      "brand-muted": g.blue[100],
      "action-destructive-primary": g.red[500],
      overlay: "rgb(71 85 105 / 0.8)"
    },
    content: {
      ...J.light.content,
      emphasis: g.slate[900],
      default: g.slate[700],
      subtle: g.slate[500],
      muted: g.slate[400],
      brand: g.blue[500],
      destructive: g.red[500],
      "destructive-emphasis": g.red[800],
      "brand-default": g.blue[500]
    },
    border: {
      ...J.light.border,
      default: g.slate[300],
      emphasis: g.slate[500],
      subtle: g.slate[200],
      destructive: g.red[600],
      "destructive-emphasis": g.red[600],
      "brand-default": g.blue[500],
      "brand-subtle": g.blue[300]
    },
    ring: {
      ...J.light.ring,
      default: g.blue[500],
      destructive: g.red[600]
    },
    stroke: {
      ...J.light.stroke
    }
  },
  dark: {
    bg: {
      ...J.dark.bg,
      base: g.slate[900],
      card: g.slate[800],
      subtle: g.slate[600],
      muted: g.slate[700],
      navigation: g.slate[800],
      "brand-accent": g.blue[600],
      "brand-subtle": g.blue[900],
      "brand-muted": g.blue[800],
      "brand-accent-muted": g.blue[500],
      "action-secondary": g.slate[800],
      "action-destructive-primary": g.red[500],
      "action-destructive-secondary": g.slate[800],
      overlay: "rgb(71 85 105 / 0.8)",
      input: g.slate[800],
      menu: g.slate[800]
    },
    content: {
      ...J.dark.content,
      default: g.slate[200],
      subtle: g.slate[300],
      muted: g.slate[400],
      brand: g.blue[400],
      destructive: g.red[400],
      "destructive-emphasis": g.red[50],
      "brand-default": g.blue[400]
    },
    border: {
      ...J.dark.border,
      default: g.slate[500],
      emphasis: g.slate[400],
      subtle: g.slate[700],
      destructive: g.red[400],
      "destructive-emphasis": g.red[300],
      "brand-default": g.blue[500],
      "brand-subtle": g.blue[300]
    },
    ring: {
      ...J.dark.ring,
      default: g.blue[400],
      destructive: g.red[600]
    },
    stroke: {
      ...J.dark.stroke
    }
  },
  charts: {
    light: {
      monochromatic: [
        g.blue[700],
        g.blue[400],
        g.blue[900],
        g.violet[500],
        g.violet[900],
        g.slate[400],
        g.slate[500],
        g.slate[700]
      ],
      highContrast: [
        g.blue[500],
        g.cyan[800],
        g.rose[400],
        g.pink[700],
        g.teal[500],
        g.green[700],
        g.fuchsia[500],
        g.purple[800],
        g.amber[500],
        g.amber[700],
        g.lime[600],
        g.indigo[800],
        g.violet[500],
        g.zinc[500]
      ]
    },
    dark: {
      monochromatic: [
        g.blue[500],
        g.blue[300],
        g.blue[600],
        g.violet[300],
        g.violet[500],
        g.slate[300],
        g.slate[400],
        g.slate[500]
      ],
      highContrast: [
        g.blue[500],
        g.cyan[400],
        g.rose[300],
        g.pink[600],
        g.teal[500],
        g.green[700],
        g.fuchsia[600],
        g.purple[500],
        g.amber[400],
        g.amber[600],
        g.lime[600],
        g.indigo[700],
        g.violet[500],
        g.zinc[400]
      ]
    }
  }
}, tI = {
  gradients: J.gradients,
  light: {
    bg: {
      ...J.light.bg,
      base: g.slate[50],
      subtle: g.slate[200],
      muted: g.slate[100],
      navigation: g.slate[100],
      "brand-accent": g.cyan[700],
      "brand-accent-muted": g.cyan[600],
      "brand-subtle": g.cyan[200],
      "brand-muted": g.cyan[100],
      "action-destructive-primary": g.red[500],
      overlay: "rgb(71 85 105 / 0.8)"
    },
    content: {
      ...J.light.content,
      emphasis: g.slate[900],
      default: g.slate[700],
      subtle: g.slate[500],
      muted: g.slate[400],
      brand: g.cyan[600],
      destructive: g.red[500],
      "destructive-emphasis": g.red[800],
      "brand-default": g.cyan[500]
    },
    border: {
      ...J.light.border,
      default: g.slate[300],
      emphasis: g.slate[500],
      subtle: g.slate[200],
      destructive: g.red[600],
      "destructive-emphasis": g.red[600],
      "brand-default": g.cyan[400],
      "brand-subtle": g.cyan[300]
    },
    ring: {
      ...J.light.ring,
      default: g.cyan[500],
      destructive: g.red[200]
    },
    stroke: {
      ...J.light.stroke
    }
  },
  dark: {
    bg: {
      ...J.dark.bg,
      base: g.gray[900],
      card: g.gray[800],
      subtle: g.gray[600],
      muted: g.gray[700],
      navigation: g.gray[800],
      "brand-accent": g.cyan[700],
      "brand-accent-muted": g.cyan[600],
      "brand-subtle": g.cyan[800],
      "brand-muted": g.cyan[900],
      "action-secondary": g.gray[800],
      "action-destructive-primary": g.red[500],
      "action-destructive-secondary": g.gray[800],
      overlay: "rgb(75 85 99 / 0.8)",
      input: g.gray[800],
      menu: g.gray[800]
    },
    content: {
      ...J.dark.content,
      default: g.gray[200],
      subtle: g.gray[300],
      muted: g.gray[400],
      brand: g.cyan[300],
      destructive: g.red[400],
      "destructive-emphasis": g.red[50],
      "brand-default": g.cyan[300]
    },
    border: {
      ...J.dark.border,
      default: g.gray[500],
      emphasis: g.gray[400],
      subtle: g.gray[700],
      destructive: g.red[400],
      "destructive-emphasis": g.red[300],
      "brand-default": g.cyan[600],
      "brand-subtle": g.cyan[300]
    },
    ring: {
      ...J.dark.ring,
      default: g.cyan[400],
      destructive: g.red[600]
    },
    stroke: {
      ...J.dark.stroke
    }
  },
  charts: {
    light: {
      monochromatic: [
        g.cyan[700],
        g.cyan[500],
        g.cyan[800],
        g.teal[500],
        g.teal[800],
        g.gray[400],
        g.gray[500],
        g.gray[700]
      ],
      highContrast: [
        g.cyan[800],
        g.pink[700],
        g.rose[400],
        g.teal[500],
        g.green[700],
        g.fuchsia[500],
        g.purple[800],
        g.amber[500],
        g.amber[700],
        g.lime[600],
        g.indigo[800],
        g.violet[500],
        g.zinc[500],
        g.blue[500]
      ]
    },
    dark: {
      monochromatic: [
        g.cyan[500],
        g.cyan[300],
        g.cyan[700],
        g.teal[400],
        g.teal[500],
        g.teal[300],
        g.teal[400],
        g.teal[500]
      ],
      highContrast: [
        g.cyan[400],
        g.rose[300],
        g.pink[600],
        g.emerald[500],
        g.green[700],
        g.fuchsia[600],
        g.purple[400],
        g.amber[300],
        g.amber[600],
        g.lime[500],
        g.indigo[700],
        g.violet[500],
        g.zinc[400],
        g.blue[500]
      ]
    }
  }
}, nI = {
  gradients: J.gradients,
  light: {
    bg: {
      ...J.light.bg,
      base: g.neutral[50],
      subtle: g.neutral[300],
      muted: g.neutral[200],
      navigation: g.neutral[100],
      "brand-accent": g.fuchsia[600],
      "brand-accent-muted": g.fuchsia[500],
      "brand-subtle": g.fuchsia[200],
      "brand-muted": g.fuchsia[100],
      "action-destructive-primary": g.red[500],
      overlay: "rgb(82 82 82 / 0.8)"
    },
    content: {
      ...J.light.content,
      emphasis: g.neutral[900],
      default: g.neutral[700],
      subtle: g.neutral[500],
      muted: g.neutral[400],
      brand: g.fuchsia[600],
      destructive: g.red[500],
      "destructive-emphasis": g.red[800],
      "brand-default": g.fuchsia[500]
    },
    border: {
      ...J.light.border,
      default: g.neutral[300],
      emphasis: g.neutral[500],
      subtle: g.neutral[200],
      destructive: g.red[600],
      "destructive-emphasis": g.red[600],
      "brand-default": g.fuchsia[300],
      "brand-subtle": g.fuchsia[300]
    },
    ring: {
      ...J.light.ring,
      default: g.fuchsia[400],
      destructive: g.red[300]
    },
    stroke: {
      ...J.light.stroke
    }
  },
  dark: {
    bg: {
      ...J.dark.bg,
      base: g.neutral[900],
      card: g.neutral[800],
      subtle: g.neutral[600],
      muted: g.neutral[700],
      navigation: g.neutral[800],
      "brand-accent": g.fuchsia[700],
      "brand-accent-muted": g.fuchsia[600],
      "brand-subtle": g.fuchsia[900],
      "brand-muted": g.fuchsia[950],
      "action-secondary": g.neutral[800],
      "action-destructive-primary": g.red[500],
      "action-destructive-secondary": g.neutral[800],
      overlay: "rgb(82 82 82 / 0.8)",
      input: g.neutral[800],
      menu: g.neutral[800]
    },
    content: {
      ...J.dark.content,
      default: g.neutral[200],
      subtle: g.neutral[300],
      muted: g.neutral[400],
      brand: g.fuchsia[300],
      destructive: g.red[400],
      "destructive-emphasis": g.red[50],
      "brand-default": g.fuchsia[500]
    },
    border: {
      ...J.dark.border,
      default: g.neutral[500],
      emphasis: g.neutral[400],
      subtle: g.neutral[700],
      destructive: g.red[400],
      "destructive-emphasis": g.red[300],
      "brand-default": g.fuchsia[700],
      "brand-subtle": g.fuchsia[300]
    },
    ring: {
      ...J.dark.ring,
      default: g.fuchsia[300],
      destructive: g.red[500]
    },
    stroke: {
      ...J.dark.stroke
    }
  },
  charts: {
    light: {
      monochromatic: [
        g.fuchsia[600],
        g.fuchsia[400],
        g.fuchsia[800],
        g.pink[500],
        g.pink[800],
        g.neutral[400],
        g.neutral[500],
        g.neutral[700]
      ],
      highContrast: [
        g.fuchsia[500],
        g.purple[800],
        g.amber[500],
        g.amber[700],
        g.lime[600],
        g.indigo[800],
        g.violet[500],
        g.zinc[500],
        g.blue[500],
        g.cyan[800],
        g.pink[700],
        g.rose[400],
        g.teal[500],
        g.green[700]
      ]
    },
    dark: {
      monochromatic: [
        g.fuchsia[400],
        g.fuchsia[300],
        g.fuchsia[600],
        g.pink[300],
        g.pink[500],
        g.neutral[300],
        g.neutral[400],
        g.neutral[500]
      ],
      highContrast: [
        g.fuchsia[600],
        g.purple[400],
        g.amber[300],
        g.amber[600],
        g.lime[500],
        g.indigo[700],
        g.violet[500],
        g.zinc[400],
        g.blue[500],
        g.cyan[400],
        g.rose[300],
        g.pink[600],
        g.emerald[500],
        g.green[700]
      ]
    }
  }
}, rI = {
  gradients: J.gradients,
  light: {
    bg: {
      ...J.light.bg,
      base: g.gray[50],
      subtle: g.gray[300],
      muted: g.gray[200],
      navigation: g.gray[100],
      "brand-accent": g.green[600],
      "brand-accent-muted": g.green[500],
      "brand-subtle": g.green[300],
      "brand-muted": g.green[100],
      "action-destructive-primary": g.red[500],
      overlay: "rgb(75 85 99 / 0.8)"
    },
    content: {
      ...J.light.content,
      emphasis: g.gray[900],
      default: g.gray[700],
      subtle: g.gray[500],
      muted: g.gray[400],
      brand: g.green[600],
      destructive: g.red[500],
      "destructive-emphasis": g.red[800],
      "brand-default": g.green[500]
    },
    border: {
      ...J.light.border,
      default: g.gray[300],
      emphasis: g.gray[500],
      subtle: g.gray[200],
      destructive: g.red[600],
      "destructive-emphasis": g.red[600],
      "brand-default": g.green[400],
      "brand-subtle": g.green[300]
    },
    ring: {
      ...J.light.ring,
      default: g.gray[700],
      destructive: g.red[200]
    },
    stroke: {
      ...J.light.stroke
    }
  },
  dark: {
    bg: {
      ...J.dark.bg,
      base: g.zinc[900],
      card: g.zinc[800],
      subtle: g.zinc[600],
      muted: g.zinc[700],
      navigation: g.zinc[800],
      "brand-accent": g.green[600],
      "brand-accent-muted": g.green[500],
      "brand-subtle": g.green[700],
      "brand-muted": g.green[900],
      "action-secondary": g.gray[800],
      "action-destructive-primary": g.red[500],
      "action-destructive-secondary": g.zinc[800],
      overlay: "rgb(82 82 91 / 0.8)",
      input: g.zinc[800],
      menu: g.zinc[800]
    },
    content: {
      ...J.dark.content,
      default: g.zinc[200],
      subtle: g.zinc[300],
      muted: g.zinc[400],
      brand: g.green[300],
      destructive: g.red[400],
      "destructive-emphasis": g.red[50],
      "brand-default": g.green[400]
    },
    border: {
      ...J.dark.border,
      default: g.zinc[500],
      emphasis: g.zinc[400],
      subtle: g.zinc[700],
      destructive: g.red[400],
      "destructive-emphasis": g.red[300],
      "brand-default": g.green[700],
      "brand-subtle": g.green[300]
    },
    ring: {
      ...J.dark.ring,
      default: g.green[400],
      destructive: g.red[600]
    },
    stroke: {
      ...J.dark.stroke
    }
  },
  charts: {
    light: {
      monochromatic: [
        g.green[600],
        g.green[400],
        g.green[800],
        g.amber[500],
        g.amber[800],
        g.zinc[400],
        g.zinc[500],
        g.zinc[700]
      ],
      highContrast: [
        g.green[700],
        g.fuchsia[500],
        g.purple[800],
        g.amber[500],
        g.amber[700],
        g.lime[600],
        g.indigo[800],
        g.violet[500],
        g.zinc[500],
        g.blue[500],
        g.cyan[800],
        g.pink[700],
        g.teal[500],
        g.rose[400]
      ]
    },
    dark: {
      monochromatic: [
        g.green[500],
        g.green[300],
        g.green[600],
        g.amber[300],
        g.amber[500],
        g.zinc[300],
        g.zinc[400],
        g.zinc[500]
      ],
      highContrast: [
        g.green[700],
        g.fuchsia[600],
        g.purple[400],
        g.amber[300],
        g.amber[600],
        g.lime[500],
        g.indigo[700],
        g.violet[500],
        g.zinc[400],
        g.blue[500],
        g.cyan[400],
        g.rose[300],
        g.pink[600],
        g.emerald[500]
      ]
    }
  }
}, iI = {
  gradients: J.gradients,
  light: {
    bg: {
      ...J.light.bg,
      base: g.zinc[50],
      subtle: g.zinc[300],
      muted: g.zinc[200],
      navigation: g.zinc[100],
      "brand-accent": g.lime[700],
      "brand-accent-muted": g.lime[600],
      "brand-subtle": g.lime[400],
      "brand-muted": g.lime[200],
      "action-destructive-primary": g.red[500],
      overlay: "rgb(82 82 91 / 0.8)"
    },
    content: {
      ...J.light.content,
      emphasis: g.zinc[900],
      default: g.zinc[700],
      subtle: g.zinc[500],
      muted: g.zinc[400],
      brand: g.lime[600],
      destructive: g.red[500],
      "destructive-emphasis": g.red[800],
      "brand-default": g.lime[500]
    },
    border: {
      ...J.light.border,
      default: g.zinc[300],
      emphasis: g.zinc[500],
      subtle: g.zinc[200],
      destructive: g.red[600],
      "destructive-emphasis": g.red[600],
      "brand-default": g.lime[400],
      "brand-subtle": g.lime[300]
    },
    ring: {
      ...J.light.ring,
      default: g.lime[600],
      destructive: g.red[200]
    },
    stroke: {
      ...J.light.stroke
    }
  },
  dark: {
    bg: {
      ...J.dark.bg,
      base: g.zinc[900],
      card: g.zinc[800],
      subtle: g.zinc[600],
      muted: g.zinc[700],
      navigation: g.zinc[800],
      "brand-accent": g.lime[700],
      "brand-accent-muted": g.lime[600],
      "brand-subtle": g.lime[700],
      "brand-muted": g.lime[900],
      "action-secondary": g.gray[800],
      "action-destructive-primary": g.red[500],
      "action-destructive-secondary": g.zinc[800],
      overlay: "rgb(82 82 91 / 0.8)",
      input: g.zinc[800],
      menu: g.zinc[800]
    },
    content: {
      ...J.dark.content,
      default: g.zinc[200],
      subtle: g.zinc[300],
      muted: g.zinc[400],
      brand: g.lime[300],
      destructive: g.red[400],
      "destructive-emphasis": g.red[50],
      "brand-default": g.lime[400]
    },
    border: {
      ...J.dark.border,
      default: g.zinc[500],
      emphasis: g.zinc[400],
      subtle: g.zinc[700],
      destructive: g.red[400],
      "destructive-emphasis": g.red[300],
      "brand-default": g.lime[600],
      "brand-subtle": g.lime[300]
    },
    ring: {
      ...J.dark.ring,
      default: g.lime[600],
      destructive: g.red[600]
    },
    stroke: {
      ...J.dark.stroke
    }
  },
  charts: {
    light: {
      monochromatic: [
        g.lime[700],
        g.lime[400],
        g.lime[800],
        g.orange[500],
        g.orange[800],
        g.zinc[400],
        g.zinc[500],
        g.zinc[700]
      ],
      highContrast: [
        g.lime[600],
        g.indigo[800],
        g.violet[500],
        g.zinc[500],
        g.blue[500],
        g.cyan[800],
        g.pink[700],
        g.rose[400],
        g.teal[500],
        g.green[700],
        g.fuchsia[500],
        g.purple[800],
        g.amber[500],
        g.amber[700]
      ]
    },
    dark: {
      monochromatic: [
        g.lime[500],
        g.lime[300],
        g.lime[600],
        g.orange[300],
        g.orange[500],
        g.zinc[300],
        g.zinc[400],
        g.zinc[500]
      ],
      highContrast: [
        g.lime[500],
        g.amber[600],
        g.indigo[700],
        g.violet[500],
        g.zinc[400],
        g.blue[500],
        g.cyan[400],
        g.rose[300],
        g.pink[600],
        g.emerald[500],
        g.green[700],
        g.fuchsia[600],
        g.purple[400],
        g.amber[300]
      ]
    }
  }
}, oI = {
  gradients: J.gradients,
  light: {
    bg: {
      ...J.light.bg,
      base: g.zinc[50],
      subtle: g.zinc[300],
      muted: g.zinc[200],
      navigation: g.zinc[100],
      "brand-accent": g.pink[600],
      "brand-accent-muted": g.pink[500],
      "brand-subtle": g.pink[200],
      "brand-muted": g.pink[100],
      "action-destructive-primary": g.red[500],
      overlay: "rgb(82 82 91 / 0.8)"
    },
    content: {
      ...J.light.content,
      emphasis: g.zinc[900],
      default: g.zinc[700],
      subtle: g.zinc[500],
      muted: g.zinc[400],
      brand: g.pink[600],
      destructive: g.red[500],
      "destructive-emphasis": g.red[800],
      "brand-default": g.pink[500]
    },
    border: {
      ...J.light.border,
      default: g.zinc[300],
      emphasis: g.zinc[500],
      subtle: g.zinc[200],
      destructive: g.red[600],
      "destructive-emphasis": g.red[600],
      "brand-default": g.pink[300],
      "brand-subtle": g.pink[300]
    },
    ring: {
      ...J.light.ring,
      default: g.pink[300],
      destructive: g.red[300]
    },
    stroke: {
      ...J.light.stroke
    }
  },
  dark: {
    bg: {
      ...J.dark.bg,
      base: g.zinc[900],
      card: g.zinc[800],
      subtle: g.zinc[600],
      muted: g.zinc[700],
      navigation: g.zinc[800],
      "brand-accent": g.pink[600],
      "brand-accent-muted": g.pink[500],
      "brand-subtle": g.pink[700],
      "brand-muted": g.pink[900],
      "action-secondary": g.zinc[800],
      "action-destructive-primary": g.red[500],
      "action-destructive-secondary": g.zinc[800],
      overlay: "rgb(82 82 91 / 0.8)",
      input: g.zinc[800],
      menu: g.zinc[800]
    },
    content: {
      ...J.dark.content,
      default: g.zinc[200],
      subtle: g.zinc[300],
      muted: g.zinc[400],
      brand: g.pink[300],
      destructive: g.red[400],
      "destructive-emphasis": g.red[50],
      "brand-default": g.pink[400]
    },
    border: {
      ...J.dark.border,
      default: g.zinc[500],
      emphasis: g.zinc[400],
      subtle: g.zinc[700],
      destructive: g.red[400],
      "destructive-emphasis": g.red[300],
      "brand-default": g.pink[700],
      "brand-subtle": g.pink[300]
    },
    ring: {
      ...J.dark.ring,
      default: g.pink[500],
      destructive: g.red[500]
    },
    stroke: {
      ...J.dark.stroke
    }
  },
  charts: {
    light: {
      monochromatic: [
        g.pink[600],
        g.pink[400],
        g.pink[800],
        g.fuchsia[500],
        g.fuchsia[800],
        g.zinc[400],
        g.zinc[500],
        g.zinc[700]
      ],
      highContrast: [
        g.pink[700],
        g.rose[400],
        g.teal[500],
        g.green[700],
        g.fuchsia[500],
        g.purple[800],
        g.amber[500],
        g.amber[700],
        g.lime[600],
        g.indigo[800],
        g.violet[500],
        g.zinc[500],
        g.blue[500],
        g.cyan[800]
      ]
    },
    dark: {
      monochromatic: [
        g.pink[400],
        g.pink[300],
        g.pink[600],
        g.fuchsia[300],
        g.fuchsia[500],
        g.zinc[300],
        g.zinc[400],
        g.zinc[500]
      ],
      highContrast: [
        g.pink[600],
        g.emerald[500],
        g.green[700],
        g.fuchsia[600],
        g.purple[400],
        g.amber[300],
        g.amber[600],
        g.lime[500],
        g.indigo[700],
        g.violet[500],
        g.zinc[400],
        g.blue[500],
        g.cyan[400],
        g.rose[300]
      ]
    }
  }
}, sI = {
  gradients: J.gradients,
  light: {
    bg: {
      ...J.light.bg,
      base: g.zinc[50],
      subtle: g.zinc[300],
      muted: g.zinc[200],
      navigation: g.zinc[100],
      "brand-accent": g.violet[600],
      "brand-accent-muted": g.violet[500],
      "brand-subtle": g.violet[200],
      "brand-muted": g.violet[100],
      "action-destructive-primary": g.red[500],
      overlay: "rgb(82 82 91 / 0.8)"
    },
    content: {
      ...J.light.content,
      emphasis: g.zinc[900],
      default: g.zinc[700],
      subtle: g.zinc[500],
      muted: g.zinc[400],
      brand: g.violet[500],
      destructive: g.red[500],
      "destructive-emphasis": g.red[800],
      "brand-default": g.violet[500]
    },
    border: {
      ...J.light.border,
      default: g.zinc[300],
      emphasis: g.zinc[500],
      subtle: g.zinc[200],
      destructive: g.red[600],
      "destructive-emphasis": g.red[600],
      "brand-default": g.violet[400],
      "brand-subtle": g.violet[300]
    },
    ring: {
      ...J.light.ring,
      default: g.violet[400],
      destructive: g.red[200]
    },
    stroke: {
      ...J.light.stroke
    }
  },
  dark: {
    bg: {
      ...J.dark.bg,
      base: g.zinc[900],
      card: g.zinc[800],
      subtle: g.zinc[600],
      muted: g.zinc[700],
      navigation: g.zinc[800],
      "brand-accent": g.violet[600],
      "brand-accent-muted": g.violet[500],
      "brand-subtle": g.violet[800],
      "brand-muted": g.violet[900],
      "action-secondary": g.zinc[800],
      "action-destructive-primary": g.red[500],
      "action-destructive-secondary": g.zinc[800],
      overlay: "rgb(82 82 91 / 0.8)",
      input: g.zinc[800],
      menu: g.zinc[800]
    },
    content: {
      ...J.dark.content,
      default: g.zinc[200],
      subtle: g.zinc[300],
      muted: g.zinc[400],
      brand: g.violet[500],
      destructive: g.red[400],
      "destructive-emphasis": g.red[50],
      "brand-default": g.violet[400]
    },
    border: {
      ...J.dark.border,
      default: g.zinc[500],
      emphasis: g.zinc[400],
      subtle: g.zinc[700],
      destructive: g.red[400],
      "destructive-emphasis": g.red[300],
      "brand-default": g.violet[500],
      "brand-subtle": g.violet[300]
    },
    ring: {
      ...J.dark.ring,
      default: g.violet[400],
      destructive: g.red[600]
    },
    stroke: {
      ...J.dark.stroke
    }
  },
  charts: {
    light: {
      monochromatic: [
        g.violet[700],
        g.violet[400],
        g.violet[800],
        g.blue[500],
        g.blue[800],
        g.zinc[400],
        g.zinc[500],
        g.zinc[700]
      ],
      highContrast: [
        g.violet[500],
        g.zinc[500],
        g.blue[500],
        g.cyan[800],
        g.pink[700],
        g.rose[400],
        g.teal[500],
        g.green[700],
        g.fuchsia[500],
        g.purple[800],
        g.amber[500],
        g.amber[700],
        g.lime[600],
        g.indigo[800]
      ]
    },
    dark: {
      monochromatic: [
        g.violet[500],
        g.violet[300],
        g.violet[600],
        g.blue[300],
        g.blue[500],
        g.zinc[300],
        g.zinc[400],
        g.zinc[500]
      ],
      highContrast: [
        g.violet[500],
        g.zinc[400],
        g.blue[500],
        g.cyan[400],
        g.rose[300],
        g.pink[600],
        g.emerald[500],
        g.green[700],
        g.fuchsia[600],
        g.purple[400],
        g.amber[300],
        g.amber[600],
        g.lime[500],
        g.indigo[700]
      ]
    }
  }
}, Eoe = [
  {
    name: "default",
    color: "bg-brand"
  },
  {
    name: "blue",
    color: "bg-blue-500"
  },
  {
    name: "cyan",
    color: "bg-cyan-500"
  },
  {
    name: "lime",
    color: "bg-lime-500"
  },
  {
    name: "green",
    color: "bg-green-500"
  },
  {
    name: "pink",
    color: "bg-pink-500"
  },
  {
    name: "fuchsia",
    color: "bg-fuchsia-500"
  },
  {
    name: "violet",
    color: "bg-violet-500"
  },
  {
    name: "amber",
    color: "bg-amber-500"
  }
], Moe = ["vertical", "horizontal"], Ooe = ["full", "max"], Aoe = ["light", "dark", "system"], Noe = "themeMode", Go = {
  name: "Default Knack Theme",
  author: "Knack",
  id: "default",
  version: 4,
  updatedOn: "",
  mode: "light",
  shouldAllowModeToggle: !0,
  appWidth: "max",
  colors: {
    preset: "blue",
    customTokens: null
  },
  background: {
    light: "",
    dark: ""
  },
  font: "Inter",
  tables: {
    border: "rows-only",
    hasMaxHeight: !1,
    maxHeightPx: 600,
    rowSpacing: "default",
    hasAlternateRowColor: !0,
    hasHoverRowColor: !0
  },
  appearance: {
    corners: "rounded",
    shadowsInCards: !0
  },
  mainNavContainer: {
    layout: "horizontal",
    structure: {
      isLogoAbove: !1
    },
    isSticky: !0,
    hasBorder: !0,
    hasShadow: !0,
    logo: {
      isVisible: !1,
      imageWidthPercentage: 50,
      url: "",
      name: "",
      size: 0
    },
    appTitle: {
      isVisible: !0,
      isCustom: !1,
      customText: "",
      size: "small"
    },
    navigationMenu: {
      isVisible: !0
    }
  }
}, aI = {
  ...Go,
  name: "My Custom Theme",
  id: "custom"
}, Roe = {
  activeThemeId: "custom",
  appThemes: [aI]
};
function lI(t) {
  const { r: e, g: n, b: r } = kn(t).toRgb();
  return `${e} ${n} ${r}`;
}
function Yp(t) {
  return kn(t).isValid() && kn(t).alpha() === 1;
}
function NS(t, e = [], n = {}) {
  let r = n;
  return Object.entries(t).forEach(([i, o]) => {
    const s = e.concat(i);
    if (typeof o != "string")
      NS(o, s, r);
    else {
      if (i === "DEFAULT") return;
      r = Object.assign(r, {
        [`--${s.join("-")}`]: Yp(o) ? lI(o) : o
      });
    }
  }), r;
}
function bl(t) {
  let e = "";
  return Object.entries(NS(t)).forEach(([n, r]) => {
    e += `${n}: ${r};
	`;
  }), e;
}
function iy(t, e) {
  let n;
  switch (t) {
    case "default":
      n = J;
      break;
    case "blue":
      n = eI;
      break;
    case "cyan":
      n = tI;
      break;
    case "lime":
      n = iI;
      break;
    case "green":
      n = rI;
      break;
    case "pink":
      n = oI;
      break;
    case "fuchsia":
      n = nI;
      break;
    case "violet":
      n = sI;
      break;
    case "amber":
      n = QD;
      break;
    case "custom":
      n = e || J;
      break;
    default:
      n = J;
  }
  const r = bl(P), i = bl(n.gradients), o = bl(n.light), s = bl(n.dark);
  return `
  :root {
    ${r}
    ${i}
  }
  [data-theme='light'] {
    ${o}
  }
  [data-theme='dark'] {
    ${s}
  }
  `;
}
const RS = {
  isDarkMode: !1,
  theme: Go
}, DS = Pn(RS);
function Doe({
  children: t,
  isRtl: e = !1,
  lang: n = "en",
  theme: r = Go
}) {
  const i = ct(() => r.mode === "light" ? !1 : r.mode === "dark" || r.mode === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches ? !0 : RS.isDarkMode, [r.mode]), [o, s] = pe(() => i());
  De(() => {
    const l = "theme-styles", c = document.getElementById(l);
    c ? c.textContent = iy(
      r.colors.preset,
      r.colors.customTokens
    ) : document.head.insertAdjacentHTML(
      "beforeend",
      `<style id="${l}">${iy(r.colors.preset, r.colors.customTokens)}</style>`
    );
  }, [r.colors.preset, r.colors.customTokens]), De(() => {
    const c = `custom-font-styles-${typeof r.font == "string" ? r.font : r.font.name}`;
    document.querySelectorAll(`[id*="custom-font-styles"]:not([id="${c}"])`).forEach((d) => d.remove());
    let u = document.getElementById(c);
    u || (u = zD(r.font, c), u && document.head.appendChild(u));
  }, [r.font]), De(() => {
    if (r.mode === "system" && window.matchMedia) {
      const l = window.matchMedia("(prefers-color-scheme: dark)"), c = l.matches;
      s(c);
      const u = (d) => {
        s(d.matches);
      };
      return l.addEventListener("change", u), () => l.removeEventListener("change", u);
    }
    s(i());
  }, [i, r.mode]), De(() => {
    const { documentElement: l } = document;
    l.setAttribute("lang", n), l.setAttribute("dir", e ? "rtl" : "ltr"), l.dataset.theme = o ? "dark" : "light";
  }, [e, n, o]);
  const a = En(
    () => ({
      isDarkMode: o,
      theme: r
    }),
    [o, r]
  );
  return /* @__PURE__ */ v(DS.Provider, { value: a, children: t });
}
const xe = () => {
  const t = Ln(DS);
  if (!t)
    throw new Error("useThemeContext must be used within a ThemeProviderContext");
  return t;
}, cI = {
  intent: {
    inverted: ["text-white"]
  },
  size: {
    default: ["w-5", "h-5"],
    sm: ["w-3.5", "h-3.5"]
  }
}, oy = {
  name: "spinner",
  base: ["inline-block", "animate-spin"],
  config: {
    variants: cI,
    defaultVariants: {
      size: "default"
    }
  }
}, uI = Ie(oy.base, oy.config);
function IS({ className: t, intent: e, size: n, ...r }) {
  const i = xe();
  return /* @__PURE__ */ v(
    "svg",
    {
      "data-testid": "asterisk-spinner",
      className: I(
        "kn-spinner",
        uI({ intent: e, size: n }),
        {
          "rounded-full": i.theme.appearance.corners === "rounded"
        },
        t
      ),
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ v(
        "path",
        {
          d: "M17.5 10C17.5 11.4834 17.0601 12.9334 16.236 14.1668C15.4119 15.4001 14.2406 16.3614 12.8701 16.9291C11.4997 17.4968 9.99168 17.6453 8.53682 17.3559C7.08196 17.0665 5.74559 16.3522 4.6967 15.3033C3.64781 14.2544 2.9335 12.918 2.64411 11.4632C2.35472 10.0083 2.50325 8.50032 3.0709 7.12987C3.63856 5.75943 4.59985 4.58809 5.83322 3.76398C7.06659 2.93987 8.51664 2.5 10 2.5V4.375C8.88748 4.375 7.79994 4.7049 6.87492 5.32298C5.94989 5.94107 5.22892 6.81957 4.80318 7.84741C4.37743 8.87524 4.26604 10.0062 4.48308 11.0974C4.70012 12.1885 5.23585 13.1908 6.02252 13.9775C6.80919 14.7641 7.81147 15.2999 8.90262 15.5169C9.99376 15.734 11.1248 15.6226 12.1526 15.1968C13.1804 14.7711 14.0589 14.0501 14.677 13.1251C15.2951 12.2001 15.625 11.1125 15.625 10H17.5Z",
          fill: "currentColor"
        }
      )
    }
  );
}
IS.displayName = "Spinner";
const _S = he.forwardRef(
  ({
    className: t,
    intent: e,
    size: n,
    disabled: r = !1,
    isLoading: i = !1,
    isFullWidth: o = !1,
    type: s = "button",
    asChild: a,
    children: l,
    ...c
  }, u) => {
    const d = xe(), f = a ? TD : "button", h = i ? /* @__PURE__ */ v(
      IS,
      {
        intent: e === "primary" || e === "primary-gradient" || e === "destructive" || e === "outline-gradient" ? "inverted" : void 0
      }
    ) : l, p = {
      "rounded-lg": (!n || n === "default" || n === "lg") && d.theme.appearance.corners === "rounded",
      rounded: n === "xs" && d.theme.appearance.corners === "rounded",
      "rounded-md": n === "sm" && d.theme.appearance.corners === "rounded"
    };
    return /* @__PURE__ */ v(
      f,
      {
        className: I(
          "kn-button",
          Ub({ size: n, intent: e }),
          {
            "px-0": e === "minimalStandalone" || e === "link" || e === "outline-gradient",
            "py-0": e === "link" || e === "outline-gradient",
            "h-auto": e === "link",
            "w-full": o,
            ...p
          },
          t
        ),
        "data-testid": "asterisk-button",
        ref: u,
        type: s,
        disabled: r || i,
        ...c,
        children: e === "outline-gradient" ? /* @__PURE__ */ v(
          "div",
          {
            className: I(
              Ub({ size: n }),
              DD.base.join(" "),
              p,
              {
                "w-full": o
              }
            ),
            children: /* @__PURE__ */ v("span", { className: "text-brand-gradient hover:text-brand-gradient-2", children: h })
          }
        ) : h
      }
    );
  }
);
function PS({ icon: t, position: e, gradientId: n, className: r, ...i }) {
  return /* @__PURE__ */ v(
    t,
    {
      className: I(ID.base.join(" "), r, {
        [`fill-[url(#svg-${n})]`]: n,
        [_D.base.join(" ")]: e === "left",
        [PD.base.join(" ")]: e === "right"
      }),
      "data-testid": "asterisk-button-icon",
      ...i
    }
  );
}
const Ze = Object.assign(_S, {
  Icon: PS
});
_S.displayName = "Button";
PS.displayName = "Button.Icon";
const dI = {
  intent: {
    neutral: ["bg-subtle", "text-default"],
    "neutral-outline": ["border", "border-emphasis", "text-default"],
    destructive: ["bg-destructive", "text-destructive-emphasis"],
    success: ["bg-success", "text-success-emphasis"],
    warning: ["bg-warning", "text-warning-emphasis"],
    blue: ["bg-blue-100", "text-blue-800"],
    gradient: ["bg-gradient-1", "text-white"]
  }
}, sy = {
  name: "badge",
  base: ["px-2", "py-1"],
  config: {
    variants: dI,
    defaultVariants: {
      intent: "neutral"
    }
  }
}, fI = Ie(sy.base, sy.config);
function LS({ children: t, className: e, intent: n, ...r }, i) {
  const o = xe();
  return /* @__PURE__ */ v(
    "span",
    {
      ref: i,
      className: I(
        "kn-badge",
        fI({ intent: n }),
        {
          "rounded-full": o.theme.appearance.corners === "rounded"
        },
        e
      ),
      "data-testid": "asterisk-badge",
      ...r,
      children: t
    }
  );
}
const hI = ce(LS);
LS.displayName = "Badge";
var FS = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, ay = he.createContext && /* @__PURE__ */ he.createContext(FS), pI = ["attr", "size", "title"];
function mI(t, e) {
  if (t == null) return {};
  var n = gI(t, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (i = 0; i < o.length; i++)
      r = o[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function gI(t, e) {
  if (t == null) return {};
  var n = {};
  for (var r in t)
    if (Object.prototype.hasOwnProperty.call(t, r)) {
      if (e.indexOf(r) >= 0) continue;
      n[r] = t[r];
    }
  return n;
}
function Sc() {
  return Sc = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Sc.apply(this, arguments);
}
function ly(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Tc(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ly(Object(n), !0).forEach(function(r) {
      vI(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ly(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function vI(t, e, n) {
  return e = bI(e), e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function bI(t) {
  var e = yI(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function yI(t, e) {
  if (typeof t != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function $S(t) {
  return t && t.map((e, n) => /* @__PURE__ */ he.createElement(e.tag, Tc({
    key: n
  }, e.attr), $S(e.child)));
}
function Ee(t) {
  return (e) => /* @__PURE__ */ he.createElement(wI, Sc({
    attr: Tc({}, t.attr)
  }, e), $S(t.child));
}
function wI(t) {
  var e = (n) => {
    var {
      attr: r,
      size: i,
      title: o
    } = t, s = mI(t, pI), a = i || n.size || "1em", l;
    return n.className && (l = n.className), t.className && (l = (l ? l + " " : "") + t.className), /* @__PURE__ */ he.createElement("svg", Sc({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, n.attr, r, s, {
      className: l,
      style: Tc(Tc({
        color: t.color || n.color
      }, n.style), t.style),
      height: a,
      width: a,
      xmlns: "http://www.w3.org/2000/svg"
    }), o && /* @__PURE__ */ he.createElement("title", null, o), t.children);
  };
  return ay !== void 0 ? /* @__PURE__ */ he.createElement(ay.Consumer, null, (n) => e(n)) : e(FS);
}
function xI(t) {
  return Ee({ attr: { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function M0(t) {
  return Ee({ attr: { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function Vu(t) {
  return Ee({ attr: { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function BS(t) {
  return Ee({ attr: { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function kI(t) {
  return Ee({ attr: { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function CI(t) {
  return Ee({ attr: { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M11.47 7.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function VS(t) {
  return Ee({ attr: { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M4.5 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function SI(t) {
  return Ee({ attr: { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M19.902 4.098a3.75 3.75 0 0 0-5.304 0l-4.5 4.5a3.75 3.75 0 0 0 1.035 6.037.75.75 0 0 1-.646 1.353 5.25 5.25 0 0 1-1.449-8.45l4.5-4.5a5.25 5.25 0 1 1 7.424 7.424l-1.757 1.757a.75.75 0 1 1-1.06-1.06l1.757-1.757a3.75 3.75 0 0 0 0-5.304Zm-7.389 4.267a.75.75 0 0 1 1-.353 5.25 5.25 0 0 1 1.449 8.45l-4.5 4.5a5.25 5.25 0 1 1-7.424-7.424l1.757-1.757a.75.75 0 1 1 1.06 1.06l-1.757 1.757a3.75 3.75 0 1 0 5.304 5.304l4.5-4.5a3.75 3.75 0 0 0-1.035-6.037.75.75 0 0 1-.354-1Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function TI(t) {
  return Ee({ attr: { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function EI(t) {
  return Ee({ attr: { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function MI(t) {
  return Ee({ attr: { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M1.5 5.625c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v12.75c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 18.375V5.625ZM21 9.375A.375.375 0 0 0 20.625 9h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5ZM10.875 18.75a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5ZM3.375 15h7.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375Zm0-3.75h7.5a.375.375 0 0 0 .375-.375v-1.5A.375.375 0 0 0 10.875 9h-7.5A.375.375 0 0 0 3 9.375v1.5c0 .207.168.375.375.375Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function Vr(t) {
  return Ee({ attr: { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function OI(t) {
  return Ee({ attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M2 4.75A.75.75 0 0 1 2.75 4h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75Zm0 10.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75ZM2 10a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 10Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function AI(t) {
  return Ee({ attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M2 4.75A.75.75 0 0 1 2.75 4h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75Zm7 10.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75ZM2 10a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 10Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function NI(t) {
  return Ee({ attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M2 4.75A.75.75 0 0 1 2.75 4h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75ZM2 10a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 10Zm0 5.25a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function zS(t) {
  return Ee({ attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M6.28 5.22a.75.75 0 0 1 0 1.06L2.56 10l3.72 3.72a.75.75 0 0 1-1.06 1.06L.97 10.53a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Zm7.44 0a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L17.44 10l-3.72-3.72a.75.75 0 0 1 0-1.06ZM11.377 2.011a.75.75 0 0 1 .612.867l-2.5 14.5a.75.75 0 0 1-1.478-.255l2.5-14.5a.75.75 0 0 1 .866-.612Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function RI(t) {
  return Ee({ attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M6 4.75A.75.75 0 0 1 6.75 4h10.5a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 4.75ZM6 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 10Zm0 5.25a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1-.75-.75ZM1.99 4.75a1 1 0 0 1 1-1H3a1 1 0 0 1 1 1v.01a1 1 0 0 1-1 1h-.01a1 1 0 0 1-1-1v-.01ZM1.99 15.25a1 1 0 0 1 1-1H3a1 1 0 0 1 1 1v.01a1 1 0 0 1-1 1h-.01a1 1 0 0 1-1-1v-.01ZM1.99 10a1 1 0 0 1 1-1H3a1 1 0 0 1 1 1v.01a1 1 0 0 1-1 1h-.01a1 1 0 0 1-1-1V10Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function HS(t) {
  return Ee({ attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function DI(t) {
  return Ee({ attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M1 5.25A2.25 2.25 0 0 1 3.25 3h13.5A2.25 2.25 0 0 1 19 5.25v9.5A2.25 2.25 0 0 1 16.75 17H3.25A2.25 2.25 0 0 1 1 14.75v-9.5Zm1.5 5.81v3.69c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75v-2.69l-2.22-2.219a.75.75 0 0 0-1.06 0l-1.91 1.909.47.47a.75.75 0 1 1-1.06 1.06L6.53 8.091a.75.75 0 0 0-1.06 0l-2.97 2.97ZM12 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", clipRule: "evenodd" }, child: [] }] })(t);
}
function II(t) {
  return Ee({ attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { d: "M3.25 4A2.25 2.25 0 0 0 1 6.25v7.5A2.25 2.25 0 0 0 3.25 16h7.5A2.25 2.25 0 0 0 13 13.75v-7.5A2.25 2.25 0 0 0 10.75 4h-7.5ZM19 4.75a.75.75 0 0 0-1.28-.53l-3 3a.75.75 0 0 0-.22.53v4.5c0 .199.079.39.22.53l3 3a.75.75 0 0 0 1.28-.53V4.75Z" }, child: [] }] })(t);
}
const _I = {
  intent: {
    default: ["bg-intense", "text-inverted"],
    destructive: ["bg-destructive", "text-destructive-emphasis"],
    warning: ["bg-warning", "text-warning-emphasis"],
    success: ["bg-success", "text-success-emphasis"],
    gradient: ["bg-gradient-1", "text-white"],
    light: ["bg-subtle", "text-default"]
  },
  type: {
    inline: ["sm:flex", "justify-between"],
    block: ["sm:block"]
  }
}, cy = {
  name: "banner",
  base: ["p-4", "gap-2"],
  config: {
    variants: _I,
    defaultVariants: {
      intent: "default",
      type: "inline"
    }
  }
}, PI = Ie(cy.base, cy.config);
function LI({
  children: t,
  className: e,
  intent: n,
  icon: r,
  actionLabel: i = "Action",
  closeLabel: o = "Dismiss",
  title: s,
  type: a,
  onClose: l,
  closeMode: c = "icon",
  onAction: u,
  ...d
}, f) {
  const h = {
    "text-inverted": !n || n === "default",
    "text-destructive-emphasis": n === "destructive",
    "text-warning-emphasis": n === "warning",
    "text-success-emphasis": n === "success",
    "text-white": n === "gradient",
    "text-default": n === "light"
  }, p = xe();
  return /* @__PURE__ */ F(
    "div",
    {
      className: I(
        "kn-banner",
        PI({ intent: n, type: a }),
        {
          "rounded-lg": p.theme.appearance.corners === "rounded"
        },
        e
      ),
      ref: f,
      "data-testid": "asterisk-banner",
      ...d,
      children: [
        /* @__PURE__ */ F(
          "div",
          {
            "data-testid": "asterisk-banner-content",
            className: I("mb-2 flex gap-2 sm:mb-0", { "sm:my-auto": !s }),
            children: [
              r && /* @__PURE__ */ v(r, { className: I("size-4 flex-none", { "mt-1": s }) }),
              /* @__PURE__ */ F("div", { className: "grow", children: [
                s && /* @__PURE__ */ v("p", { className: "text-md mb-2 font-semibold", children: s }),
                t
              ] })
            ]
          }
        ),
        (l || u) && /* @__PURE__ */ F("div", { className: "flex items-center gap-1", children: [
          l && c === "text" && /* @__PURE__ */ v(
            Ze,
            {
              "data-testid": "asterisk-banner-close-button",
              className: I("text-inverted pl-7 sm:pl-0", {
                "sm:pl-7": a === "block" && r,
                ...h
              }),
              intent: "minimalStandalone",
              onClick: l,
              children: o
            }
          ),
          l && c === "icon" && /* @__PURE__ */ v(
            Ze,
            {
              "data-testid": "asterisk-banner-close-button",
              className: I("text-inverted pl-0 sm:hidden", {
                "pl-7": r,
                ...h
              }),
              intent: "minimalStandalone",
              onClick: l,
              children: o
            }
          ),
          u && /* @__PURE__ */ v(
            Ze,
            {
              "data-testid": "asterisk-banner-action-button",
              className: I("text-inverted pl-0", {
                "pl-7": a === "block" && r,
                ...h
              }),
              intent: "minimalStandalone",
              onClick: u,
              children: i
            }
          )
        ] }),
        l && c === "icon" && /* @__PURE__ */ v(
          Ze,
          {
            className: "hidden hover:bg-gray-900/5 sm:block",
            "data-testid": "asterisk-banner-close-button",
            size: "sm",
            intent: "link",
            onClick: l,
            children: /* @__PURE__ */ v(Vr, { className: "size-4" })
          }
        )
      ]
    }
  );
}
function WS({ className: t, children: e }) {
  return /* @__PURE__ */ v("p", { "data-testid": "asterisk-banner-message", className: I(t), children: e });
}
const FI = ce(LI), Ioe = Object.assign(FI, {
  Message: WS
});
WS.displayName = "Banner.Message";
const $I = {}, uy = {
  name: "card",
  base: ["p-6", "sm:p-14", "bg-card", "text-default"],
  config: {
    variants: $I,
    defaultVariants: {
      intent: "default"
    }
  }
}, BI = Ie(uy.base, uy.config), jS = ce(({ className: t, ...e }, n) => {
  const r = xe();
  return /* @__PURE__ */ v(
    "div",
    {
      className: I(
        "kn-card",
        BI(),
        {
          "shadow-md": r.theme.appearance.shadowsInCards,
          "rounded-lg": r.theme.appearance.corners === "rounded"
        },
        t
      ),
      "data-testid": "asterisk-card",
      ref: n,
      ...e
    }
  );
});
jS.displayName = "Card";
function Le(t) {
  const e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new t.constructor(+t) : typeof t == "number" || e === "[object Number]" || typeof t == "string" || e === "[object String]" ? new Date(t) : /* @__PURE__ */ new Date(NaN);
}
function mn(t, e) {
  return t instanceof Date ? new t.constructor(e) : new Date(e);
}
function zt(t, e) {
  const n = Le(t);
  return isNaN(e) ? mn(t, NaN) : (e && n.setDate(n.getDate() + e), n);
}
function jn(t, e) {
  const n = Le(t);
  if (isNaN(e)) return mn(t, NaN);
  if (!e)
    return n;
  const r = n.getDate(), i = mn(t, n.getTime());
  i.setMonth(n.getMonth() + e + 1, 0);
  const o = i.getDate();
  return r >= o ? i : (n.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    r
  ), n);
}
const O0 = 6048e5, VI = 864e5;
let zI = {};
function Pa() {
  return zI;
}
function cr(t, e) {
  var a, l, c, u;
  const n = Pa(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (a = e == null ? void 0 : e.locale) == null ? void 0 : a.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, i = Le(t), o = i.getDay(), s = (o < r ? 7 : 0) + o - r;
  return i.setDate(i.getDate() - s), i.setHours(0, 0, 0, 0), i;
}
function eo(t) {
  return cr(t, { weekStartsOn: 1 });
}
function US(t) {
  const e = Le(t), n = e.getFullYear(), r = mn(t, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const i = eo(r), o = mn(t, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const s = eo(o);
  return e.getTime() >= i.getTime() ? n + 1 : e.getTime() >= s.getTime() ? n : n - 1;
}
function Yo(t) {
  const e = Le(t);
  return e.setHours(0, 0, 0, 0), e;
}
function Ec(t) {
  const e = Le(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function rr(t, e) {
  const n = Yo(t), r = Yo(e), i = +n - Ec(n), o = +r - Ec(r);
  return Math.round((i - o) / VI);
}
function HI(t) {
  const e = US(t), n = mn(t, 0);
  return n.setFullYear(e, 0, 4), n.setHours(0, 0, 0, 0), eo(n);
}
function Zp(t, e) {
  const n = e * 7;
  return zt(t, n);
}
function WI(t, e) {
  return jn(t, e * 12);
}
function jI(t) {
  let e;
  return t.forEach(function(n) {
    const r = Le(n);
    (e === void 0 || e < r || isNaN(Number(r))) && (e = r);
  }), e || /* @__PURE__ */ new Date(NaN);
}
function UI(t) {
  let e;
  return t.forEach((n) => {
    const r = Le(n);
    (!e || e > r || isNaN(+r)) && (e = r);
  }), e || /* @__PURE__ */ new Date(NaN);
}
function Xt(t, e) {
  const n = Yo(t), r = Yo(e);
  return +n == +r;
}
function A0(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function qI(t) {
  if (!A0(t) && typeof t != "number")
    return !1;
  const e = Le(t);
  return !isNaN(Number(e));
}
function ca(t, e) {
  const n = Le(t), r = Le(e), i = n.getFullYear() - r.getFullYear(), o = n.getMonth() - r.getMonth();
  return i * 12 + o;
}
function KI(t, e, n) {
  const r = cr(t, n), i = cr(e, n), o = +r - Ec(r), s = +i - Ec(i);
  return Math.round((o - s) / O0);
}
function N0(t) {
  const e = Le(t), n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e;
}
function Qt(t) {
  const e = Le(t);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function qS(t) {
  const e = Le(t), n = mn(t, 0);
  return n.setFullYear(e.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function R0(t, e) {
  var a, l, c, u;
  const n = Pa(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (a = e == null ? void 0 : e.locale) == null ? void 0 : a.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, i = Le(t), o = i.getDay(), s = (o < r ? -7 : 0) + 6 - (o - r);
  return i.setDate(i.getDate() + s), i.setHours(23, 59, 59, 999), i;
}
function KS(t) {
  return R0(t, { weekStartsOn: 1 });
}
const GI = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, YI = (t, e, n) => {
  let r;
  const i = GI[t];
  return typeof i == "string" ? r = i : e === 1 ? r = i.one : r = i.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function tf(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const ZI = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, JI = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, XI = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, QI = {
  date: tf({
    formats: ZI,
    defaultWidth: "full"
  }),
  time: tf({
    formats: JI,
    defaultWidth: "full"
  }),
  dateTime: tf({
    formats: XI,
    defaultWidth: "full"
  })
}, e4 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, t4 = (t, e, n, r) => e4[t];
function As(t) {
  return (e, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (r === "formatting" && t.formattingValues) {
      const s = t.defaultFormattingWidth || t.defaultWidth, a = n != null && n.width ? String(n.width) : s;
      i = t.formattingValues[a] || t.formattingValues[s];
    } else {
      const s = t.defaultWidth, a = n != null && n.width ? String(n.width) : t.defaultWidth;
      i = t.values[a] || t.values[s];
    }
    const o = t.argumentCallback ? t.argumentCallback(e) : e;
    return i[o];
  };
}
const n4 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, r4 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, i4 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, o4 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, s4 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, a4 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, l4 = (t, e) => {
  const n = Number(t), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, c4 = {
  ordinalNumber: l4,
  era: As({
    values: n4,
    defaultWidth: "wide"
  }),
  quarter: As({
    values: r4,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: As({
    values: i4,
    defaultWidth: "wide"
  }),
  day: As({
    values: o4,
    defaultWidth: "wide"
  }),
  dayPeriod: As({
    values: s4,
    defaultWidth: "wide",
    formattingValues: a4,
    defaultFormattingWidth: "wide"
  })
};
function Ns(t) {
  return (e, n = {}) => {
    const r = n.width, i = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], o = e.match(i);
    if (!o)
      return null;
    const s = o[0], a = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(a) ? d4(a, (d) => d.test(s)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      u4(a, (d) => d.test(s))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = e.slice(s.length);
    return { value: c, rest: u };
  };
}
function u4(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function d4(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function f4(t) {
  return (e, n = {}) => {
    const r = e.match(t.matchPattern);
    if (!r) return null;
    const i = r[0], o = e.match(t.parsePattern);
    if (!o) return null;
    let s = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const a = e.slice(i.length);
    return { value: s, rest: a };
  };
}
const h4 = /^(\d+)(th|st|nd|rd)?/i, p4 = /\d+/i, m4 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, g4 = {
  any: [/^b/i, /^(a|c)/i]
}, v4 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, b4 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, y4 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, w4 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, x4 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, k4 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, C4 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, S4 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, T4 = {
  ordinalNumber: f4({
    matchPattern: h4,
    parsePattern: p4,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Ns({
    matchPatterns: m4,
    defaultMatchWidth: "wide",
    parsePatterns: g4,
    defaultParseWidth: "any"
  }),
  quarter: Ns({
    matchPatterns: v4,
    defaultMatchWidth: "wide",
    parsePatterns: b4,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Ns({
    matchPatterns: y4,
    defaultMatchWidth: "wide",
    parsePatterns: w4,
    defaultParseWidth: "any"
  }),
  day: Ns({
    matchPatterns: x4,
    defaultMatchWidth: "wide",
    parsePatterns: k4,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ns({
    matchPatterns: C4,
    defaultMatchWidth: "any",
    parsePatterns: S4,
    defaultParseWidth: "any"
  })
}, GS = {
  code: "en-US",
  formatDistance: YI,
  formatLong: QI,
  formatRelative: t4,
  localize: c4,
  match: T4,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function E4(t) {
  const e = Le(t);
  return rr(e, qS(e)) + 1;
}
function YS(t) {
  const e = Le(t), n = +eo(e) - +HI(e);
  return Math.round(n / O0) + 1;
}
function ZS(t, e) {
  var u, d, f, h;
  const n = Le(t), r = n.getFullYear(), i = Pa(), o = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((d = (u = e == null ? void 0 : e.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((h = (f = i.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, s = mn(t, 0);
  s.setFullYear(r + 1, 0, o), s.setHours(0, 0, 0, 0);
  const a = cr(s, e), l = mn(t, 0);
  l.setFullYear(r, 0, o), l.setHours(0, 0, 0, 0);
  const c = cr(l, e);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= c.getTime() ? r : r - 1;
}
function M4(t, e) {
  var a, l, c, u;
  const n = Pa(), r = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((l = (a = e == null ? void 0 : e.locale) == null ? void 0 : a.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, i = ZS(t, e), o = mn(t, 0);
  return o.setFullYear(i, 0, r), o.setHours(0, 0, 0, 0), cr(o, e);
}
function JS(t, e) {
  const n = Le(t), r = +cr(n, e) - +M4(n, e);
  return Math.round(r / O0) + 1;
}
function qe(t, e) {
  const n = t < 0 ? "-" : "", r = Math.abs(t).toString().padStart(e, "0");
  return n + r;
}
const Hr = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), r = n > 0 ? n : 1 - n;
    return qe(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : qe(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return qe(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return qe(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return qe(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return qe(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return qe(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, r = t.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return qe(i, e.length);
  }
}, ko = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, dy = {
  // Era
  G: function(t, e, n) {
    const r = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const r = t.getFullYear(), i = r > 0 ? r : 1 - r;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return Hr.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, r) {
    const i = ZS(t, r), o = i > 0 ? i : 1 - i;
    if (e === "YY") {
      const s = o % 100;
      return qe(s, 2);
    }
    return e === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : qe(o, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = US(t);
    return qe(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return qe(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return qe(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return qe(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Hr.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return qe(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, r) {
    const i = JS(t, r);
    return e === "wo" ? n.ordinalNumber(i, { unit: "week" }) : qe(i, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const r = YS(t);
    return e === "Io" ? n.ordinalNumber(r, { unit: "week" }) : qe(r, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : Hr.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const r = E4(t);
    return e === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : qe(r, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const r = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, r) {
    const i = t.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return qe(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, r) {
    const i = t.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return qe(o, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const r = t.getDay(), i = r === 0 ? 7 : r;
    switch (e) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return qe(i, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const i = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const r = t.getHours();
    let i;
    switch (r === 12 ? i = ko.noon : r === 0 ? i = ko.midnight : i = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const r = t.getHours();
    let i;
    switch (r >= 17 ? i = ko.evening : r >= 12 ? i = ko.afternoon : r >= 4 ? i = ko.morning : i = ko.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let r = t.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Hr.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : Hr.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const r = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : qe(r, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let r = t.getHours();
    return r === 0 && (r = 24), e === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : qe(r, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : Hr.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : Hr.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return Hr.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const r = t.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return hy(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Fi(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Fi(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return hy(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Fi(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Fi(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + fy(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Fi(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + fy(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Fi(r, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const r = Math.trunc(t.getTime() / 1e3);
    return qe(r, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    const r = t.getTime();
    return qe(r, e.length);
  }
};
function fy(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), i = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? n + String(i) : n + String(i) + e + qe(o, 2);
}
function hy(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + qe(Math.abs(t) / 60, 2) : Fi(t, e);
}
function Fi(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), i = qe(Math.trunc(r / 60), 2), o = qe(r % 60, 2);
  return n + i + e + o;
}
const py = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, XS = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, O4 = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
  if (!i)
    return py(t, e);
  let o;
  switch (r) {
    case "P":
      o = e.dateTime({ width: "short" });
      break;
    case "PP":
      o = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = e.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", py(r, e)).replace("{{time}}", XS(i, e));
}, A4 = {
  p: XS,
  P: O4
}, N4 = /^D+$/, R4 = /^Y+$/, D4 = ["D", "DD", "YY", "YYYY"];
function I4(t) {
  return N4.test(t);
}
function _4(t) {
  return R4.test(t);
}
function P4(t, e, n) {
  const r = L4(t, e, n);
  if (console.warn(r), D4.includes(t)) throw new RangeError(r);
}
function L4(t, e, n) {
  const r = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const F4 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $4 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, B4 = /^'([^]*?)'?$/, V4 = /''/g, z4 = /[a-zA-Z]/;
function fo(t, e, n) {
  var u, d, f, h, p, m, b, y;
  const r = Pa(), i = (n == null ? void 0 : n.locale) ?? r.locale ?? GS, o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, s = (n == null ? void 0 : n.weekStartsOn) ?? ((m = (p = n == null ? void 0 : n.locale) == null ? void 0 : p.options) == null ? void 0 : m.weekStartsOn) ?? r.weekStartsOn ?? ((y = (b = r.locale) == null ? void 0 : b.options) == null ? void 0 : y.weekStartsOn) ?? 0, a = Le(t);
  if (!qI(a))
    throw new RangeError("Invalid time value");
  let l = e.match($4).map((k) => {
    const C = k[0];
    if (C === "p" || C === "P") {
      const x = A4[C];
      return x(k, i.formatLong);
    }
    return k;
  }).join("").match(F4).map((k) => {
    if (k === "''")
      return { isToken: !1, value: "'" };
    const C = k[0];
    if (C === "'")
      return { isToken: !1, value: H4(k) };
    if (dy[C])
      return { isToken: !0, value: k };
    if (C.match(z4))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + C + "`"
      );
    return { isToken: !1, value: k };
  });
  i.localize.preprocessor && (l = i.localize.preprocessor(a, l));
  const c = {
    firstWeekContainsDate: o,
    weekStartsOn: s,
    locale: i
  };
  return l.map((k) => {
    if (!k.isToken) return k.value;
    const C = k.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && _4(C) || !(n != null && n.useAdditionalDayOfYearTokens) && I4(C)) && P4(C, e, String(t));
    const x = dy[C[0]];
    return x(a, C, i.localize, c);
  }).join("");
}
function H4(t) {
  const e = t.match(B4);
  return e ? e[1].replace(V4, "'") : t;
}
function W4(t) {
  const e = Le(t), n = e.getFullYear(), r = e.getMonth(), i = mn(t, 0);
  return i.setFullYear(n, r + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function j4(t) {
  return Math.trunc(+Le(t) / 1e3);
}
function U4(t) {
  const e = Le(t), n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(0, 0, 0, 0), e;
}
function q4(t, e) {
  return KI(
    U4(t),
    Qt(t),
    e
  ) + 1;
}
function Jp(t, e) {
  const n = Le(t), r = Le(e);
  return n.getTime() > r.getTime();
}
function QS(t, e) {
  const n = Le(t), r = Le(e);
  return +n < +r;
}
function D0(t, e) {
  const n = Le(t), r = Le(e);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function K4(t, e) {
  const n = Le(t), r = Le(e);
  return n.getFullYear() === r.getFullYear();
}
function nf(t, e) {
  return zt(t, -e);
}
function rf(t, e) {
  const n = Le(t), r = n.getFullYear(), i = n.getDate(), o = mn(t, 0);
  o.setFullYear(r, e, 15), o.setHours(0, 0, 0, 0);
  const s = W4(o);
  return n.setMonth(e, Math.min(i, s)), n;
}
function my(t, e) {
  const n = Le(t);
  return isNaN(+n) ? mn(t, NaN) : (n.setFullYear(e), n);
}
var Ce = function() {
  return Ce = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, Ce.apply(this, arguments);
};
function G4(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function eT(t, e, n) {
  for (var r = 0, i = e.length, o; r < i; r++)
    (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return t.concat(o || Array.prototype.slice.call(e));
}
function La(t) {
  return t.mode === "multiple";
}
function Fa(t) {
  return t.mode === "range";
}
function zu(t) {
  return t.mode === "single";
}
var Y4 = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function Z4(t, e) {
  return fo(t, "LLLL y", e);
}
function J4(t, e) {
  return fo(t, "d", e);
}
function X4(t, e) {
  return fo(t, "LLLL", e);
}
function Q4(t) {
  return "".concat(t);
}
function e_(t, e) {
  return fo(t, "cccccc", e);
}
function t_(t, e) {
  return fo(t, "yyyy", e);
}
var n_ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: Z4,
  formatDay: J4,
  formatMonthCaption: X4,
  formatWeekNumber: Q4,
  formatWeekdayName: e_,
  formatYearCaption: t_
}), r_ = function(t, e, n) {
  return fo(t, "do MMMM (EEEE)", n);
}, i_ = function() {
  return "Month: ";
}, o_ = function() {
  return "Go to next month";
}, s_ = function() {
  return "Go to previous month";
}, a_ = function(t, e) {
  return fo(t, "cccc", e);
}, l_ = function(t) {
  return "Week n. ".concat(t);
}, c_ = function() {
  return "Year: ";
}, u_ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: r_,
  labelMonthDropdown: i_,
  labelNext: o_,
  labelPrevious: s_,
  labelWeekNumber: l_,
  labelWeekday: a_,
  labelYearDropdown: c_
});
function d_() {
  var t = "buttons", e = Y4, n = GS, r = {}, i = {}, o = 1, s = {}, a = /* @__PURE__ */ new Date();
  return {
    captionLayout: t,
    classNames: e,
    formatters: n_,
    labels: u_,
    locale: n,
    modifiersClassNames: r,
    modifiers: i,
    numberOfMonths: o,
    styles: s,
    today: a,
    mode: "default"
  };
}
function f_(t) {
  var e = t.fromYear, n = t.toYear, r = t.fromMonth, i = t.toMonth, o = t.fromDate, s = t.toDate;
  return r ? o = Qt(r) : e && (o = new Date(e, 0, 1)), i ? s = N0(i) : n && (s = new Date(n, 11, 31)), {
    fromDate: o ? Yo(o) : void 0,
    toDate: s ? Yo(s) : void 0
  };
}
var tT = Pn(void 0);
function h_(t) {
  var e, n = t.initialProps, r = d_(), i = f_(n), o = i.fromDate, s = i.toDate, a = (e = n.captionLayout) !== null && e !== void 0 ? e : r.captionLayout;
  a !== "buttons" && (!o || !s) && (a = "buttons");
  var l;
  (zu(n) || La(n) || Fa(n)) && (l = n.onSelect);
  var c = Ce(Ce(Ce({}, r), n), { captionLayout: a, classNames: Ce(Ce({}, r.classNames), n.classNames), components: Ce({}, n.components), formatters: Ce(Ce({}, r.formatters), n.formatters), fromDate: o, labels: Ce(Ce({}, r.labels), n.labels), mode: n.mode || r.mode, modifiers: Ce(Ce({}, r.modifiers), n.modifiers), modifiersClassNames: Ce(Ce({}, r.modifiersClassNames), n.modifiersClassNames), onSelect: l, styles: Ce(Ce({}, r.styles), n.styles), toDate: s });
  return v(tT.Provider, { value: c, children: t.children });
}
function Je() {
  var t = Ln(tT);
  if (!t)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return t;
}
function nT(t) {
  var e = Je(), n = e.locale, r = e.classNames, i = e.styles, o = e.formatters.formatCaption;
  return v("div", { className: r.caption_label, style: i.caption_label, "aria-live": "polite", role: "presentation", id: t.id, children: o(t.displayMonth, { locale: n }) });
}
function p_(t) {
  return v("svg", Ce({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, t, { children: v("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function rT(t) {
  var e, n, r = t.onChange, i = t.value, o = t.children, s = t.caption, a = t.className, l = t.style, c = Je(), u = (n = (e = c.components) === null || e === void 0 ? void 0 : e.IconDropdown) !== null && n !== void 0 ? n : p_;
  return F("div", { className: a, style: l, children: [v("span", { className: c.classNames.vhidden, children: t["aria-label"] }), v("select", { name: t.name, "aria-label": t["aria-label"], className: c.classNames.dropdown, style: c.styles.dropdown, value: i, onChange: r, children: o }), F("div", { className: c.classNames.caption_label, style: c.styles.caption_label, "aria-hidden": "true", children: [s, v(u, { className: c.classNames.dropdown_icon, style: c.styles.dropdown_icon })] })] });
}
function m_(t) {
  var e, n = Je(), r = n.fromDate, i = n.toDate, o = n.styles, s = n.locale, a = n.formatters.formatMonthCaption, l = n.classNames, c = n.components, u = n.labels.labelMonthDropdown;
  if (!r)
    return v(je, {});
  if (!i)
    return v(je, {});
  var d = [];
  if (K4(r, i))
    for (var f = Qt(r), h = r.getMonth(); h <= i.getMonth(); h++)
      d.push(rf(f, h));
  else
    for (var f = Qt(/* @__PURE__ */ new Date()), h = 0; h <= 11; h++)
      d.push(rf(f, h));
  var p = function(b) {
    var y = Number(b.target.value), k = rf(Qt(t.displayMonth), y);
    t.onChange(k);
  }, m = (e = c == null ? void 0 : c.Dropdown) !== null && e !== void 0 ? e : rT;
  return v(m, { name: "months", "aria-label": u(), className: l.dropdown_month, style: o.dropdown_month, onChange: p, value: t.displayMonth.getMonth(), caption: a(t.displayMonth, { locale: s }), children: d.map(function(b) {
    return v("option", { value: b.getMonth(), children: a(b, { locale: s }) }, b.getMonth());
  }) });
}
function g_(t) {
  var e, n = t.displayMonth, r = Je(), i = r.fromDate, o = r.toDate, s = r.locale, a = r.styles, l = r.classNames, c = r.components, u = r.formatters.formatYearCaption, d = r.labels.labelYearDropdown, f = [];
  if (!i)
    return v(je, {});
  if (!o)
    return v(je, {});
  for (var h = i.getFullYear(), p = o.getFullYear(), m = h; m <= p; m++)
    f.push(my(qS(/* @__PURE__ */ new Date()), m));
  var b = function(k) {
    var C = my(Qt(n), Number(k.target.value));
    t.onChange(C);
  }, y = (e = c == null ? void 0 : c.Dropdown) !== null && e !== void 0 ? e : rT;
  return v(y, { name: "years", "aria-label": d(), className: l.dropdown_year, style: a.dropdown_year, onChange: b, value: n.getFullYear(), caption: u(n, { locale: s }), children: f.map(function(k) {
    return v("option", { value: k.getFullYear(), children: u(k, { locale: s }) }, k.getFullYear());
  }) });
}
function v_(t, e) {
  var n = pe(t), r = n[0], i = n[1], o = e === void 0 ? r : e;
  return [o, i];
}
function b_(t) {
  var e = t.month, n = t.defaultMonth, r = t.today, i = e || n || r || /* @__PURE__ */ new Date(), o = t.toDate, s = t.fromDate, a = t.numberOfMonths, l = a === void 0 ? 1 : a;
  if (o && ca(o, i) < 0) {
    var c = -1 * (l - 1);
    i = jn(o, c);
  }
  return s && ca(i, s) < 0 && (i = s), Qt(i);
}
function y_() {
  var t = Je(), e = b_(t), n = v_(e, t.month), r = n[0], i = n[1], o = function(s) {
    var a;
    if (!t.disableNavigation) {
      var l = Qt(s);
      i(l), (a = t.onMonthChange) === null || a === void 0 || a.call(t, l);
    }
  };
  return [r, o];
}
function w_(t, e) {
  for (var n = e.reverseMonths, r = e.numberOfMonths, i = Qt(t), o = Qt(jn(i, r)), s = ca(o, i), a = [], l = 0; l < s; l++) {
    var c = jn(i, l);
    a.push(c);
  }
  return n && (a = a.reverse()), a;
}
function x_(t, e) {
  if (!e.disableNavigation) {
    var n = e.toDate, r = e.pagedNavigation, i = e.numberOfMonths, o = i === void 0 ? 1 : i, s = r ? o : 1, a = Qt(t);
    if (!n)
      return jn(a, s);
    var l = ca(n, t);
    if (!(l < o))
      return jn(a, s);
  }
}
function k_(t, e) {
  if (!e.disableNavigation) {
    var n = e.fromDate, r = e.pagedNavigation, i = e.numberOfMonths, o = i === void 0 ? 1 : i, s = r ? o : 1, a = Qt(t);
    if (!n)
      return jn(a, -s);
    var l = ca(a, n);
    if (!(l <= 0))
      return jn(a, -s);
  }
}
var iT = Pn(void 0);
function C_(t) {
  var e = Je(), n = y_(), r = n[0], i = n[1], o = w_(r, e), s = x_(r, e), a = k_(r, e), l = function(d) {
    return o.some(function(f) {
      return D0(d, f);
    });
  }, c = function(d, f) {
    l(d) || (f && QS(d, f) ? i(jn(d, 1 + e.numberOfMonths * -1)) : i(d));
  }, u = {
    currentMonth: r,
    displayMonths: o,
    goToMonth: i,
    goToDate: c,
    previousMonth: a,
    nextMonth: s,
    isDateDisplayed: l
  };
  return v(iT.Provider, { value: u, children: t.children });
}
function hs() {
  var t = Ln(iT);
  if (!t)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return t;
}
function gy(t) {
  var e, n = Je(), r = n.classNames, i = n.styles, o = n.components, s = hs().goToMonth, a = function(u) {
    s(jn(u, t.displayIndex ? -t.displayIndex : 0));
  }, l = (e = o == null ? void 0 : o.CaptionLabel) !== null && e !== void 0 ? e : nT, c = v(l, { id: t.id, displayMonth: t.displayMonth });
  return F("div", { className: r.caption_dropdowns, style: i.caption_dropdowns, children: [v("div", { className: r.vhidden, children: c }), v(m_, { onChange: a, displayMonth: t.displayMonth }), v(g_, { onChange: a, displayMonth: t.displayMonth })] });
}
function S_(t) {
  return v("svg", Ce({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, t, { children: v("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function T_(t) {
  return v("svg", Ce({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, t, { children: v("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var Mc = ce(function(t, e) {
  var n = Je(), r = n.classNames, i = n.styles, o = [r.button_reset, r.button];
  t.className && o.push(t.className);
  var s = o.join(" "), a = Ce(Ce({}, i.button_reset), i.button);
  return t.style && Object.assign(a, t.style), v("button", Ce({}, t, { ref: e, type: "button", className: s, style: a }));
});
function E_(t) {
  var e, n, r = Je(), i = r.dir, o = r.locale, s = r.classNames, a = r.styles, l = r.labels, c = l.labelPrevious, u = l.labelNext, d = r.components;
  if (!t.nextMonth && !t.previousMonth)
    return v(je, {});
  var f = c(t.previousMonth, { locale: o }), h = [
    s.nav_button,
    s.nav_button_previous
  ].join(" "), p = u(t.nextMonth, { locale: o }), m = [
    s.nav_button,
    s.nav_button_next
  ].join(" "), b = (e = d == null ? void 0 : d.IconRight) !== null && e !== void 0 ? e : T_, y = (n = d == null ? void 0 : d.IconLeft) !== null && n !== void 0 ? n : S_;
  return F("div", { className: s.nav, style: a.nav, children: [!t.hidePrevious && v(Mc, { name: "previous-month", "aria-label": f, className: h, style: a.nav_button_previous, disabled: !t.previousMonth, onClick: t.onPreviousClick, children: i === "rtl" ? v(b, { className: s.nav_icon, style: a.nav_icon }) : v(y, { className: s.nav_icon, style: a.nav_icon }) }), !t.hideNext && v(Mc, { name: "next-month", "aria-label": p, className: m, style: a.nav_button_next, disabled: !t.nextMonth, onClick: t.onNextClick, children: i === "rtl" ? v(y, { className: s.nav_icon, style: a.nav_icon }) : v(b, { className: s.nav_icon, style: a.nav_icon }) })] });
}
function vy(t) {
  var e = Je().numberOfMonths, n = hs(), r = n.previousMonth, i = n.nextMonth, o = n.goToMonth, s = n.displayMonths, a = s.findIndex(function(p) {
    return D0(t.displayMonth, p);
  }), l = a === 0, c = a === s.length - 1, u = e > 1 && (l || !c), d = e > 1 && (c || !l), f = function() {
    r && o(r);
  }, h = function() {
    i && o(i);
  };
  return v(E_, { displayMonth: t.displayMonth, hideNext: u, hidePrevious: d, nextMonth: i, previousMonth: r, onPreviousClick: f, onNextClick: h });
}
function M_(t) {
  var e, n = Je(), r = n.classNames, i = n.disableNavigation, o = n.styles, s = n.captionLayout, a = n.components, l = (e = a == null ? void 0 : a.CaptionLabel) !== null && e !== void 0 ? e : nT, c;
  return i ? c = v(l, { id: t.id, displayMonth: t.displayMonth }) : s === "dropdown" ? c = v(gy, { displayMonth: t.displayMonth, id: t.id }) : s === "dropdown-buttons" ? c = F(je, { children: [v(gy, { displayMonth: t.displayMonth, displayIndex: t.displayIndex, id: t.id }), v(vy, { displayMonth: t.displayMonth, displayIndex: t.displayIndex, id: t.id })] }) : c = F(je, { children: [v(l, { id: t.id, displayMonth: t.displayMonth, displayIndex: t.displayIndex }), v(vy, { displayMonth: t.displayMonth, id: t.id })] }), v("div", { className: r.caption, style: o.caption, children: c });
}
function O_(t) {
  var e = Je(), n = e.footer, r = e.styles, i = e.classNames.tfoot;
  return n ? v("tfoot", { className: i, style: r.tfoot, children: v("tr", { children: v("td", { colSpan: 8, children: n }) }) }) : v(je, {});
}
function A_(t, e, n) {
  for (var r = n ? eo(/* @__PURE__ */ new Date()) : cr(/* @__PURE__ */ new Date(), { locale: t, weekStartsOn: e }), i = [], o = 0; o < 7; o++) {
    var s = zt(r, o);
    i.push(s);
  }
  return i;
}
function N_() {
  var t = Je(), e = t.classNames, n = t.styles, r = t.showWeekNumber, i = t.locale, o = t.weekStartsOn, s = t.ISOWeek, a = t.formatters.formatWeekdayName, l = t.labels.labelWeekday, c = A_(i, o, s);
  return F("tr", { style: n.head_row, className: e.head_row, children: [r && v("td", { style: n.head_cell, className: e.head_cell }), c.map(function(u, d) {
    return v("th", { scope: "col", className: e.head_cell, style: n.head_cell, "aria-label": l(u, { locale: i }), children: a(u, { locale: i }) }, d);
  })] });
}
function R_() {
  var t, e = Je(), n = e.classNames, r = e.styles, i = e.components, o = (t = i == null ? void 0 : i.HeadRow) !== null && t !== void 0 ? t : N_;
  return v("thead", { style: r.head, className: n.head, children: v(o, {}) });
}
function D_(t) {
  var e = Je(), n = e.locale, r = e.formatters.formatDay;
  return v(je, { children: r(t.date, { locale: n }) });
}
var I0 = Pn(void 0);
function I_(t) {
  if (!La(t.initialProps)) {
    var e = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return v(I0.Provider, { value: e, children: t.children });
  }
  return v(__, { initialProps: t.initialProps, children: t.children });
}
function __(t) {
  var e = t.initialProps, n = t.children, r = e.selected, i = e.min, o = e.max, s = function(c, u, d) {
    var f, h;
    (f = e.onDayClick) === null || f === void 0 || f.call(e, c, u, d);
    var p = !!(u.selected && i && (r == null ? void 0 : r.length) === i);
    if (!p) {
      var m = !!(!u.selected && o && (r == null ? void 0 : r.length) === o);
      if (!m) {
        var b = r ? eT([], r) : [];
        if (u.selected) {
          var y = b.findIndex(function(k) {
            return Xt(c, k);
          });
          b.splice(y, 1);
        } else
          b.push(c);
        (h = e.onSelect) === null || h === void 0 || h.call(e, b, c, u, d);
      }
    }
  }, a = {
    disabled: []
  };
  r && a.disabled.push(function(c) {
    var u = o && r.length > o - 1, d = r.some(function(f) {
      return Xt(f, c);
    });
    return !!(u && !d);
  });
  var l = {
    selected: r,
    onDayClick: s,
    modifiers: a
  };
  return v(I0.Provider, { value: l, children: n });
}
function _0() {
  var t = Ln(I0);
  if (!t)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return t;
}
function P_(t, e) {
  var n = e || {}, r = n.from, i = n.to;
  return r && i ? Xt(i, t) && Xt(r, t) ? void 0 : Xt(i, t) ? { from: i, to: void 0 } : Xt(r, t) ? void 0 : Jp(r, t) ? { from: t, to: i } : { from: r, to: t } : i ? Jp(t, i) ? { from: i, to: t } : { from: t, to: i } : r ? QS(t, r) ? { from: t, to: r } : { from: r, to: t } : { from: t, to: void 0 };
}
var P0 = Pn(void 0);
function L_(t) {
  if (!Fa(t.initialProps)) {
    var e = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return v(P0.Provider, { value: e, children: t.children });
  }
  return v(F_, { initialProps: t.initialProps, children: t.children });
}
function F_(t) {
  var e = t.initialProps, n = t.children, r = e.selected, i = r || {}, o = i.from, s = i.to, a = e.min, l = e.max, c = function(h, p, m) {
    var b, y;
    (b = e.onDayClick) === null || b === void 0 || b.call(e, h, p, m);
    var k = P_(h, r);
    (y = e.onSelect) === null || y === void 0 || y.call(e, k, h, p, m);
  }, u = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (o ? (u.range_start = [o], s ? (u.range_end = [s], Xt(o, s) || (u.range_middle = [
    {
      after: o,
      before: s
    }
  ])) : u.range_end = [o]) : s && (u.range_start = [s], u.range_end = [s]), a && (o && !s && u.disabled.push({
    after: nf(o, a - 1),
    before: zt(o, a - 1)
  }), o && s && u.disabled.push({
    after: o,
    before: zt(o, a - 1)
  }), !o && s && u.disabled.push({
    after: nf(s, a - 1),
    before: zt(s, a - 1)
  })), l) {
    if (o && !s && (u.disabled.push({
      before: zt(o, -l + 1)
    }), u.disabled.push({
      after: zt(o, l - 1)
    })), o && s) {
      var d = rr(s, o) + 1, f = l - d;
      u.disabled.push({
        before: nf(o, f)
      }), u.disabled.push({
        after: zt(s, f)
      });
    }
    !o && s && (u.disabled.push({
      before: zt(s, -l + 1)
    }), u.disabled.push({
      after: zt(s, l - 1)
    }));
  }
  return v(P0.Provider, { value: { selected: r, onDayClick: c, modifiers: u }, children: n });
}
function L0() {
  var t = Ln(P0);
  if (!t)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return t;
}
function oc(t) {
  return Array.isArray(t) ? eT([], t) : t !== void 0 ? [t] : [];
}
function $_(t) {
  var e = {};
  return Object.entries(t).forEach(function(n) {
    var r = n[0], i = n[1];
    e[r] = oc(i);
  }), e;
}
var Un;
(function(t) {
  t.Outside = "outside", t.Disabled = "disabled", t.Selected = "selected", t.Hidden = "hidden", t.Today = "today", t.RangeStart = "range_start", t.RangeEnd = "range_end", t.RangeMiddle = "range_middle";
})(Un || (Un = {}));
var B_ = Un.Selected, xr = Un.Disabled, V_ = Un.Hidden, z_ = Un.Today, of = Un.RangeEnd, sf = Un.RangeMiddle, af = Un.RangeStart, H_ = Un.Outside;
function W_(t, e, n) {
  var r, i = (r = {}, r[B_] = oc(t.selected), r[xr] = oc(t.disabled), r[V_] = oc(t.hidden), r[z_] = [t.today], r[of] = [], r[sf] = [], r[af] = [], r[H_] = [], r);
  return t.fromDate && i[xr].push({ before: t.fromDate }), t.toDate && i[xr].push({ after: t.toDate }), La(t) ? i[xr] = i[xr].concat(e.modifiers[xr]) : Fa(t) && (i[xr] = i[xr].concat(n.modifiers[xr]), i[af] = n.modifiers[af], i[sf] = n.modifiers[sf], i[of] = n.modifiers[of]), i;
}
var oT = Pn(void 0);
function j_(t) {
  var e = Je(), n = _0(), r = L0(), i = W_(e, n, r), o = $_(e.modifiers), s = Ce(Ce({}, i), o);
  return v(oT.Provider, { value: s, children: t.children });
}
function sT() {
  var t = Ln(oT);
  if (!t)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return t;
}
function U_(t) {
  return !!(t && typeof t == "object" && "before" in t && "after" in t);
}
function q_(t) {
  return !!(t && typeof t == "object" && "from" in t);
}
function aT(t) {
  return !!(t && typeof t == "object" && "after" in t);
}
function lT(t) {
  return !!(t && typeof t == "object" && "before" in t);
}
function K_(t) {
  return !!(t && typeof t == "object" && "dayOfWeek" in t);
}
function G_(t, e) {
  var n, r = e.from, i = e.to;
  if (r && i) {
    var o = rr(i, r) < 0;
    o && (n = [i, r], r = n[0], i = n[1]);
    var s = rr(t, r) >= 0 && rr(i, t) >= 0;
    return s;
  }
  return i ? Xt(i, t) : r ? Xt(r, t) : !1;
}
function Y_(t) {
  return A0(t);
}
function Z_(t) {
  return Array.isArray(t) && t.every(A0);
}
function J_(t, e) {
  return e.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (Y_(n))
      return Xt(t, n);
    if (Z_(n))
      return n.includes(t);
    if (q_(n))
      return G_(t, n);
    if (K_(n))
      return n.dayOfWeek.includes(t.getDay());
    if (U_(n)) {
      var r = rr(n.before, t), i = rr(n.after, t), o = r > 0, s = i < 0, a = Jp(n.before, n.after);
      return a ? s && o : o || s;
    }
    return aT(n) ? rr(t, n.after) > 0 : lT(n) ? rr(n.before, t) > 0 : typeof n == "function" ? n(t) : !1;
  });
}
function F0(t, e, n) {
  var r = Object.keys(e).reduce(function(o, s) {
    var a = e[s];
    return J_(t, a) && o.push(s), o;
  }, []), i = {};
  return r.forEach(function(o) {
    return i[o] = !0;
  }), n && !D0(t, n) && (i.outside = !0), i;
}
function X_(t, e) {
  for (var n = Qt(t[0]), r = N0(t[t.length - 1]), i, o, s = n; s <= r; ) {
    var a = F0(s, e), l = !a.disabled && !a.hidden;
    if (!l) {
      s = zt(s, 1);
      continue;
    }
    if (a.selected)
      return s;
    a.today && !o && (o = s), i || (i = s), s = zt(s, 1);
  }
  return o || i;
}
var Q_ = 365;
function cT(t, e) {
  var n = e.moveBy, r = e.direction, i = e.context, o = e.modifiers, s = e.retry, a = s === void 0 ? { count: 0, lastFocused: t } : s, l = i.weekStartsOn, c = i.fromDate, u = i.toDate, d = i.locale, f = {
    day: zt,
    week: Zp,
    month: jn,
    year: WI,
    startOfWeek: function(b) {
      return i.ISOWeek ? eo(b) : cr(b, { locale: d, weekStartsOn: l });
    },
    endOfWeek: function(b) {
      return i.ISOWeek ? KS(b) : R0(b, { locale: d, weekStartsOn: l });
    }
  }, h = f[n](t, r === "after" ? 1 : -1);
  r === "before" && c ? h = jI([c, h]) : r === "after" && u && (h = UI([u, h]));
  var p = !0;
  if (o) {
    var m = F0(h, o);
    p = !m.disabled && !m.hidden;
  }
  return p ? h : a.count > Q_ ? a.lastFocused : cT(h, {
    moveBy: n,
    direction: r,
    context: i,
    modifiers: o,
    retry: Ce(Ce({}, a), { count: a.count + 1 })
  });
}
var uT = Pn(void 0);
function e6(t) {
  var e = hs(), n = sT(), r = pe(), i = r[0], o = r[1], s = pe(), a = s[0], l = s[1], c = X_(e.displayMonths, n), u = i ?? (a && e.isDateDisplayed(a)) ? a : c, d = function() {
    l(i), o(void 0);
  }, f = function(b) {
    o(b);
  }, h = Je(), p = function(b, y) {
    if (i) {
      var k = cT(i, {
        moveBy: b,
        direction: y,
        context: h,
        modifiers: n
      });
      Xt(i, k) || (e.goToDate(k, i), f(k));
    }
  }, m = {
    focusedDay: i,
    focusTarget: u,
    blur: d,
    focus: f,
    focusDayAfter: function() {
      return p("day", "after");
    },
    focusDayBefore: function() {
      return p("day", "before");
    },
    focusWeekAfter: function() {
      return p("week", "after");
    },
    focusWeekBefore: function() {
      return p("week", "before");
    },
    focusMonthBefore: function() {
      return p("month", "before");
    },
    focusMonthAfter: function() {
      return p("month", "after");
    },
    focusYearBefore: function() {
      return p("year", "before");
    },
    focusYearAfter: function() {
      return p("year", "after");
    },
    focusStartOfWeek: function() {
      return p("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return p("endOfWeek", "after");
    }
  };
  return v(uT.Provider, { value: m, children: t.children });
}
function $0() {
  var t = Ln(uT);
  if (!t)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return t;
}
function t6(t, e) {
  var n = sT(), r = F0(t, n, e);
  return r;
}
var B0 = Pn(void 0);
function n6(t) {
  if (!zu(t.initialProps)) {
    var e = {
      selected: void 0
    };
    return v(B0.Provider, { value: e, children: t.children });
  }
  return v(r6, { initialProps: t.initialProps, children: t.children });
}
function r6(t) {
  var e = t.initialProps, n = t.children, r = function(o, s, a) {
    var l, c, u;
    if ((l = e.onDayClick) === null || l === void 0 || l.call(e, o, s, a), s.selected && !e.required) {
      (c = e.onSelect) === null || c === void 0 || c.call(e, void 0, o, s, a);
      return;
    }
    (u = e.onSelect) === null || u === void 0 || u.call(e, o, o, s, a);
  }, i = {
    selected: e.selected,
    onDayClick: r
  };
  return v(B0.Provider, { value: i, children: n });
}
function dT() {
  var t = Ln(B0);
  if (!t)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return t;
}
function i6(t, e) {
  var n = Je(), r = dT(), i = _0(), o = L0(), s = $0(), a = s.focusDayAfter, l = s.focusDayBefore, c = s.focusWeekAfter, u = s.focusWeekBefore, d = s.blur, f = s.focus, h = s.focusMonthBefore, p = s.focusMonthAfter, m = s.focusYearBefore, b = s.focusYearAfter, y = s.focusStartOfWeek, k = s.focusEndOfWeek, C = function(_) {
    var D, q, V, H;
    zu(n) ? (D = r.onDayClick) === null || D === void 0 || D.call(r, t, e, _) : La(n) ? (q = i.onDayClick) === null || q === void 0 || q.call(i, t, e, _) : Fa(n) ? (V = o.onDayClick) === null || V === void 0 || V.call(o, t, e, _) : (H = n.onDayClick) === null || H === void 0 || H.call(n, t, e, _);
  }, x = function(_) {
    var D;
    f(t), (D = n.onDayFocus) === null || D === void 0 || D.call(n, t, e, _);
  }, S = function(_) {
    var D;
    d(), (D = n.onDayBlur) === null || D === void 0 || D.call(n, t, e, _);
  }, T = function(_) {
    var D;
    (D = n.onDayMouseEnter) === null || D === void 0 || D.call(n, t, e, _);
  }, E = function(_) {
    var D;
    (D = n.onDayMouseLeave) === null || D === void 0 || D.call(n, t, e, _);
  }, M = function(_) {
    var D;
    (D = n.onDayPointerEnter) === null || D === void 0 || D.call(n, t, e, _);
  }, O = function(_) {
    var D;
    (D = n.onDayPointerLeave) === null || D === void 0 || D.call(n, t, e, _);
  }, L = function(_) {
    var D;
    (D = n.onDayTouchCancel) === null || D === void 0 || D.call(n, t, e, _);
  }, $ = function(_) {
    var D;
    (D = n.onDayTouchEnd) === null || D === void 0 || D.call(n, t, e, _);
  }, z = function(_) {
    var D;
    (D = n.onDayTouchMove) === null || D === void 0 || D.call(n, t, e, _);
  }, B = function(_) {
    var D;
    (D = n.onDayTouchStart) === null || D === void 0 || D.call(n, t, e, _);
  }, A = function(_) {
    var D;
    (D = n.onDayKeyUp) === null || D === void 0 || D.call(n, t, e, _);
  }, N = function(_) {
    var D;
    switch (_.key) {
      case "ArrowLeft":
        _.preventDefault(), _.stopPropagation(), n.dir === "rtl" ? a() : l();
        break;
      case "ArrowRight":
        _.preventDefault(), _.stopPropagation(), n.dir === "rtl" ? l() : a();
        break;
      case "ArrowDown":
        _.preventDefault(), _.stopPropagation(), c();
        break;
      case "ArrowUp":
        _.preventDefault(), _.stopPropagation(), u();
        break;
      case "PageUp":
        _.preventDefault(), _.stopPropagation(), _.shiftKey ? m() : h();
        break;
      case "PageDown":
        _.preventDefault(), _.stopPropagation(), _.shiftKey ? b() : p();
        break;
      case "Home":
        _.preventDefault(), _.stopPropagation(), y();
        break;
      case "End":
        _.preventDefault(), _.stopPropagation(), k();
        break;
    }
    (D = n.onDayKeyDown) === null || D === void 0 || D.call(n, t, e, _);
  }, R = {
    onClick: C,
    onFocus: x,
    onBlur: S,
    onKeyDown: N,
    onKeyUp: A,
    onMouseEnter: T,
    onMouseLeave: E,
    onPointerEnter: M,
    onPointerLeave: O,
    onTouchCancel: L,
    onTouchEnd: $,
    onTouchMove: z,
    onTouchStart: B
  };
  return R;
}
function o6() {
  var t = Je(), e = dT(), n = _0(), r = L0(), i = zu(t) ? e.selected : La(t) ? n.selected : Fa(t) ? r.selected : void 0;
  return i;
}
function s6(t) {
  return Object.values(Un).includes(t);
}
function a6(t, e) {
  var n = [t.classNames.day];
  return Object.keys(e).forEach(function(r) {
    var i = t.modifiersClassNames[r];
    if (i)
      n.push(i);
    else if (s6(r)) {
      var o = t.classNames["day_".concat(r)];
      o && n.push(o);
    }
  }), n;
}
function l6(t, e) {
  var n = Ce({}, t.styles.day);
  return Object.keys(e).forEach(function(r) {
    var i;
    n = Ce(Ce({}, n), (i = t.modifiersStyles) === null || i === void 0 ? void 0 : i[r]);
  }), n;
}
function c6(t, e, n) {
  var r, i, o, s = Je(), a = $0(), l = t6(t, e), c = i6(t, l), u = o6(), d = !!(s.onDayClick || s.mode !== "default");
  De(function() {
    var T;
    l.outside || a.focusedDay && d && Xt(a.focusedDay, t) && ((T = n.current) === null || T === void 0 || T.focus());
  }, [
    a.focusedDay,
    t,
    n,
    d,
    l.outside
  ]);
  var f = a6(s, l).join(" "), h = l6(s, l), p = !!(l.outside && !s.showOutsideDays || l.hidden), m = (o = (i = s.components) === null || i === void 0 ? void 0 : i.DayContent) !== null && o !== void 0 ? o : D_, b = v(m, { date: t, displayMonth: e, activeModifiers: l }), y = {
    style: h,
    className: f,
    children: b,
    role: "gridcell"
  }, k = a.focusTarget && Xt(a.focusTarget, t) && !l.outside, C = a.focusedDay && Xt(a.focusedDay, t), x = Ce(Ce(Ce({}, y), (r = { disabled: l.disabled, role: "gridcell" }, r["aria-selected"] = l.selected, r.tabIndex = C || k ? 0 : -1, r)), c), S = {
    isButton: d,
    isHidden: p,
    activeModifiers: l,
    selectedDays: u,
    buttonProps: x,
    divProps: y
  };
  return S;
}
function u6(t) {
  var e = Me(null), n = c6(t.date, t.displayMonth, e);
  return n.isHidden ? v("div", { role: "gridcell" }) : n.isButton ? v(Mc, Ce({ name: "day", ref: e }, n.buttonProps)) : v("div", Ce({}, n.divProps));
}
function d6(t) {
  var e = t.number, n = t.dates, r = Je(), i = r.onWeekNumberClick, o = r.styles, s = r.classNames, a = r.locale, l = r.labels.labelWeekNumber, c = r.formatters.formatWeekNumber, u = c(Number(e), { locale: a });
  if (!i)
    return v("span", { className: s.weeknumber, style: o.weeknumber, children: u });
  var d = l(Number(e), { locale: a }), f = function(h) {
    i(e, n, h);
  };
  return v(Mc, { name: "week-number", "aria-label": d, className: s.weeknumber, style: o.weeknumber, onClick: f, children: u });
}
function f6(t) {
  var e, n, r = Je(), i = r.styles, o = r.classNames, s = r.showWeekNumber, a = r.components, l = (e = a == null ? void 0 : a.Day) !== null && e !== void 0 ? e : u6, c = (n = a == null ? void 0 : a.WeekNumber) !== null && n !== void 0 ? n : d6, u;
  return s && (u = v("td", { className: o.cell, style: i.cell, children: v(c, { number: t.weekNumber, dates: t.dates }) })), F("tr", { className: o.row, style: i.row, children: [u, t.dates.map(function(d) {
    return v("td", { className: o.cell, style: i.cell, role: "presentation", children: v(l, { displayMonth: t.displayMonth, date: d }) }, j4(d));
  })] });
}
function by(t, e, n) {
  for (var r = n != null && n.ISOWeek ? KS(e) : R0(e, n), i = n != null && n.ISOWeek ? eo(t) : cr(t, n), o = rr(r, i), s = [], a = 0; a <= o; a++)
    s.push(zt(i, a));
  var l = s.reduce(function(c, u) {
    var d = n != null && n.ISOWeek ? YS(u) : JS(u, n), f = c.find(function(h) {
      return h.weekNumber === d;
    });
    return f ? (f.dates.push(u), c) : (c.push({
      weekNumber: d,
      dates: [u]
    }), c);
  }, []);
  return l;
}
function h6(t, e) {
  var n = by(Qt(t), N0(t), e);
  if (e != null && e.useFixedWeeks) {
    var r = q4(t, e);
    if (r < 6) {
      var i = n[n.length - 1], o = i.dates[i.dates.length - 1], s = Zp(o, 6 - r), a = by(Zp(o, 1), s, e);
      n.push.apply(n, a);
    }
  }
  return n;
}
function p6(t) {
  var e, n, r, i = Je(), o = i.locale, s = i.classNames, a = i.styles, l = i.hideHead, c = i.fixedWeeks, u = i.components, d = i.weekStartsOn, f = i.firstWeekContainsDate, h = i.ISOWeek, p = h6(t.displayMonth, {
    useFixedWeeks: !!c,
    ISOWeek: h,
    locale: o,
    weekStartsOn: d,
    firstWeekContainsDate: f
  }), m = (e = u == null ? void 0 : u.Head) !== null && e !== void 0 ? e : R_, b = (n = u == null ? void 0 : u.Row) !== null && n !== void 0 ? n : f6, y = (r = u == null ? void 0 : u.Footer) !== null && r !== void 0 ? r : O_;
  return F("table", { id: t.id, className: s.table, style: a.table, role: "grid", "aria-labelledby": t["aria-labelledby"], children: [!l && v(m, {}), v("tbody", { className: s.tbody, style: a.tbody, children: p.map(function(k) {
    return v(b, { displayMonth: t.displayMonth, dates: k.dates, weekNumber: k.weekNumber }, k.weekNumber);
  }) }), v(y, { displayMonth: t.displayMonth })] });
}
function m6() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var g6 = m6() ? uo : De, lf = !1, v6 = 0;
function yy() {
  return "react-day-picker-".concat(++v6);
}
function b6(t) {
  var e, n = t ?? (lf ? yy() : null), r = pe(n), i = r[0], o = r[1];
  return g6(function() {
    i === null && o(yy());
  }, []), De(function() {
    lf === !1 && (lf = !0);
  }, []), (e = t ?? i) !== null && e !== void 0 ? e : void 0;
}
function y6(t) {
  var e, n, r = Je(), i = r.dir, o = r.classNames, s = r.styles, a = r.components, l = hs().displayMonths, c = b6(r.id ? "".concat(r.id, "-").concat(t.displayIndex) : void 0), u = r.id ? "".concat(r.id, "-grid-").concat(t.displayIndex) : void 0, d = [o.month], f = s.month, h = t.displayIndex === 0, p = t.displayIndex === l.length - 1, m = !h && !p;
  i === "rtl" && (e = [h, p], p = e[0], h = e[1]), h && (d.push(o.caption_start), f = Ce(Ce({}, f), s.caption_start)), p && (d.push(o.caption_end), f = Ce(Ce({}, f), s.caption_end)), m && (d.push(o.caption_between), f = Ce(Ce({}, f), s.caption_between));
  var b = (n = a == null ? void 0 : a.Caption) !== null && n !== void 0 ? n : M_;
  return F("div", { className: d.join(" "), style: f, children: [v(b, { id: c, displayMonth: t.displayMonth, displayIndex: t.displayIndex }), v(p6, { id: u, "aria-labelledby": c, displayMonth: t.displayMonth })] }, t.displayIndex);
}
function w6(t) {
  var e = Je(), n = e.classNames, r = e.styles;
  return v("div", { className: n.months, style: r.months, children: t.children });
}
function x6(t) {
  var e, n, r = t.initialProps, i = Je(), o = $0(), s = hs(), a = pe(!1), l = a[0], c = a[1];
  De(function() {
    i.initialFocus && o.focusTarget && (l || (o.focus(o.focusTarget), c(!0)));
  }, [
    i.initialFocus,
    l,
    o.focus,
    o.focusTarget,
    o
  ]);
  var u = [i.classNames.root, i.className];
  i.numberOfMonths > 1 && u.push(i.classNames.multiple_months), i.showWeekNumber && u.push(i.classNames.with_weeknumber);
  var d = Ce(Ce({}, i.styles.root), i.style), f = Object.keys(r).filter(function(p) {
    return p.startsWith("data-");
  }).reduce(function(p, m) {
    var b;
    return Ce(Ce({}, p), (b = {}, b[m] = r[m], b));
  }, {}), h = (n = (e = r.components) === null || e === void 0 ? void 0 : e.Months) !== null && n !== void 0 ? n : w6;
  return v("div", Ce({ className: u.join(" "), style: d, dir: i.dir, id: i.id, nonce: r.nonce, title: r.title, lang: r.lang }, f, { children: v(h, { children: s.displayMonths.map(function(p, m) {
    return v(y6, { displayIndex: m, displayMonth: p }, m);
  }) }) }));
}
function k6(t) {
  var e = t.children, n = G4(t, ["children"]);
  return v(h_, { initialProps: n, children: v(C_, { children: v(n6, { initialProps: n, children: v(I_, { initialProps: n, children: v(L_, { initialProps: n, children: v(j_, { children: v(e6, { children: e }) }) }) }) }) }) });
}
function C6(t) {
  return v(k6, Ce({}, t, { children: v(x6, { initialProps: t }) }));
}
class ho extends Error {
}
class S6 extends ho {
  constructor(e) {
    super(`Invalid DateTime: ${e.toMessage()}`);
  }
}
class T6 extends ho {
  constructor(e) {
    super(`Invalid Interval: ${e.toMessage()}`);
  }
}
class E6 extends ho {
  constructor(e) {
    super(`Invalid Duration: ${e.toMessage()}`);
  }
}
class Fo extends ho {
}
class fT extends ho {
  constructor(e) {
    super(`Invalid unit ${e}`);
  }
}
class Rt extends ho {
}
class Wr extends ho {
  constructor() {
    super("Zone is an abstract class");
  }
}
const re = "numeric", qn = "short", dn = "long", Oc = {
  year: re,
  month: re,
  day: re
}, hT = {
  year: re,
  month: qn,
  day: re
}, M6 = {
  year: re,
  month: qn,
  day: re,
  weekday: qn
}, pT = {
  year: re,
  month: dn,
  day: re
}, mT = {
  year: re,
  month: dn,
  day: re,
  weekday: dn
}, gT = {
  hour: re,
  minute: re
}, vT = {
  hour: re,
  minute: re,
  second: re
}, bT = {
  hour: re,
  minute: re,
  second: re,
  timeZoneName: qn
}, yT = {
  hour: re,
  minute: re,
  second: re,
  timeZoneName: dn
}, wT = {
  hour: re,
  minute: re,
  hourCycle: "h23"
}, xT = {
  hour: re,
  minute: re,
  second: re,
  hourCycle: "h23"
}, kT = {
  hour: re,
  minute: re,
  second: re,
  hourCycle: "h23",
  timeZoneName: qn
}, CT = {
  hour: re,
  minute: re,
  second: re,
  hourCycle: "h23",
  timeZoneName: dn
}, ST = {
  year: re,
  month: re,
  day: re,
  hour: re,
  minute: re
}, TT = {
  year: re,
  month: re,
  day: re,
  hour: re,
  minute: re,
  second: re
}, ET = {
  year: re,
  month: qn,
  day: re,
  hour: re,
  minute: re
}, MT = {
  year: re,
  month: qn,
  day: re,
  hour: re,
  minute: re,
  second: re
}, O6 = {
  year: re,
  month: qn,
  day: re,
  weekday: qn,
  hour: re,
  minute: re
}, OT = {
  year: re,
  month: dn,
  day: re,
  hour: re,
  minute: re,
  timeZoneName: qn
}, AT = {
  year: re,
  month: dn,
  day: re,
  hour: re,
  minute: re,
  second: re,
  timeZoneName: qn
}, NT = {
  year: re,
  month: dn,
  day: re,
  weekday: dn,
  hour: re,
  minute: re,
  timeZoneName: dn
}, RT = {
  year: re,
  month: dn,
  day: re,
  weekday: dn,
  hour: re,
  minute: re,
  second: re,
  timeZoneName: dn
};
class $a {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new Wr();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new Wr();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new Wr();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(e, n) {
    throw new Wr();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, n) {
    throw new Wr();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(e) {
    throw new Wr();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    throw new Wr();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new Wr();
  }
}
let cf = null;
class Hu extends $a {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return cf === null && (cf = new Hu()), cf;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(e, { format: n, locale: r }) {
    return HT(e, n, r);
  }
  /** @override **/
  formatOffset(e, n) {
    return Gs(this.offset(e), n);
  }
  /** @override **/
  offset(e) {
    return -new Date(e).getTimezoneOffset();
  }
  /** @override **/
  equals(e) {
    return e.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
const Xp = /* @__PURE__ */ new Map();
function A6(t) {
  let e = Xp.get(t);
  return e === void 0 && (e = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  }), Xp.set(t, e)), e;
}
const N6 = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function R6(t, e) {
  const n = t.format(e).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(n), [, i, o, s, a, l, c, u] = r;
  return [s, i, o, a, l, c, u];
}
function D6(t, e) {
  const n = t.formatToParts(e), r = [];
  for (let i = 0; i < n.length; i++) {
    const { type: o, value: s } = n[i], a = N6[o];
    o === "era" ? r[a] = s : Te(a) || (r[a] = parseInt(s, 10));
  }
  return r;
}
const uf = /* @__PURE__ */ new Map();
class Pr extends $a {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(e) {
    let n = uf.get(e);
    return n === void 0 && uf.set(e, n = new Pr(e)), n;
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    uf.clear(), Xp.clear();
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(e) {
    return this.isValidZone(e);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(e) {
    if (!e)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: e }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(e) {
    super(), this.zoneName = e, this.valid = Pr.isValidZone(e);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !1;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(e, { format: n, locale: r }) {
    return HT(e, n, r, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, n) {
    return Gs(this.offset(e), n);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(e) {
    if (!this.valid) return NaN;
    const n = new Date(e);
    if (isNaN(n)) return NaN;
    const r = A6(this.name);
    let [i, o, s, a, l, c, u] = r.formatToParts ? D6(r, n) : R6(r, n);
    a === "BC" && (i = -Math.abs(i) + 1);
    const f = ju({
      year: i,
      month: o,
      day: s,
      hour: l === 24 ? 0 : l,
      minute: c,
      second: u,
      millisecond: 0
    });
    let h = +n;
    const p = h % 1e3;
    return h -= p >= 0 ? p : 1e3 + p, (f - h) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    return e.type === "iana" && e.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let wy = {};
function I6(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let r = wy[n];
  return r || (r = new Intl.ListFormat(t, e), wy[n] = r), r;
}
const Qp = /* @__PURE__ */ new Map();
function em(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let r = Qp.get(n);
  return r === void 0 && (r = new Intl.DateTimeFormat(t, e), Qp.set(n, r)), r;
}
const tm = /* @__PURE__ */ new Map();
function _6(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let r = tm.get(n);
  return r === void 0 && (r = new Intl.NumberFormat(t, e), tm.set(n, r)), r;
}
const nm = /* @__PURE__ */ new Map();
function P6(t, e = {}) {
  const { base: n, ...r } = e, i = JSON.stringify([t, r]);
  let o = nm.get(i);
  return o === void 0 && (o = new Intl.RelativeTimeFormat(t, e), nm.set(i, o)), o;
}
let Ps = null;
function L6() {
  return Ps || (Ps = new Intl.DateTimeFormat().resolvedOptions().locale, Ps);
}
const rm = /* @__PURE__ */ new Map();
function DT(t) {
  let e = rm.get(t);
  return e === void 0 && (e = new Intl.DateTimeFormat(t).resolvedOptions(), rm.set(t, e)), e;
}
const im = /* @__PURE__ */ new Map();
function F6(t) {
  let e = im.get(t);
  if (!e) {
    const n = new Intl.Locale(t);
    e = "getWeekInfo" in n ? n.getWeekInfo() : n.weekInfo, "minimalDays" in e || (e = { ...IT, ...e }), im.set(t, e);
  }
  return e;
}
function $6(t) {
  const e = t.indexOf("-x-");
  e !== -1 && (t = t.substring(0, e));
  const n = t.indexOf("-u-");
  if (n === -1)
    return [t];
  {
    let r, i;
    try {
      r = em(t).resolvedOptions(), i = t;
    } catch {
      const l = t.substring(0, n);
      r = em(l).resolvedOptions(), i = l;
    }
    const { numberingSystem: o, calendar: s } = r;
    return [i, o, s];
  }
}
function B6(t, e, n) {
  return (n || e) && (t.includes("-u-") || (t += "-u"), n && (t += `-ca-${n}`), e && (t += `-nu-${e}`)), t;
}
function V6(t) {
  const e = [];
  for (let n = 1; n <= 12; n++) {
    const r = de.utc(2009, n, 1);
    e.push(t(r));
  }
  return e;
}
function z6(t) {
  const e = [];
  for (let n = 1; n <= 7; n++) {
    const r = de.utc(2016, 11, 13 + n);
    e.push(t(r));
  }
  return e;
}
function yl(t, e, n, r) {
  const i = t.listingMode();
  return i === "error" ? null : i === "en" ? n(e) : r(e);
}
function H6(t) {
  return t.numberingSystem && t.numberingSystem !== "latn" ? !1 : t.numberingSystem === "latn" || !t.locale || t.locale.startsWith("en") || DT(t.locale).numberingSystem === "latn";
}
class W6 {
  constructor(e, n, r) {
    this.padTo = r.padTo || 0, this.floor = r.floor || !1;
    const { padTo: i, floor: o, ...s } = r;
    if (!n || Object.keys(s).length > 0) {
      const a = { useGrouping: !1, ...r };
      r.padTo > 0 && (a.minimumIntegerDigits = r.padTo), this.inf = _6(e, a);
    }
  }
  format(e) {
    if (this.inf) {
      const n = this.floor ? Math.floor(e) : e;
      return this.inf.format(n);
    } else {
      const n = this.floor ? Math.floor(e) : j0(e, 3);
      return ut(n, this.padTo);
    }
  }
}
class j6 {
  constructor(e, n, r) {
    this.opts = r, this.originalZone = void 0;
    let i;
    if (this.opts.timeZone)
      this.dt = e;
    else if (e.zone.type === "fixed") {
      const s = -1 * (e.offset / 60), a = s >= 0 ? `Etc/GMT+${s}` : `Etc/GMT${s}`;
      e.offset !== 0 && Pr.create(a).valid ? (i = a, this.dt = e) : (i = "UTC", this.dt = e.offset === 0 ? e : e.setZone("UTC").plus({ minutes: e.offset }), this.originalZone = e.zone);
    } else e.zone.type === "system" ? this.dt = e : e.zone.type === "iana" ? (this.dt = e, i = e.zone.name) : (i = "UTC", this.dt = e.setZone("UTC").plus({ minutes: e.offset }), this.originalZone = e.zone);
    const o = { ...this.opts };
    o.timeZone = o.timeZone || i, this.dtf = em(n, o);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: e }) => e).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const e = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? e.map((n) => {
      if (n.type === "timeZoneName") {
        const r = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...n,
          value: r
        };
      } else
        return n;
    }) : e;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class U6 {
  constructor(e, n, r) {
    this.opts = { style: "long", ...r }, !n && VT() && (this.rtf = P6(e, r));
  }
  format(e, n) {
    return this.rtf ? this.rtf.format(e, n) : hP(n, e, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(e, n) {
    return this.rtf ? this.rtf.formatToParts(e, n) : [];
  }
}
const IT = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class We {
  static fromOpts(e) {
    return We.create(
      e.locale,
      e.numberingSystem,
      e.outputCalendar,
      e.weekSettings,
      e.defaultToEN
    );
  }
  static create(e, n, r, i, o = !1) {
    const s = e || it.defaultLocale, a = s || (o ? "en-US" : L6()), l = n || it.defaultNumberingSystem, c = r || it.defaultOutputCalendar, u = sm(i) || it.defaultWeekSettings;
    return new We(a, l, c, u, s);
  }
  static resetCache() {
    Ps = null, Qp.clear(), tm.clear(), nm.clear(), rm.clear(), im.clear();
  }
  static fromObject({ locale: e, numberingSystem: n, outputCalendar: r, weekSettings: i } = {}) {
    return We.create(e, n, r, i);
  }
  constructor(e, n, r, i, o) {
    const [s, a, l] = $6(e);
    this.locale = s, this.numberingSystem = n || a || null, this.outputCalendar = r || l || null, this.weekSettings = i, this.intl = B6(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = o, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = H6(this)), this.fastNumbersCached;
  }
  listingMode() {
    const e = this.isEnglish(), n = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return e && n ? "en" : "intl";
  }
  clone(e) {
    return !e || Object.getOwnPropertyNames(e).length === 0 ? this : We.create(
      e.locale || this.specifiedLocale,
      e.numberingSystem || this.numberingSystem,
      e.outputCalendar || this.outputCalendar,
      sm(e.weekSettings) || this.weekSettings,
      e.defaultToEN || !1
    );
  }
  redefaultToEN(e = {}) {
    return this.clone({ ...e, defaultToEN: !0 });
  }
  redefaultToSystem(e = {}) {
    return this.clone({ ...e, defaultToEN: !1 });
  }
  months(e, n = !1) {
    return yl(this, e, UT, () => {
      const r = n ? { month: e, day: "numeric" } : { month: e }, i = n ? "format" : "standalone";
      return this.monthsCache[i][e] || (this.monthsCache[i][e] = V6((o) => this.extract(o, r, "month"))), this.monthsCache[i][e];
    });
  }
  weekdays(e, n = !1) {
    return yl(this, e, GT, () => {
      const r = n ? { weekday: e, year: "numeric", month: "long", day: "numeric" } : { weekday: e }, i = n ? "format" : "standalone";
      return this.weekdaysCache[i][e] || (this.weekdaysCache[i][e] = z6(
        (o) => this.extract(o, r, "weekday")
      )), this.weekdaysCache[i][e];
    });
  }
  meridiems() {
    return yl(
      this,
      void 0,
      () => YT,
      () => {
        if (!this.meridiemCache) {
          const e = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [de.utc(2016, 11, 13, 9), de.utc(2016, 11, 13, 19)].map(
            (n) => this.extract(n, e, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(e) {
    return yl(this, e, ZT, () => {
      const n = { era: e };
      return this.eraCache[e] || (this.eraCache[e] = [de.utc(-40, 1, 1), de.utc(2017, 1, 1)].map(
        (r) => this.extract(r, n, "era")
      )), this.eraCache[e];
    });
  }
  extract(e, n, r) {
    const i = this.dtFormatter(e, n), o = i.formatToParts(), s = o.find((a) => a.type.toLowerCase() === r);
    return s ? s.value : null;
  }
  numberFormatter(e = {}) {
    return new W6(this.intl, e.forceSimple || this.fastNumbers, e);
  }
  dtFormatter(e, n = {}) {
    return new j6(e, this.intl, n);
  }
  relFormatter(e = {}) {
    return new U6(this.intl, this.isEnglish(), e);
  }
  listFormatter(e = {}) {
    return I6(this.intl, e);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || DT(this.intl).locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : zT() ? F6(this.locale) : IT;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(e) {
    return this.locale === e.locale && this.numberingSystem === e.numberingSystem && this.outputCalendar === e.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let df = null;
class Ht extends $a {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return df === null && (df = new Ht(0)), df;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(e) {
    return e === 0 ? Ht.utcInstance : new Ht(e);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(e) {
    if (e) {
      const n = e.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (n)
        return new Ht(Uu(n[1], n[2]));
    }
    return null;
  }
  constructor(e) {
    super(), this.fixed = e;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${Gs(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${Gs(-this.fixed, "narrow")}`;
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, n) {
    return Gs(this.fixed, n);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !0;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    return e.type === "fixed" && e.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return !0;
  }
}
class q6 extends $a {
  constructor(e) {
    super(), this.zoneName = e;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function Qr(t, e) {
  if (Te(t) || t === null)
    return e;
  if (t instanceof $a)
    return t;
  if (X6(t)) {
    const n = t.toLowerCase();
    return n === "default" ? e : n === "local" || n === "system" ? Hu.instance : n === "utc" || n === "gmt" ? Ht.utcInstance : Ht.parseSpecifier(n) || Pr.create(t);
  } else return li(t) ? Ht.instance(t) : typeof t == "object" && "offset" in t && typeof t.offset == "function" ? t : new q6(t);
}
const V0 = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, xy = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, K6 = V0.hanidec.replace(/[\[|\]]/g, "").split("");
function G6(t) {
  let e = parseInt(t, 10);
  if (isNaN(e)) {
    e = "";
    for (let n = 0; n < t.length; n++) {
      const r = t.charCodeAt(n);
      if (t[n].search(V0.hanidec) !== -1)
        e += K6.indexOf(t[n]);
      else
        for (const i in xy) {
          const [o, s] = xy[i];
          r >= o && r <= s && (e += r - o);
        }
    }
    return parseInt(e, 10);
  } else
    return e;
}
const om = /* @__PURE__ */ new Map();
function Y6() {
  om.clear();
}
function Fn({ numberingSystem: t }, e = "") {
  const n = t || "latn";
  let r = om.get(n);
  r === void 0 && (r = /* @__PURE__ */ new Map(), om.set(n, r));
  let i = r.get(e);
  return i === void 0 && (i = new RegExp(`${V0[n]}${e}`), r.set(e, i)), i;
}
let ky = () => Date.now(), Cy = "system", Sy = null, Ty = null, Ey = null, My = 60, Oy, Ay = null;
class it {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return ky;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(e) {
    ky = e;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(e) {
    Cy = e;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return Qr(Cy, Hu.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return Sy;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(e) {
    Sy = e;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return Ty;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(e) {
    Ty = e;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return Ey;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(e) {
    Ey = e;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return Ay;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(e) {
    Ay = sm(e);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return My;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(e) {
    My = e % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return Oy;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(e) {
    Oy = e;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    We.resetCache(), Pr.resetCache(), de.resetCache(), Y6();
  }
}
class zn {
  constructor(e, n) {
    this.reason = e, this.explanation = n;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const _T = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], PT = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function On(t, e) {
  return new zn(
    "unit out of range",
    `you specified ${e} (of type ${typeof e}) as a ${t}, which is invalid`
  );
}
function z0(t, e, n) {
  const r = new Date(Date.UTC(t, e - 1, n));
  t < 100 && t >= 0 && r.setUTCFullYear(r.getUTCFullYear() - 1900);
  const i = r.getUTCDay();
  return i === 0 ? 7 : i;
}
function LT(t, e, n) {
  return n + (Ba(t) ? PT : _T)[e - 1];
}
function FT(t, e) {
  const n = Ba(t) ? PT : _T, r = n.findIndex((o) => o < e), i = e - n[r];
  return { month: r + 1, day: i };
}
function H0(t, e) {
  return (t - e + 7) % 7 + 1;
}
function Ac(t, e = 4, n = 1) {
  const { year: r, month: i, day: o } = t, s = LT(r, i, o), a = H0(z0(r, i, o), n);
  let l = Math.floor((s - a + 14 - e) / 7), c;
  return l < 1 ? (c = r - 1, l = ua(c, e, n)) : l > ua(r, e, n) ? (c = r + 1, l = 1) : c = r, { weekYear: c, weekNumber: l, weekday: a, ...qu(t) };
}
function Ny(t, e = 4, n = 1) {
  const { weekYear: r, weekNumber: i, weekday: o } = t, s = H0(z0(r, 1, e), n), a = Ho(r);
  let l = i * 7 + o - s - 7 + e, c;
  l < 1 ? (c = r - 1, l += Ho(c)) : l > a ? (c = r + 1, l -= Ho(r)) : c = r;
  const { month: u, day: d } = FT(c, l);
  return { year: c, month: u, day: d, ...qu(t) };
}
function ff(t) {
  const { year: e, month: n, day: r } = t, i = LT(e, n, r);
  return { year: e, ordinal: i, ...qu(t) };
}
function Ry(t) {
  const { year: e, ordinal: n } = t, { month: r, day: i } = FT(e, n);
  return { year: e, month: r, day: i, ...qu(t) };
}
function Dy(t, e) {
  if (!Te(t.localWeekday) || !Te(t.localWeekNumber) || !Te(t.localWeekYear)) {
    if (!Te(t.weekday) || !Te(t.weekNumber) || !Te(t.weekYear))
      throw new Fo(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return Te(t.localWeekday) || (t.weekday = t.localWeekday), Te(t.localWeekNumber) || (t.weekNumber = t.localWeekNumber), Te(t.localWeekYear) || (t.weekYear = t.localWeekYear), delete t.localWeekday, delete t.localWeekNumber, delete t.localWeekYear, {
      minDaysInFirstWeek: e.getMinDaysInFirstWeek(),
      startOfWeek: e.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function Z6(t, e = 4, n = 1) {
  const r = Wu(t.weekYear), i = An(
    t.weekNumber,
    1,
    ua(t.weekYear, e, n)
  ), o = An(t.weekday, 1, 7);
  return r ? i ? o ? !1 : On("weekday", t.weekday) : On("week", t.weekNumber) : On("weekYear", t.weekYear);
}
function J6(t) {
  const e = Wu(t.year), n = An(t.ordinal, 1, Ho(t.year));
  return e ? n ? !1 : On("ordinal", t.ordinal) : On("year", t.year);
}
function $T(t) {
  const e = Wu(t.year), n = An(t.month, 1, 12), r = An(t.day, 1, Nc(t.year, t.month));
  return e ? n ? r ? !1 : On("day", t.day) : On("month", t.month) : On("year", t.year);
}
function BT(t) {
  const { hour: e, minute: n, second: r, millisecond: i } = t, o = An(e, 0, 23) || e === 24 && n === 0 && r === 0 && i === 0, s = An(n, 0, 59), a = An(r, 0, 59), l = An(i, 0, 999);
  return o ? s ? a ? l ? !1 : On("millisecond", i) : On("second", r) : On("minute", n) : On("hour", e);
}
function Te(t) {
  return typeof t > "u";
}
function li(t) {
  return typeof t == "number";
}
function Wu(t) {
  return typeof t == "number" && t % 1 === 0;
}
function X6(t) {
  return typeof t == "string";
}
function Q6(t) {
  return Object.prototype.toString.call(t) === "[object Date]";
}
function VT() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function zT() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function eP(t) {
  return Array.isArray(t) ? t : [t];
}
function Iy(t, e, n) {
  if (t.length !== 0)
    return t.reduce((r, i) => {
      const o = [e(i), i];
      return r && n(r[0], o[0]) === r[0] ? r : o;
    }, null)[1];
}
function tP(t, e) {
  return e.reduce((n, r) => (n[r] = t[r], n), {});
}
function Zo(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function sm(t) {
  if (t == null)
    return null;
  if (typeof t != "object")
    throw new Rt("Week settings must be an object");
  if (!An(t.firstDay, 1, 7) || !An(t.minimalDays, 1, 7) || !Array.isArray(t.weekend) || t.weekend.some((e) => !An(e, 1, 7)))
    throw new Rt("Invalid week settings");
  return {
    firstDay: t.firstDay,
    minimalDays: t.minimalDays,
    weekend: Array.from(t.weekend)
  };
}
function An(t, e, n) {
  return Wu(t) && t >= e && t <= n;
}
function nP(t, e) {
  return t - e * Math.floor(t / e);
}
function ut(t, e = 2) {
  const n = t < 0;
  let r;
  return n ? r = "-" + ("" + -t).padStart(e, "0") : r = ("" + t).padStart(e, "0"), r;
}
function Yr(t) {
  if (!(Te(t) || t === null || t === ""))
    return parseInt(t, 10);
}
function _i(t) {
  if (!(Te(t) || t === null || t === ""))
    return parseFloat(t);
}
function W0(t) {
  if (!(Te(t) || t === null || t === "")) {
    const e = parseFloat("0." + t) * 1e3;
    return Math.floor(e);
  }
}
function j0(t, e, n = !1) {
  const r = 10 ** e;
  return (n ? Math.trunc : Math.round)(t * r) / r;
}
function Ba(t) {
  return t % 4 === 0 && (t % 100 !== 0 || t % 400 === 0);
}
function Ho(t) {
  return Ba(t) ? 366 : 365;
}
function Nc(t, e) {
  const n = nP(e - 1, 12) + 1, r = t + (e - n) / 12;
  return n === 2 ? Ba(r) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][n - 1];
}
function ju(t) {
  let e = Date.UTC(
    t.year,
    t.month - 1,
    t.day,
    t.hour,
    t.minute,
    t.second,
    t.millisecond
  );
  return t.year < 100 && t.year >= 0 && (e = new Date(e), e.setUTCFullYear(t.year, t.month - 1, t.day)), +e;
}
function _y(t, e, n) {
  return -H0(z0(t, 1, e), n) + e - 1;
}
function ua(t, e = 4, n = 1) {
  const r = _y(t, e, n), i = _y(t + 1, e, n);
  return (Ho(t) - r + i) / 7;
}
function am(t) {
  return t > 99 ? t : t > it.twoDigitCutoffYear ? 1900 + t : 2e3 + t;
}
function HT(t, e, n, r = null) {
  const i = new Date(t), o = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  r && (o.timeZone = r);
  const s = { timeZoneName: e, ...o }, a = new Intl.DateTimeFormat(n, s).formatToParts(i).find((l) => l.type.toLowerCase() === "timezonename");
  return a ? a.value : null;
}
function Uu(t, e) {
  let n = parseInt(t, 10);
  Number.isNaN(n) && (n = 0);
  const r = parseInt(e, 10) || 0, i = n < 0 || Object.is(n, -0) ? -r : r;
  return n * 60 + i;
}
function WT(t) {
  const e = Number(t);
  if (typeof t == "boolean" || t === "" || Number.isNaN(e))
    throw new Rt(`Invalid unit value ${t}`);
  return e;
}
function Rc(t, e) {
  const n = {};
  for (const r in t)
    if (Zo(t, r)) {
      const i = t[r];
      if (i == null) continue;
      n[e(r)] = WT(i);
    }
  return n;
}
function Gs(t, e) {
  const n = Math.trunc(Math.abs(t / 60)), r = Math.trunc(Math.abs(t % 60)), i = t >= 0 ? "+" : "-";
  switch (e) {
    case "short":
      return `${i}${ut(n, 2)}:${ut(r, 2)}`;
    case "narrow":
      return `${i}${n}${r > 0 ? `:${r}` : ""}`;
    case "techie":
      return `${i}${ut(n, 2)}${ut(r, 2)}`;
    default:
      throw new RangeError(`Value format ${e} is out of range for property format`);
  }
}
function qu(t) {
  return tP(t, ["hour", "minute", "second", "millisecond"]);
}
const rP = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], jT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], iP = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function UT(t) {
  switch (t) {
    case "narrow":
      return [...iP];
    case "short":
      return [...jT];
    case "long":
      return [...rP];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const qT = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], KT = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], oP = ["M", "T", "W", "T", "F", "S", "S"];
function GT(t) {
  switch (t) {
    case "narrow":
      return [...oP];
    case "short":
      return [...KT];
    case "long":
      return [...qT];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const YT = ["AM", "PM"], sP = ["Before Christ", "Anno Domini"], aP = ["BC", "AD"], lP = ["B", "A"];
function ZT(t) {
  switch (t) {
    case "narrow":
      return [...lP];
    case "short":
      return [...aP];
    case "long":
      return [...sP];
    default:
      return null;
  }
}
function cP(t) {
  return YT[t.hour < 12 ? 0 : 1];
}
function uP(t, e) {
  return GT(e)[t.weekday - 1];
}
function dP(t, e) {
  return UT(e)[t.month - 1];
}
function fP(t, e) {
  return ZT(e)[t.year < 0 ? 0 : 1];
}
function hP(t, e, n = "always", r = !1) {
  const i = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, o = ["hours", "minutes", "seconds"].indexOf(t) === -1;
  if (n === "auto" && o) {
    const d = t === "days";
    switch (e) {
      case 1:
        return d ? "tomorrow" : `next ${i[t][0]}`;
      case -1:
        return d ? "yesterday" : `last ${i[t][0]}`;
      case 0:
        return d ? "today" : `this ${i[t][0]}`;
    }
  }
  const s = Object.is(e, -0) || e < 0, a = Math.abs(e), l = a === 1, c = i[t], u = r ? l ? c[1] : c[2] || c[1] : l ? i[t][0] : t;
  return s ? `${a} ${u} ago` : `in ${a} ${u}`;
}
function Py(t, e) {
  let n = "";
  for (const r of t)
    r.literal ? n += r.val : n += e(r.val);
  return n;
}
const pP = {
  D: Oc,
  DD: hT,
  DDD: pT,
  DDDD: mT,
  t: gT,
  tt: vT,
  ttt: bT,
  tttt: yT,
  T: wT,
  TT: xT,
  TTT: kT,
  TTTT: CT,
  f: ST,
  ff: ET,
  fff: OT,
  ffff: NT,
  F: TT,
  FF: MT,
  FFF: AT,
  FFFF: RT
};
class Dt {
  static create(e, n = {}) {
    return new Dt(e, n);
  }
  static parseFormat(e) {
    let n = null, r = "", i = !1;
    const o = [];
    for (let s = 0; s < e.length; s++) {
      const a = e.charAt(s);
      a === "'" ? (r.length > 0 && o.push({ literal: i || /^\s+$/.test(r), val: r }), n = null, r = "", i = !i) : i || a === n ? r += a : (r.length > 0 && o.push({ literal: /^\s+$/.test(r), val: r }), r = a, n = a);
    }
    return r.length > 0 && o.push({ literal: i || /^\s+$/.test(r), val: r }), o;
  }
  static macroTokenToFormatOpts(e) {
    return pP[e];
  }
  constructor(e, n) {
    this.opts = n, this.loc = e, this.systemLoc = null;
  }
  formatWithSystemDefault(e, n) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(e, { ...this.opts, ...n }).format();
  }
  dtFormatter(e, n = {}) {
    return this.loc.dtFormatter(e, { ...this.opts, ...n });
  }
  formatDateTime(e, n) {
    return this.dtFormatter(e, n).format();
  }
  formatDateTimeParts(e, n) {
    return this.dtFormatter(e, n).formatToParts();
  }
  formatInterval(e, n) {
    return this.dtFormatter(e.start, n).dtf.formatRange(e.start.toJSDate(), e.end.toJSDate());
  }
  resolvedOptions(e, n) {
    return this.dtFormatter(e, n).resolvedOptions();
  }
  num(e, n = 0) {
    if (this.opts.forceSimple)
      return ut(e, n);
    const r = { ...this.opts };
    return n > 0 && (r.padTo = n), this.loc.numberFormatter(r).format(e);
  }
  formatDateTimeFromString(e, n) {
    const r = this.loc.listingMode() === "en", i = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", o = (h, p) => this.loc.extract(e, h, p), s = (h) => e.isOffsetFixed && e.offset === 0 && h.allowZ ? "Z" : e.isValid ? e.zone.formatOffset(e.ts, h.format) : "", a = () => r ? cP(e) : o({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), l = (h, p) => r ? dP(e, h) : o(p ? { month: h } : { month: h, day: "numeric" }, "month"), c = (h, p) => r ? uP(e, h) : o(
      p ? { weekday: h } : { weekday: h, month: "long", day: "numeric" },
      "weekday"
    ), u = (h) => {
      const p = Dt.macroTokenToFormatOpts(h);
      return p ? this.formatWithSystemDefault(e, p) : h;
    }, d = (h) => r ? fP(e, h) : o({ era: h }, "era"), f = (h) => {
      switch (h) {
        // ms
        case "S":
          return this.num(e.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(e.millisecond, 3);
        // seconds
        case "s":
          return this.num(e.second);
        case "ss":
          return this.num(e.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(e.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(e.millisecond / 100));
        // minutes
        case "m":
          return this.num(e.minute);
        case "mm":
          return this.num(e.minute, 2);
        // hours
        case "h":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12);
        case "hh":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12, 2);
        case "H":
          return this.num(e.hour);
        case "HH":
          return this.num(e.hour, 2);
        // offset
        case "Z":
          return s({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return s({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return s({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return e.zone.offsetName(e.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return e.zone.offsetName(e.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return e.zoneName;
        // meridiems
        case "a":
          return a();
        // dates
        case "d":
          return i ? o({ day: "numeric" }, "day") : this.num(e.day);
        case "dd":
          return i ? o({ day: "2-digit" }, "day") : this.num(e.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(e.weekday);
        case "ccc":
          return c("short", !0);
        case "cccc":
          return c("long", !0);
        case "ccccc":
          return c("narrow", !0);
        // weekdays - format
        case "E":
          return this.num(e.weekday);
        case "EEE":
          return c("short", !1);
        case "EEEE":
          return c("long", !1);
        case "EEEEE":
          return c("narrow", !1);
        // months - standalone
        case "L":
          return i ? o({ month: "numeric", day: "numeric" }, "month") : this.num(e.month);
        case "LL":
          return i ? o({ month: "2-digit", day: "numeric" }, "month") : this.num(e.month, 2);
        case "LLL":
          return l("short", !0);
        case "LLLL":
          return l("long", !0);
        case "LLLLL":
          return l("narrow", !0);
        // months - format
        case "M":
          return i ? o({ month: "numeric" }, "month") : this.num(e.month);
        case "MM":
          return i ? o({ month: "2-digit" }, "month") : this.num(e.month, 2);
        case "MMM":
          return l("short", !1);
        case "MMMM":
          return l("long", !1);
        case "MMMMM":
          return l("narrow", !1);
        // years
        case "y":
          return i ? o({ year: "numeric" }, "year") : this.num(e.year);
        case "yy":
          return i ? o({ year: "2-digit" }, "year") : this.num(e.year.toString().slice(-2), 2);
        case "yyyy":
          return i ? o({ year: "numeric" }, "year") : this.num(e.year, 4);
        case "yyyyyy":
          return i ? o({ year: "numeric" }, "year") : this.num(e.year, 6);
        // eras
        case "G":
          return d("short");
        case "GG":
          return d("long");
        case "GGGGG":
          return d("narrow");
        case "kk":
          return this.num(e.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(e.weekYear, 4);
        case "W":
          return this.num(e.weekNumber);
        case "WW":
          return this.num(e.weekNumber, 2);
        case "n":
          return this.num(e.localWeekNumber);
        case "nn":
          return this.num(e.localWeekNumber, 2);
        case "ii":
          return this.num(e.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(e.localWeekYear, 4);
        case "o":
          return this.num(e.ordinal);
        case "ooo":
          return this.num(e.ordinal, 3);
        case "q":
          return this.num(e.quarter);
        case "qq":
          return this.num(e.quarter, 2);
        case "X":
          return this.num(Math.floor(e.ts / 1e3));
        case "x":
          return this.num(e.ts);
        default:
          return u(h);
      }
    };
    return Py(Dt.parseFormat(n), f);
  }
  formatDurationFromString(e, n) {
    const r = (l) => {
      switch (l[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, i = (l) => (c) => {
      const u = r(c);
      return u ? this.num(l.get(u), c.length) : c;
    }, o = Dt.parseFormat(n), s = o.reduce(
      (l, { literal: c, val: u }) => c ? l : l.concat(u),
      []
    ), a = e.shiftTo(...s.map(r).filter((l) => l));
    return Py(o, i(a));
  }
}
const JT = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function ps(...t) {
  const e = t.reduce((n, r) => n + r.source, "");
  return RegExp(`^${e}$`);
}
function ms(...t) {
  return (e) => t.reduce(
    ([n, r, i], o) => {
      const [s, a, l] = o(e, i);
      return [{ ...n, ...s }, a || r, l];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function gs(t, ...e) {
  if (t == null)
    return [null, null];
  for (const [n, r] of e) {
    const i = n.exec(t);
    if (i)
      return r(i);
  }
  return [null, null];
}
function XT(...t) {
  return (e, n) => {
    const r = {};
    let i;
    for (i = 0; i < t.length; i++)
      r[t[i]] = Yr(e[n + i]);
    return [r, null, n + i];
  };
}
const QT = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, mP = `(?:${QT.source}?(?:\\[(${JT.source})\\])?)?`, U0 = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, eE = RegExp(`${U0.source}${mP}`), q0 = RegExp(`(?:T${eE.source})?`), gP = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, vP = /(\d{4})-?W(\d\d)(?:-?(\d))?/, bP = /(\d{4})-?(\d{3})/, yP = XT("weekYear", "weekNumber", "weekDay"), wP = XT("year", "ordinal"), xP = /(\d{4})-(\d\d)-(\d\d)/, tE = RegExp(
  `${U0.source} ?(?:${QT.source}|(${JT.source}))?`
), kP = RegExp(`(?: ${tE.source})?`);
function Wo(t, e, n) {
  const r = t[e];
  return Te(r) ? n : Yr(r);
}
function CP(t, e) {
  return [{
    year: Wo(t, e),
    month: Wo(t, e + 1, 1),
    day: Wo(t, e + 2, 1)
  }, null, e + 3];
}
function vs(t, e) {
  return [{
    hours: Wo(t, e, 0),
    minutes: Wo(t, e + 1, 0),
    seconds: Wo(t, e + 2, 0),
    milliseconds: W0(t[e + 3])
  }, null, e + 4];
}
function Va(t, e) {
  const n = !t[e] && !t[e + 1], r = Uu(t[e + 1], t[e + 2]), i = n ? null : Ht.instance(r);
  return [{}, i, e + 3];
}
function za(t, e) {
  const n = t[e] ? Pr.create(t[e]) : null;
  return [{}, n, e + 1];
}
const SP = RegExp(`^T?${U0.source}$`), TP = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function EP(t) {
  const [e, n, r, i, o, s, a, l, c] = t, u = e[0] === "-", d = l && l[0] === "-", f = (h, p = !1) => h !== void 0 && (p || h && u) ? -h : h;
  return [
    {
      years: f(_i(n)),
      months: f(_i(r)),
      weeks: f(_i(i)),
      days: f(_i(o)),
      hours: f(_i(s)),
      minutes: f(_i(a)),
      seconds: f(_i(l), l === "-0"),
      milliseconds: f(W0(c), d)
    }
  ];
}
const MP = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function K0(t, e, n, r, i, o, s) {
  const a = {
    year: e.length === 2 ? am(Yr(e)) : Yr(e),
    month: jT.indexOf(n) + 1,
    day: Yr(r),
    hour: Yr(i),
    minute: Yr(o)
  };
  return s && (a.second = Yr(s)), t && (a.weekday = t.length > 3 ? qT.indexOf(t) + 1 : KT.indexOf(t) + 1), a;
}
const OP = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function AP(t) {
  const [
    ,
    e,
    n,
    r,
    i,
    o,
    s,
    a,
    l,
    c,
    u,
    d
  ] = t, f = K0(e, i, r, n, o, s, a);
  let h;
  return l ? h = MP[l] : c ? h = 0 : h = Uu(u, d), [f, new Ht(h)];
}
function NP(t) {
  return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const RP = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, DP = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, IP = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function Ly(t) {
  const [, e, n, r, i, o, s, a] = t;
  return [K0(e, i, r, n, o, s, a), Ht.utcInstance];
}
function _P(t) {
  const [, e, n, r, i, o, s, a] = t;
  return [K0(e, a, n, r, i, o, s), Ht.utcInstance];
}
const PP = ps(gP, q0), LP = ps(vP, q0), FP = ps(bP, q0), $P = ps(eE), nE = ms(
  CP,
  vs,
  Va,
  za
), BP = ms(
  yP,
  vs,
  Va,
  za
), VP = ms(
  wP,
  vs,
  Va,
  za
), zP = ms(
  vs,
  Va,
  za
);
function HP(t) {
  return gs(
    t,
    [PP, nE],
    [LP, BP],
    [FP, VP],
    [$P, zP]
  );
}
function WP(t) {
  return gs(NP(t), [OP, AP]);
}
function jP(t) {
  return gs(
    t,
    [RP, Ly],
    [DP, Ly],
    [IP, _P]
  );
}
function UP(t) {
  return gs(t, [TP, EP]);
}
const qP = ms(vs);
function KP(t) {
  return gs(t, [SP, qP]);
}
const GP = ps(xP, kP), YP = ps(tE), ZP = ms(
  vs,
  Va,
  za
);
function JP(t) {
  return gs(
    t,
    [GP, nE],
    [YP, ZP]
  );
}
const Fy = "Invalid Duration", rE = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, XP = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...rE
}, yn = 146097 / 400, Co = 146097 / 4800, QP = {
  years: {
    quarters: 4,
    months: 12,
    weeks: yn / 7,
    days: yn,
    hours: yn * 24,
    minutes: yn * 24 * 60,
    seconds: yn * 24 * 60 * 60,
    milliseconds: yn * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: yn / 28,
    days: yn / 4,
    hours: yn * 24 / 4,
    minutes: yn * 24 * 60 / 4,
    seconds: yn * 24 * 60 * 60 / 4,
    milliseconds: yn * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: Co / 7,
    days: Co,
    hours: Co * 24,
    minutes: Co * 24 * 60,
    seconds: Co * 24 * 60 * 60,
    milliseconds: Co * 24 * 60 * 60 * 1e3
  },
  ...rE
}, zi = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], e7 = zi.slice(0).reverse();
function jr(t, e, n = !1) {
  const r = {
    values: n ? e.values : { ...t.values, ...e.values || {} },
    loc: t.loc.clone(e.loc),
    conversionAccuracy: e.conversionAccuracy || t.conversionAccuracy,
    matrix: e.matrix || t.matrix
  };
  return new Pe(r);
}
function iE(t, e) {
  let n = e.milliseconds ?? 0;
  for (const r of e7.slice(1))
    e[r] && (n += e[r] * t[r].milliseconds);
  return n;
}
function $y(t, e) {
  const n = iE(t, e) < 0 ? -1 : 1;
  zi.reduceRight((r, i) => {
    if (Te(e[i]))
      return r;
    if (r) {
      const o = e[r] * n, s = t[i][r], a = Math.floor(o / s);
      e[i] += a * n, e[r] -= a * s * n;
    }
    return i;
  }, null), zi.reduce((r, i) => {
    if (Te(e[i]))
      return r;
    if (r) {
      const o = e[r] % 1;
      e[r] -= o, e[i] += o * t[r][i];
    }
    return i;
  }, null);
}
function t7(t) {
  const e = {};
  for (const [n, r] of Object.entries(t))
    r !== 0 && (e[n] = r);
  return e;
}
class Pe {
  /**
   * @private
   */
  constructor(e) {
    const n = e.conversionAccuracy === "longterm" || !1;
    let r = n ? QP : XP;
    e.matrix && (r = e.matrix), this.values = e.values, this.loc = e.loc || We.create(), this.conversionAccuracy = n ? "longterm" : "casual", this.invalid = e.invalid || null, this.matrix = r, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(e, n) {
    return Pe.fromObject({ milliseconds: e }, n);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(e, n = {}) {
    if (e == null || typeof e != "object")
      throw new Rt(
        `Duration.fromObject: argument expected to be an object, got ${e === null ? "null" : typeof e}`
      );
    return new Pe({
      values: Rc(e, Pe.normalizeUnit),
      loc: We.fromObject(n),
      conversionAccuracy: n.conversionAccuracy,
      matrix: n.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(e) {
    if (li(e))
      return Pe.fromMillis(e);
    if (Pe.isDuration(e))
      return e;
    if (typeof e == "object")
      return Pe.fromObject(e);
    throw new Rt(
      `Unknown duration argument ${e} of type ${typeof e}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(e, n) {
    const [r] = UP(e);
    return r ? Pe.fromObject(r, n) : Pe.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(e, n) {
    const [r] = KP(e);
    return r ? Pe.fromObject(r, n) : Pe.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new Rt("need to specify a reason the Duration is invalid");
    const r = e instanceof zn ? e : new zn(e, n);
    if (it.throwOnInvalid)
      throw new E6(r);
    return new Pe({ invalid: r });
  }
  /**
   * @private
   */
  static normalizeUnit(e) {
    const n = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[e && e.toLowerCase()];
    if (!n) throw new fT(e);
    return n;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(e) {
    return e && e.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(e, n = {}) {
    const r = {
      ...n,
      floor: n.round !== !1 && n.floor !== !1
    };
    return this.isValid ? Dt.create(this.loc, r).formatDurationFromString(this, e) : Fy;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(e = {}) {
    if (!this.isValid) return Fy;
    const n = zi.map((r) => {
      const i = this.values[r];
      return Te(i) ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...e, unit: r.slice(0, -1) }).format(i);
    }).filter((r) => r);
    return this.loc.listFormatter({ type: "conjunction", style: e.listStyle || "narrow", ...e }).format(n);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let e = "P";
    return this.years !== 0 && (e += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (e += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (e += this.weeks + "W"), this.days !== 0 && (e += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (e += "T"), this.hours !== 0 && (e += this.hours + "H"), this.minutes !== 0 && (e += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (e += j0(this.seconds + this.milliseconds / 1e3, 3) + "S"), e === "P" && (e += "T0S"), e;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(e = {}) {
    if (!this.isValid) return null;
    const n = this.toMillis();
    return n < 0 || n >= 864e5 ? null : (e = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...e,
      includeOffset: !1
    }, de.fromMillis(n, { zone: "UTC" }).toISOTime(e));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? iE(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(e) {
    if (!this.isValid) return this;
    const n = Pe.fromDurationLike(e), r = {};
    for (const i of zi)
      (Zo(n.values, i) || Zo(this.values, i)) && (r[i] = n.get(i) + this.get(i));
    return jr(this, { values: r }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(e) {
    if (!this.isValid) return this;
    const n = Pe.fromDurationLike(e);
    return this.plus(n.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(e) {
    if (!this.isValid) return this;
    const n = {};
    for (const r of Object.keys(this.values))
      n[r] = WT(e(this.values[r], r));
    return jr(this, { values: n }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(e) {
    return this[Pe.normalizeUnit(e)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(e) {
    if (!this.isValid) return this;
    const n = { ...this.values, ...Rc(e, Pe.normalizeUnit) };
    return jr(this, { values: n });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: e, numberingSystem: n, conversionAccuracy: r, matrix: i } = {}) {
    const s = { loc: this.loc.clone({ locale: e, numberingSystem: n }), matrix: i, conversionAccuracy: r };
    return jr(this, s);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(e) {
    return this.isValid ? this.shiftTo(e).get(e) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const e = this.toObject();
    return $y(this.matrix, e), jr(this, { values: e }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const e = t7(this.normalize().shiftToAll().toObject());
    return jr(this, { values: e }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...e) {
    if (!this.isValid) return this;
    if (e.length === 0)
      return this;
    e = e.map((s) => Pe.normalizeUnit(s));
    const n = {}, r = {}, i = this.toObject();
    let o;
    for (const s of zi)
      if (e.indexOf(s) >= 0) {
        o = s;
        let a = 0;
        for (const c in r)
          a += this.matrix[c][s] * r[c], r[c] = 0;
        li(i[s]) && (a += i[s]);
        const l = Math.trunc(a);
        n[s] = l, r[s] = (a * 1e3 - l * 1e3) / 1e3;
      } else li(i[s]) && (r[s] = i[s]);
    for (const s in r)
      r[s] !== 0 && (n[o] += s === o ? r[s] : r[s] / this.matrix[o][s]);
    return $y(this.matrix, n), jr(this, { values: n }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const e = {};
    for (const n of Object.keys(this.values))
      e[n] = this.values[n] === 0 ? 0 : -this.values[n];
    return jr(this, { values: e }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(e) {
    if (!this.isValid || !e.isValid || !this.loc.equals(e.loc))
      return !1;
    function n(r, i) {
      return r === void 0 || r === 0 ? i === void 0 || i === 0 : r === i;
    }
    for (const r of zi)
      if (!n(this.values[r], e.values[r]))
        return !1;
    return !0;
  }
}
const So = "Invalid Interval";
function n7(t, e) {
  return !t || !t.isValid ? rt.invalid("missing or invalid start") : !e || !e.isValid ? rt.invalid("missing or invalid end") : e < t ? rt.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${t.toISO()} and end=${e.toISO()}`
  ) : null;
}
class rt {
  /**
   * @private
   */
  constructor(e) {
    this.s = e.start, this.e = e.end, this.invalid = e.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new Rt("need to specify a reason the Interval is invalid");
    const r = e instanceof zn ? e : new zn(e, n);
    if (it.throwOnInvalid)
      throw new T6(r);
    return new rt({ invalid: r });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(e, n) {
    const r = Rs(e), i = Rs(n), o = n7(r, i);
    return o ?? new rt({
      start: r,
      end: i
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(e, n) {
    const r = Pe.fromDurationLike(n), i = Rs(e);
    return rt.fromDateTimes(i, i.plus(r));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(e, n) {
    const r = Pe.fromDurationLike(n), i = Rs(e);
    return rt.fromDateTimes(i.minus(r), i);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(e, n) {
    const [r, i] = (e || "").split("/", 2);
    if (r && i) {
      let o, s;
      try {
        o = de.fromISO(r, n), s = o.isValid;
      } catch {
        s = !1;
      }
      let a, l;
      try {
        a = de.fromISO(i, n), l = a.isValid;
      } catch {
        l = !1;
      }
      if (s && l)
        return rt.fromDateTimes(o, a);
      if (s) {
        const c = Pe.fromISO(i, n);
        if (c.isValid)
          return rt.after(o, c);
      } else if (l) {
        const c = Pe.fromISO(r, n);
        if (c.isValid)
          return rt.before(a, c);
      }
    }
    return rt.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(e) {
    return e && e.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */
  get lastDateTime() {
    return this.isValid && this.e ? this.e.minus(1) : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(e = "milliseconds") {
    return this.isValid ? this.toDuration(e).get(e) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(e = "milliseconds", n) {
    if (!this.isValid) return NaN;
    const r = this.start.startOf(e, n);
    let i;
    return n != null && n.useLocaleWeeks ? i = this.end.reconfigure({ locale: r.locale }) : i = this.end, i = i.startOf(e, n), Math.floor(i.diff(r, e).get(e)) + (i.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(e) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, e) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(e) {
    return this.isValid ? this.s > e : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(e) {
    return this.isValid ? this.e <= e : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(e) {
    return this.isValid ? this.s <= e && this.e > e : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: e, end: n } = {}) {
    return this.isValid ? rt.fromDateTimes(e || this.s, n || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...e) {
    if (!this.isValid) return [];
    const n = e.map(Rs).filter((s) => this.contains(s)).sort((s, a) => s.toMillis() - a.toMillis()), r = [];
    let { s: i } = this, o = 0;
    for (; i < this.e; ) {
      const s = n[o] || this.e, a = +s > +this.e ? this.e : s;
      r.push(rt.fromDateTimes(i, a)), i = a, o += 1;
    }
    return r;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(e) {
    const n = Pe.fromDurationLike(e);
    if (!this.isValid || !n.isValid || n.as("milliseconds") === 0)
      return [];
    let { s: r } = this, i = 1, o;
    const s = [];
    for (; r < this.e; ) {
      const a = this.start.plus(n.mapUnits((l) => l * i));
      o = +a > +this.e ? this.e : a, s.push(rt.fromDateTimes(r, o)), r = o, i += 1;
    }
    return s;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(e) {
    return this.isValid ? this.splitBy(this.length() / e).slice(0, e) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(e) {
    return this.e > e.s && this.s < e.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(e) {
    return this.isValid ? +this.e == +e.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(e) {
    return this.isValid ? +e.e == +this.s : !1;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(e) {
    return this.isValid ? this.s <= e.s && this.e >= e.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(e) {
    return !this.isValid || !e.isValid ? !1 : this.s.equals(e.s) && this.e.equals(e.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(e) {
    if (!this.isValid) return this;
    const n = this.s > e.s ? this.s : e.s, r = this.e < e.e ? this.e : e.e;
    return n >= r ? null : rt.fromDateTimes(n, r);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(e) {
    if (!this.isValid) return this;
    const n = this.s < e.s ? this.s : e.s, r = this.e > e.e ? this.e : e.e;
    return rt.fromDateTimes(n, r);
  }
  /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(e) {
    const [n, r] = e.sort((i, o) => i.s - o.s).reduce(
      ([i, o], s) => o ? o.overlaps(s) || o.abutsStart(s) ? [i, o.union(s)] : [i.concat([o]), s] : [i, s],
      [[], null]
    );
    return r && n.push(r), n;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(e) {
    let n = null, r = 0;
    const i = [], o = e.map((l) => [
      { time: l.s, type: "s" },
      { time: l.e, type: "e" }
    ]), s = Array.prototype.concat(...o), a = s.sort((l, c) => l.time - c.time);
    for (const l of a)
      r += l.type === "s" ? 1 : -1, r === 1 ? n = l.time : (n && +n != +l.time && i.push(rt.fromDateTimes(n, l.time)), n = null);
    return rt.merge(i);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...e) {
    return rt.xor([this].concat(e)).map((n) => this.intersection(n)).filter((n) => n && !n.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : So;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(e = Oc, n = {}) {
    return this.isValid ? Dt.create(this.s.loc.clone(n), e).formatInterval(this) : So;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(e) {
    return this.isValid ? `${this.s.toISO(e)}/${this.e.toISO(e)}` : So;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : So;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(e) {
    return this.isValid ? `${this.s.toISOTime(e)}/${this.e.toISOTime(e)}` : So;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(e, { separator: n = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(e)}${n}${this.e.toFormat(e)}` : So;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(e, n) {
    return this.isValid ? this.e.diff(this.s, e, n) : Pe.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(e) {
    return rt.fromDateTimes(e(this.s), e(this.e));
  }
}
class wl {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(e = it.defaultZone) {
    const n = de.now().setZone(e).set({ month: 12 });
    return !e.isUniversal && n.offset !== n.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(e) {
    return Pr.isValidZone(e);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(e) {
    return Qr(e, it.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: e = null, locObj: n = null } = {}) {
    return (n || We.create(e)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: e = null, locObj: n = null } = {}) {
    return (n || We.create(e)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: e = null, locObj: n = null } = {}) {
    return (n || We.create(e)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(e = "long", { locale: n = null, numberingSystem: r = null, locObj: i = null, outputCalendar: o = "gregory" } = {}) {
    return (i || We.create(n, r, o)).months(e);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(e = "long", { locale: n = null, numberingSystem: r = null, locObj: i = null, outputCalendar: o = "gregory" } = {}) {
    return (i || We.create(n, r, o)).months(e, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(e = "long", { locale: n = null, numberingSystem: r = null, locObj: i = null } = {}) {
    return (i || We.create(n, r, null)).weekdays(e);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(e = "long", { locale: n = null, numberingSystem: r = null, locObj: i = null } = {}) {
    return (i || We.create(n, r, null)).weekdays(e, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: e = null } = {}) {
    return We.create(e).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(e = "short", { locale: n = null } = {}) {
    return We.create(n, null, "gregory").eras(e);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: VT(), localeWeek: zT() };
  }
}
function By(t, e) {
  const n = (i) => i.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), r = n(e) - n(t);
  return Math.floor(Pe.fromMillis(r).as("days"));
}
function r7(t, e, n) {
  const r = [
    ["years", (l, c) => c.year - l.year],
    ["quarters", (l, c) => c.quarter - l.quarter + (c.year - l.year) * 4],
    ["months", (l, c) => c.month - l.month + (c.year - l.year) * 12],
    [
      "weeks",
      (l, c) => {
        const u = By(l, c);
        return (u - u % 7) / 7;
      }
    ],
    ["days", By]
  ], i = {}, o = t;
  let s, a;
  for (const [l, c] of r)
    n.indexOf(l) >= 0 && (s = l, i[l] = c(t, e), a = o.plus(i), a > e ? (i[l]--, t = o.plus(i), t > e && (a = t, i[l]--, t = o.plus(i))) : t = a);
  return [t, i, a, s];
}
function i7(t, e, n, r) {
  let [i, o, s, a] = r7(t, e, n);
  const l = e - i, c = n.filter(
    (d) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(d) >= 0
  );
  c.length === 0 && (s < e && (s = i.plus({ [a]: 1 })), s !== i && (o[a] = (o[a] || 0) + l / (s - i)));
  const u = Pe.fromObject(o, r);
  return c.length > 0 ? Pe.fromMillis(l, r).shiftTo(...c).plus(u) : u;
}
const o7 = "missing Intl.DateTimeFormat.formatToParts support";
function $e(t, e = (n) => n) {
  return { regex: t, deser: ([n]) => e(G6(n)) };
}
const s7 = " ", oE = `[ ${s7}]`, sE = new RegExp(oE, "g");
function a7(t) {
  return t.replace(/\./g, "\\.?").replace(sE, oE);
}
function Vy(t) {
  return t.replace(/\./g, "").replace(sE, " ").toLowerCase();
}
function $n(t, e) {
  return t === null ? null : {
    regex: RegExp(t.map(a7).join("|")),
    deser: ([n]) => t.findIndex((r) => Vy(n) === Vy(r)) + e
  };
}
function zy(t, e) {
  return { regex: t, deser: ([, n, r]) => Uu(n, r), groups: e };
}
function xl(t) {
  return { regex: t, deser: ([e]) => e };
}
function l7(t) {
  return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function c7(t, e) {
  const n = Fn(e), r = Fn(e, "{2}"), i = Fn(e, "{3}"), o = Fn(e, "{4}"), s = Fn(e, "{6}"), a = Fn(e, "{1,2}"), l = Fn(e, "{1,3}"), c = Fn(e, "{1,6}"), u = Fn(e, "{1,9}"), d = Fn(e, "{2,4}"), f = Fn(e, "{4,6}"), h = (b) => ({ regex: RegExp(l7(b.val)), deser: ([y]) => y, literal: !0 }), m = ((b) => {
    if (t.literal)
      return h(b);
    switch (b.val) {
      // era
      case "G":
        return $n(e.eras("short"), 0);
      case "GG":
        return $n(e.eras("long"), 0);
      // years
      case "y":
        return $e(c);
      case "yy":
        return $e(d, am);
      case "yyyy":
        return $e(o);
      case "yyyyy":
        return $e(f);
      case "yyyyyy":
        return $e(s);
      // months
      case "M":
        return $e(a);
      case "MM":
        return $e(r);
      case "MMM":
        return $n(e.months("short", !0), 1);
      case "MMMM":
        return $n(e.months("long", !0), 1);
      case "L":
        return $e(a);
      case "LL":
        return $e(r);
      case "LLL":
        return $n(e.months("short", !1), 1);
      case "LLLL":
        return $n(e.months("long", !1), 1);
      // dates
      case "d":
        return $e(a);
      case "dd":
        return $e(r);
      // ordinals
      case "o":
        return $e(l);
      case "ooo":
        return $e(i);
      // time
      case "HH":
        return $e(r);
      case "H":
        return $e(a);
      case "hh":
        return $e(r);
      case "h":
        return $e(a);
      case "mm":
        return $e(r);
      case "m":
        return $e(a);
      case "q":
        return $e(a);
      case "qq":
        return $e(r);
      case "s":
        return $e(a);
      case "ss":
        return $e(r);
      case "S":
        return $e(l);
      case "SSS":
        return $e(i);
      case "u":
        return xl(u);
      case "uu":
        return xl(a);
      case "uuu":
        return $e(n);
      // meridiem
      case "a":
        return $n(e.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return $e(o);
      case "kk":
        return $e(d, am);
      // weekNumber (W)
      case "W":
        return $e(a);
      case "WW":
        return $e(r);
      // weekdays
      case "E":
      case "c":
        return $e(n);
      case "EEE":
        return $n(e.weekdays("short", !1), 1);
      case "EEEE":
        return $n(e.weekdays("long", !1), 1);
      case "ccc":
        return $n(e.weekdays("short", !0), 1);
      case "cccc":
        return $n(e.weekdays("long", !0), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return zy(new RegExp(`([+-]${a.source})(?::(${r.source}))?`), 2);
      case "ZZZ":
        return zy(new RegExp(`([+-]${a.source})(${r.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return xl(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return xl(/[^\S\n\r]/);
      default:
        return h(b);
    }
  })(t) || {
    invalidReason: o7
  };
  return m.token = t, m;
}
const u7 = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function d7(t, e, n) {
  const { type: r, value: i } = t;
  if (r === "literal") {
    const l = /^\s+$/.test(i);
    return {
      literal: !l,
      val: l ? " " : i
    };
  }
  const o = e[r];
  let s = r;
  r === "hour" && (e.hour12 != null ? s = e.hour12 ? "hour12" : "hour24" : e.hourCycle != null ? e.hourCycle === "h11" || e.hourCycle === "h12" ? s = "hour12" : s = "hour24" : s = n.hour12 ? "hour12" : "hour24");
  let a = u7[s];
  if (typeof a == "object" && (a = a[o]), a)
    return {
      literal: !1,
      val: a
    };
}
function f7(t) {
  return [`^${t.map((n) => n.regex).reduce((n, r) => `${n}(${r.source})`, "")}$`, t];
}
function h7(t, e, n) {
  const r = t.match(e);
  if (r) {
    const i = {};
    let o = 1;
    for (const s in n)
      if (Zo(n, s)) {
        const a = n[s], l = a.groups ? a.groups + 1 : 1;
        !a.literal && a.token && (i[a.token.val[0]] = a.deser(r.slice(o, o + l))), o += l;
      }
    return [r, i];
  } else
    return [r, {}];
}
function p7(t) {
  const e = (o) => {
    switch (o) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let n = null, r;
  return Te(t.z) || (n = Pr.create(t.z)), Te(t.Z) || (n || (n = new Ht(t.Z)), r = t.Z), Te(t.q) || (t.M = (t.q - 1) * 3 + 1), Te(t.h) || (t.h < 12 && t.a === 1 ? t.h += 12 : t.h === 12 && t.a === 0 && (t.h = 0)), t.G === 0 && t.y && (t.y = -t.y), Te(t.u) || (t.S = W0(t.u)), [Object.keys(t).reduce((o, s) => {
    const a = e(s);
    return a && (o[a] = t[s]), o;
  }, {}), n, r];
}
let hf = null;
function m7() {
  return hf || (hf = de.fromMillis(1555555555555)), hf;
}
function g7(t, e) {
  if (t.literal)
    return t;
  const n = Dt.macroTokenToFormatOpts(t.val), r = uE(n, e);
  return r == null || r.includes(void 0) ? t : r;
}
function aE(t, e) {
  return Array.prototype.concat(...t.map((n) => g7(n, e)));
}
class lE {
  constructor(e, n) {
    if (this.locale = e, this.format = n, this.tokens = aE(Dt.parseFormat(n), e), this.units = this.tokens.map((r) => c7(r, e)), this.disqualifyingUnit = this.units.find((r) => r.invalidReason), !this.disqualifyingUnit) {
      const [r, i] = f7(this.units);
      this.regex = RegExp(r, "i"), this.handlers = i;
    }
  }
  explainFromTokens(e) {
    if (this.isValid) {
      const [n, r] = h7(e, this.regex, this.handlers), [i, o, s] = r ? p7(r) : [null, null, void 0];
      if (Zo(r, "a") && Zo(r, "H"))
        throw new Fo(
          "Can't include meridiem when specifying 24-hour format"
        );
      return {
        input: e,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: n,
        matches: r,
        result: i,
        zone: o,
        specificOffset: s
      };
    } else
      return { input: e, tokens: this.tokens, invalidReason: this.invalidReason };
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function cE(t, e, n) {
  return new lE(t, n).explainFromTokens(e);
}
function v7(t, e, n) {
  const { result: r, zone: i, specificOffset: o, invalidReason: s } = cE(t, e, n);
  return [r, i, o, s];
}
function uE(t, e) {
  if (!t)
    return null;
  const r = Dt.create(e, t).dtFormatter(m7()), i = r.formatToParts(), o = r.resolvedOptions();
  return i.map((s) => d7(s, t, o));
}
const pf = "Invalid DateTime", b7 = 864e13;
function Ls(t) {
  return new zn("unsupported zone", `the zone "${t.name}" is not supported`);
}
function mf(t) {
  return t.weekData === null && (t.weekData = Ac(t.c)), t.weekData;
}
function gf(t) {
  return t.localWeekData === null && (t.localWeekData = Ac(
    t.c,
    t.loc.getMinDaysInFirstWeek(),
    t.loc.getStartOfWeek()
  )), t.localWeekData;
}
function Pi(t, e) {
  const n = {
    ts: t.ts,
    zone: t.zone,
    c: t.c,
    o: t.o,
    loc: t.loc,
    invalid: t.invalid
  };
  return new de({ ...n, ...e, old: n });
}
function dE(t, e, n) {
  let r = t - e * 60 * 1e3;
  const i = n.offset(r);
  if (e === i)
    return [r, e];
  r -= (i - e) * 60 * 1e3;
  const o = n.offset(r);
  return i === o ? [r, i] : [t - Math.min(i, o) * 60 * 1e3, Math.max(i, o)];
}
function kl(t, e) {
  t += e * 60 * 1e3;
  const n = new Date(t);
  return {
    year: n.getUTCFullYear(),
    month: n.getUTCMonth() + 1,
    day: n.getUTCDate(),
    hour: n.getUTCHours(),
    minute: n.getUTCMinutes(),
    second: n.getUTCSeconds(),
    millisecond: n.getUTCMilliseconds()
  };
}
function sc(t, e, n) {
  return dE(ju(t), e, n);
}
function Hy(t, e) {
  const n = t.o, r = t.c.year + Math.trunc(e.years), i = t.c.month + Math.trunc(e.months) + Math.trunc(e.quarters) * 3, o = {
    ...t.c,
    year: r,
    month: i,
    day: Math.min(t.c.day, Nc(r, i)) + Math.trunc(e.days) + Math.trunc(e.weeks) * 7
  }, s = Pe.fromObject({
    years: e.years - Math.trunc(e.years),
    quarters: e.quarters - Math.trunc(e.quarters),
    months: e.months - Math.trunc(e.months),
    weeks: e.weeks - Math.trunc(e.weeks),
    days: e.days - Math.trunc(e.days),
    hours: e.hours,
    minutes: e.minutes,
    seconds: e.seconds,
    milliseconds: e.milliseconds
  }).as("milliseconds"), a = ju(o);
  let [l, c] = dE(a, n, t.zone);
  return s !== 0 && (l += s, c = t.zone.offset(l)), { ts: l, o: c };
}
function To(t, e, n, r, i, o) {
  const { setZone: s, zone: a } = n;
  if (t && Object.keys(t).length !== 0 || e) {
    const l = e || a, c = de.fromObject(t, {
      ...n,
      zone: l,
      specificOffset: o
    });
    return s ? c : c.setZone(a);
  } else
    return de.invalid(
      new zn("unparsable", `the input "${i}" can't be parsed as ${r}`)
    );
}
function Cl(t, e, n = !0) {
  return t.isValid ? Dt.create(We.create("en-US"), {
    allowZ: n,
    forceSimple: !0
  }).formatDateTimeFromString(t, e) : null;
}
function vf(t, e) {
  const n = t.c.year > 9999 || t.c.year < 0;
  let r = "";
  return n && t.c.year >= 0 && (r += "+"), r += ut(t.c.year, n ? 6 : 4), e ? (r += "-", r += ut(t.c.month), r += "-", r += ut(t.c.day)) : (r += ut(t.c.month), r += ut(t.c.day)), r;
}
function Wy(t, e, n, r, i, o) {
  let s = ut(t.c.hour);
  return e ? (s += ":", s += ut(t.c.minute), (t.c.millisecond !== 0 || t.c.second !== 0 || !n) && (s += ":")) : s += ut(t.c.minute), (t.c.millisecond !== 0 || t.c.second !== 0 || !n) && (s += ut(t.c.second), (t.c.millisecond !== 0 || !r) && (s += ".", s += ut(t.c.millisecond, 3))), i && (t.isOffsetFixed && t.offset === 0 && !o ? s += "Z" : t.o < 0 ? (s += "-", s += ut(Math.trunc(-t.o / 60)), s += ":", s += ut(Math.trunc(-t.o % 60))) : (s += "+", s += ut(Math.trunc(t.o / 60)), s += ":", s += ut(Math.trunc(t.o % 60)))), o && (s += "[" + t.zone.ianaName + "]"), s;
}
const fE = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, y7 = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, w7 = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, hE = ["year", "month", "day", "hour", "minute", "second", "millisecond"], x7 = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], k7 = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function C7(t) {
  const e = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[t.toLowerCase()];
  if (!e) throw new fT(t);
  return e;
}
function jy(t) {
  switch (t.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return C7(t);
  }
}
function S7(t) {
  if (Fs === void 0 && (Fs = it.now()), t.type !== "iana")
    return t.offset(Fs);
  const e = t.name;
  let n = lm.get(e);
  return n === void 0 && (n = t.offset(Fs), lm.set(e, n)), n;
}
function Uy(t, e) {
  const n = Qr(e.zone, it.defaultZone);
  if (!n.isValid)
    return de.invalid(Ls(n));
  const r = We.fromObject(e);
  let i, o;
  if (Te(t.year))
    i = it.now();
  else {
    for (const l of hE)
      Te(t[l]) && (t[l] = fE[l]);
    const s = $T(t) || BT(t);
    if (s)
      return de.invalid(s);
    const a = S7(n);
    [i, o] = sc(t, a, n);
  }
  return new de({ ts: i, zone: n, loc: r, o });
}
function qy(t, e, n) {
  const r = Te(n.round) ? !0 : n.round, i = (s, a) => (s = j0(s, r || n.calendary ? 0 : 2, !0), e.loc.clone(n).relFormatter(n).format(s, a)), o = (s) => n.calendary ? e.hasSame(t, s) ? 0 : e.startOf(s).diff(t.startOf(s), s).get(s) : e.diff(t, s).get(s);
  if (n.unit)
    return i(o(n.unit), n.unit);
  for (const s of n.units) {
    const a = o(s);
    if (Math.abs(a) >= 1)
      return i(a, s);
  }
  return i(t > e ? -0 : 0, n.units[n.units.length - 1]);
}
function Ky(t) {
  let e = {}, n;
  return t.length > 0 && typeof t[t.length - 1] == "object" ? (e = t[t.length - 1], n = Array.from(t).slice(0, t.length - 1)) : n = Array.from(t), [e, n];
}
let Fs;
const lm = /* @__PURE__ */ new Map();
class de {
  /**
   * @access private
   */
  constructor(e) {
    const n = e.zone || it.defaultZone;
    let r = e.invalid || (Number.isNaN(e.ts) ? new zn("invalid input") : null) || (n.isValid ? null : Ls(n));
    this.ts = Te(e.ts) ? it.now() : e.ts;
    let i = null, o = null;
    if (!r)
      if (e.old && e.old.ts === this.ts && e.old.zone.equals(n))
        [i, o] = [e.old.c, e.old.o];
      else {
        const a = li(e.o) && !e.old ? e.o : n.offset(this.ts);
        i = kl(this.ts, a), r = Number.isNaN(i.year) ? new zn("invalid input") : null, i = r ? null : i, o = r ? null : a;
      }
    this._zone = n, this.loc = e.loc || We.create(), this.invalid = r, this.weekData = null, this.localWeekData = null, this.c = i, this.o = o, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new de({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [e, n] = Ky(arguments), [r, i, o, s, a, l, c] = n;
    return Uy({ year: r, month: i, day: o, hour: s, minute: a, second: l, millisecond: c }, e);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [e, n] = Ky(arguments), [r, i, o, s, a, l, c] = n;
    return e.zone = Ht.utcInstance, Uy({ year: r, month: i, day: o, hour: s, minute: a, second: l, millisecond: c }, e);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(e, n = {}) {
    const r = Q6(e) ? e.valueOf() : NaN;
    if (Number.isNaN(r))
      return de.invalid("invalid input");
    const i = Qr(n.zone, it.defaultZone);
    return i.isValid ? new de({
      ts: r,
      zone: i,
      loc: We.fromObject(n)
    }) : de.invalid(Ls(i));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(e, n = {}) {
    if (li(e))
      return e < -864e13 || e > b7 ? de.invalid("Timestamp out of range") : new de({
        ts: e,
        zone: Qr(n.zone, it.defaultZone),
        loc: We.fromObject(n)
      });
    throw new Rt(
      `fromMillis requires a numerical input, but received a ${typeof e} with value ${e}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(e, n = {}) {
    if (li(e))
      return new de({
        ts: e * 1e3,
        zone: Qr(n.zone, it.defaultZone),
        loc: We.fromObject(n)
      });
    throw new Rt("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(e, n = {}) {
    e = e || {};
    const r = Qr(n.zone, it.defaultZone);
    if (!r.isValid)
      return de.invalid(Ls(r));
    const i = We.fromObject(n), o = Rc(e, jy), { minDaysInFirstWeek: s, startOfWeek: a } = Dy(o, i), l = it.now(), c = Te(n.specificOffset) ? r.offset(l) : n.specificOffset, u = !Te(o.ordinal), d = !Te(o.year), f = !Te(o.month) || !Te(o.day), h = d || f, p = o.weekYear || o.weekNumber;
    if ((h || u) && p)
      throw new Fo(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (f && u)
      throw new Fo("Can't mix ordinal dates with month/day");
    const m = p || o.weekday && !h;
    let b, y, k = kl(l, c);
    m ? (b = x7, y = y7, k = Ac(k, s, a)) : u ? (b = k7, y = w7, k = ff(k)) : (b = hE, y = fE);
    let C = !1;
    for (const L of b) {
      const $ = o[L];
      Te($) ? C ? o[L] = y[L] : o[L] = k[L] : C = !0;
    }
    const x = m ? Z6(o, s, a) : u ? J6(o) : $T(o), S = x || BT(o);
    if (S)
      return de.invalid(S);
    const T = m ? Ny(o, s, a) : u ? Ry(o) : o, [E, M] = sc(T, c, r), O = new de({
      ts: E,
      zone: r,
      o: M,
      loc: i
    });
    return o.weekday && h && e.weekday !== O.weekday ? de.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${o.weekday} and a date of ${O.toISO()}`
    ) : O.isValid ? O : de.invalid(O.invalid);
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(e, n = {}) {
    const [r, i] = HP(e);
    return To(r, i, n, "ISO 8601", e);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(e, n = {}) {
    const [r, i] = WP(e);
    return To(r, i, n, "RFC 2822", e);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(e, n = {}) {
    const [r, i] = jP(e);
    return To(r, i, n, "HTTP", n);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(e, n, r = {}) {
    if (Te(e) || Te(n))
      throw new Rt("fromFormat requires an input string and a format");
    const { locale: i = null, numberingSystem: o = null } = r, s = We.fromOpts({
      locale: i,
      numberingSystem: o,
      defaultToEN: !0
    }), [a, l, c, u] = v7(s, e, n);
    return u ? de.invalid(u) : To(a, l, r, `format ${n}`, e, c);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(e, n, r = {}) {
    return de.fromFormat(e, n, r);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(e, n = {}) {
    const [r, i] = JP(e);
    return To(r, i, n, "SQL", e);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new Rt("need to specify a reason the DateTime is invalid");
    const r = e instanceof zn ? e : new zn(e, n);
    if (it.throwOnInvalid)
      throw new S6(r);
    return new de({ invalid: r });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(e) {
    return e && e.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(e, n = {}) {
    const r = uE(e, We.fromObject(n));
    return r ? r.map((i) => i ? i.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(e, n = {}) {
    return aE(Dt.parseFormat(e), We.fromObject(n)).map((i) => i.val).join("");
  }
  static resetCache() {
    Fs = void 0, lm.clear();
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(e) {
    return this[e];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? mf(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? mf(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? mf(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? gf(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? gf(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? gf(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? ff(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? wl.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? wl.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? wl.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? wl.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const e = 864e5, n = 6e4, r = ju(this.c), i = this.zone.offset(r - e), o = this.zone.offset(r + e), s = this.zone.offset(r - i * n), a = this.zone.offset(r - o * n);
    if (s === a)
      return [this];
    const l = r - s * n, c = r - a * n, u = kl(l, s), d = kl(c, a);
    return u.hour === d.hour && u.minute === d.minute && u.second === d.second && u.millisecond === d.millisecond ? [Pi(this, { ts: l }), Pi(this, { ts: c })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return Ba(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return Nc(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? Ho(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? ua(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? ua(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(e = {}) {
    const { locale: n, numberingSystem: r, calendar: i } = Dt.create(
      this.loc.clone(e),
      e
    ).resolvedOptions(this);
    return { locale: n, numberingSystem: r, outputCalendar: i };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(e = 0, n = {}) {
    return this.setZone(Ht.instance(e), n);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(it.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(e, { keepLocalTime: n = !1, keepCalendarTime: r = !1 } = {}) {
    if (e = Qr(e, it.defaultZone), e.equals(this.zone))
      return this;
    if (e.isValid) {
      let i = this.ts;
      if (n || r) {
        const o = e.offset(this.ts), s = this.toObject();
        [i] = sc(s, o, e);
      }
      return Pi(this, { ts: i, zone: e });
    } else
      return de.invalid(Ls(e));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: e, numberingSystem: n, outputCalendar: r } = {}) {
    const i = this.loc.clone({ locale: e, numberingSystem: n, outputCalendar: r });
    return Pi(this, { loc: i });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(e) {
    return this.reconfigure({ locale: e });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(e) {
    if (!this.isValid) return this;
    const n = Rc(e, jy), { minDaysInFirstWeek: r, startOfWeek: i } = Dy(n, this.loc), o = !Te(n.weekYear) || !Te(n.weekNumber) || !Te(n.weekday), s = !Te(n.ordinal), a = !Te(n.year), l = !Te(n.month) || !Te(n.day), c = a || l, u = n.weekYear || n.weekNumber;
    if ((c || s) && u)
      throw new Fo(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (l && s)
      throw new Fo("Can't mix ordinal dates with month/day");
    let d;
    o ? d = Ny(
      { ...Ac(this.c, r, i), ...n },
      r,
      i
    ) : Te(n.ordinal) ? (d = { ...this.toObject(), ...n }, Te(n.day) && (d.day = Math.min(Nc(d.year, d.month), d.day))) : d = Ry({ ...ff(this.c), ...n });
    const [f, h] = sc(d, this.o, this.zone);
    return Pi(this, { ts: f, o: h });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(e) {
    if (!this.isValid) return this;
    const n = Pe.fromDurationLike(e);
    return Pi(this, Hy(this, n));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(e) {
    if (!this.isValid) return this;
    const n = Pe.fromDurationLike(e).negate();
    return Pi(this, Hy(this, n));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(e, { useLocaleWeeks: n = !1 } = {}) {
    if (!this.isValid) return this;
    const r = {}, i = Pe.normalizeUnit(e);
    switch (i) {
      case "years":
        r.month = 1;
      // falls through
      case "quarters":
      case "months":
        r.day = 1;
      // falls through
      case "weeks":
      case "days":
        r.hour = 0;
      // falls through
      case "hours":
        r.minute = 0;
      // falls through
      case "minutes":
        r.second = 0;
      // falls through
      case "seconds":
        r.millisecond = 0;
        break;
    }
    if (i === "weeks")
      if (n) {
        const o = this.loc.getStartOfWeek(), { weekday: s } = this;
        s < o && (r.weekNumber = this.weekNumber - 1), r.weekday = o;
      } else
        r.weekday = 1;
    if (i === "quarters") {
      const o = Math.ceil(this.month / 3);
      r.month = (o - 1) * 3 + 1;
    }
    return this.set(r);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(e, n) {
    return this.isValid ? this.plus({ [e]: 1 }).startOf(e, n).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(e, n = {}) {
    return this.isValid ? Dt.create(this.loc.redefaultToEN(n)).formatDateTimeFromString(this, e) : pf;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(e = Oc, n = {}) {
    return this.isValid ? Dt.create(this.loc.clone(n), e).formatDateTime(this) : pf;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(e = {}) {
    return this.isValid ? Dt.create(this.loc.clone(e), e).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string|null}
   */
  toISO({
    format: e = "extended",
    suppressSeconds: n = !1,
    suppressMilliseconds: r = !1,
    includeOffset: i = !0,
    extendedZone: o = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const s = e === "extended";
    let a = vf(this, s);
    return a += "T", a += Wy(this, s, n, r, i, o), a;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string|null}
   */
  toISODate({ format: e = "extended" } = {}) {
    return this.isValid ? vf(this, e === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return Cl(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: e = !1,
    suppressSeconds: n = !1,
    includeOffset: r = !0,
    includePrefix: i = !1,
    extendedZone: o = !1,
    format: s = "extended"
  } = {}) {
    return this.isValid ? (i ? "T" : "") + Wy(
      this,
      s === "extended",
      n,
      e,
      r,
      o
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return Cl(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return Cl(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */
  toSQLDate() {
    return this.isValid ? vf(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: e = !0, includeZone: n = !1, includeOffsetSpace: r = !0 } = {}) {
    let i = "HH:mm:ss.SSS";
    return (n || e) && (r && (i += " "), n ? i += "z" : e && (i += "ZZ")), Cl(this, i, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(e = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(e)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : pf;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(e = {}) {
    if (!this.isValid) return {};
    const n = { ...this.c };
    return e.includeConfig && (n.outputCalendar = this.outputCalendar, n.numberingSystem = this.loc.numberingSystem, n.locale = this.loc.locale), n;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(e, n = "milliseconds", r = {}) {
    if (!this.isValid || !e.isValid)
      return Pe.invalid("created by diffing an invalid DateTime");
    const i = { locale: this.locale, numberingSystem: this.numberingSystem, ...r }, o = eP(n).map(Pe.normalizeUnit), s = e.valueOf() > this.valueOf(), a = s ? this : e, l = s ? e : this, c = i7(a, l, o, i);
    return s ? c.negate() : c;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(e = "milliseconds", n = {}) {
    return this.diff(de.now(), e, n);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */
  until(e) {
    return this.isValid ? rt.fromDateTimes(this, e) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(e, n, r) {
    if (!this.isValid) return !1;
    const i = e.valueOf(), o = this.setZone(e.zone, { keepLocalTime: !0 });
    return o.startOf(n, r) <= i && i <= o.endOf(n, r);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(e) {
    return this.isValid && e.isValid && this.valueOf() === e.valueOf() && this.zone.equals(e.zone) && this.loc.equals(e.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(e = {}) {
    if (!this.isValid) return null;
    const n = e.base || de.fromObject({}, { zone: this.zone }), r = e.padding ? this < n ? -e.padding : e.padding : 0;
    let i = ["years", "months", "days", "hours", "minutes", "seconds"], o = e.unit;
    return Array.isArray(e.unit) && (i = e.unit, o = void 0), qy(n, this.plus(r), {
      ...e,
      numeric: "always",
      units: i,
      unit: o
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(e = {}) {
    return this.isValid ? qy(e.base || de.fromObject({}, { zone: this.zone }), this, {
      ...e,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...e) {
    if (!e.every(de.isDateTime))
      throw new Rt("min requires all arguments be DateTimes");
    return Iy(e, (n) => n.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...e) {
    if (!e.every(de.isDateTime))
      throw new Rt("max requires all arguments be DateTimes");
    return Iy(e, (n) => n.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(e, n, r = {}) {
    const { locale: i = null, numberingSystem: o = null } = r, s = We.fromOpts({
      locale: i,
      numberingSystem: o,
      defaultToEN: !0
    });
    return cE(s, e, n);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(e, n, r = {}) {
    return de.fromFormatExplain(e, n, r);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(e, n = {}) {
    const { locale: r = null, numberingSystem: i = null } = n, o = We.fromOpts({
      locale: r,
      numberingSystem: i,
      defaultToEN: !0
    });
    return new lE(o, e);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(e, n, r = {}) {
    if (Te(e) || Te(n))
      throw new Rt(
        "fromFormatParser requires an input string and a format parser"
      );
    const { locale: i = null, numberingSystem: o = null } = r, s = We.fromOpts({
      locale: i,
      numberingSystem: o,
      defaultToEN: !0
    });
    if (!s.equals(n.locale))
      throw new Rt(
        `fromFormatParser called with a locale of ${s}, but the format parser was created for ${n.locale}`
      );
    const { result: a, zone: l, specificOffset: c, invalidReason: u } = n.explainFromTokens(e);
    return u ? de.invalid(u) : To(
      a,
      l,
      r,
      `format ${n.format}`,
      e,
      c
    );
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return Oc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return hT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return M6;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return pT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return mT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return gT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return vT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return bT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return yT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return wT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return xT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return kT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return CT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return ST;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return TT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return ET;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return MT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return O6;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return OT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return AT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return NT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return RT;
  }
}
function Rs(t) {
  if (de.isDateTime(t))
    return t;
  if (t && t.valueOf && li(t.valueOf()))
    return de.fromJSDate(t);
  if (t && typeof t == "object")
    return de.fromObject(t);
  throw new Rt(
    `Unknown datetime argument: ${t}, of type ${typeof t}`
  );
}
const Gy = 15;
function T7(t) {
  const { date: e } = t, n = de.now().toFormat("MM/dd/yyyy"), r = de.fromJSDate(e).toFormat("MM/dd/yyyy"), i = n === r, o = xe();
  return /* @__PURE__ */ F("div", { className: "relative", children: [
    e.getDate(),
    i && /* @__PURE__ */ v(
      "div",
      {
        className: I("bg-inverted z[1] absolute -bottom-1 left-1/2 size-1 -translate-x-1/2", {
          "rounded-full": o.theme.appearance.corners === "rounded"
        })
      }
    )
  ] });
}
function E7(t) {
  const { goToMonth: e, currentMonth: n, goToDate: r } = hs(), i = xe(), o = Je(), { month: s, year: a } = de.fromJSDate(n), { children: l, value: c, name: u } = t, d = ct(
    (h) => {
      e(new Date(a, Number(h)));
    },
    [e, a]
  ), f = ct(
    (h) => {
      r(new Date(Number(h), s - 1));
    },
    [r, s]
  );
  return u === "months" ? /* @__PURE__ */ v(
    "select",
    {
      className: I("border-default hover:border-emphasis border", {
        "rounded-lg": i.theme.appearance.corners === "rounded"
      }),
      value: c == null ? void 0 : c.toString(),
      onChange: (h) => d(h.target.value),
      "data-testid": "asterisk-calendar-month-dropdown",
      children: l == null ? void 0 : l.map((h) => aT(o.disabled) && h.props.value > o.disabled.after.getMonth() && a === o.disabled.after.getFullYear() || lT(o.disabled) && o.disabled.before.getMonth() > h.props.value && a === o.disabled.before.getFullYear() ? null : /* @__PURE__ */ v("option", { value: h.props.value.toString(), children: h.props.children }, h.key))
    }
  ) : /* @__PURE__ */ v(
    "select",
    {
      className: I("border-default hover:border-emphasis border", {
        "rounded-lg": i.theme.appearance.corners === "rounded"
      }),
      value: c == null ? void 0 : c.toString(),
      onChange: (h) => f(h.target.value),
      "data-testid": "asterisk-calendar-year-dropdown",
      children: l
    }
  );
}
function G0({ className: t, classNames: e, size: n, ...r }) {
  const { year: i } = de.now(), o = xe(), s = En(() => n || (r.mode === "range" ? "small" : "big"), [n, r.mode]);
  return /* @__PURE__ */ v(
    C6,
    {
      captionLayout: "dropdown-buttons",
      fromYear: i - Gy,
      toYear: i + Gy,
      showOutsideDays: !0,
      fixedWeeks: !0,
      "data-testid": "asterisk-calendar",
      className: I(
        "bg-card max-w-fit border p-4 shadow-sm",
        {
          "rounded-lg": o.theme.appearance.corners === "rounded"
        },
        t
      ),
      classNames: {
        vhidden: "hidden",
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-between items-center w-full",
        caption_dropdowns: "flex justify-between gap-1 w-full items-center",
        nav: "hidden",
        caption_label: "hidden",
        table: "border-collapse space-y-1",
        head_row: "flex",
        head_cell: I(
          "size-10 m-0.5 font-normal text-xs flex items-center justify-center text-subtle",
          {
            "size-8 m-0": s === "small"
          }
        ),
        row: "flex w-full mt-0",
        cell: "relative p-0 text-center",
        day: I(
          "size-10 text-xs m-0.5 aria-selected:opacity-100 hover:bg-subtle flex items-center justify-center cursor-pointer",
          {
            "rounded-lg": o.theme.appearance.corners === "rounded",
            // When in range mode the background of the selected days has to touch each other so we need to remove the margin
            "size-12 m-0": r.mode === "range",
            "size-8 m-0": s === "small"
          }
        ),
        day_selected: I("bg-inverted text-inverted hover:!bg-intense", {
          "rounded-lg": o.theme.appearance.corners === "rounded"
        }),
        day_range_start: "bg-inverted text-inverted rounded-none rounded-l-lg m-r-0",
        // day_selected overwrites the text color, so we need an important here.
        day_range_middle: "bg-inverted rounded-none text-inverted",
        day_range_end: "bg-inverted text-inverted rounded-none rounded-r-lg",
        day_outside: "day-outside opacity-50 aria-selected:bg-accent/50 aria-selected:aria-selected:opacity-30",
        day_disabled: "opacity-50 line-through !cursor-not-allowed hover:bg-transparent",
        ...e
      },
      components: {
        Dropdown: E7,
        DayContent: T7
      },
      ...r
    }
  );
}
var bf, Yy;
function Ku() {
  if (Yy) return bf;
  Yy = 1;
  var t = Array.isArray;
  return bf = t, bf;
}
var yf, Zy;
function M7() {
  if (Zy) return yf;
  Zy = 1;
  var t = typeof ii == "object" && ii && ii.Object === Object && ii;
  return yf = t, yf;
}
var wf, Jy;
function Gu() {
  if (Jy) return wf;
  Jy = 1;
  var t = M7(), e = typeof self == "object" && self && self.Object === Object && self, n = t || e || Function("return this")();
  return wf = n, wf;
}
var xf, Xy;
function Y0() {
  if (Xy) return xf;
  Xy = 1;
  var t = Gu(), e = t.Symbol;
  return xf = e, xf;
}
var kf, Qy;
function O7() {
  if (Qy) return kf;
  Qy = 1;
  var t = Y0(), e = Object.prototype, n = e.hasOwnProperty, r = e.toString, i = t ? t.toStringTag : void 0;
  function o(s) {
    var a = n.call(s, i), l = s[i];
    try {
      s[i] = void 0;
      var c = !0;
    } catch {
    }
    var u = r.call(s);
    return c && (a ? s[i] = l : delete s[i]), u;
  }
  return kf = o, kf;
}
var Cf, e1;
function A7() {
  if (e1) return Cf;
  e1 = 1;
  var t = Object.prototype, e = t.toString;
  function n(r) {
    return e.call(r);
  }
  return Cf = n, Cf;
}
var Sf, t1;
function Yu() {
  if (t1) return Sf;
  t1 = 1;
  var t = Y0(), e = O7(), n = A7(), r = "[object Null]", i = "[object Undefined]", o = t ? t.toStringTag : void 0;
  function s(a) {
    return a == null ? a === void 0 ? i : r : o && o in Object(a) ? e(a) : n(a);
  }
  return Sf = s, Sf;
}
var Tf, n1;
function Z0() {
  if (n1) return Tf;
  n1 = 1;
  function t(e) {
    return e != null && typeof e == "object";
  }
  return Tf = t, Tf;
}
var Ef, r1;
function Zu() {
  if (r1) return Ef;
  r1 = 1;
  var t = Yu(), e = Z0(), n = "[object Symbol]";
  function r(i) {
    return typeof i == "symbol" || e(i) && t(i) == n;
  }
  return Ef = r, Ef;
}
var Mf, i1;
function N7() {
  if (i1) return Mf;
  i1 = 1;
  var t = Ku(), e = Zu(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function i(o, s) {
    if (t(o))
      return !1;
    var a = typeof o;
    return a == "number" || a == "symbol" || a == "boolean" || o == null || e(o) ? !0 : r.test(o) || !n.test(o) || s != null && o in Object(s);
  }
  return Mf = i, Mf;
}
var Of, o1;
function bs() {
  if (o1) return Of;
  o1 = 1;
  function t(e) {
    var n = typeof e;
    return e != null && (n == "object" || n == "function");
  }
  return Of = t, Of;
}
var Af, s1;
function pE() {
  if (s1) return Af;
  s1 = 1;
  var t = Yu(), e = bs(), n = "[object AsyncFunction]", r = "[object Function]", i = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(a) {
    if (!e(a))
      return !1;
    var l = t(a);
    return l == r || l == i || l == n || l == o;
  }
  return Af = s, Af;
}
var Nf, a1;
function R7() {
  if (a1) return Nf;
  a1 = 1;
  var t = Gu(), e = t["__core-js_shared__"];
  return Nf = e, Nf;
}
var Rf, l1;
function D7() {
  if (l1) return Rf;
  l1 = 1;
  var t = R7(), e = function() {
    var r = /[^.]+$/.exec(t && t.keys && t.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function n(r) {
    return !!e && e in r;
  }
  return Rf = n, Rf;
}
var Df, c1;
function I7() {
  if (c1) return Df;
  c1 = 1;
  var t = Function.prototype, e = t.toString;
  function n(r) {
    if (r != null) {
      try {
        return e.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return Df = n, Df;
}
var If, u1;
function _7() {
  if (u1) return If;
  u1 = 1;
  var t = pE(), e = D7(), n = bs(), r = I7(), i = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, a = Object.prototype, l = s.toString, c = a.hasOwnProperty, u = RegExp(
    "^" + l.call(c).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function d(f) {
    if (!n(f) || e(f))
      return !1;
    var h = t(f) ? u : o;
    return h.test(r(f));
  }
  return If = d, If;
}
var _f, d1;
function P7() {
  if (d1) return _f;
  d1 = 1;
  function t(e, n) {
    return e == null ? void 0 : e[n];
  }
  return _f = t, _f;
}
var Pf, f1;
function mE() {
  if (f1) return Pf;
  f1 = 1;
  var t = _7(), e = P7();
  function n(r, i) {
    var o = e(r, i);
    return t(o) ? o : void 0;
  }
  return Pf = n, Pf;
}
var Lf, h1;
function Ju() {
  if (h1) return Lf;
  h1 = 1;
  var t = mE(), e = t(Object, "create");
  return Lf = e, Lf;
}
var Ff, p1;
function L7() {
  if (p1) return Ff;
  p1 = 1;
  var t = Ju();
  function e() {
    this.__data__ = t ? t(null) : {}, this.size = 0;
  }
  return Ff = e, Ff;
}
var $f, m1;
function F7() {
  if (m1) return $f;
  m1 = 1;
  function t(e) {
    var n = this.has(e) && delete this.__data__[e];
    return this.size -= n ? 1 : 0, n;
  }
  return $f = t, $f;
}
var Bf, g1;
function $7() {
  if (g1) return Bf;
  g1 = 1;
  var t = Ju(), e = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function i(o) {
    var s = this.__data__;
    if (t) {
      var a = s[o];
      return a === e ? void 0 : a;
    }
    return r.call(s, o) ? s[o] : void 0;
  }
  return Bf = i, Bf;
}
var Vf, v1;
function B7() {
  if (v1) return Vf;
  v1 = 1;
  var t = Ju(), e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var o = this.__data__;
    return t ? o[i] !== void 0 : n.call(o, i);
  }
  return Vf = r, Vf;
}
var zf, b1;
function V7() {
  if (b1) return zf;
  b1 = 1;
  var t = Ju(), e = "__lodash_hash_undefined__";
  function n(r, i) {
    var o = this.__data__;
    return this.size += this.has(r) ? 0 : 1, o[r] = t && i === void 0 ? e : i, this;
  }
  return zf = n, zf;
}
var Hf, y1;
function z7() {
  if (y1) return Hf;
  y1 = 1;
  var t = L7(), e = F7(), n = $7(), r = B7(), i = V7();
  function o(s) {
    var a = -1, l = s == null ? 0 : s.length;
    for (this.clear(); ++a < l; ) {
      var c = s[a];
      this.set(c[0], c[1]);
    }
  }
  return o.prototype.clear = t, o.prototype.delete = e, o.prototype.get = n, o.prototype.has = r, o.prototype.set = i, Hf = o, Hf;
}
var Wf, w1;
function H7() {
  if (w1) return Wf;
  w1 = 1;
  function t() {
    this.__data__ = [], this.size = 0;
  }
  return Wf = t, Wf;
}
var jf, x1;
function W7() {
  if (x1) return jf;
  x1 = 1;
  function t(e, n) {
    return e === n || e !== e && n !== n;
  }
  return jf = t, jf;
}
var Uf, k1;
function Xu() {
  if (k1) return Uf;
  k1 = 1;
  var t = W7();
  function e(n, r) {
    for (var i = n.length; i--; )
      if (t(n[i][0], r))
        return i;
    return -1;
  }
  return Uf = e, Uf;
}
var qf, C1;
function j7() {
  if (C1) return qf;
  C1 = 1;
  var t = Xu(), e = Array.prototype, n = e.splice;
  function r(i) {
    var o = this.__data__, s = t(o, i);
    if (s < 0)
      return !1;
    var a = o.length - 1;
    return s == a ? o.pop() : n.call(o, s, 1), --this.size, !0;
  }
  return qf = r, qf;
}
var Kf, S1;
function U7() {
  if (S1) return Kf;
  S1 = 1;
  var t = Xu();
  function e(n) {
    var r = this.__data__, i = t(r, n);
    return i < 0 ? void 0 : r[i][1];
  }
  return Kf = e, Kf;
}
var Gf, T1;
function q7() {
  if (T1) return Gf;
  T1 = 1;
  var t = Xu();
  function e(n) {
    return t(this.__data__, n) > -1;
  }
  return Gf = e, Gf;
}
var Yf, E1;
function K7() {
  if (E1) return Yf;
  E1 = 1;
  var t = Xu();
  function e(n, r) {
    var i = this.__data__, o = t(i, n);
    return o < 0 ? (++this.size, i.push([n, r])) : i[o][1] = r, this;
  }
  return Yf = e, Yf;
}
var Zf, M1;
function G7() {
  if (M1) return Zf;
  M1 = 1;
  var t = H7(), e = j7(), n = U7(), r = q7(), i = K7();
  function o(s) {
    var a = -1, l = s == null ? 0 : s.length;
    for (this.clear(); ++a < l; ) {
      var c = s[a];
      this.set(c[0], c[1]);
    }
  }
  return o.prototype.clear = t, o.prototype.delete = e, o.prototype.get = n, o.prototype.has = r, o.prototype.set = i, Zf = o, Zf;
}
var Jf, O1;
function Y7() {
  if (O1) return Jf;
  O1 = 1;
  var t = mE(), e = Gu(), n = t(e, "Map");
  return Jf = n, Jf;
}
var Xf, A1;
function Z7() {
  if (A1) return Xf;
  A1 = 1;
  var t = z7(), e = G7(), n = Y7();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new t(),
      map: new (n || e)(),
      string: new t()
    };
  }
  return Xf = r, Xf;
}
var Qf, N1;
function J7() {
  if (N1) return Qf;
  N1 = 1;
  function t(e) {
    var n = typeof e;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
  }
  return Qf = t, Qf;
}
var eh, R1;
function Qu() {
  if (R1) return eh;
  R1 = 1;
  var t = J7();
  function e(n, r) {
    var i = n.__data__;
    return t(r) ? i[typeof r == "string" ? "string" : "hash"] : i.map;
  }
  return eh = e, eh;
}
var th, D1;
function X7() {
  if (D1) return th;
  D1 = 1;
  var t = Qu();
  function e(n) {
    var r = t(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return th = e, th;
}
var nh, I1;
function Q7() {
  if (I1) return nh;
  I1 = 1;
  var t = Qu();
  function e(n) {
    return t(this, n).get(n);
  }
  return nh = e, nh;
}
var rh, _1;
function eL() {
  if (_1) return rh;
  _1 = 1;
  var t = Qu();
  function e(n) {
    return t(this, n).has(n);
  }
  return rh = e, rh;
}
var ih, P1;
function tL() {
  if (P1) return ih;
  P1 = 1;
  var t = Qu();
  function e(n, r) {
    var i = t(this, n), o = i.size;
    return i.set(n, r), this.size += i.size == o ? 0 : 1, this;
  }
  return ih = e, ih;
}
var oh, L1;
function nL() {
  if (L1) return oh;
  L1 = 1;
  var t = Z7(), e = X7(), n = Q7(), r = eL(), i = tL();
  function o(s) {
    var a = -1, l = s == null ? 0 : s.length;
    for (this.clear(); ++a < l; ) {
      var c = s[a];
      this.set(c[0], c[1]);
    }
  }
  return o.prototype.clear = t, o.prototype.delete = e, o.prototype.get = n, o.prototype.has = r, o.prototype.set = i, oh = o, oh;
}
var sh, F1;
function rL() {
  if (F1) return sh;
  F1 = 1;
  var t = nL(), e = "Expected a function";
  function n(r, i) {
    if (typeof r != "function" || i != null && typeof i != "function")
      throw new TypeError(e);
    var o = function() {
      var s = arguments, a = i ? i.apply(this, s) : s[0], l = o.cache;
      if (l.has(a))
        return l.get(a);
      var c = r.apply(this, s);
      return o.cache = l.set(a, c) || l, c;
    };
    return o.cache = new (n.Cache || t)(), o;
  }
  return n.Cache = t, sh = n, sh;
}
var ah, $1;
function iL() {
  if ($1) return ah;
  $1 = 1;
  var t = rL(), e = 500;
  function n(r) {
    var i = t(r, function(s) {
      return o.size === e && o.clear(), s;
    }), o = i.cache;
    return i;
  }
  return ah = n, ah;
}
var lh, B1;
function oL() {
  if (B1) return lh;
  B1 = 1;
  var t = iL(), e = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = t(function(i) {
    var o = [];
    return i.charCodeAt(0) === 46 && o.push(""), i.replace(e, function(s, a, l, c) {
      o.push(l ? c.replace(n, "$1") : a || s);
    }), o;
  });
  return lh = r, lh;
}
var ch, V1;
function sL() {
  if (V1) return ch;
  V1 = 1;
  function t(e, n) {
    for (var r = -1, i = e == null ? 0 : e.length, o = Array(i); ++r < i; )
      o[r] = n(e[r], r, e);
    return o;
  }
  return ch = t, ch;
}
var uh, z1;
function aL() {
  if (z1) return uh;
  z1 = 1;
  var t = Y0(), e = sL(), n = Ku(), r = Zu(), i = t ? t.prototype : void 0, o = i ? i.toString : void 0;
  function s(a) {
    if (typeof a == "string")
      return a;
    if (n(a))
      return e(a, s) + "";
    if (r(a))
      return o ? o.call(a) : "";
    var l = a + "";
    return l == "0" && 1 / a == -1 / 0 ? "-0" : l;
  }
  return uh = s, uh;
}
var dh, H1;
function lL() {
  if (H1) return dh;
  H1 = 1;
  var t = aL();
  function e(n) {
    return n == null ? "" : t(n);
  }
  return dh = e, dh;
}
var fh, W1;
function cL() {
  if (W1) return fh;
  W1 = 1;
  var t = Ku(), e = N7(), n = oL(), r = lL();
  function i(o, s) {
    return t(o) ? o : e(o, s) ? [o] : n(r(o));
  }
  return fh = i, fh;
}
var hh, j1;
function uL() {
  if (j1) return hh;
  j1 = 1;
  var t = Zu();
  function e(n) {
    if (typeof n == "string" || t(n))
      return n;
    var r = n + "";
    return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
  }
  return hh = e, hh;
}
var ph, U1;
function dL() {
  if (U1) return ph;
  U1 = 1;
  var t = cL(), e = uL();
  function n(r, i) {
    i = t(i, r);
    for (var o = 0, s = i.length; r != null && o < s; )
      r = r[e(i[o++])];
    return o && o == s ? r : void 0;
  }
  return ph = n, ph;
}
var mh, q1;
function fL() {
  if (q1) return mh;
  q1 = 1;
  var t = dL();
  function e(n, r, i) {
    var o = n == null ? void 0 : t(n, r);
    return o === void 0 ? i : o;
  }
  return mh = e, mh;
}
fL();
var gh, K1;
function hL() {
  if (K1) return gh;
  K1 = 1;
  var t = Yu(), e = Ku(), n = Z0(), r = "[object String]";
  function i(o) {
    return typeof o == "string" || !e(o) && n(o) && t(o) == r;
  }
  return gh = i, gh;
}
var pL = hL();
const mL = /* @__PURE__ */ ki(pL);
pE();
bs();
var Sl = { exports: {} }, Be = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var G1;
function gL() {
  if (G1) return Be;
  G1 = 1;
  var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), a = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p;
  p = Symbol.for("react.module.reference");
  function m(b) {
    if (typeof b == "object" && b !== null) {
      var y = b.$$typeof;
      switch (y) {
        case t:
          switch (b = b.type, b) {
            case n:
            case i:
            case r:
            case c:
            case u:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case a:
                case s:
                case l:
                case f:
                case d:
                case o:
                  return b;
                default:
                  return y;
              }
          }
        case e:
          return y;
      }
    }
  }
  return Be.ContextConsumer = s, Be.ContextProvider = o, Be.Element = t, Be.ForwardRef = l, Be.Fragment = n, Be.Lazy = f, Be.Memo = d, Be.Portal = e, Be.Profiler = i, Be.StrictMode = r, Be.Suspense = c, Be.SuspenseList = u, Be.isAsyncMode = function() {
    return !1;
  }, Be.isConcurrentMode = function() {
    return !1;
  }, Be.isContextConsumer = function(b) {
    return m(b) === s;
  }, Be.isContextProvider = function(b) {
    return m(b) === o;
  }, Be.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === t;
  }, Be.isForwardRef = function(b) {
    return m(b) === l;
  }, Be.isFragment = function(b) {
    return m(b) === n;
  }, Be.isLazy = function(b) {
    return m(b) === f;
  }, Be.isMemo = function(b) {
    return m(b) === d;
  }, Be.isPortal = function(b) {
    return m(b) === e;
  }, Be.isProfiler = function(b) {
    return m(b) === i;
  }, Be.isStrictMode = function(b) {
    return m(b) === r;
  }, Be.isSuspense = function(b) {
    return m(b) === c;
  }, Be.isSuspenseList = function(b) {
    return m(b) === u;
  }, Be.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === n || b === i || b === r || b === c || b === u || b === h || typeof b == "object" && b !== null && (b.$$typeof === f || b.$$typeof === d || b.$$typeof === o || b.$$typeof === s || b.$$typeof === l || b.$$typeof === p || b.getModuleId !== void 0);
  }, Be.typeOf = m, Be;
}
var Ve = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Y1;
function vL() {
  return Y1 || (Y1 = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), a = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = !1, m = !1, b = !1, y = !1, k = !1, C;
    C = Symbol.for("react.module.reference");
    function x(oe) {
      return !!(typeof oe == "string" || typeof oe == "function" || oe === n || oe === i || k || oe === r || oe === c || oe === u || y || oe === h || p || m || b || typeof oe == "object" && oe !== null && (oe.$$typeof === f || oe.$$typeof === d || oe.$$typeof === o || oe.$$typeof === s || oe.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      oe.$$typeof === C || oe.getModuleId !== void 0));
    }
    function S(oe) {
      if (typeof oe == "object" && oe !== null) {
        var kt = oe.$$typeof;
        switch (kt) {
          case t:
            var Ot = oe.type;
            switch (Ot) {
              case n:
              case i:
              case r:
              case c:
              case u:
                return Ot;
              default:
                var Zt = Ot && Ot.$$typeof;
                switch (Zt) {
                  case a:
                  case s:
                  case l:
                  case f:
                  case d:
                  case o:
                    return Zt;
                  default:
                    return kt;
                }
            }
          case e:
            return kt;
        }
      }
    }
    var T = s, E = o, M = t, O = l, L = n, $ = f, z = d, B = e, A = i, N = r, R = c, _ = u, D = !1, q = !1;
    function V(oe) {
      return D || (D = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function H(oe) {
      return q || (q = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function G(oe) {
      return S(oe) === s;
    }
    function Q(oe) {
      return S(oe) === o;
    }
    function te(oe) {
      return typeof oe == "object" && oe !== null && oe.$$typeof === t;
    }
    function le(oe) {
      return S(oe) === l;
    }
    function se(oe) {
      return S(oe) === n;
    }
    function j(oe) {
      return S(oe) === f;
    }
    function X(oe) {
      return S(oe) === d;
    }
    function ie(oe) {
      return S(oe) === e;
    }
    function ne(oe) {
      return S(oe) === i;
    }
    function we(oe) {
      return S(oe) === r;
    }
    function K(oe) {
      return S(oe) === c;
    }
    function Fe(oe) {
      return S(oe) === u;
    }
    Ve.ContextConsumer = T, Ve.ContextProvider = E, Ve.Element = M, Ve.ForwardRef = O, Ve.Fragment = L, Ve.Lazy = $, Ve.Memo = z, Ve.Portal = B, Ve.Profiler = A, Ve.StrictMode = N, Ve.Suspense = R, Ve.SuspenseList = _, Ve.isAsyncMode = V, Ve.isConcurrentMode = H, Ve.isContextConsumer = G, Ve.isContextProvider = Q, Ve.isElement = te, Ve.isForwardRef = le, Ve.isFragment = se, Ve.isLazy = j, Ve.isMemo = X, Ve.isPortal = ie, Ve.isProfiler = ne, Ve.isStrictMode = we, Ve.isSuspense = K, Ve.isSuspenseList = Fe, Ve.isValidElementType = x, Ve.typeOf = S;
  }()), Ve;
}
var Z1;
function bL() {
  return Z1 || (Z1 = 1, process.env.NODE_ENV === "production" ? Sl.exports = gL() : Sl.exports = vL()), Sl.exports;
}
bL();
var vh, J1;
function gE() {
  if (J1) return vh;
  J1 = 1;
  var t = Yu(), e = Z0(), n = "[object Number]";
  function r(i) {
    return typeof i == "number" || e(i) && t(i) == n;
  }
  return vh = r, vh;
}
var bh, X1;
function yL() {
  if (X1) return bh;
  X1 = 1;
  var t = gE();
  function e(n) {
    return t(n) && n != +n;
  }
  return bh = e, bh;
}
yL();
gE();
var Tl = function(e) {
  return mL(e) && e.indexOf("%") === e.length - 1;
}, wL = function(e) {
  return typeof e == "string" ? e : e ? e.displayName || e.name || "Component" : "";
}, xL = process.env.NODE_ENV !== "production", yh = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)
    i[o - 2] = arguments[o];
  if (xL && typeof console < "u" && console.warn && (n === void 0 && console.warn("LogUtils requires an error message argument"), !e))
    if (n === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var s = 0;
      console.warn(n.replace(/%s/g, function() {
        return i[s++];
      }));
    }
}, wh, Q1;
function kL() {
  if (Q1) return wh;
  Q1 = 1;
  var t = Gu(), e = function() {
    return t.Date.now();
  };
  return wh = e, wh;
}
var xh, ew;
function CL() {
  if (ew) return xh;
  ew = 1;
  var t = /\s/;
  function e(n) {
    for (var r = n.length; r-- && t.test(n.charAt(r)); )
      ;
    return r;
  }
  return xh = e, xh;
}
var kh, tw;
function SL() {
  if (tw) return kh;
  tw = 1;
  var t = CL(), e = /^\s+/;
  function n(r) {
    return r && r.slice(0, t(r) + 1).replace(e, "");
  }
  return kh = n, kh;
}
var Ch, nw;
function TL() {
  if (nw) return Ch;
  nw = 1;
  var t = SL(), e = bs(), n = Zu(), r = NaN, i = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, s = /^0o[0-7]+$/i, a = parseInt;
  function l(c) {
    if (typeof c == "number")
      return c;
    if (n(c))
      return r;
    if (e(c)) {
      var u = typeof c.valueOf == "function" ? c.valueOf() : c;
      c = e(u) ? u + "" : u;
    }
    if (typeof c != "string")
      return c === 0 ? c : +c;
    c = t(c);
    var d = o.test(c);
    return d || s.test(c) ? a(c.slice(2), d ? 2 : 8) : i.test(c) ? r : +c;
  }
  return Ch = l, Ch;
}
var Sh, rw;
function EL() {
  if (rw) return Sh;
  rw = 1;
  var t = bs(), e = kL(), n = TL(), r = "Expected a function", i = Math.max, o = Math.min;
  function s(a, l, c) {
    var u, d, f, h, p, m, b = 0, y = !1, k = !1, C = !0;
    if (typeof a != "function")
      throw new TypeError(r);
    l = n(l) || 0, t(c) && (y = !!c.leading, k = "maxWait" in c, f = k ? i(n(c.maxWait) || 0, l) : f, C = "trailing" in c ? !!c.trailing : C);
    function x(B) {
      var A = u, N = d;
      return u = d = void 0, b = B, h = a.apply(N, A), h;
    }
    function S(B) {
      return b = B, p = setTimeout(M, l), y ? x(B) : h;
    }
    function T(B) {
      var A = B - m, N = B - b, R = l - A;
      return k ? o(R, f - N) : R;
    }
    function E(B) {
      var A = B - m, N = B - b;
      return m === void 0 || A >= l || A < 0 || k && N >= f;
    }
    function M() {
      var B = e();
      if (E(B))
        return O(B);
      p = setTimeout(M, T(B));
    }
    function O(B) {
      return p = void 0, C && u ? x(B) : (u = d = void 0, h);
    }
    function L() {
      p !== void 0 && clearTimeout(p), b = 0, u = m = d = p = void 0;
    }
    function $() {
      return p === void 0 ? h : O(e());
    }
    function z() {
      var B = e(), A = E(B);
      if (u = arguments, d = this, m = B, A) {
        if (p === void 0)
          return S(m);
        if (k)
          return clearTimeout(p), p = setTimeout(M, l), x(m);
      }
      return p === void 0 && (p = setTimeout(M, l)), h;
    }
    return z.cancel = L, z.flush = $, z;
  }
  return Sh = s, Sh;
}
var Th, iw;
function ML() {
  if (iw) return Th;
  iw = 1;
  var t = EL(), e = bs(), n = "Expected a function";
  function r(i, o, s) {
    var a = !0, l = !0;
    if (typeof i != "function")
      throw new TypeError(n);
    return e(s) && (a = "leading" in s ? !!s.leading : a, l = "trailing" in s ? !!s.trailing : l), t(i, o, {
      leading: a,
      maxWait: o,
      trailing: l
    });
  }
  return Th = r, Th;
}
var OL = ML();
const AL = /* @__PURE__ */ ki(OL);
function da(t) {
  "@babel/helpers - typeof";
  return da = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, da(t);
}
function ow(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function El(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ow(Object(n), !0).forEach(function(r) {
      NL(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ow(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function NL(t, e, n) {
  return e = RL(e), e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function RL(t) {
  var e = DL(t, "string");
  return da(e) == "symbol" ? e : e + "";
}
function DL(t, e) {
  if (da(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (da(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function IL(t, e) {
  return FL(t) || LL(t, e) || PL(t, e) || _L();
}
function _L() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function PL(t, e) {
  if (t) {
    if (typeof t == "string") return sw(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sw(t, e);
  }
}
function sw(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function LL(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r, i, o, s, a = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(t)).next, e !== 0) for (; !(l = (r = o.call(n)).done) && (a.push(r.value), a.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && n.return != null && (s = n.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw i;
      }
    }
    return a;
  }
}
function FL(t) {
  if (Array.isArray(t)) return t;
}
var $L = /* @__PURE__ */ ce(function(t, e) {
  var n = t.aspect, r = t.initialDimension, i = r === void 0 ? {
    width: -1,
    height: -1
  } : r, o = t.width, s = o === void 0 ? "100%" : o, a = t.height, l = a === void 0 ? "100%" : a, c = t.minWidth, u = c === void 0 ? 0 : c, d = t.minHeight, f = t.maxHeight, h = t.children, p = t.debounce, m = p === void 0 ? 0 : p, b = t.id, y = t.className, k = t.onResize, C = t.style, x = C === void 0 ? {} : C, S = Me(null), T = Me();
  T.current = k, vS(e, function() {
    return Object.defineProperty(S.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), S.current;
      },
      configurable: !0
    });
  });
  var E = pe({
    containerWidth: i.width,
    containerHeight: i.height
  }), M = IL(E, 2), O = M[0], L = M[1], $ = ct(function(B, A) {
    L(function(N) {
      var R = Math.round(B), _ = Math.round(A);
      return N.containerWidth === R && N.containerHeight === _ ? N : {
        containerWidth: R,
        containerHeight: _
      };
    });
  }, []);
  De(function() {
    var B = function(q) {
      var V, H = q[0].contentRect, G = H.width, Q = H.height;
      $(G, Q), (V = T.current) === null || V === void 0 || V.call(T, G, Q);
    };
    m > 0 && (B = AL(B, m, {
      trailing: !0,
      leading: !1
    }));
    var A = new ResizeObserver(B), N = S.current.getBoundingClientRect(), R = N.width, _ = N.height;
    return $(R, _), A.observe(S.current), function() {
      A.disconnect();
    };
  }, [$, m]);
  var z = En(function() {
    var B = O.containerWidth, A = O.containerHeight;
    if (B < 0 || A < 0)
      return null;
    yh(Tl(s) || Tl(l), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, s, l), yh(!n || n > 0, "The aspect(%s) must be greater than zero.", n);
    var N = Tl(s) ? B : s, R = Tl(l) ? A : l;
    n && n > 0 && (N ? R = N / n : R && (N = R * n), f && R > f && (R = f)), yh(N > 0 || R > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, N, R, s, l, u, d, n);
    var _ = !Array.isArray(h) && wL(h.type).endsWith("Chart");
    return he.Children.map(h, function(D) {
      return /* @__PURE__ */ he.isValidElement(D) ? /* @__PURE__ */ xD(D, El({
        width: N,
        height: R
      }, _ ? {
        style: El({
          height: "100%",
          width: "100%",
          maxHeight: R,
          maxWidth: N
        }, D.props.style)
      } : {})) : D;
    });
  }, [n, h, l, f, d, u, O, s]);
  return /* @__PURE__ */ he.createElement("div", {
    id: b ? "".concat(b) : void 0,
    className: CS("recharts-responsive-container", y),
    style: El(El({}, x), {}, {
      width: s,
      height: l,
      minWidth: u,
      minHeight: d,
      maxHeight: f
    }),
    ref: S
  }, z);
}), Ml = { exports: {} }, Ol = { exports: {} }, ze = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aw;
function BL() {
  if (aw) return ze;
  aw = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, b = t ? Symbol.for("react.fundamental") : 60117, y = t ? Symbol.for("react.responder") : 60118, k = t ? Symbol.for("react.scope") : 60119;
  function C(S) {
    if (typeof S == "object" && S !== null) {
      var T = S.$$typeof;
      switch (T) {
        case e:
          switch (S = S.type, S) {
            case l:
            case c:
            case r:
            case o:
            case i:
            case d:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case a:
                case u:
                case p:
                case h:
                case s:
                  return S;
                default:
                  return T;
              }
          }
        case n:
          return T;
      }
    }
  }
  function x(S) {
    return C(S) === c;
  }
  return ze.AsyncMode = l, ze.ConcurrentMode = c, ze.ContextConsumer = a, ze.ContextProvider = s, ze.Element = e, ze.ForwardRef = u, ze.Fragment = r, ze.Lazy = p, ze.Memo = h, ze.Portal = n, ze.Profiler = o, ze.StrictMode = i, ze.Suspense = d, ze.isAsyncMode = function(S) {
    return x(S) || C(S) === l;
  }, ze.isConcurrentMode = x, ze.isContextConsumer = function(S) {
    return C(S) === a;
  }, ze.isContextProvider = function(S) {
    return C(S) === s;
  }, ze.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === e;
  }, ze.isForwardRef = function(S) {
    return C(S) === u;
  }, ze.isFragment = function(S) {
    return C(S) === r;
  }, ze.isLazy = function(S) {
    return C(S) === p;
  }, ze.isMemo = function(S) {
    return C(S) === h;
  }, ze.isPortal = function(S) {
    return C(S) === n;
  }, ze.isProfiler = function(S) {
    return C(S) === o;
  }, ze.isStrictMode = function(S) {
    return C(S) === i;
  }, ze.isSuspense = function(S) {
    return C(S) === d;
  }, ze.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === r || S === c || S === o || S === i || S === d || S === f || typeof S == "object" && S !== null && (S.$$typeof === p || S.$$typeof === h || S.$$typeof === s || S.$$typeof === a || S.$$typeof === u || S.$$typeof === b || S.$$typeof === y || S.$$typeof === k || S.$$typeof === m);
  }, ze.typeOf = C, ze;
}
var He = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lw;
function VL() {
  return lw || (lw = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, b = t ? Symbol.for("react.fundamental") : 60117, y = t ? Symbol.for("react.responder") : 60118, k = t ? Symbol.for("react.scope") : 60119;
    function C(K) {
      return typeof K == "string" || typeof K == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      K === r || K === c || K === o || K === i || K === d || K === f || typeof K == "object" && K !== null && (K.$$typeof === p || K.$$typeof === h || K.$$typeof === s || K.$$typeof === a || K.$$typeof === u || K.$$typeof === b || K.$$typeof === y || K.$$typeof === k || K.$$typeof === m);
    }
    function x(K) {
      if (typeof K == "object" && K !== null) {
        var Fe = K.$$typeof;
        switch (Fe) {
          case e:
            var oe = K.type;
            switch (oe) {
              case l:
              case c:
              case r:
              case o:
              case i:
              case d:
                return oe;
              default:
                var kt = oe && oe.$$typeof;
                switch (kt) {
                  case a:
                  case u:
                  case p:
                  case h:
                  case s:
                    return kt;
                  default:
                    return Fe;
                }
            }
          case n:
            return Fe;
        }
      }
    }
    var S = l, T = c, E = a, M = s, O = e, L = u, $ = r, z = p, B = h, A = n, N = o, R = i, _ = d, D = !1;
    function q(K) {
      return D || (D = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), V(K) || x(K) === l;
    }
    function V(K) {
      return x(K) === c;
    }
    function H(K) {
      return x(K) === a;
    }
    function G(K) {
      return x(K) === s;
    }
    function Q(K) {
      return typeof K == "object" && K !== null && K.$$typeof === e;
    }
    function te(K) {
      return x(K) === u;
    }
    function le(K) {
      return x(K) === r;
    }
    function se(K) {
      return x(K) === p;
    }
    function j(K) {
      return x(K) === h;
    }
    function X(K) {
      return x(K) === n;
    }
    function ie(K) {
      return x(K) === o;
    }
    function ne(K) {
      return x(K) === i;
    }
    function we(K) {
      return x(K) === d;
    }
    He.AsyncMode = S, He.ConcurrentMode = T, He.ContextConsumer = E, He.ContextProvider = M, He.Element = O, He.ForwardRef = L, He.Fragment = $, He.Lazy = z, He.Memo = B, He.Portal = A, He.Profiler = N, He.StrictMode = R, He.Suspense = _, He.isAsyncMode = q, He.isConcurrentMode = V, He.isContextConsumer = H, He.isContextProvider = G, He.isElement = Q, He.isForwardRef = te, He.isFragment = le, He.isLazy = se, He.isMemo = j, He.isPortal = X, He.isProfiler = ie, He.isStrictMode = ne, He.isSuspense = we, He.isValidElementType = C, He.typeOf = x;
  }()), He;
}
var cw;
function vE() {
  return cw || (cw = 1, process.env.NODE_ENV === "production" ? Ol.exports = BL() : Ol.exports = VL()), Ol.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Eh, uw;
function zL() {
  if (uw) return Eh;
  uw = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(s).map(function(u) {
        return s[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Eh = i() ? Object.assign : function(o, s) {
    for (var a, l = r(o), c, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var d in a)
        e.call(a, d) && (l[d] = a[d]);
      if (t) {
        c = t(a);
        for (var f = 0; f < c.length; f++)
          n.call(a, c[f]) && (l[c[f]] = a[c[f]]);
      }
    }
    return l;
  }, Eh;
}
var Mh, dw;
function J0() {
  if (dw) return Mh;
  dw = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Mh = t, Mh;
}
var Oh, fw;
function bE() {
  return fw || (fw = 1, Oh = Function.call.bind(Object.prototype.hasOwnProperty)), Oh;
}
var Ah, hw;
function HL() {
  if (hw) return Ah;
  hw = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */ J0(), n = {}, r = /* @__PURE__ */ bE();
    t = function(o) {
      var s = "Warning: " + o;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(o, s, a, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in o)
        if (r(o, u)) {
          var d;
          try {
            if (typeof o[u] != "function") {
              var f = Error(
                (l || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = o[u](s, u, l, a, null, e);
          } catch (p) {
            d = p;
          }
          if (d && !(d instanceof Error) && t(
            (l || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = c ? c() : "";
            t(
              "Failed " + a + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Ah = i, Ah;
}
var Nh, pw;
function WL() {
  if (pw) return Nh;
  pw = 1;
  var t = vE(), e = zL(), n = /* @__PURE__ */ J0(), r = /* @__PURE__ */ bE(), i = /* @__PURE__ */ HL(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return Nh = function(a, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(V) {
      var H = V && (c && V[c] || V[u]);
      if (typeof H == "function")
        return H;
    }
    var f = "<<anonymous>>", h = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: k(),
      arrayOf: C,
      element: x(),
      elementType: S(),
      instanceOf: T,
      node: L(),
      objectOf: M,
      oneOf: E,
      oneOfType: O,
      shape: z,
      exact: B
    };
    function p(V, H) {
      return V === H ? V !== 0 || 1 / V === 1 / H : V !== V && H !== H;
    }
    function m(V, H) {
      this.message = V, this.data = H && typeof H == "object" ? H : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function b(V) {
      if (process.env.NODE_ENV !== "production")
        var H = {}, G = 0;
      function Q(le, se, j, X, ie, ne, we) {
        if (X = X || f, ne = ne || j, we !== n) {
          if (l) {
            var K = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw K.name = "Invariant Violation", K;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Fe = X + ":" + j;
            !H[Fe] && // Avoid spamming the console because they are often not actionable except for lib authors
            G < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + ne + "` prop on `" + X + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), H[Fe] = !0, G++);
          }
        }
        return se[j] == null ? le ? se[j] === null ? new m("The " + ie + " `" + ne + "` is marked as required " + ("in `" + X + "`, but its value is `null`.")) : new m("The " + ie + " `" + ne + "` is marked as required in " + ("`" + X + "`, but its value is `undefined`.")) : null : V(se, j, X, ie, ne);
      }
      var te = Q.bind(null, !1);
      return te.isRequired = Q.bind(null, !0), te;
    }
    function y(V) {
      function H(G, Q, te, le, se, j) {
        var X = G[Q], ie = R(X);
        if (ie !== V) {
          var ne = _(X);
          return new m(
            "Invalid " + le + " `" + se + "` of type " + ("`" + ne + "` supplied to `" + te + "`, expected ") + ("`" + V + "`."),
            { expectedType: V }
          );
        }
        return null;
      }
      return b(H);
    }
    function k() {
      return b(s);
    }
    function C(V) {
      function H(G, Q, te, le, se) {
        if (typeof V != "function")
          return new m("Property `" + se + "` of component `" + te + "` has invalid PropType notation inside arrayOf.");
        var j = G[Q];
        if (!Array.isArray(j)) {
          var X = R(j);
          return new m("Invalid " + le + " `" + se + "` of type " + ("`" + X + "` supplied to `" + te + "`, expected an array."));
        }
        for (var ie = 0; ie < j.length; ie++) {
          var ne = V(j, ie, te, le, se + "[" + ie + "]", n);
          if (ne instanceof Error)
            return ne;
        }
        return null;
      }
      return b(H);
    }
    function x() {
      function V(H, G, Q, te, le) {
        var se = H[G];
        if (!a(se)) {
          var j = R(se);
          return new m("Invalid " + te + " `" + le + "` of type " + ("`" + j + "` supplied to `" + Q + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(V);
    }
    function S() {
      function V(H, G, Q, te, le) {
        var se = H[G];
        if (!t.isValidElementType(se)) {
          var j = R(se);
          return new m("Invalid " + te + " `" + le + "` of type " + ("`" + j + "` supplied to `" + Q + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(V);
    }
    function T(V) {
      function H(G, Q, te, le, se) {
        if (!(G[Q] instanceof V)) {
          var j = V.name || f, X = q(G[Q]);
          return new m("Invalid " + le + " `" + se + "` of type " + ("`" + X + "` supplied to `" + te + "`, expected ") + ("instance of `" + j + "`."));
        }
        return null;
      }
      return b(H);
    }
    function E(V) {
      if (!Array.isArray(V))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), s;
      function H(G, Q, te, le, se) {
        for (var j = G[Q], X = 0; X < V.length; X++)
          if (p(j, V[X]))
            return null;
        var ie = JSON.stringify(V, function(we, K) {
          var Fe = _(K);
          return Fe === "symbol" ? String(K) : K;
        });
        return new m("Invalid " + le + " `" + se + "` of value `" + String(j) + "` " + ("supplied to `" + te + "`, expected one of " + ie + "."));
      }
      return b(H);
    }
    function M(V) {
      function H(G, Q, te, le, se) {
        if (typeof V != "function")
          return new m("Property `" + se + "` of component `" + te + "` has invalid PropType notation inside objectOf.");
        var j = G[Q], X = R(j);
        if (X !== "object")
          return new m("Invalid " + le + " `" + se + "` of type " + ("`" + X + "` supplied to `" + te + "`, expected an object."));
        for (var ie in j)
          if (r(j, ie)) {
            var ne = V(j, ie, te, le, se + "." + ie, n);
            if (ne instanceof Error)
              return ne;
          }
        return null;
      }
      return b(H);
    }
    function O(V) {
      if (!Array.isArray(V))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var H = 0; H < V.length; H++) {
        var G = V[H];
        if (typeof G != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + D(G) + " at index " + H + "."
          ), s;
      }
      function Q(te, le, se, j, X) {
        for (var ie = [], ne = 0; ne < V.length; ne++) {
          var we = V[ne], K = we(te, le, se, j, X, n);
          if (K == null)
            return null;
          K.data && r(K.data, "expectedType") && ie.push(K.data.expectedType);
        }
        var Fe = ie.length > 0 ? ", expected one of type [" + ie.join(", ") + "]" : "";
        return new m("Invalid " + j + " `" + X + "` supplied to " + ("`" + se + "`" + Fe + "."));
      }
      return b(Q);
    }
    function L() {
      function V(H, G, Q, te, le) {
        return A(H[G]) ? null : new m("Invalid " + te + " `" + le + "` supplied to " + ("`" + Q + "`, expected a ReactNode."));
      }
      return b(V);
    }
    function $(V, H, G, Q, te) {
      return new m(
        (V || "React class") + ": " + H + " type `" + G + "." + Q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + te + "`."
      );
    }
    function z(V) {
      function H(G, Q, te, le, se) {
        var j = G[Q], X = R(j);
        if (X !== "object")
          return new m("Invalid " + le + " `" + se + "` of type `" + X + "` " + ("supplied to `" + te + "`, expected `object`."));
        for (var ie in V) {
          var ne = V[ie];
          if (typeof ne != "function")
            return $(te, le, se, ie, _(ne));
          var we = ne(j, ie, te, le, se + "." + ie, n);
          if (we)
            return we;
        }
        return null;
      }
      return b(H);
    }
    function B(V) {
      function H(G, Q, te, le, se) {
        var j = G[Q], X = R(j);
        if (X !== "object")
          return new m("Invalid " + le + " `" + se + "` of type `" + X + "` " + ("supplied to `" + te + "`, expected `object`."));
        var ie = e({}, G[Q], V);
        for (var ne in ie) {
          var we = V[ne];
          if (r(V, ne) && typeof we != "function")
            return $(te, le, se, ne, _(we));
          if (!we)
            return new m(
              "Invalid " + le + " `" + se + "` key `" + ne + "` supplied to `" + te + "`.\nBad object: " + JSON.stringify(G[Q], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(V), null, "  ")
            );
          var K = we(j, ne, te, le, se + "." + ne, n);
          if (K)
            return K;
        }
        return null;
      }
      return b(H);
    }
    function A(V) {
      switch (typeof V) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !V;
        case "object":
          if (Array.isArray(V))
            return V.every(A);
          if (V === null || a(V))
            return !0;
          var H = d(V);
          if (H) {
            var G = H.call(V), Q;
            if (H !== V.entries) {
              for (; !(Q = G.next()).done; )
                if (!A(Q.value))
                  return !1;
            } else
              for (; !(Q = G.next()).done; ) {
                var te = Q.value;
                if (te && !A(te[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function N(V, H) {
      return V === "symbol" ? !0 : H ? H["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && H instanceof Symbol : !1;
    }
    function R(V) {
      var H = typeof V;
      return Array.isArray(V) ? "array" : V instanceof RegExp ? "object" : N(H, V) ? "symbol" : H;
    }
    function _(V) {
      if (typeof V > "u" || V === null)
        return "" + V;
      var H = R(V);
      if (H === "object") {
        if (V instanceof Date)
          return "date";
        if (V instanceof RegExp)
          return "regexp";
      }
      return H;
    }
    function D(V) {
      var H = _(V);
      switch (H) {
        case "array":
        case "object":
          return "an " + H;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + H;
        default:
          return H;
      }
    }
    function q(V) {
      return !V.constructor || !V.constructor.name ? f : V.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, Nh;
}
var Rh, mw;
function jL() {
  if (mw) return Rh;
  mw = 1;
  var t = /* @__PURE__ */ J0();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, Rh = function() {
    function r(s, a, l, c, u, d) {
      if (d !== t) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return o.PropTypes = o, o;
  }, Rh;
}
var gw;
function UL() {
  if (gw) return Ml.exports;
  if (gw = 1, process.env.NODE_ENV !== "production") {
    var t = vE(), e = !0;
    Ml.exports = /* @__PURE__ */ WL()(t.isElement, e);
  } else
    Ml.exports = /* @__PURE__ */ jL()();
  return Ml.exports;
}
var qL = /* @__PURE__ */ UL();
const me = /* @__PURE__ */ ki(qL), yE = Pn(null);
function wE() {
  const t = Ln(yE);
  if (!t)
    throw new Error("useChart must be used within a <ChartContainer />");
  return t;
}
function cm(t, e, n) {
  if (typeof e != "object" || e === null)
    return;
  const r = "payload" in e && typeof e.payload == "object" && e.payload !== null ? e.payload : void 0;
  let i = n;
  return n in e && typeof e[n] == "string" ? i = e[n] : r && n in r && typeof r[n] == "string" && (i = r[n]), i in t ? t[i] : t[n];
}
function KL({
  className: t,
  hideIcon: e = !1,
  payload: n,
  verticalAlign: r = "bottom",
  layout: i = "horizontal",
  align: o = "center",
  nameKey: s
}, a) {
  const { config: l } = wE(), c = xe();
  return n != null && n.length ? /* @__PURE__ */ v(
    "div",
    {
      ref: a,
      className: I(
        "flex flex-wrap items-center gap-2",
        i === "vertical" ? "flex-col" : "flex-row",
        r === "top" && "pb-3",
        r === "bottom" && "pt-3",
        o === "left" && "items-start pr-3",
        o === "right" && "items-end pl-3",
        (!o || o === "center") && "justify-center",
        t
      ),
      children: n.map((u) => {
        const d = `${s || u.dataKey || "value"}`, f = cm(l, u, d);
        return /* @__PURE__ */ F(
          "div",
          {
            className: I(
              "[&>svg]:text-muted-foreground flex items-center gap-1.5 [&>svg]:h-3 [&>svg]:w-3"
            ),
            children: [
              f != null && f.icon && !e ? /* @__PURE__ */ v(f.icon, {}) : /* @__PURE__ */ v(
                "div",
                {
                  className: I("h-2 w-2 shrink-0", {
                    "rounded-[2px]": c.theme.appearance.corners === "rounded"
                  }),
                  style: {
                    backgroundColor: u.color
                  }
                }
              ),
              f == null ? void 0 : f.label
            ]
          },
          u.value
        );
      })
    }
  ) : null;
}
function GL({
  active: t,
  payload: e,
  className: n,
  indicator: r = "dot",
  hideLabel: i = !1,
  hideIndicator: o = !1,
  label: s,
  labelFormatter: a,
  labelClassName: l,
  formatter: c,
  color: u,
  nameKey: d,
  labelKey: f,
  total: h
}, p) {
  const { config: m } = wE(), b = xe(), y = En(() => {
    var E;
    if (i || !(e != null && e.length))
      return null;
    const [C] = e, x = `${f || C.dataKey || C.name || "value"}`, S = cm(m, C, x), T = !f && typeof s == "string" ? ((E = m[s]) == null ? void 0 : E.label) || s : S == null ? void 0 : S.label;
    return a ? /* @__PURE__ */ v("div", { className: I("font-medium", l), children: a(T, e) }) : T ? /* @__PURE__ */ v("div", { className: I("font-medium", l), children: T }) : null;
  }, [s, a, e, i, l, m, f]);
  if (!t || !(e != null && e.length))
    return null;
  const k = e.length === 1 && r !== "dot";
  return /* @__PURE__ */ F(
    "div",
    {
      ref: p,
      className: I(
        "border-border/50 bg-base grid min-w-[8rem] items-start gap-1.5 border px-2.5 py-1.5 text-xs shadow-xl",
        {
          "rounded-lg": b.theme.appearance.corners === "rounded"
        },
        n
      ),
      children: [
        k ? null : y,
        /* @__PURE__ */ v("div", { className: "grid gap-1.5", children: e.map((C, x) => {
          const S = `${d || C.name || C.dataKey || "value"}`, T = cm(m, C, S), E = u || C.payload.fill || C.color, M = h ? (Number(C.value) / h * 100).toFixed(2) : null;
          return /* @__PURE__ */ v(
            "div",
            {
              className: I(
                "[&>svg]:text-muted-foreground flex w-full flex-wrap items-stretch gap-2 [&>svg]:h-2.5 [&>svg]:w-2.5",
                r === "dot" && "items-center"
              ),
              children: c && (C == null ? void 0 : C.value) !== void 0 && C.name ? c(C.value, C.name, C, x, C.payload) : /* @__PURE__ */ F(je, { children: [
                T != null && T.icon ? /* @__PURE__ */ v(T.icon, {}) : !o && /* @__PURE__ */ v(
                  "div",
                  {
                    className: I("shrink-0 border-[--color-border] bg-[--color-bg]", {
                      "h-2.5 w-2.5": r === "dot",
                      "w-1": r === "line",
                      "w-0 border-[1.5px] border-dashed bg-transparent": r === "dashed",
                      "my-0.5": k && r === "dashed",
                      "rounded-[2px]": b.theme.appearance.corners === "rounded"
                    }),
                    style: {
                      "--color-bg": E,
                      "--color-border": E
                    }
                  }
                ),
                /* @__PURE__ */ F(
                  "div",
                  {
                    className: I(
                      "flex flex-1 justify-between leading-none",
                      k ? "items-end" : "items-center"
                    ),
                    children: [
                      /* @__PURE__ */ F("div", { className: "grid gap-1.5", children: [
                        k ? y : null,
                        /* @__PURE__ */ v("span", { className: "text-muted-foreground", children: (T == null ? void 0 : T.label) || C.name })
                      ] }),
                      C.value && /* @__PURE__ */ F("span", { className: "text-foreground ml-1 font-mono font-medium tabular-nums", children: [
                        C.payload.calc_format || C.value.toLocaleString(),
                        M && ` (${M}%)`
                      ] })
                    ]
                  }
                )
              ] })
            },
            C.dataKey
          );
        }) })
      ]
    }
  );
}
const YL = { light: "", dark: ".dark" };
function ZL({ id: t, config: e }) {
  const n = Object.entries(e).filter(
    ([, r]) => r.theme || r.color
  );
  return n.length ? /* @__PURE__ */ v(
    "style",
    {
      dangerouslySetInnerHTML: {
        __html: Object.entries(YL).map(
          ([r, i]) => `
${i} [data-chart=${t}] {
${n.map(([o, s]) => {
            var l;
            const a = ((l = s.theme) == null ? void 0 : l[r]) || s.color;
            return a ? `  --color-${o}: ${a};` : null;
          }).join(`
`)}
}
`
        ).join(`
`)
      }
    }
  ) : null;
}
function xE({ id: t, className: e, children: n, config: r, ...i }, o) {
  const s = bS(), a = `chart-${t || s.replace(/:/g, "")}`, l = En(() => ({ config: r }), [r]);
  return /* @__PURE__ */ v(yE.Provider, { value: l, children: /* @__PURE__ */ F(
    "div",
    {
      "data-chart": a,
      ref: o,
      className: I(
        "[&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border flex aspect-video justify-center text-xs [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-none [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-sector]:outline-none [&_.recharts-surface]:outline-none",
        e
      ),
      "data-testid": "asterisk-chart",
      ...i,
      children: [
        /* @__PURE__ */ v(ZL, { id: a, config: r }),
        /* @__PURE__ */ v($L, { children: n })
      ]
    }
  ) });
}
xE.displayName = "Chart";
const JL = ce(xE), kE = Object.assign(JL, {
  TooltipContent: ce(GL),
  LegendContent: ce(KL)
});
kE.TooltipContent.displayName = "Chart.TooltipContent";
kE.LegendContent.displayName = "Chart.LegendContent";
const XL = {
  name: "divider",
  base: ["flex", "w-full", "items-center", "justify-center", "gap-4"],
  config: {}
}, QL = {
  name: "divider-left-side",
  base: ["bg-subtle", "h-px", "w-1/2"],
  config: {}
}, eF = {
  name: "divider-right-side",
  base: ["bg-subtle", "h-px", "w-1/2"],
  config: {}
}, tF = {
  name: "divider-center",
  base: ["text-subtle", "text-xs"],
  config: {}
}, nF = {
  base: ["bg-subtle", "h-px", "w-full"]
};
function um({ className: t, text: e }) {
  return /* @__PURE__ */ v(
    "div",
    {
      className: I("kn-divider", [XL.base], [t]),
      "data-testid": "asterisk-divider",
      children: e ? /* @__PURE__ */ F(je, { children: [
        /* @__PURE__ */ v(
          "div",
          {
            className: QL.base.join(" "),
            "data-testid": "asterisk-divider-left"
          }
        ),
        /* @__PURE__ */ v("span", { className: tF.base.join(" "), "data-testid": "asterisk-divider-text", children: e }),
        /* @__PURE__ */ v(
          "div",
          {
            className: eF.base.join(" "),
            "data-testid": "asterisk-divider-right"
          }
        )
      ] }) : /* @__PURE__ */ v("div", { className: nF.base.join(" "), "data-testid": "asterisk-divider-line" })
    }
  );
}
var rF = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ae = rF.reduce((t, e) => {
  const n = /* @__PURE__ */ mi(`Primitive.${e}`), r = w.forwardRef((i, o) => {
    const { asChild: s, ...a } = i, l = s ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v(l, { ...a, ref: o });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {});
function X0(t, e) {
  t && fs.flushSync(() => t.dispatchEvent(e));
}
var iF = "VisuallyHidden", Ha = w.forwardRef(
  (t, e) => /* @__PURE__ */ v(
    ae.span,
    {
      ...t,
      ref: e,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...t.style
      }
    }
  )
);
Ha.displayName = iF;
var oF = Ha;
function sF(t, e) {
  const n = w.createContext(e), r = (o) => {
    const { children: s, ...a } = o, l = w.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ v(n.Provider, { value: l, children: s });
  };
  r.displayName = t + "Provider";
  function i(o) {
    const s = w.useContext(n);
    if (s) return s;
    if (e !== void 0) return e;
    throw new Error(`\`${o}\` must be used within \`${t}\``);
  }
  return [r, i];
}
function mt(t, e = []) {
  let n = [];
  function r(o, s) {
    const a = w.createContext(s), l = n.length;
    n = [...n, s];
    const c = (d) => {
      var y;
      const { scope: f, children: h, ...p } = d, m = ((y = f == null ? void 0 : f[t]) == null ? void 0 : y[l]) || a, b = w.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ v(m.Provider, { value: b, children: h });
    };
    c.displayName = o + "Provider";
    function u(d, f) {
      var m;
      const h = ((m = f == null ? void 0 : f[t]) == null ? void 0 : m[l]) || a, p = w.useContext(h);
      if (p) return p;
      if (s !== void 0) return s;
      throw new Error(`\`${d}\` must be used within \`${o}\``);
    }
    return [c, u];
  }
  const i = () => {
    const o = n.map((s) => w.createContext(s));
    return function(a) {
      const l = (a == null ? void 0 : a[t]) || o;
      return w.useMemo(
        () => ({ [`__scope${t}`]: { ...a, [t]: l } }),
        [a, l]
      );
    };
  };
  return i.scopeName = t, [r, aF(i, ...e)];
}
function aF(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const n = () => {
    const r = t.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const s = r.reduce((a, { useScope: l, scopeName: c }) => {
        const d = l(o)[`__scope${c}`];
        return { ...a, ...d };
      }, {});
      return w.useMemo(() => ({ [`__scope${e.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
function Wa(t) {
  const e = t + "CollectionProvider", [n, r] = mt(e), [i, o] = n(
    e,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (m) => {
    const { scope: b, children: y } = m, k = he.useRef(null), C = he.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ v(i, { scope: b, itemMap: C, collectionRef: k, children: y });
  };
  s.displayName = e;
  const a = t + "CollectionSlot", l = /* @__PURE__ */ mi(a), c = he.forwardRef(
    (m, b) => {
      const { scope: y, children: k } = m, C = o(a, y), x = Oe(b, C.collectionRef);
      return /* @__PURE__ */ v(l, { ref: x, children: k });
    }
  );
  c.displayName = a;
  const u = t + "CollectionItemSlot", d = "data-radix-collection-item", f = /* @__PURE__ */ mi(u), h = he.forwardRef(
    (m, b) => {
      const { scope: y, children: k, ...C } = m, x = he.useRef(null), S = Oe(b, x), T = o(u, y);
      return he.useEffect(() => (T.itemMap.set(x, { ref: x, ...C }), () => void T.itemMap.delete(x))), /* @__PURE__ */ v(f, { [d]: "", ref: S, children: k });
    }
  );
  h.displayName = u;
  function p(m) {
    const b = o(t + "CollectionConsumer", m);
    return he.useCallback(() => {
      const k = b.collectionRef.current;
      if (!k) return [];
      const C = Array.from(k.querySelectorAll(`[${d}]`));
      return Array.from(b.itemMap.values()).sort(
        (T, E) => C.indexOf(T.ref.current) - C.indexOf(E.ref.current)
      );
    }, [b.collectionRef, b.itemMap]);
  }
  return [
    { Provider: s, Slot: c, ItemSlot: h },
    p,
    r
  ];
}
function Z(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (t == null || t(i), n === !1 || !i.defaultPrevented)
      return e == null ? void 0 : e(i);
  };
}
function wt(t) {
  const e = w.useRef(t);
  return w.useEffect(() => {
    e.current = t;
  }), w.useMemo(() => (...n) => {
    var r;
    return (r = e.current) == null ? void 0 : r.call(e, ...n);
  }, []);
}
function qt({
  prop: t,
  defaultProp: e,
  onChange: n = () => {
  }
}) {
  const [r, i] = lF({ defaultProp: e, onChange: n }), o = t !== void 0, s = o ? t : r, a = wt(n), l = w.useCallback(
    (c) => {
      if (o) {
        const d = typeof c == "function" ? c(t) : c;
        d !== t && a(d);
      } else
        i(c);
    },
    [o, t, i, a]
  );
  return [s, l];
}
function lF({
  defaultProp: t,
  onChange: e
}) {
  const n = w.useState(t), [r] = n, i = w.useRef(r), o = wt(e);
  return w.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [r, i, o]), n;
}
var ft = globalThis != null && globalThis.document ? w.useLayoutEffect : () => {
};
function cF(t, e) {
  return w.useReducer((n, r) => e[n][r] ?? n, t);
}
var Mt = (t) => {
  const { present: e, children: n } = t, r = uF(e), i = typeof n == "function" ? n({ present: r.isPresent }) : w.Children.only(n), o = Oe(r.ref, dF(i));
  return typeof n == "function" || r.isPresent ? w.cloneElement(i, { ref: o }) : null;
};
Mt.displayName = "Presence";
function uF(t) {
  const [e, n] = w.useState(), r = w.useRef({}), i = w.useRef(t), o = w.useRef("none"), s = t ? "mounted" : "unmounted", [a, l] = cF(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return w.useEffect(() => {
    const c = Al(r.current);
    o.current = a === "mounted" ? c : "none";
  }, [a]), ft(() => {
    const c = r.current, u = i.current;
    if (u !== t) {
      const f = o.current, h = Al(c);
      t ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), i.current = t;
    }
  }, [t, l]), ft(() => {
    if (e) {
      let c;
      const u = e.ownerDocument.defaultView ?? window, d = (h) => {
        const m = Al(r.current).includes(h.animationName);
        if (h.target === e && m && (l("ANIMATION_END"), !i.current)) {
          const b = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = b);
          });
        }
      }, f = (h) => {
        h.target === e && (o.current = Al(r.current));
      };
      return e.addEventListener("animationstart", f), e.addEventListener("animationcancel", d), e.addEventListener("animationend", d), () => {
        u.clearTimeout(c), e.removeEventListener("animationstart", f), e.removeEventListener("animationcancel", d), e.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [e, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: w.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function Al(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function dF(t) {
  var r, i;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (i = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : i.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var fF = w[" useId ".trim().toString()] || (() => {
}), hF = 0;
function Ut(t) {
  const [e, n] = w.useState(fF());
  return ft(() => {
    n((r) => r ?? String(hF++));
  }, [t]), t || (e ? `radix-${e}` : "");
}
var Q0 = "Collapsible", [pF, mF] = mt(Q0), [gF, eg] = pF(Q0), tg = w.forwardRef(
  (t, e) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: i,
      disabled: o,
      onOpenChange: s,
      ...a
    } = t, [l = !1, c] = qt({
      prop: r,
      defaultProp: i,
      onChange: s
    });
    return /* @__PURE__ */ v(
      gF,
      {
        scope: n,
        disabled: o,
        contentId: Ut(),
        open: l,
        onOpenToggle: w.useCallback(() => c((u) => !u), [c]),
        children: /* @__PURE__ */ v(
          ae.div,
          {
            "data-state": rg(l),
            "data-disabled": o ? "" : void 0,
            ...a,
            ref: e
          }
        )
      }
    );
  }
);
tg.displayName = Q0;
var CE = "CollapsibleTrigger", ed = w.forwardRef(
  (t, e) => {
    const { __scopeCollapsible: n, ...r } = t, i = eg(CE, n);
    return /* @__PURE__ */ v(
      ae.button,
      {
        type: "button",
        "aria-controls": i.contentId,
        "aria-expanded": i.open || !1,
        "data-state": rg(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        disabled: i.disabled,
        ...r,
        ref: e,
        onClick: Z(t.onClick, i.onOpenToggle)
      }
    );
  }
);
ed.displayName = CE;
var ng = "CollapsibleContent", td = w.forwardRef(
  (t, e) => {
    const { forceMount: n, ...r } = t, i = eg(ng, t.__scopeCollapsible);
    return /* @__PURE__ */ v(Mt, { present: n || i.open, children: ({ present: o }) => /* @__PURE__ */ v(vF, { ...r, ref: e, present: o }) });
  }
);
td.displayName = ng;
var vF = w.forwardRef((t, e) => {
  const { __scopeCollapsible: n, present: r, children: i, ...o } = t, s = eg(ng, n), [a, l] = w.useState(r), c = w.useRef(null), u = Oe(e, c), d = w.useRef(0), f = d.current, h = w.useRef(0), p = h.current, m = s.open || a, b = w.useRef(m), y = w.useRef(void 0);
  return w.useEffect(() => {
    const k = requestAnimationFrame(() => b.current = !1);
    return () => cancelAnimationFrame(k);
  }, []), ft(() => {
    const k = c.current;
    if (k) {
      y.current = y.current || {
        transitionDuration: k.style.transitionDuration,
        animationName: k.style.animationName
      }, k.style.transitionDuration = "0s", k.style.animationName = "none";
      const C = k.getBoundingClientRect();
      d.current = C.height, h.current = C.width, b.current || (k.style.transitionDuration = y.current.transitionDuration, k.style.animationName = y.current.animationName), l(r);
    }
  }, [s.open, r]), /* @__PURE__ */ v(
    ae.div,
    {
      "data-state": rg(s.open),
      "data-disabled": s.disabled ? "" : void 0,
      id: s.contentId,
      hidden: !m,
      ...o,
      ref: u,
      style: {
        "--radix-collapsible-content-height": f ? `${f}px` : void 0,
        "--radix-collapsible-content-width": p ? `${p}px` : void 0,
        ...t.style
      },
      children: m && i
    }
  );
});
function rg(t) {
  return t ? "open" : "closed";
}
var SE = tg, bF = ed, yF = td;
const wF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Collapsible: tg,
  CollapsibleContent: td,
  CollapsibleTrigger: ed,
  Content: yF,
  Root: SE,
  Trigger: bF,
  createCollapsibleScope: mF
}, Symbol.toStringTag, { value: "Module" }));
var xF = w.createContext(void 0);
function ys(t) {
  const e = w.useContext(xF);
  return t || e || "ltr";
}
function kF(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = wt(t);
  w.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return e.addEventListener("keydown", r, { capture: !0 }), () => e.removeEventListener("keydown", r, { capture: !0 });
  }, [n, e]);
}
var CF = "DismissableLayer", dm = "dismissableLayer.update", SF = "dismissableLayer.pointerDownOutside", TF = "dismissableLayer.focusOutside", vw, TE = w.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), po = w.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: s,
      onDismiss: a,
      ...l
    } = t, c = w.useContext(TE), [u, d] = w.useState(null), f = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = w.useState({}), p = Oe(e, (E) => d(E)), m = Array.from(c.layers), [b] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), y = m.indexOf(b), k = u ? m.indexOf(u) : -1, C = c.layersWithOutsidePointerEventsDisabled.size > 0, x = k >= y, S = MF((E) => {
      const M = E.target, O = [...c.branches].some((L) => L.contains(M));
      !x || O || (i == null || i(E), s == null || s(E), E.defaultPrevented || a == null || a());
    }, f), T = OF((E) => {
      const M = E.target;
      [...c.branches].some((L) => L.contains(M)) || (o == null || o(E), s == null || s(E), E.defaultPrevented || a == null || a());
    }, f);
    return kF((E) => {
      k === c.layers.size - 1 && (r == null || r(E), !E.defaultPrevented && a && (E.preventDefault(), a()));
    }, f), w.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (vw = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), bw(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = vw);
        };
    }, [u, f, n, c]), w.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), bw());
    }, [u, c]), w.useEffect(() => {
      const E = () => h({});
      return document.addEventListener(dm, E), () => document.removeEventListener(dm, E);
    }, []), /* @__PURE__ */ v(
      ae.div,
      {
        ...l,
        ref: p,
        style: {
          pointerEvents: C ? x ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: Z(t.onFocusCapture, T.onFocusCapture),
        onBlurCapture: Z(t.onBlurCapture, T.onBlurCapture),
        onPointerDownCapture: Z(
          t.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
po.displayName = CF;
var EF = "DismissableLayerBranch", EE = w.forwardRef((t, e) => {
  const n = w.useContext(TE), r = w.useRef(null), i = Oe(e, r);
  return w.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ v(ae.div, { ...t, ref: i });
});
EE.displayName = EF;
function MF(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = wt(t), r = w.useRef(!1), i = w.useRef(() => {
  });
  return w.useEffect(() => {
    const o = (a) => {
      if (a.target && !r.current) {
        let l = function() {
          ME(
            SF,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: a };
        a.pointerType === "touch" ? (e.removeEventListener("click", i.current), i.current = l, e.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        e.removeEventListener("click", i.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      e.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(s), e.removeEventListener("pointerdown", o), e.removeEventListener("click", i.current);
    };
  }, [e, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function OF(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = wt(t), r = w.useRef(!1);
  return w.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && ME(TF, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", i), () => e.removeEventListener("focusin", i);
  }, [e, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function bw() {
  const t = new CustomEvent(dm);
  document.dispatchEvent(t);
}
function ME(t, e, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: n });
  e && i.addEventListener(t, e, { once: !0 }), r ? X0(i, o) : i.dispatchEvent(o);
}
var AF = po, NF = EE, Dh = "focusScope.autoFocusOnMount", Ih = "focusScope.autoFocusOnUnmount", yw = { bubbles: !1, cancelable: !0 }, RF = "FocusScope", ja = w.forwardRef((t, e) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o,
    ...s
  } = t, [a, l] = w.useState(null), c = wt(i), u = wt(o), d = w.useRef(null), f = Oe(e, (m) => l(m)), h = w.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  w.useEffect(() => {
    if (r) {
      let m = function(C) {
        if (h.paused || !a) return;
        const x = C.target;
        a.contains(x) ? d.current = x : Kr(d.current, { select: !0 });
      }, b = function(C) {
        if (h.paused || !a) return;
        const x = C.relatedTarget;
        x !== null && (a.contains(x) || Kr(d.current, { select: !0 }));
      }, y = function(C) {
        if (document.activeElement === document.body)
          for (const S of C)
            S.removedNodes.length > 0 && Kr(a);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", b);
      const k = new MutationObserver(y);
      return a && k.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", b), k.disconnect();
      };
    }
  }, [r, a, h.paused]), w.useEffect(() => {
    if (a) {
      xw.add(h);
      const m = document.activeElement;
      if (!a.contains(m)) {
        const y = new CustomEvent(Dh, yw);
        a.addEventListener(Dh, c), a.dispatchEvent(y), y.defaultPrevented || (DF(FF(OE(a)), { select: !0 }), document.activeElement === m && Kr(a));
      }
      return () => {
        a.removeEventListener(Dh, c), setTimeout(() => {
          const y = new CustomEvent(Ih, yw);
          a.addEventListener(Ih, u), a.dispatchEvent(y), y.defaultPrevented || Kr(m ?? document.body, { select: !0 }), a.removeEventListener(Ih, u), xw.remove(h);
        }, 0);
      };
    }
  }, [a, c, u, h]);
  const p = w.useCallback(
    (m) => {
      if (!n && !r || h.paused) return;
      const b = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, y = document.activeElement;
      if (b && y) {
        const k = m.currentTarget, [C, x] = IF(k);
        C && x ? !m.shiftKey && y === x ? (m.preventDefault(), n && Kr(C, { select: !0 })) : m.shiftKey && y === C && (m.preventDefault(), n && Kr(x, { select: !0 })) : y === k && m.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ v(ae.div, { tabIndex: -1, ...s, ref: f, onKeyDown: p });
});
ja.displayName = RF;
function DF(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (Kr(r, { select: e }), document.activeElement !== n) return;
}
function IF(t) {
  const e = OE(t), n = ww(e, t), r = ww(e.reverse(), t);
  return [n, r];
}
function OE(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
function ww(t, e) {
  for (const n of t)
    if (!_F(n, { upTo: e })) return n;
}
function _F(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden") return !0;
  for (; t; ) {
    if (e !== void 0 && t === e) return !1;
    if (getComputedStyle(t).display === "none") return !0;
    t = t.parentElement;
  }
  return !1;
}
function PF(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Kr(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({ preventScroll: !0 }), t !== n && PF(t) && e && t.select();
  }
}
var xw = LF();
function LF() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = kw(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = kw(t, e), (n = t[0]) == null || n.resume();
    }
  };
}
function kw(t, e) {
  const n = [...t], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function FF(t) {
  return t.filter((e) => e.tagName !== "A");
}
var $F = "Portal", mo = w.forwardRef((t, e) => {
  var a;
  const { container: n, ...r } = t, [i, o] = w.useState(!1);
  ft(() => o(!0), []);
  const s = n || i && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return s ? wS.createPortal(/* @__PURE__ */ v(ae.div, { ...r, ref: e }), s) : null;
});
mo.displayName = $F;
var _h = 0;
function nd() {
  w.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? Cw()), document.body.insertAdjacentElement("beforeend", t[1] ?? Cw()), _h++, () => {
      _h === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), _h--;
    };
  }, []);
}
function Cw() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
var nr = function() {
  return nr = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, nr.apply(this, arguments);
};
function AE(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function BF(t, e, n) {
  if (n || arguments.length === 2) for (var r = 0, i = e.length, o; r < i; r++)
    (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return t.concat(o || Array.prototype.slice.call(e));
}
var ac = "right-scroll-bar-position", lc = "width-before-scroll-bar", VF = "with-scroll-bars-hidden", zF = "--removed-body-scroll-bar-size";
function Ph(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function HF(t, e) {
  var n = pe(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = e, n.facade;
}
var WF = typeof window < "u" ? w.useLayoutEffect : w.useEffect, Sw = /* @__PURE__ */ new WeakMap();
function jF(t, e) {
  var n = HF(null, function(r) {
    return t.forEach(function(i) {
      return Ph(i, r);
    });
  });
  return WF(function() {
    var r = Sw.get(n);
    if (r) {
      var i = new Set(r), o = new Set(t), s = n.current;
      i.forEach(function(a) {
        o.has(a) || Ph(a, null);
      }), o.forEach(function(a) {
        i.has(a) || Ph(a, s);
      });
    }
    Sw.set(n, t);
  }, [t]), n;
}
function UF(t) {
  return t;
}
function qF(t, e) {
  e === void 0 && (e = UF);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : t;
    },
    useMedium: function(o) {
      var s = e(o, r);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(o);
      }
      n = {
        push: function(a) {
          return o(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(o), s = n;
      }
      var l = function() {
        var u = s;
        s = [], u.forEach(o);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          s.push(u), c();
        },
        filter: function(u) {
          return s = s.filter(u), n;
        }
      };
    }
  };
  return i;
}
function KF(t) {
  t === void 0 && (t = {});
  var e = qF(null);
  return e.options = nr({ async: !0, ssr: !1 }, t), e;
}
var NE = function(t) {
  var e = t.sideCar, n = AE(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = e.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return w.createElement(r, nr({}, n));
};
NE.isSideCarExport = !0;
function GF(t, e) {
  return t.useMedium(e), NE;
}
var RE = KF(), Lh = function() {
}, rd = w.forwardRef(function(t, e) {
  var n = w.useRef(null), r = w.useState({
    onScrollCapture: Lh,
    onWheelCapture: Lh,
    onTouchMoveCapture: Lh
  }), i = r[0], o = r[1], s = t.forwardProps, a = t.children, l = t.className, c = t.removeScrollBar, u = t.enabled, d = t.shards, f = t.sideCar, h = t.noIsolation, p = t.inert, m = t.allowPinchZoom, b = t.as, y = b === void 0 ? "div" : b, k = t.gapMode, C = AE(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), x = f, S = jF([n, e]), T = nr(nr({}, C), i);
  return w.createElement(
    w.Fragment,
    null,
    u && w.createElement(x, { sideCar: RE, removeScrollBar: c, shards: d, noIsolation: h, inert: p, setCallbacks: o, allowPinchZoom: !!m, lockRef: n, gapMode: k }),
    s ? w.cloneElement(w.Children.only(a), nr(nr({}, T), { ref: S })) : w.createElement(y, nr({}, T, { className: l, ref: S }), a)
  );
});
rd.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
rd.classNames = {
  fullWidth: lc,
  zeroRight: ac
};
var YF = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function ZF() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = YF();
  return e && t.setAttribute("nonce", e), t;
}
function JF(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function XF(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var QF = function() {
  var t = 0, e = null;
  return {
    add: function(n) {
      t == 0 && (e = ZF()) && (JF(e, n), XF(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, e8 = function() {
  var t = QF();
  return function(e, n) {
    w.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && n]);
  };
}, DE = function() {
  var t = e8(), e = function(n) {
    var r = n.styles, i = n.dynamic;
    return t(r, i), null;
  };
  return e;
}, t8 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Fh = function(t) {
  return parseInt(t || "", 10) || 0;
}, n8 = function(t) {
  var e = window.getComputedStyle(document.body), n = e[t === "padding" ? "paddingLeft" : "marginLeft"], r = e[t === "padding" ? "paddingTop" : "marginTop"], i = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [Fh(n), Fh(r), Fh(i)];
}, r8 = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return t8;
  var e = n8(t), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, r - n + e[2] - e[0])
  };
}, i8 = DE(), jo = "data-scroll-locked", o8 = function(t, e, n, r) {
  var i = t.left, o = t.top, s = t.right, a = t.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(VF, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(jo, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ac, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(lc, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(ac, " .").concat(ac, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(lc, " .").concat(lc, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(jo, `] {
    `).concat(zF, ": ").concat(a, `px;
  }
`);
}, Tw = function() {
  var t = parseInt(document.body.getAttribute(jo) || "0", 10);
  return isFinite(t) ? t : 0;
}, s8 = function() {
  w.useEffect(function() {
    return document.body.setAttribute(jo, (Tw() + 1).toString()), function() {
      var t = Tw() - 1;
      t <= 0 ? document.body.removeAttribute(jo) : document.body.setAttribute(jo, t.toString());
    };
  }, []);
}, a8 = function(t) {
  var e = t.noRelative, n = t.noImportant, r = t.gapMode, i = r === void 0 ? "margin" : r;
  s8();
  var o = w.useMemo(function() {
    return r8(i);
  }, [i]);
  return w.createElement(i8, { styles: o8(o, !e, i, n ? "" : "!important") });
}, fm = !1;
if (typeof window < "u")
  try {
    var Nl = Object.defineProperty({}, "passive", {
      get: function() {
        return fm = !0, !0;
      }
    });
    window.addEventListener("test", Nl, Nl), window.removeEventListener("test", Nl, Nl);
  } catch {
    fm = !1;
  }
var Eo = fm ? { passive: !1 } : !1, l8 = function(t) {
  return t.tagName === "TEXTAREA";
}, IE = function(t, e) {
  if (!(t instanceof Element))
    return !1;
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !l8(t) && n[e] === "visible")
  );
}, c8 = function(t) {
  return IE(t, "overflowY");
}, u8 = function(t) {
  return IE(t, "overflowX");
}, Ew = function(t, e) {
  var n = e.ownerDocument, r = e;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = _E(t, r);
    if (i) {
      var o = PE(t, r), s = o[1], a = o[2];
      if (s > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, d8 = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, r = t.clientHeight;
  return [
    e,
    n,
    r
  ];
}, f8 = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, r = t.clientWidth;
  return [
    e,
    n,
    r
  ];
}, _E = function(t, e) {
  return t === "v" ? c8(e) : u8(e);
}, PE = function(t, e) {
  return t === "v" ? d8(e) : f8(e);
}, h8 = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, p8 = function(t, e, n, r, i) {
  var o = h8(t, window.getComputedStyle(e).direction), s = o * r, a = n.target, l = e.contains(a), c = !1, u = s > 0, d = 0, f = 0;
  do {
    var h = PE(t, a), p = h[0], m = h[1], b = h[2], y = m - b - o * p;
    (p || y) && _E(t, a) && (d += y, f += p), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (e.contains(a) || e === a)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(f) < 1) && (c = !0), c;
}, Rl = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, Mw = function(t) {
  return [t.deltaX, t.deltaY];
}, Ow = function(t) {
  return t && "current" in t ? t.current : t;
}, m8 = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, g8 = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, v8 = 0, Mo = [];
function b8(t) {
  var e = w.useRef([]), n = w.useRef([0, 0]), r = w.useRef(), i = w.useState(v8++)[0], o = w.useState(DE)[0], s = w.useRef(t);
  w.useEffect(function() {
    s.current = t;
  }, [t]), w.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var m = BF([t.lockRef.current], (t.shards || []).map(Ow), !0).filter(Boolean);
      return m.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), m.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var a = w.useCallback(function(m, b) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !s.current.allowPinchZoom;
    var y = Rl(m), k = n.current, C = "deltaX" in m ? m.deltaX : k[0] - y[0], x = "deltaY" in m ? m.deltaY : k[1] - y[1], S, T = m.target, E = Math.abs(C) > Math.abs(x) ? "h" : "v";
    if ("touches" in m && E === "h" && T.type === "range")
      return !1;
    var M = Ew(E, T);
    if (!M)
      return !0;
    if (M ? S = E : (S = E === "v" ? "h" : "v", M = Ew(E, T)), !M)
      return !1;
    if (!r.current && "changedTouches" in m && (C || x) && (r.current = S), !S)
      return !0;
    var O = r.current || S;
    return p8(O, b, m, O === "h" ? C : x);
  }, []), l = w.useCallback(function(m) {
    var b = m;
    if (!(!Mo.length || Mo[Mo.length - 1] !== o)) {
      var y = "deltaY" in b ? Mw(b) : Rl(b), k = e.current.filter(function(S) {
        return S.name === b.type && (S.target === b.target || b.target === S.shadowParent) && m8(S.delta, y);
      })[0];
      if (k && k.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!k) {
        var C = (s.current.shards || []).map(Ow).filter(Boolean).filter(function(S) {
          return S.contains(b.target);
        }), x = C.length > 0 ? a(b, C[0]) : !s.current.noIsolation;
        x && b.cancelable && b.preventDefault();
      }
    }
  }, []), c = w.useCallback(function(m, b, y, k) {
    var C = { name: m, delta: b, target: y, should: k, shadowParent: y8(y) };
    e.current.push(C), setTimeout(function() {
      e.current = e.current.filter(function(x) {
        return x !== C;
      });
    }, 1);
  }, []), u = w.useCallback(function(m) {
    n.current = Rl(m), r.current = void 0;
  }, []), d = w.useCallback(function(m) {
    c(m.type, Mw(m), m.target, a(m, t.lockRef.current));
  }, []), f = w.useCallback(function(m) {
    c(m.type, Rl(m), m.target, a(m, t.lockRef.current));
  }, []);
  w.useEffect(function() {
    return Mo.push(o), t.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, Eo), document.addEventListener("touchmove", l, Eo), document.addEventListener("touchstart", u, Eo), function() {
      Mo = Mo.filter(function(m) {
        return m !== o;
      }), document.removeEventListener("wheel", l, Eo), document.removeEventListener("touchmove", l, Eo), document.removeEventListener("touchstart", u, Eo);
    };
  }, []);
  var h = t.removeScrollBar, p = t.inert;
  return w.createElement(
    w.Fragment,
    null,
    p ? w.createElement(o, { styles: g8(i) }) : null,
    h ? w.createElement(a8, { gapMode: t.gapMode }) : null
  );
}
function y8(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const w8 = GF(RE, b8);
var Ua = w.forwardRef(function(t, e) {
  return w.createElement(rd, nr({}, t, { ref: e, sideCar: w8 }));
});
Ua.classNames = rd.classNames;
var x8 = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, Oo = /* @__PURE__ */ new WeakMap(), Dl = /* @__PURE__ */ new WeakMap(), Il = {}, $h = 0, LE = function(t) {
  return t && (t.host || LE(t.parentNode));
}, k8 = function(t, e) {
  return e.map(function(n) {
    if (t.contains(n))
      return n;
    var r = LE(n);
    return r && t.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, C8 = function(t, e, n, r) {
  var i = k8(e, Array.isArray(t) ? t : [t]);
  Il[n] || (Il[n] = /* @__PURE__ */ new WeakMap());
  var o = Il[n], s = [], a = /* @__PURE__ */ new Set(), l = new Set(i), c = function(d) {
    !d || a.has(d) || (a.add(d), c(d.parentNode));
  };
  i.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (a.has(f))
        u(f);
      else
        try {
          var h = f.getAttribute(r), p = h !== null && h !== "false", m = (Oo.get(f) || 0) + 1, b = (o.get(f) || 0) + 1;
          Oo.set(f, m), o.set(f, b), s.push(f), m === 1 && p && Dl.set(f, !0), b === 1 && f.setAttribute(n, "true"), p || f.setAttribute(r, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", f, y);
        }
    });
  };
  return u(e), a.clear(), $h++, function() {
    s.forEach(function(d) {
      var f = Oo.get(d) - 1, h = o.get(d) - 1;
      Oo.set(d, f), o.set(d, h), f || (Dl.has(d) || d.removeAttribute(r), Dl.delete(d)), h || d.removeAttribute(n);
    }), $h--, $h || (Oo = /* @__PURE__ */ new WeakMap(), Oo = /* @__PURE__ */ new WeakMap(), Dl = /* @__PURE__ */ new WeakMap(), Il = {});
  };
}, id = function(t, e, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(t) ? t : [t]), i = x8(t);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), C8(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, ig = "Dialog", [FE, S8] = mt(ig), [T8, Zn] = FE(ig), og = (t) => {
  const {
    __scopeDialog: e,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    modal: s = !0
  } = t, a = w.useRef(null), l = w.useRef(null), [c = !1, u] = qt({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ v(
    T8,
    {
      scope: e,
      triggerRef: a,
      contentRef: l,
      contentId: Ut(),
      titleId: Ut(),
      descriptionId: Ut(),
      open: c,
      onOpenChange: u,
      onOpenToggle: w.useCallback(() => u((d) => !d), [u]),
      modal: s,
      children: n
    }
  );
};
og.displayName = ig;
var $E = "DialogTrigger", sg = w.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = Zn($E, n), o = Oe(e, i.triggerRef);
    return /* @__PURE__ */ v(
      ae.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": mg(i.open),
        ...r,
        ref: o,
        onClick: Z(t.onClick, i.onOpenToggle)
      }
    );
  }
);
sg.displayName = $E;
var ag = "DialogPortal", [E8, BE] = FE(ag, {
  forceMount: void 0
}), lg = (t) => {
  const { __scopeDialog: e, forceMount: n, children: r, container: i } = t, o = Zn(ag, e);
  return /* @__PURE__ */ v(E8, { scope: e, forceMount: n, children: w.Children.map(r, (s) => /* @__PURE__ */ v(Mt, { present: n || o.open, children: /* @__PURE__ */ v(mo, { asChild: !0, container: i, children: s }) })) });
};
lg.displayName = ag;
var Dc = "DialogOverlay", cg = w.forwardRef(
  (t, e) => {
    const n = BE(Dc, t.__scopeDialog), { forceMount: r = n.forceMount, ...i } = t, o = Zn(Dc, t.__scopeDialog);
    return o.modal ? /* @__PURE__ */ v(Mt, { present: r || o.open, children: /* @__PURE__ */ v(O8, { ...i, ref: e }) }) : null;
  }
);
cg.displayName = Dc;
var M8 = /* @__PURE__ */ mi("DialogOverlay.RemoveScroll"), O8 = w.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = Zn(Dc, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ v(Ua, { as: M8, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ v(
        ae.div,
        {
          "data-state": mg(i.open),
          ...r,
          ref: e,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), to = "DialogContent", ug = w.forwardRef(
  (t, e) => {
    const n = BE(to, t.__scopeDialog), { forceMount: r = n.forceMount, ...i } = t, o = Zn(to, t.__scopeDialog);
    return /* @__PURE__ */ v(Mt, { present: r || o.open, children: o.modal ? /* @__PURE__ */ v(A8, { ...i, ref: e }) : /* @__PURE__ */ v(N8, { ...i, ref: e }) });
  }
);
ug.displayName = to;
var A8 = w.forwardRef(
  (t, e) => {
    const n = Zn(to, t.__scopeDialog), r = w.useRef(null), i = Oe(e, n.contentRef, r);
    return w.useEffect(() => {
      const o = r.current;
      if (o) return id(o);
    }, []), /* @__PURE__ */ v(
      VE,
      {
        ...t,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Z(t.onCloseAutoFocus, (o) => {
          var s;
          o.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: Z(t.onPointerDownOutside, (o) => {
          const s = o.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || a) && o.preventDefault();
        }),
        onFocusOutside: Z(
          t.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), N8 = w.forwardRef(
  (t, e) => {
    const n = Zn(to, t.__scopeDialog), r = w.useRef(!1), i = w.useRef(!1);
    return /* @__PURE__ */ v(
      VE,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var s, a;
          (s = t.onCloseAutoFocus) == null || s.call(t, o), o.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), o.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (o) => {
          var l, c;
          (l = t.onInteractOutside) == null || l.call(t, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const s = o.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(s)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
        }
      }
    );
  }
), VE = w.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, ...s } = t, a = Zn(to, n), l = w.useRef(null), c = Oe(e, l);
    return nd(), /* @__PURE__ */ F(je, { children: [
      /* @__PURE__ */ v(
        ja,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ v(
            po,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": mg(a.open),
              ...s,
              ref: c,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ F(je, { children: [
        /* @__PURE__ */ v(D8, { titleId: a.titleId }),
        /* @__PURE__ */ v(_8, { contentRef: l, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), dg = "DialogTitle", fg = w.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = Zn(dg, n);
    return /* @__PURE__ */ v(ae.h2, { id: i.titleId, ...r, ref: e });
  }
);
fg.displayName = dg;
var zE = "DialogDescription", hg = w.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = Zn(zE, n);
    return /* @__PURE__ */ v(ae.p, { id: i.descriptionId, ...r, ref: e });
  }
);
hg.displayName = zE;
var HE = "DialogClose", pg = w.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, i = Zn(HE, n);
    return /* @__PURE__ */ v(
      ae.button,
      {
        type: "button",
        ...r,
        ref: e,
        onClick: Z(t.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
pg.displayName = HE;
function mg(t) {
  return t ? "open" : "closed";
}
var WE = "DialogTitleWarning", [R8, jE] = sF(WE, {
  contentName: to,
  titleName: dg,
  docsSlug: "dialog"
}), D8 = ({ titleId: t }) => {
  const e = jE(WE), n = `\`${e.contentName}\` requires a \`${e.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${e.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${e.docsSlug}`;
  return w.useEffect(() => {
    t && (document.getElementById(t) || console.error(n));
  }, [n, t]), null;
}, I8 = "DialogDescriptionWarning", _8 = ({ contentRef: t, descriptionId: e }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${jE(I8).contentName}}.`;
  return w.useEffect(() => {
    var o;
    const i = (o = t.current) == null ? void 0 : o.getAttribute("aria-describedby");
    e && i && (document.getElementById(e) || console.warn(r));
  }, [r, t, e]), null;
}, UE = og, P8 = sg, qE = lg, KE = cg, GE = ug, YE = fg, ZE = hg, JE = pg;
const L8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Close: JE,
  Content: GE,
  Description: ZE,
  Dialog: og,
  DialogClose: pg,
  DialogContent: ug,
  DialogDescription: hg,
  DialogOverlay: cg,
  DialogPortal: lg,
  DialogTitle: fg,
  DialogTrigger: sg,
  Overlay: KE,
  Portal: qE,
  Root: UE,
  Title: YE,
  Trigger: P8,
  WarningProvider: R8,
  createDialogScope: S8
}, Symbol.toStringTag, { value: "Module" }));
var gg = "Avatar", [F8, _oe] = mt(gg), [$8, XE] = F8(gg), QE = w.forwardRef(
  (t, e) => {
    const { __scopeAvatar: n, ...r } = t, [i, o] = w.useState("idle");
    return /* @__PURE__ */ v(
      $8,
      {
        scope: n,
        imageLoadingStatus: i,
        onImageLoadingStatusChange: o,
        children: /* @__PURE__ */ v(ae.span, { ...r, ref: e })
      }
    );
  }
);
QE.displayName = gg;
var e2 = "AvatarImage", t2 = w.forwardRef(
  (t, e) => {
    const { __scopeAvatar: n, src: r, onLoadingStatusChange: i = () => {
    }, ...o } = t, s = XE(e2, n), a = B8(r, o), l = wt((c) => {
      i(c), s.onImageLoadingStatusChange(c);
    });
    return ft(() => {
      a !== "idle" && l(a);
    }, [a, l]), a === "loaded" ? /* @__PURE__ */ v(ae.img, { ...o, ref: e, src: r }) : null;
  }
);
t2.displayName = e2;
var n2 = "AvatarFallback", r2 = w.forwardRef(
  (t, e) => {
    const { __scopeAvatar: n, delayMs: r, ...i } = t, o = XE(n2, n), [s, a] = w.useState(r === void 0);
    return w.useEffect(() => {
      if (r !== void 0) {
        const l = window.setTimeout(() => a(!0), r);
        return () => window.clearTimeout(l);
      }
    }, [r]), s && o.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ v(ae.span, { ...i, ref: e }) : null;
  }
);
r2.displayName = n2;
function Aw(t, e) {
  return t ? e ? (t.src !== e && (t.src = e), t.complete && t.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function B8(t, { referrerPolicy: e, crossOrigin: n }) {
  const r = z8(), i = w.useRef(null), o = r ? (i.current || (i.current = new window.Image()), i.current) : null, [s, a] = w.useState(
    () => Aw(o, t)
  );
  return ft(() => {
    a(Aw(o, t));
  }, [o, t]), ft(() => {
    const l = (d) => () => {
      a(d);
    };
    if (!o) return;
    const c = l("loaded"), u = l("error");
    return o.addEventListener("load", c), o.addEventListener("error", u), e && (o.referrerPolicy = e), typeof n == "string" && (o.crossOrigin = n), () => {
      o.removeEventListener("load", c), o.removeEventListener("error", u);
    };
  }, [o, n, e]), s;
}
function V8() {
  return () => {
  };
}
function z8() {
  return w.useSyncExternalStore(
    V8,
    () => !0,
    () => !1
  );
}
var H8 = QE, W8 = t2, j8 = r2;
function qa(t) {
  const e = w.useRef({ value: t, previous: t });
  return w.useMemo(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [t]);
}
function Ka(t) {
  const [e, n] = w.useState(void 0);
  return ft(() => {
    if (t) {
      n({ width: t.offsetWidth, height: t.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let s, a;
        if ("borderBoxSize" in o) {
          const l = o.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          s = c.inlineSize, a = c.blockSize;
        } else
          s = t.offsetWidth, a = t.offsetHeight;
        n({ width: s, height: a });
      });
      return r.observe(t, { box: "border-box" }), () => r.unobserve(t);
    } else
      n(void 0);
  }, [t]), e;
}
var vg = "Checkbox", [U8, Poe] = mt(vg), [q8, K8] = U8(vg), i2 = w.forwardRef(
  (t, e) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: i,
      defaultChecked: o,
      required: s,
      disabled: a,
      value: l = "on",
      onCheckedChange: c,
      form: u,
      ...d
    } = t, [f, h] = w.useState(null), p = Oe(e, (x) => h(x)), m = w.useRef(!1), b = f ? u || !!f.closest("form") : !0, [y = !1, k] = qt({
      prop: i,
      defaultProp: o,
      onChange: c
    }), C = w.useRef(y);
    return w.useEffect(() => {
      const x = f == null ? void 0 : f.form;
      if (x) {
        const S = () => k(C.current);
        return x.addEventListener("reset", S), () => x.removeEventListener("reset", S);
      }
    }, [f, k]), /* @__PURE__ */ F(q8, { scope: n, state: y, disabled: a, children: [
      /* @__PURE__ */ v(
        ae.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": ci(y) ? "mixed" : y,
          "aria-required": s,
          "data-state": a2(y),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: l,
          ...d,
          ref: p,
          onKeyDown: Z(t.onKeyDown, (x) => {
            x.key === "Enter" && x.preventDefault();
          }),
          onClick: Z(t.onClick, (x) => {
            k((S) => ci(S) ? !0 : !S), b && (m.current = x.isPropagationStopped(), m.current || x.stopPropagation());
          })
        }
      ),
      b && /* @__PURE__ */ v(
        G8,
        {
          control: f,
          bubbles: !m.current,
          name: r,
          value: l,
          checked: y,
          required: s,
          disabled: a,
          form: u,
          style: { transform: "translateX(-100%)" },
          defaultChecked: ci(o) ? !1 : o
        }
      )
    ] });
  }
);
i2.displayName = vg;
var o2 = "CheckboxIndicator", s2 = w.forwardRef(
  (t, e) => {
    const { __scopeCheckbox: n, forceMount: r, ...i } = t, o = K8(o2, n);
    return /* @__PURE__ */ v(Mt, { present: r || ci(o.state) || o.state === !0, children: /* @__PURE__ */ v(
      ae.span,
      {
        "data-state": a2(o.state),
        "data-disabled": o.disabled ? "" : void 0,
        ...i,
        ref: e,
        style: { pointerEvents: "none", ...t.style }
      }
    ) });
  }
);
s2.displayName = o2;
var G8 = (t) => {
  const { control: e, checked: n, bubbles: r = !0, defaultChecked: i, ...o } = t, s = w.useRef(null), a = qa(n), l = Ka(e);
  w.useEffect(() => {
    const u = s.current, d = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(d, "checked").set;
    if (a !== n && h) {
      const p = new Event("click", { bubbles: r });
      u.indeterminate = ci(n), h.call(u, ci(n) ? !1 : n), u.dispatchEvent(p);
    }
  }, [a, n, r]);
  const c = w.useRef(ci(n) ? !1 : n);
  return /* @__PURE__ */ v(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: i ?? c.current,
      ...o,
      tabIndex: -1,
      ref: s,
      style: {
        ...t.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function ci(t) {
  return t === "indeterminate";
}
function a2(t) {
  return ci(t) ? "indeterminate" : t ? "checked" : "unchecked";
}
var Y8 = i2, Z8 = s2;
const J8 = ["top", "right", "bottom", "left"], gi = Math.min, an = Math.max, Ic = Math.round, _l = Math.floor, ar = (t) => ({
  x: t,
  y: t
}), X8 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Q8 = {
  start: "end",
  end: "start"
};
function hm(t, e, n) {
  return an(t, gi(e, n));
}
function Lr(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Fr(t) {
  return t.split("-")[0];
}
function ws(t) {
  return t.split("-")[1];
}
function bg(t) {
  return t === "x" ? "y" : "x";
}
function yg(t) {
  return t === "y" ? "height" : "width";
}
function vi(t) {
  return ["top", "bottom"].includes(Fr(t)) ? "y" : "x";
}
function wg(t) {
  return bg(vi(t));
}
function e9(t, e, n) {
  n === void 0 && (n = !1);
  const r = ws(t), i = wg(t), o = yg(i);
  let s = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[o] > e.floating[o] && (s = _c(s)), [s, _c(s)];
}
function t9(t) {
  const e = _c(t);
  return [pm(t), e, pm(e)];
}
function pm(t) {
  return t.replace(/start|end/g, (e) => Q8[e]);
}
function n9(t, e, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], s = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? i : r : e ? r : i;
    case "left":
    case "right":
      return e ? o : s;
    default:
      return [];
  }
}
function r9(t, e, n, r) {
  const i = ws(t);
  let o = n9(Fr(t), n === "start", r);
  return i && (o = o.map((s) => s + "-" + i), e && (o = o.concat(o.map(pm)))), o;
}
function _c(t) {
  return t.replace(/left|right|bottom|top/g, (e) => X8[e]);
}
function i9(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function l2(t) {
  return typeof t != "number" ? i9(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Pc(t) {
  const {
    x: e,
    y: n,
    width: r,
    height: i
  } = t;
  return {
    width: r,
    height: i,
    top: n,
    left: e,
    right: e + r,
    bottom: n + i,
    x: e,
    y: n
  };
}
function Nw(t, e, n) {
  let {
    reference: r,
    floating: i
  } = t;
  const o = vi(e), s = wg(e), a = yg(s), l = Fr(e), c = o === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[a] / 2 - i[a] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - i.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (ws(e)) {
    case "start":
      h[s] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      h[s] += f * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const o9 = async (t, e, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: s
  } = n, a = o.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let c = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: u,
    y: d
  } = Nw(c, r, l), f = r, h = {}, p = 0;
  for (let m = 0; m < a.length; m++) {
    const {
      name: b,
      fn: y
    } = a[m], {
      x: k,
      y: C,
      data: x,
      reset: S
    } = await y({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: i,
      middlewareData: h,
      rects: c,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    u = k ?? u, d = C ?? d, h = {
      ...h,
      [b]: {
        ...h[b],
        ...x
      }
    }, S && p <= 50 && (p++, typeof S == "object" && (S.placement && (f = S.placement), S.rects && (c = S.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : S.rects), {
      x: u,
      y: d
    } = Nw(c, f, l)), m = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: i,
    middlewareData: h
  };
};
async function fa(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: s,
    elements: a,
    strategy: l
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = Lr(e, t), p = l2(h), b = a[f ? d === "floating" ? "reference" : "floating" : d], y = Pc(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(b))) == null || n ? b : b.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), k = d === "floating" ? {
    x: r,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, C = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(a.floating)), x = await (o.isElement == null ? void 0 : o.isElement(C)) ? await (o.getScale == null ? void 0 : o.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = Pc(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: k,
    offsetParent: C,
    strategy: l
  }) : k);
  return {
    top: (y.top - S.top + p.top) / x.y,
    bottom: (S.bottom - y.bottom + p.bottom) / x.y,
    left: (y.left - S.left + p.left) / x.x,
    right: (S.right - y.right + p.right) / x.x
  };
}
const s9 = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: s,
      elements: a,
      middlewareData: l
    } = e, {
      element: c,
      padding: u = 0
    } = Lr(t, e) || {};
    if (c == null)
      return {};
    const d = l2(u), f = {
      x: n,
      y: r
    }, h = wg(i), p = yg(h), m = await s.getDimensions(c), b = h === "y", y = b ? "top" : "left", k = b ? "bottom" : "right", C = b ? "clientHeight" : "clientWidth", x = o.reference[p] + o.reference[h] - f[h] - o.floating[p], S = f[h] - o.reference[h], T = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let E = T ? T[C] : 0;
    (!E || !await (s.isElement == null ? void 0 : s.isElement(T))) && (E = a.floating[C] || o.floating[p]);
    const M = x / 2 - S / 2, O = E / 2 - m[p] / 2 - 1, L = gi(d[y], O), $ = gi(d[k], O), z = L, B = E - m[p] - $, A = E / 2 - m[p] / 2 + M, N = hm(z, A, B), R = !l.arrow && ws(i) != null && A !== N && o.reference[p] / 2 - (A < z ? L : $) - m[p] / 2 < 0, _ = R ? A < z ? A - z : A - B : 0;
    return {
      [h]: f[h] + _,
      data: {
        [h]: N,
        centerOffset: A - N - _,
        ...R && {
          alignmentOffset: _
        }
      },
      reset: R
    };
  }
}), a9 = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: s,
        initialPlacement: a,
        platform: l,
        elements: c
      } = e, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: m = !0,
        ...b
      } = Lr(t, e);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const y = Fr(i), k = vi(a), C = Fr(a) === a, x = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), S = f || (C || !m ? [_c(a)] : t9(a)), T = p !== "none";
      !f && T && S.push(...r9(a, m, p, x));
      const E = [a, ...S], M = await fa(e, b), O = [];
      let L = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (u && O.push(M[y]), d) {
        const A = e9(i, s, x);
        O.push(M[A[0]], M[A[1]]);
      }
      if (L = [...L, {
        placement: i,
        overflows: O
      }], !O.every((A) => A <= 0)) {
        var $, z;
        const A = ((($ = o.flip) == null ? void 0 : $.index) || 0) + 1, N = E[A];
        if (N)
          return {
            data: {
              index: A,
              overflows: L
            },
            reset: {
              placement: N
            }
          };
        let R = (z = L.filter((_) => _.overflows[0] <= 0).sort((_, D) => _.overflows[1] - D.overflows[1])[0]) == null ? void 0 : z.placement;
        if (!R)
          switch (h) {
            case "bestFit": {
              var B;
              const _ = (B = L.filter((D) => {
                if (T) {
                  const q = vi(D.placement);
                  return q === k || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  q === "y";
                }
                return !0;
              }).map((D) => [D.placement, D.overflows.filter((q) => q > 0).reduce((q, V) => q + V, 0)]).sort((D, q) => D[1] - q[1])[0]) == null ? void 0 : B[0];
              _ && (R = _);
              break;
            }
            case "initialPlacement":
              R = a;
              break;
          }
        if (i !== R)
          return {
            reset: {
              placement: R
            }
          };
      }
      return {};
    }
  };
};
function Rw(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function Dw(t) {
  return J8.some((e) => t[e] >= 0);
}
const l9 = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: r = "referenceHidden",
        ...i
      } = Lr(t, e);
      switch (r) {
        case "referenceHidden": {
          const o = await fa(e, {
            ...i,
            elementContext: "reference"
          }), s = Rw(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Dw(s)
            }
          };
        }
        case "escaped": {
          const o = await fa(e, {
            ...i,
            altBoundary: !0
          }), s = Rw(o, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Dw(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function c9(t, e) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = t, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), s = Fr(n), a = ws(n), l = vi(n) === "y", c = ["left", "top"].includes(s) ? -1 : 1, u = o && l ? -1 : 1, d = Lr(e, t);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: p
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return a && typeof p == "number" && (h = a === "end" ? p * -1 : p), l ? {
    x: h * u,
    y: f * c
  } : {
    x: f * c,
    y: h * u
  };
}
const u9 = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: s,
        middlewareData: a
      } = e, l = await c9(e, t);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: i + l.x,
        y: o + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, d9 = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r,
        placement: i
      } = e, {
        mainAxis: o = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (b) => {
            let {
              x: y,
              y: k
            } = b;
            return {
              x: y,
              y: k
            };
          }
        },
        ...l
      } = Lr(t, e), c = {
        x: n,
        y: r
      }, u = await fa(e, l), d = vi(Fr(i)), f = bg(d);
      let h = c[f], p = c[d];
      if (o) {
        const b = f === "y" ? "top" : "left", y = f === "y" ? "bottom" : "right", k = h + u[b], C = h - u[y];
        h = hm(k, h, C);
      }
      if (s) {
        const b = d === "y" ? "top" : "left", y = d === "y" ? "bottom" : "right", k = p + u[b], C = p - u[y];
        p = hm(k, p, C);
      }
      const m = a.fn({
        ...e,
        [f]: h,
        [d]: p
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r,
          enabled: {
            [f]: o,
            [d]: s
          }
        }
      };
    }
  };
}, f9 = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: o,
        middlewareData: s
      } = e, {
        offset: a = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = Lr(t, e), u = {
        x: n,
        y: r
      }, d = vi(i), f = bg(d);
      let h = u[f], p = u[d];
      const m = Lr(a, e), b = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (l) {
        const C = f === "y" ? "height" : "width", x = o.reference[f] - o.floating[C] + b.mainAxis, S = o.reference[f] + o.reference[C] - b.mainAxis;
        h < x ? h = x : h > S && (h = S);
      }
      if (c) {
        var y, k;
        const C = f === "y" ? "width" : "height", x = ["top", "left"].includes(Fr(i)), S = o.reference[d] - o.floating[C] + (x && ((y = s.offset) == null ? void 0 : y[d]) || 0) + (x ? 0 : b.crossAxis), T = o.reference[d] + o.reference[C] + (x ? 0 : ((k = s.offset) == null ? void 0 : k[d]) || 0) - (x ? b.crossAxis : 0);
        p < S ? p = S : p > T && (p = T);
      }
      return {
        [f]: h,
        [d]: p
      };
    }
  };
}, h9 = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var n, r;
      const {
        placement: i,
        rects: o,
        platform: s,
        elements: a
      } = e, {
        apply: l = () => {
        },
        ...c
      } = Lr(t, e), u = await fa(e, c), d = Fr(i), f = ws(i), h = vi(i) === "y", {
        width: p,
        height: m
      } = o.floating;
      let b, y;
      d === "top" || d === "bottom" ? (b = d, y = f === (await (s.isRTL == null ? void 0 : s.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (y = d, b = f === "end" ? "top" : "bottom");
      const k = m - u.top - u.bottom, C = p - u.left - u.right, x = gi(m - u[b], k), S = gi(p - u[y], C), T = !e.middlewareData.shift;
      let E = x, M = S;
      if ((n = e.middlewareData.shift) != null && n.enabled.x && (M = C), (r = e.middlewareData.shift) != null && r.enabled.y && (E = k), T && !f) {
        const L = an(u.left, 0), $ = an(u.right, 0), z = an(u.top, 0), B = an(u.bottom, 0);
        h ? M = p - 2 * (L !== 0 || $ !== 0 ? L + $ : an(u.left, u.right)) : E = m - 2 * (z !== 0 || B !== 0 ? z + B : an(u.top, u.bottom));
      }
      await l({
        ...e,
        availableWidth: M,
        availableHeight: E
      });
      const O = await s.getDimensions(a.floating);
      return p !== O.width || m !== O.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function od() {
  return typeof window < "u";
}
function xs(t) {
  return c2(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function fn(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function pr(t) {
  var e;
  return (e = (c2(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function c2(t) {
  return od() ? t instanceof Node || t instanceof fn(t).Node : !1;
}
function Et(t) {
  return od() ? t instanceof Element || t instanceof fn(t).Element : !1;
}
function ur(t) {
  return od() ? t instanceof HTMLElement || t instanceof fn(t).HTMLElement : !1;
}
function mm(t) {
  return !od() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof fn(t).ShadowRoot;
}
function Ga(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: i
  } = Kn(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(i);
}
function p9(t) {
  return ["table", "td", "th"].includes(xs(t));
}
function sd(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function xg(t) {
  const e = kg(), n = Et(t) ? Kn(t) : t;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function m9(t) {
  let e = bi(t);
  for (; ur(e) && !Jo(e); ) {
    if (xg(e))
      return e;
    if (sd(e))
      return null;
    e = bi(e);
  }
  return null;
}
function kg() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Jo(t) {
  return ["html", "body", "#document"].includes(xs(t));
}
function Kn(t) {
  return fn(t).getComputedStyle(t);
}
function ad(t) {
  return Et(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function bi(t) {
  if (xs(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    mm(t) && t.host || // Fallback.
    pr(t)
  );
  return mm(e) ? e.host : e;
}
function u2(t) {
  const e = bi(t);
  return Jo(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : ur(e) && Ga(e) ? e : u2(e);
}
function ha(t, e, n) {
  var r;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const i = u2(t), o = i === ((r = t.ownerDocument) == null ? void 0 : r.body), s = fn(i);
  if (o) {
    const a = gm(s);
    return e.concat(s, s.visualViewport || [], Ga(i) ? i : [], a && n ? ha(a) : []);
  }
  return e.concat(i, ha(i, [], n));
}
function gm(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function d2(t) {
  const e = Kn(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const i = ur(t), o = i ? t.offsetWidth : n, s = i ? t.offsetHeight : r, a = Ic(n) !== o || Ic(r) !== s;
  return a && (n = o, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function Cg(t) {
  return Et(t) ? t : t.contextElement;
}
function Uo(t) {
  const e = Cg(t);
  if (!ur(e))
    return ar(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = d2(e);
  let s = (o ? Ic(n.width) : n.width) / r, a = (o ? Ic(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const g9 = /* @__PURE__ */ ar(0);
function f2(t) {
  const e = fn(t);
  return !kg() || !e.visualViewport ? g9 : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function v9(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== fn(t) ? !1 : e;
}
function no(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), o = Cg(t);
  let s = ar(1);
  e && (r ? Et(r) && (s = Uo(r)) : s = Uo(t));
  const a = v9(o, n, r) ? f2(o) : ar(0);
  let l = (i.left + a.x) / s.x, c = (i.top + a.y) / s.y, u = i.width / s.x, d = i.height / s.y;
  if (o) {
    const f = fn(o), h = r && Et(r) ? fn(r) : r;
    let p = f, m = gm(p);
    for (; m && r && h !== p; ) {
      const b = Uo(m), y = m.getBoundingClientRect(), k = Kn(m), C = y.left + (m.clientLeft + parseFloat(k.paddingLeft)) * b.x, x = y.top + (m.clientTop + parseFloat(k.paddingTop)) * b.y;
      l *= b.x, c *= b.y, u *= b.x, d *= b.y, l += C, c += x, p = fn(m), m = gm(p);
    }
  }
  return Pc({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function Sg(t, e) {
  const n = ad(t).scrollLeft;
  return e ? e.left + n : no(pr(t)).left + n;
}
function h2(t, e, n) {
  n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), i = r.left + e.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Sg(t, r)
  )), o = r.top + e.scrollTop;
  return {
    x: i,
    y: o
  };
}
function b9(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: r,
    strategy: i
  } = t;
  const o = i === "fixed", s = pr(r), a = e ? sd(e.floating) : !1;
  if (r === s || a && o)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = ar(1);
  const u = ar(0), d = ur(r);
  if ((d || !d && !o) && ((xs(r) !== "body" || Ga(s)) && (l = ad(r)), ur(r))) {
    const h = no(r);
    c = Uo(r), u.x = h.x + r.clientLeft, u.y = h.y + r.clientTop;
  }
  const f = s && !d && !o ? h2(s, l, !0) : ar(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x + f.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y + f.y
  };
}
function y9(t) {
  return Array.from(t.getClientRects());
}
function w9(t) {
  const e = pr(t), n = ad(t), r = t.ownerDocument.body, i = an(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), o = an(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Sg(t);
  const a = -n.scrollTop;
  return Kn(r).direction === "rtl" && (s += an(e.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: s,
    y: a
  };
}
function x9(t, e) {
  const n = fn(t), r = pr(t), i = n.visualViewport;
  let o = r.clientWidth, s = r.clientHeight, a = 0, l = 0;
  if (i) {
    o = i.width, s = i.height;
    const c = kg();
    (!c || c && e === "fixed") && (a = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: a,
    y: l
  };
}
function k9(t, e) {
  const n = no(t, !0, e === "fixed"), r = n.top + t.clientTop, i = n.left + t.clientLeft, o = ur(t) ? Uo(t) : ar(1), s = t.clientWidth * o.x, a = t.clientHeight * o.y, l = i * o.x, c = r * o.y;
  return {
    width: s,
    height: a,
    x: l,
    y: c
  };
}
function Iw(t, e, n) {
  let r;
  if (e === "viewport")
    r = x9(t, n);
  else if (e === "document")
    r = w9(pr(t));
  else if (Et(e))
    r = k9(e, n);
  else {
    const i = f2(t);
    r = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return Pc(r);
}
function p2(t, e) {
  const n = bi(t);
  return n === e || !Et(n) || Jo(n) ? !1 : Kn(n).position === "fixed" || p2(n, e);
}
function C9(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let r = ha(t, [], !1).filter((a) => Et(a) && xs(a) !== "body"), i = null;
  const o = Kn(t).position === "fixed";
  let s = o ? bi(t) : t;
  for (; Et(s) && !Jo(s); ) {
    const a = Kn(s), l = xg(s);
    !l && a.position === "fixed" && (i = null), (o ? !l && !i : !l && a.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || Ga(s) && !l && p2(t, s)) ? r = r.filter((u) => u !== s) : i = a, s = bi(s);
  }
  return e.set(t, r), r;
}
function S9(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = t;
  const s = [...n === "clippingAncestors" ? sd(e) ? [] : C9(e, this._c) : [].concat(n), r], a = s[0], l = s.reduce((c, u) => {
    const d = Iw(e, u, i);
    return c.top = an(d.top, c.top), c.right = gi(d.right, c.right), c.bottom = gi(d.bottom, c.bottom), c.left = an(d.left, c.left), c;
  }, Iw(e, a, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function T9(t) {
  const {
    width: e,
    height: n
  } = d2(t);
  return {
    width: e,
    height: n
  };
}
function E9(t, e, n) {
  const r = ur(e), i = pr(e), o = n === "fixed", s = no(t, !0, o, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = ar(0);
  if (r || !r && !o)
    if ((xs(e) !== "body" || Ga(i)) && (a = ad(e)), r) {
      const f = no(e, !0, o, e);
      l.x = f.x + e.clientLeft, l.y = f.y + e.clientTop;
    } else i && (l.x = Sg(i));
  const c = i && !r && !o ? h2(i, a) : ar(0), u = s.left + a.scrollLeft - l.x - c.x, d = s.top + a.scrollTop - l.y - c.y;
  return {
    x: u,
    y: d,
    width: s.width,
    height: s.height
  };
}
function Bh(t) {
  return Kn(t).position === "static";
}
function _w(t, e) {
  if (!ur(t) || Kn(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return pr(t) === n && (n = n.ownerDocument.body), n;
}
function m2(t, e) {
  const n = fn(t);
  if (sd(t))
    return n;
  if (!ur(t)) {
    let i = bi(t);
    for (; i && !Jo(i); ) {
      if (Et(i) && !Bh(i))
        return i;
      i = bi(i);
    }
    return n;
  }
  let r = _w(t, e);
  for (; r && p9(r) && Bh(r); )
    r = _w(r, e);
  return r && Jo(r) && Bh(r) && !xg(r) ? n : r || m9(t) || n;
}
const M9 = async function(t) {
  const e = this.getOffsetParent || m2, n = this.getDimensions, r = await n(t.floating);
  return {
    reference: E9(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function O9(t) {
  return Kn(t).direction === "rtl";
}
const A9 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: b9,
  getDocumentElement: pr,
  getClippingRect: S9,
  getOffsetParent: m2,
  getElementRects: M9,
  getClientRects: y9,
  getDimensions: T9,
  getScale: Uo,
  isElement: Et,
  isRTL: O9
};
function g2(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function N9(t, e) {
  let n = null, r;
  const i = pr(t);
  function o() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), o();
    const c = t.getBoundingClientRect(), {
      left: u,
      top: d,
      width: f,
      height: h
    } = c;
    if (a || e(), !f || !h)
      return;
    const p = _l(d), m = _l(i.clientWidth - (u + f)), b = _l(i.clientHeight - (d + h)), y = _l(u), C = {
      rootMargin: -p + "px " + -m + "px " + -b + "px " + -y + "px",
      threshold: an(0, gi(1, l)) || 1
    };
    let x = !0;
    function S(T) {
      const E = T[0].intersectionRatio;
      if (E !== l) {
        if (!x)
          return s();
        E ? s(!1, E) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !g2(c, t.getBoundingClientRect()) && s(), x = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...C,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, C);
    }
    n.observe(t);
  }
  return s(!0), o;
}
function v2(t, e, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = Cg(t), u = i || o ? [...c ? ha(c) : [], ...ha(e)] : [];
  u.forEach((y) => {
    i && y.addEventListener("scroll", n, {
      passive: !0
    }), o && y.addEventListener("resize", n);
  });
  const d = c && a ? N9(c, n) : null;
  let f = -1, h = null;
  s && (h = new ResizeObserver((y) => {
    let [k] = y;
    k && k.target === c && h && (h.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var C;
      (C = h) == null || C.observe(e);
    })), n();
  }), c && !l && h.observe(c), h.observe(e));
  let p, m = l ? no(t) : null;
  l && b();
  function b() {
    const y = no(t);
    m && !g2(m, y) && n(), m = y, p = requestAnimationFrame(b);
  }
  return n(), () => {
    var y;
    u.forEach((k) => {
      i && k.removeEventListener("scroll", n), o && k.removeEventListener("resize", n);
    }), d == null || d(), (y = h) == null || y.disconnect(), h = null, l && cancelAnimationFrame(p);
  };
}
const R9 = u9, D9 = d9, I9 = a9, _9 = h9, P9 = l9, Pw = s9, L9 = f9, F9 = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: A9,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return o9(t, e, {
    ...i,
    platform: o
  });
};
var cc = typeof document < "u" ? uo : De;
function Lc(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, r, i;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== e.length) return !1;
      for (r = n; r-- !== 0; )
        if (!Lc(t[r], e[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(t), n = i.length, n !== Object.keys(e).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(e, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = i[r];
      if (!(o === "_owner" && t.$$typeof) && !Lc(t[o], e[o]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function b2(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Lw(t, e) {
  const n = b2(t);
  return Math.round(e * n) / n;
}
function Vh(t) {
  const e = w.useRef(t);
  return cc(() => {
    e.current = t;
  }), e;
}
function y2(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: o,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = t, [u, d] = w.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = w.useState(r);
  Lc(f, r) || h(r);
  const [p, m] = w.useState(null), [b, y] = w.useState(null), k = w.useCallback((D) => {
    D !== T.current && (T.current = D, m(D));
  }, []), C = w.useCallback((D) => {
    D !== E.current && (E.current = D, y(D));
  }, []), x = o || p, S = s || b, T = w.useRef(null), E = w.useRef(null), M = w.useRef(u), O = l != null, L = Vh(l), $ = Vh(i), z = Vh(c), B = w.useCallback(() => {
    if (!T.current || !E.current)
      return;
    const D = {
      placement: e,
      strategy: n,
      middleware: f
    };
    $.current && (D.platform = $.current), F9(T.current, E.current, D).then((q) => {
      const V = {
        ...q,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: z.current !== !1
      };
      A.current && !Lc(M.current, V) && (M.current = V, fs.flushSync(() => {
        d(V);
      }));
    });
  }, [f, e, n, $, z]);
  cc(() => {
    c === !1 && M.current.isPositioned && (M.current.isPositioned = !1, d((D) => ({
      ...D,
      isPositioned: !1
    })));
  }, [c]);
  const A = w.useRef(!1);
  cc(() => (A.current = !0, () => {
    A.current = !1;
  }), []), cc(() => {
    if (x && (T.current = x), S && (E.current = S), x && S) {
      if (L.current)
        return L.current(x, S, B);
      B();
    }
  }, [x, S, B, L, O]);
  const N = w.useMemo(() => ({
    reference: T,
    floating: E,
    setReference: k,
    setFloating: C
  }), [k, C]), R = w.useMemo(() => ({
    reference: x,
    floating: S
  }), [x, S]), _ = w.useMemo(() => {
    const D = {
      position: n,
      left: 0,
      top: 0
    };
    if (!R.floating)
      return D;
    const q = Lw(R.floating, u.x), V = Lw(R.floating, u.y);
    return a ? {
      ...D,
      transform: "translate(" + q + "px, " + V + "px)",
      ...b2(R.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: q,
      top: V
    };
  }, [n, a, R.floating, u.x, u.y]);
  return w.useMemo(() => ({
    ...u,
    update: B,
    refs: N,
    elements: R,
    floatingStyles: _
  }), [u, B, N, R, _]);
}
const $9 = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof t == "function" ? t(n) : t;
      return r && e(r) ? r.current != null ? Pw({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? Pw({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
}, B9 = (t, e) => ({
  ...R9(t),
  options: [t, e]
}), V9 = (t, e) => ({
  ...D9(t),
  options: [t, e]
}), z9 = (t, e) => ({
  ...L9(t),
  options: [t, e]
}), w2 = (t, e) => ({
  ...I9(t),
  options: [t, e]
}), x2 = (t, e) => ({
  ..._9(t),
  options: [t, e]
}), H9 = (t, e) => ({
  ...P9(t),
  options: [t, e]
}), W9 = (t, e) => ({
  ...$9(t),
  options: [t, e]
});
var j9 = "Arrow", k2 = w.forwardRef((t, e) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = t;
  return /* @__PURE__ */ v(
    ae.svg,
    {
      ...o,
      ref: e,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: t.asChild ? n : /* @__PURE__ */ v("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
k2.displayName = j9;
var U9 = k2, Tg = "Popper", [C2, Ci] = mt(Tg), [q9, S2] = C2(Tg), T2 = (t) => {
  const { __scopePopper: e, children: n } = t, [r, i] = w.useState(null);
  return /* @__PURE__ */ v(q9, { scope: e, anchor: r, onAnchorChange: i, children: n });
};
T2.displayName = Tg;
var E2 = "PopperAnchor", M2 = w.forwardRef(
  (t, e) => {
    const { __scopePopper: n, virtualRef: r, ...i } = t, o = S2(E2, n), s = w.useRef(null), a = Oe(e, s);
    return w.useEffect(() => {
      o.onAnchorChange((r == null ? void 0 : r.current) || s.current);
    }), r ? null : /* @__PURE__ */ v(ae.div, { ...i, ref: a });
  }
);
M2.displayName = E2;
var Eg = "PopperContent", [K9, G9] = C2(Eg), O2 = w.forwardRef(
  (t, e) => {
    var j, X, ie, ne, we, K;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: i = 0,
      align: o = "center",
      alignOffset: s = 0,
      arrowPadding: a = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: p,
      ...m
    } = t, b = S2(Eg, n), [y, k] = w.useState(null), C = Oe(e, (Fe) => k(Fe)), [x, S] = w.useState(null), T = Ka(x), E = (T == null ? void 0 : T.width) ?? 0, M = (T == null ? void 0 : T.height) ?? 0, O = r + (o !== "center" ? "-" + o : ""), L = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, $ = Array.isArray(c) ? c : [c], z = $.length > 0, B = {
      padding: L,
      boundary: $.filter(Z9),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: z
    }, { refs: A, floatingStyles: N, placement: R, isPositioned: _, middlewareData: D } = y2({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: O,
      whileElementsMounted: (...Fe) => v2(...Fe, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        B9({ mainAxis: i + M, alignmentAxis: s }),
        l && V9({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? z9() : void 0,
          ...B
        }),
        l && w2({ ...B }),
        x2({
          ...B,
          apply: ({ elements: Fe, rects: oe, availableWidth: kt, availableHeight: Ot }) => {
            const { width: Zt, height: yo } = oe.reference, br = Fe.floating.style;
            br.setProperty("--radix-popper-available-width", `${kt}px`), br.setProperty("--radix-popper-available-height", `${Ot}px`), br.setProperty("--radix-popper-anchor-width", `${Zt}px`), br.setProperty("--radix-popper-anchor-height", `${yo}px`);
          }
        }),
        x && W9({ element: x, padding: a }),
        J9({ arrowWidth: E, arrowHeight: M }),
        f && H9({ strategy: "referenceHidden", ...B })
      ]
    }), [q, V] = R2(R), H = wt(p);
    ft(() => {
      _ && (H == null || H());
    }, [_, H]);
    const G = (j = D.arrow) == null ? void 0 : j.x, Q = (X = D.arrow) == null ? void 0 : X.y, te = ((ie = D.arrow) == null ? void 0 : ie.centerOffset) !== 0, [le, se] = w.useState();
    return ft(() => {
      y && se(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ v(
      "div",
      {
        ref: A.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...N,
          transform: _ ? N.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: le,
          "--radix-popper-transform-origin": [
            (ne = D.transformOrigin) == null ? void 0 : ne.x,
            (we = D.transformOrigin) == null ? void 0 : we.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((K = D.hide) == null ? void 0 : K.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: t.dir,
        children: /* @__PURE__ */ v(
          K9,
          {
            scope: n,
            placedSide: q,
            onArrowChange: S,
            arrowX: G,
            arrowY: Q,
            shouldHideArrow: te,
            children: /* @__PURE__ */ v(
              ae.div,
              {
                "data-side": q,
                "data-align": V,
                ...m,
                ref: C,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: _ ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
O2.displayName = Eg;
var A2 = "PopperArrow", Y9 = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, N2 = w.forwardRef(function(e, n) {
  const { __scopePopper: r, ...i } = e, o = G9(A2, r), s = Y9[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ v(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ v(
          U9,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
N2.displayName = A2;
function Z9(t) {
  return t !== null;
}
var J9 = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var b, y, k;
    const { placement: n, rects: r, middlewareData: i } = e, s = ((b = i.arrow) == null ? void 0 : b.centerOffset) !== 0, a = s ? 0 : t.arrowWidth, l = s ? 0 : t.arrowHeight, [c, u] = R2(n), d = { start: "0%", center: "50%", end: "100%" }[u], f = (((y = i.arrow) == null ? void 0 : y.x) ?? 0) + a / 2, h = (((k = i.arrow) == null ? void 0 : k.y) ?? 0) + l / 2;
    let p = "", m = "";
    return c === "bottom" ? (p = s ? d : `${f}px`, m = `${-l}px`) : c === "top" ? (p = s ? d : `${f}px`, m = `${r.floating.height + l}px`) : c === "right" ? (p = `${-l}px`, m = s ? d : `${h}px`) : c === "left" && (p = `${r.floating.width + l}px`, m = s ? d : `${h}px`), { data: { x: p, y: m } };
  }
});
function R2(t) {
  const [e, n = "center"] = t.split("-");
  return [e, n];
}
var Ya = T2, Za = M2, ld = O2, cd = N2, zh = "rovingFocusGroup.onEntryFocus", X9 = { bubbles: !1, cancelable: !0 }, ud = "RovingFocusGroup", [vm, D2, Q9] = Wa(ud), [e$, ks] = mt(
  ud,
  [Q9]
), [t$, n$] = e$(ud), I2 = w.forwardRef(
  (t, e) => /* @__PURE__ */ v(vm.Provider, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(vm.Slot, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(r$, { ...t, ref: e }) }) })
);
I2.displayName = ud;
var r$ = w.forwardRef((t, e) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: i = !1,
    dir: o,
    currentTabStopId: s,
    defaultCurrentTabStopId: a,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = t, f = w.useRef(null), h = Oe(e, f), p = ys(o), [m = null, b] = qt({
    prop: s,
    defaultProp: a,
    onChange: l
  }), [y, k] = w.useState(!1), C = wt(c), x = D2(n), S = w.useRef(!1), [T, E] = w.useState(0);
  return w.useEffect(() => {
    const M = f.current;
    if (M)
      return M.addEventListener(zh, C), () => M.removeEventListener(zh, C);
  }, [C]), /* @__PURE__ */ v(
    t$,
    {
      scope: n,
      orientation: r,
      dir: p,
      loop: i,
      currentTabStopId: m,
      onItemFocus: w.useCallback(
        (M) => b(M),
        [b]
      ),
      onItemShiftTab: w.useCallback(() => k(!0), []),
      onFocusableItemAdd: w.useCallback(
        () => E((M) => M + 1),
        []
      ),
      onFocusableItemRemove: w.useCallback(
        () => E((M) => M - 1),
        []
      ),
      children: /* @__PURE__ */ v(
        ae.div,
        {
          tabIndex: y || T === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: h,
          style: { outline: "none", ...t.style },
          onMouseDown: Z(t.onMouseDown, () => {
            S.current = !0;
          }),
          onFocus: Z(t.onFocus, (M) => {
            const O = !S.current;
            if (M.target === M.currentTarget && O && !y) {
              const L = new CustomEvent(zh, X9);
              if (M.currentTarget.dispatchEvent(L), !L.defaultPrevented) {
                const $ = x().filter((R) => R.focusable), z = $.find((R) => R.active), B = $.find((R) => R.id === m), N = [z, B, ...$].filter(
                  Boolean
                ).map((R) => R.ref.current);
                L2(N, u);
              }
            }
            S.current = !1;
          }),
          onBlur: Z(t.onBlur, () => k(!1))
        }
      )
    }
  );
}), _2 = "RovingFocusGroupItem", P2 = w.forwardRef(
  (t, e) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: i = !1,
      tabStopId: o,
      ...s
    } = t, a = Ut(), l = o || a, c = n$(_2, n), u = c.currentTabStopId === l, d = D2(n), { onFocusableItemAdd: f, onFocusableItemRemove: h } = c;
    return w.useEffect(() => {
      if (r)
        return f(), () => h();
    }, [r, f, h]), /* @__PURE__ */ v(
      vm.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: i,
        children: /* @__PURE__ */ v(
          ae.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": c.orientation,
            ...s,
            ref: e,
            onMouseDown: Z(t.onMouseDown, (p) => {
              r ? c.onItemFocus(l) : p.preventDefault();
            }),
            onFocus: Z(t.onFocus, () => c.onItemFocus(l)),
            onKeyDown: Z(t.onKeyDown, (p) => {
              if (p.key === "Tab" && p.shiftKey) {
                c.onItemShiftTab();
                return;
              }
              if (p.target !== p.currentTarget) return;
              const m = s$(p, c.orientation, c.dir);
              if (m !== void 0) {
                if (p.metaKey || p.ctrlKey || p.altKey || p.shiftKey) return;
                p.preventDefault();
                let y = d().filter((k) => k.focusable).map((k) => k.ref.current);
                if (m === "last") y.reverse();
                else if (m === "prev" || m === "next") {
                  m === "prev" && y.reverse();
                  const k = y.indexOf(p.currentTarget);
                  y = c.loop ? a$(y, k + 1) : y.slice(k + 1);
                }
                setTimeout(() => L2(y));
              }
            })
          }
        )
      }
    );
  }
);
P2.displayName = _2;
var i$ = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function o$(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function s$(t, e, n) {
  const r = o$(t.key, n);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return i$[r];
}
function L2(t, e = !1) {
  const n = document.activeElement;
  for (const r of t)
    if (r === n || (r.focus({ preventScroll: e }), document.activeElement !== n)) return;
}
function a$(t, e) {
  return t.map((n, r) => t[(e + r) % t.length]);
}
var Mg = I2, Og = P2, bm = ["Enter", " "], l$ = ["ArrowDown", "PageUp", "Home"], F2 = ["ArrowUp", "PageDown", "End"], c$ = [...l$, ...F2], u$ = {
  ltr: [...bm, "ArrowRight"],
  rtl: [...bm, "ArrowLeft"]
}, d$ = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Ja = "Menu", [pa, f$, h$] = Wa(Ja), [go, $2] = mt(Ja, [
  h$,
  Ci,
  ks
]), Xa = Ci(), B2 = ks(), [V2, Si] = go(Ja), [p$, Qa] = go(Ja), z2 = (t) => {
  const { __scopeMenu: e, open: n = !1, children: r, dir: i, onOpenChange: o, modal: s = !0 } = t, a = Xa(e), [l, c] = w.useState(null), u = w.useRef(!1), d = wt(o), f = ys(i);
  return w.useEffect(() => {
    const h = () => {
      u.current = !0, document.addEventListener("pointerdown", p, { capture: !0, once: !0 }), document.addEventListener("pointermove", p, { capture: !0, once: !0 });
    }, p = () => u.current = !1;
    return document.addEventListener("keydown", h, { capture: !0 }), () => {
      document.removeEventListener("keydown", h, { capture: !0 }), document.removeEventListener("pointerdown", p, { capture: !0 }), document.removeEventListener("pointermove", p, { capture: !0 });
    };
  }, []), /* @__PURE__ */ v(Ya, { ...a, children: /* @__PURE__ */ v(
    V2,
    {
      scope: e,
      open: n,
      onOpenChange: d,
      content: l,
      onContentChange: c,
      children: /* @__PURE__ */ v(
        p$,
        {
          scope: e,
          onClose: w.useCallback(() => d(!1), [d]),
          isUsingKeyboardRef: u,
          dir: f,
          modal: s,
          children: r
        }
      )
    }
  ) });
};
z2.displayName = Ja;
var m$ = "MenuAnchor", Ag = w.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...r } = t, i = Xa(n);
    return /* @__PURE__ */ v(Za, { ...i, ...r, ref: e });
  }
);
Ag.displayName = m$;
var Ng = "MenuPortal", [g$, H2] = go(Ng, {
  forceMount: void 0
}), W2 = (t) => {
  const { __scopeMenu: e, forceMount: n, children: r, container: i } = t, o = Si(Ng, e);
  return /* @__PURE__ */ v(g$, { scope: e, forceMount: n, children: /* @__PURE__ */ v(Mt, { present: n || o.open, children: /* @__PURE__ */ v(mo, { asChild: !0, container: i, children: r }) }) });
};
W2.displayName = Ng;
var Nn = "MenuContent", [v$, Rg] = go(Nn), j2 = w.forwardRef(
  (t, e) => {
    const n = H2(Nn, t.__scopeMenu), { forceMount: r = n.forceMount, ...i } = t, o = Si(Nn, t.__scopeMenu), s = Qa(Nn, t.__scopeMenu);
    return /* @__PURE__ */ v(pa.Provider, { scope: t.__scopeMenu, children: /* @__PURE__ */ v(Mt, { present: r || o.open, children: /* @__PURE__ */ v(pa.Slot, { scope: t.__scopeMenu, children: s.modal ? /* @__PURE__ */ v(b$, { ...i, ref: e }) : /* @__PURE__ */ v(y$, { ...i, ref: e }) }) }) });
  }
), b$ = w.forwardRef(
  (t, e) => {
    const n = Si(Nn, t.__scopeMenu), r = w.useRef(null), i = Oe(e, r);
    return w.useEffect(() => {
      const o = r.current;
      if (o) return id(o);
    }, []), /* @__PURE__ */ v(
      Dg,
      {
        ...t,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: Z(
          t.onFocusOutside,
          (o) => o.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), y$ = w.forwardRef((t, e) => {
  const n = Si(Nn, t.__scopeMenu);
  return /* @__PURE__ */ v(
    Dg,
    {
      ...t,
      ref: e,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), w$ = /* @__PURE__ */ mi("MenuContent.ScrollLock"), Dg = w.forwardRef(
  (t, e) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: i,
      onOpenAutoFocus: o,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: a,
      onEntryFocus: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: u,
      onFocusOutside: d,
      onInteractOutside: f,
      onDismiss: h,
      disableOutsideScroll: p,
      ...m
    } = t, b = Si(Nn, n), y = Qa(Nn, n), k = Xa(n), C = B2(n), x = f$(n), [S, T] = w.useState(null), E = w.useRef(null), M = Oe(e, E, b.onContentChange), O = w.useRef(0), L = w.useRef(""), $ = w.useRef(0), z = w.useRef(null), B = w.useRef("right"), A = w.useRef(0), N = p ? Ua : w.Fragment, R = p ? { as: w$, allowPinchZoom: !0 } : void 0, _ = (q) => {
      var j, X;
      const V = L.current + q, H = x().filter((ie) => !ie.disabled), G = document.activeElement, Q = (j = H.find((ie) => ie.ref.current === G)) == null ? void 0 : j.textValue, te = H.map((ie) => ie.textValue), le = D$(te, V, Q), se = (X = H.find((ie) => ie.textValue === le)) == null ? void 0 : X.ref.current;
      (function ie(ne) {
        L.current = ne, window.clearTimeout(O.current), ne !== "" && (O.current = window.setTimeout(() => ie(""), 1e3));
      })(V), se && setTimeout(() => se.focus());
    };
    w.useEffect(() => () => window.clearTimeout(O.current), []), nd();
    const D = w.useCallback((q) => {
      var H, G;
      return B.current === ((H = z.current) == null ? void 0 : H.side) && _$(q, (G = z.current) == null ? void 0 : G.area);
    }, []);
    return /* @__PURE__ */ v(
      v$,
      {
        scope: n,
        searchRef: L,
        onItemEnter: w.useCallback(
          (q) => {
            D(q) && q.preventDefault();
          },
          [D]
        ),
        onItemLeave: w.useCallback(
          (q) => {
            var V;
            D(q) || ((V = E.current) == null || V.focus(), T(null));
          },
          [D]
        ),
        onTriggerLeave: w.useCallback(
          (q) => {
            D(q) && q.preventDefault();
          },
          [D]
        ),
        pointerGraceTimerRef: $,
        onPointerGraceIntentChange: w.useCallback((q) => {
          z.current = q;
        }, []),
        children: /* @__PURE__ */ v(N, { ...R, children: /* @__PURE__ */ v(
          ja,
          {
            asChild: !0,
            trapped: i,
            onMountAutoFocus: Z(o, (q) => {
              var V;
              q.preventDefault(), (V = E.current) == null || V.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ v(
              po,
              {
                asChild: !0,
                disableOutsidePointerEvents: a,
                onEscapeKeyDown: c,
                onPointerDownOutside: u,
                onFocusOutside: d,
                onInteractOutside: f,
                onDismiss: h,
                children: /* @__PURE__ */ v(
                  Mg,
                  {
                    asChild: !0,
                    ...C,
                    dir: y.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: S,
                    onCurrentTabStopIdChange: T,
                    onEntryFocus: Z(l, (q) => {
                      y.isUsingKeyboardRef.current || q.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ v(
                      ld,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": aM(b.open),
                        "data-radix-menu-content": "",
                        dir: y.dir,
                        ...k,
                        ...m,
                        ref: M,
                        style: { outline: "none", ...m.style },
                        onKeyDown: Z(m.onKeyDown, (q) => {
                          const H = q.target.closest("[data-radix-menu-content]") === q.currentTarget, G = q.ctrlKey || q.altKey || q.metaKey, Q = q.key.length === 1;
                          H && (q.key === "Tab" && q.preventDefault(), !G && Q && _(q.key));
                          const te = E.current;
                          if (q.target !== te || !c$.includes(q.key)) return;
                          q.preventDefault();
                          const se = x().filter((j) => !j.disabled).map((j) => j.ref.current);
                          F2.includes(q.key) && se.reverse(), N$(se);
                        }),
                        onBlur: Z(t.onBlur, (q) => {
                          q.currentTarget.contains(q.target) || (window.clearTimeout(O.current), L.current = "");
                        }),
                        onPointerMove: Z(
                          t.onPointerMove,
                          ma((q) => {
                            const V = q.target, H = A.current !== q.clientX;
                            if (q.currentTarget.contains(V) && H) {
                              const G = q.clientX > A.current ? "right" : "left";
                              B.current = G, A.current = q.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
j2.displayName = Nn;
var x$ = "MenuGroup", Ig = w.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...r } = t;
    return /* @__PURE__ */ v(ae.div, { role: "group", ...r, ref: e });
  }
);
Ig.displayName = x$;
var k$ = "MenuLabel", U2 = w.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...r } = t;
    return /* @__PURE__ */ v(ae.div, { ...r, ref: e });
  }
);
U2.displayName = k$;
var Fc = "MenuItem", Fw = "menu.itemSelect", dd = w.forwardRef(
  (t, e) => {
    const { disabled: n = !1, onSelect: r, ...i } = t, o = w.useRef(null), s = Qa(Fc, t.__scopeMenu), a = Rg(Fc, t.__scopeMenu), l = Oe(e, o), c = w.useRef(!1), u = () => {
      const d = o.current;
      if (!n && d) {
        const f = new CustomEvent(Fw, { bubbles: !0, cancelable: !0 });
        d.addEventListener(Fw, (h) => r == null ? void 0 : r(h), { once: !0 }), X0(d, f), f.defaultPrevented ? c.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ v(
      q2,
      {
        ...i,
        ref: l,
        disabled: n,
        onClick: Z(t.onClick, u),
        onPointerDown: (d) => {
          var f;
          (f = t.onPointerDown) == null || f.call(t, d), c.current = !0;
        },
        onPointerUp: Z(t.onPointerUp, (d) => {
          var f;
          c.current || (f = d.currentTarget) == null || f.click();
        }),
        onKeyDown: Z(t.onKeyDown, (d) => {
          const f = a.searchRef.current !== "";
          n || f && d.key === " " || bm.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
        })
      }
    );
  }
);
dd.displayName = Fc;
var q2 = w.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: i, ...o } = t, s = Rg(Fc, n), a = B2(n), l = w.useRef(null), c = Oe(e, l), [u, d] = w.useState(!1), [f, h] = w.useState("");
    return w.useEffect(() => {
      const p = l.current;
      p && h((p.textContent ?? "").trim());
    }, [o.children]), /* @__PURE__ */ v(
      pa.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: i ?? f,
        children: /* @__PURE__ */ v(Og, { asChild: !0, ...a, focusable: !r, children: /* @__PURE__ */ v(
          ae.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...o,
            ref: c,
            onPointerMove: Z(
              t.onPointerMove,
              ma((p) => {
                r ? s.onItemLeave(p) : (s.onItemEnter(p), p.defaultPrevented || p.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: Z(
              t.onPointerLeave,
              ma((p) => s.onItemLeave(p))
            ),
            onFocus: Z(t.onFocus, () => d(!0)),
            onBlur: Z(t.onBlur, () => d(!1))
          }
        ) })
      }
    );
  }
), C$ = "MenuCheckboxItem", K2 = w.forwardRef(
  (t, e) => {
    const { checked: n = !1, onCheckedChange: r, ...i } = t;
    return /* @__PURE__ */ v(X2, { scope: t.__scopeMenu, checked: n, children: /* @__PURE__ */ v(
      dd,
      {
        role: "menuitemcheckbox",
        "aria-checked": $c(n) ? "mixed" : n,
        ...i,
        ref: e,
        "data-state": Lg(n),
        onSelect: Z(
          i.onSelect,
          () => r == null ? void 0 : r($c(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
K2.displayName = C$;
var G2 = "MenuRadioGroup", [S$, T$] = go(
  G2,
  { value: void 0, onValueChange: () => {
  } }
), Y2 = w.forwardRef(
  (t, e) => {
    const { value: n, onValueChange: r, ...i } = t, o = wt(r);
    return /* @__PURE__ */ v(S$, { scope: t.__scopeMenu, value: n, onValueChange: o, children: /* @__PURE__ */ v(Ig, { ...i, ref: e }) });
  }
);
Y2.displayName = G2;
var Z2 = "MenuRadioItem", J2 = w.forwardRef(
  (t, e) => {
    const { value: n, ...r } = t, i = T$(Z2, t.__scopeMenu), o = n === i.value;
    return /* @__PURE__ */ v(X2, { scope: t.__scopeMenu, checked: o, children: /* @__PURE__ */ v(
      dd,
      {
        role: "menuitemradio",
        "aria-checked": o,
        ...r,
        ref: e,
        "data-state": Lg(o),
        onSelect: Z(
          r.onSelect,
          () => {
            var s;
            return (s = i.onValueChange) == null ? void 0 : s.call(i, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
J2.displayName = Z2;
var _g = "MenuItemIndicator", [X2, E$] = go(
  _g,
  { checked: !1 }
), Q2 = w.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, forceMount: r, ...i } = t, o = E$(_g, n);
    return /* @__PURE__ */ v(
      Mt,
      {
        present: r || $c(o.checked) || o.checked === !0,
        children: /* @__PURE__ */ v(
          ae.span,
          {
            ...i,
            ref: e,
            "data-state": Lg(o.checked)
          }
        )
      }
    );
  }
);
Q2.displayName = _g;
var M$ = "MenuSeparator", eM = w.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...r } = t;
    return /* @__PURE__ */ v(
      ae.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: e
      }
    );
  }
);
eM.displayName = M$;
var O$ = "MenuArrow", tM = w.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...r } = t, i = Xa(n);
    return /* @__PURE__ */ v(cd, { ...i, ...r, ref: e });
  }
);
tM.displayName = O$;
var Pg = "MenuSub", [A$, nM] = go(Pg), rM = (t) => {
  const { __scopeMenu: e, children: n, open: r = !1, onOpenChange: i } = t, o = Si(Pg, e), s = Xa(e), [a, l] = w.useState(null), [c, u] = w.useState(null), d = wt(i);
  return w.useEffect(() => (o.open === !1 && d(!1), () => d(!1)), [o.open, d]), /* @__PURE__ */ v(Ya, { ...s, children: /* @__PURE__ */ v(
    V2,
    {
      scope: e,
      open: r,
      onOpenChange: d,
      content: c,
      onContentChange: u,
      children: /* @__PURE__ */ v(
        A$,
        {
          scope: e,
          contentId: Ut(),
          triggerId: Ut(),
          trigger: a,
          onTriggerChange: l,
          children: n
        }
      )
    }
  ) });
};
rM.displayName = Pg;
var $s = "MenuSubTrigger", iM = w.forwardRef(
  (t, e) => {
    const n = Si($s, t.__scopeMenu), r = Qa($s, t.__scopeMenu), i = nM($s, t.__scopeMenu), o = Rg($s, t.__scopeMenu), s = w.useRef(null), { pointerGraceTimerRef: a, onPointerGraceIntentChange: l } = o, c = { __scopeMenu: t.__scopeMenu }, u = w.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return w.useEffect(() => u, [u]), w.useEffect(() => {
      const d = a.current;
      return () => {
        window.clearTimeout(d), l(null);
      };
    }, [a, l]), /* @__PURE__ */ v(Ag, { asChild: !0, ...c, children: /* @__PURE__ */ v(
      q2,
      {
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": i.contentId,
        "data-state": aM(n.open),
        ...t,
        ref: Bu(e, i.onTriggerChange),
        onClick: (d) => {
          var f;
          (f = t.onClick) == null || f.call(t, d), !(t.disabled || d.defaultPrevented) && (d.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: Z(
          t.onPointerMove,
          ma((d) => {
            o.onItemEnter(d), !d.defaultPrevented && !t.disabled && !n.open && !s.current && (o.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: Z(
          t.onPointerLeave,
          ma((d) => {
            var h, p;
            u();
            const f = (h = n.content) == null ? void 0 : h.getBoundingClientRect();
            if (f) {
              const m = (p = n.content) == null ? void 0 : p.dataset.side, b = m === "right", y = b ? -5 : 5, k = f[b ? "left" : "right"], C = f[b ? "right" : "left"];
              o.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: d.clientX + y, y: d.clientY },
                  { x: k, y: f.top },
                  { x: C, y: f.top },
                  { x: C, y: f.bottom },
                  { x: k, y: f.bottom }
                ],
                side: m
              }), window.clearTimeout(a.current), a.current = window.setTimeout(
                () => o.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (o.onTriggerLeave(d), d.defaultPrevented) return;
              o.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: Z(t.onKeyDown, (d) => {
          var h;
          const f = o.searchRef.current !== "";
          t.disabled || f && d.key === " " || u$[r.dir].includes(d.key) && (n.onOpenChange(!0), (h = n.content) == null || h.focus(), d.preventDefault());
        })
      }
    ) });
  }
);
iM.displayName = $s;
var oM = "MenuSubContent", sM = w.forwardRef(
  (t, e) => {
    const n = H2(Nn, t.__scopeMenu), { forceMount: r = n.forceMount, ...i } = t, o = Si(Nn, t.__scopeMenu), s = Qa(Nn, t.__scopeMenu), a = nM(oM, t.__scopeMenu), l = w.useRef(null), c = Oe(e, l);
    return /* @__PURE__ */ v(pa.Provider, { scope: t.__scopeMenu, children: /* @__PURE__ */ v(Mt, { present: r || o.open, children: /* @__PURE__ */ v(pa.Slot, { scope: t.__scopeMenu, children: /* @__PURE__ */ v(
      Dg,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        ...i,
        ref: c,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var d;
          s.isUsingKeyboardRef.current && ((d = l.current) == null || d.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: Z(t.onFocusOutside, (u) => {
          u.target !== a.trigger && o.onOpenChange(!1);
        }),
        onEscapeKeyDown: Z(t.onEscapeKeyDown, (u) => {
          s.onClose(), u.preventDefault();
        }),
        onKeyDown: Z(t.onKeyDown, (u) => {
          var h;
          const d = u.currentTarget.contains(u.target), f = d$[s.dir].includes(u.key);
          d && f && (o.onOpenChange(!1), (h = a.trigger) == null || h.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
sM.displayName = oM;
function aM(t) {
  return t ? "open" : "closed";
}
function $c(t) {
  return t === "indeterminate";
}
function Lg(t) {
  return $c(t) ? "indeterminate" : t ? "checked" : "unchecked";
}
function N$(t) {
  const e = document.activeElement;
  for (const n of t)
    if (n === e || (n.focus(), document.activeElement !== e)) return;
}
function R$(t, e) {
  return t.map((n, r) => t[(e + r) % t.length]);
}
function D$(t, e, n) {
  const i = e.length > 1 && Array.from(e).every((c) => c === e[0]) ? e[0] : e, o = n ? t.indexOf(n) : -1;
  let s = R$(t, Math.max(o, 0));
  i.length === 1 && (s = s.filter((c) => c !== n));
  const l = s.find(
    (c) => c.toLowerCase().startsWith(i.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function I$(t, e) {
  const { x: n, y: r } = t;
  let i = !1;
  for (let o = 0, s = e.length - 1; o < e.length; s = o++) {
    const a = e[o].x, l = e[o].y, c = e[s].x, u = e[s].y;
    l > r != u > r && n < (c - a) * (r - l) / (u - l) + a && (i = !i);
  }
  return i;
}
function _$(t, e) {
  if (!e) return !1;
  const n = { x: t.clientX, y: t.clientY };
  return I$(n, e);
}
function ma(t) {
  return (e) => e.pointerType === "mouse" ? t(e) : void 0;
}
var P$ = z2, L$ = Ag, F$ = W2, $$ = j2, B$ = Ig, V$ = U2, z$ = dd, H$ = K2, W$ = Y2, j$ = J2, U$ = Q2, q$ = eM, K$ = tM, G$ = rM, Y$ = iM, Z$ = sM, Fg = "DropdownMenu", [J$, X$] = mt(
  Fg,
  [$2]
), $t = $2(), [Q$, lM] = J$(Fg), $g = (t) => {
  const {
    __scopeDropdownMenu: e,
    children: n,
    dir: r,
    open: i,
    defaultOpen: o,
    onOpenChange: s,
    modal: a = !0
  } = t, l = $t(e), c = w.useRef(null), [u = !1, d] = qt({
    prop: i,
    defaultProp: o,
    onChange: s
  });
  return /* @__PURE__ */ v(
    Q$,
    {
      scope: e,
      triggerId: Ut(),
      triggerRef: c,
      contentId: Ut(),
      open: u,
      onOpenChange: d,
      onOpenToggle: w.useCallback(() => d((f) => !f), [d]),
      modal: a,
      children: /* @__PURE__ */ v(P$, { ...l, open: u, onOpenChange: d, dir: r, modal: a, children: n })
    }
  );
};
$g.displayName = Fg;
var cM = "DropdownMenuTrigger", Bg = w.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...i } = t, o = lM(cM, n), s = $t(n);
    return /* @__PURE__ */ v(L$, { asChild: !0, ...s, children: /* @__PURE__ */ v(
      ae.button,
      {
        type: "button",
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": o.open,
        "aria-controls": o.open ? o.contentId : void 0,
        "data-state": o.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...i,
        ref: Bu(e, o.triggerRef),
        onPointerDown: Z(t.onPointerDown, (a) => {
          !r && a.button === 0 && a.ctrlKey === !1 && (o.onOpenToggle(), o.open || a.preventDefault());
        }),
        onKeyDown: Z(t.onKeyDown, (a) => {
          r || (["Enter", " "].includes(a.key) && o.onOpenToggle(), a.key === "ArrowDown" && o.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(a.key) && a.preventDefault());
        })
      }
    ) });
  }
);
Bg.displayName = cM;
var eB = "DropdownMenuPortal", Vg = (t) => {
  const { __scopeDropdownMenu: e, ...n } = t, r = $t(e);
  return /* @__PURE__ */ v(F$, { ...r, ...n });
};
Vg.displayName = eB;
var uM = "DropdownMenuContent", zg = w.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, ...r } = t, i = lM(uM, n), o = $t(n), s = w.useRef(!1);
    return /* @__PURE__ */ v(
      $$,
      {
        id: i.contentId,
        "aria-labelledby": i.triggerId,
        ...o,
        ...r,
        ref: e,
        onCloseAutoFocus: Z(t.onCloseAutoFocus, (a) => {
          var l;
          s.current || (l = i.triggerRef.current) == null || l.focus(), s.current = !1, a.preventDefault();
        }),
        onInteractOutside: Z(t.onInteractOutside, (a) => {
          const l = a.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, u = l.button === 2 || c;
          (!i.modal || u) && (s.current = !0);
        }),
        style: {
          ...t.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
zg.displayName = uM;
var tB = "DropdownMenuGroup", Hg = w.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, ...r } = t, i = $t(n);
    return /* @__PURE__ */ v(B$, { ...i, ...r, ref: e });
  }
);
Hg.displayName = tB;
var nB = "DropdownMenuLabel", Wg = w.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, ...r } = t, i = $t(n);
    return /* @__PURE__ */ v(V$, { ...i, ...r, ref: e });
  }
);
Wg.displayName = nB;
var rB = "DropdownMenuItem", jg = w.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, ...r } = t, i = $t(n);
    return /* @__PURE__ */ v(z$, { ...i, ...r, ref: e });
  }
);
jg.displayName = rB;
var iB = "DropdownMenuCheckboxItem", Ug = w.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, i = $t(n);
  return /* @__PURE__ */ v(H$, { ...i, ...r, ref: e });
});
Ug.displayName = iB;
var oB = "DropdownMenuRadioGroup", qg = w.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, i = $t(n);
  return /* @__PURE__ */ v(W$, { ...i, ...r, ref: e });
});
qg.displayName = oB;
var sB = "DropdownMenuRadioItem", Kg = w.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, i = $t(n);
  return /* @__PURE__ */ v(j$, { ...i, ...r, ref: e });
});
Kg.displayName = sB;
var aB = "DropdownMenuItemIndicator", Gg = w.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, i = $t(n);
  return /* @__PURE__ */ v(U$, { ...i, ...r, ref: e });
});
Gg.displayName = aB;
var lB = "DropdownMenuSeparator", Yg = w.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, i = $t(n);
  return /* @__PURE__ */ v(q$, { ...i, ...r, ref: e });
});
Yg.displayName = lB;
var cB = "DropdownMenuArrow", Zg = w.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, ...r } = t, i = $t(n);
    return /* @__PURE__ */ v(K$, { ...i, ...r, ref: e });
  }
);
Zg.displayName = cB;
var dM = (t) => {
  const { __scopeDropdownMenu: e, children: n, open: r, onOpenChange: i, defaultOpen: o } = t, s = $t(e), [a = !1, l] = qt({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ v(G$, { ...s, open: a, onOpenChange: l, children: n });
}, uB = "DropdownMenuSubTrigger", Jg = w.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, i = $t(n);
  return /* @__PURE__ */ v(Y$, { ...i, ...r, ref: e });
});
Jg.displayName = uB;
var dB = "DropdownMenuSubContent", Xg = w.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, i = $t(n);
  return /* @__PURE__ */ v(
    Z$,
    {
      ...i,
      ...r,
      ref: e,
      style: {
        ...t.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Xg.displayName = dB;
var fM = $g, hM = Bg, pM = Vg, mM = zg, fB = Hg, gM = Wg, fd = jg, vM = Ug, hB = qg, pB = Kg, bM = Gg, yM = Yg, mB = Zg, gB = dM, wM = Jg, xM = Xg;
const vB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Arrow: mB,
  CheckboxItem: vM,
  Content: mM,
  DropdownMenu: $g,
  DropdownMenuArrow: Zg,
  DropdownMenuCheckboxItem: Ug,
  DropdownMenuContent: zg,
  DropdownMenuGroup: Hg,
  DropdownMenuItem: jg,
  DropdownMenuItemIndicator: Gg,
  DropdownMenuLabel: Wg,
  DropdownMenuPortal: Vg,
  DropdownMenuRadioGroup: qg,
  DropdownMenuRadioItem: Kg,
  DropdownMenuSeparator: Yg,
  DropdownMenuSub: dM,
  DropdownMenuSubContent: Xg,
  DropdownMenuSubTrigger: Jg,
  DropdownMenuTrigger: Bg,
  Group: fB,
  Item: fd,
  ItemIndicator: bM,
  Label: gM,
  Portal: pM,
  RadioGroup: hB,
  RadioItem: pB,
  Root: fM,
  Separator: yM,
  Sub: gB,
  SubContent: xM,
  SubTrigger: wM,
  Trigger: hM,
  createDropdownMenuScope: X$
}, Symbol.toStringTag, { value: "Module" }));
var bB = "Label", kM = w.forwardRef((t, e) => /* @__PURE__ */ v(
  ae.label,
  {
    ...t,
    ref: e,
    onMouseDown: (n) => {
      var i;
      n.target.closest("button, input, select, textarea") || ((i = t.onMouseDown) == null || i.call(t, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
kM.displayName = bB;
var yB = kM, Qg = "Popover", [CM, Loe] = mt(Qg, [
  Ci
]), el = Ci(), [wB, Ti] = CM(Qg), SM = (t) => {
  const {
    __scopePopover: e,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    modal: s = !1
  } = t, a = el(e), l = w.useRef(null), [c, u] = w.useState(!1), [d = !1, f] = qt({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ v(Ya, { ...a, children: /* @__PURE__ */ v(
    wB,
    {
      scope: e,
      contentId: Ut(),
      triggerRef: l,
      open: d,
      onOpenChange: f,
      onOpenToggle: w.useCallback(() => f((h) => !h), [f]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: w.useCallback(() => u(!0), []),
      onCustomAnchorRemove: w.useCallback(() => u(!1), []),
      modal: s,
      children: n
    }
  ) });
};
SM.displayName = Qg;
var TM = "PopoverAnchor", EM = w.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...r } = t, i = Ti(TM, n), o = el(n), { onCustomAnchorAdd: s, onCustomAnchorRemove: a } = i;
    return w.useEffect(() => (s(), () => a()), [s, a]), /* @__PURE__ */ v(Za, { ...o, ...r, ref: e });
  }
);
EM.displayName = TM;
var MM = "PopoverTrigger", OM = w.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...r } = t, i = Ti(MM, n), o = el(n), s = Oe(e, i.triggerRef), a = /* @__PURE__ */ v(
      ae.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": IM(i.open),
        ...r,
        ref: s,
        onClick: Z(t.onClick, i.onOpenToggle)
      }
    );
    return i.hasCustomAnchor ? a : /* @__PURE__ */ v(Za, { asChild: !0, ...o, children: a });
  }
);
OM.displayName = MM;
var ev = "PopoverPortal", [xB, kB] = CM(ev, {
  forceMount: void 0
}), AM = (t) => {
  const { __scopePopover: e, forceMount: n, children: r, container: i } = t, o = Ti(ev, e);
  return /* @__PURE__ */ v(xB, { scope: e, forceMount: n, children: /* @__PURE__ */ v(Mt, { present: n || o.open, children: /* @__PURE__ */ v(mo, { asChild: !0, container: i, children: r }) }) });
};
AM.displayName = ev;
var Xo = "PopoverContent", NM = w.forwardRef(
  (t, e) => {
    const n = kB(Xo, t.__scopePopover), { forceMount: r = n.forceMount, ...i } = t, o = Ti(Xo, t.__scopePopover);
    return /* @__PURE__ */ v(Mt, { present: r || o.open, children: o.modal ? /* @__PURE__ */ v(SB, { ...i, ref: e }) : /* @__PURE__ */ v(TB, { ...i, ref: e }) });
  }
);
NM.displayName = Xo;
var CB = /* @__PURE__ */ mi("PopoverContent.RemoveScroll"), SB = w.forwardRef(
  (t, e) => {
    const n = Ti(Xo, t.__scopePopover), r = w.useRef(null), i = Oe(e, r), o = w.useRef(!1);
    return w.useEffect(() => {
      const s = r.current;
      if (s) return id(s);
    }, []), /* @__PURE__ */ v(Ua, { as: CB, allowPinchZoom: !0, children: /* @__PURE__ */ v(
      RM,
      {
        ...t,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Z(t.onCloseAutoFocus, (s) => {
          var a;
          s.preventDefault(), o.current || (a = n.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: Z(
          t.onPointerDownOutside,
          (s) => {
            const a = s.detail.originalEvent, l = a.button === 0 && a.ctrlKey === !0, c = a.button === 2 || l;
            o.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: Z(
          t.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), TB = w.forwardRef(
  (t, e) => {
    const n = Ti(Xo, t.__scopePopover), r = w.useRef(!1), i = w.useRef(!1);
    return /* @__PURE__ */ v(
      RM,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var s, a;
          (s = t.onCloseAutoFocus) == null || s.call(t, o), o.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), o.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (o) => {
          var l, c;
          (l = t.onInteractOutside) == null || l.call(t, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const s = o.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(s)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
        }
      }
    );
  }
), RM = w.forwardRef(
  (t, e) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: i,
      onCloseAutoFocus: o,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: a,
      onPointerDownOutside: l,
      onFocusOutside: c,
      onInteractOutside: u,
      ...d
    } = t, f = Ti(Xo, n), h = el(n);
    return nd(), /* @__PURE__ */ v(
      ja,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: i,
        onUnmountAutoFocus: o,
        children: /* @__PURE__ */ v(
          po,
          {
            asChild: !0,
            disableOutsidePointerEvents: s,
            onInteractOutside: u,
            onEscapeKeyDown: a,
            onPointerDownOutside: l,
            onFocusOutside: c,
            onDismiss: () => f.onOpenChange(!1),
            children: /* @__PURE__ */ v(
              ld,
              {
                "data-state": IM(f.open),
                role: "dialog",
                id: f.contentId,
                ...h,
                ...d,
                ref: e,
                style: {
                  ...d.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), DM = "PopoverClose", EB = w.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...r } = t, i = Ti(DM, n);
    return /* @__PURE__ */ v(
      ae.button,
      {
        type: "button",
        ...r,
        ref: e,
        onClick: Z(t.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
EB.displayName = DM;
var MB = "PopoverArrow", OB = w.forwardRef(
  (t, e) => {
    const { __scopePopover: n, ...r } = t, i = el(n);
    return /* @__PURE__ */ v(cd, { ...i, ...r, ref: e });
  }
);
OB.displayName = MB;
function IM(t) {
  return t ? "open" : "closed";
}
var AB = SM, NB = EM, RB = OM, DB = AM, IB = NM, tv = "Progress", nv = 100, [_B, Foe] = mt(tv), [PB, LB] = _B(tv), _M = w.forwardRef(
  (t, e) => {
    const {
      __scopeProgress: n,
      value: r = null,
      max: i,
      getValueLabel: o = FB,
      ...s
    } = t;
    (i || i === 0) && !$w(i) && console.error($B(`${i}`, "Progress"));
    const a = $w(i) ? i : nv;
    r !== null && !Bw(r, a) && console.error(BB(`${r}`, "Progress"));
    const l = Bw(r, a) ? r : null, c = Bc(l) ? o(l, a) : void 0;
    return /* @__PURE__ */ v(PB, { scope: n, value: l, max: a, children: /* @__PURE__ */ v(
      ae.div,
      {
        "aria-valuemax": a,
        "aria-valuemin": 0,
        "aria-valuenow": Bc(l) ? l : void 0,
        "aria-valuetext": c,
        role: "progressbar",
        "data-state": FM(l, a),
        "data-value": l ?? void 0,
        "data-max": a,
        ...s,
        ref: e
      }
    ) });
  }
);
_M.displayName = tv;
var PM = "ProgressIndicator", LM = w.forwardRef(
  (t, e) => {
    const { __scopeProgress: n, ...r } = t, i = LB(PM, n);
    return /* @__PURE__ */ v(
      ae.div,
      {
        "data-state": FM(i.value, i.max),
        "data-value": i.value ?? void 0,
        "data-max": i.max,
        ...r,
        ref: e
      }
    );
  }
);
LM.displayName = PM;
function FB(t, e) {
  return `${Math.round(t / e * 100)}%`;
}
function FM(t, e) {
  return t == null ? "indeterminate" : t === e ? "complete" : "loading";
}
function Bc(t) {
  return typeof t == "number";
}
function $w(t) {
  return Bc(t) && !isNaN(t) && t > 0;
}
function Bw(t, e) {
  return Bc(t) && !isNaN(t) && t <= e && t >= 0;
}
function $B(t, e) {
  return `Invalid prop \`max\` of value \`${t}\` supplied to \`${e}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${nv}\`.`;
}
function BB(t, e) {
  return `Invalid prop \`value\` of value \`${t}\` supplied to \`${e}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${nv} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var VB = _M, zB = LM, rv = "Radio", [HB, $M] = mt(rv), [WB, jB] = HB(rv), BM = w.forwardRef(
  (t, e) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: i = !1,
      required: o,
      disabled: s,
      value: a = "on",
      onCheck: l,
      form: c,
      ...u
    } = t, [d, f] = w.useState(null), h = Oe(e, (b) => f(b)), p = w.useRef(!1), m = d ? c || !!d.closest("form") : !0;
    return /* @__PURE__ */ F(WB, { scope: n, checked: i, disabled: s, children: [
      /* @__PURE__ */ v(
        ae.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": i,
          "data-state": HM(i),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: a,
          ...u,
          ref: h,
          onClick: Z(t.onClick, (b) => {
            i || l == null || l(), m && (p.current = b.isPropagationStopped(), p.current || b.stopPropagation());
          })
        }
      ),
      m && /* @__PURE__ */ v(
        UB,
        {
          control: d,
          bubbles: !p.current,
          name: r,
          value: a,
          checked: i,
          required: o,
          disabled: s,
          form: c,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
BM.displayName = rv;
var VM = "RadioIndicator", zM = w.forwardRef(
  (t, e) => {
    const { __scopeRadio: n, forceMount: r, ...i } = t, o = jB(VM, n);
    return /* @__PURE__ */ v(Mt, { present: r || o.checked, children: /* @__PURE__ */ v(
      ae.span,
      {
        "data-state": HM(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...i,
        ref: e
      }
    ) });
  }
);
zM.displayName = VM;
var UB = (t) => {
  const { control: e, checked: n, bubbles: r = !0, ...i } = t, o = w.useRef(null), s = qa(n), a = Ka(e);
  return w.useEffect(() => {
    const l = o.current, c = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(c, "checked").set;
    if (s !== n && d) {
      const f = new Event("click", { bubbles: r });
      d.call(l, n), l.dispatchEvent(f);
    }
  }, [s, n, r]), /* @__PURE__ */ v(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: n,
      ...i,
      tabIndex: -1,
      ref: o,
      style: {
        ...t.style,
        ...a,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function HM(t) {
  return t ? "checked" : "unchecked";
}
var qB = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], iv = "RadioGroup", [KB, $oe] = mt(iv, [
  ks,
  $M
]), WM = ks(), jM = $M(), [GB, YB] = KB(iv), UM = w.forwardRef(
  (t, e) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: i,
      value: o,
      required: s = !1,
      disabled: a = !1,
      orientation: l,
      dir: c,
      loop: u = !0,
      onValueChange: d,
      ...f
    } = t, h = WM(n), p = ys(c), [m, b] = qt({
      prop: o,
      defaultProp: i,
      onChange: d
    });
    return /* @__PURE__ */ v(
      GB,
      {
        scope: n,
        name: r,
        required: s,
        disabled: a,
        value: m,
        onValueChange: b,
        children: /* @__PURE__ */ v(
          Mg,
          {
            asChild: !0,
            ...h,
            orientation: l,
            dir: p,
            loop: u,
            children: /* @__PURE__ */ v(
              ae.div,
              {
                role: "radiogroup",
                "aria-required": s,
                "aria-orientation": l,
                "data-disabled": a ? "" : void 0,
                dir: p,
                ...f,
                ref: e
              }
            )
          }
        )
      }
    );
  }
);
UM.displayName = iv;
var qM = "RadioGroupItem", KM = w.forwardRef(
  (t, e) => {
    const { __scopeRadioGroup: n, disabled: r, ...i } = t, o = YB(qM, n), s = o.disabled || r, a = WM(n), l = jM(n), c = w.useRef(null), u = Oe(e, c), d = o.value === i.value, f = w.useRef(!1);
    return w.useEffect(() => {
      const h = (m) => {
        qB.includes(m.key) && (f.current = !0);
      }, p = () => f.current = !1;
      return document.addEventListener("keydown", h), document.addEventListener("keyup", p), () => {
        document.removeEventListener("keydown", h), document.removeEventListener("keyup", p);
      };
    }, []), /* @__PURE__ */ v(
      Og,
      {
        asChild: !0,
        ...a,
        focusable: !s,
        active: d,
        children: /* @__PURE__ */ v(
          BM,
          {
            disabled: s,
            required: o.required,
            checked: d,
            ...l,
            ...i,
            name: o.name,
            ref: u,
            onCheck: () => o.onValueChange(i.value),
            onKeyDown: Z((h) => {
              h.key === "Enter" && h.preventDefault();
            }),
            onFocus: Z(i.onFocus, () => {
              var h;
              f.current && ((h = c.current) == null || h.click());
            })
          }
        )
      }
    );
  }
);
KM.displayName = qM;
var ZB = "RadioGroupIndicator", GM = w.forwardRef(
  (t, e) => {
    const { __scopeRadioGroup: n, ...r } = t, i = jM(n);
    return /* @__PURE__ */ v(zM, { ...i, ...r, ref: e });
  }
);
GM.displayName = ZB;
var YM = UM, ZM = KM, JM = GM;
function Vc(t, [e, n]) {
  return Math.min(n, Math.max(e, t));
}
var JB = [" ", "Enter", "ArrowUp", "ArrowDown"], XB = [" ", "Enter"], tl = "Select", [hd, pd, QB] = Wa(tl), [Cs, eV] = mt(tl, [
  QB,
  Ci
]), md = Ci(), [tV, Ei] = Cs(tl), [nV, rV] = Cs(tl), ov = (t) => {
  const {
    __scopeSelect: e,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    value: s,
    defaultValue: a,
    onValueChange: l,
    dir: c,
    name: u,
    autoComplete: d,
    disabled: f,
    required: h,
    form: p
  } = t, m = md(e), [b, y] = w.useState(null), [k, C] = w.useState(null), [x, S] = w.useState(!1), T = ys(c), [E = !1, M] = qt({
    prop: r,
    defaultProp: i,
    onChange: o
  }), [O, L] = qt({
    prop: s,
    defaultProp: a,
    onChange: l
  }), $ = w.useRef(null), z = b ? p || !!b.closest("form") : !0, [B, A] = w.useState(/* @__PURE__ */ new Set()), N = Array.from(B).map((R) => R.props.value).join(";");
  return /* @__PURE__ */ v(Ya, { ...m, children: /* @__PURE__ */ F(
    tV,
    {
      required: h,
      scope: e,
      trigger: b,
      onTriggerChange: y,
      valueNode: k,
      onValueNodeChange: C,
      valueNodeHasChildren: x,
      onValueNodeHasChildrenChange: S,
      contentId: Ut(),
      value: O,
      onValueChange: L,
      open: E,
      onOpenChange: M,
      dir: T,
      triggerPointerDownPosRef: $,
      disabled: f,
      children: [
        /* @__PURE__ */ v(hd.Provider, { scope: e, children: /* @__PURE__ */ v(
          nV,
          {
            scope: t.__scopeSelect,
            onNativeOptionAdd: w.useCallback((R) => {
              A((_) => new Set(_).add(R));
            }, []),
            onNativeOptionRemove: w.useCallback((R) => {
              A((_) => {
                const D = new Set(_);
                return D.delete(R), D;
              });
            }, []),
            children: n
          }
        ) }),
        z ? /* @__PURE__ */ F(
          c5,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: u,
            autoComplete: d,
            value: O,
            onChange: (R) => L(R.target.value),
            disabled: f,
            form: p,
            children: [
              O === void 0 ? /* @__PURE__ */ v("option", { value: "" }) : null,
              Array.from(B)
            ]
          },
          N
        ) : null
      ]
    }
  ) });
};
ov.displayName = tl;
var XM = "SelectTrigger", sv = w.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, disabled: r = !1, ...i } = t, o = md(n), s = Ei(XM, n), a = s.disabled || r, l = Oe(e, s.onTriggerChange), c = pd(n), u = w.useRef("touch"), [d, f, h] = u5((m) => {
      const b = c().filter((C) => !C.disabled), y = b.find((C) => C.value === s.value), k = d5(b, m, y);
      k !== void 0 && s.onValueChange(k.value);
    }), p = (m) => {
      a || (s.onOpenChange(!0), h()), m && (s.triggerPointerDownPosRef.current = {
        x: Math.round(m.pageX),
        y: Math.round(m.pageY)
      });
    };
    return /* @__PURE__ */ v(Za, { asChild: !0, ...o, children: /* @__PURE__ */ v(
      ae.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": s.contentId,
        "aria-expanded": s.open,
        "aria-required": s.required,
        "aria-autocomplete": "none",
        dir: s.dir,
        "data-state": s.open ? "open" : "closed",
        disabled: a,
        "data-disabled": a ? "" : void 0,
        "data-placeholder": l5(s.value) ? "" : void 0,
        ...i,
        ref: l,
        onClick: Z(i.onClick, (m) => {
          m.currentTarget.focus(), u.current !== "mouse" && p(m);
        }),
        onPointerDown: Z(i.onPointerDown, (m) => {
          u.current = m.pointerType;
          const b = m.target;
          b.hasPointerCapture(m.pointerId) && b.releasePointerCapture(m.pointerId), m.button === 0 && m.ctrlKey === !1 && m.pointerType === "mouse" && (p(m), m.preventDefault());
        }),
        onKeyDown: Z(i.onKeyDown, (m) => {
          const b = d.current !== "";
          !(m.ctrlKey || m.altKey || m.metaKey) && m.key.length === 1 && f(m.key), !(b && m.key === " ") && JB.includes(m.key) && (p(), m.preventDefault());
        })
      }
    ) });
  }
);
sv.displayName = XM;
var QM = "SelectValue", av = w.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, className: r, style: i, children: o, placeholder: s = "", ...a } = t, l = Ei(QM, n), { onValueNodeHasChildrenChange: c } = l, u = o !== void 0, d = Oe(e, l.onValueNodeChange);
    return ft(() => {
      c(u);
    }, [c, u]), /* @__PURE__ */ v(
      ae.span,
      {
        ...a,
        ref: d,
        style: { pointerEvents: "none" },
        children: l5(l.value) ? /* @__PURE__ */ v(je, { children: s }) : o
      }
    );
  }
);
av.displayName = QM;
var iV = "SelectIcon", lv = w.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, children: r, ...i } = t;
    return /* @__PURE__ */ v(ae.span, { "aria-hidden": !0, ...i, ref: e, children: r || "▼" });
  }
);
lv.displayName = iV;
var oV = "SelectPortal", cv = (t) => /* @__PURE__ */ v(mo, { asChild: !0, ...t });
cv.displayName = oV;
var ro = "SelectContent", uv = w.forwardRef(
  (t, e) => {
    const n = Ei(ro, t.__scopeSelect), [r, i] = w.useState();
    if (ft(() => {
      i(new DocumentFragment());
    }, []), !n.open) {
      const o = r;
      return o ? fs.createPortal(
        /* @__PURE__ */ v(e5, { scope: t.__scopeSelect, children: /* @__PURE__ */ v(hd.Slot, { scope: t.__scopeSelect, children: /* @__PURE__ */ v("div", { children: t.children }) }) }),
        o
      ) : null;
    }
    return /* @__PURE__ */ v(t5, { ...t, ref: e });
  }
);
uv.displayName = ro;
var Bn = 10, [e5, Mi] = Cs(ro), sV = "SelectContentImpl", aV = /* @__PURE__ */ mi("SelectContent.RemoveScroll"), t5 = w.forwardRef(
  (t, e) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: i,
      onEscapeKeyDown: o,
      onPointerDownOutside: s,
      //
      // PopperContent props
      side: a,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: f,
      collisionPadding: h,
      sticky: p,
      hideWhenDetached: m,
      avoidCollisions: b,
      //
      ...y
    } = t, k = Ei(ro, n), [C, x] = w.useState(null), [S, T] = w.useState(null), E = Oe(e, (j) => x(j)), [M, O] = w.useState(null), [L, $] = w.useState(
      null
    ), z = pd(n), [B, A] = w.useState(!1), N = w.useRef(!1);
    w.useEffect(() => {
      if (C) return id(C);
    }, [C]), nd();
    const R = w.useCallback(
      (j) => {
        const [X, ...ie] = z().map((K) => K.ref.current), [ne] = ie.slice(-1), we = document.activeElement;
        for (const K of j)
          if (K === we || (K == null || K.scrollIntoView({ block: "nearest" }), K === X && S && (S.scrollTop = 0), K === ne && S && (S.scrollTop = S.scrollHeight), K == null || K.focus(), document.activeElement !== we)) return;
      },
      [z, S]
    ), _ = w.useCallback(
      () => R([M, C]),
      [R, M, C]
    );
    w.useEffect(() => {
      B && _();
    }, [B, _]);
    const { onOpenChange: D, triggerPointerDownPosRef: q } = k;
    w.useEffect(() => {
      if (C) {
        let j = { x: 0, y: 0 };
        const X = (ne) => {
          var we, K;
          j = {
            x: Math.abs(Math.round(ne.pageX) - (((we = q.current) == null ? void 0 : we.x) ?? 0)),
            y: Math.abs(Math.round(ne.pageY) - (((K = q.current) == null ? void 0 : K.y) ?? 0))
          };
        }, ie = (ne) => {
          j.x <= 10 && j.y <= 10 ? ne.preventDefault() : C.contains(ne.target) || D(!1), document.removeEventListener("pointermove", X), q.current = null;
        };
        return q.current !== null && (document.addEventListener("pointermove", X), document.addEventListener("pointerup", ie, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", X), document.removeEventListener("pointerup", ie, { capture: !0 });
        };
      }
    }, [C, D, q]), w.useEffect(() => {
      const j = () => D(!1);
      return window.addEventListener("blur", j), window.addEventListener("resize", j), () => {
        window.removeEventListener("blur", j), window.removeEventListener("resize", j);
      };
    }, [D]);
    const [V, H] = u5((j) => {
      const X = z().filter((we) => !we.disabled), ie = X.find((we) => we.ref.current === document.activeElement), ne = d5(X, j, ie);
      ne && setTimeout(() => ne.ref.current.focus());
    }), G = w.useCallback(
      (j, X, ie) => {
        const ne = !N.current && !ie;
        (k.value !== void 0 && k.value === X || ne) && (O(j), ne && (N.current = !0));
      },
      [k.value]
    ), Q = w.useCallback(() => C == null ? void 0 : C.focus(), [C]), te = w.useCallback(
      (j, X, ie) => {
        const ne = !N.current && !ie;
        (k.value !== void 0 && k.value === X || ne) && $(j);
      },
      [k.value]
    ), le = r === "popper" ? ym : n5, se = le === ym ? {
      side: a,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: f,
      collisionPadding: h,
      sticky: p,
      hideWhenDetached: m,
      avoidCollisions: b
    } : {};
    return /* @__PURE__ */ v(
      e5,
      {
        scope: n,
        content: C,
        viewport: S,
        onViewportChange: T,
        itemRefCallback: G,
        selectedItem: M,
        onItemLeave: Q,
        itemTextRefCallback: te,
        focusSelectedItem: _,
        selectedItemText: L,
        position: r,
        isPositioned: B,
        searchRef: V,
        children: /* @__PURE__ */ v(Ua, { as: aV, allowPinchZoom: !0, children: /* @__PURE__ */ v(
          ja,
          {
            asChild: !0,
            trapped: k.open,
            onMountAutoFocus: (j) => {
              j.preventDefault();
            },
            onUnmountAutoFocus: Z(i, (j) => {
              var X;
              (X = k.trigger) == null || X.focus({ preventScroll: !0 }), j.preventDefault();
            }),
            children: /* @__PURE__ */ v(
              po,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: o,
                onPointerDownOutside: s,
                onFocusOutside: (j) => j.preventDefault(),
                onDismiss: () => k.onOpenChange(!1),
                children: /* @__PURE__ */ v(
                  le,
                  {
                    role: "listbox",
                    id: k.contentId,
                    "data-state": k.open ? "open" : "closed",
                    dir: k.dir,
                    onContextMenu: (j) => j.preventDefault(),
                    ...y,
                    ...se,
                    onPlaced: () => A(!0),
                    ref: E,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...y.style
                    },
                    onKeyDown: Z(y.onKeyDown, (j) => {
                      const X = j.ctrlKey || j.altKey || j.metaKey;
                      if (j.key === "Tab" && j.preventDefault(), !X && j.key.length === 1 && H(j.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(j.key)) {
                        let ne = z().filter((we) => !we.disabled).map((we) => we.ref.current);
                        if (["ArrowUp", "End"].includes(j.key) && (ne = ne.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(j.key)) {
                          const we = j.target, K = ne.indexOf(we);
                          ne = ne.slice(K + 1);
                        }
                        setTimeout(() => R(ne)), j.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
t5.displayName = sV;
var lV = "SelectItemAlignedPosition", n5 = w.forwardRef((t, e) => {
  const { __scopeSelect: n, onPlaced: r, ...i } = t, o = Ei(ro, n), s = Mi(ro, n), [a, l] = w.useState(null), [c, u] = w.useState(null), d = Oe(e, (E) => u(E)), f = pd(n), h = w.useRef(!1), p = w.useRef(!0), { viewport: m, selectedItem: b, selectedItemText: y, focusSelectedItem: k } = s, C = w.useCallback(() => {
    if (o.trigger && o.valueNode && a && c && m && b && y) {
      const E = o.trigger.getBoundingClientRect(), M = c.getBoundingClientRect(), O = o.valueNode.getBoundingClientRect(), L = y.getBoundingClientRect();
      if (o.dir !== "rtl") {
        const we = L.left - M.left, K = O.left - we, Fe = E.left - K, oe = E.width + Fe, kt = Math.max(oe, M.width), Ot = window.innerWidth - Bn, Zt = Vc(K, [
          Bn,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Bn, Ot - kt)
        ]);
        a.style.minWidth = oe + "px", a.style.left = Zt + "px";
      } else {
        const we = M.right - L.right, K = window.innerWidth - O.right - we, Fe = window.innerWidth - E.right - K, oe = E.width + Fe, kt = Math.max(oe, M.width), Ot = window.innerWidth - Bn, Zt = Vc(K, [
          Bn,
          Math.max(Bn, Ot - kt)
        ]);
        a.style.minWidth = oe + "px", a.style.right = Zt + "px";
      }
      const $ = f(), z = window.innerHeight - Bn * 2, B = m.scrollHeight, A = window.getComputedStyle(c), N = parseInt(A.borderTopWidth, 10), R = parseInt(A.paddingTop, 10), _ = parseInt(A.borderBottomWidth, 10), D = parseInt(A.paddingBottom, 10), q = N + R + B + D + _, V = Math.min(b.offsetHeight * 5, q), H = window.getComputedStyle(m), G = parseInt(H.paddingTop, 10), Q = parseInt(H.paddingBottom, 10), te = E.top + E.height / 2 - Bn, le = z - te, se = b.offsetHeight / 2, j = b.offsetTop + se, X = N + R + j, ie = q - X;
      if (X <= te) {
        const we = $.length > 0 && b === $[$.length - 1].ref.current;
        a.style.bottom = "0px";
        const K = c.clientHeight - m.offsetTop - m.offsetHeight, Fe = Math.max(
          le,
          se + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (we ? Q : 0) + K + _
        ), oe = X + Fe;
        a.style.height = oe + "px";
      } else {
        const we = $.length > 0 && b === $[0].ref.current;
        a.style.top = "0px";
        const Fe = Math.max(
          te,
          N + m.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (we ? G : 0) + se
        ) + ie;
        a.style.height = Fe + "px", m.scrollTop = X - te + m.offsetTop;
      }
      a.style.margin = `${Bn}px 0`, a.style.minHeight = V + "px", a.style.maxHeight = z + "px", r == null || r(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    f,
    o.trigger,
    o.valueNode,
    a,
    c,
    m,
    b,
    y,
    o.dir,
    r
  ]);
  ft(() => C(), [C]);
  const [x, S] = w.useState();
  ft(() => {
    c && S(window.getComputedStyle(c).zIndex);
  }, [c]);
  const T = w.useCallback(
    (E) => {
      E && p.current === !0 && (C(), k == null || k(), p.current = !1);
    },
    [C, k]
  );
  return /* @__PURE__ */ v(
    uV,
    {
      scope: n,
      contentWrapper: a,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: T,
      children: /* @__PURE__ */ v(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: x
          },
          children: /* @__PURE__ */ v(
            ae.div,
            {
              ...i,
              ref: d,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...i.style
              }
            }
          )
        }
      )
    }
  );
});
n5.displayName = lV;
var cV = "SelectPopperPosition", ym = w.forwardRef((t, e) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: i = Bn,
    ...o
  } = t, s = md(n);
  return /* @__PURE__ */ v(
    ld,
    {
      ...s,
      ...o,
      ref: e,
      align: r,
      collisionPadding: i,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...o.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
ym.displayName = cV;
var [uV, dv] = Cs(ro, {}), wm = "SelectViewport", fv = w.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, nonce: r, ...i } = t, o = Mi(wm, n), s = dv(wm, n), a = Oe(e, o.onViewportChange), l = w.useRef(0);
    return /* @__PURE__ */ F(je, { children: [
      /* @__PURE__ */ v(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ v(hd.Slot, { scope: n, children: /* @__PURE__ */ v(
        ae.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...i,
          ref: a,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...i.style
          },
          onScroll: Z(i.onScroll, (c) => {
            const u = c.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: f } = s;
            if (f != null && f.current && d) {
              const h = Math.abs(l.current - u.scrollTop);
              if (h > 0) {
                const p = window.innerHeight - Bn * 2, m = parseFloat(d.style.minHeight), b = parseFloat(d.style.height), y = Math.max(m, b);
                if (y < p) {
                  const k = y + h, C = Math.min(p, k), x = k - C;
                  d.style.height = C + "px", d.style.bottom === "0px" && (u.scrollTop = x > 0 ? x : 0, d.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
fv.displayName = wm;
var r5 = "SelectGroup", [dV, fV] = Cs(r5), hv = w.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t, i = Ut();
    return /* @__PURE__ */ v(dV, { scope: n, id: i, children: /* @__PURE__ */ v(ae.div, { role: "group", "aria-labelledby": i, ...r, ref: e }) });
  }
);
hv.displayName = r5;
var i5 = "SelectLabel", pv = w.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t, i = fV(i5, n);
    return /* @__PURE__ */ v(ae.div, { id: i.id, ...r, ref: e });
  }
);
pv.displayName = i5;
var zc = "SelectItem", [hV, o5] = Cs(zc), mv = w.forwardRef(
  (t, e) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: i = !1,
      textValue: o,
      ...s
    } = t, a = Ei(zc, n), l = Mi(zc, n), c = a.value === r, [u, d] = w.useState(o ?? ""), [f, h] = w.useState(!1), p = Oe(
      e,
      (k) => {
        var C;
        return (C = l.itemRefCallback) == null ? void 0 : C.call(l, k, r, i);
      }
    ), m = Ut(), b = w.useRef("touch"), y = () => {
      i || (a.onValueChange(r), a.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ v(
      hV,
      {
        scope: n,
        value: r,
        disabled: i,
        textId: m,
        isSelected: c,
        onItemTextChange: w.useCallback((k) => {
          d((C) => C || ((k == null ? void 0 : k.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ v(
          hd.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: i,
            textValue: u,
            children: /* @__PURE__ */ v(
              ae.div,
              {
                role: "option",
                "aria-labelledby": m,
                "data-highlighted": f ? "" : void 0,
                "aria-selected": c && f,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": i || void 0,
                "data-disabled": i ? "" : void 0,
                tabIndex: i ? void 0 : -1,
                ...s,
                ref: p,
                onFocus: Z(s.onFocus, () => h(!0)),
                onBlur: Z(s.onBlur, () => h(!1)),
                onClick: Z(s.onClick, () => {
                  b.current !== "mouse" && y();
                }),
                onPointerUp: Z(s.onPointerUp, () => {
                  b.current === "mouse" && y();
                }),
                onPointerDown: Z(s.onPointerDown, (k) => {
                  b.current = k.pointerType;
                }),
                onPointerMove: Z(s.onPointerMove, (k) => {
                  var C;
                  b.current = k.pointerType, i ? (C = l.onItemLeave) == null || C.call(l) : b.current === "mouse" && k.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: Z(s.onPointerLeave, (k) => {
                  var C;
                  k.currentTarget === document.activeElement && ((C = l.onItemLeave) == null || C.call(l));
                }),
                onKeyDown: Z(s.onKeyDown, (k) => {
                  var x;
                  ((x = l.searchRef) == null ? void 0 : x.current) !== "" && k.key === " " || (XB.includes(k.key) && y(), k.key === " " && k.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
mv.displayName = zc;
var Bs = "SelectItemText", gv = w.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, className: r, style: i, ...o } = t, s = Ei(Bs, n), a = Mi(Bs, n), l = o5(Bs, n), c = rV(Bs, n), [u, d] = w.useState(null), f = Oe(
      e,
      (y) => d(y),
      l.onItemTextChange,
      (y) => {
        var k;
        return (k = a.itemTextRefCallback) == null ? void 0 : k.call(a, y, l.value, l.disabled);
      }
    ), h = u == null ? void 0 : u.textContent, p = w.useMemo(
      () => /* @__PURE__ */ v("option", { value: l.value, disabled: l.disabled, children: h }, l.value),
      [l.disabled, l.value, h]
    ), { onNativeOptionAdd: m, onNativeOptionRemove: b } = c;
    return ft(() => (m(p), () => b(p)), [m, b, p]), /* @__PURE__ */ F(je, { children: [
      /* @__PURE__ */ v(ae.span, { id: l.textId, ...o, ref: f }),
      l.isSelected && s.valueNode && !s.valueNodeHasChildren ? fs.createPortal(o.children, s.valueNode) : null
    ] });
  }
);
gv.displayName = Bs;
var s5 = "SelectItemIndicator", vv = w.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t;
    return o5(s5, n).isSelected ? /* @__PURE__ */ v(ae.span, { "aria-hidden": !0, ...r, ref: e }) : null;
  }
);
vv.displayName = s5;
var xm = "SelectScrollUpButton", bv = w.forwardRef((t, e) => {
  const n = Mi(xm, t.__scopeSelect), r = dv(xm, t.__scopeSelect), [i, o] = w.useState(!1), s = Oe(e, r.onScrollButtonChange);
  return ft(() => {
    if (n.viewport && n.isPositioned) {
      let a = function() {
        const c = l.scrollTop > 0;
        o(c);
      };
      const l = n.viewport;
      return a(), l.addEventListener("scroll", a), () => l.removeEventListener("scroll", a);
    }
  }, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ v(
    a5,
    {
      ...t,
      ref: s,
      onAutoScroll: () => {
        const { viewport: a, selectedItem: l } = n;
        a && l && (a.scrollTop = a.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
bv.displayName = xm;
var km = "SelectScrollDownButton", yv = w.forwardRef((t, e) => {
  const n = Mi(km, t.__scopeSelect), r = dv(km, t.__scopeSelect), [i, o] = w.useState(!1), s = Oe(e, r.onScrollButtonChange);
  return ft(() => {
    if (n.viewport && n.isPositioned) {
      let a = function() {
        const c = l.scrollHeight - l.clientHeight, u = Math.ceil(l.scrollTop) < c;
        o(u);
      };
      const l = n.viewport;
      return a(), l.addEventListener("scroll", a), () => l.removeEventListener("scroll", a);
    }
  }, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ v(
    a5,
    {
      ...t,
      ref: s,
      onAutoScroll: () => {
        const { viewport: a, selectedItem: l } = n;
        a && l && (a.scrollTop = a.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
yv.displayName = km;
var a5 = w.forwardRef((t, e) => {
  const { __scopeSelect: n, onAutoScroll: r, ...i } = t, o = Mi("SelectScrollButton", n), s = w.useRef(null), a = pd(n), l = w.useCallback(() => {
    s.current !== null && (window.clearInterval(s.current), s.current = null);
  }, []);
  return w.useEffect(() => () => l(), [l]), ft(() => {
    var u;
    const c = a().find((d) => d.ref.current === document.activeElement);
    (u = c == null ? void 0 : c.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [a]), /* @__PURE__ */ v(
    ae.div,
    {
      "aria-hidden": !0,
      ...i,
      ref: e,
      style: { flexShrink: 0, ...i.style },
      onPointerDown: Z(i.onPointerDown, () => {
        s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerMove: Z(i.onPointerMove, () => {
        var c;
        (c = o.onItemLeave) == null || c.call(o), s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerLeave: Z(i.onPointerLeave, () => {
        l();
      })
    }
  );
}), pV = "SelectSeparator", wv = w.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t;
    return /* @__PURE__ */ v(ae.div, { "aria-hidden": !0, ...r, ref: e });
  }
);
wv.displayName = pV;
var Cm = "SelectArrow", xv = w.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t, i = md(n), o = Ei(Cm, n), s = Mi(Cm, n);
    return o.open && s.position === "popper" ? /* @__PURE__ */ v(cd, { ...i, ...r, ref: e }) : null;
  }
);
xv.displayName = Cm;
function l5(t) {
  return t === "" || t === void 0;
}
var c5 = w.forwardRef(
  (t, e) => {
    const { value: n, ...r } = t, i = w.useRef(null), o = Oe(e, i), s = qa(n);
    return w.useEffect(() => {
      const a = i.current, l = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (s !== n && u) {
        const d = new Event("change", { bubbles: !0 });
        u.call(a, n), a.dispatchEvent(d);
      }
    }, [s, n]), /* @__PURE__ */ v(Ha, { asChild: !0, children: /* @__PURE__ */ v("select", { ...r, ref: o, defaultValue: n }) });
  }
);
c5.displayName = "BubbleSelect";
function u5(t) {
  const e = wt(t), n = w.useRef(""), r = w.useRef(0), i = w.useCallback(
    (s) => {
      const a = n.current + s;
      e(a), function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(a);
    },
    [e]
  ), o = w.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return w.useEffect(() => () => window.clearTimeout(r.current), []), [n, i, o];
}
function d5(t, e, n) {
  const i = e.length > 1 && Array.from(e).every((c) => c === e[0]) ? e[0] : e, o = n ? t.indexOf(n) : -1;
  let s = mV(t, Math.max(o, 0));
  i.length === 1 && (s = s.filter((c) => c !== n));
  const l = s.find(
    (c) => c.textValue.toLowerCase().startsWith(i.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function mV(t, e) {
  return t.map((n, r) => t[(e + r) % t.length]);
}
var f5 = ov, h5 = sv, p5 = av, gV = lv, m5 = cv, g5 = uv, v5 = fv, vV = hv, b5 = pv, y5 = mv, kv = gv, w5 = vv, x5 = bv, k5 = yv, C5 = wv, bV = xv;
const yV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Arrow: bV,
  Content: g5,
  Group: vV,
  Icon: gV,
  Item: y5,
  ItemIndicator: w5,
  ItemText: kv,
  Label: b5,
  Portal: m5,
  Root: f5,
  ScrollDownButton: k5,
  ScrollUpButton: x5,
  Select: ov,
  SelectArrow: xv,
  SelectContent: uv,
  SelectGroup: hv,
  SelectIcon: lv,
  SelectItem: mv,
  SelectItemIndicator: vv,
  SelectItemText: gv,
  SelectLabel: pv,
  SelectPortal: cv,
  SelectScrollDownButton: yv,
  SelectScrollUpButton: bv,
  SelectSeparator: wv,
  SelectTrigger: sv,
  SelectValue: av,
  SelectViewport: fv,
  Separator: C5,
  Trigger: h5,
  Value: p5,
  Viewport: v5,
  createSelectScope: eV
}, Symbol.toStringTag, { value: "Module" }));
var S5 = ["PageUp", "PageDown"], T5 = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], E5 = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, Ss = "Slider", [Sm, wV, xV] = Wa(Ss), [M5, Boe] = mt(Ss, [
  xV
]), [kV, gd] = M5(Ss), O5 = w.forwardRef(
  (t, e) => {
    const {
      name: n,
      min: r = 0,
      max: i = 100,
      step: o = 1,
      orientation: s = "horizontal",
      disabled: a = !1,
      minStepsBetweenThumbs: l = 0,
      defaultValue: c = [r],
      value: u,
      onValueChange: d = () => {
      },
      onValueCommit: f = () => {
      },
      inverted: h = !1,
      form: p,
      ...m
    } = t, b = w.useRef(/* @__PURE__ */ new Set()), y = w.useRef(0), C = s === "horizontal" ? CV : SV, [x = [], S] = qt({
      prop: u,
      defaultProp: c,
      onChange: ($) => {
        var B;
        (B = [...b.current][y.current]) == null || B.focus(), d($);
      }
    }), T = w.useRef(x);
    function E($) {
      const z = AV(x, $);
      L($, z);
    }
    function M($) {
      L($, y.current);
    }
    function O() {
      const $ = T.current[y.current];
      x[y.current] !== $ && f(x);
    }
    function L($, z, { commit: B } = { commit: !1 }) {
      const A = IV(o), N = _V(Math.round(($ - r) / o) * o + r, A), R = Vc(N, [r, i]);
      S((_ = []) => {
        const D = MV(_, R, z);
        if (DV(D, l * o)) {
          y.current = D.indexOf(R);
          const q = String(D) !== String(_);
          return q && B && f(D), q ? D : _;
        } else
          return _;
      });
    }
    return /* @__PURE__ */ v(
      kV,
      {
        scope: t.__scopeSlider,
        name: n,
        disabled: a,
        min: r,
        max: i,
        valueIndexToChangeRef: y,
        thumbs: b.current,
        values: x,
        orientation: s,
        form: p,
        children: /* @__PURE__ */ v(Sm.Provider, { scope: t.__scopeSlider, children: /* @__PURE__ */ v(Sm.Slot, { scope: t.__scopeSlider, children: /* @__PURE__ */ v(
          C,
          {
            "aria-disabled": a,
            "data-disabled": a ? "" : void 0,
            ...m,
            ref: e,
            onPointerDown: Z(m.onPointerDown, () => {
              a || (T.current = x);
            }),
            min: r,
            max: i,
            inverted: h,
            onSlideStart: a ? void 0 : E,
            onSlideMove: a ? void 0 : M,
            onSlideEnd: a ? void 0 : O,
            onHomeKeyDown: () => !a && L(r, 0, { commit: !0 }),
            onEndKeyDown: () => !a && L(i, x.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: $, direction: z }) => {
              if (!a) {
                const N = S5.includes($.key) || $.shiftKey && T5.includes($.key) ? 10 : 1, R = y.current, _ = x[R], D = o * N * z;
                L(_ + D, R, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
O5.displayName = Ss;
var [A5, N5] = M5(Ss, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), CV = w.forwardRef(
  (t, e) => {
    const {
      min: n,
      max: r,
      dir: i,
      inverted: o,
      onSlideStart: s,
      onSlideMove: a,
      onSlideEnd: l,
      onStepKeyDown: c,
      ...u
    } = t, [d, f] = w.useState(null), h = Oe(e, (C) => f(C)), p = w.useRef(void 0), m = ys(i), b = m === "ltr", y = b && !o || !b && o;
    function k(C) {
      const x = p.current || d.getBoundingClientRect(), S = [0, x.width], E = Cv(S, y ? [n, r] : [r, n]);
      return p.current = x, E(C - x.left);
    }
    return /* @__PURE__ */ v(
      A5,
      {
        scope: t.__scopeSlider,
        startEdge: y ? "left" : "right",
        endEdge: y ? "right" : "left",
        direction: y ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ v(
          R5,
          {
            dir: m,
            "data-orientation": "horizontal",
            ...u,
            ref: h,
            style: {
              ...u.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (C) => {
              const x = k(C.clientX);
              s == null || s(x);
            },
            onSlideMove: (C) => {
              const x = k(C.clientX);
              a == null || a(x);
            },
            onSlideEnd: () => {
              p.current = void 0, l == null || l();
            },
            onStepKeyDown: (C) => {
              const S = E5[y ? "from-left" : "from-right"].includes(C.key);
              c == null || c({ event: C, direction: S ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), SV = w.forwardRef(
  (t, e) => {
    const {
      min: n,
      max: r,
      inverted: i,
      onSlideStart: o,
      onSlideMove: s,
      onSlideEnd: a,
      onStepKeyDown: l,
      ...c
    } = t, u = w.useRef(null), d = Oe(e, u), f = w.useRef(void 0), h = !i;
    function p(m) {
      const b = f.current || u.current.getBoundingClientRect(), y = [0, b.height], C = Cv(y, h ? [r, n] : [n, r]);
      return f.current = b, C(m - b.top);
    }
    return /* @__PURE__ */ v(
      A5,
      {
        scope: t.__scopeSlider,
        startEdge: h ? "bottom" : "top",
        endEdge: h ? "top" : "bottom",
        size: "height",
        direction: h ? 1 : -1,
        children: /* @__PURE__ */ v(
          R5,
          {
            "data-orientation": "vertical",
            ...c,
            ref: d,
            style: {
              ...c.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (m) => {
              const b = p(m.clientY);
              o == null || o(b);
            },
            onSlideMove: (m) => {
              const b = p(m.clientY);
              s == null || s(b);
            },
            onSlideEnd: () => {
              f.current = void 0, a == null || a();
            },
            onStepKeyDown: (m) => {
              const y = E5[h ? "from-bottom" : "from-top"].includes(m.key);
              l == null || l({ event: m, direction: y ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), R5 = w.forwardRef(
  (t, e) => {
    const {
      __scopeSlider: n,
      onSlideStart: r,
      onSlideMove: i,
      onSlideEnd: o,
      onHomeKeyDown: s,
      onEndKeyDown: a,
      onStepKeyDown: l,
      ...c
    } = t, u = gd(Ss, n);
    return /* @__PURE__ */ v(
      ae.span,
      {
        ...c,
        ref: e,
        onKeyDown: Z(t.onKeyDown, (d) => {
          d.key === "Home" ? (s(d), d.preventDefault()) : d.key === "End" ? (a(d), d.preventDefault()) : S5.concat(T5).includes(d.key) && (l(d), d.preventDefault());
        }),
        onPointerDown: Z(t.onPointerDown, (d) => {
          const f = d.target;
          f.setPointerCapture(d.pointerId), d.preventDefault(), u.thumbs.has(f) ? f.focus() : r(d);
        }),
        onPointerMove: Z(t.onPointerMove, (d) => {
          d.target.hasPointerCapture(d.pointerId) && i(d);
        }),
        onPointerUp: Z(t.onPointerUp, (d) => {
          const f = d.target;
          f.hasPointerCapture(d.pointerId) && (f.releasePointerCapture(d.pointerId), o(d));
        })
      }
    );
  }
), D5 = "SliderTrack", I5 = w.forwardRef(
  (t, e) => {
    const { __scopeSlider: n, ...r } = t, i = gd(D5, n);
    return /* @__PURE__ */ v(
      ae.span,
      {
        "data-disabled": i.disabled ? "" : void 0,
        "data-orientation": i.orientation,
        ...r,
        ref: e
      }
    );
  }
);
I5.displayName = D5;
var Tm = "SliderRange", _5 = w.forwardRef(
  (t, e) => {
    const { __scopeSlider: n, ...r } = t, i = gd(Tm, n), o = N5(Tm, n), s = w.useRef(null), a = Oe(e, s), l = i.values.length, c = i.values.map(
      (f) => L5(f, i.min, i.max)
    ), u = l > 1 ? Math.min(...c) : 0, d = 100 - Math.max(...c);
    return /* @__PURE__ */ v(
      ae.span,
      {
        "data-orientation": i.orientation,
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: a,
        style: {
          ...t.style,
          [o.startEdge]: u + "%",
          [o.endEdge]: d + "%"
        }
      }
    );
  }
);
_5.displayName = Tm;
var Em = "SliderThumb", P5 = w.forwardRef(
  (t, e) => {
    const n = wV(t.__scopeSlider), [r, i] = w.useState(null), o = Oe(e, (a) => i(a)), s = w.useMemo(
      () => r ? n().findIndex((a) => a.ref.current === r) : -1,
      [n, r]
    );
    return /* @__PURE__ */ v(TV, { ...t, ref: o, index: s });
  }
), TV = w.forwardRef(
  (t, e) => {
    const { __scopeSlider: n, index: r, name: i, ...o } = t, s = gd(Em, n), a = N5(Em, n), [l, c] = w.useState(null), u = Oe(e, (k) => c(k)), d = l ? s.form || !!l.closest("form") : !0, f = Ka(l), h = s.values[r], p = h === void 0 ? 0 : L5(h, s.min, s.max), m = OV(r, s.values.length), b = f == null ? void 0 : f[a.size], y = b ? NV(b, p, a.direction) : 0;
    return w.useEffect(() => {
      if (l)
        return s.thumbs.add(l), () => {
          s.thumbs.delete(l);
        };
    }, [l, s.thumbs]), /* @__PURE__ */ F(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [a.startEdge]: `calc(${p}% + ${y}px)`
        },
        children: [
          /* @__PURE__ */ v(Sm.ItemSlot, { scope: t.__scopeSlider, children: /* @__PURE__ */ v(
            ae.span,
            {
              role: "slider",
              "aria-label": t["aria-label"] || m,
              "aria-valuemin": s.min,
              "aria-valuenow": h,
              "aria-valuemax": s.max,
              "aria-orientation": s.orientation,
              "data-orientation": s.orientation,
              "data-disabled": s.disabled ? "" : void 0,
              tabIndex: s.disabled ? void 0 : 0,
              ...o,
              ref: u,
              style: h === void 0 ? { display: "none" } : t.style,
              onFocus: Z(t.onFocus, () => {
                s.valueIndexToChangeRef.current = r;
              })
            }
          ) }),
          d && /* @__PURE__ */ v(
            EV,
            {
              name: i ?? (s.name ? s.name + (s.values.length > 1 ? "[]" : "") : void 0),
              form: s.form,
              value: h
            },
            r
          )
        ]
      }
    );
  }
);
P5.displayName = Em;
var EV = (t) => {
  const { value: e, ...n } = t, r = w.useRef(null), i = qa(e);
  return w.useEffect(() => {
    const o = r.current, s = window.HTMLInputElement.prototype, l = Object.getOwnPropertyDescriptor(s, "value").set;
    if (i !== e && l) {
      const c = new Event("input", { bubbles: !0 });
      l.call(o, e), o.dispatchEvent(c);
    }
  }, [i, e]), /* @__PURE__ */ v("input", { style: { display: "none" }, ...n, ref: r, defaultValue: e });
};
function MV(t = [], e, n) {
  const r = [...t];
  return r[n] = e, r.sort((i, o) => i - o);
}
function L5(t, e, n) {
  const o = 100 / (n - e) * (t - e);
  return Vc(o, [0, 100]);
}
function OV(t, e) {
  return e > 2 ? `Value ${t + 1} of ${e}` : e === 2 ? ["Minimum", "Maximum"][t] : void 0;
}
function AV(t, e) {
  if (t.length === 1) return 0;
  const n = t.map((i) => Math.abs(i - e)), r = Math.min(...n);
  return n.indexOf(r);
}
function NV(t, e, n) {
  const r = t / 2, o = Cv([0, 50], [0, r]);
  return (r - o(e) * n) * n;
}
function RV(t) {
  return t.slice(0, -1).map((e, n) => t[n + 1] - e);
}
function DV(t, e) {
  if (e > 0) {
    const n = RV(t);
    return Math.min(...n) >= e;
  }
  return !0;
}
function Cv(t, e) {
  return (n) => {
    if (t[0] === t[1] || e[0] === e[1]) return e[0];
    const r = (e[1] - e[0]) / (t[1] - t[0]);
    return e[0] + r * (n - t[0]);
  };
}
function IV(t) {
  return (String(t).split(".")[1] || "").length;
}
function _V(t, e) {
  const n = Math.pow(10, e);
  return Math.round(t * n) / n;
}
var PV = O5, LV = I5, FV = _5, $V = P5, Sv = "Switch", [BV, Voe] = mt(Sv), [VV, zV] = BV(Sv), F5 = w.forwardRef(
  (t, e) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: i,
      defaultChecked: o,
      required: s,
      disabled: a,
      value: l = "on",
      onCheckedChange: c,
      form: u,
      ...d
    } = t, [f, h] = w.useState(null), p = Oe(e, (C) => h(C)), m = w.useRef(!1), b = f ? u || !!f.closest("form") : !0, [y = !1, k] = qt({
      prop: i,
      defaultProp: o,
      onChange: c
    });
    return /* @__PURE__ */ F(VV, { scope: n, checked: y, disabled: a, children: [
      /* @__PURE__ */ v(
        ae.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": y,
          "aria-required": s,
          "data-state": V5(y),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: l,
          ...d,
          ref: p,
          onClick: Z(t.onClick, (C) => {
            k((x) => !x), b && (m.current = C.isPropagationStopped(), m.current || C.stopPropagation());
          })
        }
      ),
      b && /* @__PURE__ */ v(
        HV,
        {
          control: f,
          bubbles: !m.current,
          name: r,
          value: l,
          checked: y,
          required: s,
          disabled: a,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
F5.displayName = Sv;
var $5 = "SwitchThumb", B5 = w.forwardRef(
  (t, e) => {
    const { __scopeSwitch: n, ...r } = t, i = zV($5, n);
    return /* @__PURE__ */ v(
      ae.span,
      {
        "data-state": V5(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: e
      }
    );
  }
);
B5.displayName = $5;
var HV = (t) => {
  const { control: e, checked: n, bubbles: r = !0, ...i } = t, o = w.useRef(null), s = qa(n), a = Ka(e);
  return w.useEffect(() => {
    const l = o.current, c = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(c, "checked").set;
    if (s !== n && d) {
      const f = new Event("click", { bubbles: r });
      d.call(l, n), l.dispatchEvent(f);
    }
  }, [s, n, r]), /* @__PURE__ */ v(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...i,
      tabIndex: -1,
      ref: o,
      style: {
        ...t.style,
        ...a,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function V5(t) {
  return t ? "checked" : "unchecked";
}
var WV = F5, jV = B5, Tv = "Tabs", [UV, zoe] = mt(Tv, [
  ks
]), z5 = ks(), [qV, Ev] = UV(Tv), H5 = w.forwardRef(
  (t, e) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: i,
      defaultValue: o,
      orientation: s = "horizontal",
      dir: a,
      activationMode: l = "automatic",
      ...c
    } = t, u = ys(a), [d, f] = qt({
      prop: r,
      onChange: i,
      defaultProp: o
    });
    return /* @__PURE__ */ v(
      qV,
      {
        scope: n,
        baseId: Ut(),
        value: d,
        onValueChange: f,
        orientation: s,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ v(
          ae.div,
          {
            dir: u,
            "data-orientation": s,
            ...c,
            ref: e
          }
        )
      }
    );
  }
);
H5.displayName = Tv;
var W5 = "TabsList", j5 = w.forwardRef(
  (t, e) => {
    const { __scopeTabs: n, loop: r = !0, ...i } = t, o = Ev(W5, n), s = z5(n);
    return /* @__PURE__ */ v(
      Mg,
      {
        asChild: !0,
        ...s,
        orientation: o.orientation,
        dir: o.dir,
        loop: r,
        children: /* @__PURE__ */ v(
          ae.div,
          {
            role: "tablist",
            "aria-orientation": o.orientation,
            ...i,
            ref: e
          }
        )
      }
    );
  }
);
j5.displayName = W5;
var U5 = "TabsTrigger", q5 = w.forwardRef(
  (t, e) => {
    const { __scopeTabs: n, value: r, disabled: i = !1, ...o } = t, s = Ev(U5, n), a = z5(n), l = Y5(s.baseId, r), c = Z5(s.baseId, r), u = r === s.value;
    return /* @__PURE__ */ v(
      Og,
      {
        asChild: !0,
        ...a,
        focusable: !i,
        active: u,
        children: /* @__PURE__ */ v(
          ae.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": i ? "" : void 0,
            disabled: i,
            id: l,
            ...o,
            ref: e,
            onMouseDown: Z(t.onMouseDown, (d) => {
              !i && d.button === 0 && d.ctrlKey === !1 ? s.onValueChange(r) : d.preventDefault();
            }),
            onKeyDown: Z(t.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && s.onValueChange(r);
            }),
            onFocus: Z(t.onFocus, () => {
              const d = s.activationMode !== "manual";
              !u && !i && d && s.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
q5.displayName = U5;
var K5 = "TabsContent", G5 = w.forwardRef(
  (t, e) => {
    const { __scopeTabs: n, value: r, forceMount: i, children: o, ...s } = t, a = Ev(K5, n), l = Y5(a.baseId, r), c = Z5(a.baseId, r), u = r === a.value, d = w.useRef(u);
    return w.useEffect(() => {
      const f = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(f);
    }, []), /* @__PURE__ */ v(Mt, { present: i || u, children: ({ present: f }) => /* @__PURE__ */ v(
      ae.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": a.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !f,
        id: c,
        tabIndex: 0,
        ...s,
        ref: e,
        style: {
          ...t.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: f && o
      }
    ) });
  }
);
G5.displayName = K5;
function Y5(t, e) {
  return `${t}-trigger-${e}`;
}
function Z5(t, e) {
  return `${t}-content-${e}`;
}
var KV = H5, Vw = j5, zw = q5, GV = G5, Mv = "ToastProvider", [Ov, YV, ZV] = Wa("Toast"), [J5, Hoe] = mt("Toast", [ZV]), [JV, vd] = J5(Mv), X5 = (t) => {
  const {
    __scopeToast: e,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: i = "right",
    swipeThreshold: o = 50,
    children: s
  } = t, [a, l] = w.useState(null), [c, u] = w.useState(0), d = w.useRef(!1), f = w.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${Mv}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ v(Ov.Provider, { scope: e, children: /* @__PURE__ */ v(
    JV,
    {
      scope: e,
      label: n,
      duration: r,
      swipeDirection: i,
      swipeThreshold: o,
      toastCount: c,
      viewport: a,
      onViewportChange: l,
      onToastAdd: w.useCallback(() => u((h) => h + 1), []),
      onToastRemove: w.useCallback(() => u((h) => h - 1), []),
      isFocusedToastEscapeKeyDownRef: d,
      isClosePausedRef: f,
      children: s
    }
  ) });
};
X5.displayName = Mv;
var Q5 = "ToastViewport", XV = ["F8"], Mm = "toast.viewportPause", Om = "toast.viewportResume", eO = w.forwardRef(
  (t, e) => {
    const {
      __scopeToast: n,
      hotkey: r = XV,
      label: i = "Notifications ({hotkey})",
      ...o
    } = t, s = vd(Q5, n), a = YV(n), l = w.useRef(null), c = w.useRef(null), u = w.useRef(null), d = w.useRef(null), f = Oe(e, d, s.onViewportChange), h = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), p = s.toastCount > 0;
    w.useEffect(() => {
      const b = (y) => {
        var C;
        r.length !== 0 && r.every((x) => y[x] || y.code === x) && ((C = d.current) == null || C.focus());
      };
      return document.addEventListener("keydown", b), () => document.removeEventListener("keydown", b);
    }, [r]), w.useEffect(() => {
      const b = l.current, y = d.current;
      if (p && b && y) {
        const k = () => {
          if (!s.isClosePausedRef.current) {
            const T = new CustomEvent(Mm);
            y.dispatchEvent(T), s.isClosePausedRef.current = !0;
          }
        }, C = () => {
          if (s.isClosePausedRef.current) {
            const T = new CustomEvent(Om);
            y.dispatchEvent(T), s.isClosePausedRef.current = !1;
          }
        }, x = (T) => {
          !b.contains(T.relatedTarget) && C();
        }, S = () => {
          b.contains(document.activeElement) || C();
        };
        return b.addEventListener("focusin", k), b.addEventListener("focusout", x), b.addEventListener("pointermove", k), b.addEventListener("pointerleave", S), window.addEventListener("blur", k), window.addEventListener("focus", C), () => {
          b.removeEventListener("focusin", k), b.removeEventListener("focusout", x), b.removeEventListener("pointermove", k), b.removeEventListener("pointerleave", S), window.removeEventListener("blur", k), window.removeEventListener("focus", C);
        };
      }
    }, [p, s.isClosePausedRef]);
    const m = w.useCallback(
      ({ tabbingDirection: b }) => {
        const k = a().map((C) => {
          const x = C.ref.current, S = [x, ...hz(x)];
          return b === "forwards" ? S : S.reverse();
        });
        return (b === "forwards" ? k.reverse() : k).flat();
      },
      [a]
    );
    return w.useEffect(() => {
      const b = d.current;
      if (b) {
        const y = (k) => {
          var S, T, E;
          const C = k.altKey || k.ctrlKey || k.metaKey;
          if (k.key === "Tab" && !C) {
            const M = document.activeElement, O = k.shiftKey;
            if (k.target === b && O) {
              (S = c.current) == null || S.focus();
              return;
            }
            const z = m({ tabbingDirection: O ? "backwards" : "forwards" }), B = z.findIndex((A) => A === M);
            Hh(z.slice(B + 1)) ? k.preventDefault() : O ? (T = c.current) == null || T.focus() : (E = u.current) == null || E.focus();
          }
        };
        return b.addEventListener("keydown", y), () => b.removeEventListener("keydown", y);
      }
    }, [a, m]), /* @__PURE__ */ F(
      NF,
      {
        ref: l,
        role: "region",
        "aria-label": i.replace("{hotkey}", h),
        tabIndex: -1,
        style: { pointerEvents: p ? void 0 : "none" },
        children: [
          p && /* @__PURE__ */ v(
            Am,
            {
              ref: c,
              onFocusFromOutsideViewport: () => {
                const b = m({
                  tabbingDirection: "forwards"
                });
                Hh(b);
              }
            }
          ),
          /* @__PURE__ */ v(Ov.Slot, { scope: n, children: /* @__PURE__ */ v(ae.ol, { tabIndex: -1, ...o, ref: f }) }),
          p && /* @__PURE__ */ v(
            Am,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const b = m({
                  tabbingDirection: "backwards"
                });
                Hh(b);
              }
            }
          )
        ]
      }
    );
  }
);
eO.displayName = Q5;
var tO = "ToastFocusProxy", Am = w.forwardRef(
  (t, e) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...i } = t, o = vd(tO, n);
    return /* @__PURE__ */ v(
      Ha,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...i,
        ref: e,
        style: { position: "fixed" },
        onFocus: (s) => {
          var c;
          const a = s.relatedTarget;
          !((c = o.viewport) != null && c.contains(a)) && r();
        }
      }
    );
  }
);
Am.displayName = tO;
var bd = "Toast", QV = "toast.swipeStart", ez = "toast.swipeMove", tz = "toast.swipeCancel", nz = "toast.swipeEnd", nO = w.forwardRef(
  (t, e) => {
    const { forceMount: n, open: r, defaultOpen: i, onOpenChange: o, ...s } = t, [a = !0, l] = qt({
      prop: r,
      defaultProp: i,
      onChange: o
    });
    return /* @__PURE__ */ v(Mt, { present: n || a, children: /* @__PURE__ */ v(
      oz,
      {
        open: a,
        ...s,
        ref: e,
        onClose: () => l(!1),
        onPause: wt(t.onPause),
        onResume: wt(t.onResume),
        onSwipeStart: Z(t.onSwipeStart, (c) => {
          c.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: Z(t.onSwipeMove, (c) => {
          const { x: u, y: d } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "move"), c.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${u}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${d}px`);
        }),
        onSwipeCancel: Z(t.onSwipeCancel, (c) => {
          c.currentTarget.setAttribute("data-swipe", "cancel"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: Z(t.onSwipeEnd, (c) => {
          const { x: u, y: d } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "end"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${u}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${d}px`), l(!1);
        })
      }
    ) });
  }
);
nO.displayName = bd;
var [rz, iz] = J5(bd, {
  onClose() {
  }
}), oz = w.forwardRef(
  (t, e) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: i,
      open: o,
      onClose: s,
      onEscapeKeyDown: a,
      onPause: l,
      onResume: c,
      onSwipeStart: u,
      onSwipeMove: d,
      onSwipeCancel: f,
      onSwipeEnd: h,
      ...p
    } = t, m = vd(bd, n), [b, y] = w.useState(null), k = Oe(e, (A) => y(A)), C = w.useRef(null), x = w.useRef(null), S = i || m.duration, T = w.useRef(0), E = w.useRef(S), M = w.useRef(0), { onToastAdd: O, onToastRemove: L } = m, $ = wt(() => {
      var N;
      (b == null ? void 0 : b.contains(document.activeElement)) && ((N = m.viewport) == null || N.focus()), s();
    }), z = w.useCallback(
      (A) => {
        !A || A === 1 / 0 || (window.clearTimeout(M.current), T.current = (/* @__PURE__ */ new Date()).getTime(), M.current = window.setTimeout($, A));
      },
      [$]
    );
    w.useEffect(() => {
      const A = m.viewport;
      if (A) {
        const N = () => {
          z(E.current), c == null || c();
        }, R = () => {
          const _ = (/* @__PURE__ */ new Date()).getTime() - T.current;
          E.current = E.current - _, window.clearTimeout(M.current), l == null || l();
        };
        return A.addEventListener(Mm, R), A.addEventListener(Om, N), () => {
          A.removeEventListener(Mm, R), A.removeEventListener(Om, N);
        };
      }
    }, [m.viewport, S, l, c, z]), w.useEffect(() => {
      o && !m.isClosePausedRef.current && z(S);
    }, [o, S, m.isClosePausedRef, z]), w.useEffect(() => (O(), () => L()), [O, L]);
    const B = w.useMemo(() => b ? lO(b) : null, [b]);
    return m.viewport ? /* @__PURE__ */ F(je, { children: [
      B && /* @__PURE__ */ v(
        sz,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: B
        }
      ),
      /* @__PURE__ */ v(rz, { scope: n, onClose: $, children: fs.createPortal(
        /* @__PURE__ */ v(Ov.ItemSlot, { scope: n, children: /* @__PURE__ */ v(
          AF,
          {
            asChild: !0,
            onEscapeKeyDown: Z(a, () => {
              m.isFocusedToastEscapeKeyDownRef.current || $(), m.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ v(
              ae.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": o ? "open" : "closed",
                "data-swipe-direction": m.swipeDirection,
                ...p,
                ref: k,
                style: { userSelect: "none", touchAction: "none", ...t.style },
                onKeyDown: Z(t.onKeyDown, (A) => {
                  A.key === "Escape" && (a == null || a(A.nativeEvent), A.nativeEvent.defaultPrevented || (m.isFocusedToastEscapeKeyDownRef.current = !0, $()));
                }),
                onPointerDown: Z(t.onPointerDown, (A) => {
                  A.button === 0 && (C.current = { x: A.clientX, y: A.clientY });
                }),
                onPointerMove: Z(t.onPointerMove, (A) => {
                  if (!C.current) return;
                  const N = A.clientX - C.current.x, R = A.clientY - C.current.y, _ = !!x.current, D = ["left", "right"].includes(m.swipeDirection), q = ["left", "up"].includes(m.swipeDirection) ? Math.min : Math.max, V = D ? q(0, N) : 0, H = D ? 0 : q(0, R), G = A.pointerType === "touch" ? 10 : 2, Q = { x: V, y: H }, te = { originalEvent: A, delta: Q };
                  _ ? (x.current = Q, Pl(ez, d, te, {
                    discrete: !1
                  })) : Hw(Q, m.swipeDirection, G) ? (x.current = Q, Pl(QV, u, te, {
                    discrete: !1
                  }), A.target.setPointerCapture(A.pointerId)) : (Math.abs(N) > G || Math.abs(R) > G) && (C.current = null);
                }),
                onPointerUp: Z(t.onPointerUp, (A) => {
                  const N = x.current, R = A.target;
                  if (R.hasPointerCapture(A.pointerId) && R.releasePointerCapture(A.pointerId), x.current = null, C.current = null, N) {
                    const _ = A.currentTarget, D = { originalEvent: A, delta: N };
                    Hw(N, m.swipeDirection, m.swipeThreshold) ? Pl(nz, h, D, {
                      discrete: !0
                    }) : Pl(
                      tz,
                      f,
                      D,
                      {
                        discrete: !0
                      }
                    ), _.addEventListener("click", (q) => q.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        m.viewport
      ) })
    ] }) : null;
  }
), sz = (t) => {
  const { __scopeToast: e, children: n, ...r } = t, i = vd(bd, e), [o, s] = w.useState(!1), [a, l] = w.useState(!1);
  return dz(() => s(!0)), w.useEffect(() => {
    const c = window.setTimeout(() => l(!0), 1e3);
    return () => window.clearTimeout(c);
  }, []), a ? null : /* @__PURE__ */ v(mo, { asChild: !0, children: /* @__PURE__ */ v(Ha, { ...r, children: o && /* @__PURE__ */ F(je, { children: [
    i.label,
    " ",
    n
  ] }) }) });
}, az = "ToastTitle", rO = w.forwardRef(
  (t, e) => {
    const { __scopeToast: n, ...r } = t;
    return /* @__PURE__ */ v(ae.div, { ...r, ref: e });
  }
);
rO.displayName = az;
var lz = "ToastDescription", cz = w.forwardRef(
  (t, e) => {
    const { __scopeToast: n, ...r } = t;
    return /* @__PURE__ */ v(ae.div, { ...r, ref: e });
  }
);
cz.displayName = lz;
var iO = "ToastAction", uz = w.forwardRef(
  (t, e) => {
    const { altText: n, ...r } = t;
    return n.trim() ? /* @__PURE__ */ v(aO, { altText: n, asChild: !0, children: /* @__PURE__ */ v(sO, { ...r, ref: e }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${iO}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
uz.displayName = iO;
var oO = "ToastClose", sO = w.forwardRef(
  (t, e) => {
    const { __scopeToast: n, ...r } = t, i = iz(oO, n);
    return /* @__PURE__ */ v(aO, { asChild: !0, children: /* @__PURE__ */ v(
      ae.button,
      {
        type: "button",
        ...r,
        ref: e,
        onClick: Z(t.onClick, i.onClose)
      }
    ) });
  }
);
sO.displayName = oO;
var aO = w.forwardRef((t, e) => {
  const { __scopeToast: n, altText: r, ...i } = t;
  return /* @__PURE__ */ v(
    ae.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...i,
      ref: e
    }
  );
});
function lO(t) {
  const e = [];
  return Array.from(t.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && e.push(r.textContent), fz(r)) {
      const i = r.ariaHidden || r.hidden || r.style.display === "none", o = r.dataset.radixToastAnnounceExclude === "";
      if (!i)
        if (o) {
          const s = r.dataset.radixToastAnnounceAlt;
          s && e.push(s);
        } else
          e.push(...lO(r));
    }
  }), e;
}
function Pl(t, e, n, { discrete: r }) {
  const i = n.originalEvent.currentTarget, o = new CustomEvent(t, { bubbles: !0, cancelable: !0, detail: n });
  e && i.addEventListener(t, e, { once: !0 }), r ? X0(i, o) : i.dispatchEvent(o);
}
var Hw = (t, e, n = 0) => {
  const r = Math.abs(t.x), i = Math.abs(t.y), o = r > i;
  return e === "left" || e === "right" ? o && r > n : !o && i > n;
};
function dz(t = () => {
}) {
  const e = wt(t);
  ft(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(e)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [e]);
}
function fz(t) {
  return t.nodeType === t.ELEMENT_NODE;
}
function hz(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
function Hh(t) {
  const e = document.activeElement;
  return t.some((n) => n === e ? !0 : (n.focus(), document.activeElement !== e));
}
var pz = X5, mz = eO, gz = nO, vz = rO, [yd, Woe] = mt("Tooltip", [
  Ci
]), wd = Ci(), cO = "TooltipProvider", bz = 700, Nm = "tooltip.open", [yz, Av] = yd(cO), uO = (t) => {
  const {
    __scopeTooltip: e,
    delayDuration: n = bz,
    skipDelayDuration: r = 300,
    disableHoverableContent: i = !1,
    children: o
  } = t, s = w.useRef(!0), a = w.useRef(!1), l = w.useRef(0);
  return w.useEffect(() => {
    const c = l.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ v(
    yz,
    {
      scope: e,
      isOpenDelayedRef: s,
      delayDuration: n,
      onOpen: w.useCallback(() => {
        window.clearTimeout(l.current), s.current = !1;
      }, []),
      onClose: w.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => s.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: a,
      onPointerInTransitChange: w.useCallback((c) => {
        a.current = c;
      }, []),
      disableHoverableContent: i,
      children: o
    }
  );
};
uO.displayName = cO;
var xd = "Tooltip", [wz, nl] = yd(xd), dO = (t) => {
  const {
    __scopeTooltip: e,
    children: n,
    open: r,
    defaultOpen: i = !1,
    onOpenChange: o,
    disableHoverableContent: s,
    delayDuration: a
  } = t, l = Av(xd, t.__scopeTooltip), c = wd(e), [u, d] = w.useState(null), f = Ut(), h = w.useRef(0), p = s ?? l.disableHoverableContent, m = a ?? l.delayDuration, b = w.useRef(!1), [y = !1, k] = qt({
    prop: r,
    defaultProp: i,
    onChange: (E) => {
      E ? (l.onOpen(), document.dispatchEvent(new CustomEvent(Nm))) : l.onClose(), o == null || o(E);
    }
  }), C = w.useMemo(() => y ? b.current ? "delayed-open" : "instant-open" : "closed", [y]), x = w.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, b.current = !1, k(!0);
  }, [k]), S = w.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, k(!1);
  }, [k]), T = w.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      b.current = !0, k(!0), h.current = 0;
    }, m);
  }, [m, k]);
  return w.useEffect(() => () => {
    h.current && (window.clearTimeout(h.current), h.current = 0);
  }, []), /* @__PURE__ */ v(Ya, { ...c, children: /* @__PURE__ */ v(
    wz,
    {
      scope: e,
      contentId: f,
      open: y,
      stateAttribute: C,
      trigger: u,
      onTriggerChange: d,
      onTriggerEnter: w.useCallback(() => {
        l.isOpenDelayedRef.current ? T() : x();
      }, [l.isOpenDelayedRef, T, x]),
      onTriggerLeave: w.useCallback(() => {
        p ? S() : (window.clearTimeout(h.current), h.current = 0);
      }, [S, p]),
      onOpen: x,
      onClose: S,
      disableHoverableContent: p,
      children: n
    }
  ) });
};
dO.displayName = xd;
var Rm = "TooltipTrigger", fO = w.forwardRef(
  (t, e) => {
    const { __scopeTooltip: n, ...r } = t, i = nl(Rm, n), o = Av(Rm, n), s = wd(n), a = w.useRef(null), l = Oe(e, a, i.onTriggerChange), c = w.useRef(!1), u = w.useRef(!1), d = w.useCallback(() => c.current = !1, []);
    return w.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ v(Za, { asChild: !0, ...s, children: /* @__PURE__ */ v(
      ae.button,
      {
        "aria-describedby": i.open ? i.contentId : void 0,
        "data-state": i.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: Z(t.onPointerMove, (f) => {
          f.pointerType !== "touch" && !u.current && !o.isPointerInTransitRef.current && (i.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: Z(t.onPointerLeave, () => {
          i.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: Z(t.onPointerDown, () => {
          i.open && i.onClose(), c.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: Z(t.onFocus, () => {
          c.current || i.onOpen();
        }),
        onBlur: Z(t.onBlur, i.onClose),
        onClick: Z(t.onClick, i.onClose)
      }
    ) });
  }
);
fO.displayName = Rm;
var Nv = "TooltipPortal", [xz, kz] = yd(Nv, {
  forceMount: void 0
}), hO = (t) => {
  const { __scopeTooltip: e, forceMount: n, children: r, container: i } = t, o = nl(Nv, e);
  return /* @__PURE__ */ v(xz, { scope: e, forceMount: n, children: /* @__PURE__ */ v(Mt, { present: n || o.open, children: /* @__PURE__ */ v(mo, { asChild: !0, container: i, children: r }) }) });
};
hO.displayName = Nv;
var Qo = "TooltipContent", pO = w.forwardRef(
  (t, e) => {
    const n = kz(Qo, t.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...o } = t, s = nl(Qo, t.__scopeTooltip);
    return /* @__PURE__ */ v(Mt, { present: r || s.open, children: s.disableHoverableContent ? /* @__PURE__ */ v(mO, { side: i, ...o, ref: e }) : /* @__PURE__ */ v(Cz, { side: i, ...o, ref: e }) });
  }
), Cz = w.forwardRef((t, e) => {
  const n = nl(Qo, t.__scopeTooltip), r = Av(Qo, t.__scopeTooltip), i = w.useRef(null), o = Oe(e, i), [s, a] = w.useState(null), { trigger: l, onClose: c } = n, u = i.current, { onPointerInTransitChange: d } = r, f = w.useCallback(() => {
    a(null), d(!1);
  }, [d]), h = w.useCallback(
    (p, m) => {
      const b = p.currentTarget, y = { x: p.clientX, y: p.clientY }, k = Oz(y, b.getBoundingClientRect()), C = Az(y, k), x = Nz(m.getBoundingClientRect()), S = Dz([...C, ...x]);
      a(S), d(!0);
    },
    [d]
  );
  return w.useEffect(() => () => f(), [f]), w.useEffect(() => {
    if (l && u) {
      const p = (b) => h(b, u), m = (b) => h(b, l);
      return l.addEventListener("pointerleave", p), u.addEventListener("pointerleave", m), () => {
        l.removeEventListener("pointerleave", p), u.removeEventListener("pointerleave", m);
      };
    }
  }, [l, u, h, f]), w.useEffect(() => {
    if (s) {
      const p = (m) => {
        const b = m.target, y = { x: m.clientX, y: m.clientY }, k = (l == null ? void 0 : l.contains(b)) || (u == null ? void 0 : u.contains(b)), C = !Rz(y, s);
        k ? f() : C && (f(), c());
      };
      return document.addEventListener("pointermove", p), () => document.removeEventListener("pointermove", p);
    }
  }, [l, u, s, c, f]), /* @__PURE__ */ v(mO, { ...t, ref: o });
}), [Sz, Tz] = yd(xd, { isInside: !1 }), Ez = /* @__PURE__ */ MD("TooltipContent"), mO = w.forwardRef(
  (t, e) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": i,
      onEscapeKeyDown: o,
      onPointerDownOutside: s,
      ...a
    } = t, l = nl(Qo, n), c = wd(n), { onClose: u } = l;
    return w.useEffect(() => (document.addEventListener(Nm, u), () => document.removeEventListener(Nm, u)), [u]), w.useEffect(() => {
      if (l.trigger) {
        const d = (f) => {
          const h = f.target;
          h != null && h.contains(l.trigger) && u();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [l.trigger, u]), /* @__PURE__ */ v(
      po,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: o,
        onPointerDownOutside: s,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ F(
          ld,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...a,
            ref: e,
            style: {
              ...a.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ v(Ez, { children: r }),
              /* @__PURE__ */ v(Sz, { scope: n, isInside: !0, children: /* @__PURE__ */ v(oF, { id: l.contentId, role: "tooltip", children: i || r }) })
            ]
          }
        )
      }
    );
  }
);
pO.displayName = Qo;
var gO = "TooltipArrow", Mz = w.forwardRef(
  (t, e) => {
    const { __scopeTooltip: n, ...r } = t, i = wd(n);
    return Tz(
      gO,
      n
    ).isInside ? null : /* @__PURE__ */ v(cd, { ...i, ...r, ref: e });
  }
);
Mz.displayName = gO;
function Oz(t, e) {
  const n = Math.abs(e.top - t.y), r = Math.abs(e.bottom - t.y), i = Math.abs(e.right - t.x), o = Math.abs(e.left - t.x);
  switch (Math.min(n, r, i, o)) {
    case o:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Az(t, e, n = 5) {
  const r = [];
  switch (e) {
    case "top":
      r.push(
        { x: t.x - n, y: t.y + n },
        { x: t.x + n, y: t.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: t.x - n, y: t.y - n },
        { x: t.x + n, y: t.y - n }
      );
      break;
    case "left":
      r.push(
        { x: t.x + n, y: t.y - n },
        { x: t.x + n, y: t.y + n }
      );
      break;
    case "right":
      r.push(
        { x: t.x - n, y: t.y - n },
        { x: t.x - n, y: t.y + n }
      );
      break;
  }
  return r;
}
function Nz(t) {
  const { top: e, right: n, bottom: r, left: i } = t;
  return [
    { x: i, y: e },
    { x: n, y: e },
    { x: n, y: r },
    { x: i, y: r }
  ];
}
function Rz(t, e) {
  const { x: n, y: r } = t;
  let i = !1;
  for (let o = 0, s = e.length - 1; o < e.length; s = o++) {
    const a = e[o].x, l = e[o].y, c = e[s].x, u = e[s].y;
    l > r != u > r && n < (c - a) * (r - l) / (u - l) + a && (i = !i);
  }
  return i;
}
function Dz(t) {
  const e = t.slice();
  return e.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), Iz(e);
}
function Iz(t) {
  if (t.length <= 1) return t.slice();
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    for (; e.length >= 2; ) {
      const o = e[e.length - 1], s = e[e.length - 2];
      if ((o.x - s.x) * (i.y - s.y) >= (o.y - s.y) * (i.x - s.x)) e.pop();
      else break;
    }
    e.push(i);
  }
  e.pop();
  const n = [];
  for (let r = t.length - 1; r >= 0; r--) {
    const i = t[r];
    for (; n.length >= 2; ) {
      const o = n[n.length - 1], s = n[n.length - 2];
      if ((o.x - s.x) * (i.y - s.y) >= (o.y - s.y) * (i.x - s.x)) n.pop();
      else break;
    }
    n.push(i);
  }
  return n.pop(), e.length === 1 && n.length === 1 && e[0].x === n[0].x && e[0].y === n[0].y ? e : e.concat(n);
}
var vO = uO, _z = dO, Pz = fO, bO = hO, Lz = pO;
const Fz = 1, $z = 1e6;
let Wh = 0;
function Bz() {
  return Wh = (Wh + 1) % Number.MAX_SAFE_INTEGER, Wh.toString();
}
const jh = /* @__PURE__ */ new Map(), Ww = (t) => {
  if (jh.has(t))
    return;
  const e = setTimeout(() => {
    jh.delete(t), Ys({
      type: "REMOVE_TOAST",
      toastId: t
    });
  }, $z);
  jh.set(t, e);
}, Vz = (t, e) => {
  switch (e.type) {
    case "ADD_TOAST":
      return {
        ...t,
        toasts: [e.toast, ...t.toasts].slice(0, Fz)
      };
    case "UPDATE_TOAST":
      return {
        ...t,
        toasts: t.toasts.map((n) => n.id === e.toast.id ? { ...n, ...e.toast } : n)
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = e;
      return n ? Ww(n) : t.toasts.forEach((r) => {
        Ww(r.id);
      }), {
        ...t,
        toasts: t.toasts.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_TOAST":
      return e.toastId === void 0 ? {
        ...t,
        toasts: []
      } : {
        ...t,
        toasts: t.toasts.filter((n) => n.id !== e.toastId)
      };
    default:
      return {
        ...t,
        toasts: []
      };
  }
}, uc = [];
let dc = { toasts: [] };
function Ys(t) {
  dc = Vz(dc, t), uc.forEach((e) => {
    e(dc);
  });
}
function zz({ ...t }) {
  const e = Bz(), n = (i) => Ys({
    type: "UPDATE_TOAST",
    toast: { ...i, id: e }
  }), r = () => Ys({ type: "DISMISS_TOAST", toastId: e });
  return Ys({
    type: "ADD_TOAST",
    toast: {
      ...t,
      id: e,
      open: !0,
      onOpenChange: (i) => {
        i || r();
      }
    }
  }), {
    id: e,
    dismiss: r,
    update: n
  };
}
function Rv() {
  const [t, e] = w.useState(dc);
  return w.useEffect(() => (uc.push(e), () => {
    const n = uc.indexOf(e);
    n > -1 && uc.splice(n, 1);
  }), [t]), {
    ...t,
    presentToast: zz,
    dismiss: (n) => Ys({ type: "DISMISS_TOAST", toastId: n })
  };
}
const yO = pz, Hz = {
  intent: {
    success: ["bg-success", "text-success-emphasis"],
    warning: ["bg-warning", "text-warning-emphasis"],
    destructive: ["bg-destructive", "text-destructive-emphasis"]
  }
}, jw = {
  base: [
    "relative",
    "pointer-events-auto",
    "flex",
    "items-center",
    "justify-center",
    "overflow-hidden",
    "py-3",
    "px-4",
    "m-6",
    "transition-all",
    "bg-intense",
    "text-inverted",
    "data-[swipe=move]:transition-none",
    "data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)]",
    "data-[swipe=cancel]:translate-x-0",
    "data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)]",
    "data-[swipe=end]:animate-out",
    "data-[state=closed]:animate-out",
    "data-[state=closed]:fade-out-60",
    "data-[state=closed]:sm:fade-out-10",
    "data-[state=closed]:slide-out-to-right",
    "data-[state=closed]:sm:slide-out-to-right-[30vw]",
    "data-[state=open]:animate-in",
    "data-[state=open]:slide-in-from-bottom-full"
  ],
  config: { variants: Hz }
}, Wz = {
  name: "toast-viewport",
  base: [
    "fixed",
    "bottom-0",
    "left-0",
    "right-0",
    "z-[100]",
    "m-auto",
    "flex",
    "max-h-screen",
    "w-fit",
    "flex-col-reverse"
  ],
  config: {}
}, jz = Ie(jw.base, jw.config);
function Dv({ children: t, className: e, intent: n, isDismissable: r = !1, ...i }, o) {
  const { dismiss: s } = Rv(), a = xe();
  return /* @__PURE__ */ v(
    gz,
    {
      "data-testid": "asterisk-toast",
      ref: o,
      className: I(
        "kn-toast pointer-events-none",
        jz({ intent: n }),
        {
          "rounded-xl": a.theme.appearance.corners === "rounded"
        },
        e
      ),
      ...i,
      children: /* @__PURE__ */ F("div", { className: "flex items-center gap-2", children: [
        t,
        r && /* @__PURE__ */ v(
          "button",
          {
            onClick: () => s(i.id),
            type: "button",
            "aria-label": "Close Toast",
            "data-testid": "asterisk-toast-close-button",
            children: /* @__PURE__ */ v(Vr, { size: 16 })
          }
        )
      ] })
    }
  );
}
function wO({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    mz,
    {
      "data-testid": "asterisk-toast-viewport",
      className: I(
        "kn-toast-viewport pointer-events-none",
        Wz.base.join(" "),
        t
      ),
      ref: n,
      ...e
    }
  );
}
function xO({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    vz,
    {
      "data-testid": "asterisk-toast-title",
      className: I(t),
      ref: n,
      ...e
    }
  );
}
const Uz = ce(Dv), Ll = Object.assign(Uz, {
  Toast: ce(Dv),
  Title: ce(xO),
  Viewport: ce(wO),
  Provider: yO
});
yO.displayName = "Toast.Provider";
Dv.displayName = "Toast";
wO.displayName = "Toast.Viewport";
xO.displayName = "Toast.Title";
function joe() {
  const { toasts: t } = Rv();
  return /* @__PURE__ */ F(Ll.Provider, { children: [
    t.map(({ id: e, title: n, content: r, ...i }) => /* @__PURE__ */ v(Ll, { ...i, children: /* @__PURE__ */ F("div", { className: "grid gap-1", children: [
      n && /* @__PURE__ */ v(Ll.Title, { children: n }),
      r && /* @__PURE__ */ v("div", { dangerouslySetInnerHTML: { __html: r } })
    ] }) }, e)),
    /* @__PURE__ */ v(Ll.Viewport, {})
  ] });
}
const qz = {
  intent: {
    default: ["rounded-full"],
    square: ["rounded-xl"]
  },
  size: {
    default: ["h-8", "w-8"],
    sm: ["h-6", "w-6"],
    lg: ["h-10", "w-10"]
  }
}, Uw = {
  name: "avatar",
  base: ["relative", "flex", "shrink-0", "overflow-hidden", "rounded-md"],
  config: {
    variants: qz,
    defaultVariants: {
      intent: "default",
      size: "default"
    }
  }
}, Kz = {
  name: "avatar-image",
  base: ["aspect-square", "h-full", "w-full", "object-cover"],
  config: {}
}, Gz = {
  name: "avatar-fallback",
  base: [
    "bg-brand-100",
    "flex",
    "h-full",
    "w-full",
    "text-gray-900",
    "items-center",
    "justify-center",
    "rounded-full",
    "uppercase"
  ],
  config: {}
}, Yz = Ie(Uw.base, Uw.config);
function Zz({ className: t, intent: e, size: n, ...r }, i) {
  return /* @__PURE__ */ v(
    H8,
    {
      className: I("kn-avatar", Yz({ intent: e, size: n, className: t })),
      "data-testid": "asterisk-avatar",
      ref: i,
      ...r
    }
  );
}
function kO({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    W8,
    {
      className: I(Kz.base.join(" "), t),
      "data-testid": "asterisk-avatar-image",
      ref: n,
      ...e
    }
  );
}
function CO({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    j8,
    {
      className: I(Gz.base.join(" "), t),
      "data-testid": "asterisk-avatar-fallback",
      ref: n,
      ...e
    }
  );
}
const Jz = ce(Zz), qw = Object.assign(Jz, {
  Image: ce(kO),
  Fallback: ce(CO)
});
kO.displayName = "Avatar.Image";
CO.displayName = "Avatar.Fallback";
const Xz = {
  name: "dropdown-menu",
  base: [
    "min-w-[244px]",
    "overflow-auto",
    "border",
    "border-subtle",
    "bg-menu",
    "p-1",
    "text-default",
    "shadow-md",
    "p-2",
    "text-base",
    "data-[side=right]:animate-slideRightAndFade",
    "data-[side=left]:animate-slideLeftAndFade",
    "data-[side=bottom]:animate-slideDownAndFade",
    "data-[side=top]:animate-slideUpAndFade",
    "z-50",
    "data-[state=default]:hover:bg-brand-subtle",
    "data-[state=default]:hover:text-emphasis",
    "data-[state=selected]:text-emphasis",
    "data-[state=selected]:bg-brand-accent",
    "data-[state=disabled]:text-muted"
  ],
  config: {}
}, Qz = {
  name: "dropdown-menu-subtrigger",
  base: [
    "focus:bg-brand-subtle",
    "data-[state=open]:bg-brand-subtle",
    "flex",
    "cursor-default",
    "select-none",
    "items-center",
    "p-2",
    "outline-none"
  ],
  config: {}
}, eH = {
  name: "dropdown-menu-sub-content",
  base: [
    "animate-slideRightAndFade",
    "border-subtle",
    "text-default",
    "bg-menu",
    "z-50",
    "min-w-[8rem]",
    "overflow-hidden",
    "border",
    "p-1",
    "shadow-md"
  ],
  config: {}
}, tH = {
  name: "dropdown-menu-item",
  base: [
    "focus:bg-brand-subtle",
    "relative",
    "flex",
    "cursor-pointer",
    "select-none",
    "appearance-none",
    "items-center",
    "gap-1",
    "p-2",
    "outline-none",
    "data-[disabled]:pointer-events-none",
    "data-[disabled]:opacity-50"
  ],
  config: {}
}, nH = {
  name: "dropdown-menu-checkbox-item",
  base: [
    "relative",
    "flex",
    "cursor-default",
    "select-none",
    "items-center",
    "py-1.5",
    "pl-8",
    "pr-2",
    "font-medium",
    "outline-none",
    "data-[disabled]:pointer-events-none",
    "data-[disabled]:opacity-50"
  ],
  config: {}
}, rH = {
  name: "dropdown-menu-label",
  base: ["p-2", "font-semibold"],
  config: {}
}, iH = {
  name: "dropdown-menu-separator",
  base: ["bg-emphasis", "h-px", "m-2"],
  config: {}
}, Uoe = {
  name: "dropdown-menu-shortcut",
  base: ["text-subtle", "ml-auto", "text-xs", "tracking-widest"],
  config: {}
}, oH = {
  name: "dropdown-menu-trigger",
  base: [
    "focus:outline-none",
    "focus:outline-default",
    "focus-visible:ring-2",
    "focus-visible:ring-gray-400"
  ],
  config: {}
}, sH = Ie(Xz.base);
function SO({ className: t, inset: e, children: n, shouldHideChevron: r, ...i }, o) {
  const s = xe();
  return /* @__PURE__ */ F(
    wM,
    {
      "data-testid": "asterisk-dropdownmenu-subtrigger",
      ref: o,
      className: I(
        "kn-dropdownmenu-subtrigger",
        Qz.base.join(" "),
        e && "pl-8",
        {
          "rounded-lg": s.theme.appearance.corners === "rounded"
        },
        t
      ),
      ...i,
      children: [
        n,
        !r && /* @__PURE__ */ v(kI, { className: "ml-auto size-4" })
      ]
    }
  );
}
function TO({ className: t, ...e }, n) {
  const r = xe();
  return /* @__PURE__ */ v(
    xM,
    {
      "data-testid": "asterisk-dropdownmenu-subcontent",
      ref: n,
      className: I(
        "kn-dropdownmenu-subcontent",
        eH.base.join(" "),
        {
          "rounded-lg": r.theme.appearance.corners === "rounded"
        },
        t
      ),
      ...e
    }
  );
}
function EO({ className: t, sideOffset: e = 4, ...n }, r) {
  const i = xe();
  return /* @__PURE__ */ v(pM, { children: /* @__PURE__ */ v(
    mM,
    {
      "data-testid": "asterisk-dropdownmenu-content",
      ref: r,
      sideOffset: e,
      style: { maxHeight: "var(--radix-dropdown-menu-content-available-height)" },
      className: I(
        "kn-dropdownmenu-content",
        sH(),
        {
          "rounded-lg": i.theme.appearance.corners === "rounded"
        },
        t
      ),
      ...n
    }
  ) });
}
function MO({ className: t, inset: e, ...n }, r) {
  const i = xe();
  return /* @__PURE__ */ v(
    fd,
    {
      "data-testid": "asterisk-dropdownmenu-item",
      ref: r,
      className: I(
        "kn-dropdownmenu-item",
        tH.base.join(" "),
        e && "pl-8",
        {
          "rounded-lg": i.theme.appearance.corners === "rounded"
        },
        t
      ),
      ...n
    }
  );
}
function OO({ className: t, children: e, checked: n, ...r }, i) {
  const o = xe();
  return /* @__PURE__ */ F(
    vM,
    {
      "data-testid": "asterisk-dropdownmenu-checkbox-item",
      ref: i,
      className: I(
        "kn-dropdownmenu-checkbox",
        nH.base.join(" "),
        {
          "rounded-sm": o.theme.appearance.corners === "rounded"
        },
        t
      ),
      checked: n,
      ...r,
      children: [
        /* @__PURE__ */ v("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ v(bM, { children: /* @__PURE__ */ v(M0, { className: "h-4 w-4" }) }) }),
        e
      ]
    }
  );
}
function AO({ className: t, inset: e, ...n }, r) {
  return /* @__PURE__ */ v(
    gM,
    {
      "data-testid": "asterisk-dropdownmenu-label",
      ref: r,
      className: I(
        "kn-dropdownmenu-label",
        rH.base.join(" "),
        e && "pl-8",
        t
      ),
      ...n
    }
  );
}
function NO({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    hM,
    {
      "data-testid": "asterisk-dropdownmenu-trigger",
      ref: n,
      className: I("kn-dropdownmenu-trigger", oH.base.join(" "), t),
      ...e
    }
  );
}
function RO({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    yM,
    {
      "data-testid": "asterisk-dropdownmenu-separator",
      ref: n,
      className: I(
        "kn-dropdownmenu-separator",
        iH.base.join(" "),
        t
      ),
      ...e
    }
  );
}
function DO({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    "span",
    {
      "data-testid": "asterisk-dropdownmenu-shortcut",
      ref: n,
      className: I(
        "kn-dropdownmenu-shortcut text-subtle ml-auto text-xs tracking-widest",
        t
      ),
      ...e
    }
  );
}
function IO({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    "span",
    {
      "data-testid": "asterisk-dropdownmenu-caption-text",
      ref: n,
      className: I("kn-dropdownmenu-caption text-subtle text-xs", t),
      ...e
    }
  );
}
const { Group: _O, Portal: PO, Sub: LO } = vB, Qe = Object.assign(fM, {
  Label: ce(AO),
  Separator: ce(RO),
  Item: ce(MO),
  Content: ce(EO),
  SubContent: ce(TO),
  SubTrigger: ce(SO),
  CheckboxItem: ce(OO),
  Shortcut: ce(DO),
  CaptionText: ce(IO),
  Trigger: ce(NO),
  Group: _O,
  Portal: PO,
  SubMenu: LO
});
AO.displayName = "DropdownMenu.Label";
RO.displayName = "DropdownMenu.Separator";
EO.displayName = "DropdownMenu.Content";
TO.displayName = "DropdownMenu.SubContent";
SO.displayName = "DropdownMenu.SubTrigger";
MO.displayName = "DropdownMenu.Item";
OO.displayName = "DropdownMenu.CheckboxItem";
DO.displayName = "DropdownMenu.Shortcut";
IO.displayName = "DropdownMenu.CaptionText";
NO.displayName = "DropdownMenu.Trigger";
_O.displayName = "DropdownMenu.Group";
PO.displayName = "DropdownMenu.Portal";
LO.displayName = "DropdownMenu.SubMenu";
const aH = {
  intent: {
    default: [
      "border-default",
      "focus:border-default",
      "focus:outline-default",
      "focus:hover:border-emphasis",
      "hover:border-emphasis"
    ],
    destructive: [
      "border-destructive",
      "focus:outline-destructive",
      "focus:border-destructive",
      "hover:border-destructive"
    ]
  },
  size: {
    default: ["px-3", "py-2", "h-10"],
    sm: ["px-2.5", "py-2", "leading-none"]
  }
}, Kw = {
  name: "input",
  base: [
    "w-full",
    "bg-input",
    "text-emphasis",
    "text-base",
    "block",
    "border",
    "focus:ring-0",
    "focus:ring-gray-300",
    "placeholder:text-muted",
    "border",
    "border-default",
    "disabled:cursor-not-allowed",
    "disabled:bg-muted",
    "disabled:border-default",
    "disabled:text-subtle"
  ],
  config: {
    variants: aH,
    defaultVariants: {
      intent: "default",
      size: "default"
    }
  }
}, lH = Ie(Kw.base, Kw.config), cH = {
  base: ["relative"]
}, uH = {
  positionSize: {
    left: ["left-4"],
    right: ["right-4"],
    leftSmall: ["left-2.5"],
    rightSmall: ["right-2.5"]
  }
}, Gw = {
  base: ["absolute inset-y-3 flex cursor-pointer items-center"],
  config: {
    variants: uH,
    defaultVariants: {
      positionSize: "left"
    }
  }
}, dH = Ie(Gw.base, Gw.config);
function fH({ className: t, intent: e, size: n, ...r }, i) {
  const o = xe();
  return /* @__PURE__ */ v(
    "input",
    {
      className: I(
        lH({ intent: e, size: n }),
        {
          "rounded-lg": o.theme.appearance.corners === "rounded"
        },
        t
      ),
      "data-testid": "asterisk-input",
      ref: i,
      ...r
    }
  );
}
function FO({ children: t, className: e }) {
  return /* @__PURE__ */ v(
    "div",
    {
      className: I(cH.base.join(" "), e),
      "data-testid": "asterisk-input-container",
      children: t
    }
  );
}
function $O({ className: t, inputSize: e = "default", position: n = "right", children: r }) {
  let i = "left";
  return n === "left" && e === "sm" && (i = "leftSmall"), n === "right" && (e === "sm" ? i = "rightSmall" : i = "right"), /* @__PURE__ */ v(
    "span",
    {
      className: I(dH({ positionSize: i, className: t })),
      "data-testid": "asterisk-input-icon",
      children: r
    }
  );
}
function BO({ className: t, children: e }) {
  return /* @__PURE__ */ v("div", { className: I("text-subtle mt-2 text-xs", t), "data-testid": "asterisk-input-hint", children: e });
}
const hH = ce(fH), hn = Object.assign(hH, {
  Container: FO,
  Icon: $O,
  Hint: BO
});
FO.displayName = "Input.Container";
$O.displayName = "Input.Icon";
BO.displayName = "Input.Hint";
function pH(t) {
  return Ee({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46A11.804 11.804 0 0 0 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" }, child: [] }] })(t);
}
function mH(t) {
  return Ee({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" }, child: [] }] })(t);
}
function gH(t) {
  return Ee({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z" }, child: [] }] })(t);
}
function vH(t) {
  return Ee({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" }, child: [] }] })(t);
}
function bH(t) {
  return Ee({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z" }, child: [] }] })(t);
}
function yH(t) {
  return Ee({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" }, child: [] }] })(t);
}
function wH(t) {
  return Ee({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }, child: [] }] })(t);
}
function xH(t) {
  return Ee({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" }, child: [] }, { tag: "path", attr: { d: "M20 8V5H6.39l3 3h1.83l-.55 1.28 2.09 2.1L14.21 8zM3.41 4.86 2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21l1.41-1.41z" }, child: [] }] })(t);
}
function kH(t) {
  return Ee({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M7.24 8.75c-.26-.48-.39-1.03-.39-1.67 0-.61.13-1.16.4-1.67.26-.5.63-.93 1.11-1.29a5.73 5.73 0 0 1 1.7-.83c.66-.19 1.39-.29 2.18-.29.81 0 1.54.11 2.21.34.66.22 1.23.54 1.69.94.47.4.83.88 1.08 1.43s.38 1.15.38 1.81h-3.01c0-.31-.05-.59-.15-.85-.09-.27-.24-.49-.44-.68-.2-.19-.45-.33-.75-.44-.3-.1-.66-.16-1.06-.16-.39 0-.74.04-1.03.13s-.53.21-.72.36c-.19.16-.34.34-.44.55-.1.21-.15.43-.15.66 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.05-.08-.11-.17-.15-.25zM21 12v-2H3v2h9.62c.18.07.4.14.55.2.37.17.66.34.87.51s.35.36.43.57c.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42c-.25-.19-.45-.44-.59-.75s-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58s.37.85.65 1.21c.28.35.6.66.98.92.37.26.78.48 1.22.65.44.17.9.3 1.38.39.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28s1.21-.45 1.67-.79c.46-.34.82-.77 1.07-1.27s.38-1.07.38-1.71c0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H21V12z" }, child: [] }] })(t);
}
function CH({ hasError: t = !1, isEmpty: e = !0, ...n }, r) {
  const [i, o] = pe(!1), s = !e || t, a = i ? mH : pH;
  return /* @__PURE__ */ F(hn.Container, { children: [
    /* @__PURE__ */ v(
      hn,
      {
        type: i ? "text" : "password",
        intent: t ? "destructive" : void 0,
        ref: r,
        ...n
      }
    ),
    /* @__PURE__ */ v(hn.Icon, { children: /* @__PURE__ */ v(
      a,
      {
        className: I(
          `h-[20px] w-[22px] hover:fill-gray-800 active:fill-gray-800 ${s ? "fill-gray-800" : "fill-gray-300"}`
        ),
        onClick: () => o(!i)
      }
    ) })
  ] });
}
const qoe = ce(CH);
function SH({ ...t }, e) {
  return /* @__PURE__ */ F(hn.Container, { className: "w-full self-start", children: [
    /* @__PURE__ */ v(hn, { ref: e, ...t }),
    /* @__PURE__ */ v(hn.Icon, { children: /* @__PURE__ */ v(TI, { className: "h-5 w-5 text-gray-500" }) })
  ] });
}
const Koe = ce(SH), TH = Ie(
  // Base styles
  [
    "w-full",
    "flex",
    "border",
    "overflow-hidden",
    "focus-within:ring-0",
    "placeholder:text-subtle",
    "border",
    "disabled:cursor-not-allowed",
    "disabled:bg-muted",
    "disabled:border-default",
    "disabled:text-subtle",
    "outline-2",
    "outline-default",
    "outline-offset-2"
  ],
  {
    variants: {
      intent: {
        default: [
          "border-default",
          "focus-within:border-default",
          "focus-within:outline-default",
          "focus-within:hover:border-emphasis",
          "focus-within:border-emphasis",
          "focus-within:outline"
        ],
        destructive: [
          "border-destructive",
          "focus-within:outline-destructive",
          "focus-within:border-destructive",
          "hover:border-destructive",
          "focus-within:outline"
        ]
      },
      size: {
        default: ["h-10"],
        sm: ["h-10", "leading-none"]
      }
    },
    defaultVariants: {
      intent: "default",
      size: "default"
    }
  }
), EH = {
  name: "input-with-disabled-text",
  base: [
    "bg-input",
    "disabled:bg-muted",
    "flex-auto",
    "border-none",
    "px-2",
    "py-0",
    "shadow-none",
    "outline-none",
    "ring-0",
    "disabled:cursor-not-allowed"
  ],
  config: {}
}, VO = [
  "border-subtle",
  "bg-muted",
  "text-subtle",
  "flex",
  "items-center",
  "overflow-hidden",
  "px-2",
  "min-w-9",
  "justify-center"
], MH = {
  name: "input-with-disabled-text-left",
  base: [...VO, "border-r-2"],
  config: {}
}, OH = {
  name: "input-with-disabled-text-right",
  base: [...VO, "border-l-2"],
  config: {}
};
function AH({
  className: t,
  inputClassName: e,
  intent: n,
  size: r,
  disabledTextRight: i,
  disabledTextLeft: o,
  disabled: s,
  ...a
}, l) {
  const c = xe();
  return /* @__PURE__ */ F(
    "div",
    {
      className: I(
        TH({ intent: n, size: r }),
        {
          "rounded-lg": c.theme.appearance.corners === "rounded"
        },
        t
      ),
      children: [
        o && /* @__PURE__ */ v("div", { className: I(MH.base.join(" ")), children: o }),
        /* @__PURE__ */ v(
          "input",
          {
            className: I(EH.base.join(" "), e),
            style: { boxShadow: "none" },
            ref: l,
            disabled: s,
            ...a
          }
        ),
        i && /* @__PURE__ */ v("div", { className: I(OH.base.join(" ")), children: i })
      ]
    }
  );
}
const Goe = ce(AH), NH = {
  intent: {
    default: ["bg-inverted"],
    brand: ["bg-brand-accent-muted"],
    success: ["bg-success-secondary"],
    destructive: ["bg-action-destructive-primary"]
  },
  size: {
    default: ["h-4", "w-full"],
    sm: ["h-2", "w-full"]
  }
}, Yw = {
  name: "progress",
  base: ["flex-1", "transition-all"],
  config: {
    variants: NH,
    defaultVariants: {
      intent: "default",
      size: "default"
    }
  }
}, RH = {
  name: "progress-root",
  base: ["bg-emphasis", "relative", "overflow-hidden"],
  config: {}
}, DH = Ie(Yw.base, Yw.config);
function IH({ className: t, value: e, intent: n, size: r, ...i }, o) {
  const s = xe();
  return /* @__PURE__ */ v(
    VB,
    {
      ref: o,
      "data-testid": "asterisk-progress",
      className: I(
        "kn-progress",
        RH.base.join(" "),
        {
          "rounded-full": s.theme.appearance.corners === "rounded"
        },
        t
      ),
      ...i,
      children: /* @__PURE__ */ v(
        zB,
        {
          "data-testid": "asterisk-progress-indicator",
          className: I(DH({ intent: n, size: r, className: t })),
          style: { transform: `translateX(-${100 - (e || 0)}%)` }
        }
      )
    }
  );
}
const Yoe = ce(IH), _H = {
  intent: {
    default: ["p-0"],
    text: ["py-2 px-4"]
  }
}, Zw = {
  name: "popover-content",
  base: [
    "data-[state=open]:animate-slideDownAndFade",
    "relative",
    "z-50",
    "px-2",
    "py-1",
    "border",
    "leading-none",
    "border-subtle",
    "bg-base",
    "shadow-md",
    "max-h-[600px]"
  ],
  config: {
    variants: _H,
    defaultVariants: {
      intent: "default"
    }
  }
}, PH = Ie(Zw.base, Zw.config);
function LH({ className: t, intent: e, children: n, ...r }, i) {
  const o = xe();
  return /* @__PURE__ */ v(DB, { children: /* @__PURE__ */ v(
    IB,
    {
      ref: i,
      className: I(
        "kn-popover-content",
        PH({ intent: e }),
        {
          "rounded-md": o.theme.appearance.corners === "rounded"
        },
        t
      ),
      "data-testid": "asterisk-popover-content",
      ...r,
      children: n
    }
  ) });
}
function FH({ children: t, className: e, ...n }, r) {
  return /* @__PURE__ */ v(
    RB,
    {
      className: I("kn-popover-trigger", e),
      "data-testid": "asterisk-popover-trigger",
      ref: r,
      ...n,
      children: t
    }
  );
}
function $H({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    NB,
    {
      className: I("kn-popover-anchor", t),
      "data-testid": "asterisk-popover-anchor",
      ref: n,
      ...e
    }
  );
}
const lt = Object.assign(AB, {
  Trigger: ce(FH),
  Content: ce(LH),
  Anchor: ce($H)
});
lt.Content.displayName = "Popover.Content";
lt.Trigger.displayName = "Popover.Trigger";
lt.Anchor.displayName = "Popover.Anchor";
const BH = {
  intent: {
    default: ["bg-inverted"],
    brand: ["bg-brand"]
  }
}, Jw = {
  name: "slider",
  base: ["absolute", "h-full"],
  config: {
    variants: BH,
    defaultVariants: {
      intent: "default"
    }
  }
}, VH = {
  name: "slider-root",
  base: ["relative", "flex", "w-full", "touch-none", "select-none", "items-center"],
  config: {}
}, zH = {
  name: "slider-track",
  base: [
    "bg-subtle",
    "relative",
    "h-2",
    "w-full",
    "grow",
    "cursor-pointer",
    "overflow-hidden",
    "data-[disabled]:pointer-events-none",
    "data-[disabled]:opacity-50"
  ],
  config: {}
}, HH = {
  intent: {
    default: ["focus:ring-default"],
    brand: ["border-brand", "focus:ring-brand"]
  }
}, Xw = {
  name: "slider-thumb",
  base: [
    "bg-base",
    "block",
    "size-5",
    "cursor-grab",
    "border-2",
    "transition-colors",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-offset-2",
    "data-[disabled]:pointer-events-none",
    "data-[disabled]:bg-muted"
  ],
  config: {
    variants: HH,
    defaultVariants: {
      intent: "default"
    }
  }
}, WH = Ie(Jw.base, Jw.config), jH = Ie(Xw.base, Xw.config);
function UH({ className: t, intent: e, ...n }, r) {
  const i = xe();
  return /* @__PURE__ */ F(
    PV,
    {
      "data-testid": "asterisk-slider",
      ref: r,
      className: I("kn-slider", VH.base.join(" ")),
      ...n,
      children: [
        /* @__PURE__ */ v(
          LV,
          {
            className: zH.base.join(" "),
            "data-testid": "asterisk-slider-track",
            children: /* @__PURE__ */ v(
              FV,
              {
                "data-testid": "asterisk-slider-range",
                className: I(
                  WH({ intent: e }),
                  {
                    "rounded-full": i.theme.appearance.corners === "rounded"
                  },
                  t
                )
              }
            )
          }
        ),
        /* @__PURE__ */ v(
          $V,
          {
            "data-testid": "asterisk-slider-thumb",
            className: I(
              jH({ intent: e }),
              {
                "rounded-full": i.theme.appearance.corners === "rounded"
              },
              t
            )
          }
        )
      ]
    }
  );
}
const Zoe = ce(UH), qH = {
  width: {
    sm: ["sm:max-w-[480px]"],
    lg: ["sm:max-w-[960px]"]
  }
}, Qw = {
  name: "dialog",
  base: [
    "relative",
    "z-50",
    "mx-auto",
    "my-4",
    "w-[calc(100%_-_2rem)]",
    "bg-default",
    "animate-in",
    "sm:max-w-lg",
    "sm:zoom-in-90",
    "data-[state=open]:fade-in-90",
    "data-[state=open]:slide-in-from-bottom-10",
    "data-[state=open]:sm:slide-in-from-bottom-0"
  ],
  config: {
    variants: qH,
    defaultVariants: {
      width: "sm"
    }
  }
}, KH = {
  name: "dialog-overlay",
  base: [
    "data-[state=closed]:animate-out",
    "data-[state=open]:fade-in",
    "data-[state=closed]:fade-out",
    "bg-overlay",
    "fixed",
    "inset-0",
    "z-50",
    "flex",
    "items-center",
    "justify-center",
    "backdrop-blur-sm",
    "transition-all",
    "duration-100"
  ],
  config: {}
}, GH = {
  name: "dialog-close",
  base: [
    "focus:ring-default",
    "data-[state=open]:bg-muted",
    "absolute",
    "right-4",
    "top-4",
    "opacity-70",
    "transition-opacity",
    "hover:opacity-100",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-offset-2",
    "disabled:pointer-events-none"
  ],
  config: {}
}, YH = {
  name: "dialog-title",
  base: ["text-emphasis", "text-lg", "font-semibold"],
  config: {}
}, ZH = {
  name: "dialog-description",
  base: ["text-default"],
  config: {}
}, JH = {
  name: "dialog-header",
  base: ["flex", "flex-col", "space-y-2"],
  config: {}
}, XH = {
  base: ["p-6"]
}, QH = {
  intent: {
    default: ["bottom-0", "left-0", "w-full", "items-center", "border-subtle"],
    borderless: ["border-t-0"]
  }
}, ex = {
  name: "dialog-footer",
  base: ["flex", "p-6", "gap-6", "justify-end", "text-emphasis", "border-t"],
  config: {
    variants: QH,
    defaultVariants: {
      intent: "borderless"
    }
  }
}, eW = Ie(Qw.base, Qw.config), tW = Ie(ex.base, ex.config);
function zO({
  className: t,
  width: e,
  children: n,
  modal: r = !0,
  shouldHideCloseButton: i = !1,
  ...o
}, s) {
  const a = xe();
  return /* @__PURE__ */ v(qE, { children: /* @__PURE__ */ v(
    r ? KE : "div",
    {
      className: I("kn-dialog-overlay", KH.base.join(" ")),
      "data-testid": "asterisk-dialog-overlay",
      children: /* @__PURE__ */ v("div", { className: "max-h-full w-full overflow-y-auto", children: /* @__PURE__ */ F(
        GE,
        {
          ref: s,
          "data-testid": "asterisk-dialog-content",
          className: I(
            "kn-dialog-content",
            eW({ width: e }),
            {
              "rounded-lg sm:rounded-lg": a.theme.appearance.corners === "rounded"
            },
            t
          ),
          ...o,
          children: [
            n,
            !i && /* @__PURE__ */ F(
              JE,
              {
                "data-testid": "asterisk-dialog-close",
                className: I("kn-dialog-close", GH.base.join(" "), {
                  "rounded-sm": a.theme.appearance.corners === "rounded"
                }),
                children: [
                  /* @__PURE__ */ v(wH, { className: "h-4 w-4" }),
                  /* @__PURE__ */ v("span", { className: "sr-only", children: "Close" })
                ]
              }
            )
          ]
        }
      ) })
    }
  ) });
}
function HO({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    YE,
    {
      ref: n,
      "data-testid": "asterisk-dialog-title",
      className: I("kn-dialog-title", YH.base.join(" "), t),
      ...e
    }
  );
}
function WO({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    ZE,
    {
      ref: n,
      "data-testid": "asterisk-dialog-description",
      className: I("kn-dialog-description", ZH.base.join(" "), t),
      ...e
    }
  );
}
function jO({ className: t, ...e }) {
  return /* @__PURE__ */ v(
    "div",
    {
      "data-testid": "asterisk-dialog-header",
      className: I("kn-dialog-header", JH.base.join(" "), t),
      ...e
    }
  );
}
function UO({ className: t, intent: e, ...n }) {
  const r = xe();
  return /* @__PURE__ */ v(
    "div",
    {
      "data-testid": "asterisk-dialog-footer",
      className: I(
        "kn-dialog-footer",
        tW({ intent: e }),
        {
          "rounded-bl-lg rounded-br-lg": r.theme.appearance.corners === "rounded"
        },
        t
      ),
      ...n
    }
  );
}
function nW({ className: t, ...e }) {
  return /* @__PURE__ */ v(
    "div",
    {
      "data-testid": "asterisk-dialog-main-content",
      className: I("kn-dialog-main-content", XH.base.join(" "), t),
      ...e
    }
  );
}
const { Trigger: qO, Close: KO } = L8, Joe = Object.assign(UE, {
  Content: ce(zO),
  Title: ce(HO),
  Description: ce(WO),
  MainContent: nW,
  Header: jO,
  Footer: UO,
  Trigger: qO,
  Close: KO
});
zO.displayName = "Dialog.Content";
HO.displayName = "Dialog.Title";
WO.displayName = "Dialog.Description";
jO.displayName = "Dialog.Header";
UO.displayName = "Dialog.Footer";
qO.displayName = "Dialog.Trigger";
KO.displayName = "Dialog.CloseTrigger";
function rW({
  selected: t,
  onSelect: e,
  mode: n,
  children: r,
  align: i = "start",
  calendarProps: o,
  onDatePickerOpenChange: s,
  triggerRef: a
}) {
  const [l, c] = pe(!1), { day: u } = de.fromJSDate(t), d = (h) => {
    h && e(h);
  };
  return /* @__PURE__ */ F(lt, { open: l, onOpenChange: (h) => {
    c(h), s && s(h);
  }, "data-testid": "asterisk-date-picker", children: [
    /* @__PURE__ */ v(lt.Trigger, { "data-testid": "asterisk-date-picker-trigger", children: r }),
    /* @__PURE__ */ v(
      lt.Content,
      {
        onOpenAutoFocus: (h) => h.preventDefault(),
        className: "border-none",
        align: i,
        "data-testid": "asterisk-date-picker-content",
        onCloseAutoFocus: () => {
          a && a.current && a.current.blur();
        },
        children: /* @__PURE__ */ v(
          G0,
          {
            mode: n,
            selected: t,
            onSelect: (h) => d(h),
            month: t,
            onMonthChange: (h) => {
              d(new Date(h.getFullYear(), h.getMonth(), u));
            },
            "data-testid": "asterisk-date-picker-calendar",
            ...o
          }
        )
      }
    )
  ] });
}
function GO({ children: t }) {
  return t;
}
const Xoe = Object.assign(rW, {
  Trigger: GO
});
GO.displayName = "DatePicker.Trigger";
function iW(t) {
  return Ee({ attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z", clipRule: "evenodd" }, child: [] }] })(t);
}
function oW(t) {
  return Ee({ attr: { fill: "none", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { strokeLinecap: "round", strokeLinejoin: "round", d: "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" }, child: [] }] })(t);
}
function sW(t) {
  let e = t.activeElement;
  for (; ((n = e) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    e = e.shadowRoot.activeElement;
  }
  return e;
}
function aW(t, e) {
  if (!t || !e)
    return !1;
  const n = e.getRootNode == null ? void 0 : e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && mm(n)) {
    let r = e;
    for (; r; ) {
      if (t === r)
        return !0;
      r = r.parentNode || r.host;
    }
  }
  return !1;
}
function lW() {
  return /apple/i.test(navigator.vendor);
}
function Iv(t) {
  return (t == null ? void 0 : t.ownerDocument) || document;
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var cW = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Dm = /* @__PURE__ */ cW.join(","), YO = typeof Element > "u", ga = YO ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Hc = !YO && Element.prototype.getRootNode ? function(t) {
  var e;
  return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
} : function(t) {
  return t == null ? void 0 : t.ownerDocument;
}, Wc = function t(e, n) {
  var r;
  n === void 0 && (n = !0);
  var i = e == null || (r = e.getAttribute) === null || r === void 0 ? void 0 : r.call(e, "inert"), o = i === "" || i === "true", s = o || n && e && t(e.parentNode);
  return s;
}, uW = function(e) {
  var n, r = e == null || (n = e.getAttribute) === null || n === void 0 ? void 0 : n.call(e, "contenteditable");
  return r === "" || r === "true";
}, dW = function(e, n, r) {
  if (Wc(e))
    return [];
  var i = Array.prototype.slice.apply(e.querySelectorAll(Dm));
  return n && ga.call(e, Dm) && i.unshift(e), i = i.filter(r), i;
}, fW = function t(e, n, r) {
  for (var i = [], o = Array.from(e); o.length; ) {
    var s = o.shift();
    if (!Wc(s, !1))
      if (s.tagName === "SLOT") {
        var a = s.assignedElements(), l = a.length ? a : s.children, c = t(l, !0, r);
        r.flatten ? i.push.apply(i, c) : i.push({
          scopeParent: s,
          candidates: c
        });
      } else {
        var u = ga.call(s, Dm);
        u && r.filter(s) && (n || !e.includes(s)) && i.push(s);
        var d = s.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(s), f = !Wc(d, !1) && (!r.shadowRootFilter || r.shadowRootFilter(s));
        if (d && f) {
          var h = t(d === !0 ? s.children : d.children, !0, r);
          r.flatten ? i.push.apply(i, h) : i.push({
            scopeParent: s,
            candidates: h
          });
        } else
          o.unshift.apply(o, s.children);
      }
  }
  return i;
}, ZO = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, JO = function(e) {
  if (!e)
    throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || uW(e)) && !ZO(e) ? 0 : e.tabIndex;
}, hW = function(e, n) {
  var r = JO(e);
  return r < 0 && n && !ZO(e) ? 0 : r;
}, pW = function(e, n) {
  return e.tabIndex === n.tabIndex ? e.documentOrder - n.documentOrder : e.tabIndex - n.tabIndex;
}, XO = function(e) {
  return e.tagName === "INPUT";
}, mW = function(e) {
  return XO(e) && e.type === "hidden";
}, gW = function(e) {
  var n = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, vW = function(e, n) {
  for (var r = 0; r < e.length; r++)
    if (e[r].checked && e[r].form === n)
      return e[r];
}, bW = function(e) {
  if (!e.name)
    return !0;
  var n = e.form || Hc(e), r = function(a) {
    return n.querySelectorAll('input[type="radio"][name="' + a + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = r(window.CSS.escape(e.name));
  else
    try {
      i = r(e.name);
    } catch (s) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", s.message), !1;
    }
  var o = vW(i, e.form);
  return !o || o === e;
}, yW = function(e) {
  return XO(e) && e.type === "radio";
}, wW = function(e) {
  return yW(e) && !bW(e);
}, xW = function(e) {
  var n, r = e && Hc(e), i = (n = r) === null || n === void 0 ? void 0 : n.host, o = !1;
  if (r && r !== e) {
    var s, a, l;
    for (o = !!((s = i) !== null && s !== void 0 && (a = s.ownerDocument) !== null && a !== void 0 && a.contains(i) || e != null && (l = e.ownerDocument) !== null && l !== void 0 && l.contains(e)); !o && i; ) {
      var c, u, d;
      r = Hc(i), i = (c = r) === null || c === void 0 ? void 0 : c.host, o = !!((u = i) !== null && u !== void 0 && (d = u.ownerDocument) !== null && d !== void 0 && d.contains(i));
    }
  }
  return o;
}, tx = function(e) {
  var n = e.getBoundingClientRect(), r = n.width, i = n.height;
  return r === 0 && i === 0;
}, kW = function(e, n) {
  var r = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var o = ga.call(e, "details>summary:first-of-type"), s = o ? e.parentElement : e;
  if (ga.call(s, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof i == "function") {
      for (var a = e; e; ) {
        var l = e.parentElement, c = Hc(e);
        if (l && !l.shadowRoot && i(l) === !0)
          return tx(e);
        e.assignedSlot ? e = e.assignedSlot : !l && c !== e.ownerDocument ? e = c.host : e = l;
      }
      e = a;
    }
    if (xW(e))
      return !e.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return tx(e);
  return !1;
}, CW = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var n = e.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var i = n.children.item(r);
          if (i.tagName === "LEGEND")
            return ga.call(n, "fieldset[disabled] *") ? !0 : !i.contains(e);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, SW = function(e, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Wc(n) || mW(n) || kW(n, e) || // For a details element with a summary, the summary element gets the focus
  gW(n) || CW(n));
}, nx = function(e, n) {
  return !(wW(n) || JO(n) < 0 || !SW(e, n));
}, TW = function(e) {
  var n = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, EW = function t(e) {
  var n = [], r = [];
  return e.forEach(function(i, o) {
    var s = !!i.scopeParent, a = s ? i.scopeParent : i, l = hW(a, s), c = s ? t(i.candidates) : a;
    l === 0 ? s ? n.push.apply(n, c) : n.push(a) : r.push({
      documentOrder: o,
      tabIndex: l,
      item: i,
      isScope: s,
      content: c
    });
  }), r.sort(pW).reduce(function(i, o) {
    return o.isScope ? i.push.apply(i, o.content) : i.push(o.content), i;
  }, []).concat(n);
}, QO = function(e, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = fW([e], n.includeContainer, {
    filter: nx.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: TW
  }) : r = dW(e, n.includeContainer, nx.bind(null, n)), EW(r);
};
const eA = {
  ...w
}, MW = eA.useInsertionEffect, OW = MW || ((t) => t());
function AW(t) {
  const e = w.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return OW(() => {
    e.current = t;
  }), w.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return e.current == null ? void 0 : e.current(...r);
  }, []);
}
var Ki = typeof document < "u" ? uo : De;
let rx = !1, NW = 0;
const ix = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + NW++
);
function RW() {
  const [t, e] = w.useState(() => rx ? ix() : void 0);
  return Ki(() => {
    t == null && e(ix());
  }, []), w.useEffect(() => {
    rx = !0;
  }, []), t;
}
const DW = eA.useId, tA = DW || RW;
let Im;
process.env.NODE_ENV !== "production" && (Im = /* @__PURE__ */ new Set());
function IW() {
  for (var t, e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  const i = "Floating UI: " + n.join(" ");
  if (!((t = Im) != null && t.has(i))) {
    var o;
    (o = Im) == null || o.add(i), console.error(i);
  }
}
function _W() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(e, n) {
      var r;
      (r = t.get(e)) == null || r.forEach((i) => i(n));
    },
    on(e, n) {
      t.set(e, [...t.get(e) || [], n]);
    },
    off(e, n) {
      var r;
      t.set(e, ((r = t.get(e)) == null ? void 0 : r.filter((i) => i !== n)) || []);
    }
  };
}
const PW = /* @__PURE__ */ w.createContext(null), LW = /* @__PURE__ */ w.createContext(null), FW = () => {
  var t;
  return ((t = w.useContext(PW)) == null ? void 0 : t.id) || null;
}, $W = () => w.useContext(LW);
function nA(t) {
  return "data-floating-ui-" + t;
}
const rA = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function iA(t, e) {
  const n = QO(t, rA());
  e === "prev" && n.reverse();
  const r = n.indexOf(sW(Iv(t)));
  return n.slice(r + 1)[0];
}
function BW(t) {
  return iA(Iv(t).body, "next") || t;
}
function VW(t) {
  return iA(Iv(t).body, "prev") || t;
}
function Uh(t, e) {
  const n = e || t.currentTarget, r = t.relatedTarget;
  return !r || !aW(n, r);
}
function zW(t) {
  QO(t, rA()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function ox(t) {
  t.querySelectorAll("[data-tabindex]").forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
const oA = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
}, sx = /* @__PURE__ */ w.forwardRef(function(e, n) {
  const [r, i] = w.useState();
  Ki(() => {
    lW() && i("button");
  }, []);
  const o = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: r,
    "aria-hidden": r ? void 0 : !0,
    [nA("focus-guard")]: "",
    style: oA
  };
  return /* @__PURE__ */ v("span", {
    ...e,
    ...o
  });
}), sA = /* @__PURE__ */ w.createContext(null), ax = /* @__PURE__ */ nA("portal");
function HW(t) {
  t === void 0 && (t = {});
  const {
    id: e,
    root: n
  } = t, r = tA(), i = WW(), [o, s] = w.useState(null), a = w.useRef(null);
  return Ki(() => () => {
    o == null || o.remove(), queueMicrotask(() => {
      a.current = null;
    });
  }, [o]), Ki(() => {
    if (!r || a.current) return;
    const l = e ? document.getElementById(e) : null;
    if (!l) return;
    const c = document.createElement("div");
    c.id = r, c.setAttribute(ax, ""), l.appendChild(c), a.current = c, s(c);
  }, [e, r]), Ki(() => {
    if (n === null || !r || a.current) return;
    let l = n || (i == null ? void 0 : i.portalNode);
    l && !Et(l) && (l = l.current), l = l || document.body;
    let c = null;
    e && (c = document.createElement("div"), c.id = e, l.appendChild(c));
    const u = document.createElement("div");
    u.id = r, u.setAttribute(ax, ""), l = c || l, l.appendChild(u), a.current = u, s(u);
  }, [e, n, r, i]), o;
}
function aA(t) {
  const {
    children: e,
    id: n,
    root: r,
    preserveTabOrder: i = !0
  } = t, o = HW({
    id: n,
    root: r
  }), [s, a] = w.useState(null), l = w.useRef(null), c = w.useRef(null), u = w.useRef(null), d = w.useRef(null), f = s == null ? void 0 : s.modal, h = s == null ? void 0 : s.open, p = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!s && // Guards are only for non-modal focus management.
    !s.modal && // Don't render if unmount is transitioning.
    s.open && i && !!(r || o)
  );
  return w.useEffect(() => {
    if (!o || !i || f)
      return;
    function m(b) {
      o && Uh(b) && (b.type === "focusin" ? ox : zW)(o);
    }
    return o.addEventListener("focusin", m, !0), o.addEventListener("focusout", m, !0), () => {
      o.removeEventListener("focusin", m, !0), o.removeEventListener("focusout", m, !0);
    };
  }, [o, i, f]), w.useEffect(() => {
    o && (h || ox(o));
  }, [h, o]), /* @__PURE__ */ F(sA.Provider, {
    value: w.useMemo(() => ({
      preserveTabOrder: i,
      beforeOutsideRef: l,
      afterOutsideRef: c,
      beforeInsideRef: u,
      afterInsideRef: d,
      portalNode: o,
      setFocusManagerState: a
    }), [i, o]),
    children: [p && o && /* @__PURE__ */ v(sx, {
      "data-type": "outside",
      ref: l,
      onFocus: (m) => {
        if (Uh(m, o)) {
          var b;
          (b = u.current) == null || b.focus();
        } else {
          const y = s ? s.domReference : null, k = VW(y);
          k == null || k.focus();
        }
      }
    }), p && o && /* @__PURE__ */ v("span", {
      "aria-owns": o.id,
      style: oA
    }), o && /* @__PURE__ */ fs.createPortal(e, o), p && o && /* @__PURE__ */ v(sx, {
      "data-type": "outside",
      ref: c,
      onFocus: (m) => {
        if (Uh(m, o)) {
          var b;
          (b = d.current) == null || b.focus();
        } else {
          const y = s ? s.domReference : null, k = BW(y);
          k == null || k.focus(), s != null && s.closeOnFocusOut && (s == null || s.onOpenChange(!1, m.nativeEvent, "focus-out"));
        }
      }
    })]
  });
}
const WW = () => w.useContext(sA);
function jW(t) {
  const {
    open: e = !1,
    onOpenChange: n,
    elements: r
  } = t, i = tA(), o = w.useRef({}), [s] = w.useState(() => _W()), a = FW() != null;
  if (process.env.NODE_ENV !== "production") {
    const h = r.reference;
    h && !Et(h) && IW("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, c] = w.useState(r.reference), u = AW((h, p, m) => {
    o.current.openEvent = h ? p : void 0, s.emit("openchange", {
      open: h,
      event: p,
      reason: m,
      nested: a
    }), n == null || n(h, p, m);
  }), d = w.useMemo(() => ({
    setPositionReference: c
  }), []), f = w.useMemo(() => ({
    reference: l || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [l, r.reference, r.floating]);
  return w.useMemo(() => ({
    dataRef: o,
    open: e,
    onOpenChange: u,
    elements: f,
    events: s,
    floatingId: i,
    refs: d
  }), [e, u, f, s, i, d]);
}
function UW(t) {
  t === void 0 && (t = {});
  const {
    nodeId: e
  } = t, n = jW({
    ...t,
    elements: {
      reference: null,
      floating: null,
      ...t.elements
    }
  }), r = t.rootContext || n, i = r.elements, [o, s] = w.useState(null), [a, l] = w.useState(null), u = (i == null ? void 0 : i.domReference) || o, d = w.useRef(null), f = $W();
  Ki(() => {
    u && (d.current = u);
  }, [u]);
  const h = y2({
    ...t,
    elements: {
      ...i,
      ...a && {
        reference: a
      }
    }
  }), p = w.useCallback((C) => {
    const x = Et(C) ? {
      getBoundingClientRect: () => C.getBoundingClientRect(),
      getClientRects: () => C.getClientRects(),
      contextElement: C
    } : C;
    l(x), h.refs.setReference(x);
  }, [h.refs]), m = w.useCallback((C) => {
    (Et(C) || C === null) && (d.current = C, s(C)), (Et(h.refs.reference.current) || h.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    C !== null && !Et(C)) && h.refs.setReference(C);
  }, [h.refs]), b = w.useMemo(() => ({
    ...h.refs,
    setReference: m,
    setPositionReference: p,
    domReference: d
  }), [h.refs, m, p]), y = w.useMemo(() => ({
    ...h.elements,
    domReference: u
  }), [h.elements, u]), k = w.useMemo(() => ({
    ...h,
    ...r,
    refs: b,
    elements: y,
    nodeId: e
  }), [h, b, y, e, r]);
  return Ki(() => {
    r.dataRef.current.floatingContext = k;
    const C = f == null ? void 0 : f.nodesRef.current.find((x) => x.id === e);
    C && (C.context = k);
  }), w.useMemo(() => ({
    ...h,
    context: k,
    refs: b,
    elements: y
  }), [h, b, y, k]);
}
const lA = 1900, cA = 2050, qW = 180, KW = 140, GW = 100, YW = 95, ei = (t) => t.date && t.time ? qW : t.date ? KW : t.time === "hh:mm a" ? GW : YW;
function ui(t) {
  return typeof t == "string" || t instanceof String;
}
function lx(t) {
  var e;
  return typeof t == "object" && t != null && (t == null || (e = t.constructor) == null ? void 0 : e.name) === "Object";
}
function uA(t, e) {
  return Array.isArray(e) ? uA(t, (n, r) => e.includes(r)) : Object.entries(t).reduce((n, r) => {
    let [i, o] = r;
    return e(o, i) && (n[i] = o), n;
  }, {});
}
const ve = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function ZW(t) {
  switch (t) {
    case ve.LEFT:
      return ve.FORCE_LEFT;
    case ve.RIGHT:
      return ve.FORCE_RIGHT;
    default:
      return t;
  }
}
function qh(t) {
  return t.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
}
function jc(t, e) {
  if (e === t) return !0;
  const n = Array.isArray(e), r = Array.isArray(t);
  let i;
  if (n && r) {
    if (e.length != t.length) return !1;
    for (i = 0; i < e.length; i++) if (!jc(e[i], t[i])) return !1;
    return !0;
  }
  if (n != r) return !1;
  if (e && t && typeof e == "object" && typeof t == "object") {
    const o = e instanceof Date, s = t instanceof Date;
    if (o && s) return e.getTime() == t.getTime();
    if (o != s) return !1;
    const a = e instanceof RegExp, l = t instanceof RegExp;
    if (a && l) return e.toString() == t.toString();
    if (a != l) return !1;
    const c = Object.keys(e);
    for (i = 0; i < c.length; i++) if (!Object.prototype.hasOwnProperty.call(t, c[i])) return !1;
    for (i = 0; i < c.length; i++) if (!jc(t[c[i]], e[c[i]])) return !1;
    return !0;
  } else if (e && t && typeof e == "function" && typeof t == "function")
    return e.toString() === t.toString();
  return !1;
}
class JW {
  /** Current input value */
  /** Current cursor position */
  /** Old input value */
  /** Old selection */
  constructor(e) {
    for (Object.assign(this, e); this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos); )
      --this.oldSelection.start;
    if (this.insertedCount)
      for (; this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end); )
        this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end ? ++this.oldSelection.end : ++this.cursorPos;
  }
  /** Start changing position */
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }
  /** Inserted symbols count */
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }
  /** Inserted symbols */
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }
  /** Removed symbols count */
  get removedCount() {
    return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
    this.oldValue.length - this.value.length, 0);
  }
  /** Removed symbols */
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }
  /** Unchanged head symbols */
  get head() {
    return this.value.substring(0, this.startChangePos);
  }
  /** Unchanged tail symbols */
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }
  /** Remove direction */
  get removeDirection() {
    return !this.removedCount || this.insertedCount ? ve.NONE : (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
    this.oldSelection.end === this.oldSelection.start ? ve.RIGHT : ve.LEFT;
  }
}
function ke(t, e) {
  return new ke.InputMask(t, e);
}
function dA(t) {
  if (t == null) throw new Error("mask property should be defined");
  return t instanceof RegExp ? ke.MaskedRegExp : ui(t) ? ke.MaskedPattern : t === Date ? ke.MaskedDate : t === Number ? ke.MaskedNumber : Array.isArray(t) || t === Array ? ke.MaskedDynamic : ke.Masked && t.prototype instanceof ke.Masked ? t : ke.Masked && t instanceof ke.Masked ? t.constructor : t instanceof Function ? ke.MaskedFunction : (console.warn("Mask not found for mask", t), ke.Masked);
}
function va(t) {
  if (!t) throw new Error("Options in not defined");
  if (ke.Masked) {
    if (t.prototype instanceof ke.Masked) return {
      mask: t
    };
    const {
      mask: e = void 0,
      ...n
    } = t instanceof ke.Masked ? {
      mask: t
    } : lx(t) && t.mask instanceof ke.Masked ? t : {};
    if (e) {
      const r = e.mask;
      return {
        ...uA(e, (i, o) => !o.startsWith("_")),
        mask: e.constructor,
        _mask: r,
        ...n
      };
    }
  }
  return lx(t) ? {
    ...t
  } : {
    mask: t
  };
}
function $r(t) {
  if (ke.Masked && t instanceof ke.Masked) return t;
  const e = va(t), n = dA(e.mask);
  if (!n) throw new Error("Masked class is not found for provided mask " + e.mask + ", appropriate module needs to be imported manually before creating mask.");
  return e.mask === n && delete e.mask, e._mask && (e.mask = e._mask, delete e._mask), new n(e);
}
ke.createMask = $r;
class _v {
  /** */
  /** */
  /** */
  /** Safely returns selection start */
  get selectionStart() {
    let e;
    try {
      e = this._unsafeSelectionStart;
    } catch {
    }
    return e ?? this.value.length;
  }
  /** Safely returns selection end */
  get selectionEnd() {
    let e;
    try {
      e = this._unsafeSelectionEnd;
    } catch {
    }
    return e ?? this.value.length;
  }
  /** Safely sets element selection */
  select(e, n) {
    if (!(e == null || n == null || e === this.selectionStart && n === this.selectionEnd))
      try {
        this._unsafeSelect(e, n);
      } catch {
      }
  }
  /** */
  get isActive() {
    return !1;
  }
  /** */
  /** */
  /** */
}
ke.MaskElement = _v;
const cx = 90, XW = 89;
class kd extends _v {
  /** HTMLElement to use mask on */
  constructor(e) {
    super(), this.input = e, this._onKeydown = this._onKeydown.bind(this), this._onInput = this._onInput.bind(this), this._onBeforeinput = this._onBeforeinput.bind(this), this._onCompositionEnd = this._onCompositionEnd.bind(this);
  }
  get rootElement() {
    var e, n, r;
    return (e = (n = (r = this.input).getRootNode) == null ? void 0 : n.call(r)) != null ? e : document;
  }
  /** Is element in focus */
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }
  /** Binds HTMLElement events to mask internal events */
  bindEvents(e) {
    this.input.addEventListener("keydown", this._onKeydown), this.input.addEventListener("input", this._onInput), this.input.addEventListener("beforeinput", this._onBeforeinput), this.input.addEventListener("compositionend", this._onCompositionEnd), this.input.addEventListener("drop", e.drop), this.input.addEventListener("click", e.click), this.input.addEventListener("focus", e.focus), this.input.addEventListener("blur", e.commit), this._handlers = e;
  }
  _onKeydown(e) {
    if (this._handlers.redo && (e.keyCode === cx && e.shiftKey && (e.metaKey || e.ctrlKey) || e.keyCode === XW && e.ctrlKey))
      return e.preventDefault(), this._handlers.redo(e);
    if (this._handlers.undo && e.keyCode === cx && (e.metaKey || e.ctrlKey))
      return e.preventDefault(), this._handlers.undo(e);
    e.isComposing || this._handlers.selectionChange(e);
  }
  _onBeforeinput(e) {
    if (e.inputType === "historyUndo" && this._handlers.undo)
      return e.preventDefault(), this._handlers.undo(e);
    if (e.inputType === "historyRedo" && this._handlers.redo)
      return e.preventDefault(), this._handlers.redo(e);
  }
  _onCompositionEnd(e) {
    this._handlers.input(e);
  }
  _onInput(e) {
    e.isComposing || this._handlers.input(e);
  }
  /** Unbinds HTMLElement events to mask internal events */
  unbindEvents() {
    this.input.removeEventListener("keydown", this._onKeydown), this.input.removeEventListener("input", this._onInput), this.input.removeEventListener("beforeinput", this._onBeforeinput), this.input.removeEventListener("compositionend", this._onCompositionEnd), this.input.removeEventListener("drop", this._handlers.drop), this.input.removeEventListener("click", this._handlers.click), this.input.removeEventListener("focus", this._handlers.focus), this.input.removeEventListener("blur", this._handlers.commit), this._handlers = {};
  }
}
ke.HTMLMaskElement = kd;
class QW extends kd {
  /** InputElement to use mask on */
  constructor(e) {
    super(e), this.input = e;
  }
  /** Returns InputElement selection start */
  get _unsafeSelectionStart() {
    return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
  }
  /** Returns InputElement selection end */
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }
  /** Sets InputElement selection */
  _unsafeSelect(e, n) {
    this.input.setSelectionRange(e, n);
  }
  get value() {
    return this.input.value;
  }
  set value(e) {
    this.input.value = e;
  }
}
ke.HTMLMaskElement = kd;
class fA extends kd {
  /** Returns HTMLElement selection start */
  get _unsafeSelectionStart() {
    const e = this.rootElement, n = e.getSelection && e.getSelection(), r = n && n.anchorOffset, i = n && n.focusOffset;
    return i == null || r == null || r < i ? r : i;
  }
  /** Returns HTMLElement selection end */
  get _unsafeSelectionEnd() {
    const e = this.rootElement, n = e.getSelection && e.getSelection(), r = n && n.anchorOffset, i = n && n.focusOffset;
    return i == null || r == null || r > i ? r : i;
  }
  /** Sets HTMLElement selection */
  _unsafeSelect(e, n) {
    if (!this.rootElement.createRange) return;
    const r = this.rootElement.createRange();
    r.setStart(this.input.firstChild || this.input, e), r.setEnd(this.input.lastChild || this.input, n);
    const i = this.rootElement, o = i.getSelection && i.getSelection();
    o && (o.removeAllRanges(), o.addRange(r));
  }
  /** HTMLElement value */
  get value() {
    return this.input.textContent || "";
  }
  set value(e) {
    this.input.textContent = e;
  }
}
ke.HTMLContenteditableMaskElement = fA;
class Cd {
  constructor() {
    this.states = [], this.currentIndex = 0;
  }
  get currentState() {
    return this.states[this.currentIndex];
  }
  get isEmpty() {
    return this.states.length === 0;
  }
  push(e) {
    this.currentIndex < this.states.length - 1 && (this.states.length = this.currentIndex + 1), this.states.push(e), this.states.length > Cd.MAX_LENGTH && this.states.shift(), this.currentIndex = this.states.length - 1;
  }
  go(e) {
    return this.currentIndex = Math.min(Math.max(this.currentIndex + e, 0), this.states.length - 1), this.currentState;
  }
  undo() {
    return this.go(-1);
  }
  redo() {
    return this.go(1);
  }
  clear() {
    this.states.length = 0, this.currentIndex = 0;
  }
}
Cd.MAX_LENGTH = 100;
class ej {
  /**
    View element
  */
  /** Internal {@link Masked} model */
  constructor(e, n) {
    this.el = e instanceof _v ? e : e.isContentEditable && e.tagName !== "INPUT" && e.tagName !== "TEXTAREA" ? new fA(e) : new QW(e), this.masked = $r(n), this._listeners = {}, this._value = "", this._unmaskedValue = "", this._rawInputValue = "", this.history = new Cd(), this._saveSelection = this._saveSelection.bind(this), this._onInput = this._onInput.bind(this), this._onChange = this._onChange.bind(this), this._onDrop = this._onDrop.bind(this), this._onFocus = this._onFocus.bind(this), this._onClick = this._onClick.bind(this), this._onUndo = this._onUndo.bind(this), this._onRedo = this._onRedo.bind(this), this.alignCursor = this.alignCursor.bind(this), this.alignCursorFriendly = this.alignCursorFriendly.bind(this), this._bindEvents(), this.updateValue(), this._onChange();
  }
  maskEquals(e) {
    var n;
    return e == null || ((n = this.masked) == null ? void 0 : n.maskEquals(e));
  }
  /** Masked */
  get mask() {
    return this.masked.mask;
  }
  set mask(e) {
    if (this.maskEquals(e)) return;
    if (!(e instanceof ke.Masked) && this.masked.constructor === dA(e)) {
      this.masked.updateOptions({
        mask: e
      });
      return;
    }
    const n = e instanceof ke.Masked ? e : $r({
      mask: e
    });
    n.unmaskedValue = this.masked.unmaskedValue, this.masked = n;
  }
  /** Raw value */
  get value() {
    return this._value;
  }
  set value(e) {
    this.value !== e && (this.masked.value = e, this.updateControl("auto"));
  }
  /** Unmasked value */
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(e) {
    this.unmaskedValue !== e && (this.masked.unmaskedValue = e, this.updateControl("auto"));
  }
  /** Raw input value */
  get rawInputValue() {
    return this._rawInputValue;
  }
  set rawInputValue(e) {
    this.rawInputValue !== e && (this.masked.rawInputValue = e, this.updateControl(), this.alignCursor());
  }
  /** Typed unmasked value */
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(e) {
    this.masked.typedValueEquals(e) || (this.masked.typedValue = e, this.updateControl("auto"));
  }
  /** Display value */
  get displayValue() {
    return this.masked.displayValue;
  }
  /** Starts listening to element events */
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange,
      undo: this._onUndo,
      redo: this._onRedo
    });
  }
  /** Stops listening to element events */
  _unbindEvents() {
    this.el && this.el.unbindEvents();
  }
  /** Fires custom event */
  _fireEvent(e, n) {
    const r = this._listeners[e];
    r && r.forEach((i) => i(n));
  }
  /** Current selection start */
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }
  /** Current cursor position */
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(e) {
    !this.el || !this.el.isActive || (this.el.select(e, e), this._saveSelection());
  }
  /** Stores current selection */
  _saveSelection() {
    this.displayValue !== this.el.value && console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."), this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }
  /** Syncronizes model value from view */
  updateValue() {
    this.masked.value = this.el.value, this._value = this.masked.value, this._unmaskedValue = this.masked.unmaskedValue, this._rawInputValue = this.masked.rawInputValue;
  }
  /** Syncronizes view from model value, fires change events */
  updateControl(e) {
    const n = this.masked.unmaskedValue, r = this.masked.value, i = this.masked.rawInputValue, o = this.displayValue, s = this.unmaskedValue !== n || this.value !== r || this._rawInputValue !== i;
    this._unmaskedValue = n, this._value = r, this._rawInputValue = i, this.el.value !== o && (this.el.value = o), e === "auto" ? this.alignCursor() : e != null && (this.cursorPos = e), s && this._fireChangeEvents(), !this._historyChanging && (s || this.history.isEmpty) && this.history.push({
      unmaskedValue: n,
      selection: {
        start: this.selectionStart,
        end: this.cursorPos
      }
    });
  }
  /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */
  updateOptions(e) {
    const {
      mask: n,
      ...r
    } = e, i = !this.maskEquals(n), o = this.masked.optionsIsChanged(r);
    i && (this.mask = n), o && this.masked.updateOptions(r), (i || o) && this.updateControl();
  }
  /** Updates cursor */
  updateCursor(e) {
    e != null && (this.cursorPos = e, this._delayUpdateCursor(e));
  }
  /** Delays cursor update to support mobile browsers */
  _delayUpdateCursor(e) {
    this._abortUpdateCursor(), this._changingCursorPos = e, this._cursorChanging = setTimeout(() => {
      this.el && (this.cursorPos = this._changingCursorPos, this._abortUpdateCursor());
    }, 10);
  }
  /** Fires custom events */
  _fireChangeEvents() {
    this._fireEvent("accept", this._inputEvent), this.masked.isComplete && this._fireEvent("complete", this._inputEvent);
  }
  /** Aborts delayed cursor update */
  _abortUpdateCursor() {
    this._cursorChanging && (clearTimeout(this._cursorChanging), delete this._cursorChanging);
  }
  /** Aligns cursor to nearest available position */
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, ve.LEFT));
  }
  /** Aligns cursor only if selection is empty */
  alignCursorFriendly() {
    this.selectionStart === this.cursorPos && this.alignCursor();
  }
  /** Adds listener on custom event */
  on(e, n) {
    return this._listeners[e] || (this._listeners[e] = []), this._listeners[e].push(n), this;
  }
  /** Removes custom event listener */
  off(e, n) {
    if (!this._listeners[e]) return this;
    if (!n)
      return delete this._listeners[e], this;
    const r = this._listeners[e].indexOf(n);
    return r >= 0 && this._listeners[e].splice(r, 1), this;
  }
  /** Handles view input event */
  _onInput(e) {
    this._inputEvent = e, this._abortUpdateCursor();
    const n = new JW({
      // new state
      value: this.el.value,
      cursorPos: this.cursorPos,
      // old state
      oldValue: this.displayValue,
      oldSelection: this._selection
    }), r = this.masked.rawInputValue, i = this.masked.splice(n.startChangePos, n.removed.length, n.inserted, n.removeDirection, {
      input: !0,
      raw: !0
    }).offset, o = r === this.masked.rawInputValue ? n.removeDirection : ve.NONE;
    let s = this.masked.nearestInputPos(n.startChangePos + i, o);
    o !== ve.NONE && (s = this.masked.nearestInputPos(s, ve.NONE)), this.updateControl(s), delete this._inputEvent;
  }
  /** Handles view change event and commits model value */
  _onChange() {
    this.displayValue !== this.el.value && this.updateValue(), this.masked.doCommit(), this.updateControl(), this._saveSelection();
  }
  /** Handles view drop event, prevents by default */
  _onDrop(e) {
    e.preventDefault(), e.stopPropagation();
  }
  /** Restore last selection on focus */
  _onFocus(e) {
    this.alignCursorFriendly();
  }
  /** Restore last selection on focus */
  _onClick(e) {
    this.alignCursorFriendly();
  }
  _onUndo() {
    this._applyHistoryState(this.history.undo());
  }
  _onRedo() {
    this._applyHistoryState(this.history.redo());
  }
  _applyHistoryState(e) {
    e && (this._historyChanging = !0, this.unmaskedValue = e.unmaskedValue, this.el.select(e.selection.start, e.selection.end), this._saveSelection(), this._historyChanging = !1);
  }
  /** Unbind view events and removes element reference */
  destroy() {
    this._unbindEvents(), this._listeners.length = 0, delete this.el;
  }
}
ke.InputMask = ej;
class Re {
  /** Inserted symbols */
  /** Additional offset if any changes occurred before tail */
  /** Raw inserted is used by dynamic mask */
  /** Can skip chars */
  static normalize(e) {
    return Array.isArray(e) ? e : [e, new Re()];
  }
  constructor(e) {
    Object.assign(this, {
      inserted: "",
      rawInserted: "",
      tailShift: 0,
      skip: !1
    }, e);
  }
  /** Aggregate changes */
  aggregate(e) {
    return this.inserted += e.inserted, this.rawInserted += e.rawInserted, this.tailShift += e.tailShift, this.skip = this.skip || e.skip, this;
  }
  /** Total offset considering all changes */
  get offset() {
    return this.tailShift + this.inserted.length;
  }
  get consumed() {
    return !!this.rawInserted || this.skip;
  }
  equals(e) {
    return this.inserted === e.inserted && this.tailShift === e.tailShift && this.rawInserted === e.rawInserted && this.skip === e.skip;
  }
}
ke.ChangeDetails = Re;
class ir {
  /** Tail value as string */
  /** Tail start position */
  /** Start position */
  constructor(e, n, r) {
    e === void 0 && (e = ""), n === void 0 && (n = 0), this.value = e, this.from = n, this.stop = r;
  }
  toString() {
    return this.value;
  }
  extend(e) {
    this.value += String(e);
  }
  appendTo(e) {
    return e.append(this.toString(), {
      tail: !0
    }).aggregate(e._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  unshift(e) {
    if (!this.value.length || e != null && this.from >= e) return "";
    const n = this.value[0];
    return this.value = this.value.slice(1), n;
  }
  shift() {
    if (!this.value.length) return "";
    const e = this.value[this.value.length - 1];
    return this.value = this.value.slice(0, -1), e;
  }
}
class _t {
  /** */
  /** */
  /** Transforms value before mask processing */
  /** Transforms each char before mask processing */
  /** Validates if value is acceptable */
  /** Does additional processing at the end of editing */
  /** Format typed value to string */
  /** Parse string to get typed value */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    this._value = "", this._update({
      ..._t.DEFAULTS,
      ...e
    }), this._initialized = !0;
  }
  /** Sets and applies new options */
  updateOptions(e) {
    this.optionsIsChanged(e) && this.withValueRefresh(this._update.bind(this, e));
  }
  /** Sets new options */
  _update(e) {
    Object.assign(this, e);
  }
  /** Mask state */
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(e) {
    this._value = e._value;
  }
  /** Resets value */
  reset() {
    this._value = "";
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this.resolve(e, {
      input: !0
    });
  }
  /** Resolve new value */
  resolve(e, n) {
    n === void 0 && (n = {
      input: !0
    }), this.reset(), this.append(e, n, ""), this.doCommit();
  }
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(e) {
    this.resolve(e, {});
  }
  get typedValue() {
    return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
  }
  set typedValue(e) {
    this.format ? this.value = this.format(e, this) : this.unmaskedValue = String(e);
  }
  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.displayValue.length, {
      raw: !0
    });
  }
  set rawInputValue(e) {
    this.resolve(e, {
      raw: !0
    });
  }
  get displayValue() {
    return this.value;
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return this.isComplete;
  }
  /** Finds nearest input position in direction */
  nearestInputPos(e, n) {
    return e;
  }
  totalInputPositions(e, n) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), Math.min(this.displayValue.length, n - e);
  }
  /** Extracts value in range considering flags */
  extractInput(e, n, r) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), this.displayValue.slice(e, n);
  }
  /** Extracts tail in range */
  extractTail(e, n) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), new ir(this.extractInput(e, n), e);
  }
  /** Appends tail */
  appendTail(e) {
    return ui(e) && (e = new ir(String(e))), e.appendTo(this);
  }
  /** Appends char */
  _appendCharRaw(e, n) {
    return e ? (this._value += e, new Re({
      inserted: e,
      rawInserted: e
    })) : new Re();
  }
  /** Appends char */
  _appendChar(e, n, r) {
    n === void 0 && (n = {});
    const i = this.state;
    let o;
    if ([e, o] = this.doPrepareChar(e, n), e && (o = o.aggregate(this._appendCharRaw(e, n)), !o.rawInserted && this.autofix === "pad")) {
      const s = this.state;
      this.state = i;
      let a = this.pad(n);
      const l = this._appendCharRaw(e, n);
      a = a.aggregate(l), l.rawInserted || a.equals(o) ? o = a : this.state = s;
    }
    if (o.inserted) {
      let s, a = this.doValidate(n) !== !1;
      if (a && r != null) {
        const l = this.state;
        if (this.overwrite === !0) {
          s = r.state;
          for (let u = 0; u < o.rawInserted.length; ++u)
            r.unshift(this.displayValue.length - o.tailShift);
        }
        let c = this.appendTail(r);
        if (a = c.rawInserted.length === r.toString().length, !(a && c.inserted) && this.overwrite === "shift") {
          this.state = l, s = r.state;
          for (let u = 0; u < o.rawInserted.length; ++u)
            r.shift();
          c = this.appendTail(r), a = c.rawInserted.length === r.toString().length;
        }
        a && c.inserted && (this.state = l);
      }
      a || (o = new Re(), this.state = i, r && s && (r.state = s));
    }
    return o;
  }
  /** Appends optional placeholder at the end */
  _appendPlaceholder() {
    return new Re();
  }
  /** Appends optional eager placeholder at the end */
  _appendEager() {
    return new Re();
  }
  /** Appends symbols considering flags */
  append(e, n, r) {
    if (!ui(e)) throw new Error("value should be string");
    const i = ui(r) ? new ir(String(r)) : r;
    n != null && n.tail && (n._beforeTailState = this.state);
    let o;
    [e, o] = this.doPrepare(e, n);
    for (let s = 0; s < e.length; ++s) {
      const a = this._appendChar(e[s], n, i);
      if (!a.rawInserted && !this.doSkipInvalid(e[s], n, i)) break;
      o.aggregate(a);
    }
    return (this.eager === !0 || this.eager === "append") && n != null && n.input && e && o.aggregate(this._appendEager()), i != null && (o.tailShift += this.appendTail(i).tailShift), o;
  }
  remove(e, n) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), this._value = this.displayValue.slice(0, e) + this.displayValue.slice(n), new Re();
  }
  /** Calls function and reapplies current value */
  withValueRefresh(e) {
    if (this._refreshing || !this._initialized) return e();
    this._refreshing = !0;
    const n = this.rawInputValue, r = this.value, i = e();
    return this.rawInputValue = n, this.value && this.value !== r && r.indexOf(this.value) === 0 && (this.append(r.slice(this.displayValue.length), {}, ""), this.doCommit()), delete this._refreshing, i;
  }
  runIsolated(e) {
    if (this._isolated || !this._initialized) return e(this);
    this._isolated = !0;
    const n = this.state, r = e(this);
    return this.state = n, delete this._isolated, r;
  }
  doSkipInvalid(e, n, r) {
    return !!this.skipInvalid;
  }
  /** Prepares string before mask processing */
  doPrepare(e, n) {
    return n === void 0 && (n = {}), Re.normalize(this.prepare ? this.prepare(e, this, n) : e);
  }
  /** Prepares each char before mask processing */
  doPrepareChar(e, n) {
    return n === void 0 && (n = {}), Re.normalize(this.prepareChar ? this.prepareChar(e, this, n) : e);
  }
  /** Validates if value is acceptable */
  doValidate(e) {
    return (!this.validate || this.validate(this.value, this, e)) && (!this.parent || this.parent.doValidate(e));
  }
  /** Does additional processing at the end of editing */
  doCommit() {
    this.commit && this.commit(this.value, this);
  }
  splice(e, n, r, i, o) {
    r === void 0 && (r = ""), i === void 0 && (i = ve.NONE), o === void 0 && (o = {
      input: !0
    });
    const s = e + n, a = this.extractTail(s), l = this.eager === !0 || this.eager === "remove";
    let c;
    l && (i = ZW(i), c = this.extractInput(0, s, {
      raw: !0
    }));
    let u = e;
    const d = new Re();
    if (i !== ve.NONE && (u = this.nearestInputPos(e, n > 1 && e !== 0 && !l ? ve.NONE : i), d.tailShift = u - e), d.aggregate(this.remove(u)), l && i !== ve.NONE && c === this.rawInputValue)
      if (i === ve.FORCE_LEFT) {
        let f;
        for (; c === this.rawInputValue && (f = this.displayValue.length); )
          d.aggregate(new Re({
            tailShift: -1
          })).aggregate(this.remove(f - 1));
      } else i === ve.FORCE_RIGHT && a.unshift();
    return d.aggregate(this.append(r, o, a));
  }
  maskEquals(e) {
    return this.mask === e;
  }
  optionsIsChanged(e) {
    return !jc(this, e);
  }
  typedValueEquals(e) {
    const n = this.typedValue;
    return e === n || _t.EMPTY_VALUES.includes(e) && _t.EMPTY_VALUES.includes(n) || (this.format ? this.format(e, this) === this.format(this.typedValue, this) : !1);
  }
  pad(e) {
    return new Re();
  }
}
_t.DEFAULTS = {
  skipInvalid: !0
};
_t.EMPTY_VALUES = [void 0, null, ""];
ke.Masked = _t;
class Hi {
  /** */
  constructor(e, n) {
    e === void 0 && (e = []), n === void 0 && (n = 0), this.chunks = e, this.from = n;
  }
  toString() {
    return this.chunks.map(String).join("");
  }
  extend(e) {
    if (!String(e)) return;
    e = ui(e) ? new ir(String(e)) : e;
    const n = this.chunks[this.chunks.length - 1], r = n && // if stops are same or tail has no stop
    (n.stop === e.stop || e.stop == null) && // if tail chunk goes just after last chunk
    e.from === n.from + n.toString().length;
    if (e instanceof ir)
      r ? n.extend(e.toString()) : this.chunks.push(e);
    else if (e instanceof Hi) {
      if (e.stop == null) {
        let i;
        for (; e.chunks.length && e.chunks[0].stop == null; )
          i = e.chunks.shift(), i.from += e.from, this.extend(i);
      }
      e.toString() && (e.stop = e.blockIndex, this.chunks.push(e));
    }
  }
  appendTo(e) {
    if (!(e instanceof ke.MaskedPattern))
      return new ir(this.toString()).appendTo(e);
    const n = new Re();
    for (let r = 0; r < this.chunks.length; ++r) {
      const i = this.chunks[r], o = e._mapPosToBlock(e.displayValue.length), s = i.stop;
      let a;
      if (s != null && // if block not found or stop is behind lastBlock
      (!o || o.index <= s) && ((i instanceof Hi || // for continuous block also check if stop is exist
      e._stops.indexOf(s) >= 0) && n.aggregate(e._appendPlaceholder(s)), a = i instanceof Hi && e._blocks[s]), a) {
        const l = a.appendTail(i);
        n.aggregate(l);
        const c = i.toString().slice(l.rawInserted.length);
        c && n.aggregate(e.append(c, {
          tail: !0
        }));
      } else
        n.aggregate(e.append(i.toString(), {
          tail: !0
        }));
    }
    return n;
  }
  get state() {
    return {
      chunks: this.chunks.map((e) => e.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(e) {
    const {
      chunks: n,
      ...r
    } = e;
    Object.assign(this, r), this.chunks = n.map((i) => {
      const o = "chunks" in i ? new Hi() : new ir();
      return o.state = i, o;
    });
  }
  unshift(e) {
    if (!this.chunks.length || e != null && this.from >= e) return "";
    const n = e != null ? e - this.from : e;
    let r = 0;
    for (; r < this.chunks.length; ) {
      const i = this.chunks[r], o = i.unshift(n);
      if (i.toString()) {
        if (!o) break;
        ++r;
      } else
        this.chunks.splice(r, 1);
      if (o) return o;
    }
    return "";
  }
  shift() {
    if (!this.chunks.length) return "";
    let e = this.chunks.length - 1;
    for (; 0 <= e; ) {
      const n = this.chunks[e], r = n.shift();
      if (n.toString()) {
        if (!r) break;
        --e;
      } else
        this.chunks.splice(e, 1);
      if (r) return r;
    }
    return "";
  }
}
class tj {
  constructor(e, n) {
    this.masked = e, this._log = [];
    const {
      offset: r,
      index: i
    } = e._mapPosToBlock(n) || (n < 0 ? (
      // first
      {
        index: 0,
        offset: 0
      }
    ) : (
      // last
      {
        index: this.masked._blocks.length,
        offset: 0
      }
    ));
    this.offset = r, this.index = i, this.ok = !1;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const e = this._log.pop();
    return e && (this.state = e), e;
  }
  bindBlock() {
    this.block || (this.index < 0 && (this.index = 0, this.offset = 0), this.index >= this.masked._blocks.length && (this.index = this.masked._blocks.length - 1, this.offset = this.block.displayValue.length));
  }
  _pushLeft(e) {
    for (this.pushState(), this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((n = this.block) == null ? void 0 : n.displayValue.length) || 0) {
      var n;
      if (e()) return this.ok = !0;
    }
    return this.ok = !1;
  }
  _pushRight(e) {
    for (this.pushState(), this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0)
      if (e()) return this.ok = !0;
    return this.ok = !1;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, ve.FORCE_LEFT), this.offset !== 0))
        return !0;
    });
  }
  pushLeftBeforeInput() {
    return this._pushLeft(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, ve.LEFT), !0;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, ve.LEFT), !0;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, ve.FORCE_RIGHT), this.offset !== this.block.value.length))
        return !0;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, ve.NONE), !0;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, ve.NONE), !0;
    });
  }
}
class hA {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    Object.assign(this, e), this._value = "", this.isFixed = !0;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : "";
  }
  get rawInputValue() {
    return this._isRawInput ? this.value : "";
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = !1, this._value = "";
  }
  remove(e, n) {
    return e === void 0 && (e = 0), n === void 0 && (n = this._value.length), this._value = this._value.slice(0, e) + this._value.slice(n), this._value || (this._isRawInput = !1), new Re();
  }
  nearestInputPos(e, n) {
    n === void 0 && (n = ve.NONE);
    const r = 0, i = this._value.length;
    switch (n) {
      case ve.LEFT:
      case ve.FORCE_LEFT:
        return r;
      case ve.NONE:
      case ve.RIGHT:
      case ve.FORCE_RIGHT:
      default:
        return i;
    }
  }
  totalInputPositions(e, n) {
    return e === void 0 && (e = 0), n === void 0 && (n = this._value.length), this._isRawInput ? n - e : 0;
  }
  extractInput(e, n, r) {
    return e === void 0 && (e = 0), n === void 0 && (n = this._value.length), r === void 0 && (r = {}), r.raw && this._isRawInput && this._value.slice(e, n) || "";
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return !!this._value;
  }
  _appendChar(e, n) {
    if (n === void 0 && (n = {}), this.isFilled) return new Re();
    const r = this.eager === !0 || this.eager === "append", o = this.char === e && (this.isUnmasking || n.input || n.raw) && (!n.raw || !r) && !n.tail, s = new Re({
      inserted: this.char,
      rawInserted: o ? this.char : ""
    });
    return this._value = this.char, this._isRawInput = o && (n.raw || n.input), s;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: !0
    });
  }
  _appendPlaceholder() {
    const e = new Re();
    return this.isFilled || (this._value = e.inserted = this.char), e;
  }
  extractTail() {
    return new ir("");
  }
  appendTail(e) {
    return ui(e) && (e = new ir(String(e))), e.appendTo(this);
  }
  append(e, n, r) {
    const i = this._appendChar(e[0], n);
    return r != null && (i.tailShift += this.appendTail(r).tailShift), i;
  }
  doCommit() {
  }
  get state() {
    return {
      _value: this._value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(e) {
    this._value = e._value, this._isRawInput = !!e._rawInputValue;
  }
  pad(e) {
    return this._appendPlaceholder();
  }
}
class Uc {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    const {
      parent: n,
      isOptional: r,
      placeholderChar: i,
      displayChar: o,
      lazy: s,
      eager: a,
      ...l
    } = e;
    this.masked = $r(l), Object.assign(this, {
      parent: n,
      isOptional: r,
      placeholderChar: i,
      displayChar: o,
      lazy: s,
      eager: a
    });
  }
  reset() {
    this.isFilled = !1, this.masked.reset();
  }
  remove(e, n) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.value.length), e === 0 && n >= 1 ? (this.isFilled = !1, this.masked.remove(e, n)) : new Re();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get rawInputValue() {
    return this.masked.rawInputValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return !!this.masked.value || this.isOptional;
  }
  _appendChar(e, n) {
    if (n === void 0 && (n = {}), this.isFilled) return new Re();
    const r = this.masked.state;
    let i = this.masked._appendChar(e, this.currentMaskFlags(n));
    return i.inserted && this.doValidate(n) === !1 && (i = new Re(), this.masked.state = r), !i.inserted && !this.isOptional && !this.lazy && !n.input && (i.inserted = this.placeholderChar), i.skip = !i.inserted && !this.isOptional, this.isFilled = !!i.inserted, i;
  }
  append(e, n, r) {
    return this.masked.append(e, this.currentMaskFlags(n), r);
  }
  _appendPlaceholder() {
    return this.isFilled || this.isOptional ? new Re() : (this.isFilled = !0, new Re({
      inserted: this.placeholderChar
    }));
  }
  _appendEager() {
    return new Re();
  }
  extractTail(e, n) {
    return this.masked.extractTail(e, n);
  }
  appendTail(e) {
    return this.masked.appendTail(e);
  }
  extractInput(e, n, r) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.value.length), this.masked.extractInput(e, n, r);
  }
  nearestInputPos(e, n) {
    n === void 0 && (n = ve.NONE);
    const r = 0, i = this.value.length, o = Math.min(Math.max(e, r), i);
    switch (n) {
      case ve.LEFT:
      case ve.FORCE_LEFT:
        return this.isComplete ? o : r;
      case ve.RIGHT:
      case ve.FORCE_RIGHT:
        return this.isComplete ? o : i;
      case ve.NONE:
      default:
        return o;
    }
  }
  totalInputPositions(e, n) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.value.length), this.value.slice(e, n).length;
  }
  doValidate(e) {
    return this.masked.doValidate(this.currentMaskFlags(e)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(e)));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue,
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(e) {
    this.masked.state = e.masked, this.isFilled = e.isFilled;
  }
  currentMaskFlags(e) {
    var n;
    return {
      ...e,
      _beforeTailState: (e == null || (n = e._beforeTailState) == null ? void 0 : n.masked) || (e == null ? void 0 : e._beforeTailState)
    };
  }
  pad(e) {
    return new Re();
  }
}
Uc.DEFAULT_DEFINITIONS = {
  0: /\d/,
  a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  "*": /./
};
class nj extends _t {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const n = e.mask;
    n && (e.validate = (r) => r.search(n) >= 0), super._update(e);
  }
}
ke.MaskedRegExp = nj;
class Pt extends _t {
  /** */
  /** */
  /** Single char for empty input */
  /** Single char for filled input */
  /** Show placeholder only when needed */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  constructor(e) {
    super({
      ...Pt.DEFAULTS,
      ...e,
      definitions: Object.assign({}, Uc.DEFAULT_DEFINITIONS, e == null ? void 0 : e.definitions)
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    e.definitions = Object.assign({}, this.definitions, e.definitions), super._update(e), this._rebuildMask();
  }
  _rebuildMask() {
    const e = this.definitions;
    this._blocks = [], this.exposeBlock = void 0, this._stops = [], this._maskedBlocks = {};
    const n = this.mask;
    if (!n || !e) return;
    let r = !1, i = !1;
    for (let o = 0; o < n.length; ++o) {
      if (this.blocks) {
        const c = n.slice(o), u = Object.keys(this.blocks).filter((f) => c.indexOf(f) === 0);
        u.sort((f, h) => h.length - f.length);
        const d = u[0];
        if (d) {
          const {
            expose: f,
            repeat: h,
            ...p
          } = va(this.blocks[d]), m = {
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite,
            autofix: this.autofix,
            ...p,
            repeat: h,
            parent: this
          }, b = h != null ? new ke.RepeatBlock(
            m
            /* TODO */
          ) : $r(m);
          b && (this._blocks.push(b), f && (this.exposeBlock = b), this._maskedBlocks[d] || (this._maskedBlocks[d] = []), this._maskedBlocks[d].push(this._blocks.length - 1)), o += d.length - 1;
          continue;
        }
      }
      let s = n[o], a = s in e;
      if (s === Pt.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (s === "{" || s === "}") {
        r = !r;
        continue;
      }
      if (s === "[" || s === "]") {
        i = !i;
        continue;
      }
      if (s === Pt.ESCAPE_CHAR) {
        if (++o, s = n[o], !s) break;
        a = !1;
      }
      const l = a ? new Uc({
        isOptional: i,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar,
        ...va(e[s]),
        parent: this
      }) : new hA({
        char: s,
        eager: this.eager,
        isUnmasking: r
      });
      this._blocks.push(l);
    }
  }
  get state() {
    return {
      ...super.state,
      _blocks: this._blocks.map((e) => e.state)
    };
  }
  set state(e) {
    if (!e) {
      this.reset();
      return;
    }
    const {
      _blocks: n,
      ...r
    } = e;
    this._blocks.forEach((i, o) => i.state = n[o]), super.state = r;
  }
  reset() {
    super.reset(), this._blocks.forEach((e) => e.reset());
  }
  get isComplete() {
    return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every((e) => e.isComplete);
  }
  get isFilled() {
    return this._blocks.every((e) => e.isFilled);
  }
  get isFixed() {
    return this._blocks.every((e) => e.isFixed);
  }
  get isOptional() {
    return this._blocks.every((e) => e.isOptional);
  }
  doCommit() {
    this._blocks.forEach((e) => e.doCommit()), super.doCommit();
  }
  get unmaskedValue() {
    return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((e, n) => e += n.unmaskedValue, "");
  }
  set unmaskedValue(e) {
    if (this.exposeBlock) {
      const n = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.unmaskedValue = e, this.appendTail(n), this.doCommit();
    } else super.unmaskedValue = e;
  }
  get value() {
    return this.exposeBlock ? this.exposeBlock.value : (
      // TODO return _value when not in change?
      this._blocks.reduce((e, n) => e += n.value, "")
    );
  }
  set value(e) {
    if (this.exposeBlock) {
      const n = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.value = e, this.appendTail(n), this.doCommit();
    } else super.value = e;
  }
  get typedValue() {
    return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
  }
  set typedValue(e) {
    if (this.exposeBlock) {
      const n = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.typedValue = e, this.appendTail(n), this.doCommit();
    } else super.typedValue = e;
  }
  get displayValue() {
    return this._blocks.reduce((e, n) => e += n.displayValue, "");
  }
  appendTail(e) {
    return super.appendTail(e).aggregate(this._appendPlaceholder());
  }
  _appendEager() {
    var e;
    const n = new Re();
    let r = (e = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : e.index;
    if (r == null) return n;
    this._blocks[r].isFilled && ++r;
    for (let i = r; i < this._blocks.length; ++i) {
      const o = this._blocks[i]._appendEager();
      if (!o.inserted) break;
      n.aggregate(o);
    }
    return n;
  }
  _appendCharRaw(e, n) {
    n === void 0 && (n = {});
    const r = this._mapPosToBlock(this.displayValue.length), i = new Re();
    if (!r) return i;
    for (let s = r.index, a; a = this._blocks[s]; ++s) {
      var o;
      const l = a._appendChar(e, {
        ...n,
        _beforeTailState: (o = n._beforeTailState) == null || (o = o._blocks) == null ? void 0 : o[s]
      });
      if (i.aggregate(l), l.consumed) break;
    }
    return i;
  }
  extractTail(e, n) {
    e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length);
    const r = new Hi();
    return e === n || this._forEachBlocksInRange(e, n, (i, o, s, a) => {
      const l = i.extractTail(s, a);
      l.stop = this._findStopBefore(o), l.from = this._blockStartPos(o), l instanceof Hi && (l.blockIndex = o), r.extend(l);
    }), r;
  }
  extractInput(e, n, r) {
    if (e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), r === void 0 && (r = {}), e === n) return "";
    let i = "";
    return this._forEachBlocksInRange(e, n, (o, s, a, l) => {
      i += o.extractInput(a, l, r);
    }), i;
  }
  _findStopBefore(e) {
    let n;
    for (let r = 0; r < this._stops.length; ++r) {
      const i = this._stops[r];
      if (i <= e) n = i;
      else break;
    }
    return n;
  }
  /** Appends placeholder depending on laziness */
  _appendPlaceholder(e) {
    const n = new Re();
    if (this.lazy && e == null) return n;
    const r = this._mapPosToBlock(this.displayValue.length);
    if (!r) return n;
    const i = r.index, o = e ?? this._blocks.length;
    return this._blocks.slice(i, o).forEach((s) => {
      if (!s.lazy || e != null) {
        var a;
        n.aggregate(s._appendPlaceholder((a = s._blocks) == null ? void 0 : a.length));
      }
    }), n;
  }
  /** Finds block in pos */
  _mapPosToBlock(e) {
    let n = "";
    for (let r = 0; r < this._blocks.length; ++r) {
      const i = this._blocks[r], o = n.length;
      if (n += i.displayValue, e <= n.length)
        return {
          index: r,
          offset: e - o
        };
    }
  }
  _blockStartPos(e) {
    return this._blocks.slice(0, e).reduce((n, r) => n += r.displayValue.length, 0);
  }
  _forEachBlocksInRange(e, n, r) {
    n === void 0 && (n = this.displayValue.length);
    const i = this._mapPosToBlock(e);
    if (i) {
      const o = this._mapPosToBlock(n), s = o && i.index === o.index, a = i.offset, l = o && s ? o.offset : this._blocks[i.index].displayValue.length;
      if (r(this._blocks[i.index], i.index, a, l), o && !s) {
        for (let c = i.index + 1; c < o.index; ++c)
          r(this._blocks[c], c, 0, this._blocks[c].displayValue.length);
        r(this._blocks[o.index], o.index, 0, o.offset);
      }
    }
  }
  remove(e, n) {
    e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length);
    const r = super.remove(e, n);
    return this._forEachBlocksInRange(e, n, (i, o, s, a) => {
      r.aggregate(i.remove(s, a));
    }), r;
  }
  nearestInputPos(e, n) {
    if (n === void 0 && (n = ve.NONE), !this._blocks.length) return 0;
    const r = new tj(this, e);
    if (n === ve.NONE)
      return r.pushRightBeforeInput() || (r.popState(), r.pushLeftBeforeInput()) ? r.pos : this.displayValue.length;
    if (n === ve.LEFT || n === ve.FORCE_LEFT) {
      if (n === ve.LEFT) {
        if (r.pushRightBeforeFilled(), r.ok && r.pos === e) return e;
        r.popState();
      }
      if (r.pushLeftBeforeInput(), r.pushLeftBeforeRequired(), r.pushLeftBeforeFilled(), n === ve.LEFT) {
        if (r.pushRightBeforeInput(), r.pushRightBeforeRequired(), r.ok && r.pos <= e || (r.popState(), r.ok && r.pos <= e)) return r.pos;
        r.popState();
      }
      return r.ok ? r.pos : n === ve.FORCE_LEFT ? 0 : (r.popState(), r.ok || (r.popState(), r.ok) ? r.pos : 0);
    }
    return n === ve.RIGHT || n === ve.FORCE_RIGHT ? (r.pushRightBeforeInput(), r.pushRightBeforeRequired(), r.pushRightBeforeFilled() ? r.pos : n === ve.FORCE_RIGHT ? this.displayValue.length : (r.popState(), r.ok || (r.popState(), r.ok) ? r.pos : this.nearestInputPos(e, ve.LEFT))) : e;
  }
  totalInputPositions(e, n) {
    e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length);
    let r = 0;
    return this._forEachBlocksInRange(e, n, (i, o, s, a) => {
      r += i.totalInputPositions(s, a);
    }), r;
  }
  /** Get block by name */
  maskedBlock(e) {
    return this.maskedBlocks(e)[0];
  }
  /** Get all blocks by name */
  maskedBlocks(e) {
    const n = this._maskedBlocks[e];
    return n ? n.map((r) => this._blocks[r]) : [];
  }
  pad(e) {
    const n = new Re();
    return this._forEachBlocksInRange(0, this.displayValue.length, (r) => n.aggregate(r.pad(e))), n;
  }
}
Pt.DEFAULTS = {
  ..._t.DEFAULTS,
  lazy: !0,
  placeholderChar: "_"
};
Pt.STOP_CHAR = "`";
Pt.ESCAPE_CHAR = "\\";
Pt.InputDefinition = Uc;
Pt.FixedDefinition = hA;
ke.MaskedPattern = Pt;
class fc extends Pt {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */
  /** Min bound */
  /** Max bound */
  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  constructor(e) {
    super(e);
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      to: n = this.to || 0,
      from: r = this.from || 0,
      maxLength: i = this.maxLength || 0,
      autofix: o = this.autofix,
      ...s
    } = e;
    this.to = n, this.from = r, this.maxLength = Math.max(String(n).length, i), this.autofix = o;
    const a = String(this.from).padStart(this.maxLength, "0"), l = String(this.to).padStart(this.maxLength, "0");
    let c = 0;
    for (; c < l.length && l[c] === a[c]; ) ++c;
    s.mask = l.slice(0, c).replace(/0/g, "\\0") + "0".repeat(this.maxLength - c), super._update(s);
  }
  get isComplete() {
    return super.isComplete && !!this.value;
  }
  boundaries(e) {
    let n = "", r = "";
    const [, i, o] = e.match(/^(\D*)(\d*)(\D*)/) || [];
    return o && (n = "0".repeat(i.length) + o, r = "9".repeat(i.length) + o), n = n.padEnd(this.maxLength, "0"), r = r.padEnd(this.maxLength, "9"), [n, r];
  }
  doPrepareChar(e, n) {
    n === void 0 && (n = {});
    let r;
    return [e, r] = super.doPrepareChar(e.replace(/\D/g, ""), n), e || (r.skip = !this.isComplete), [e, r];
  }
  _appendCharRaw(e, n) {
    if (n === void 0 && (n = {}), !this.autofix || this.value.length + 1 > this.maxLength) return super._appendCharRaw(e, n);
    const r = String(this.from).padStart(this.maxLength, "0"), i = String(this.to).padStart(this.maxLength, "0"), [o, s] = this.boundaries(this.value + e);
    return Number(s) < this.from ? super._appendCharRaw(r[this.value.length], n) : Number(o) > this.to ? !n.tail && this.autofix === "pad" && this.value.length + 1 < this.maxLength ? super._appendCharRaw(r[this.value.length], n).aggregate(this._appendCharRaw(e, n)) : super._appendCharRaw(i[this.value.length], n) : super._appendCharRaw(e, n);
  }
  doValidate(e) {
    const n = this.value;
    if (n.search(/[^0]/) === -1 && n.length <= this._matchFrom) return !0;
    const [i, o] = this.boundaries(n);
    return this.from <= Number(o) && Number(i) <= this.to && super.doValidate(e);
  }
  pad(e) {
    const n = new Re();
    if (this.value.length === this.maxLength) return n;
    const r = this.value, i = this.maxLength - this.value.length;
    if (i) {
      this.reset();
      for (let o = 0; o < i; ++o)
        n.aggregate(super._appendCharRaw("0", e));
      r.split("").forEach((o) => this._appendCharRaw(o));
    }
    return n;
  }
}
ke.MaskedRange = fc;
const rj = "d{.}`m{.}`Y";
class Nr extends Pt {
  static extractPatternOptions(e) {
    const {
      mask: n,
      pattern: r,
      ...i
    } = e;
    return {
      ...i,
      mask: ui(n) ? n : r
    };
  }
  /** Pattern mask for date according to {@link MaskedDate#format} */
  /** Start date */
  /** End date */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(e) {
    super(Nr.extractPatternOptions({
      ...Nr.DEFAULTS,
      ...e
    }));
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      mask: n,
      pattern: r,
      blocks: i,
      ...o
    } = {
      ...Nr.DEFAULTS,
      ...e
    }, s = Object.assign({}, Nr.GET_DEFAULT_BLOCKS());
    e.min && (s.Y.from = e.min.getFullYear()), e.max && (s.Y.to = e.max.getFullYear()), e.min && e.max && s.Y.from === s.Y.to && (s.m.from = e.min.getMonth() + 1, s.m.to = e.max.getMonth() + 1, s.m.from === s.m.to && (s.d.from = e.min.getDate(), s.d.to = e.max.getDate())), Object.assign(s, this.blocks, i), super._update({
      ...o,
      mask: ui(n) ? n : r,
      blocks: s
    });
  }
  doValidate(e) {
    const n = this.date;
    return super.doValidate(e) && (!this.isComplete || this.isDateExist(this.value) && n != null && (this.min == null || this.min <= n) && (this.max == null || n <= this.max));
  }
  /** Checks if date is exists */
  isDateExist(e) {
    return this.format(this.parse(e, this), this).indexOf(e) >= 0;
  }
  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(e) {
    this.typedValue = e;
  }
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(e) {
    super.typedValue = e;
  }
  maskEquals(e) {
    return e === Date || super.maskEquals(e);
  }
  optionsIsChanged(e) {
    return super.optionsIsChanged(Nr.extractPatternOptions(e));
  }
}
Nr.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: fc,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: fc,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: fc,
    from: 1900,
    to: 9999
  }
});
Nr.DEFAULTS = {
  ...Pt.DEFAULTS,
  mask: Date,
  pattern: rj,
  format: (t, e) => {
    if (!t) return "";
    const n = String(t.getDate()).padStart(2, "0"), r = String(t.getMonth() + 1).padStart(2, "0"), i = t.getFullYear();
    return [n, r, i].join(".");
  },
  parse: (t, e) => {
    const [n, r, i] = t.split(".").map(Number);
    return new Date(i, r - 1, n);
  }
};
ke.MaskedDate = Nr;
class Sd extends _t {
  constructor(e) {
    super({
      ...Sd.DEFAULTS,
      ...e
    }), this.currentMask = void 0;
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update(e), "mask" in e && (this.exposeMask = void 0, this.compiledMasks = Array.isArray(e.mask) ? e.mask.map((n) => {
      const {
        expose: r,
        ...i
      } = va(n), o = $r({
        overwrite: this._overwrite,
        eager: this._eager,
        skipInvalid: this._skipInvalid,
        ...i
      });
      return r && (this.exposeMask = o), o;
    }) : []);
  }
  _appendCharRaw(e, n) {
    n === void 0 && (n = {});
    const r = this._applyDispatch(e, n);
    return this.currentMask && r.aggregate(this.currentMask._appendChar(e, this.currentMaskFlags(n))), r;
  }
  _applyDispatch(e, n, r) {
    e === void 0 && (e = ""), n === void 0 && (n = {}), r === void 0 && (r = "");
    const i = n.tail && n._beforeTailState != null ? n._beforeTailState._value : this.value, o = this.rawInputValue, s = n.tail && n._beforeTailState != null ? n._beforeTailState._rawInputValue : o, a = o.slice(s.length), l = this.currentMask, c = new Re(), u = l == null ? void 0 : l.state;
    return this.currentMask = this.doDispatch(e, {
      ...n
    }, r), this.currentMask && (this.currentMask !== l ? (this.currentMask.reset(), s && (this.currentMask.append(s, {
      raw: !0
    }), c.tailShift = this.currentMask.value.length - i.length), a && (c.tailShift += this.currentMask.append(a, {
      raw: !0,
      tail: !0
    }).tailShift)) : u && (this.currentMask.state = u)), c;
  }
  _appendPlaceholder() {
    const e = this._applyDispatch();
    return this.currentMask && e.aggregate(this.currentMask._appendPlaceholder()), e;
  }
  _appendEager() {
    const e = this._applyDispatch();
    return this.currentMask && e.aggregate(this.currentMask._appendEager()), e;
  }
  appendTail(e) {
    const n = new Re();
    return e && n.aggregate(this._applyDispatch("", {}, e)), n.aggregate(this.currentMask ? this.currentMask.appendTail(e) : super.appendTail(e));
  }
  currentMaskFlags(e) {
    var n, r;
    return {
      ...e,
      _beforeTailState: ((n = e._beforeTailState) == null ? void 0 : n.currentMaskRef) === this.currentMask && ((r = e._beforeTailState) == null ? void 0 : r.currentMask) || e._beforeTailState
    };
  }
  doDispatch(e, n, r) {
    return n === void 0 && (n = {}), r === void 0 && (r = ""), this.dispatch(e, this, n, r);
  }
  doValidate(e) {
    return super.doValidate(e) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(e)));
  }
  doPrepare(e, n) {
    n === void 0 && (n = {});
    let [r, i] = super.doPrepare(e, n);
    if (this.currentMask) {
      let o;
      [r, o] = super.doPrepare(r, this.currentMaskFlags(n)), i = i.aggregate(o);
    }
    return [r, i];
  }
  doPrepareChar(e, n) {
    n === void 0 && (n = {});
    let [r, i] = super.doPrepareChar(e, n);
    if (this.currentMask) {
      let o;
      [r, o] = super.doPrepareChar(r, this.currentMaskFlags(n)), i = i.aggregate(o);
    }
    return [r, i];
  }
  reset() {
    var e;
    (e = this.currentMask) == null || e.reset(), this.compiledMasks.forEach((n) => n.reset());
  }
  get value() {
    return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : "";
  }
  set value(e) {
    this.exposeMask ? (this.exposeMask.value = e, this.currentMask = this.exposeMask, this._applyDispatch()) : super.value = e;
  }
  get unmaskedValue() {
    return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : "";
  }
  set unmaskedValue(e) {
    this.exposeMask ? (this.exposeMask.unmaskedValue = e, this.currentMask = this.exposeMask, this._applyDispatch()) : super.unmaskedValue = e;
  }
  get typedValue() {
    return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : "";
  }
  set typedValue(e) {
    if (this.exposeMask) {
      this.exposeMask.typedValue = e, this.currentMask = this.exposeMask, this._applyDispatch();
      return;
    }
    let n = String(e);
    this.currentMask && (this.currentMask.typedValue = e, n = this.currentMask.unmaskedValue), this.unmaskedValue = n;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : "";
  }
  get isComplete() {
    var e;
    return !!((e = this.currentMask) != null && e.isComplete);
  }
  get isFilled() {
    var e;
    return !!((e = this.currentMask) != null && e.isFilled);
  }
  remove(e, n) {
    const r = new Re();
    return this.currentMask && r.aggregate(this.currentMask.remove(e, n)).aggregate(this._applyDispatch()), r;
  }
  get state() {
    var e;
    return {
      ...super.state,
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map((n) => n.state),
      currentMaskRef: this.currentMask,
      currentMask: (e = this.currentMask) == null ? void 0 : e.state
    };
  }
  set state(e) {
    const {
      compiledMasks: n,
      currentMaskRef: r,
      currentMask: i,
      ...o
    } = e;
    n && this.compiledMasks.forEach((s, a) => s.state = n[a]), r != null && (this.currentMask = r, this.currentMask.state = i), super.state = o;
  }
  extractInput(e, n, r) {
    return this.currentMask ? this.currentMask.extractInput(e, n, r) : "";
  }
  extractTail(e, n) {
    return this.currentMask ? this.currentMask.extractTail(e, n) : super.extractTail(e, n);
  }
  doCommit() {
    this.currentMask && this.currentMask.doCommit(), super.doCommit();
  }
  nearestInputPos(e, n) {
    return this.currentMask ? this.currentMask.nearestInputPos(e, n) : super.nearestInputPos(e, n);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : this._overwrite;
  }
  set overwrite(e) {
    this._overwrite = e;
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : this._eager;
  }
  set eager(e) {
    this._eager = e;
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
  }
  set skipInvalid(e) {
    this._skipInvalid = e;
  }
  get autofix() {
    return this.currentMask ? this.currentMask.autofix : this._autofix;
  }
  set autofix(e) {
    this._autofix = e;
  }
  maskEquals(e) {
    return Array.isArray(e) ? this.compiledMasks.every((n, r) => {
      if (!e[r]) return;
      const {
        mask: i,
        ...o
      } = e[r];
      return jc(n, o) && n.maskEquals(i);
    }) : super.maskEquals(e);
  }
  typedValueEquals(e) {
    var n;
    return !!((n = this.currentMask) != null && n.typedValueEquals(e));
  }
}
Sd.DEFAULTS = {
  ..._t.DEFAULTS,
  dispatch: (t, e, n, r) => {
    if (!e.compiledMasks.length) return;
    const i = e.rawInputValue, o = e.compiledMasks.map((s, a) => {
      const l = e.currentMask === s, c = l ? s.displayValue.length : s.nearestInputPos(s.displayValue.length, ve.FORCE_LEFT);
      return s.rawInputValue !== i ? (s.reset(), s.append(i, {
        raw: !0
      })) : l || s.remove(c), s.append(t, e.currentMaskFlags(n)), s.appendTail(r), {
        index: a,
        weight: s.rawInputValue.length,
        totalInputPositions: s.totalInputPositions(0, Math.max(c, s.nearestInputPos(s.displayValue.length, ve.FORCE_LEFT)))
      };
    });
    return o.sort((s, a) => a.weight - s.weight || a.totalInputPositions - s.totalInputPositions), e.compiledMasks[o[0].index];
  }
};
ke.MaskedDynamic = Sd;
class Td extends Pt {
  constructor(e) {
    super({
      ...Td.DEFAULTS,
      ...e
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      enum: n,
      ...r
    } = e;
    if (n) {
      const i = n.map((a) => a.length), o = Math.min(...i), s = Math.max(...i) - o;
      r.mask = "*".repeat(o), s && (r.mask += "[" + "*".repeat(s) + "]"), this.enum = n;
    }
    super._update(r);
  }
  _appendCharRaw(e, n) {
    n === void 0 && (n = {});
    const r = Math.min(this.nearestInputPos(0, ve.FORCE_RIGHT), this.value.length), i = this.enum.filter((o) => this.matchValue(o, this.unmaskedValue + e, r));
    if (i.length) {
      i.length === 1 && this._forEachBlocksInRange(0, this.value.length, (s, a) => {
        const l = i[0][a];
        a >= this.value.length || l === s.value || (s.reset(), s._appendChar(l, n));
      });
      const o = super._appendCharRaw(i[0][this.value.length], n);
      return i.length === 1 && i[0].slice(this.unmaskedValue.length).split("").forEach((s) => o.aggregate(super._appendCharRaw(s))), o;
    }
    return new Re({
      skip: !this.isComplete
    });
  }
  extractTail(e, n) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), new ir("", e);
  }
  remove(e, n) {
    if (e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), e === n) return new Re();
    const r = Math.min(super.nearestInputPos(0, ve.FORCE_RIGHT), this.value.length);
    let i;
    for (i = e; i >= 0 && !(this.enum.filter((a) => this.matchValue(a, this.value.slice(r, i), r)).length > 1); --i)
      ;
    const o = super.remove(i, n);
    return o.tailShift += i - e, o;
  }
  get isComplete() {
    return this.enum.indexOf(this.value) >= 0;
  }
}
Td.DEFAULTS = {
  ...Pt.DEFAULTS,
  matchValue: (t, e, n) => t.indexOf(e, n) === n
};
ke.MaskedEnum = Td;
class ij extends _t {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update({
      ...e,
      validate: e.mask
    });
  }
}
ke.MaskedFunction = ij;
var pA;
class on extends _t {
  /** Single char */
  /** Single char */
  /** Array of single chars */
  /** */
  /** */
  /** Digits after point */
  /** Flag to remove leading and trailing zeros in the end of editing */
  /** Flag to pad trailing zeros after point in the end of editing */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(e) {
    super({
      ...on.DEFAULTS,
      ...e
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update(e), this._updateRegExps();
  }
  _updateRegExps() {
    const e = "^" + (this.allowNegative ? "[+|\\-]?" : ""), n = "\\d*", r = (this.scale ? "(" + qh(this.radix) + "\\d{0," + this.scale + "})?" : "") + "$";
    this._numberRegExp = new RegExp(e + n + r), this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map(qh).join("") + "]", "g"), this._thousandsSeparatorRegExp = new RegExp(qh(this.thousandsSeparator), "g");
  }
  _removeThousandsSeparators(e) {
    return e.replace(this._thousandsSeparatorRegExp, "");
  }
  _insertThousandsSeparators(e) {
    const n = e.split(this.radix);
    return n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator), n.join(this.radix);
  }
  doPrepareChar(e, n) {
    n === void 0 && (n = {});
    const [r, i] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */
    (n.input && n.raw || !n.input && !n.raw) ? e.replace(this._mapToRadixRegExp, this.radix) : e), n);
    return e && !r && (i.skip = !0), r && !this.allowPositive && !this.value && r !== "-" && i.aggregate(this._appendChar("-")), [r, i];
  }
  _separatorsCount(e, n) {
    n === void 0 && (n = !1);
    let r = 0;
    for (let i = 0; i < e; ++i)
      this._value.indexOf(this.thousandsSeparator, i) === i && (++r, n && (e += this.thousandsSeparator.length));
    return r;
  }
  _separatorsCountFromSlice(e) {
    return e === void 0 && (e = this._value), this._separatorsCount(this._removeThousandsSeparators(e).length, !0);
  }
  extractInput(e, n, r) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), [e, n] = this._adjustRangeWithSeparators(e, n), this._removeThousandsSeparators(super.extractInput(e, n, r));
  }
  _appendCharRaw(e, n) {
    n === void 0 && (n = {});
    const r = n.tail && n._beforeTailState ? n._beforeTailState._value : this._value, i = this._separatorsCountFromSlice(r);
    this._value = this._removeThousandsSeparators(this.value);
    const o = this._value;
    this._value += e;
    const s = this.number;
    let a = !isNaN(s), l = !1;
    if (a) {
      let f;
      this.min != null && this.min < 0 && this.number < this.min && (f = this.min), this.max != null && this.max > 0 && this.number > this.max && (f = this.max), f != null && (this.autofix ? (this._value = this.format(f, this).replace(on.UNMASKED_RADIX, this.radix), l || (l = o === this._value && !n.tail)) : a = !1), a && (a = !!this._value.match(this._numberRegExp));
    }
    let c;
    a ? c = new Re({
      inserted: this._value.slice(o.length),
      rawInserted: l ? "" : e,
      skip: l
    }) : (this._value = o, c = new Re()), this._value = this._insertThousandsSeparators(this._value);
    const u = n.tail && n._beforeTailState ? n._beforeTailState._value : this._value, d = this._separatorsCountFromSlice(u);
    return c.tailShift += (d - i) * this.thousandsSeparator.length, c;
  }
  _findSeparatorAround(e) {
    if (this.thousandsSeparator) {
      const n = e - this.thousandsSeparator.length + 1, r = this.value.indexOf(this.thousandsSeparator, n);
      if (r <= e) return r;
    }
    return -1;
  }
  _adjustRangeWithSeparators(e, n) {
    const r = this._findSeparatorAround(e);
    r >= 0 && (e = r);
    const i = this._findSeparatorAround(n);
    return i >= 0 && (n = i + this.thousandsSeparator.length), [e, n];
  }
  remove(e, n) {
    e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), [e, n] = this._adjustRangeWithSeparators(e, n);
    const r = this.value.slice(0, e), i = this.value.slice(n), o = this._separatorsCount(r.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(r + i));
    const s = this._separatorsCountFromSlice(r);
    return new Re({
      tailShift: (s - o) * this.thousandsSeparator.length
    });
  }
  nearestInputPos(e, n) {
    if (!this.thousandsSeparator) return e;
    switch (n) {
      case ve.NONE:
      case ve.LEFT:
      case ve.FORCE_LEFT: {
        const r = this._findSeparatorAround(e - 1);
        if (r >= 0) {
          const i = r + this.thousandsSeparator.length;
          if (e < i || this.value.length <= i || n === ve.FORCE_LEFT)
            return r;
        }
        break;
      }
      case ve.RIGHT:
      case ve.FORCE_RIGHT: {
        const r = this._findSeparatorAround(e);
        if (r >= 0)
          return r + this.thousandsSeparator.length;
      }
    }
    return e;
  }
  doCommit() {
    if (this.value) {
      const e = this.number;
      let n = e;
      this.min != null && (n = Math.max(n, this.min)), this.max != null && (n = Math.min(n, this.max)), n !== e && (this.unmaskedValue = this.format(n, this));
      let r = this.value;
      this.normalizeZeros && (r = this._normalizeZeros(r)), this.padFractionalZeros && this.scale > 0 && (r = this._padFractionalZeros(r)), this._value = r;
    }
    super.doCommit();
  }
  _normalizeZeros(e) {
    const n = this._removeThousandsSeparators(e).split(this.radix);
    return n[0] = n[0].replace(/^(\D*)(0*)(\d*)/, (r, i, o, s) => i + s), e.length && !/\d$/.test(n[0]) && (n[0] = n[0] + "0"), n.length > 1 && (n[1] = n[1].replace(/0*$/, ""), n[1].length || (n.length = 1)), this._insertThousandsSeparators(n.join(this.radix));
  }
  _padFractionalZeros(e) {
    if (!e) return e;
    const n = e.split(this.radix);
    return n.length < 2 && n.push(""), n[1] = n[1].padEnd(this.scale, "0"), n.join(this.radix);
  }
  doSkipInvalid(e, n, r) {
    n === void 0 && (n = {});
    const i = this.scale === 0 && e !== this.thousandsSeparator && (e === this.radix || e === on.UNMASKED_RADIX || this.mapToRadix.includes(e));
    return super.doSkipInvalid(e, n, r) && !i;
  }
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, on.UNMASKED_RADIX);
  }
  set unmaskedValue(e) {
    super.unmaskedValue = e;
  }
  get typedValue() {
    return this.parse(this.unmaskedValue, this);
  }
  set typedValue(e) {
    this.rawInputValue = this.format(e, this).replace(on.UNMASKED_RADIX, this.radix);
  }
  /** Parsed Number */
  get number() {
    return this.typedValue;
  }
  set number(e) {
    this.typedValue = e;
  }
  get allowNegative() {
    return this.min != null && this.min < 0 || this.max != null && this.max < 0;
  }
  get allowPositive() {
    return this.min != null && this.min > 0 || this.max != null && this.max > 0;
  }
  typedValueEquals(e) {
    return (super.typedValueEquals(e) || on.EMPTY_VALUES.includes(e) && on.EMPTY_VALUES.includes(this.typedValue)) && !(e === 0 && this.value === "");
  }
}
pA = on;
on.UNMASKED_RADIX = ".";
on.EMPTY_VALUES = [..._t.EMPTY_VALUES, 0];
on.DEFAULTS = {
  ..._t.DEFAULTS,
  mask: Number,
  radix: ",",
  thousandsSeparator: "",
  mapToRadix: [pA.UNMASKED_RADIX],
  min: Number.MIN_SAFE_INTEGER,
  max: Number.MAX_SAFE_INTEGER,
  scale: 2,
  normalizeZeros: !0,
  padFractionalZeros: !1,
  parse: Number,
  format: (t) => t.toLocaleString("en-US", {
    useGrouping: !1,
    maximumFractionDigits: 20
  })
};
ke.MaskedNumber = on;
const _m = {
  MASKED: "value",
  UNMASKED: "unmaskedValue",
  TYPED: "typedValue"
};
function mA(t, e, n) {
  e === void 0 && (e = _m.MASKED), n === void 0 && (n = _m.MASKED);
  const r = $r(t);
  return (i) => r.runIsolated((o) => (o[e] = i, o[n]));
}
function oj(t, e, n, r) {
  return mA(e, n, r)(t);
}
ke.PIPE_TYPE = _m;
ke.createPipe = mA;
ke.pipe = oj;
class sj extends Pt {
  get repeatFrom() {
    var e;
    return (e = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === 1 / 0 ? 0 : this.repeat) != null ? e : 0;
  }
  get repeatTo() {
    var e;
    return (e = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? e : 1 / 0;
  }
  constructor(e) {
    super(e);
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    var n, r, i;
    const {
      repeat: o,
      ...s
    } = va(e);
    this._blockOpts = Object.assign({}, this._blockOpts, s);
    const a = $r(this._blockOpts);
    this.repeat = (n = (r = o ?? a.repeat) != null ? r : this.repeat) != null ? n : 1 / 0, super._update({
      mask: "m".repeat(Math.max(this.repeatTo === 1 / 0 && ((i = this._blocks) == null ? void 0 : i.length) || 0, this.repeatFrom)),
      blocks: {
        m: a
      },
      eager: a.eager,
      overwrite: a.overwrite,
      skipInvalid: a.skipInvalid,
      lazy: a.lazy,
      placeholderChar: a.placeholderChar,
      displayChar: a.displayChar
    });
  }
  _allocateBlock(e) {
    if (e < this._blocks.length) return this._blocks[e];
    if (this.repeatTo === 1 / 0 || this._blocks.length < this.repeatTo)
      return this._blocks.push($r(this._blockOpts)), this.mask += "m", this._blocks[this._blocks.length - 1];
  }
  _appendCharRaw(e, n) {
    n === void 0 && (n = {});
    const r = new Re();
    for (
      let l = (i = (o = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : o.index) != null ? i : Math.max(this._blocks.length - 1, 0), c, u;
      // try to get a block or
      // try to allocate a new block if not allocated already
      c = (s = this._blocks[l]) != null ? s : u = !u && this._allocateBlock(l);
      ++l
    ) {
      var i, o, s, a;
      const d = c._appendChar(e, {
        ...n,
        _beforeTailState: (a = n._beforeTailState) == null || (a = a._blocks) == null ? void 0 : a[l]
      });
      if (d.skip && u) {
        this._blocks.pop(), this.mask = this.mask.slice(1);
        break;
      }
      if (r.aggregate(d), d.consumed) break;
    }
    return r;
  }
  _trimEmptyTail(e, n) {
    var r, i;
    e === void 0 && (e = 0);
    const o = Math.max(((r = this._mapPosToBlock(e)) == null ? void 0 : r.index) || 0, this.repeatFrom, 0);
    let s;
    n != null && (s = (i = this._mapPosToBlock(n)) == null ? void 0 : i.index), s == null && (s = this._blocks.length - 1);
    let a = 0;
    for (let l = s; o <= l && !this._blocks[l].unmaskedValue; --l, ++a)
      ;
    a && (this._blocks.splice(s - a + 1, a), this.mask = this.mask.slice(a));
  }
  reset() {
    super.reset(), this._trimEmptyTail();
  }
  remove(e, n) {
    e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length);
    const r = super.remove(e, n);
    return this._trimEmptyTail(e, n), r;
  }
  totalInputPositions(e, n) {
    return e === void 0 && (e = 0), n == null && this.repeatTo === 1 / 0 ? 1 / 0 : super.totalInputPositions(e, n);
  }
  get state() {
    return super.state;
  }
  set state(e) {
    this._blocks.length = e._blocks.length, this.mask = this.mask.slice(0, this._blocks.length), super.state = e;
  }
}
ke.RepeatBlock = sj;
try {
  globalThis.IMask = ke;
} catch {
}
const gA = {
  // common
  mask: me.oneOfType([me.array, me.func, me.string, me.instanceOf(RegExp), me.oneOf([Date, Number, ke.Masked]), me.instanceOf(ke.Masked)]),
  value: me.any,
  unmask: me.oneOfType([me.bool, me.oneOf(["typed"])]),
  prepare: me.func,
  prepareChar: me.func,
  validate: me.func,
  commit: me.func,
  overwrite: me.oneOfType([me.bool, me.oneOf(["shift"])]),
  eager: me.oneOfType([me.bool, me.oneOf(["append", "remove"])]),
  skipInvalid: me.bool,
  // events
  onAccept: me.func,
  onComplete: me.func,
  // pattern
  placeholderChar: me.string,
  displayChar: me.string,
  lazy: me.bool,
  definitions: me.object,
  blocks: me.object,
  // enum
  enum: me.arrayOf(me.string),
  // range
  maxLength: me.number,
  from: me.number,
  to: me.number,
  // date
  pattern: me.string,
  format: me.func,
  parse: me.func,
  autofix: me.oneOfType([me.bool, me.oneOf(["pad"])]),
  // number
  radix: me.string,
  thousandsSeparator: me.string,
  mapToRadix: me.arrayOf(me.string),
  scale: me.number,
  normalizeZeros: me.bool,
  padFractionalZeros: me.bool,
  min: me.oneOfType([me.number, me.instanceOf(Date)]),
  max: me.oneOfType([me.number, me.instanceOf(Date)]),
  // dynamic
  dispatch: me.func,
  // ref
  inputRef: me.oneOfType([me.func, me.shape({
    current: me.object
  })])
}, vA = Object.keys(gA).filter((t) => t !== "value"), aj = ["value", "unmask", "onAccept", "onComplete", "inputRef"], lj = vA.filter((t) => aj.indexOf(t) < 0);
function cj(t) {
  var e;
  const n = (e = class extends he.Component {
    constructor(o) {
      super(o), this._inputRef = this._inputRef.bind(this);
    }
    componentDidMount() {
      this.props.mask && this.initMask();
    }
    componentDidUpdate() {
      const o = this.props, s = this._extractMaskOptionsFromProps(o);
      if (s.mask)
        this.maskRef ? (this.maskRef.updateOptions(s), "value" in o && o.value !== void 0 && (this.maskValue = o.value)) : this.initMask(s);
      else if (this.destroyMask(), "value" in o && o.value !== void 0) {
        var a;
        (a = this.element) != null && a.isContentEditable && this.element.tagName !== "INPUT" && this.element.tagName !== "TEXTAREA" ? this.element.textContent = o.value : this.element.value = o.value;
      }
    }
    componentWillUnmount() {
      this.destroyMask();
    }
    _inputRef(o) {
      this.element = o, this.props.inputRef && (Object.prototype.hasOwnProperty.call(this.props.inputRef, "current") ? this.props.inputRef.current = o : this.props.inputRef(o));
    }
    initMask(o) {
      o === void 0 && (o = this._extractMaskOptionsFromProps(this.props)), this.maskRef = ke(this.element, o).on("accept", this._onAccept.bind(this)).on("complete", this._onComplete.bind(this)), "value" in this.props && this.props.value !== void 0 && (this.maskValue = this.props.value);
    }
    destroyMask() {
      this.maskRef && (this.maskRef.destroy(), delete this.maskRef);
    }
    _extractMaskOptionsFromProps(o) {
      const {
        ...s
      } = o;
      return Object.keys(s).filter((a) => lj.indexOf(a) < 0).forEach((a) => {
        delete s[a];
      }), s;
    }
    _extractNonMaskProps(o) {
      const {
        ...s
      } = o;
      return vA.forEach((a) => {
        a !== "maxLength" && delete s[a];
      }), "defaultValue" in s || (s.defaultValue = o.mask ? "" : s.value), delete s.value, s;
    }
    get maskValue() {
      return this.maskRef ? this.props.unmask === "typed" ? this.maskRef.typedValue : this.props.unmask ? this.maskRef.unmaskedValue : this.maskRef.value : "";
    }
    set maskValue(o) {
      this.maskRef && (o = o == null && this.props.unmask !== "typed" ? "" : o, this.props.unmask === "typed" ? this.maskRef.typedValue = o : this.props.unmask ? this.maskRef.unmaskedValue = o : this.maskRef.value = o);
    }
    _onAccept(o) {
      this.props.onAccept && this.maskRef && this.props.onAccept(this.maskValue, this.maskRef, o);
    }
    _onComplete(o) {
      this.props.onComplete && this.maskRef && this.props.onComplete(this.maskValue, this.maskRef, o);
    }
    render() {
      return he.createElement(t, {
        ...this._extractNonMaskProps(this.props),
        inputRef: this._inputRef
      });
    }
  }, e.displayName = void 0, e.propTypes = void 0, e), r = t.displayName || t.name || "Component";
  return n.displayName = "IMask(" + r + ")", n.propTypes = gA, he.forwardRef((i, o) => he.createElement(n, {
    ...i,
    ref: o
  }));
}
const uj = cj((t) => {
  let {
    inputRef: e,
    ...n
  } = t;
  return he.createElement("input", {
    ...n,
    ref: e
  });
}), dj = (t, e) => he.createElement(uj, {
  ...t,
  ref: e
});
he.forwardRef(dj);
function fj(t, e) {
  let {
    onAccept: n,
    onComplete: r,
    ref: i = Me(null),
    defaultValue: o,
    defaultUnmaskedValue: s,
    defaultTypedValue: a
  } = e === void 0 ? {} : e;
  const l = Me(null), [c, u] = pe({}), [d, f] = pe(""), [h, p] = pe(""), [m, b] = pe(), y = ct(() => {
    var S;
    (S = l.current) == null || S.destroy(), l.current = null;
  }, []), k = ct(() => {
    const S = l.current;
    S && (u({
      value: S.value,
      unmaskedValue: S.unmaskedValue,
      typedValue: S.typedValue
    }), b(S.typedValue), p(S.unmaskedValue), f(S.value));
  }, []), C = ct((S) => {
    const T = l.current;
    T && (k(), n == null || n(T.value, T, S));
  }, [n]), x = ct((S) => l.current && (r == null ? void 0 : r(l.current.value, l.current, S)), [r]);
  return De(() => {
    const {
      value: S,
      ...T
    } = c, E = l.current;
    !E || d === void 0 || (S !== d && (E.value = d, E.value !== d && C()), u(T));
  }, [d]), De(() => {
    const {
      unmaskedValue: S,
      ...T
    } = c, E = l.current;
    !E || h === void 0 || (S !== h && (E.unmaskedValue = h, E.unmaskedValue !== h && C()), u(T));
  }, [h]), De(() => {
    const {
      typedValue: S,
      ...T
    } = c, E = l.current;
    !E || m === void 0 || (S !== m && (E.typedValue = m, E.masked.typedValueEquals(m) || C()), u(T));
  }, [m]), De(() => {
    const S = i.current;
    if (!S || !(t != null && t.mask)) return y();
    const T = l.current;
    T ? T == null || T.updateOptions(t) : S && t != null && t.mask && (l.current = ke(S, t), k(), o !== void 0 && f(o), s !== void 0 && p(s), a !== void 0 && b(a));
  }, [t, y, C]), De(() => {
    if (!l.current) return;
    const S = l.current;
    return S.on("accept", C), S.on("complete", x), () => {
      S.off("accept", C), S.off("complete", x);
    };
  }, [C, x]), De(() => y, [y]), {
    ref: i,
    maskRef: l,
    value: d,
    setValue: f,
    unmaskedValue: h,
    setUnmaskedValue: p,
    typedValue: m,
    setTypedValue: b
  };
}
const Kh = void 0, ux = null, ese = ["HH:mm", "hh:mm a"], tse = ["MM/dd/yyyy", "dd/MM/yyyy"], dx = {
  "dd/MM/yyyy": "d{/}`m{/}`Y",
  "MM/dd/yyyy": "m{/}`d{/}`Y",
  "HH:mm": "HH{:}`MM",
  "hh:mm a": "hh{:}`MM"
}, es = ce((t, e) => {
  const { value: n, onChange: r, format: i, ...o } = t, [s, a] = pe(() => n ? de.fromJSDate(n).toFormat("a") : "AM"), l = En(() => `${i.date || ""} ${i.time || ""}`.trim(), [i]), c = En(
    () => `${i.date && dx[i.date] || ""} ${i.time && dx[i.time] || ""}`.trim(),
    [i]
  ), u = En(
    () => ({
      mask: Date,
      pattern: c,
      blocks: {
        hh: {
          mask: ke.MaskedRange,
          placeholderChar: "H",
          from: 1,
          to: 12,
          maxLength: 2
        },
        HH: {
          mask: ke.MaskedRange,
          placeholderChar: "H",
          from: 0,
          to: 23,
          maxLength: 2
        },
        MM: {
          mask: ke.MaskedRange,
          placeholderChar: "M",
          from: 0,
          to: 59,
          maxLength: 2
        }
      },
      format(m) {
        return m ? de.fromJSDate(m).toFormat(l).toUpperCase() : "";
      },
      parse(m) {
        let b = m;
        i.time === "hh:mm a" && (b += ` ${s}`);
        const y = de.fromFormat(b.toUpperCase(), l);
        return y.isValid ? y.toJSDate() : /* @__PURE__ */ new Date();
      },
      autofix: !0,
      overwrite: !0
    }),
    [c, l, i.time, s]
  ), d = ct(
    (m, b) => {
      if (m === "") {
        r(Kh);
        return;
      }
      let y = m;
      i.time === "hh:mm a" && (y += ` ${b}`);
      const k = de.fromFormat(y, l);
      k.isValid ? r(k.toJSDate()) : r(!m || m === "" ? Kh : ux);
    },
    [i.time, l, r]
  ), { ref: f, setValue: h } = fj(
    { ...u, lazy: !0 },
    {
      defaultValue: n && de.fromJSDate(n).toFormat(l).toLowerCase() || "",
      onAccept: (m) => {
        d(m, s);
      }
    }
  );
  De(() => {
    var b;
    if (n === ux)
      return;
    if (n === Kh) {
      h("");
      return;
    }
    const m = de.fromJSDate(n).toFormat(
      i.time === "hh:mm a" ? "hh:mm" : l
    );
    m !== ((b = f.current) == null ? void 0 : b.value) && h(m);
  }, [l, i.time, f, h, n]);
  const p = En(() => i.date ? i.date.toUpperCase() : i.time ? "HH:MM" : "", [i.date, i.time]);
  return /* @__PURE__ */ F("div", { className: "relative", children: [
    i.date && /* @__PURE__ */ v(
      xI,
      {
        className: "text-subtle pointer-events-none absolute left-2 top-[9px] text-sm",
        size: 16
      }
    ),
    /* @__PURE__ */ v(
      hn,
      {
        ref: (m) => {
          typeof e == "function" ? e(m) : e && (e.current = m), f.current = m;
        },
        ...o,
        className: I({ "pl-7": i.date }, o.className),
        placeholder: p,
        onKeyDown: (m) => {
          var b, y, k;
          if (i.time === "hh:mm a") {
            if (m.key === "A" || m.key === "a") {
              m.preventDefault();
              const C = "AM";
              a(C), d(((b = f.current) == null ? void 0 : b.value) || "", C);
              return;
            }
            if (m.key === "P" || m.key === "p") {
              m.preventDefault();
              const C = "PM";
              a(C), d(((y = f.current) == null ? void 0 : y.value) || "", C);
              return;
            }
          }
          (k = o.onKeyDown) == null || k.call(o, m);
        }
      }
    ),
    i.time === "hh:mm a" && /* @__PURE__ */ v(
      Ze,
      {
        className: "absolute right-1 top-[5px] text-sm",
        intent: "minimal",
        size: "xs",
        onClick: () => {
          var b;
          const m = s === "AM" ? "PM" : "AM";
          a(m), d(((b = f.current) == null ? void 0 : b.value) || "", m);
        },
        children: s
      }
    )
  ] });
});
es.displayName = "DateTimeInput";
const qc = ce((t, e) => {
  const { onChange: n, dateValue: r, timeValue: i, format: o, intent: s, onTimeInputFinish: a, ...l } = t, c = Me(null), u = Me(null);
  vS(e, () => u.current, []);
  const d = ct(
    (f, h) => {
      n(f, h);
    },
    [n]
  );
  return /* @__PURE__ */ F("div", { className: "flex gap-2", children: [
    /* @__PURE__ */ v(
      es,
      {
        ...l,
        ref: u,
        format: { date: o.date },
        className: "size-full",
        value: r,
        intent: s,
        onChange: (f) => {
          d(f, i);
        },
        style: { width: `${ei({ date: o.date })}px` },
        onKeyUp: (f) => {
          var h, p, m, b;
          f.key !== "Backspace" && ((h = u.current) == null ? void 0 : h.selectionStart) === ((p = u.current) == null ? void 0 : p.value.length) && r && ((m = c.current) == null || m.focus(), (b = c.current) == null || b.setSelectionRange(0, c.current.value.length));
        },
        "data-testid": "knack-date-picker-input-date"
      }
    ),
    /* @__PURE__ */ v(
      es,
      {
        ref: c,
        format: { time: o.time },
        className: "size-full",
        value: i,
        intent: s,
        onChange: (f) => {
          d(r, f);
        },
        style: { width: `${ei({ time: o.time })}px` },
        onKeyDown: (f) => {
          var h, p, m, b, y;
          f.key === "Backspace" && ((h = c.current) == null ? void 0 : h.selectionStart) === 0 && ((p = c.current) == null ? void 0 : p.selectionEnd) === 0 && ((m = u.current) == null || m.focus(), f.preventDefault()), a && f.key !== "Backspace" && i && ((b = c.current) == null ? void 0 : b.selectionStart) === ((y = c.current) == null ? void 0 : y.value.length) && (f.preventDefault(), a == null || a(f));
        },
        "data-testid": "knack-date-picker-input-time"
      }
    )
  ] });
});
qc.displayName = "DateTimeInputCombined";
var Gh, fx;
function hj() {
  if (fx) return Gh;
  fx = 1;
  var t = "Expected a function", e = NaN, n = "[object Symbol]", r = /^\s+|\s+$/g, i = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, s = /^0o[0-7]+$/i, a = parseInt, l = typeof ii == "object" && ii && ii.Object === Object && ii, c = typeof self == "object" && self && self.Object === Object && self, u = l || c || Function("return this")(), d = Object.prototype, f = d.toString, h = Math.max, p = Math.min, m = function() {
    return u.Date.now();
  };
  function b(S, T, E) {
    var M, O, L, $, z, B, A = 0, N = !1, R = !1, _ = !0;
    if (typeof S != "function")
      throw new TypeError(t);
    T = x(T) || 0, y(E) && (N = !!E.leading, R = "maxWait" in E, L = R ? h(x(E.maxWait) || 0, T) : L, _ = "trailing" in E ? !!E.trailing : _);
    function D(j) {
      var X = M, ie = O;
      return M = O = void 0, A = j, $ = S.apply(ie, X), $;
    }
    function q(j) {
      return A = j, z = setTimeout(G, T), N ? D(j) : $;
    }
    function V(j) {
      var X = j - B, ie = j - A, ne = T - X;
      return R ? p(ne, L - ie) : ne;
    }
    function H(j) {
      var X = j - B, ie = j - A;
      return B === void 0 || X >= T || X < 0 || R && ie >= L;
    }
    function G() {
      var j = m();
      if (H(j))
        return Q(j);
      z = setTimeout(G, V(j));
    }
    function Q(j) {
      return z = void 0, _ && M ? D(j) : (M = O = void 0, $);
    }
    function te() {
      z !== void 0 && clearTimeout(z), A = 0, M = B = O = z = void 0;
    }
    function le() {
      return z === void 0 ? $ : Q(m());
    }
    function se() {
      var j = m(), X = H(j);
      if (M = arguments, O = this, B = j, X) {
        if (z === void 0)
          return q(B);
        if (R)
          return z = setTimeout(G, T), D(B);
      }
      return z === void 0 && (z = setTimeout(G, T)), $;
    }
    return se.cancel = te, se.flush = le, se;
  }
  function y(S) {
    var T = typeof S;
    return !!S && (T == "object" || T == "function");
  }
  function k(S) {
    return !!S && typeof S == "object";
  }
  function C(S) {
    return typeof S == "symbol" || k(S) && f.call(S) == n;
  }
  function x(S) {
    if (typeof S == "number")
      return S;
    if (C(S))
      return e;
    if (y(S)) {
      var T = typeof S.valueOf == "function" ? S.valueOf() : S;
      S = y(T) ? T + "" : T;
    }
    if (typeof S != "string")
      return S === 0 ? S : +S;
    S = S.replace(r, "");
    var E = o.test(S);
    return E || s.test(S) ? a(S.slice(2), E ? 2 : 8) : i.test(S) ? e : +S;
  }
  return Gh = b, Gh;
}
var pj = hj();
const hx = /* @__PURE__ */ ki(pj);
var mj = typeof window < "u" ? uo : De;
function gj(t, e, n, r) {
  const i = Me(e);
  mj(() => {
    i.current = e;
  }, [e]), De(() => {
    const o = window;
    if (!(o && o.addEventListener))
      return;
    const s = (a) => {
      i.current(a);
    };
    return o.addEventListener(t, s, r), () => {
      o.removeEventListener(t, s, r);
    };
  }, [t, n, r]);
}
function vj(t) {
  const e = Me(t);
  e.current = t, De(
    () => () => {
      e.current();
    },
    []
  );
}
function bj(t, e = 500, n) {
  const r = Me();
  vj(() => {
    r.current && r.current.cancel();
  });
  const i = En(() => {
    const o = hx(t, e, n), s = (...a) => o(...a);
    return s.cancel = () => {
      o.cancel();
    }, s.isPending = () => !!r.current, s.flush = () => o.flush(), s;
  }, [t, e, n]);
  return De(() => {
    r.current = hx(t, e, n);
  }, [t, e, n]), i;
}
function yj() {
  const t = Me(!1);
  return De(() => (t.current = !0, () => {
    t.current = !1;
  }), []), ct(() => t.current, []);
}
function wj(t, e, n = "mousedown", r = {}) {
  gj(
    n,
    (i) => {
      const o = i.target;
      if (!o || !o.isConnected)
        return;
      (Array.isArray(t) ? t.filter((a) => !!a.current).every((a) => a.current && !a.current.contains(o)) : t.current && !t.current.contains(o)) && e(i);
    },
    void 0,
    r
  );
}
var px = {
  width: void 0,
  height: void 0
};
function xj(t) {
  const { ref: e, box: n = "content-box" } = t, [{ width: r, height: i }, o] = pe(px), s = yj(), a = Me({ ...px }), l = Me(void 0);
  return l.current = t.onResize, De(() => {
    if (!e.current || typeof window > "u" || !("ResizeObserver" in window))
      return;
    const c = new ResizeObserver(([u]) => {
      const d = n === "border-box" ? "borderBoxSize" : n === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize", f = mx(u, d, "inlineSize"), h = mx(u, d, "blockSize");
      if (a.current.width !== f || a.current.height !== h) {
        const m = { width: f, height: h };
        a.current.width = f, a.current.height = h, l.current ? l.current(m) : s() && o(m);
      }
    });
    return c.observe(e.current, { box: n }), () => {
      c.disconnect();
    };
  }, [n, e, s]), { width: r, height: i };
}
function mx(t, e, n) {
  return t[e] ? Array.isArray(t[e]) ? t[e][0][n] : (
    // @ts-ignore Support Firefox's non-standard behavior
    t[e][n]
  ) : e === "contentBoxSize" ? t.contentRect[n === "inlineSize" ? "width" : "height"] : void 0;
}
const bA = ({ onClickOutside: t }) => {
  const { floatingStyles: e, refs: n } = UW({
    placement: "bottom-start",
    middleware: [
      w2(),
      x2({
        padding: 25,
        apply({ availableHeight: r, availableWidth: i, elements: o }) {
          o.floating.style.maxHeight = `${r}px`, o.floating.style.maxWidth = `${i}px`;
        }
      })
    ],
    whileElementsMounted: v2
  });
  return wj(n.floating, (r) => {
    if (r.target instanceof HTMLElement) {
      if (r.target === n.reference.current)
        return;
      r.target && r.target.closest('[role="listbox"]') !== null || t();
    } else
      t();
  }), { floatingStyles: e, refs: n };
};
function $o(t) {
  return t instanceof Date;
}
const Vs = (t, e) => {
  if (!(!t || !e))
    return de.fromJSDate(t).set({
      hour: e.getHours(),
      minute: e.getMinutes(),
      second: e.getSeconds(),
      millisecond: e.getMilliseconds()
    }).toJSDate();
};
function kj(t) {
  const {
    value: e,
    onChange: n,
    format: r,
    children: i,
    min: o,
    max: s,
    intent: a,
    dateInitialValue: l,
    timeInitialValue: c
  } = t, u = xe(), d = (e == null ? void 0 : e.from) || (e == null ? void 0 : e.to), [f, h] = pe({
    dateTime: e == null ? void 0 : e.from,
    dateValue: d ? e == null ? void 0 : e.from : l,
    timeValue: d ? e == null ? void 0 : e.from : c
  }), [p, m] = pe({
    dateTime: e == null ? void 0 : e.to,
    dateValue: d ? e == null ? void 0 : e.to : l,
    timeValue: d ? e == null ? void 0 : e.to : c
  }), b = Me(null), y = Me(null), k = Me(null), [C, x] = pe(!1), [S, T] = pe((e == null ? void 0 : e.from) || /* @__PURE__ */ new Date()), { floatingStyles: E, refs: M } = bA({
    onClickOutside: () => x(!1)
  }), O = ct(
    (A, N) => {
      const R = { ...A }, _ = { ...N };
      if (r.date && r.time) {
        if (A.dateValue === void 0 && A.timeValue === void 0)
          R.dateTime = void 0;
        else if (A.dateValue && A.timeValue) {
          const D = Vs(
            A.dateValue,
            A.timeValue
          );
          R.dateTime = D;
        } else
          R.dateTime = null;
        if (N.dateValue === void 0 && N.timeValue === void 0)
          _.dateTime = void 0;
        else if (N.dateValue && N.timeValue) {
          const D = Vs(N.dateValue, N.timeValue);
          _.dateTime = D;
        } else
          _.dateTime = null;
      }
      if (!r.date && r.time) {
        const D = de.now();
        A.dateTime ? R.dateTime = de.fromJSDate(A.dateTime).set({
          year: D.year,
          month: D.month,
          day: D.day
        }).toJSDate() : R.dateTime = A.dateTime, N.dateTime ? _.dateTime = de.fromJSDate(N.dateTime).set({
          year: D.year,
          month: D.month,
          day: D.day
        }).toJSDate() : _.dateTime = N.dateTime;
      }
      r.date && !r.time && (R.dateTime = A.dateValue, _.dateTime = N.dateValue), h(R), m(_), n({
        from: R.dateTime,
        to: _.dateTime
      });
    },
    [r.date, r.time, n]
  ), L = ct(
    (A) => {
      const N = {
        ...f,
        dateValue: A == null ? void 0 : A.from
      }, R = {
        ...p,
        dateValue: A == null ? void 0 : A.to
      };
      O(N, R);
    },
    [f, p, O]
  ), $ = ct(
    (A) => {
      if (M.reference.current === A.current) {
        x((N) => !N);
        return;
      }
      M.setReference(A.current), x(!0);
    },
    [M]
  ), [z, B] = pe(!1);
  return uo(() => {
    var _;
    const N = r.date && r.time ? ei({ date: r.date }) + ei({ time: r.time }) : ei(r);
    window.addEventListener("resize", () => {
      if (b.current && k.current) {
        const D = b.current.offsetWidth;
        B(D <= N * 2 + 20);
      }
    });
    const R = ((_ = b.current) == null ? void 0 : _.offsetWidth) || 0;
    return B(R <= N * 2 + 20), () => {
      window.removeEventListener("resize", () => {
      });
    };
  }, [b, r]), /* @__PURE__ */ F("div", { ref: b, className: "w-full", children: [
    /* @__PURE__ */ F(
      "div",
      {
        className: I("flex w-fit items-center gap-2", {
          "rounded-lg": u.theme.appearance.corners === "rounded",
          "flex-col content-start": z
        }),
        children: [
          r.date && r.time ? /* @__PURE__ */ v("div", { className: "flex", children: /* @__PURE__ */ v(
            qc,
            {
              ref: y,
              dateValue: f.dateValue,
              timeValue: f.timeValue,
              onFocus: () => {
                M.setReference(y.current);
              },
              onChange: (A, N) => {
                const R = {
                  dateTime: Vs(A, N),
                  dateValue: A,
                  timeValue: N
                };
                O(R, p);
              },
              format: r,
              className: "size-full",
              intent: a,
              onTimeInputFinish: () => {
                var A, N;
                (A = k.current) == null || A.focus(), (N = k.current) == null || N.setSelectionRange(0, k.current.value.length);
              },
              onMouseUp: () => $(y),
              "data-testid": "knack-date-picker-input-date"
            }
          ) }) : /* @__PURE__ */ v(
            es,
            {
              ref: y,
              className: "size-full",
              format: r,
              value: f.dateTime,
              onMouseUp: () => $(y),
              onFocus: () => {
                M.setReference(y.current);
              },
              onChange: (A) => {
                const N = {
                  ...f,
                  dateTime: A,
                  dateValue: A
                };
                O(N, p);
              },
              onKeyUp: (A) => {
                var N, R, _, D;
                A.key !== "Backspace" && f.dateTime && ((N = y.current) == null ? void 0 : N.selectionStart) === ((R = y.current) == null ? void 0 : R.value.length) && ((_ = k.current) == null || _.focus(), (D = k.current) == null || D.setSelectionRange(0, k.current.value.length));
              },
              "data-testid": "knack-date-picker-input-from",
              style: { width: `${ei(r)}px` },
              intent: a
            }
          ),
          /* @__PURE__ */ v(
            iW,
            {
              className: I("text-subtle", {
                "flex-grow rotate-90": z
              }),
              size: 18
            }
          ),
          r.date && r.time ? /* @__PURE__ */ v("div", { className: "flex", children: /* @__PURE__ */ v(
            qc,
            {
              ref: k,
              dateValue: p.dateValue,
              timeValue: p.timeValue,
              onFocus: () => {
                M.setReference(k.current);
              },
              onChange: (A, N) => {
                const R = {
                  dateTime: Vs(A, N),
                  dateValue: A,
                  timeValue: N
                };
                O(f, R);
              },
              format: r,
              className: "size-full",
              intent: a,
              onMouseUp: () => $(k)
            }
          ) }) : /* @__PURE__ */ v(
            es,
            {
              ref: k,
              className: "size-full",
              format: r,
              value: p.dateTime,
              onMouseUp: () => $(k),
              onFocus: () => {
                M.setReference(k.current);
              },
              onKeyDown: (A) => {
                var N, R, _;
                A.key === "Backspace" && p.dateTime && ((N = k.current) == null ? void 0 : N.selectionStart) === 0 && ((R = k.current) == null ? void 0 : R.selectionEnd) === 0 && ((_ = y.current) == null || _.focus(), M.setReference(y.current), A.preventDefault());
              },
              onChange: (A) => {
                const N = {
                  ...p,
                  dateTime: A,
                  dateValue: A
                };
                O(f, N);
              },
              "data-testid": "knack-date-picker-input-to",
              style: { width: `${ei(r)}px` },
              intent: a
            }
          )
        ]
      }
    ),
    C && /* @__PURE__ */ v(aA, { children: /* @__PURE__ */ F(
      "div",
      {
        ref: M.setFloating,
        style: E,
        className: I("border-default bg-card pointer-events-auto z-50 mt-2 border", {
          rounded: u.theme.appearance.corners === "rounded"
        }),
        children: [
          r.date && /* @__PURE__ */ v(
            G0,
            {
              className: "max-w-fit border-none",
              numberOfMonths: 1,
              mode: "range",
              selected: {
                from: f.dateValue || void 0,
                to: p.dateValue || void 0
              },
              onSelect: L,
              month: S,
              onMonthChange: (A) => T(A),
              disabled: {
                ...$o(s) ? { after: s } : {},
                ...$o(o) ? { before: o } : {}
                // Matcher type complains because the min/max can be undefined
                // We can use Matcher[] instead of Matcher to fix this but our calendar component is not designed to handle this
              },
              fromYear: o ? de.fromJSDate(o).year : lA,
              toYear: s ? de.fromJSDate(s).year : cA,
              fromMonth: o || void 0,
              toMonth: s || void 0
            }
          ),
          i
        ]
      }
    ) })
  ] });
}
function Cj(t) {
  const {
    value: e,
    onChange: n,
    intent: r,
    format: i,
    children: o,
    min: s,
    max: a,
    dateInitialValue: l,
    timeInitialValue: c
  } = t, u = xe(), [d, f] = pe({
    dateTime: e,
    dateValue: e || l,
    timeValue: e || c
  }), [h, p] = pe($o(e) ? e : /* @__PURE__ */ new Date()), [m, b] = pe(!1), { floatingStyles: y, refs: k } = bA({
    onClickOutside: () => b(!1)
  }), C = ct(
    (T) => {
      if (i.date && i.time)
        if (T.dateValue === void 0 && T.timeValue === void 0)
          T.dateTime = void 0;
        else if (T.dateValue && T.timeValue) {
          const E = Vs(T.dateValue, T.timeValue);
          T.dateTime = E;
        } else
          T.dateTime = null;
      f(T), n(T.dateTime), $o(T.dateTime) && (p(T.dateTime), b(!1));
    },
    [i.date, i.time, n]
  ), x = ct(
    (T) => {
      const E = {
        ...d,
        dateValue: T
      };
      i.date && !i.time && (E.dateTime = E.dateValue), C(E);
    },
    [d, i.date, i.time, C]
  ), S = ct(() => {
    b((T) => !T);
  }, []);
  return /* @__PURE__ */ F("div", { children: [
    /* @__PURE__ */ v("div", { className: "flex", children: i.date && i.time ? /* @__PURE__ */ v("div", { className: "flex", children: /* @__PURE__ */ v(
      qc,
      {
        ref: k.setReference,
        dateValue: d.dateValue,
        timeValue: d.timeValue,
        onChange: (T, E) => {
          const M = {
            ...d,
            dateValue: T,
            timeValue: E
          };
          C(M);
        },
        format: i,
        className: "size-full",
        intent: r,
        onMouseUp: S,
        "data-testid": "knack-date-picker-input-date"
      }
    ) }) : /* @__PURE__ */ v(
      es,
      {
        ref: k.setReference,
        format: i,
        className: "size-full",
        intent: r,
        value: d.dateTime,
        onMouseUp: S,
        onChange: (T) => {
          const E = {
            ...d,
            dateTime: T,
            dateValue: T
          };
          C(E);
        },
        "data-testid": "knack-date-picker-input",
        style: { width: `${ei(i)}px` }
      }
    ) }),
    m && i.date && /* @__PURE__ */ v(aA, { children: /* @__PURE__ */ F(
      "div",
      {
        ref: k.setFloating,
        style: y,
        className: I(
          "border-default bg-card pointer-events-auto z-50 mt-2 overflow-auto border",
          {
            rounded: u.theme.appearance.corners === "rounded"
          }
        ),
        children: [
          i.date && /* @__PURE__ */ v(
            G0,
            {
              size: "small",
              className: "max-w-fit border-none",
              mode: "single",
              selected: d.dateValue || void 0,
              onSelect: x,
              month: h,
              onMonthChange: (T) => p(T),
              disabled: {
                ...$o(a) ? { after: a } : {},
                ...$o(s) ? { before: s } : {}
                // Matcher type complains because the min/max can be undefined
                // We can use Matcher[] instead of Matcher to fix this but our calendar component is not designed to handle this
              },
              fromYear: s ? de.fromJSDate(s).year : lA,
              toYear: a ? de.fromJSDate(a).year : cA,
              fromMonth: s || void 0,
              toMonth: a || void 0
            }
          ),
          o
        ]
      }
    ) })
  ] });
}
function nse(t) {
  const { mode: e, format: n } = t;
  if (!n.date && !n.time)
    throw new Error("A date format and/or time format must be provided");
  return e === "single" ? /* @__PURE__ */ v(Cj, { "data-testid": "asterisk-date-time-picker-single", ...t }) : e === "range" ? /* @__PURE__ */ v(kj, { "data-testid": "asterisk-date-time-picker-range", ...t }) : null;
}
const Sj = {
  hideResize: {
    false: ["right-6"]
  }
}, gx = {
  base: [
    "flex",
    "justify-end",
    "absolute",
    "bottom-0",
    "right-0",
    "left-0",
    "h-6",
    "pr-2",
    "pb-2",
    "bg-input",
    "pointer-events-none",
    "text-subtle",
    "transition-all"
  ],
  config: {
    variants: Sj,
    defaultVariants: {
      hideResize: !1
    }
  }
}, Tj = Ie(gx.base, gx.config);
function Ej({ maxLength: t, characterCount: e, hideResize: n }) {
  const r = xe();
  return /* @__PURE__ */ F(
    "div",
    {
      className: I(Tj({ hideResize: n }), {
        "rounded-bl-lg rounded-br-lg": r.theme.appearance.corners === "rounded"
      }),
      children: [
        /* @__PURE__ */ v("div", { className: "absolute left-0 right-0 top-[-12px] h-3 w-full bg-gradient-to-b from-transparent to-[rgb(var(--bg-input))]" }),
        `${e}${t ? `/${t}` : ""}`
      ]
    }
  );
}
const Mj = {
  intent: {
    default: [
      "border-default",
      "focus-within:border-default",
      "focus-within:outline-default",
      "focus-within:hover:border-emphasis",
      "hover:border-emphasis",
      "focus-within:outline"
    ],
    destructive: [
      "border-destructive",
      "focus-within:outline-destructive",
      "focus-within:border-destructive",
      "hover:border-destructive"
    ]
  },
  disabled: {
    true: ["cursor-not-allowed", "hover:border-default", "bg-muted"]
  }
}, Oj = {
  disabled: {
    true: ["disabled:cursor-not-allowed", "disabled:text-subtle"]
  },
  showCharCount: {
    true: ["pb-5"]
  },
  hideResize: {
    true: ["resize-none"]
  }
}, vx = {
  name: "textarea",
  base: [
    "flex",
    "h-auto",
    "w-full",
    "border",
    "py-2",
    "px-3",
    "bg-input",
    "text-emphasis",
    "outline-offset-2",
    "relative"
  ],
  config: {
    variants: Mj,
    defaultVariants: {
      intent: "default",
      disabled: !1
    }
  }
}, bx = {
  base: [
    "placeholder:text-subtle",
    "flex-auto",
    "border-none",
    "bg-transparent",
    "focus:ring-0",
    "p-0"
  ],
  config: {
    variants: Oj,
    defaultVariants: {
      showCharCount: !1,
      disabled: !1,
      hideResize: !1
    }
  }
}, Aj = Ie(vx.base, vx.config), Nj = Ie(bx.base, bx.config);
function Rj({
  className: t,
  intent: e,
  onChange: n,
  showCharCount: r,
  hideResize: i,
  disabled: o,
  maxLength: s,
  ...a
}, l) {
  const c = xe(), [u, d] = pe(0), f = ct(
    (p) => (r && d((p == null ? void 0 : p.value.length) ?? 0), typeof l == "function" ? l(p) : l),
    [l, r]
  ), h = (p) => {
    r && d(p.target.value.length), n && n(p);
  };
  return /* @__PURE__ */ F(
    "div",
    {
      "data-testid": "asterisk-textarea",
      className: I("kn-textarea", Aj({ intent: e, disabled: o, className: t }), {
        "rounded-lg": c.theme.appearance.corners === "rounded"
      }),
      children: [
        /* @__PURE__ */ v(
          "textarea",
          {
            "data-testid": "asterisk-textarea-input",
            className: I(Nj({ showCharCount: r, disabled: o, hideResize: i })),
            ref: f,
            disabled: o,
            onChange: h,
            maxLength: s,
            ...a
          }
        ),
        r && /* @__PURE__ */ v(
          Ej,
          {
            "data-testid": "asterisk-textarea-character-count",
            maxLength: s,
            characterCount: u,
            hideResize: i
          }
        )
      ]
    }
  );
}
const rse = ce(Rj);
function Dj(t) {
  return Ee({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" }, child: [] }] })(t);
}
function yA(t) {
  return Ee({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" }, child: [] }] })(t);
}
function Ij(t) {
  return Ee({ attr: { viewBox: "0 0 544 512" }, child: [{ tag: "path", attr: { d: "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z" }, child: [] }] })(t);
}
function _j(t) {
  return Ee({ attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" }, child: [] }] })(t);
}
const Pj = {
  intent: {
    default: [
      "data-[state=checked]:bg-inverted",
      "data-[state=checked]:border-none",
      "data-[state=checked]:outline-default",
      "data-[state=checked]:hover:bg-intense",
      "data-[state=checked]:hover:text-inverted",
      "data-[state=checked]:active:bg-gray-400",
      "data-[state=checked]:active:text-inverted",
      "data-[state=checked]:active:ring-default",
      "data-[state=indeterminate]:bg-inverted",
      "data-[state=indeterminate]:border-none",
      "data-[state=indeterminate]:outline-default",
      "data-[state=indeterminate]:hover:bg-intense",
      "data-[state=indeterminate]:hover:text-inverted",
      "data-[state=indeterminate]:active:bg-gray-400",
      "data-[state=indeterminate]:active:text-inverted",
      "data-[state=indeterminate]:active:ring-default",
      "hover:text-emphasis",
      "hover:bg-subtle",
      "active:bg-emphasis",
      "active:text-emphasis",
      "active:ring-default",
      "text-inverted"
    ],
    destructive: [
      "border-destructive",
      "data-[state=checked]:border-destructive",
      "data-[state=checked]:bg-action-destructive-primary",
      "data-[state=checked]:outline-destructive",
      "data-[state=indeterminate]:border-destructive",
      "data-[state=indeterminate]:bg-action-destructive-primary",
      "data-[state=indeterminate]:outline-destructive",
      "focus-visible:ring-destructive",
      "text-white"
    ]
  }
}, yx = {
  name: "checkbox",
  base: [
    "shrink-0",
    "border",
    "border",
    "h-4",
    "w-4",
    "border-default",
    "hover:border-emphasis",
    "focus:outline-none",
    "focus-visible:outline-none",
    "focus-visible:ring-2",
    "focus-visible:ring-default",
    "focus-visible:ring-offset-2",
    "disabled:cursor-not-allowed",
    "disabled:bg-subtle",
    "disabled:hover:border-default",
    "data-[state=checked]:disabled:border-default",
    "data-[state=checked]:disabled:bg-subtle",
    "data-[state=checked]:disabled:outline-default",
    "data-[state=indeterminate]:disabled:border-default",
    "data-[state=indeterminate]:disabled:bg-subtle",
    "data-[state=indeterminate]:disabled:outline-default"
  ],
  config: {
    variants: Pj,
    defaultVariants: {
      intent: "default"
    }
  }
}, Lj = Ie(yx.base, yx.config);
function Fj({ className: t, intent: e, ...n }, r) {
  const i = xe();
  return /* @__PURE__ */ v(
    Y8,
    {
      ref: r,
      className: I(
        "kn-checkbox",
        Lj({ intent: e }),
        {
          "rounded-sm": i.theme.appearance.corners === "rounded"
        },
        t
      ),
      "data-testid": "asterisk-checkbox",
      ...n,
      children: /* @__PURE__ */ v(Z8, { className: "flex items-center justify-center", children: n.checked === "indeterminate" || n.defaultChecked === "indeterminate" ? /* @__PURE__ */ v(_j, { className: "h-3.5 w-3.5 p-[2px]" }) : /* @__PURE__ */ v(Dj, { className: "h-3.5 w-3.5 p-[2px]" }) })
    }
  );
}
const wx = ce(Fj);
function Ao(t, e, n) {
  let r = n.initialDeps ?? [], i;
  function o() {
    var s, a, l, c;
    let u;
    n.key && ((s = n.debug) != null && s.call(n)) && (u = Date.now());
    const d = t();
    if (!(d.length !== r.length || d.some((p, m) => r[m] !== p)))
      return i;
    r = d;
    let h;
    if (n.key && ((a = n.debug) != null && a.call(n)) && (h = Date.now()), i = e(...d), n.key && ((l = n.debug) != null && l.call(n))) {
      const p = Math.round((Date.now() - u) * 100) / 100, m = Math.round((Date.now() - h) * 100) / 100, b = m / 16, y = (k, C) => {
        for (k = String(k); k.length < C; )
          k = " " + k;
        return k;
      };
      console.info(
        `%c⏱ ${y(m, 5)} /${y(p, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * b, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (c = n == null ? void 0 : n.onChange) == null || c.call(n, i), i;
  }
  return o.updateDeps = (s) => {
    r = s;
  }, o;
}
function Yh(t, e) {
  if (t === void 0)
    throw new Error("Unexpected undefined");
  return t;
}
const $j = (t, e) => Math.abs(t - e) < 1, Bj = (t, e, n) => {
  let r;
  return function(...i) {
    t.clearTimeout(r), r = t.setTimeout(() => e.apply(this, i), n);
  };
}, Vj = (t) => t, zj = (t) => {
  const e = Math.max(t.startIndex - t.overscan, 0), n = Math.min(t.endIndex + t.overscan, t.count - 1), r = [];
  for (let i = e; i <= n; i++)
    r.push(i);
  return r;
}, Hj = (t, e) => {
  const n = t.scrollElement;
  if (!n)
    return;
  const r = t.targetWindow;
  if (!r)
    return;
  const i = (s) => {
    const { width: a, height: l } = s;
    e({ width: Math.round(a), height: Math.round(l) });
  };
  if (i(n.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const o = new r.ResizeObserver((s) => {
    const a = () => {
      const l = s[0];
      if (l != null && l.borderBoxSize) {
        const c = l.borderBoxSize[0];
        if (c) {
          i({ width: c.inlineSize, height: c.blockSize });
          return;
        }
      }
      i(n.getBoundingClientRect());
    };
    t.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(a) : a();
  });
  return o.observe(n, { box: "border-box" }), () => {
    o.unobserve(n);
  };
}, xx = {
  passive: !0
}, kx = typeof window > "u" ? !0 : "onscrollend" in window, Wj = (t, e) => {
  const n = t.scrollElement;
  if (!n)
    return;
  const r = t.targetWindow;
  if (!r)
    return;
  let i = 0;
  const o = t.options.useScrollendEvent && kx ? () => {
  } : Bj(
    r,
    () => {
      e(i, !1);
    },
    t.options.isScrollingResetDelay
  ), s = (u) => () => {
    const { horizontal: d, isRtl: f } = t.options;
    i = d ? n.scrollLeft * (f && -1 || 1) : n.scrollTop, o(), e(i, u);
  }, a = s(!0), l = s(!1);
  l(), n.addEventListener("scroll", a, xx);
  const c = t.options.useScrollendEvent && kx;
  return c && n.addEventListener("scrollend", l, xx), () => {
    n.removeEventListener("scroll", a), c && n.removeEventListener("scrollend", l);
  };
}, jj = (t, e, n) => {
  if (e != null && e.borderBoxSize) {
    const r = e.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    t.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, Uj = (t, {
  adjustments: e = 0,
  behavior: n
}, r) => {
  var i, o;
  const s = t + e;
  (o = (i = r.scrollElement) == null ? void 0 : i.scrollTo) == null || o.call(i, {
    [r.options.horizontal ? "left" : "top"]: s,
    behavior: n
  });
};
class qj {
  constructor(e) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((i) => {
        i.forEach((o) => {
          const s = () => {
            this._measureElement(o.target, o);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(s) : s();
        });
      }));
      return {
        disconnect: () => {
          var i;
          (i = r()) == null || i.disconnect(), n = null;
        },
        observe: (i) => {
          var o;
          return (o = r()) == null ? void 0 : o.observe(i, { box: "border-box" });
        },
        unobserve: (i) => {
          var o;
          return (o = r()) == null ? void 0 : o.unobserve(i);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, i]) => {
        typeof i > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: Vj,
        rangeExtractor: zj,
        onChange: () => {
        },
        measureElement: jj,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...n
      };
    }, this.notify = (n) => {
      var r, i;
      (i = (r = this.options).onChange) == null || i.call(r, this, n);
    }, this.maybeNotify = Ao(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (n) => {
        this.notify(n);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this.elementsCache.forEach((i) => {
          this.observer.observe(i);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (i) => {
            this.scrollRect = i, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (i, o) => {
            this.scrollAdjustments = 0, this.scrollDirection = o ? this.getScrollOffset() < i ? "forward" : "backward" : null, this.scrollOffset = i, this.isScrolling = o, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
      for (let s = r - 1; s >= 0; s--) {
        const a = n[s];
        if (i.has(a.lane))
          continue;
        const l = o.get(
          a.lane
        );
        if (l == null || a.end > l.end ? o.set(a.lane, a) : a.end < l.end && i.set(a.lane, !0), i.size === this.options.lanes)
          break;
      }
      return o.size === this.options.lanes ? Array.from(o.values()).sort((s, a) => s.end === a.end ? s.index - a.index : s.end - a.end)[0] : void 0;
    }, this.getMeasurementOptions = Ao(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, i, o, s) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: i,
        getItemKey: o,
        enabled: s
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Ao(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: i, getItemKey: o, enabled: s }, a) => {
        if (!s)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((u) => {
          this.itemSizeCache.set(u.key, u.size);
        }));
        const l = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const c = this.measurementsCache.slice(0, l);
        for (let u = l; u < n; u++) {
          const d = o(u), f = this.options.lanes === 1 ? c[u - 1] : this.getFurthestMeasurement(c, u), h = f ? f.end + this.options.gap : r + i, p = a.get(d), m = typeof p == "number" ? p : this.options.estimateSize(u), b = h + m, y = f ? f.lane : u % this.options.lanes;
          c[u] = {
            index: u,
            start: h,
            size: m,
            end: b,
            key: d,
            lane: y
          };
        }
        return this.measurementsCache = c, c;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Ao(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (n, r, i, o) => this.range = n.length > 0 && r > 0 ? Kj({
        measurements: n,
        outerSize: r,
        scrollOffset: i,
        lanes: o
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = Ao(
      () => {
        let n = null, r = null;
        const i = this.calculateRange();
        return i && (n = i.startIndex, r = i.endIndex), this.maybeNotify.updateDeps([this.isScrolling, n, r]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          n,
          r
        ];
      },
      (n, r, i, o, s) => o === null || s === null ? [] : n({
        startIndex: o,
        endIndex: s,
        overscan: r,
        count: i
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, i = n.getAttribute(r);
      return i ? parseInt(i, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const i = this.indexFromElement(n), o = this.measurementsCache[i];
      if (!o)
        return;
      const s = o.key, a = this.elementsCache.get(s);
      a !== n && (a && this.observer.unobserve(a), this.observer.observe(n), this.elementsCache.set(s, n)), n.isConnected && this.resizeItem(i, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const i = this.measurementsCache[n];
      if (!i)
        return;
      const o = this.itemSizeCache.get(i.key) ?? i.size, s = r - o;
      s !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(i, s, this) : i.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", s), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += s,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(i.index), this.itemSizeCache = new Map(this.itemSizeCache.set(i.key, r)), this.notify(!1));
    }, this.measureElement = (n) => {
      if (!n) {
        this.elementsCache.forEach((r, i) => {
          r.isConnected || (this.observer.unobserve(r), this.elementsCache.delete(i));
        });
        return;
      }
      this._measureElement(n, void 0);
    }, this.getVirtualItems = Ao(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (n, r) => {
        const i = [];
        for (let o = 0, s = n.length; o < s; o++) {
          const a = n[o], l = r[a];
          i.push(l);
        }
        return i;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return Yh(
          r[wA(
            0,
            r.length - 1,
            (i) => Yh(r[i]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r, i = 0) => {
      const o = this.getSize(), s = this.getScrollOffset();
      r === "auto" && (r = n >= s + o ? "end" : "start"), r === "center" ? n += (i - o) / 2 : r === "end" && (n -= o);
      const a = this.options.horizontal ? "scrollWidth" : "scrollHeight", c = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[a] : this.scrollElement[a] : 0) - o;
      return Math.max(Math.min(c, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const i = this.measurementsCache[n];
      if (!i)
        return;
      const o = this.getSize(), s = this.getScrollOffset();
      if (r === "auto")
        if (i.end >= s + o - this.options.scrollPaddingEnd)
          r = "end";
        else if (i.start <= s + this.options.scrollPaddingStart)
          r = "start";
        else
          return [s, r];
      const a = r === "end" ? i.end + this.options.scrollPaddingEnd : i.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(a, r, i.size),
        r
      ];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: r = "start", behavior: i } = {}) => {
      this.cancelScrollToIndex(), i === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: i
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: i } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), i === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const o = this.getOffsetForIndex(n, r);
      if (!o) return;
      const [s, a] = o;
      this._scrollToOffset(s, { adjustments: void 0, behavior: i }), i !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [c] = Yh(
            this.getOffsetForIndex(n, a)
          );
          $j(c, this.getScrollOffset()) || this.scrollToIndex(n, { align: a, behavior: i });
        } else
          this.scrollToIndex(n, { align: a, behavior: i });
      }));
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let i;
      if (r.length === 0)
        i = this.options.paddingStart;
      else if (this.options.lanes === 1)
        i = ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0;
      else {
        const o = Array(this.options.lanes).fill(null);
        let s = r.length - 1;
        for (; s >= 0 && o.some((a) => a === null); ) {
          const a = r[s];
          o[a.lane] === null && (o[a.lane] = a.end), s--;
        }
        i = Math.max(...o.filter((a) => a !== null));
      }
      return Math.max(
        i - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: i
    }) => {
      this.options.scrollToFn(n, { behavior: i, adjustments: r }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(e);
  }
}
const wA = (t, e, n, r) => {
  for (; t <= e; ) {
    const i = (t + e) / 2 | 0, o = n(i);
    if (o < r)
      t = i + 1;
    else if (o > r)
      e = i - 1;
    else
      return i;
  }
  return t > 0 ? t - 1 : 0;
};
function Kj({
  measurements: t,
  outerSize: e,
  scrollOffset: n,
  lanes: r
}) {
  const i = t.length - 1, o = (l) => t[l].start;
  if (t.length <= r)
    return {
      startIndex: 0,
      endIndex: i
    };
  let s = wA(
    0,
    i,
    o,
    n
  ), a = s;
  if (r === 1)
    for (; a < i && t[a].end < n + e; )
      a++;
  else if (r > 1) {
    const l = Array(r).fill(0);
    for (; a < i && l.some((u) => u < n + e); ) {
      const u = t[a];
      l[u.lane] = u.end, a++;
    }
    const c = Array(r).fill(n + e);
    for (; s >= 0 && c.some((u) => u >= n); ) {
      const u = t[s];
      c[u.lane] = u.start, s--;
    }
    s = Math.max(0, s - s % r), a = Math.min(i, a + (r - 1 - a % r));
  }
  return { startIndex: s, endIndex: a };
}
const Cx = typeof document < "u" ? w.useLayoutEffect : w.useEffect;
function Gj(t) {
  const e = w.useReducer(() => ({}), {})[1], n = {
    ...t,
    onChange: (i, o) => {
      var s;
      o ? SD(e) : e(), (s = t.onChange) == null || s.call(t, i, o);
    }
  }, [r] = w.useState(
    () => new qj(n)
  );
  return r.setOptions(n), Cx(() => r._didMount(), []), Cx(() => r._willUpdate()), r;
}
function xA(t) {
  return Gj({
    observeElementRect: Hj,
    observeElementOffset: Wj,
    scrollToFn: Uj,
    ...t
  });
}
const Yj = {
  intent: {
    default: ["border-default"],
    destructive: ["border-destructive", "hover:border-destructive"]
  }
}, Sx = {
  name: "combobox-trigger",
  base: [
    "focus:border-default",
    "focus:outline-default",
    "focus:hover:border-emphasis",
    "hover:border-emphasis",
    "bg-input",
    "flex",
    "w-full",
    "items-center",
    "justify-between",
    "border",
    "p-2",
    "text-left",
    "disabled:cursor-not-allowed",
    "disabled:bg-muted",
    "disabled:border-default",
    "disabled:text-subtle"
  ],
  config: {
    variants: Yj,
    defaultVariants: {
      intent: "default"
    }
  }
}, Zj = Ie(Sx.base, Sx.config), Jj = {
  name: "combobox-content",
  base: [
    "data-[state=open]:animate-slideDownAndFade",
    "border-subtle",
    "text-default",
    "bg-menu",
    "relative",
    "overflow-hidden",
    "border",
    "p-2",
    "shadow-md"
  ],
  config: {}
};
function Xj({
  isSearchEnabled: t = !1,
  searchPlaceholder: e = "Search...",
  filteredOptions: n,
  selectedOption: r = { key: "", label: "" },
  searchValue: i = "",
  optionsClassName: o = "",
  itemClassName: s = "",
  addOptionText: a = "Add",
  setIsPopoverOpen: l,
  onSelectOption: c,
  onAddOption: u,
  setSearchValue: d,
  onSearchChange: f,
  description: h
}) {
  const p = xe(), m = Me(null), b = u && i && !n.some((k) => k.label === i), y = xA({
    count: n.length,
    getScrollElement: () => m.current,
    estimateSize: () => 40,
    gap: 2
  });
  return /* @__PURE__ */ F("div", { children: [
    t && /* @__PURE__ */ F(je, { children: [
      /* @__PURE__ */ F("div", { className: "flex items-center justify-between p-2", children: [
        /* @__PURE__ */ v(
          hn,
          {
            "data-testid": "asterisk-combobox-search-input",
            placeholder: e,
            value: i,
            onChange: (k) => {
              const C = k.target.value;
              d(C), f && f(C);
            },
            className: "focus:ring-none ml-1 h-6 border-none p-0 focus:border-none focus:outline-0 focus:outline-offset-0 focus:ring-offset-0"
          }
        ),
        b ? /* @__PURE__ */ v(
          Ze,
          {
            intent: "minimal",
            onClick: () => d(""),
            className: "h-auto p-1",
            "data-testid": "asterisk-combobox-clear-search-button",
            children: /* @__PURE__ */ v(Vr, { className: "text-subtle flex-shrink-0" })
          }
        ) : /* @__PURE__ */ v(HS, { size: 16, className: "text-subtle flex-shrink-0" })
      ] }),
      /* @__PURE__ */ v(um, { className: "mb-2 px-2" }),
      b && /* @__PURE__ */ F(
        Ze,
        {
          "data-testid": "asterisk-combobox-add-option-button",
          intent: "minimal",
          className: "w-full justify-start text-base font-normal",
          onClick: () => {
            u(i), l(!1);
          },
          children: [
            a,
            " '",
            i,
            "'"
          ]
        }
      ),
      h && /* @__PURE__ */ v(
        "p",
        {
          className: "text-subtle my-4 px-2 text-base",
          "data-testid": "asterisk-combobox-description",
          children: h
        }
      )
    ] }),
    /* @__PURE__ */ v(
      "div",
      {
        "data-testid": "asterisk-combobox-options-container",
        className: "relative w-full overflow-auto",
        ref: m,
        style: { maxHeight: 360 },
        "data-virtualizer-container": !0,
        children: /* @__PURE__ */ v(
          "div",
          {
            className: I("w-full", o),
            style: { height: `${y.getTotalSize()}px` },
            children: y.getVirtualItems().map((k) => {
              const C = n[k.index], x = r.key === C.key;
              return /* @__PURE__ */ v(
                "div",
                {
                  className: "absolute w-full",
                  "data-testid": "asterisk-combobox-option",
                  style: {
                    transform: `translateY(${k.start}px)`,
                    height: `${k.size}px`
                  },
                  children: /* @__PURE__ */ F(
                    Ze,
                    {
                      intent: "minimal",
                      autoFocus: x && !t,
                      className: I(
                        "hover:bg-muted focus:bg-subtle text-default flex h-auto w-full justify-between p-2 text-left text-base font-normal focus:outline-0 focus-visible:ring-0",
                        {
                          "bg-subtle": x,
                          "rounded-lg": p.theme.appearance.corners === "rounded"
                        },
                        s
                      ),
                      onClick: () => c(C),
                      title: C.label,
                      "data-testid": C.testId ?? `asterisk-combobox-option-${C.key}`,
                      children: [
                        /* @__PURE__ */ v("span", { className: "flex-1 truncate", children: C.label }),
                        x && /* @__PURE__ */ v(M0, { size: 16, className: "ml-2 shrink-0" })
                      ]
                    }
                  )
                },
                k.key
              );
            })
          }
        )
      }
    )
  ] });
}
function Qj({
  placeholder: t,
  selectedOption: e,
  onSelectOption: n,
  shouldHideChevron: r,
  isClearable: i
}) {
  return /* @__PURE__ */ F("div", { className: "flex w-full items-center justify-between text-base", children: [
    e ? /* @__PURE__ */ v("span", { className: "truncate", children: e }) : /* @__PURE__ */ v("span", { className: "text-subtle", children: t }),
    /* @__PURE__ */ F("div", { className: "flex items-center", children: [
      i && e && /* @__PURE__ */ v(
        Ze,
        {
          intent: "minimal",
          className: "border-subtle mr-2 h-5 rounded-r-none border-r",
          size: "sm",
          onClick: (o) => {
            n({ key: "", label: "" }), o.stopPropagation();
          },
          children: /* @__PURE__ */ v(Vr, { className: "text-subtle shrink-0" })
        }
      ),
      !r && /* @__PURE__ */ v(Vu, { size: 16, className: "shrink-0" })
    ] })
  ] });
}
function ise(t) {
  const {
    id: e,
    options: n = [],
    intent: r,
    disabled: i,
    align: o = "start",
    placeholder: s = "Select...",
    triggerClassName: a = "",
    triggerTestId: l,
    contentClassName: c = "",
    selectedOption: u = { key: "", label: "" },
    shouldHideChevron: d = !1,
    isClearable: f = !1,
    onSelectOption: h,
    shouldIgnoreFiltering: p = !1,
    onSearchChange: m
  } = t, b = xe(), [y, k] = pe(!1), [C, x] = pe(""), S = En(
    () => p ? n : n.filter(
      (E) => E.label.toLowerCase().includes(C.toLowerCase())
    ),
    [n, C, p]
  ), T = (E) => {
    h(E), k(!1);
  };
  return /* @__PURE__ */ F(
    lt,
    {
      open: y,
      onOpenChange: (E) => {
        x(""), m && m(""), k(E);
      },
      children: [
        /* @__PURE__ */ v(
          lt.Trigger,
          {
            id: e,
            disabled: i,
            className: I(
              "kn-combobox-trigger",
              Zj({ intent: r }),
              {
                "rounded-lg": b.theme.appearance.corners === "rounded"
              },
              a
            ),
            title: u.label || s,
            "data-testid": l ?? "asterisk-combobox-trigger",
            children: /* @__PURE__ */ v(
              Qj,
              {
                placeholder: s,
                selectedOption: u.label,
                onSelectOption: T,
                shouldHideChevron: d,
                isClearable: f
              }
            )
          }
        ),
        /* @__PURE__ */ v(
          lt.Content,
          {
            sideOffset: 2,
            align: o,
            "data-testid": "asterisk-combobox-content",
            className: I(
              "kn-combobox-content",
              Jj.base.join(" "),
              {
                "rounded-lg": b.theme.appearance.corners === "rounded"
              },
              c
            ),
            style: {
              width: "var(--radix-popover-trigger-width)"
            },
            children: /* @__PURE__ */ v(
              Xj,
              {
                ...t,
                filteredOptions: S,
                searchValue: C,
                onSelectOption: T,
                setSearchValue: x,
                setIsPopoverOpen: k
              }
            )
          }
        )
      ]
    }
  );
}
const eU = {}, kA = {
  name: "radio-group",
  base: [
    "rounded-2xl",
    "w-4",
    "h-4",
    "border",
    "border-default",
    "hover:border-emphasis",
    "hover:bg-subtle",
    "active:ring-default",
    "active:bg-emphasis",
    "focus:border-emphasis",
    "focus:bg-default",
    "disabled:cursor-not-allowed",
    "disabled:bg-subtle",
    "disabled:border-default",
    "data-[state=checked]:bg-inverted",
    "data-[state=checked]:text-inverted",
    "data-[state=checked]:hover:text-inverted",
    "data-[state=checked]:hover:bg-intense",
    "data-[state=checked]:active:bg-emphasis",
    "data-[state=checked]:active:text-inverted",
    "data-[state=checked]:focus:bg-inverted",
    "data-[state=checked]:focus:text-inverted",
    "data-[state=checked]:disabled:bg-subtle",
    "data-[state=checked]:disabled:text-inverted"
  ],
  config: {
    variants: eU
  }
}, tU = Ie(kA.base);
function nU({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    YM,
    {
      "data-testid": "asterisk-radio-group",
      className: I("grid gap-2", t),
      ...e,
      ref: n
    }
  );
}
function CA({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    ZM,
    {
      "data-testid": "asterisk-radio-group-item",
      ref: n,
      className: I(tU({ className: t })),
      ...e,
      children: /* @__PURE__ */ v(
        JM,
        {
          className: "flex items-center justify-center",
          "data-testid": "asterisk-radio-group-indicator",
          children: /* @__PURE__ */ v(yA, { className: "h-1.5 w-1.5" })
        }
      )
    }
  );
}
function SA({ className: t, children: e, ...n }, r) {
  return /* @__PURE__ */ v(
    "div",
    {
      "data-testid": "asterisk-radio-group-container",
      ref: r,
      className: "flex items-center space-x-2",
      ...n,
      children: e
    }
  );
}
const rU = ce(nU), ose = Object.assign(rU, {
  Item: ce(CA),
  Container: ce(SA)
});
CA.displayName = "RadioGroup.Item";
SA.displayName = "RadioGroup.Container";
const iU = {
  intent: {
    destructive: ["text-destructive"],
    warning: ["text-yellow-500"],
    success: ["text-green-500"]
  }
}, Tx = {
  name: "label",
  base: ["peer-disabled:cursor-not-allowed", "peer-disabled:opacity-70"],
  config: {
    variants: iU
  }
}, Ex = Ie(Tx.base, Tx.config);
function oU({ className: t, intent: e, children: n, isRequired: r, ...i }, o) {
  return /* @__PURE__ */ F(
    yB,
    {
      ref: o,
      className: I("kn-label", Ex({ className: t, intent: e })),
      "data-testid": "asterisk-label",
      ...i,
      children: [
        n,
        r && /* @__PURE__ */ v(
          "span",
          {
            className: I("text-brand ml-1", Ex({ intent: e, className: t })),
            "aria-label": "required",
            children: "*"
          }
        )
      ]
    }
  );
}
const yi = ce(oU), TA = Pn(null), sU = {}, aU = {
  name: "radio-card",
  base: [
    "border-subtle",
    "group-hover:bg-subtle",
    "relative",
    "flex",
    "h-full",
    "space-x-3",
    "border",
    "px-3",
    "py-4",
    "text-left",
    "shadow-none",
    "group-hover:border-gray-900",
    "sm:px-4",
    "sm:py-5"
  ],
  config: {
    variants: sU
  }
}, lU = Ie(aU.base);
function cU({ className: t, ...e }, n) {
  const [r, i] = pe(null);
  return /* @__PURE__ */ v(TA.Provider, { value: r, children: /* @__PURE__ */ v(
    YM,
    {
      "data-testid": "asterisk-radio-card-group",
      onValueChange: i,
      className: I("kn-radiocard-group grid gap-2", t),
      ...e,
      ref: n
    }
  ) });
}
function EA({
  id: t,
  className: e,
  children: n,
  value: r,
  contentClassName: i,
  width: o = "270px",
  disabled: s,
  radioItemProps: a,
  shouldHideCircleIcon: l = !1,
  ...c
}, u) {
  const d = Ln(TA) === r, [f, h] = pe(!1), p = bS(), m = t || p;
  return /* @__PURE__ */ v(
    yi,
    {
      "data-testid": "asterisk-radio-card-label",
      htmlFor: m,
      style: { width: o },
      className: I("kn-radiocard-group-item group cursor-pointer", {
        "cursor-not-allowed": s
      }),
      children: /* @__PURE__ */ F(
        jS,
        {
          "data-testid": "asterisk-radio-card",
          ref: u,
          className: I(lU({ className: e }), {
            "border-subtle text-subtle group-hover:border-subtle group-hover:bg-card": s,
            "bg-muted border-gray-900": d,
            "outline-default outline outline-offset-1": f
          }),
          ...c,
          children: [
            /* @__PURE__ */ v("div", { className: "flex items-center space-x-2", children: /* @__PURE__ */ v(
              ZM,
              {
                "data-testid": "asterisk-radio-card-item",
                id: m,
                className: I("self-start outline-0", kA.base.join(" ")),
                value: r,
                disabled: s,
                onFocus: () => h(!0),
                onBlur: () => h(!1),
                ...a,
                children: !l && /* @__PURE__ */ v(
                  JM,
                  {
                    className: "flex items-center justify-center",
                    "data-testid": "asterisk-radio-card-indicator",
                    children: /* @__PURE__ */ v(yA, { className: "h-1.5 w-1.5" })
                  }
                )
              }
            ) }),
            /* @__PURE__ */ v(
              "div",
              {
                "data-testid": "asterisk-radio-card-content-wrapper",
                className: I(
                  "group-hover:text-emphasis pointer-events-none flex grow flex-col justify-between",
                  i,
                  {
                    "group-hover:text-subtle": s
                  }
                ),
                children: n
              }
            )
          ]
        }
      )
    }
  );
}
function MA({
  title: t,
  description: e,
  children: n,
  badgeText: r,
  badgeClassName: i
}) {
  return /* @__PURE__ */ F(je, { children: [
    /* @__PURE__ */ F(
      "div",
      {
        className: "kn-radiocard-group-content space-y-2",
        "data-testid": "asterisk-radio-card-content",
        children: [
          /* @__PURE__ */ F("div", { className: "flex items-start justify-between", children: [
            /* @__PURE__ */ v("p", { className: "m-0 font-medium leading-none", children: t }),
            r && /* @__PURE__ */ v(hI, { className: I("-mt-1.5 text-inherit", i), children: r })
          ] }),
          e && /* @__PURE__ */ v("p", { className: "text-subtle", "data-testid": "asterisk-radio-card-description", children: e })
        ]
      }
    ),
    n
  ] });
}
const uU = ce(cU), sse = Object.assign(uU, {
  Content: MA,
  Card: ce(EA)
});
MA.displayName = "RadioCard.Content";
EA.displayName = "RadioCard.Card";
function dU(t) {
  return Ee({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" }, child: [] }] })(t);
}
function fU(t) {
  return Ee({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M5.354 5.119 7.538.792A.52.52 0 0 1 8 .5c.183 0 .366.097.465.292l2.184 4.327 4.898.696A.54.54 0 0 1 16 6.32a.55.55 0 0 1-.17.445l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256a.5.5 0 0 1-.146.05c-.342.06-.668-.254-.6-.642l.83-4.73L.173 6.765a.55.55 0 0 1-.172-.403.6.6 0 0 1 .085-.302.51.51 0 0 1 .37-.245zM8 12.027a.5.5 0 0 1 .232.056l3.686 1.894-.694-3.957a.56.56 0 0 1 .162-.505l2.907-2.77-4.052-.576a.53.53 0 0 1-.393-.288L8.001 2.223 8 2.226z" }, child: [] }] })(t);
}
function hU(t) {
  return Ee({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" }, child: [] }] })(t);
}
const pU = {
  name: "rating-container",
  base: ["flex", "size-fit", "cursor-pointer", "gap-1"],
  config: {}
}, Mx = {
  name: "rating-star",
  base: [
    "text-yellow-300",
    "hover:stroke-yellow-400",
    "size-6",
    "hover:stroke-[1px]",
    "hover:size-[23px]"
  ],
  config: {}
}, mU = {
  base: ["text-yellow-400", "size-6"]
};
function ase(t) {
  const { maxRatingNumber: e = 5, ratingNumber: n = 0, className: r, onChange: i, allowHalf: o = !1 } = t, s = Me(null), [a, l] = pe(n);
  let c = 0;
  const u = new Array(e).fill(null).map(() => (c += 1, c <= a ? /* @__PURE__ */ v(
    dU,
    {
      "data-testid": "full-star",
      className: Mx.base.join(" ")
    },
    c
  ) : c - 0.5 <= a ? /* @__PURE__ */ v(
    fU,
    {
      "data-testid": "half-star",
      className: Mx.base.join(" ")
    },
    c
  ) : /* @__PURE__ */ v(
    hU,
    {
      "data-testid": "empty-star",
      className: I(mU.base.join(" "))
    },
    c
  ))), d = (p) => {
    if (!s.current)
      return;
    const { left: m, width: b } = s.current.getBoundingClientRect(), k = (p.clientX - m) / b;
    if (o) {
      const S = k * e + 0.5, T = Math.floor(S * 2) / 2;
      l(T);
      return;
    }
    const C = k * e + 1, x = Math.floor(C);
    l(x);
  }, f = () => {
    i && i(a);
  }, h = () => {
    l(n);
  };
  return De(() => {
    l(n);
  }, [n]), /* @__PURE__ */ v(
    "button",
    {
      type: "button",
      ref: s,
      "data-testid": "rating-container",
      className: I("kn-rating", pU.base.join(" "), r, {
        "cursor-default": !i
      }),
      ...i && {
        onMouseMove: d,
        onMouseDown: f,
        onMouseLeave: h
      },
      children: u
    }
  );
}
const gU = {}, Ox = {
  name: "label",
  base: [
    "text-inverted",
    "px-2",
    "py-1",
    "bg-inverted",
    "leading-none",
    "shadow-sm",
    "data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade",
    "data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade",
    "data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade",
    "data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade",
    "will-change-[transform,opacity]"
  ],
  config: {
    variants: gU
  }
}, vU = Ie(Ox.base, Ox.config);
function OA({ children: t, className: e, ...n }, r) {
  const i = xe();
  return /* @__PURE__ */ v(
    Lz,
    {
      "data-testid": "asterisk-tooltip-content",
      sideOffset: 2,
      ref: r,
      className: I(
        "kn-tooltip-content",
        vU(),
        {
          "rounded-md": i.theme.appearance.corners === "rounded"
        },
        e
      ),
      ...n,
      children: t
    }
  );
}
function AA({ children: t, className: e, ...n }, r) {
  return /* @__PURE__ */ v(
    Pz,
    {
      "data-testid": "asterisk-tooltip-trigger",
      ref: r,
      className: I("kn-tooltip-trigger", e),
      ...n,
      children: t
    }
  );
}
const Wt = Object.assign(_z, {
  Trigger: ce(AA),
  Content: ce(OA),
  Provider: vO,
  Portal: bO
});
AA.displayName = "Tooltip.Trigger";
OA.displayName = "Tooltip.Content";
vO.displayName = "Tooltip.Provider";
bO.displayName = "Tooltip.Portal";
const bU = {
  sm: ["h-5", "p-1", "text-xs", "gap-1"],
  default: ["h-8", "p-2"],
  lg: ["h-10", "p-3", "text-base"]
}, yU = {
  name: "chip",
  base: [
    "inline-flex",
    "items-center",
    "justify-center",
    "gap-2",
    "font-semibold",
    "m-2",
    "p-2",
    "h-8",
    "bg-subtle",
    "text-default",
    "truncate",
    "min-w-5"
  ]
}, wU = Ie(yU.base, {
  variants: {
    size: bU
  },
  defaultVariants: {
    size: "default"
  }
});
function NA({
  profileImage: t,
  icon: e,
  text: n,
  className: r,
  disabled: i,
  onClose: o,
  size: s = "default",
  removeText: a = "Remove",
  textClassName: l,
  children: c,
  ...u
}, d) {
  const f = xe(), h = () => /* @__PURE__ */ F(Wt, { children: [
    /* @__PURE__ */ v(Wt.Trigger, { className: I("max-w-32 truncate", l), asChild: !0, children: /* @__PURE__ */ v("span", { children: n }) }),
    /* @__PURE__ */ v(Wt.Portal, { children: /* @__PURE__ */ v(Wt.Content, { className: "z-50", children: /* @__PURE__ */ v("span", { className: "max-w-[400px] truncate p-2", children: n }) }) })
  ] }, n);
  return /* @__PURE__ */ F(
    "div",
    {
      ref: d,
      className: I(
        "kn-chip",
        wU({ size: s }),
        {
          "hover:bg-emphasis": !i,
          "hover:text-emphasis": !i,
          "text-subtle": i,
          "pl-0": t && s === "sm",
          "rounded-md": f.theme.appearance.corners === "rounded"
        },
        r
      ),
      "data-testid": "asterisk-chip",
      ...u,
      children: [
        e || t && /* @__PURE__ */ v(
          qw,
          {
            className: I("size-6", {
              "rounded-sm": f.theme.appearance.corners === "rounded"
            }),
            children: /* @__PURE__ */ v(qw.Image, { src: t })
          }
        ),
        /* @__PURE__ */ F("div", { className: "flex items-center gap-2 truncate", children: [
          n ? h() : c,
          o && !i && /* @__PURE__ */ v(
            "span",
            {
              onClick: o,
              className: I(
                "hover:bg-action focus-visible:outline-default cursor-pointer focus:ring-0",
                {
                  "rounded-xs": f.theme.appearance.corners === "rounded"
                }
              ),
              role: "button",
              tabIndex: 0,
              "aria-label": a,
              onKeyDown: (p) => {
                (p.key === "Enter" || p.key === " ") && (p.preventDefault(), o(p));
              },
              children: /* @__PURE__ */ v(Vr, { size: 16 })
            }
          )
        ] })
      ]
    }
  );
}
const Zh = ce(NA);
NA.displayName = "Chip";
function Ct(t) {
  this.content = t;
}
Ct.prototype = {
  constructor: Ct,
  find: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === t) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(t) {
    var e = this.find(t);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(t, e, n) {
    var r = n && n != t ? this.remove(n) : this, i = r.find(t), o = r.content.slice();
    return i == -1 ? o.push(n || t, e) : (o[i + 1] = e, n && (o[i] = n)), new Ct(o);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(t) {
    var e = this.find(t);
    if (e == -1) return this;
    var n = this.content.slice();
    return n.splice(e, 2), new Ct(n);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(t, e) {
    return new Ct([t, e].concat(this.remove(t).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(t, e) {
    var n = this.remove(t).content.slice();
    return n.push(t, e), new Ct(n);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(t, e, n) {
    var r = this.remove(e), i = r.content.slice(), o = r.find(t);
    return i.splice(o == -1 ? i.length : o, 0, e, n), new Ct(i);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      t(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(t) {
    return t = Ct.from(t), t.size ? new Ct(t.content.concat(this.subtract(t).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(t) {
    return t = Ct.from(t), t.size ? new Ct(this.subtract(t).content.concat(t.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(t) {
    var e = this;
    t = Ct.from(t);
    for (var n = 0; n < t.content.length; n += 2)
      e = e.remove(t.content[n]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var t = {};
    return this.forEach(function(e, n) {
      t[e] = n;
    }), t;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Ct.from = function(t) {
  if (t instanceof Ct) return t;
  var e = [];
  if (t) for (var n in t) e.push(n, t[n]);
  return new Ct(e);
};
function RA(t, e, n) {
  for (let r = 0; ; r++) {
    if (r == t.childCount || r == e.childCount)
      return t.childCount == e.childCount ? null : n;
    let i = t.child(r), o = e.child(r);
    if (i == o) {
      n += i.nodeSize;
      continue;
    }
    if (!i.sameMarkup(o))
      return n;
    if (i.isText && i.text != o.text) {
      for (let s = 0; i.text[s] == o.text[s]; s++)
        n++;
      return n;
    }
    if (i.content.size || o.content.size) {
      let s = RA(i.content, o.content, n + 1);
      if (s != null)
        return s;
    }
    n += i.nodeSize;
  }
}
function DA(t, e, n, r) {
  for (let i = t.childCount, o = e.childCount; ; ) {
    if (i == 0 || o == 0)
      return i == o ? null : { a: n, b: r };
    let s = t.child(--i), a = e.child(--o), l = s.nodeSize;
    if (s == a) {
      n -= l, r -= l;
      continue;
    }
    if (!s.sameMarkup(a))
      return { a: n, b: r };
    if (s.isText && s.text != a.text) {
      let c = 0, u = Math.min(s.text.length, a.text.length);
      for (; c < u && s.text[s.text.length - c - 1] == a.text[a.text.length - c - 1]; )
        c++, n--, r--;
      return { a: n, b: r };
    }
    if (s.content.size || a.content.size) {
      let c = DA(s.content, a.content, n - 1, r - 1);
      if (c)
        return c;
    }
    n -= l, r -= l;
  }
}
class U {
  /**
  @internal
  */
  constructor(e, n) {
    if (this.content = e, this.size = n || 0, n == null)
      for (let r = 0; r < e.length; r++)
        this.size += e[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, n, r, i = 0, o) {
    for (let s = 0, a = 0; a < n; s++) {
      let l = this.content[s], c = a + l.nodeSize;
      if (c > e && r(l, i + a, o || null, s) !== !1 && l.content.size) {
        let u = a + 1;
        l.nodesBetween(Math.max(0, e - u), Math.min(l.content.size, n - u), r, i + u);
      }
      a = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, n, r, i) {
    let o = "", s = !0;
    return this.nodesBetween(e, n, (a, l) => {
      let c = a.isText ? a.text.slice(Math.max(e, l) - l, n - l) : a.isLeaf ? i ? typeof i == "function" ? i(a) : i : a.type.spec.leafText ? a.type.spec.leafText(a) : "" : "";
      a.isBlock && (a.isLeaf && c || a.isTextblock) && r && (s ? s = !1 : o += r), o += c;
    }, 0), o;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let n = this.lastChild, r = e.firstChild, i = this.content.slice(), o = 0;
    for (n.isText && n.sameMarkup(r) && (i[i.length - 1] = n.withText(n.text + r.text), o = 1); o < e.content.length; o++)
      i.push(e.content[o]);
    return new U(i, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, n = this.size) {
    if (e == 0 && n == this.size)
      return this;
    let r = [], i = 0;
    if (n > e)
      for (let o = 0, s = 0; s < n; o++) {
        let a = this.content[o], l = s + a.nodeSize;
        l > e && ((s < e || l > n) && (a.isText ? a = a.cut(Math.max(0, e - s), Math.min(a.text.length, n - s)) : a = a.cut(Math.max(0, e - s - 1), Math.min(a.content.size, n - s - 1))), r.push(a), i += a.nodeSize), s = l;
      }
    return new U(r, i);
  }
  /**
  @internal
  */
  cutByIndex(e, n) {
    return e == n ? U.empty : e == 0 && n == this.content.length ? this : new U(this.content.slice(e, n));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, n) {
    let r = this.content[e];
    if (r == n)
      return this;
    let i = this.content.slice(), o = this.size + n.nodeSize - r.nodeSize;
    return i[e] = n, new U(i, o);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new U([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new U(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let n = 0; n < this.content.length; n++)
      if (!this.content[n].eq(e.content[n]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let n = this.content[e];
    if (!n)
      throw new RangeError("Index " + e + " out of range for " + this);
    return n;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let n = 0, r = 0; n < this.content.length; n++) {
      let i = this.content[n];
      e(i, r, n), r += i.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, n = 0) {
    return RA(this, e, n);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, n = this.size, r = e.size) {
    return DA(this, e, n, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e, n = -1) {
    if (e == 0)
      return Fl(0, e);
    if (e == this.size)
      return Fl(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let r = 0, i = 0; ; r++) {
      let o = this.child(r), s = i + o.nodeSize;
      if (s >= e)
        return s == e || n > 0 ? Fl(r + 1, s) : Fl(r, i);
      i = s;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      return U.empty;
    if (!Array.isArray(n))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new U(n.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return U.empty;
    let n, r = 0;
    for (let i = 0; i < e.length; i++) {
      let o = e[i];
      r += o.nodeSize, i && o.isText && e[i - 1].sameMarkup(o) ? (n || (n = e.slice(0, i)), n[n.length - 1] = o.withText(n[n.length - 1].text + o.text)) : n && n.push(o);
    }
    return new U(n || e, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return U.empty;
    if (e instanceof U)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new U([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
U.empty = new U([], 0);
const Jh = { index: 0, offset: 0 };
function Fl(t, e) {
  return Jh.index = t, Jh.offset = e, Jh;
}
function Kc(t, e) {
  if (t === e)
    return !0;
  if (!(t && typeof t == "object") || !(e && typeof e == "object"))
    return !1;
  let n = Array.isArray(t);
  if (Array.isArray(e) != n)
    return !1;
  if (n) {
    if (t.length != e.length)
      return !1;
    for (let r = 0; r < t.length; r++)
      if (!Kc(t[r], e[r]))
        return !1;
  } else {
    for (let r in t)
      if (!(r in e) || !Kc(t[r], e[r]))
        return !1;
    for (let r in e)
      if (!(r in t))
        return !1;
  }
  return !0;
}
let Ye = class Pm {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.attrs = n;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let n, r = !1;
    for (let i = 0; i < e.length; i++) {
      let o = e[i];
      if (this.eq(o))
        return e;
      if (this.type.excludes(o.type))
        n || (n = e.slice(0, i));
      else {
        if (o.type.excludes(this.type))
          return e;
        !r && o.type.rank > this.type.rank && (n || (n = e.slice(0, i)), n.push(this), r = !0), n && n.push(o);
      }
    }
    return n || (n = e.slice()), r || n.push(this), n;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let n = 0; n < e.length; n++)
      if (this.eq(e[n]))
        return e.slice(0, n).concat(e.slice(n + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let n = 0; n < e.length; n++)
      if (this.eq(e[n]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && Kc(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let n in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, n) {
    if (!n)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = e.marks[n.type];
    if (!r)
      throw new RangeError(`There is no mark type ${n.type} in this schema`);
    let i = r.create(n.attrs);
    return r.checkAttrs(i.attrs), i;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, n) {
    if (e == n)
      return !0;
    if (e.length != n.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!e[r].eq(n[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return Pm.none;
    if (e instanceof Pm)
      return [e];
    let n = e.slice();
    return n.sort((r, i) => r.type.rank - i.type.rank), n;
  }
};
Ye.none = [];
class Gc extends Error {
}
class ee {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, n, r) {
    this.content = e, this.openStart = n, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, n) {
    let r = _A(this.content, e + this.openStart, n);
    return r && new ee(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, n) {
    return new ee(IA(this.content, e + this.openStart, n + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      return ee.empty;
    let r = n.openStart || 0, i = n.openEnd || 0;
    if (typeof r != "number" || typeof i != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new ee(U.fromJSON(e, n.content), r, i);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, n = !0) {
    let r = 0, i = 0;
    for (let o = e.firstChild; o && !o.isLeaf && (n || !o.type.spec.isolating); o = o.firstChild)
      r++;
    for (let o = e.lastChild; o && !o.isLeaf && (n || !o.type.spec.isolating); o = o.lastChild)
      i++;
    return new ee(e, r, i);
  }
}
ee.empty = new ee(U.empty, 0, 0);
function IA(t, e, n) {
  let { index: r, offset: i } = t.findIndex(e), o = t.maybeChild(r), { index: s, offset: a } = t.findIndex(n);
  if (i == e || o.isText) {
    if (a != n && !t.child(s).isText)
      throw new RangeError("Removing non-flat range");
    return t.cut(0, e).append(t.cut(n));
  }
  if (r != s)
    throw new RangeError("Removing non-flat range");
  return t.replaceChild(r, o.copy(IA(o.content, e - i - 1, n - i - 1)));
}
function _A(t, e, n, r) {
  let { index: i, offset: o } = t.findIndex(e), s = t.maybeChild(i);
  if (o == e || s.isText)
    return t.cut(0, e).append(n).append(t.cut(e));
  let a = _A(s.content, e - o - 1, n);
  return a && t.replaceChild(i, s.copy(a));
}
function xU(t, e, n) {
  if (n.openStart > t.depth)
    throw new Gc("Inserted content deeper than insertion position");
  if (t.depth - n.openStart != e.depth - n.openEnd)
    throw new Gc("Inconsistent open depths");
  return PA(t, e, n, 0);
}
function PA(t, e, n, r) {
  let i = t.index(r), o = t.node(r);
  if (i == e.index(r) && r < t.depth - n.openStart) {
    let s = PA(t, e, n, r + 1);
    return o.copy(o.content.replaceChild(i, s));
  } else if (n.content.size)
    if (!n.openStart && !n.openEnd && t.depth == r && e.depth == r) {
      let s = t.parent, a = s.content;
      return Yi(s, a.cut(0, t.parentOffset).append(n.content).append(a.cut(e.parentOffset)));
    } else {
      let { start: s, end: a } = kU(n, t);
      return Yi(o, FA(t, s, a, e, r));
    }
  else return Yi(o, Yc(t, e, r));
}
function LA(t, e) {
  if (!e.type.compatibleContent(t.type))
    throw new Gc("Cannot join " + e.type.name + " onto " + t.type.name);
}
function Lm(t, e, n) {
  let r = t.node(n);
  return LA(r, e.node(n)), r;
}
function Gi(t, e) {
  let n = e.length - 1;
  n >= 0 && t.isText && t.sameMarkup(e[n]) ? e[n] = t.withText(e[n].text + t.text) : e.push(t);
}
function Zs(t, e, n, r) {
  let i = (e || t).node(n), o = 0, s = e ? e.index(n) : i.childCount;
  t && (o = t.index(n), t.depth > n ? o++ : t.textOffset && (Gi(t.nodeAfter, r), o++));
  for (let a = o; a < s; a++)
    Gi(i.child(a), r);
  e && e.depth == n && e.textOffset && Gi(e.nodeBefore, r);
}
function Yi(t, e) {
  return t.type.checkContent(e), t.copy(e);
}
function FA(t, e, n, r, i) {
  let o = t.depth > i && Lm(t, e, i + 1), s = r.depth > i && Lm(n, r, i + 1), a = [];
  return Zs(null, t, i, a), o && s && e.index(i) == n.index(i) ? (LA(o, s), Gi(Yi(o, FA(t, e, n, r, i + 1)), a)) : (o && Gi(Yi(o, Yc(t, e, i + 1)), a), Zs(e, n, i, a), s && Gi(Yi(s, Yc(n, r, i + 1)), a)), Zs(r, null, i, a), new U(a);
}
function Yc(t, e, n) {
  let r = [];
  if (Zs(null, t, n, r), t.depth > n) {
    let i = Lm(t, e, n + 1);
    Gi(Yi(i, Yc(t, e, n + 1)), r);
  }
  return Zs(e, null, n, r), new U(r);
}
function kU(t, e) {
  let n = e.depth - t.openStart, i = e.node(n).copy(t.content);
  for (let o = n - 1; o >= 0; o--)
    i = e.node(o).copy(U.from(i));
  return {
    start: i.resolveNoCache(t.openStart + n),
    end: i.resolveNoCache(i.content.size - t.openEnd - n)
  };
}
class ba {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.pos = e, this.path = n, this.parentOffset = r, this.depth = n.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, n = this.index(this.depth);
    if (n == e.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], i = e.child(n);
    return r ? e.child(n).cut(r) : i;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), n = this.pos - this.path[this.path.length - 1];
    return n ? this.parent.child(e).cut(0, n) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, n) {
    n = this.resolveDepth(n);
    let r = this.path[n * 3], i = n == 0 ? 0 : this.path[n * 3 - 1] + 1;
    for (let o = 0; o < e; o++)
      i += r.child(o).nodeSize;
    return i;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, n = this.index();
    if (e.content.size == 0)
      return Ye.none;
    if (this.textOffset)
      return e.child(n).marks;
    let r = e.maybeChild(n - 1), i = e.maybeChild(n);
    if (!r) {
      let a = r;
      r = i, i = a;
    }
    let o = r.marks;
    for (var s = 0; s < o.length; s++)
      o[s].type.spec.inclusive === !1 && (!i || !o[s].isInSet(i.marks)) && (o = o[s--].removeFromSet(o));
    return o;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let n = this.parent.maybeChild(this.index());
    if (!n || !n.isInline)
      return null;
    let r = n.marks, i = e.parent.maybeChild(e.index());
    for (var o = 0; o < r.length; o++)
      r[o].type.spec.inclusive === !1 && (!i || !r[o].isInSet(i.marks)) && (r = r[o--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let n = this.depth; n > 0; n--)
      if (this.start(n) <= e && this.end(n) >= e)
        return n;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, n) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); r >= 0; r--)
      if (e.pos <= this.end(r) && (!n || n(this.node(r))))
        return new Zc(this, e, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let n = 1; n <= this.depth; n++)
      e += (e ? "/" : "") + this.node(n).type.name + "_" + this.index(n - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, n) {
    if (!(n >= 0 && n <= e.content.size))
      throw new RangeError("Position " + n + " out of range");
    let r = [], i = 0, o = n;
    for (let s = e; ; ) {
      let { index: a, offset: l } = s.content.findIndex(o), c = o - l;
      if (r.push(s, a, i + l), !c || (s = s.child(a), s.isText))
        break;
      o = c - 1, i += l + 1;
    }
    return new ba(n, r, o);
  }
  /**
  @internal
  */
  static resolveCached(e, n) {
    let r = Ax.get(e);
    if (r)
      for (let o = 0; o < r.elts.length; o++) {
        let s = r.elts[o];
        if (s.pos == n)
          return s;
      }
    else
      Ax.set(e, r = new CU());
    let i = r.elts[r.i] = ba.resolve(e, n);
    return r.i = (r.i + 1) % SU, i;
  }
}
class CU {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const SU = 12, Ax = /* @__PURE__ */ new WeakMap();
class Zc {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, n, r) {
    this.$from = e, this.$to = n, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const TU = /* @__PURE__ */ Object.create(null);
let Ir = class Fm {
  /**
  @internal
  */
  constructor(e, n, r, i = Ye.none) {
    this.type = e, this.attrs = n, this.marks = i, this.content = r || U.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, n, r, i = 0) {
    this.content.nodesBetween(e, n, r, i, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(e, n, r, i) {
    return this.content.textBetween(e, n, r, i);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, n, r) {
    return this.type == e && Kc(this.attrs, n || e.defaultAttrs || TU) && Ye.sameSet(this.marks, r || Ye.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new Fm(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new Fm(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, n = this.content.size) {
    return e == 0 && n == this.content.size ? this : this.copy(this.content.cut(e, n));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, n = this.content.size, r = !1) {
    if (e == n)
      return ee.empty;
    let i = this.resolve(e), o = this.resolve(n), s = r ? 0 : i.sharedDepth(n), a = i.start(s), c = i.node(s).content.cut(i.pos - a, o.pos - a);
    return new ee(c, i.depth - s, o.depth - s);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, n, r) {
    return xU(this.resolve(e), this.resolve(n), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let n = this; ; ) {
      let { index: r, offset: i } = n.content.findIndex(e);
      if (n = n.maybeChild(r), !n)
        return null;
      if (i == e || n.isText)
        return n;
      e -= i + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: n, offset: r } = this.content.findIndex(e);
    return { node: this.content.maybeChild(n), index: n, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: n, offset: r } = this.content.findIndex(e);
    if (r < e)
      return { node: this.content.child(n), index: n, offset: r };
    let i = this.content.child(n - 1);
    return { node: i, index: n - 1, offset: r - i.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return ba.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return ba.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, n, r) {
    let i = !1;
    return n > e && this.nodesBetween(e, n, (o) => (r.isInSet(o.marks) && (i = !0), !i)), i;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), $A(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let n = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!n)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return n;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, n, r = U.empty, i = 0, o = r.childCount) {
    let s = this.contentMatchAt(e).matchFragment(r, i, o), a = s && s.matchFragment(this.content, n);
    if (!a || !a.validEnd)
      return !1;
    for (let l = i; l < o; l++)
      if (!this.type.allowsMarks(r.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, n, r, i) {
    if (i && !this.type.allowsMarks(i))
      return !1;
    let o = this.contentMatchAt(e).matchType(r), s = o && o.matchFragment(this.content, n);
    return s ? s.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = Ye.none;
    for (let n = 0; n < this.marks.length; n++) {
      let r = this.marks[n];
      r.type.checkAttrs(r.attrs), e = r.addToSet(e);
    }
    if (!Ye.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((n) => n.type.name)}`);
    this.content.forEach((n) => n.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let n in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((n) => n.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r;
    if (n.marks) {
      if (!Array.isArray(n.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = n.marks.map(e.markFromJSON);
    }
    if (n.type == "text") {
      if (typeof n.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(n.text, r);
    }
    let i = U.fromJSON(e, n.content), o = e.nodeType(n.type).create(n.attrs, i, r);
    return o.type.checkAttrs(o.attrs), o;
  }
};
Ir.prototype.text = void 0;
class Jc extends Ir {
  /**
  @internal
  */
  constructor(e, n, r, i) {
    if (super(e, n, null, i), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : $A(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, n) {
    return this.text.slice(e, n);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new Jc(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new Jc(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, n = this.text.length) {
    return e == 0 && n == this.text.length ? this : this.withText(this.text.slice(e, n));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function $A(t, e) {
  for (let n = t.length - 1; n >= 0; n--)
    e = t[n].type.name + "(" + e + ")";
  return e;
}
class io {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, n) {
    let r = new EU(e, n);
    if (r.next == null)
      return io.empty;
    let i = BA(r);
    r.next && r.err("Unexpected trailing text");
    let o = IU(DU(i));
    return _U(o, r), o;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let n = 0; n < this.next.length; n++)
      if (this.next[n].type == e)
        return this.next[n].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, n = 0, r = e.childCount) {
    let i = this;
    for (let o = n; i && o < r; o++)
      i = i.matchType(e.child(o).type);
    return i;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: n } = this.next[e];
      if (!(n.isText || n.hasRequiredAttrs()))
        return n;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let n = 0; n < this.next.length; n++)
      for (let r = 0; r < e.next.length; r++)
        if (this.next[n].type == e.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, n = !1, r = 0) {
    let i = [this];
    function o(s, a) {
      let l = s.matchFragment(e, r);
      if (l && (!n || l.validEnd))
        return U.from(a.map((c) => c.createAndFill()));
      for (let c = 0; c < s.next.length; c++) {
        let { type: u, next: d } = s.next[c];
        if (!(u.isText || u.hasRequiredAttrs()) && i.indexOf(d) == -1) {
          i.push(d);
          let f = o(d, a.concat(u));
          if (f)
            return f;
        }
      }
      return null;
    }
    return o(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == e)
        return this.wrapCache[r + 1];
    let n = this.computeWrapping(e);
    return this.wrapCache.push(e, n), n;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let n = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let i = r.shift(), o = i.match;
      if (o.matchType(e)) {
        let s = [];
        for (let a = i; a.type; a = a.via)
          s.push(a.type);
        return s.reverse();
      }
      for (let s = 0; s < o.next.length; s++) {
        let { type: a, next: l } = o.next[s];
        !a.isLeaf && !a.hasRequiredAttrs() && !(a.name in n) && (!i.type || l.validEnd) && (r.push({ match: a.contentMatch, type: a, via: i }), n[a.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function n(r) {
      e.push(r);
      for (let i = 0; i < r.next.length; i++)
        e.indexOf(r.next[i].next) == -1 && n(r.next[i].next);
    }
    return n(this), e.map((r, i) => {
      let o = i + (r.validEnd ? "*" : " ") + " ";
      for (let s = 0; s < r.next.length; s++)
        o += (s ? ", " : "") + r.next[s].type.name + "->" + e.indexOf(r.next[s].next);
      return o;
    }).join(`
`);
  }
}
io.empty = new io(!0);
class EU {
  constructor(e, n) {
    this.string = e, this.nodeTypes = n, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function BA(t) {
  let e = [];
  do
    e.push(MU(t));
  while (t.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function MU(t) {
  let e = [];
  do
    e.push(OU(t));
  while (t.next && t.next != ")" && t.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function OU(t) {
  let e = RU(t);
  for (; ; )
    if (t.eat("+"))
      e = { type: "plus", expr: e };
    else if (t.eat("*"))
      e = { type: "star", expr: e };
    else if (t.eat("?"))
      e = { type: "opt", expr: e };
    else if (t.eat("{"))
      e = AU(t, e);
    else
      break;
  return e;
}
function Nx(t) {
  /\D/.test(t.next) && t.err("Expected number, got '" + t.next + "'");
  let e = Number(t.next);
  return t.pos++, e;
}
function AU(t, e) {
  let n = Nx(t), r = n;
  return t.eat(",") && (t.next != "}" ? r = Nx(t) : r = -1), t.eat("}") || t.err("Unclosed braced range"), { type: "range", min: n, max: r, expr: e };
}
function NU(t, e) {
  let n = t.nodeTypes, r = n[e];
  if (r)
    return [r];
  let i = [];
  for (let o in n) {
    let s = n[o];
    s.isInGroup(e) && i.push(s);
  }
  return i.length == 0 && t.err("No node type or group '" + e + "' found"), i;
}
function RU(t) {
  if (t.eat("(")) {
    let e = BA(t);
    return t.eat(")") || t.err("Missing closing paren"), e;
  } else if (/\W/.test(t.next))
    t.err("Unexpected token '" + t.next + "'");
  else {
    let e = NU(t, t.next).map((n) => (t.inline == null ? t.inline = n.isInline : t.inline != n.isInline && t.err("Mixing inline and block content"), { type: "name", value: n }));
    return t.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function DU(t) {
  let e = [[]];
  return i(o(t, 0), n()), e;
  function n() {
    return e.push([]) - 1;
  }
  function r(s, a, l) {
    let c = { term: l, to: a };
    return e[s].push(c), c;
  }
  function i(s, a) {
    s.forEach((l) => l.to = a);
  }
  function o(s, a) {
    if (s.type == "choice")
      return s.exprs.reduce((l, c) => l.concat(o(c, a)), []);
    if (s.type == "seq")
      for (let l = 0; ; l++) {
        let c = o(s.exprs[l], a);
        if (l == s.exprs.length - 1)
          return c;
        i(c, a = n());
      }
    else if (s.type == "star") {
      let l = n();
      return r(a, l), i(o(s.expr, l), l), [r(l)];
    } else if (s.type == "plus") {
      let l = n();
      return i(o(s.expr, a), l), i(o(s.expr, l), l), [r(l)];
    } else {
      if (s.type == "opt")
        return [r(a)].concat(o(s.expr, a));
      if (s.type == "range") {
        let l = a;
        for (let c = 0; c < s.min; c++) {
          let u = n();
          i(o(s.expr, l), u), l = u;
        }
        if (s.max == -1)
          i(o(s.expr, l), l);
        else
          for (let c = s.min; c < s.max; c++) {
            let u = n();
            r(l, u), i(o(s.expr, l), u), l = u;
          }
        return [r(l)];
      } else {
        if (s.type == "name")
          return [r(a, void 0, s.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function VA(t, e) {
  return e - t;
}
function Rx(t, e) {
  let n = [];
  return r(e), n.sort(VA);
  function r(i) {
    let o = t[i];
    if (o.length == 1 && !o[0].term)
      return r(o[0].to);
    n.push(i);
    for (let s = 0; s < o.length; s++) {
      let { term: a, to: l } = o[s];
      !a && n.indexOf(l) == -1 && r(l);
    }
  }
}
function IU(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return n(Rx(t, 0));
  function n(r) {
    let i = [];
    r.forEach((s) => {
      t[s].forEach(({ term: a, to: l }) => {
        if (!a)
          return;
        let c;
        for (let u = 0; u < i.length; u++)
          i[u][0] == a && (c = i[u][1]);
        Rx(t, l).forEach((u) => {
          c || i.push([a, c = []]), c.indexOf(u) == -1 && c.push(u);
        });
      });
    });
    let o = e[r.join(",")] = new io(r.indexOf(t.length - 1) > -1);
    for (let s = 0; s < i.length; s++) {
      let a = i[s][1].sort(VA);
      o.next.push({ type: i[s][0], next: e[a.join(",")] || n(a) });
    }
    return o;
  }
}
function _U(t, e) {
  for (let n = 0, r = [t]; n < r.length; n++) {
    let i = r[n], o = !i.validEnd, s = [];
    for (let a = 0; a < i.next.length; a++) {
      let { type: l, next: c } = i.next[a];
      s.push(l.name), o && !(l.isText || l.hasRequiredAttrs()) && (o = !1), r.indexOf(c) == -1 && r.push(c);
    }
    o && e.err("Only non-generatable nodes (" + s.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function zA(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t) {
    let r = t[n];
    if (!r.hasDefault)
      return null;
    e[n] = r.default;
  }
  return e;
}
function HA(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let r in t) {
    let i = e && e[r];
    if (i === void 0) {
      let o = t[r];
      if (o.hasDefault)
        i = o.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    n[r] = i;
  }
  return n;
}
function WA(t, e, n, r) {
  for (let i in e)
    if (!(i in t))
      throw new RangeError(`Unsupported attribute ${i} for ${n} of type ${i}`);
  for (let i in t) {
    let o = t[i];
    o.validate && o.validate(e[i]);
  }
}
function jA(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let r in e)
      n[r] = new LU(t, r, e[r]);
  return n;
}
let Dx = class UA {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.name = e, this.schema = n, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = jA(e, r.attrs), this.defaultAttrs = zA(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == io.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : HA(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, n, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Ir(this, this.computeAttrs(e), U.from(n), Ye.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, n, r) {
    return n = U.from(n), this.checkContent(n), new Ir(this, this.computeAttrs(e), n, Ye.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, n, r) {
    if (e = this.computeAttrs(e), n = U.from(n), n.size) {
      let s = this.contentMatch.fillBefore(n);
      if (!s)
        return null;
      n = s.append(n);
    }
    let i = this.contentMatch.matchFragment(n), o = i && i.fillBefore(U.empty, !0);
    return o ? new Ir(this, e, n.append(o), Ye.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let n = this.contentMatch.matchFragment(e);
    if (!n || !n.validEnd)
      return !1;
    for (let r = 0; r < e.childCount; r++)
      if (!this.allowsMarks(e.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    WA(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let n = 0; n < e.length; n++)
      if (!this.allowsMarkType(e[n].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let n;
    for (let r = 0; r < e.length; r++)
      this.allowsMarkType(e[r].type) ? n && n.push(e[r]) : n || (n = e.slice(0, r));
    return n ? n.length ? n : Ye.none : e;
  }
  /**
  @internal
  */
  static compile(e, n) {
    let r = /* @__PURE__ */ Object.create(null);
    e.forEach((o, s) => r[o] = new UA(o, n, s));
    let i = n.spec.topNode || "doc";
    if (!r[i])
      throw new RangeError("Schema is missing its top node type ('" + i + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let o in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
function PU(t, e, n) {
  let r = n.split("|");
  return (i) => {
    let o = i === null ? "null" : typeof i;
    if (r.indexOf(o) < 0)
      throw new RangeError(`Expected value of type ${r} for attribute ${e} on type ${t}, got ${o}`);
  };
}
class LU {
  constructor(e, n, r) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(r, "default"), this.default = r.default, this.validate = typeof r.validate == "string" ? PU(e, n, r.validate) : r.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Ed {
  /**
  @internal
  */
  constructor(e, n, r, i) {
    this.name = e, this.rank = n, this.schema = r, this.spec = i, this.attrs = jA(e, i.attrs), this.excluded = null;
    let o = zA(this.attrs);
    this.instance = o ? new Ye(this, o) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new Ye(this, HA(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, n) {
    let r = /* @__PURE__ */ Object.create(null), i = 0;
    return e.forEach((o, s) => r[o] = new Ed(o, i++, n, s)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var n = 0; n < e.length; n++)
      e[n].type == this && (e = e.slice(0, n).concat(e.slice(n + 1)), n--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let n = 0; n < e.length; n++)
      if (e[n].type == this)
        return e[n];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    WA(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class Pv {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let n = this.spec = {};
    for (let i in e)
      n[i] = e[i];
    n.nodes = Ct.from(e.nodes), n.marks = Ct.from(e.marks || {}), this.nodes = Dx.compile(this.spec.nodes, this), this.marks = Ed.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in this.nodes) {
      if (i in this.marks)
        throw new RangeError(i + " can not be both a node and a mark");
      let o = this.nodes[i], s = o.spec.content || "", a = o.spec.marks;
      if (o.contentMatch = r[s] || (r[s] = io.parse(s, this.nodes)), o.inlineContent = o.contentMatch.inlineContent, o.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!o.isInline || !o.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = o;
      }
      o.markSet = a == "_" ? null : a ? Ix(this, a.split(" ")) : a == "" || !o.inlineContent ? [] : null;
    }
    for (let i in this.marks) {
      let o = this.marks[i], s = o.spec.excludes;
      o.excluded = s == null ? [o] : s == "" ? [] : Ix(this, s.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, n = null, r, i) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof Dx) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(n, r, i);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, n) {
    let r = this.nodes.text;
    return new Jc(r, r.defaultAttrs, e, Ye.setFrom(n));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, n) {
    return typeof e == "string" && (e = this.marks[e]), e.create(n);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(e) {
    return Ir.fromJSON(this, e);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(e) {
    return Ye.fromJSON(this, e);
  }
  /**
  @internal
  */
  nodeType(e) {
    let n = this.nodes[e];
    if (!n)
      throw new RangeError("Unknown node type: " + e);
    return n;
  }
}
function Ix(t, e) {
  let n = [];
  for (let r = 0; r < e.length; r++) {
    let i = e[r], o = t.marks[i], s = o;
    if (o)
      n.push(o);
    else
      for (let a in t.marks) {
        let l = t.marks[a];
        (i == "_" || l.spec.group && l.spec.group.split(" ").indexOf(i) > -1) && n.push(s = l);
      }
    if (!s)
      throw new SyntaxError("Unknown mark type: '" + e[r] + "'");
  }
  return n;
}
function FU(t) {
  return t.tag != null;
}
function $U(t) {
  return t.style != null;
}
class Wn {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, n) {
    this.schema = e, this.rules = n, this.tags = [], this.styles = [];
    let r = this.matchedStyles = [];
    n.forEach((i) => {
      if (FU(i))
        this.tags.push(i);
      else if ($U(i)) {
        let o = /[^=]*/.exec(i.style)[0];
        r.indexOf(o) < 0 && r.push(o), this.styles.push(i);
      }
    }), this.normalizeLists = !this.tags.some((i) => {
      if (!/^(ul|ol)\b/.test(i.tag) || !i.node)
        return !1;
      let o = e.nodes[i.node];
      return o.contentMatch.matchType(o);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, n = {}) {
    let r = new Px(this, n, !1);
    return r.addAll(e, Ye.none, n.from, n.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, n = {}) {
    let r = new Px(this, n, !0);
    return r.addAll(e, Ye.none, n.from, n.to), ee.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(e, n, r) {
    for (let i = r ? this.tags.indexOf(r) + 1 : 0; i < this.tags.length; i++) {
      let o = this.tags[i];
      if (zU(e, o.tag) && (o.namespace === void 0 || e.namespaceURI == o.namespace) && (!o.context || n.matchesContext(o.context))) {
        if (o.getAttrs) {
          let s = o.getAttrs(e);
          if (s === !1)
            continue;
          o.attrs = s || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, n, r, i) {
    for (let o = i ? this.styles.indexOf(i) + 1 : 0; o < this.styles.length; o++) {
      let s = this.styles[o], a = s.style;
      if (!(a.indexOf(e) != 0 || s.context && !r.matchesContext(s.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      a.length > e.length && (a.charCodeAt(e.length) != 61 || a.slice(e.length + 1) != n))) {
        if (s.getAttrs) {
          let l = s.getAttrs(n);
          if (l === !1)
            continue;
          s.attrs = l || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let n = [];
    function r(i) {
      let o = i.priority == null ? 50 : i.priority, s = 0;
      for (; s < n.length; s++) {
        let a = n[s];
        if ((a.priority == null ? 50 : a.priority) < o)
          break;
      }
      n.splice(s, 0, i);
    }
    for (let i in e.marks) {
      let o = e.marks[i].spec.parseDOM;
      o && o.forEach((s) => {
        r(s = Lx(s)), s.mark || s.ignore || s.clearMark || (s.mark = i);
      });
    }
    for (let i in e.nodes) {
      let o = e.nodes[i].spec.parseDOM;
      o && o.forEach((s) => {
        r(s = Lx(s)), s.node || s.ignore || s.mark || (s.node = i);
      });
    }
    return n;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new Wn(e, Wn.schemaRules(e)));
  }
}
const qA = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, BU = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, KA = { ol: !0, ul: !0 }, ya = 1, $m = 2, hc = 4;
function _x(t, e, n) {
  return e != null ? (e ? ya : 0) | (e === "full" ? $m : 0) : t && t.whitespace == "pre" ? ya | $m : n & -5;
}
class $l {
  constructor(e, n, r, i, o, s) {
    this.type = e, this.attrs = n, this.marks = r, this.solid = i, this.options = s, this.content = [], this.activeMarks = Ye.none, this.match = o || (s & hc ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let n = this.type.contentMatch.fillBefore(U.from(e));
      if (n)
        this.match = this.type.contentMatch.matchFragment(n);
      else {
        let r = this.type.contentMatch, i;
        return (i = r.findWrapping(e.type)) ? (this.match = r, i) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & ya)) {
      let r = this.content[this.content.length - 1], i;
      if (r && r.isText && (i = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let o = r;
        r.text.length == i[0].length ? this.content.pop() : this.content[this.content.length - 1] = o.withText(o.text.slice(0, o.text.length - i[0].length));
      }
    }
    let n = U.from(this.content);
    return !e && this.match && (n = n.append(this.match.fillBefore(U.empty, !0))), this.type ? this.type.create(this.attrs, n, this.marks) : n;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !qA.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class Px {
  constructor(e, n, r) {
    this.parser = e, this.options = n, this.isOpen = r, this.open = 0, this.localPreserveWS = !1;
    let i = n.topNode, o, s = _x(null, n.preserveWhitespace, 0) | (r ? hc : 0);
    i ? o = new $l(i.type, i.attrs, Ye.none, !0, n.topMatch || i.type.contentMatch, s) : r ? o = new $l(null, null, Ye.none, !0, null, s) : o = new $l(e.schema.topNodeType, null, Ye.none, !0, null, s), this.nodes = [o], this.find = n.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, n) {
    e.nodeType == 3 ? this.addTextNode(e, n) : e.nodeType == 1 && this.addElement(e, n);
  }
  addTextNode(e, n) {
    let r = e.nodeValue, i = this.top, o = i.options & $m ? "full" : this.localPreserveWS || (i.options & ya) > 0;
    if (o === "full" || i.inlineContext(e) || /[^ \t\r\n\u000c]/.test(r)) {
      if (o)
        o !== "full" ? r = r.replace(/\r?\n|\r/g, " ") : r = r.replace(/\r\n?/g, `
`);
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let s = i.content[i.content.length - 1], a = e.previousSibling;
        (!s || a && a.nodeName == "BR" || s.isText && /[ \t\r\n\u000c]$/.test(s.text)) && (r = r.slice(1));
      }
      r && this.insertNode(this.parser.schema.text(r), n), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, n, r) {
    let i = this.localPreserveWS, o = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let s = e.nodeName.toLowerCase(), a;
    KA.hasOwnProperty(s) && this.parser.normalizeLists && VU(e);
    let l = this.options.ruleFromNode && this.options.ruleFromNode(e) || (a = this.parser.matchTag(e, this, r));
    e: if (l ? l.ignore : BU.hasOwnProperty(s))
      this.findInside(e), this.ignoreFallback(e, n);
    else if (!l || l.skip || l.closeParent) {
      l && l.closeParent ? this.open = Math.max(0, this.open - 1) : l && l.skip.nodeType && (e = l.skip);
      let c, u = this.needsBlock;
      if (qA.hasOwnProperty(s))
        o.content.length && o.content[0].isInline && this.open && (this.open--, o = this.top), c = !0, o.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, n);
        break e;
      }
      let d = l && l.skip ? n : this.readStyles(e, n);
      d && this.addAll(e, d), c && this.sync(o), this.needsBlock = u;
    } else {
      let c = this.readStyles(e, n);
      c && this.addElementByRule(e, l, c, l.consuming === !1 ? a : void 0);
    }
    this.localPreserveWS = i;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, n) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), n);
  }
  // Called for ignored nodes
  ignoreFallback(e, n) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), n);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, n) {
    let r = e.style;
    if (r && r.length)
      for (let i = 0; i < this.parser.matchedStyles.length; i++) {
        let o = this.parser.matchedStyles[i], s = r.getPropertyValue(o);
        if (s)
          for (let a = void 0; ; ) {
            let l = this.parser.matchStyle(o, s, this, a);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? n = n.filter((c) => !l.clearMark(c)) : n = n.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              a = l;
            else
              break;
          }
      }
    return n;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, n, r, i) {
    let o, s;
    if (n.node)
      if (s = this.parser.schema.nodes[n.node], s.isLeaf)
        this.insertNode(s.create(n.attrs), r) || this.leafFallback(e, r);
      else {
        let l = this.enter(s, n.attrs || null, r, n.preserveWhitespace);
        l && (o = !0, r = l);
      }
    else {
      let l = this.parser.schema.marks[n.mark];
      r = r.concat(l.create(n.attrs));
    }
    let a = this.top;
    if (s && s.isLeaf)
      this.findInside(e);
    else if (i)
      this.addElement(e, r, i);
    else if (n.getContent)
      this.findInside(e), n.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l, r));
    else {
      let l = e;
      typeof n.contentElement == "string" ? l = e.querySelector(n.contentElement) : typeof n.contentElement == "function" ? l = n.contentElement(e) : n.contentElement && (l = n.contentElement), this.findAround(e, l, !0), this.addAll(l, r), this.findAround(e, l, !1);
    }
    o && this.sync(a) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, n, r, i) {
    let o = r || 0;
    for (let s = r ? e.childNodes[r] : e.firstChild, a = i == null ? null : e.childNodes[i]; s != a; s = s.nextSibling, ++o)
      this.findAtPoint(e, o), this.addDOM(s, n);
    this.findAtPoint(e, o);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, n) {
    let r, i;
    for (let o = this.open; o >= 0; o--) {
      let s = this.nodes[o], a = s.findWrapping(e);
      if (a && (!r || r.length > a.length) && (r = a, i = s, !a.length) || s.solid)
        break;
    }
    if (!r)
      return null;
    this.sync(i);
    for (let o = 0; o < r.length; o++)
      n = this.enterInner(r[o], null, n, !1);
    return n;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, n) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let i = this.textblockFromContext();
      i && (n = this.enterInner(i, null, n));
    }
    let r = this.findPlace(e, n);
    if (r) {
      this.closeExtra();
      let i = this.top;
      i.match && (i.match = i.match.matchType(e.type));
      let o = Ye.none;
      for (let s of r.concat(e.marks))
        (i.type ? i.type.allowsMarkType(s.type) : Fx(s.type, e.type)) && (o = s.addToSet(o));
      return i.content.push(e.mark(o)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, n, r, i) {
    let o = this.findPlace(e.create(n), r);
    return o && (o = this.enterInner(e, n, r, !0, i)), o;
  }
  // Open a node of the given type
  enterInner(e, n, r, i = !1, o) {
    this.closeExtra();
    let s = this.top;
    s.match = s.match && s.match.matchType(e);
    let a = _x(e, o, s.options);
    s.options & hc && s.content.length == 0 && (a |= hc);
    let l = Ye.none;
    return r = r.filter((c) => (s.type ? s.type.allowsMarkType(c.type) : Fx(c.type, e)) ? (l = c.addToSet(l), !1) : !0), this.nodes.push(new $l(e, n, l, i, null, a)), this.open++, r;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let n = this.nodes.length - 1;
    if (n > this.open) {
      for (; n > this.open; n--)
        this.nodes[n - 1].content.push(this.nodes[n].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let n = this.open; n >= 0; n--) {
      if (this.nodes[n] == e)
        return this.open = n, !0;
      this.localPreserveWS && (this.nodes[n].options |= ya);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let n = this.open; n >= 0; n--) {
      let r = this.nodes[n].content;
      for (let i = r.length - 1; i >= 0; i--)
        e += r[i].nodeSize;
      n && e++;
    }
    return e;
  }
  findAtPoint(e, n) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && this.find[r].offset == n && (this.find[r].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && e.nodeType == 1 && e.contains(this.find[n].node) && (this.find[n].pos = this.currentPos);
  }
  findAround(e, n, r) {
    if (e != n && this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].pos == null && e.nodeType == 1 && e.contains(this.find[i].node) && n.compareDocumentPosition(this.find[i].node) & (r ? 2 : 4) && (this.find[i].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == e && (this.find[n].pos = this.currentPos - (e.nodeValue.length - this.find[n].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let n = e.split("/"), r = this.options.context, i = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), o = -(r ? r.depth + 1 : 0) + (i ? 0 : 1), s = (a, l) => {
      for (; a >= 0; a--) {
        let c = n[a];
        if (c == "") {
          if (a == n.length - 1 || a == 0)
            continue;
          for (; l >= o; l--)
            if (s(a - 1, l))
              return !0;
          return !1;
        } else {
          let u = l > 0 || l == 0 && i ? this.nodes[l].type : r && l >= o ? r.node(l - o).type : null;
          if (!u || u.name != c && !u.isInGroup(c))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return s(n.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let n = e.depth; n >= 0; n--) {
        let r = e.node(n).contentMatchAt(e.indexAfter(n)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let n in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[n];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
}
function VU(t) {
  for (let e = t.firstChild, n = null; e; e = e.nextSibling) {
    let r = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    r && KA.hasOwnProperty(r) && n ? (n.appendChild(e), e = n) : r == "li" ? n = e : r && (n = null);
  }
}
function zU(t, e) {
  return (t.matches || t.msMatchesSelector || t.webkitMatchesSelector || t.mozMatchesSelector).call(t, e);
}
function Lx(t) {
  let e = {};
  for (let n in t)
    e[n] = t[n];
  return e;
}
function Fx(t, e) {
  let n = e.schema.nodes;
  for (let r in n) {
    let i = n[r];
    if (!i.allowsMarkType(t))
      continue;
    let o = [], s = (a) => {
      o.push(a);
      for (let l = 0; l < a.edgeCount; l++) {
        let { type: c, next: u } = a.edge(l);
        if (c == e || o.indexOf(u) < 0 && s(u))
          return !0;
      }
    };
    if (s(i.contentMatch))
      return !0;
  }
}
class vo {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, n) {
    this.nodes = e, this.marks = n;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, n = {}, r) {
    r || (r = Xh(n).createDocumentFragment());
    let i = r, o = [];
    return e.forEach((s) => {
      if (o.length || s.marks.length) {
        let a = 0, l = 0;
        for (; a < o.length && l < s.marks.length; ) {
          let c = s.marks[l];
          if (!this.marks[c.type.name]) {
            l++;
            continue;
          }
          if (!c.eq(o[a][0]) || c.type.spec.spanning === !1)
            break;
          a++, l++;
        }
        for (; a < o.length; )
          i = o.pop()[1];
        for (; l < s.marks.length; ) {
          let c = s.marks[l++], u = this.serializeMark(c, s.isInline, n);
          u && (o.push([c, i]), i.appendChild(u.dom), i = u.contentDOM || u.dom);
        }
      }
      i.appendChild(this.serializeNodeInner(s, n));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(e, n) {
    let { dom: r, contentDOM: i } = pc(Xh(n), this.nodes[e.type.name](e), null, e.attrs);
    if (i) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, n, i);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, n = {}) {
    let r = this.serializeNodeInner(e, n);
    for (let i = e.marks.length - 1; i >= 0; i--) {
      let o = this.serializeMark(e.marks[i], e.isInline, n);
      o && ((o.contentDOM || o.dom).appendChild(r), r = o.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(e, n, r = {}) {
    let i = this.marks[e.type.name];
    return i && pc(Xh(r), i(e, n), null, e.attrs);
  }
  static renderSpec(e, n, r = null, i) {
    return pc(e, n, r, i);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new vo(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let n = $x(e.nodes);
    return n.text || (n.text = (r) => r.text), n;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return $x(e.marks);
  }
}
function $x(t) {
  let e = {};
  for (let n in t) {
    let r = t[n].spec.toDOM;
    r && (e[n] = r);
  }
  return e;
}
function Xh(t) {
  return t.document || window.document;
}
const Bx = /* @__PURE__ */ new WeakMap();
function HU(t) {
  let e = Bx.get(t);
  return e === void 0 && Bx.set(t, e = WU(t)), e;
}
function WU(t) {
  let e = null;
  function n(r) {
    if (r && typeof r == "object")
      if (Array.isArray(r))
        if (typeof r[0] == "string")
          e || (e = []), e.push(r);
        else
          for (let i = 0; i < r.length; i++)
            n(r[i]);
      else
        for (let i in r)
          n(r[i]);
  }
  return n(t), e;
}
function pc(t, e, n, r) {
  if (typeof e == "string")
    return { dom: t.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let i = e[0], o;
  if (typeof i != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (r && (o = HU(r)) && o.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let s = i.indexOf(" ");
  s > 0 && (n = i.slice(0, s), i = i.slice(s + 1));
  let a, l = n ? t.createElementNS(n, i) : t.createElement(i), c = e[1], u = 1;
  if (c && typeof c == "object" && c.nodeType == null && !Array.isArray(c)) {
    u = 2;
    for (let d in c)
      if (c[d] != null) {
        let f = d.indexOf(" ");
        f > 0 ? l.setAttributeNS(d.slice(0, f), d.slice(f + 1), c[d]) : l.setAttribute(d, c[d]);
      }
  }
  for (let d = u; d < e.length; d++) {
    let f = e[d];
    if (f === 0) {
      if (d < e.length - 1 || d > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: l, contentDOM: l };
    } else {
      let { dom: h, contentDOM: p } = pc(t, f, n, r);
      if (l.appendChild(h), p) {
        if (a)
          throw new RangeError("Multiple content holes");
        a = p;
      }
    }
  }
  return { dom: l, contentDOM: a };
}
const GA = 65535, YA = Math.pow(2, 16);
function jU(t, e) {
  return t + e * YA;
}
function Vx(t) {
  return t & GA;
}
function UU(t) {
  return (t - (t & GA)) / YA;
}
const ZA = 1, JA = 2, mc = 4, XA = 8;
class Bm {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.pos = e, this.delInfo = n, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & XA) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (ZA | mc)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (JA | mc)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & mc) > 0;
  }
}
class ln {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, n = !1) {
    if (this.ranges = e, this.inverted = n, !e.length && ln.empty)
      return ln.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let n = 0, r = Vx(e);
    if (!this.inverted)
      for (let i = 0; i < r; i++)
        n += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
    return this.ranges[r * 3] + n + UU(e);
  }
  mapResult(e, n = 1) {
    return this._map(e, n, !1);
  }
  map(e, n = 1) {
    return this._map(e, n, !0);
  }
  /**
  @internal
  */
  _map(e, n, r) {
    let i = 0, o = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? i : 0);
      if (l > e)
        break;
      let c = this.ranges[a + o], u = this.ranges[a + s], d = l + c;
      if (e <= d) {
        let f = c ? e == l ? -1 : e == d ? 1 : n : n, h = l + i + (f < 0 ? 0 : u);
        if (r)
          return h;
        let p = e == (n < 0 ? l : d) ? null : jU(a / 3, e - l), m = e == l ? JA : e == d ? ZA : mc;
        return (n < 0 ? e != l : e != d) && (m |= XA), new Bm(h, m, p);
      }
      i += u - c;
    }
    return r ? e + i : new Bm(e + i, 0, null);
  }
  /**
  @internal
  */
  touches(e, n) {
    let r = 0, i = Vx(n), o = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? r : 0);
      if (l > e)
        break;
      let c = this.ranges[a + o], u = l + c;
      if (e <= u && a == i * 3)
        return !0;
      r += this.ranges[a + s] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let n = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let i = 0, o = 0; i < this.ranges.length; i += 3) {
      let s = this.ranges[i], a = s - (this.inverted ? o : 0), l = s + (this.inverted ? 0 : o), c = this.ranges[i + n], u = this.ranges[i + r];
      e(a, a + c, l, l + u), o += u - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new ln(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? ln.empty : new ln(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
ln.empty = new ln([]);
class wa {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, n, r = 0, i = e ? e.length : 0) {
    this.mirror = n, this.from = r, this.to = i, this._maps = e || [], this.ownData = !(e || n);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, n = this.maps.length) {
    return new wa(this._maps, this.mirror, e, n);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, n) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), n != null && this.setMirror(this._maps.length - 1, n);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let n = 0, r = this._maps.length; n < e._maps.length; n++) {
      let i = e.getMirror(n);
      this.appendMap(e._maps[n], i != null && i < n ? r + i : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let n = 0; n < this.mirror.length; n++)
        if (this.mirror[n] == e)
          return this.mirror[n + (n % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, n) {
    this.mirror || (this.mirror = []), this.mirror.push(e, n);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let n = e.maps.length - 1, r = this._maps.length + e._maps.length; n >= 0; n--) {
      let i = e.getMirror(n);
      this.appendMap(e._maps[n].invert(), i != null && i > n ? r - i - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new wa();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, n = 1) {
    if (this.mirror)
      return this._map(e, n, !0);
    for (let r = this.from; r < this.to; r++)
      e = this._maps[r].map(e, n);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, n = 1) {
    return this._map(e, n, !1);
  }
  /**
  @internal
  */
  _map(e, n, r) {
    let i = 0;
    for (let o = this.from; o < this.to; o++) {
      let s = this._maps[o], a = s.mapResult(e, n);
      if (a.recover != null) {
        let l = this.getMirror(o);
        if (l != null && l > o && l < this.to) {
          o = l, e = this._maps[l].recover(a.recover);
          continue;
        }
      }
      i |= a.delInfo, e = a.pos;
    }
    return r ? e : new Bm(e, i, null);
  }
}
const Qh = /* @__PURE__ */ Object.create(null);
class Bt {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return ln.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, n) {
    if (!n || !n.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = Qh[n.stepType];
    if (!r)
      throw new RangeError(`No step type ${n.stepType} defined`);
    return r.fromJSON(e, n);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, n) {
    if (e in Qh)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return Qh[e] = n, n.prototype.jsonID = e, n;
  }
}
class dt {
  /**
  @internal
  */
  constructor(e, n) {
    this.doc = e, this.failed = n;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new dt(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new dt(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, n, r, i) {
    try {
      return dt.ok(e.replace(n, r, i));
    } catch (o) {
      if (o instanceof Gc)
        return dt.fail(o.message);
      throw o;
    }
  }
}
function Lv(t, e, n) {
  let r = [];
  for (let i = 0; i < t.childCount; i++) {
    let o = t.child(i);
    o.content.size && (o = o.copy(Lv(o.content, e, o))), o.isInline && (o = e(o, n, i)), r.push(o);
  }
  return U.fromArray(r);
}
class oi extends Bt {
  /**
  Create a mark step.
  */
  constructor(e, n, r) {
    super(), this.from = e, this.to = n, this.mark = r;
  }
  apply(e) {
    let n = e.slice(this.from, this.to), r = e.resolve(this.from), i = r.node(r.sharedDepth(this.to)), o = new ee(Lv(n.content, (s, a) => !s.isAtom || !a.type.allowsMarkType(this.mark.type) ? s : s.mark(this.mark.addToSet(s.marks)), i), n.openStart, n.openEnd);
    return dt.fromReplace(e, this.from, this.to, o);
  }
  invert() {
    return new or(this.from, this.to, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new oi(n.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof oi && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new oi(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new oi(n.from, n.to, e.markFromJSON(n.mark));
  }
}
Bt.jsonID("addMark", oi);
class or extends Bt {
  /**
  Create a mark-removing step.
  */
  constructor(e, n, r) {
    super(), this.from = e, this.to = n, this.mark = r;
  }
  apply(e) {
    let n = e.slice(this.from, this.to), r = new ee(Lv(n.content, (i) => i.mark(this.mark.removeFromSet(i.marks)), e), n.openStart, n.openEnd);
    return dt.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new oi(this.from, this.to, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new or(n.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof or && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new or(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new or(n.from, n.to, e.markFromJSON(n.mark));
  }
}
Bt.jsonID("removeMark", or);
class si extends Bt {
  /**
  Create a node mark step.
  */
  constructor(e, n) {
    super(), this.pos = e, this.mark = n;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return dt.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.addToSet(n.marks));
    return dt.fromReplace(e, this.pos, this.pos + 1, new ee(U.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(e) {
    let n = e.nodeAt(this.pos);
    if (n) {
      let r = this.mark.addToSet(n.marks);
      if (r.length == n.marks.length) {
        for (let i = 0; i < n.marks.length; i++)
          if (!n.marks[i].isInSet(r))
            return new si(this.pos, n.marks[i]);
        return new si(this.pos, this.mark);
      }
    }
    return new ts(this.pos, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new si(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new si(n.pos, e.markFromJSON(n.mark));
  }
}
Bt.jsonID("addNodeMark", si);
class ts extends Bt {
  /**
  Create a mark-removing step.
  */
  constructor(e, n) {
    super(), this.pos = e, this.mark = n;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return dt.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.removeFromSet(n.marks));
    return dt.fromReplace(e, this.pos, this.pos + 1, new ee(U.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(e) {
    let n = e.nodeAt(this.pos);
    return !n || !this.mark.isInSet(n.marks) ? this : new si(this.pos, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new ts(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new ts(n.pos, e.markFromJSON(n.mark));
  }
}
Bt.jsonID("removeNodeMark", ts);
class ht extends Bt {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, n, r, i = !1) {
    super(), this.from = e, this.to = n, this.slice = r, this.structure = i;
  }
  apply(e) {
    return this.structure && Vm(e, this.from, this.to) ? dt.fail("Structure replace would overwrite content") : dt.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new ln([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new ht(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deletedAcross && r.deletedAcross ? null : new ht(n.pos, Math.max(n.pos, r.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof ht) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let n = this.slice.size + e.slice.size == 0 ? ee.empty : new ee(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new ht(this.from, this.to + (e.to - e.from), n, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let n = this.slice.size + e.slice.size == 0 ? ee.empty : new ee(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new ht(e.from, this.to, n, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new ht(n.from, n.to, ee.fromJSON(e, n.slice), !!n.structure);
  }
}
Bt.jsonID("replace", ht);
class pt extends Bt {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, n, r, i, o, s, a = !1) {
    super(), this.from = e, this.to = n, this.gapFrom = r, this.gapTo = i, this.slice = o, this.insert = s, this.structure = a;
  }
  apply(e) {
    if (this.structure && (Vm(e, this.from, this.gapFrom) || Vm(e, this.gapTo, this.to)))
      return dt.fail("Structure gap-replace would overwrite content");
    let n = e.slice(this.gapFrom, this.gapTo);
    if (n.openStart || n.openEnd)
      return dt.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, n.content);
    return r ? dt.fromReplace(e, this.from, this.to, r) : dt.fail("Content does not fit in gap");
  }
  getMap() {
    return new ln([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let n = this.gapTo - this.gapFrom;
    return new pt(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), i = this.from == this.gapFrom ? n.pos : e.map(this.gapFrom, -1), o = this.to == this.gapTo ? r.pos : e.map(this.gapTo, 1);
    return n.deletedAcross && r.deletedAcross || i < n.pos || o > r.pos ? null : new pt(n.pos, r.pos, i, o, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new pt(n.from, n.to, n.gapFrom, n.gapTo, ee.fromJSON(e, n.slice), n.insert, !!n.structure);
  }
}
Bt.jsonID("replaceAround", pt);
function Vm(t, e, n) {
  let r = t.resolve(e), i = n - e, o = r.depth;
  for (; i > 0 && o > 0 && r.indexAfter(o) == r.node(o).childCount; )
    o--, i--;
  if (i > 0) {
    let s = r.node(o).maybeChild(r.indexAfter(o));
    for (; i > 0; ) {
      if (!s || s.isLeaf)
        return !0;
      s = s.firstChild, i--;
    }
  }
  return !1;
}
function qU(t, e, n, r) {
  let i = [], o = [], s, a;
  t.doc.nodesBetween(e, n, (l, c, u) => {
    if (!l.isInline)
      return;
    let d = l.marks;
    if (!r.isInSet(d) && u.type.allowsMarkType(r.type)) {
      let f = Math.max(c, e), h = Math.min(c + l.nodeSize, n), p = r.addToSet(d);
      for (let m = 0; m < d.length; m++)
        d[m].isInSet(p) || (s && s.to == f && s.mark.eq(d[m]) ? s.to = h : i.push(s = new or(f, h, d[m])));
      a && a.to == f ? a.to = h : o.push(a = new oi(f, h, r));
    }
  }), i.forEach((l) => t.step(l)), o.forEach((l) => t.step(l));
}
function KU(t, e, n, r) {
  let i = [], o = 0;
  t.doc.nodesBetween(e, n, (s, a) => {
    if (!s.isInline)
      return;
    o++;
    let l = null;
    if (r instanceof Ed) {
      let c = s.marks, u;
      for (; u = r.isInSet(c); )
        (l || (l = [])).push(u), c = u.removeFromSet(c);
    } else r ? r.isInSet(s.marks) && (l = [r]) : l = s.marks;
    if (l && l.length) {
      let c = Math.min(a + s.nodeSize, n);
      for (let u = 0; u < l.length; u++) {
        let d = l[u], f;
        for (let h = 0; h < i.length; h++) {
          let p = i[h];
          p.step == o - 1 && d.eq(i[h].style) && (f = p);
        }
        f ? (f.to = c, f.step = o) : i.push({ style: d, from: Math.max(a, e), to: c, step: o });
      }
    }
  }), i.forEach((s) => t.step(new or(s.from, s.to, s.style)));
}
function Fv(t, e, n, r = n.contentMatch, i = !0) {
  let o = t.doc.nodeAt(e), s = [], a = e + 1;
  for (let l = 0; l < o.childCount; l++) {
    let c = o.child(l), u = a + c.nodeSize, d = r.matchType(c.type);
    if (!d)
      s.push(new ht(a, u, ee.empty));
    else {
      r = d;
      for (let f = 0; f < c.marks.length; f++)
        n.allowsMarkType(c.marks[f].type) || t.step(new or(a, u, c.marks[f]));
      if (i && c.isText && n.whitespace != "pre") {
        let f, h = /\r?\n|\r/g, p;
        for (; f = h.exec(c.text); )
          p || (p = new ee(U.from(n.schema.text(" ", n.allowedMarks(c.marks))), 0, 0)), s.push(new ht(a + f.index, a + f.index + f[0].length, p));
      }
    }
    a = u;
  }
  if (!r.validEnd) {
    let l = r.fillBefore(U.empty, !0);
    t.replace(a, a, new ee(l, 0, 0));
  }
  for (let l = s.length - 1; l >= 0; l--)
    t.step(s[l]);
}
function GU(t, e, n) {
  return (e == 0 || t.canReplace(e, t.childCount)) && (n == t.childCount || t.canReplace(0, n));
}
function bo(t) {
  let n = t.parent.content.cutByIndex(t.startIndex, t.endIndex);
  for (let r = t.depth; ; --r) {
    let i = t.$from.node(r), o = t.$from.index(r), s = t.$to.indexAfter(r);
    if (r < t.depth && i.canReplace(o, s, n))
      return r;
    if (r == 0 || i.type.spec.isolating || !GU(i, o, s))
      break;
  }
  return null;
}
function YU(t, e, n) {
  let { $from: r, $to: i, depth: o } = e, s = r.before(o + 1), a = i.after(o + 1), l = s, c = a, u = U.empty, d = 0;
  for (let p = o, m = !1; p > n; p--)
    m || r.index(p) > 0 ? (m = !0, u = U.from(r.node(p).copy(u)), d++) : l--;
  let f = U.empty, h = 0;
  for (let p = o, m = !1; p > n; p--)
    m || i.after(p + 1) < i.end(p) ? (m = !0, f = U.from(i.node(p).copy(f)), h++) : c++;
  t.step(new pt(l, c, s, a, new ee(u.append(f), d, h), u.size - d, !0));
}
function $v(t, e, n = null, r = t) {
  let i = ZU(t, e), o = i && JU(r, e);
  return o ? i.map(zx).concat({ type: e, attrs: n }).concat(o.map(zx)) : null;
}
function zx(t) {
  return { type: t, attrs: null };
}
function ZU(t, e) {
  let { parent: n, startIndex: r, endIndex: i } = t, o = n.contentMatchAt(r).findWrapping(e);
  if (!o)
    return null;
  let s = o.length ? o[0] : e;
  return n.canReplaceWith(r, i, s) ? o : null;
}
function JU(t, e) {
  let { parent: n, startIndex: r, endIndex: i } = t, o = n.child(r), s = e.contentMatch.findWrapping(o.type);
  if (!s)
    return null;
  let l = (s.length ? s[s.length - 1] : e).contentMatch;
  for (let c = r; l && c < i; c++)
    l = l.matchType(n.child(c).type);
  return !l || !l.validEnd ? null : s;
}
function XU(t, e, n) {
  let r = U.empty;
  for (let s = n.length - 1; s >= 0; s--) {
    if (r.size) {
      let a = n[s].type.contentMatch.matchFragment(r);
      if (!a || !a.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = U.from(n[s].type.create(n[s].attrs, r));
  }
  let i = e.start, o = e.end;
  t.step(new pt(i, o, i, o, new ee(r, 0, 0), n.length, !0));
}
function QU(t, e, n, r, i) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let o = t.steps.length;
  t.doc.nodesBetween(e, n, (s, a) => {
    let l = typeof i == "function" ? i(s) : i;
    if (s.isTextblock && !s.hasMarkup(r, l) && eq(t.doc, t.mapping.slice(o).map(a), r)) {
      let c = null;
      if (r.schema.linebreakReplacement) {
        let h = r.whitespace == "pre", p = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        h && !p ? c = !1 : !h && p && (c = !0);
      }
      c === !1 && eN(t, s, a, o), Fv(t, t.mapping.slice(o).map(a, 1), r, void 0, c === null);
      let u = t.mapping.slice(o), d = u.map(a, 1), f = u.map(a + s.nodeSize, 1);
      return t.step(new pt(d, f, d + 1, f - 1, new ee(U.from(r.create(l, null, s.marks)), 0, 0), 1, !0)), c === !0 && QA(t, s, a, o), !1;
    }
  });
}
function QA(t, e, n, r) {
  e.forEach((i, o) => {
    if (i.isText) {
      let s, a = /\r?\n|\r/g;
      for (; s = a.exec(i.text); ) {
        let l = t.mapping.slice(r).map(n + 1 + o + s.index);
        t.replaceWith(l, l + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function eN(t, e, n, r) {
  e.forEach((i, o) => {
    if (i.type == i.type.schema.linebreakReplacement) {
      let s = t.mapping.slice(r).map(n + 1 + o);
      t.replaceWith(s, s + 1, e.type.schema.text(`
`));
    }
  });
}
function eq(t, e, n) {
  let r = t.resolve(e), i = r.index();
  return r.parent.canReplaceWith(i, i + 1, n);
}
function tq(t, e, n, r, i) {
  let o = t.doc.nodeAt(e);
  if (!o)
    throw new RangeError("No node at given position");
  n || (n = o.type);
  let s = n.create(r, null, i || o.marks);
  if (o.isLeaf)
    return t.replaceWith(e, e + o.nodeSize, s);
  if (!n.validContent(o.content))
    throw new RangeError("Invalid content for node type " + n.name);
  t.step(new pt(e, e + o.nodeSize, e + 1, e + o.nodeSize - 1, new ee(U.from(s), 0, 0), 1, !0));
}
function pn(t, e, n = 1, r) {
  let i = t.resolve(e), o = i.depth - n, s = r && r[r.length - 1] || i.parent;
  if (o < 0 || i.parent.type.spec.isolating || !i.parent.canReplace(i.index(), i.parent.childCount) || !s.type.validContent(i.parent.content.cutByIndex(i.index(), i.parent.childCount)))
    return !1;
  for (let c = i.depth - 1, u = n - 2; c > o; c--, u--) {
    let d = i.node(c), f = i.index(c);
    if (d.type.spec.isolating)
      return !1;
    let h = d.content.cutByIndex(f, d.childCount), p = r && r[u + 1];
    p && (h = h.replaceChild(0, p.type.create(p.attrs)));
    let m = r && r[u] || d;
    if (!d.canReplace(f + 1, d.childCount) || !m.type.validContent(h))
      return !1;
  }
  let a = i.indexAfter(o), l = r && r[0];
  return i.node(o).canReplaceWith(a, a, l ? l.type : i.node(o + 1).type);
}
function nq(t, e, n = 1, r) {
  let i = t.doc.resolve(e), o = U.empty, s = U.empty;
  for (let a = i.depth, l = i.depth - n, c = n - 1; a > l; a--, c--) {
    o = U.from(i.node(a).copy(o));
    let u = r && r[c];
    s = U.from(u ? u.type.create(u.attrs, s) : i.node(a).copy(s));
  }
  t.step(new ht(e, e, new ee(o.append(s), n, n), !0));
}
function mr(t, e) {
  let n = t.resolve(e), r = n.index();
  return tN(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(r, r + 1);
}
function rq(t, e) {
  e.content.size || t.type.compatibleContent(e.type);
  let n = t.contentMatchAt(t.childCount), { linebreakReplacement: r } = t.type.schema;
  for (let i = 0; i < e.childCount; i++) {
    let o = e.child(i), s = o.type == r ? t.type.schema.nodes.text : o.type;
    if (n = n.matchType(s), !n || !t.type.allowsMarks(o.marks))
      return !1;
  }
  return n.validEnd;
}
function tN(t, e) {
  return !!(t && e && !t.isLeaf && rq(t, e));
}
function Ts(t, e, n = -1) {
  let r = t.resolve(e);
  for (let i = r.depth; ; i--) {
    let o, s, a = r.index(i);
    if (i == r.depth ? (o = r.nodeBefore, s = r.nodeAfter) : n > 0 ? (o = r.node(i + 1), a++, s = r.node(i).maybeChild(a)) : (o = r.node(i).maybeChild(a - 1), s = r.node(i + 1)), o && !o.isTextblock && tN(o, s) && r.node(i).canReplace(a, a + 1))
      return e;
    if (i == 0)
      break;
    e = n < 0 ? r.before(i) : r.after(i);
  }
}
function iq(t, e, n) {
  let r = null, { linebreakReplacement: i } = t.doc.type.schema, o = t.doc.resolve(e - n), s = o.node().type;
  if (i && s.inlineContent) {
    let u = s.whitespace == "pre", d = !!s.contentMatch.matchType(i);
    u && !d ? r = !1 : !u && d && (r = !0);
  }
  let a = t.steps.length;
  if (r === !1) {
    let u = t.doc.resolve(e + n);
    eN(t, u.node(), u.before(), a);
  }
  s.inlineContent && Fv(t, e + n - 1, s, o.node().contentMatchAt(o.index()), r == null);
  let l = t.mapping.slice(a), c = l.map(e - n);
  if (t.step(new ht(c, l.map(e + n, -1), ee.empty, !0)), r === !0) {
    let u = t.doc.resolve(c);
    QA(t, u.node(), u.before(), t.steps.length);
  }
  return t;
}
function oq(t, e, n) {
  let r = t.resolve(e);
  if (r.parent.canReplaceWith(r.index(), r.index(), n))
    return e;
  if (r.parentOffset == 0)
    for (let i = r.depth - 1; i >= 0; i--) {
      let o = r.index(i);
      if (r.node(i).canReplaceWith(o, o, n))
        return r.before(i + 1);
      if (o > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let i = r.depth - 1; i >= 0; i--) {
      let o = r.indexAfter(i);
      if (r.node(i).canReplaceWith(o, o, n))
        return r.after(i + 1);
      if (o < r.node(i).childCount)
        return null;
    }
  return null;
}
function nN(t, e, n) {
  let r = t.resolve(e);
  if (!n.content.size)
    return e;
  let i = n.content;
  for (let o = 0; o < n.openStart; o++)
    i = i.firstChild.content;
  for (let o = 1; o <= (n.openStart == 0 && n.size ? 2 : 1); o++)
    for (let s = r.depth; s >= 0; s--) {
      let a = s == r.depth ? 0 : r.pos <= (r.start(s + 1) + r.end(s + 1)) / 2 ? -1 : 1, l = r.index(s) + (a > 0 ? 1 : 0), c = r.node(s), u = !1;
      if (o == 1)
        u = c.canReplace(l, l, i);
      else {
        let d = c.contentMatchAt(l).findWrapping(i.firstChild.type);
        u = d && c.canReplaceWith(l, l, d[0]);
      }
      if (u)
        return a == 0 ? r.pos : a < 0 ? r.before(s + 1) : r.after(s + 1);
    }
  return null;
}
function Md(t, e, n = e, r = ee.empty) {
  if (e == n && !r.size)
    return null;
  let i = t.resolve(e), o = t.resolve(n);
  return rN(i, o, r) ? new ht(e, n, r) : new sq(i, o, r).fit();
}
function rN(t, e, n) {
  return !n.openStart && !n.openEnd && t.start() == e.start() && t.parent.canReplace(t.index(), e.index(), n.content);
}
class sq {
  constructor(e, n, r) {
    this.$from = e, this.$to = n, this.unplaced = r, this.frontier = [], this.placed = U.empty;
    for (let i = 0; i <= e.depth; i++) {
      let o = e.node(i);
      this.frontier.push({
        type: o.type,
        match: o.contentMatchAt(e.indexAfter(i))
      });
    }
    for (let i = e.depth; i > 0; i--)
      this.placed = U.from(e.node(i).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), n = this.placed.size - this.depth - this.$from.depth, r = this.$from, i = this.close(e < 0 ? this.$to : r.doc.resolve(e));
    if (!i)
      return null;
    let o = this.placed, s = r.depth, a = i.depth;
    for (; s && a && o.childCount == 1; )
      o = o.firstChild.content, s--, a--;
    let l = new ee(o, s, a);
    return e > -1 ? new pt(r.pos, e, this.$to.pos, this.$to.end(), l, n) : l.size || r.pos != this.$to.pos ? new ht(r.pos, i.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let n = this.unplaced.content, r = 0, i = this.unplaced.openEnd; r < e; r++) {
      let o = n.firstChild;
      if (n.childCount > 1 && (i = 0), o.type.spec.isolating && i <= r) {
        e = r;
        break;
      }
      n = o.content;
    }
    for (let n = 1; n <= 2; n++)
      for (let r = n == 1 ? e : this.unplaced.openStart; r >= 0; r--) {
        let i, o = null;
        r ? (o = ep(this.unplaced.content, r - 1).firstChild, i = o.content) : i = this.unplaced.content;
        let s = i.firstChild;
        for (let a = this.depth; a >= 0; a--) {
          let { type: l, match: c } = this.frontier[a], u, d = null;
          if (n == 1 && (s ? c.matchType(s.type) || (d = c.fillBefore(U.from(s), !1)) : o && l.compatibleContent(o.type)))
            return { sliceDepth: r, frontierDepth: a, parent: o, inject: d };
          if (n == 2 && s && (u = c.findWrapping(s.type)))
            return { sliceDepth: r, frontierDepth: a, parent: o, wrap: u };
          if (o && c.matchType(o.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: n, openEnd: r } = this.unplaced, i = ep(e, n);
    return !i.childCount || i.firstChild.isLeaf ? !1 : (this.unplaced = new ee(e, n + 1, Math.max(r, i.size + n >= e.size - r ? n + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: n, openEnd: r } = this.unplaced, i = ep(e, n);
    if (i.childCount <= 1 && n > 0) {
      let o = e.size - n <= n + i.size;
      this.unplaced = new ee(zs(e, n - 1, 1), n - 1, o ? n - 1 : r);
    } else
      this.unplaced = new ee(zs(e, n, 1), n, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: n, parent: r, inject: i, wrap: o }) {
    for (; this.depth > n; )
      this.closeFrontierNode();
    if (o)
      for (let m = 0; m < o.length; m++)
        this.openFrontierNode(o[m]);
    let s = this.unplaced, a = r ? r.content : s.content, l = s.openStart - e, c = 0, u = [], { match: d, type: f } = this.frontier[n];
    if (i) {
      for (let m = 0; m < i.childCount; m++)
        u.push(i.child(m));
      d = d.matchFragment(i);
    }
    let h = a.size + e - (s.content.size - s.openEnd);
    for (; c < a.childCount; ) {
      let m = a.child(c), b = d.matchType(m.type);
      if (!b)
        break;
      c++, (c > 1 || l == 0 || m.content.size) && (d = b, u.push(iN(m.mark(f.allowedMarks(m.marks)), c == 1 ? l : 0, c == a.childCount ? h : -1)));
    }
    let p = c == a.childCount;
    p || (h = -1), this.placed = Hs(this.placed, n, U.from(u)), this.frontier[n].match = d, p && h < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let m = 0, b = a; m < h; m++) {
      let y = b.lastChild;
      this.frontier.push({ type: y.type, match: y.contentMatchAt(y.childCount) }), b = y.content;
    }
    this.unplaced = p ? e == 0 ? ee.empty : new ee(zs(s.content, e - 1, 1), e - 1, h < 0 ? s.openEnd : e - 1) : new ee(zs(s.content, e, c), s.openStart, s.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], n;
    if (!e.type.isTextblock || !tp(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (n = this.findCloseLevel(this.$to)) && n.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, i = this.$to.after(r);
    for (; r > 1 && i == this.$to.end(--r); )
      ++i;
    return i;
  }
  findCloseLevel(e) {
    e: for (let n = Math.min(this.depth, e.depth); n >= 0; n--) {
      let { match: r, type: i } = this.frontier[n], o = n < e.depth && e.end(n + 1) == e.pos + (e.depth - (n + 1)), s = tp(e, n, i, r, o);
      if (s) {
        for (let a = n - 1; a >= 0; a--) {
          let { match: l, type: c } = this.frontier[a], u = tp(e, a, c, l, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: n, fit: s, move: o ? e.doc.resolve(e.after(n + 1)) : e };
      }
    }
  }
  close(e) {
    let n = this.findCloseLevel(e);
    if (!n)
      return null;
    for (; this.depth > n.depth; )
      this.closeFrontierNode();
    n.fit.childCount && (this.placed = Hs(this.placed, n.depth, n.fit)), e = n.move;
    for (let r = n.depth + 1; r <= e.depth; r++) {
      let i = e.node(r), o = i.type.contentMatch.fillBefore(i.content, !0, e.index(r));
      this.openFrontierNode(i.type, i.attrs, o);
    }
    return e;
  }
  openFrontierNode(e, n = null, r) {
    let i = this.frontier[this.depth];
    i.match = i.match.matchType(e), this.placed = Hs(this.placed, this.depth, U.from(e.create(n, r))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let n = this.frontier.pop().match.fillBefore(U.empty, !0);
    n.childCount && (this.placed = Hs(this.placed, this.frontier.length, n));
  }
}
function zs(t, e, n) {
  return e == 0 ? t.cutByIndex(n, t.childCount) : t.replaceChild(0, t.firstChild.copy(zs(t.firstChild.content, e - 1, n)));
}
function Hs(t, e, n) {
  return e == 0 ? t.append(n) : t.replaceChild(t.childCount - 1, t.lastChild.copy(Hs(t.lastChild.content, e - 1, n)));
}
function ep(t, e) {
  for (let n = 0; n < e; n++)
    t = t.firstChild.content;
  return t;
}
function iN(t, e, n) {
  if (e <= 0)
    return t;
  let r = t.content;
  return e > 1 && (r = r.replaceChild(0, iN(r.firstChild, e - 1, r.childCount == 1 ? n - 1 : 0))), e > 0 && (r = t.type.contentMatch.fillBefore(r).append(r), n <= 0 && (r = r.append(t.type.contentMatch.matchFragment(r).fillBefore(U.empty, !0)))), t.copy(r);
}
function tp(t, e, n, r, i) {
  let o = t.node(e), s = i ? t.indexAfter(e) : t.index(e);
  if (s == o.childCount && !n.compatibleContent(o.type))
    return null;
  let a = r.fillBefore(o.content, !0, s);
  return a && !aq(n, o.content, s) ? a : null;
}
function aq(t, e, n) {
  for (let r = n; r < e.childCount; r++)
    if (!t.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
function lq(t) {
  return t.spec.defining || t.spec.definingForContent;
}
function cq(t, e, n, r) {
  if (!r.size)
    return t.deleteRange(e, n);
  let i = t.doc.resolve(e), o = t.doc.resolve(n);
  if (rN(i, o, r))
    return t.step(new ht(e, n, r));
  let s = sN(i, t.doc.resolve(n));
  s[s.length - 1] == 0 && s.pop();
  let a = -(i.depth + 1);
  s.unshift(a);
  for (let f = i.depth, h = i.pos - 1; f > 0; f--, h--) {
    let p = i.node(f).type.spec;
    if (p.defining || p.definingAsContext || p.isolating)
      break;
    s.indexOf(f) > -1 ? a = f : i.before(f) == h && s.splice(1, 0, -f);
  }
  let l = s.indexOf(a), c = [], u = r.openStart;
  for (let f = r.content, h = 0; ; h++) {
    let p = f.firstChild;
    if (c.push(p), h == r.openStart)
      break;
    f = p.content;
  }
  for (let f = u - 1; f >= 0; f--) {
    let h = c[f], p = lq(h.type);
    if (p && !h.sameMarkup(i.node(Math.abs(a) - 1)))
      u = f;
    else if (p || !h.type.isTextblock)
      break;
  }
  for (let f = r.openStart; f >= 0; f--) {
    let h = (f + u + 1) % (r.openStart + 1), p = c[h];
    if (p)
      for (let m = 0; m < s.length; m++) {
        let b = s[(m + l) % s.length], y = !0;
        b < 0 && (y = !1, b = -b);
        let k = i.node(b - 1), C = i.index(b - 1);
        if (k.canReplaceWith(C, C, p.type, p.marks))
          return t.replace(i.before(b), y ? o.after(b) : n, new ee(oN(r.content, 0, r.openStart, h), h, r.openEnd));
      }
  }
  let d = t.steps.length;
  for (let f = s.length - 1; f >= 0 && (t.replace(e, n, r), !(t.steps.length > d)); f--) {
    let h = s[f];
    h < 0 || (e = i.before(h), n = o.after(h));
  }
}
function oN(t, e, n, r, i) {
  if (e < n) {
    let o = t.firstChild;
    t = t.replaceChild(0, o.copy(oN(o.content, e + 1, n, r, o)));
  }
  if (e > r) {
    let o = i.contentMatchAt(0), s = o.fillBefore(t).append(t);
    t = s.append(o.matchFragment(s).fillBefore(U.empty, !0));
  }
  return t;
}
function uq(t, e, n, r) {
  if (!r.isInline && e == n && t.doc.resolve(e).parent.content.size) {
    let i = oq(t.doc, e, r.type);
    i != null && (e = n = i);
  }
  t.replaceRange(e, n, new ee(U.from(r), 0, 0));
}
function dq(t, e, n) {
  let r = t.doc.resolve(e), i = t.doc.resolve(n), o = sN(r, i);
  for (let s = 0; s < o.length; s++) {
    let a = o[s], l = s == o.length - 1;
    if (l && a == 0 || r.node(a).type.contentMatch.validEnd)
      return t.delete(r.start(a), i.end(a));
    if (a > 0 && (l || r.node(a - 1).canReplace(r.index(a - 1), i.indexAfter(a - 1))))
      return t.delete(r.before(a), i.after(a));
  }
  for (let s = 1; s <= r.depth && s <= i.depth; s++)
    if (e - r.start(s) == r.depth - s && n > r.end(s) && i.end(s) - n != i.depth - s && r.start(s - 1) == i.start(s - 1) && r.node(s - 1).canReplace(r.index(s - 1), i.index(s - 1)))
      return t.delete(r.before(s), n);
  t.delete(e, n);
}
function sN(t, e) {
  let n = [], r = Math.min(t.depth, e.depth);
  for (let i = r; i >= 0; i--) {
    let o = t.start(i);
    if (o < t.pos - (t.depth - i) || e.end(i) > e.pos + (e.depth - i) || t.node(i).type.spec.isolating || e.node(i).type.spec.isolating)
      break;
    (o == e.start(i) || i == t.depth && i == e.depth && t.parent.inlineContent && e.parent.inlineContent && i && e.start(i - 1) == o - 1) && n.push(i);
  }
  return n;
}
class qo extends Bt {
  /**
  Construct an attribute step.
  */
  constructor(e, n, r) {
    super(), this.pos = e, this.attr = n, this.value = r;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return dt.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let o in n.attrs)
      r[o] = n.attrs[o];
    r[this.attr] = this.value;
    let i = n.type.create(r, null, n.marks);
    return dt.fromReplace(e, this.pos, this.pos + 1, new ee(U.from(i), 0, n.isLeaf ? 0 : 1));
  }
  getMap() {
    return ln.empty;
  }
  invert(e) {
    return new qo(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new qo(n.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, n) {
    if (typeof n.pos != "number" || typeof n.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new qo(n.pos, n.attr, n.value);
  }
}
Bt.jsonID("attr", qo);
class xa extends Bt {
  /**
  Construct an attribute step.
  */
  constructor(e, n) {
    super(), this.attr = e, this.value = n;
  }
  apply(e) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let i in e.attrs)
      n[i] = e.attrs[i];
    n[this.attr] = this.value;
    let r = e.type.create(n, e.content, e.marks);
    return dt.ok(r);
  }
  getMap() {
    return ln.empty;
  }
  invert(e) {
    return new xa(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, n) {
    if (typeof n.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new xa(n.attr, n.value);
  }
}
Bt.jsonID("docAttr", xa);
let ns = class extends Error {
};
ns = function t(e) {
  let n = Error.call(this, e);
  return n.__proto__ = t.prototype, n;
};
ns.prototype = Object.create(Error.prototype);
ns.prototype.constructor = ns;
ns.prototype.name = "TransformError";
class Bv {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new wa();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let n = this.maybeStep(e);
    if (n.failed)
      throw new ns(n.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let n = e.apply(this.doc);
    return n.failed || this.addStep(e, n.doc), n;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, n) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = n;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, n = e, r = ee.empty) {
    let i = Md(this.doc, e, n, r);
    return i && this.step(i), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, n, r) {
    return this.replace(e, n, new ee(U.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, n) {
    return this.replace(e, n, ee.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, n) {
    return this.replaceWith(e, e, n);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, n, r) {
    return cq(this, e, n, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, n, r) {
    return uq(this, e, n, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, n) {
    return dq(this, e, n), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, n) {
    return YU(this, e, n), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, n = 1) {
    return iq(this, e, n), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, n) {
    return XU(this, e, n), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, n = e, r, i = null) {
    return QU(this, e, n, r, i), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, n, r = null, i) {
    return tq(this, e, n, r, i), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, n, r) {
    return this.step(new qo(e, n, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, n) {
    return this.step(new xa(e, n)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, n) {
    return this.step(new si(e, n)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, n) {
    if (!(n instanceof Ye)) {
      let r = this.doc.nodeAt(e);
      if (!r)
        throw new RangeError("No node at position " + e);
      if (n = n.isInSet(r.marks), !n)
        return this;
    }
    return this.step(new ts(e, n)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, n = 1, r) {
    return nq(this, e, n, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, n, r) {
    return qU(this, e, n, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, n, r) {
    return KU(this, e, n, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, n, r) {
    return Fv(this, e, n, r), this;
  }
}
const np = /* @__PURE__ */ Object.create(null);
class be {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, n, r) {
    this.$anchor = e, this.$head = n, this.ranges = r || [new aN(e.min(n), e.max(n))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let n = 0; n < e.length; n++)
      if (e[n].$from.pos != e[n].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, n = ee.empty) {
    let r = n.content.lastChild, i = null;
    for (let a = 0; a < n.openEnd; a++)
      i = r, r = r.lastChild;
    let o = e.steps.length, s = this.ranges;
    for (let a = 0; a < s.length; a++) {
      let { $from: l, $to: c } = s[a], u = e.mapping.slice(o);
      e.replaceRange(u.map(l.pos), u.map(c.pos), a ? ee.empty : n), a == 0 && jx(e, o, (r ? r.isInline : i && i.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, n) {
    let r = e.steps.length, i = this.ranges;
    for (let o = 0; o < i.length; o++) {
      let { $from: s, $to: a } = i[o], l = e.mapping.slice(r), c = l.map(s.pos), u = l.map(a.pos);
      o ? e.deleteRange(c, u) : (e.replaceRangeWith(c, u, n), jx(e, r, n.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, n, r = !1) {
    let i = e.parent.inlineContent ? new ge(e) : Io(e.node(0), e.parent, e.pos, e.index(), n, r);
    if (i)
      return i;
    for (let o = e.depth - 1; o >= 0; o--) {
      let s = n < 0 ? Io(e.node(0), e.node(o), e.before(o + 1), e.index(o), n, r) : Io(e.node(0), e.node(o), e.after(o + 1), e.index(o) + 1, n, r);
      if (s)
        return s;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, n = 1) {
    return this.findFrom(e, n) || this.findFrom(e, -n) || new en(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return Io(e, e, 0, 0, 1) || new en(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return Io(e, e, e.content.size, e.childCount, -1) || new en(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, n) {
    if (!n || !n.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = np[n.type];
    if (!r)
      throw new RangeError(`No selection type ${n.type} defined`);
    return r.fromJSON(e, n);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, n) {
    if (e in np)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return np[e] = n, n.prototype.jsonID = e, n;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return ge.between(this.$anchor, this.$head).getBookmark();
  }
}
be.prototype.visible = !0;
class aN {
  /**
  Create a range.
  */
  constructor(e, n) {
    this.$from = e, this.$to = n;
  }
}
let Hx = !1;
function Wx(t) {
  !Hx && !t.parent.inlineContent && (Hx = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + t.parent.type.name + ")"));
}
let ge = class Ws extends be {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, n = e) {
    Wx(e), Wx(n), super(e, n);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, n) {
    let r = e.resolve(n.map(this.head));
    if (!r.parent.inlineContent)
      return be.near(r);
    let i = e.resolve(n.map(this.anchor));
    return new Ws(i.parent.inlineContent ? i : r, r);
  }
  replace(e, n = ee.empty) {
    if (super.replace(e, n), n == ee.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && e.ensureMarks(r);
    }
  }
  eq(e) {
    return e instanceof Ws && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new Od(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.anchor != "number" || typeof n.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Ws(e.resolve(n.anchor), e.resolve(n.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, n, r = n) {
    let i = e.resolve(n);
    return new this(i, r == n ? i : e.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, n, r) {
    let i = e.pos - n.pos;
    if ((!r || i) && (r = i >= 0 ? 1 : -1), !n.parent.inlineContent) {
      let o = be.findFrom(n, r, !0) || be.findFrom(n, -r, !0);
      if (o)
        n = o.$head;
      else
        return be.near(n, r);
    }
    return e.parent.inlineContent || (i == 0 ? e = n : (e = (be.findFrom(e, -r, !0) || be.findFrom(e, r, !0)).$anchor, e.pos < n.pos != i < 0 && (e = n))), new Ws(e, n);
  }
};
be.jsonID("text", ge);
class Od {
  constructor(e, n) {
    this.anchor = e, this.head = n;
  }
  map(e) {
    return new Od(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return ge.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class ye extends be {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let n = e.nodeAfter, r = e.node(0).resolve(e.pos + n.nodeSize);
    super(e, r), this.node = n;
  }
  map(e, n) {
    let { deleted: r, pos: i } = n.mapResult(this.anchor), o = e.resolve(i);
    return r ? be.near(o) : new ye(o);
  }
  content() {
    return new ee(U.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof ye && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new Vv(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new ye(e.resolve(n.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, n) {
    return new ye(e.resolve(n));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
ye.prototype.visible = !1;
be.jsonID("node", ye);
class Vv {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: n, pos: r } = e.mapResult(this.anchor);
    return n ? new Od(r, r) : new Vv(r);
  }
  resolve(e) {
    let n = e.resolve(this.anchor), r = n.nodeAfter;
    return r && ye.isSelectable(r) ? new ye(n) : be.near(n);
  }
}
class en extends be {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, n = ee.empty) {
    if (n == ee.empty) {
      e.delete(0, e.doc.content.size);
      let r = be.atStart(e.doc);
      r.eq(e.selection) || e.setSelection(r);
    } else
      super.replace(e, n);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new en(e);
  }
  map(e) {
    return new en(e);
  }
  eq(e) {
    return e instanceof en;
  }
  getBookmark() {
    return fq;
  }
}
be.jsonID("all", en);
const fq = {
  map() {
    return this;
  },
  resolve(t) {
    return new en(t);
  }
};
function Io(t, e, n, r, i, o = !1) {
  if (e.inlineContent)
    return ge.create(t, n);
  for (let s = r - (i > 0 ? 0 : 1); i > 0 ? s < e.childCount : s >= 0; s += i) {
    let a = e.child(s);
    if (a.isAtom) {
      if (!o && ye.isSelectable(a))
        return ye.create(t, n - (i < 0 ? a.nodeSize : 0));
    } else {
      let l = Io(t, a, n + i, i < 0 ? a.childCount : 0, i, o);
      if (l)
        return l;
    }
    n += a.nodeSize * i;
  }
  return null;
}
function jx(t, e, n) {
  let r = t.steps.length - 1;
  if (r < e)
    return;
  let i = t.steps[r];
  if (!(i instanceof ht || i instanceof pt))
    return;
  let o = t.mapping.maps[r], s;
  o.forEach((a, l, c, u) => {
    s == null && (s = u);
  }), t.setSelection(be.near(t.doc.resolve(s), n));
}
const Ux = 1, qx = 2, Kx = 4;
class hq extends Bv {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | Ux) & -3, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & Ux) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= qx, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return Ye.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & qx) > 0;
  }
  /**
  @internal
  */
  addStep(e, n) {
    super.addStep(e, n), this.updated = this.updated & -3, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, n = !0) {
    let r = this.selection;
    return n && (e = e.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || Ye.none))), r.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, n, r) {
    let i = this.doc.type.schema;
    if (n == null)
      return e ? this.replaceSelectionWith(i.text(e), !0) : this.deleteSelection();
    {
      if (r == null && (r = n), r = r ?? n, !e)
        return this.deleteRange(n, r);
      let o = this.storedMarks;
      if (!o) {
        let s = this.doc.resolve(n);
        o = r == n ? s.marks() : s.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(n, r, i.text(e, o)), this.selection.empty || this.setSelection(be.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, n) {
    return this.meta[typeof e == "string" ? e : e.key] = n, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= Kx, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & Kx) > 0;
  }
}
function Gx(t, e) {
  return !e || !t ? t : t.bind(e);
}
class js {
  constructor(e, n, r) {
    this.name = e, this.init = Gx(n.init, r), this.apply = Gx(n.apply, r);
  }
}
const pq = [
  new js("doc", {
    init(t) {
      return t.doc || t.schema.topNodeType.createAndFill();
    },
    apply(t) {
      return t.doc;
    }
  }),
  new js("selection", {
    init(t, e) {
      return t.selection || be.atStart(e.doc);
    },
    apply(t) {
      return t.selection;
    }
  }),
  new js("storedMarks", {
    init(t) {
      return t.storedMarks || null;
    },
    apply(t, e, n, r) {
      return r.selection.$cursor ? t.storedMarks : null;
    }
  }),
  new js("scrollToSelection", {
    init() {
      return 0;
    },
    apply(t, e) {
      return t.scrolledIntoView ? e + 1 : e;
    }
  })
];
class rp {
  constructor(e, n) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = pq.slice(), n && n.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new js(r.key, r.spec.state, r));
    });
  }
}
class Bo {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, n = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != n) {
        let i = this.config.plugins[r];
        if (i.spec.filterTransaction && !i.spec.filterTransaction.call(i, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let n = [e], r = this.applyInner(e), i = null;
    for (; ; ) {
      let o = !1;
      for (let s = 0; s < this.config.plugins.length; s++) {
        let a = this.config.plugins[s];
        if (a.spec.appendTransaction) {
          let l = i ? i[s].n : 0, c = i ? i[s].state : this, u = l < n.length && a.spec.appendTransaction.call(a, l ? n.slice(l) : n, c, r);
          if (u && r.filterTransaction(u, s)) {
            if (u.setMeta("appendedTransaction", e), !i) {
              i = [];
              for (let d = 0; d < this.config.plugins.length; d++)
                i.push(d < s ? { state: r, n: n.length } : { state: this, n: 0 });
            }
            n.push(u), r = r.applyInner(u), o = !0;
          }
          i && (i[s] = { state: r, n: n.length });
        }
      }
      if (!o)
        return { state: r, transactions: n };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let n = new Bo(this.config), r = this.config.fields;
    for (let i = 0; i < r.length; i++) {
      let o = r[i];
      n[o.name] = o.apply(e, this[o.name], this, n);
    }
    return n;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new hq(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let n = new rp(e.doc ? e.doc.type.schema : e.schema, e.plugins), r = new Bo(n);
    for (let i = 0; i < n.fields.length; i++)
      r[n.fields[i].name] = n.fields[i].init(e, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let n = new rp(this.schema, e.plugins), r = n.fields, i = new Bo(n);
    for (let o = 0; o < r.length; o++) {
      let s = r[o].name;
      i[s] = this.hasOwnProperty(s) ? this[s] : r[o].init(e, i);
    }
    return i;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let n = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (n.storedMarks = this.storedMarks.map((r) => r.toJSON())), e && typeof e == "object")
      for (let r in e) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let i = e[r], o = i.spec.state;
        o && o.toJSON && (n[r] = o.toJSON.call(i, this[i.key]));
      }
    return n;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, n, r) {
    if (!n)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let i = new rp(e.schema, e.plugins), o = new Bo(i);
    return i.fields.forEach((s) => {
      if (s.name == "doc")
        o.doc = Ir.fromJSON(e.schema, n.doc);
      else if (s.name == "selection")
        o.selection = be.fromJSON(o.doc, n.selection);
      else if (s.name == "storedMarks")
        n.storedMarks && (o.storedMarks = n.storedMarks.map(e.schema.markFromJSON));
      else {
        if (r)
          for (let a in r) {
            let l = r[a], c = l.spec.state;
            if (l.key == s.name && c && c.fromJSON && Object.prototype.hasOwnProperty.call(n, a)) {
              o[s.name] = c.fromJSON.call(l, e, n[a], o);
              return;
            }
          }
        o[s.name] = s.init(e, o);
      }
    }), o;
  }
}
function lN(t, e, n) {
  for (let r in t) {
    let i = t[r];
    i instanceof Function ? i = i.bind(e) : r == "handleDOMEvents" && (i = lN(i, e, {})), n[r] = i;
  }
  return n;
}
class Ge {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && lN(e.props, this, this.props), this.key = e.key ? e.key.key : cN("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const ip = /* @__PURE__ */ Object.create(null);
function cN(t) {
  return t in ip ? t + "$" + ++ip[t] : (ip[t] = 0, t + "$");
}
class tt {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = cN(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const St = function(t) {
  for (var e = 0; ; e++)
    if (t = t.previousSibling, !t)
      return e;
}, rs = function(t) {
  let e = t.assignedSlot || t.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let zm = null;
const Or = function(t, e, n) {
  let r = zm || (zm = document.createRange());
  return r.setEnd(t, n ?? t.nodeValue.length), r.setStart(t, e || 0), r;
}, mq = function() {
  zm = null;
}, oo = function(t, e, n, r) {
  return n && (Yx(t, e, n, r, -1) || Yx(t, e, n, r, 1));
}, gq = /^(img|br|input|textarea|hr)$/i;
function Yx(t, e, n, r, i) {
  for (; ; ) {
    if (t == n && e == r)
      return !0;
    if (e == (i < 0 ? 0 : Tn(t))) {
      let o = t.parentNode;
      if (!o || o.nodeType != 1 || rl(t) || gq.test(t.nodeName) || t.contentEditable == "false")
        return !1;
      e = St(t) + (i < 0 ? 0 : 1), t = o;
    } else if (t.nodeType == 1) {
      if (t = t.childNodes[e + (i < 0 ? -1 : 0)], t.contentEditable == "false")
        return !1;
      e = i < 0 ? Tn(t) : 0;
    } else
      return !1;
  }
}
function Tn(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function vq(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e)
      return t;
    if (t.nodeType == 1 && e > 0) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e - 1], e = Tn(t);
    } else if (t.parentNode && !rl(t))
      e = St(t), t = t.parentNode;
    else
      return null;
  }
}
function bq(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e < t.nodeValue.length)
      return t;
    if (t.nodeType == 1 && e < t.childNodes.length) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e], e = 0;
    } else if (t.parentNode && !rl(t))
      e = St(t) + 1, t = t.parentNode;
    else
      return null;
  }
}
function yq(t, e, n) {
  for (let r = e == 0, i = e == Tn(t); r || i; ) {
    if (t == n)
      return !0;
    let o = St(t);
    if (t = t.parentNode, !t)
      return !1;
    r = r && o == 0, i = i && o == Tn(t);
  }
}
function rl(t) {
  let e;
  for (let n = t; n && !(e = n.pmViewDesc); n = n.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == t || e.contentDOM == t);
}
const Ad = function(t) {
  return t.focusNode && oo(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset);
};
function Bi(t, e) {
  let n = document.createEvent("Event");
  return n.initEvent("keydown", !0, !0), n.keyCode = t, n.key = n.code = e, n;
}
function wq(t) {
  let e = t.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function xq(t, e, n) {
  if (t.caretPositionFromPoint)
    try {
      let r = t.caretPositionFromPoint(e, n);
      if (r)
        return { node: r.offsetNode, offset: Math.min(Tn(r.offsetNode), r.offset) };
    } catch {
    }
  if (t.caretRangeFromPoint) {
    let r = t.caretRangeFromPoint(e, n);
    if (r)
      return { node: r.startContainer, offset: Math.min(Tn(r.startContainer), r.startOffset) };
  }
}
const dr = typeof navigator < "u" ? navigator : null, Zx = typeof document < "u" ? document : null, Oi = dr && dr.userAgent || "", Hm = /Edge\/(\d+)/.exec(Oi), uN = /MSIE \d/.exec(Oi), Wm = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Oi), tn = !!(uN || Wm || Hm), di = uN ? document.documentMode : Wm ? +Wm[1] : Hm ? +Hm[1] : 0, Gn = !tn && /gecko\/(\d+)/i.test(Oi);
Gn && +(/Firefox\/(\d+)/.exec(Oi) || [0, 0])[1];
const jm = !tn && /Chrome\/(\d+)/.exec(Oi), It = !!jm, dN = jm ? +jm[1] : 0, Kt = !tn && !!dr && /Apple Computer/.test(dr.vendor), is = Kt && (/Mobile\/\w+/.test(Oi) || !!dr && dr.maxTouchPoints > 2), Cn = is || (dr ? /Mac/.test(dr.platform) : !1), kq = dr ? /Win/.test(dr.platform) : !1, Rr = /Android \d/.test(Oi), il = !!Zx && "webkitFontSmoothing" in Zx.documentElement.style, Cq = il ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function Sq(t) {
  let e = t.defaultView && t.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: t.documentElement.clientWidth,
    top: 0,
    bottom: t.documentElement.clientHeight
  };
}
function kr(t, e) {
  return typeof t == "number" ? t : t[e];
}
function Tq(t) {
  let e = t.getBoundingClientRect(), n = e.width / t.offsetWidth || 1, r = e.height / t.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + t.clientWidth * n,
    top: e.top,
    bottom: e.top + t.clientHeight * r
  };
}
function Jx(t, e, n) {
  let r = t.someProp("scrollThreshold") || 0, i = t.someProp("scrollMargin") || 5, o = t.dom.ownerDocument;
  for (let s = n || t.dom; s; ) {
    if (s.nodeType != 1) {
      s = rs(s);
      continue;
    }
    let a = s, l = a == o.body, c = l ? Sq(o) : Tq(a), u = 0, d = 0;
    if (e.top < c.top + kr(r, "top") ? d = -(c.top - e.top + kr(i, "top")) : e.bottom > c.bottom - kr(r, "bottom") && (d = e.bottom - e.top > c.bottom - c.top ? e.top + kr(i, "top") - c.top : e.bottom - c.bottom + kr(i, "bottom")), e.left < c.left + kr(r, "left") ? u = -(c.left - e.left + kr(i, "left")) : e.right > c.right - kr(r, "right") && (u = e.right - c.right + kr(i, "right")), u || d)
      if (l)
        o.defaultView.scrollBy(u, d);
      else {
        let h = a.scrollLeft, p = a.scrollTop;
        d && (a.scrollTop += d), u && (a.scrollLeft += u);
        let m = a.scrollLeft - h, b = a.scrollTop - p;
        e = { left: e.left - m, top: e.top - b, right: e.right - m, bottom: e.bottom - b };
      }
    let f = l ? "fixed" : getComputedStyle(s).position;
    if (/^(fixed|sticky)$/.test(f))
      break;
    s = f == "absolute" ? s.offsetParent : rs(s);
  }
}
function Eq(t) {
  let e = t.dom.getBoundingClientRect(), n = Math.max(0, e.top), r, i;
  for (let o = (e.left + e.right) / 2, s = n + 1; s < Math.min(innerHeight, e.bottom); s += 5) {
    let a = t.root.elementFromPoint(o, s);
    if (!a || a == t.dom || !t.dom.contains(a))
      continue;
    let l = a.getBoundingClientRect();
    if (l.top >= n - 20) {
      r = a, i = l.top;
      break;
    }
  }
  return { refDOM: r, refTop: i, stack: fN(t.dom) };
}
function fN(t) {
  let e = [], n = t.ownerDocument;
  for (let r = t; r && (e.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), t != n); r = rs(r))
    ;
  return e;
}
function Mq({ refDOM: t, refTop: e, stack: n }) {
  let r = t ? t.getBoundingClientRect().top : 0;
  hN(n, r == 0 ? 0 : r - e);
}
function hN(t, e) {
  for (let n = 0; n < t.length; n++) {
    let { dom: r, top: i, left: o } = t[n];
    r.scrollTop != i + e && (r.scrollTop = i + e), r.scrollLeft != o && (r.scrollLeft = o);
  }
}
let No = null;
function Oq(t) {
  if (t.setActive)
    return t.setActive();
  if (No)
    return t.focus(No);
  let e = fN(t);
  t.focus(No == null ? {
    get preventScroll() {
      return No = { preventScroll: !0 }, !0;
    }
  } : void 0), No || (No = !1, hN(e, 0));
}
function pN(t, e) {
  let n, r = 2e8, i, o = 0, s = e.top, a = e.top, l, c;
  for (let u = t.firstChild, d = 0; u; u = u.nextSibling, d++) {
    let f;
    if (u.nodeType == 1)
      f = u.getClientRects();
    else if (u.nodeType == 3)
      f = Or(u).getClientRects();
    else
      continue;
    for (let h = 0; h < f.length; h++) {
      let p = f[h];
      if (p.top <= s && p.bottom >= a) {
        s = Math.max(p.bottom, s), a = Math.min(p.top, a);
        let m = p.left > e.left ? p.left - e.left : p.right < e.left ? e.left - p.right : 0;
        if (m < r) {
          n = u, r = m, i = m && n.nodeType == 3 ? {
            left: p.right < e.left ? p.right : p.left,
            top: e.top
          } : e, u.nodeType == 1 && m && (o = d + (e.left >= (p.left + p.right) / 2 ? 1 : 0));
          continue;
        }
      } else p.top > e.top && !l && p.left <= e.left && p.right >= e.left && (l = u, c = { left: Math.max(p.left, Math.min(p.right, e.left)), top: p.top });
      !n && (e.left >= p.right && e.top >= p.top || e.left >= p.left && e.top >= p.bottom) && (o = d + 1);
    }
  }
  return !n && l && (n = l, i = c, r = 0), n && n.nodeType == 3 ? Aq(n, i) : !n || r && n.nodeType == 1 ? { node: t, offset: o } : pN(n, i);
}
function Aq(t, e) {
  let n = t.nodeValue.length, r = document.createRange();
  for (let i = 0; i < n; i++) {
    r.setEnd(t, i + 1), r.setStart(t, i);
    let o = Gr(r, 1);
    if (o.top != o.bottom && zv(e, o))
      return { node: t, offset: i + (e.left >= (o.left + o.right) / 2 ? 1 : 0) };
  }
  return { node: t, offset: 0 };
}
function zv(t, e) {
  return t.left >= e.left - 1 && t.left <= e.right + 1 && t.top >= e.top - 1 && t.top <= e.bottom + 1;
}
function Nq(t, e) {
  let n = t.parentNode;
  return n && /^li$/i.test(n.nodeName) && e.left < t.getBoundingClientRect().left ? n : t;
}
function Rq(t, e, n) {
  let { node: r, offset: i } = pN(e, n), o = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let s = r.getBoundingClientRect();
    o = s.left != s.right && n.left > (s.left + s.right) / 2 ? 1 : -1;
  }
  return t.docView.posFromDOM(r, i, o);
}
function Dq(t, e, n, r) {
  let i = -1;
  for (let o = e, s = !1; o != t.dom; ) {
    let a = t.docView.nearestDesc(o, !0), l;
    if (!a)
      return null;
    if (a.dom.nodeType == 1 && (a.node.isBlock && a.parent || !a.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((l = a.dom.getBoundingClientRect()).width || l.height) && (a.node.isBlock && a.parent && (!s && l.left > r.left || l.top > r.top ? i = a.posBefore : (!s && l.right < r.left || l.bottom < r.top) && (i = a.posAfter), s = !0), !a.contentDOM && i < 0 && !a.node.isText))
      return (a.node.isBlock ? r.top < (l.top + l.bottom) / 2 : r.left < (l.left + l.right) / 2) ? a.posBefore : a.posAfter;
    o = a.dom.parentNode;
  }
  return i > -1 ? i : t.docView.posFromDOM(e, n, -1);
}
function mN(t, e, n) {
  let r = t.childNodes.length;
  if (r && n.top < n.bottom)
    for (let i = Math.max(0, Math.min(r - 1, Math.floor(r * (e.top - n.top) / (n.bottom - n.top)) - 2)), o = i; ; ) {
      let s = t.childNodes[o];
      if (s.nodeType == 1) {
        let a = s.getClientRects();
        for (let l = 0; l < a.length; l++) {
          let c = a[l];
          if (zv(e, c))
            return mN(s, e, c);
        }
      }
      if ((o = (o + 1) % r) == i)
        break;
    }
  return t;
}
function Iq(t, e) {
  let n = t.dom.ownerDocument, r, i = 0, o = xq(n, e.left, e.top);
  o && ({ node: r, offset: i } = o);
  let s = (t.root.elementFromPoint ? t.root : n).elementFromPoint(e.left, e.top), a;
  if (!s || !t.dom.contains(s.nodeType != 1 ? s.parentNode : s)) {
    let c = t.dom.getBoundingClientRect();
    if (!zv(e, c) || (s = mN(t.dom, e, c), !s))
      return null;
  }
  if (Kt)
    for (let c = s; r && c; c = rs(c))
      c.draggable && (r = void 0);
  if (s = Nq(s, e), r) {
    if (Gn && r.nodeType == 1 && (i = Math.min(i, r.childNodes.length), i < r.childNodes.length)) {
      let u = r.childNodes[i], d;
      u.nodeName == "IMG" && (d = u.getBoundingClientRect()).right <= e.left && d.bottom > e.top && i++;
    }
    let c;
    il && i && r.nodeType == 1 && (c = r.childNodes[i - 1]).nodeType == 1 && c.contentEditable == "false" && c.getBoundingClientRect().top >= e.top && i--, r == t.dom && i == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && e.top > r.lastChild.getBoundingClientRect().bottom ? a = t.state.doc.content.size : (i == 0 || r.nodeType != 1 || r.childNodes[i - 1].nodeName != "BR") && (a = Dq(t, r, i, e));
  }
  a == null && (a = Rq(t, s, e));
  let l = t.docView.nearestDesc(s, !0);
  return { pos: a, inside: l ? l.posAtStart - l.border : -1 };
}
function Xx(t) {
  return t.top < t.bottom || t.left < t.right;
}
function Gr(t, e) {
  let n = t.getClientRects();
  if (n.length) {
    let r = n[e < 0 ? 0 : n.length - 1];
    if (Xx(r))
      return r;
  }
  return Array.prototype.find.call(n, Xx) || t.getBoundingClientRect();
}
const _q = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function gN(t, e, n) {
  let { node: r, offset: i, atom: o } = t.docView.domFromPos(e, n < 0 ? -1 : 1), s = il || Gn;
  if (r.nodeType == 3)
    if (s && (_q.test(r.nodeValue) || (n < 0 ? !i : i == r.nodeValue.length))) {
      let l = Gr(Or(r, i, i), n);
      if (Gn && i && /\s/.test(r.nodeValue[i - 1]) && i < r.nodeValue.length) {
        let c = Gr(Or(r, i - 1, i - 1), -1);
        if (c.top == l.top) {
          let u = Gr(Or(r, i, i + 1), -1);
          if (u.top != l.top)
            return Ds(u, u.left < c.left);
        }
      }
      return l;
    } else {
      let l = i, c = i, u = n < 0 ? 1 : -1;
      return n < 0 && !i ? (c++, u = -1) : n >= 0 && i == r.nodeValue.length ? (l--, u = 1) : n < 0 ? l-- : c++, Ds(Gr(Or(r, l, c), u), u < 0);
    }
  if (!t.state.doc.resolve(e - (o || 0)).parent.inlineContent) {
    if (o == null && i && (n < 0 || i == Tn(r))) {
      let l = r.childNodes[i - 1];
      if (l.nodeType == 1)
        return op(l.getBoundingClientRect(), !1);
    }
    if (o == null && i < Tn(r)) {
      let l = r.childNodes[i];
      if (l.nodeType == 1)
        return op(l.getBoundingClientRect(), !0);
    }
    return op(r.getBoundingClientRect(), n >= 0);
  }
  if (o == null && i && (n < 0 || i == Tn(r))) {
    let l = r.childNodes[i - 1], c = l.nodeType == 3 ? Or(l, Tn(l) - (s ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (c)
      return Ds(Gr(c, 1), !1);
  }
  if (o == null && i < Tn(r)) {
    let l = r.childNodes[i];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let c = l ? l.nodeType == 3 ? Or(l, 0, s ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (c)
      return Ds(Gr(c, -1), !0);
  }
  return Ds(Gr(r.nodeType == 3 ? Or(r) : r, -n), n >= 0);
}
function Ds(t, e) {
  if (t.width == 0)
    return t;
  let n = e ? t.left : t.right;
  return { top: t.top, bottom: t.bottom, left: n, right: n };
}
function op(t, e) {
  if (t.height == 0)
    return t;
  let n = e ? t.top : t.bottom;
  return { top: n, bottom: n, left: t.left, right: t.right };
}
function vN(t, e, n) {
  let r = t.state, i = t.root.activeElement;
  r != e && t.updateState(e), i != t.dom && t.focus();
  try {
    return n();
  } finally {
    r != e && t.updateState(r), i != t.dom && i && i.focus();
  }
}
function Pq(t, e, n) {
  let r = e.selection, i = n == "up" ? r.$from : r.$to;
  return vN(t, e, () => {
    let { node: o } = t.docView.domFromPos(i.pos, n == "up" ? -1 : 1);
    for (; ; ) {
      let a = t.docView.nearestDesc(o, !0);
      if (!a)
        break;
      if (a.node.isBlock) {
        o = a.contentDOM || a.dom;
        break;
      }
      o = a.dom.parentNode;
    }
    let s = gN(t, i.pos, 1);
    for (let a = o.firstChild; a; a = a.nextSibling) {
      let l;
      if (a.nodeType == 1)
        l = a.getClientRects();
      else if (a.nodeType == 3)
        l = Or(a, 0, a.nodeValue.length).getClientRects();
      else
        continue;
      for (let c = 0; c < l.length; c++) {
        let u = l[c];
        if (u.bottom > u.top + 1 && (n == "up" ? s.top - u.top > (u.bottom - s.top) * 2 : u.bottom - s.bottom > (s.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const Lq = /[\u0590-\u08ac]/;
function Fq(t, e, n) {
  let { $head: r } = e.selection;
  if (!r.parent.isTextblock)
    return !1;
  let i = r.parentOffset, o = !i, s = i == r.parent.content.size, a = t.domSelection();
  return a ? !Lq.test(r.parent.textContent) || !a.modify ? n == "left" || n == "backward" ? o : s : vN(t, e, () => {
    let { focusNode: l, focusOffset: c, anchorNode: u, anchorOffset: d } = t.domSelectionRange(), f = a.caretBidiLevel;
    a.modify("move", n, "character");
    let h = r.depth ? t.docView.domAfterPos(r.before()) : t.dom, { focusNode: p, focusOffset: m } = t.domSelectionRange(), b = p && !h.contains(p.nodeType == 1 ? p : p.parentNode) || l == p && c == m;
    try {
      a.collapse(u, d), l && (l != u || c != d) && a.extend && a.extend(l, c);
    } catch {
    }
    return f != null && (a.caretBidiLevel = f), b;
  }) : r.pos == r.start() || r.pos == r.end();
}
let Qx = null, ek = null, tk = !1;
function $q(t, e, n) {
  return Qx == e && ek == n ? tk : (Qx = e, ek = n, tk = n == "up" || n == "down" ? Pq(t, e, n) : Fq(t, e, n));
}
const Rn = 0, nk = 1, Wi = 2, fr = 3;
class ol {
  constructor(e, n, r, i) {
    this.parent = e, this.children = n, this.dom = r, this.contentDOM = i, this.dirty = Rn, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, n, r) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let n = 0; n < this.children.length; n++)
      e += this.children[n].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let n = 0, r = this.posAtStart; ; n++) {
      let i = this.children[n];
      if (i == e)
        return r;
      r += i.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, n, r) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (r < 0) {
        let o, s;
        if (e == this.contentDOM)
          o = e.childNodes[n - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          o = e.previousSibling;
        }
        for (; o && !((s = o.pmViewDesc) && s.parent == this); )
          o = o.previousSibling;
        return o ? this.posBeforeChild(s) + s.size : this.posAtStart;
      } else {
        let o, s;
        if (e == this.contentDOM)
          o = e.childNodes[n];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          o = e.nextSibling;
        }
        for (; o && !((s = o.pmViewDesc) && s.parent == this); )
          o = o.nextSibling;
        return o ? this.posBeforeChild(s) : this.posAtEnd;
      }
    let i;
    if (e == this.dom && this.contentDOM)
      i = n > St(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      i = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (n == 0)
        for (let o = e; ; o = o.parentNode) {
          if (o == this.dom) {
            i = !1;
            break;
          }
          if (o.previousSibling)
            break;
        }
      if (i == null && n == e.childNodes.length)
        for (let o = e; ; o = o.parentNode) {
          if (o == this.dom) {
            i = !0;
            break;
          }
          if (o.nextSibling)
            break;
        }
    }
    return i ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, n = !1) {
    for (let r = !0, i = e; i; i = i.parentNode) {
      let o = this.getDesc(i), s;
      if (o && (!n || o.node))
        if (r && (s = o.nodeDOM) && !(s.nodeType == 1 ? s.contains(e.nodeType == 1 ? e : e.parentNode) : s == e))
          r = !1;
        else
          return o;
    }
  }
  getDesc(e) {
    let n = e.pmViewDesc;
    for (let r = n; r; r = r.parent)
      if (r == this)
        return n;
  }
  posFromDOM(e, n, r) {
    for (let i = e; i; i = i.parentNode) {
      let o = this.getDesc(i);
      if (o)
        return o.localPosFromDOM(e, n, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let n = 0, r = 0; n < this.children.length; n++) {
      let i = this.children[n], o = r + i.size;
      if (r == e && o != r) {
        for (; !i.border && i.children.length; )
          for (let s = 0; s < i.children.length; s++) {
            let a = i.children[s];
            if (a.size) {
              i = a;
              break;
            }
          }
        return i;
      }
      if (e < o)
        return i.descAt(e - r - i.border);
      r = o;
    }
  }
  domFromPos(e, n) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let r = 0, i = 0;
    for (let o = 0; r < this.children.length; r++) {
      let s = this.children[r], a = o + s.size;
      if (a > e || s instanceof yN) {
        i = e - o;
        break;
      }
      o = a;
    }
    if (i)
      return this.children[r].domFromPos(i - this.children[r].border, n);
    for (let o; r && !(o = this.children[r - 1]).size && o instanceof bN && o.side >= 0; r--)
      ;
    if (n <= 0) {
      let o, s = !0;
      for (; o = r ? this.children[r - 1] : null, !(!o || o.dom.parentNode == this.contentDOM); r--, s = !1)
        ;
      return o && n && s && !o.border && !o.domAtom ? o.domFromPos(o.size, n) : { node: this.contentDOM, offset: o ? St(o.dom) + 1 : 0 };
    } else {
      let o, s = !0;
      for (; o = r < this.children.length ? this.children[r] : null, !(!o || o.dom.parentNode == this.contentDOM); r++, s = !1)
        ;
      return o && s && !o.border && !o.domAtom ? o.domFromPos(0, n) : { node: this.contentDOM, offset: o ? St(o.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, n, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: n, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let i = -1, o = -1;
    for (let s = r, a = 0; ; a++) {
      let l = this.children[a], c = s + l.size;
      if (i == -1 && e <= c) {
        let u = s + l.border;
        if (e >= u && n <= c - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(e, n, u);
        e = s;
        for (let d = a; d > 0; d--) {
          let f = this.children[d - 1];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(1)) {
            i = St(f.dom) + 1;
            break;
          }
          e -= f.size;
        }
        i == -1 && (i = 0);
      }
      if (i > -1 && (c > n || a == this.children.length - 1)) {
        n = c;
        for (let u = a + 1; u < this.children.length; u++) {
          let d = this.children[u];
          if (d.size && d.dom.parentNode == this.contentDOM && !d.emptyChildAt(-1)) {
            o = St(d.dom);
            break;
          }
          n += d.size;
        }
        o == -1 && (o = this.contentDOM.childNodes.length);
        break;
      }
      s = c;
    }
    return { node: this.contentDOM, from: e, to: n, fromOffset: i, toOffset: o };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let n = this.children[e < 0 ? 0 : this.children.length - 1];
    return n.size == 0 || n.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: n, offset: r } = this.domFromPos(e, 0);
    if (n.nodeType != 1 || r == n.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return n.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, n, r, i = !1) {
    let o = Math.min(e, n), s = Math.max(e, n);
    for (let h = 0, p = 0; h < this.children.length; h++) {
      let m = this.children[h], b = p + m.size;
      if (o > p && s < b)
        return m.setSelection(e - p - m.border, n - p - m.border, r, i);
      p = b;
    }
    let a = this.domFromPos(e, e ? -1 : 1), l = n == e ? a : this.domFromPos(n, n ? -1 : 1), c = r.root.getSelection(), u = r.domSelectionRange(), d = !1;
    if ((Gn || Kt) && e == n) {
      let { node: h, offset: p } = a;
      if (h.nodeType == 3) {
        if (d = !!(p && h.nodeValue[p - 1] == `
`), d && p == h.nodeValue.length)
          for (let m = h, b; m; m = m.parentNode) {
            if (b = m.nextSibling) {
              b.nodeName == "BR" && (a = l = { node: b.parentNode, offset: St(b) + 1 });
              break;
            }
            let y = m.pmViewDesc;
            if (y && y.node && y.node.isBlock)
              break;
          }
      } else {
        let m = h.childNodes[p - 1];
        d = m && (m.nodeName == "BR" || m.contentEditable == "false");
      }
    }
    if (Gn && u.focusNode && u.focusNode != l.node && u.focusNode.nodeType == 1) {
      let h = u.focusNode.childNodes[u.focusOffset];
      h && h.contentEditable == "false" && (i = !0);
    }
    if (!(i || d && Kt) && oo(a.node, a.offset, u.anchorNode, u.anchorOffset) && oo(l.node, l.offset, u.focusNode, u.focusOffset))
      return;
    let f = !1;
    if ((c.extend || e == n) && !d) {
      c.collapse(a.node, a.offset);
      try {
        e != n && c.extend(l.node, l.offset), f = !0;
      } catch {
      }
    }
    if (!f) {
      if (e > n) {
        let p = a;
        a = l, l = p;
      }
      let h = document.createRange();
      h.setEnd(l.node, l.offset), h.setStart(a.node, a.offset), c.removeAllRanges(), c.addRange(h);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, n) {
    for (let r = 0, i = 0; i < this.children.length; i++) {
      let o = this.children[i], s = r + o.size;
      if (r == s ? e <= s && n >= r : e < s && n > r) {
        let a = r + o.border, l = s - o.border;
        if (e >= a && n <= l) {
          this.dirty = e == r || n == s ? Wi : nk, e == a && n == l && (o.contentLost || o.dom.parentNode != this.contentDOM) ? o.dirty = fr : o.markDirty(e - a, n - a);
          return;
        } else
          o.dirty = o.dom == o.contentDOM && o.dom.parentNode == this.contentDOM && !o.children.length ? Wi : fr;
      }
      r = s;
    }
    this.dirty = Wi;
  }
  markParentsDirty() {
    let e = 1;
    for (let n = this.parent; n; n = n.parent, e++) {
      let r = e == 1 ? Wi : nk;
      n.dirty < r && (n.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class bN extends ol {
  constructor(e, n, r, i) {
    let o, s = n.type.toDOM;
    if (typeof s == "function" && (s = s(r, () => {
      if (!o)
        return i;
      if (o.parent)
        return o.parent.posBeforeChild(o);
    })), !n.type.spec.raw) {
      if (s.nodeType != 1) {
        let a = document.createElement("span");
        a.appendChild(s), s = a;
      }
      s.contentEditable = "false", s.classList.add("ProseMirror-widget");
    }
    super(e, [], s, null), this.widget = n, this.widget = n, o = this;
  }
  matchesWidget(e) {
    return this.dirty == Rn && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let n = this.widget.spec.stopEvent;
    return n ? n(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class Bq extends ol {
  constructor(e, n, r, i) {
    super(e, [], n, null), this.textDOM = r, this.text = i;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, n) {
    return e != this.textDOM ? this.posAtStart + (n ? this.size : 0) : this.posAtStart + n;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class so extends ol {
  constructor(e, n, r, i, o) {
    super(e, [], r, i), this.mark = n, this.spec = o;
  }
  static create(e, n, r, i) {
    let o = i.nodeViews[n.type.name], s = o && o(n, i, r);
    return (!s || !s.dom) && (s = vo.renderSpec(document, n.type.spec.toDOM(n, r), null, n.attrs)), new so(e, n, s.dom, s.contentDOM || s.dom, s);
  }
  parseRule() {
    return this.dirty & fr || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != fr && this.mark.eq(e);
  }
  markDirty(e, n) {
    if (super.markDirty(e, n), this.dirty != Rn) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = Rn;
    }
  }
  slice(e, n, r) {
    let i = so.create(this.parent, this.mark, !0, r), o = this.children, s = this.size;
    n < s && (o = qm(o, n, s, r)), e > 0 && (o = qm(o, 0, e, r));
    for (let a = 0; a < o.length; a++)
      o[a].parent = i;
    return i.children = o, i;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class fi extends ol {
  constructor(e, n, r, i, o, s, a, l, c) {
    super(e, [], o, s), this.node = n, this.outerDeco = r, this.innerDeco = i, this.nodeDOM = a;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, n, r, i, o, s) {
    let a = o.nodeViews[n.type.name], l, c = a && a(n, o, () => {
      if (!l)
        return s;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, r, i), u = c && c.dom, d = c && c.contentDOM;
    if (n.isText) {
      if (!u)
        u = document.createTextNode(n.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else u || ({ dom: u, contentDOM: d } = vo.renderSpec(document, n.type.spec.toDOM(n), null, n.attrs));
    !d && !n.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), n.type.spec.draggable && (u.draggable = !0));
    let f = u;
    return u = kN(u, r, n), c ? l = new Vq(e, n, r, i, u, d || null, f, c, o, s + 1) : n.isText ? new Nd(e, n, r, i, u, f, o) : new fi(e, n, r, i, u, d || null, f, o, s + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let n = this.children.length - 1; n >= 0; n--) {
        let r = this.children[n];
        if (this.dom.contains(r.dom.parentNode)) {
          e.contentElement = r.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => U.empty);
    }
    return e;
  }
  matchesNode(e, n, r) {
    return this.dirty == Rn && e.eq(this.node) && Xc(n, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, n) {
    let r = this.node.inlineContent, i = n, o = e.composing ? this.localCompositionInfo(e, n) : null, s = o && o.pos > -1 ? o : null, a = o && o.pos < 0, l = new Hq(this, s && s.node, e);
    Uq(this.node, this.innerDeco, (c, u, d) => {
      c.spec.marks ? l.syncToMarks(c.spec.marks, r, e) : c.type.side >= 0 && !d && l.syncToMarks(u == this.node.childCount ? Ye.none : this.node.child(u).marks, r, e), l.placeWidget(c, e, i);
    }, (c, u, d, f) => {
      l.syncToMarks(c.marks, r, e);
      let h;
      l.findNodeMatch(c, u, d, f) || a && e.state.selection.from > i && e.state.selection.to < i + c.nodeSize && (h = l.findIndexWithChild(o.node)) > -1 && l.updateNodeAt(c, u, d, h, e) || l.updateNextNode(c, u, d, e, f, i) || l.addNode(c, u, d, e, i), i += c.nodeSize;
    }), l.syncToMarks([], r, e), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == Wi) && (s && this.protectLocalComposition(e, s), wN(this.contentDOM, this.children, e), is && qq(this.dom));
  }
  localCompositionInfo(e, n) {
    let { from: r, to: i } = e.state.selection;
    if (!(e.state.selection instanceof ge) || r < n || i > n + this.node.content.size)
      return null;
    let o = e.input.compositionNode;
    if (!o || !this.dom.contains(o.parentNode))
      return null;
    if (this.node.inlineContent) {
      let s = o.nodeValue, a = Kq(this.node.content, s, r - n, i - n);
      return a < 0 ? null : { node: o, pos: a, text: s };
    } else
      return { node: o, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: n, pos: r, text: i }) {
    if (this.getDesc(n))
      return;
    let o = n;
    for (; o.parentNode != this.contentDOM; o = o.parentNode) {
      for (; o.previousSibling; )
        o.parentNode.removeChild(o.previousSibling);
      for (; o.nextSibling; )
        o.parentNode.removeChild(o.nextSibling);
      o.pmViewDesc && (o.pmViewDesc = void 0);
    }
    let s = new Bq(this, o, n, i);
    e.input.compositionNodes.push(s), this.children = qm(this.children, r, r + i.length, e, s);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, n, r, i) {
    return this.dirty == fr || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, n, r, i), !0);
  }
  updateInner(e, n, r, i) {
    this.updateOuterDeco(n), this.node = e, this.innerDeco = r, this.contentDOM && this.updateChildren(i, this.posAtStart), this.dirty = Rn;
  }
  updateOuterDeco(e) {
    if (Xc(e, this.outerDeco))
      return;
    let n = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = xN(this.dom, this.nodeDOM, Um(this.outerDeco, this.node, n), Um(e, this.node, n)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function rk(t, e, n, r, i) {
  kN(r, e, t);
  let o = new fi(void 0, t, e, n, r, r, r, i, 0);
  return o.contentDOM && o.updateChildren(i, 0), o;
}
class Nd extends fi {
  constructor(e, n, r, i, o, s, a) {
    super(e, n, r, i, o, null, s, a, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, n, r, i) {
    return this.dirty == fr || this.dirty != Rn && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(n), (this.dirty != Rn || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, i.trackWrites == this.nodeDOM && (i.trackWrites = null)), this.node = e, this.dirty = Rn, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let n = this.nodeDOM; n; n = n.parentNode)
      if (n == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, n, r) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(n, this.node.text.length) : super.localPosFromDOM(e, n, r);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, n, r) {
    let i = this.node.cut(e, n), o = document.createTextNode(i.text);
    return new Nd(this.parent, i, this.outerDeco, this.innerDeco, o, o, r);
  }
  markDirty(e, n) {
    super.markDirty(e, n), this.dom != this.nodeDOM && (e == 0 || n == this.nodeDOM.nodeValue.length) && (this.dirty = fr);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class yN extends ol {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == Rn && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class Vq extends fi {
  constructor(e, n, r, i, o, s, a, l, c, u) {
    super(e, n, r, i, o, s, a, c, u), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, n, r, i) {
    if (this.dirty == fr)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let o = this.spec.update(e, n, r);
      return o && this.updateInner(e, n, r, i), o;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, n, r, i);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, n, r, i) {
    this.spec.setSelection ? this.spec.setSelection(e, n, r.root) : super.setSelection(e, n, r, i);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function wN(t, e, n) {
  let r = t.firstChild, i = !1;
  for (let o = 0; o < e.length; o++) {
    let s = e[o], a = s.dom;
    if (a.parentNode == t) {
      for (; a != r; )
        r = ik(r), i = !0;
      r = r.nextSibling;
    } else
      i = !0, t.insertBefore(a, r);
    if (s instanceof so) {
      let l = r ? r.previousSibling : t.lastChild;
      wN(s.contentDOM, s.children, n), r = l ? l.nextSibling : t.firstChild;
    }
  }
  for (; r; )
    r = ik(r), i = !0;
  i && n.trackWrites == t && (n.trackWrites = null);
}
const Js = function(t) {
  t && (this.nodeName = t);
};
Js.prototype = /* @__PURE__ */ Object.create(null);
const ji = [new Js()];
function Um(t, e, n) {
  if (t.length == 0)
    return ji;
  let r = n ? ji[0] : new Js(), i = [r];
  for (let o = 0; o < t.length; o++) {
    let s = t[o].type.attrs;
    if (s) {
      s.nodeName && i.push(r = new Js(s.nodeName));
      for (let a in s) {
        let l = s[a];
        l != null && (n && i.length == 1 && i.push(r = new Js(e.isInline ? "span" : "div")), a == "class" ? r.class = (r.class ? r.class + " " : "") + l : a == "style" ? r.style = (r.style ? r.style + ";" : "") + l : a != "nodeName" && (r[a] = l));
      }
    }
  }
  return i;
}
function xN(t, e, n, r) {
  if (n == ji && r == ji)
    return e;
  let i = e;
  for (let o = 0; o < r.length; o++) {
    let s = r[o], a = n[o];
    if (o) {
      let l;
      a && a.nodeName == s.nodeName && i != t && (l = i.parentNode) && l.nodeName.toLowerCase() == s.nodeName || (l = document.createElement(s.nodeName), l.pmIsDeco = !0, l.appendChild(i), a = ji[0]), i = l;
    }
    zq(i, a || ji[0], s);
  }
  return i;
}
function zq(t, e, n) {
  for (let r in e)
    r != "class" && r != "style" && r != "nodeName" && !(r in n) && t.removeAttribute(r);
  for (let r in n)
    r != "class" && r != "style" && r != "nodeName" && n[r] != e[r] && t.setAttribute(r, n[r]);
  if (e.class != n.class) {
    let r = e.class ? e.class.split(" ").filter(Boolean) : [], i = n.class ? n.class.split(" ").filter(Boolean) : [];
    for (let o = 0; o < r.length; o++)
      i.indexOf(r[o]) == -1 && t.classList.remove(r[o]);
    for (let o = 0; o < i.length; o++)
      r.indexOf(i[o]) == -1 && t.classList.add(i[o]);
    t.classList.length == 0 && t.removeAttribute("class");
  }
  if (e.style != n.style) {
    if (e.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, i;
      for (; i = r.exec(e.style); )
        t.style.removeProperty(i[1]);
    }
    n.style && (t.style.cssText += n.style);
  }
}
function kN(t, e, n) {
  return xN(t, t, ji, Um(e, n, t.nodeType != 1));
}
function Xc(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (!t[n].type.eq(e[n].type))
      return !1;
  return !0;
}
function ik(t) {
  let e = t.nextSibling;
  return t.parentNode.removeChild(t), e;
}
class Hq {
  constructor(e, n, r) {
    this.lock = n, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = Wq(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, n) {
    if (e != n) {
      for (let r = e; r < n; r++)
        this.top.children[r].destroy();
      this.top.children.splice(e, n - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, n, r) {
    let i = 0, o = this.stack.length >> 1, s = Math.min(o, e.length);
    for (; i < s && (i == o - 1 ? this.top : this.stack[i + 1 << 1]).matchesMark(e[i]) && e[i].type.spec.spanning !== !1; )
      i++;
    for (; i < o; )
      this.destroyRest(), this.top.dirty = Rn, this.index = this.stack.pop(), this.top = this.stack.pop(), o--;
    for (; o < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let a = -1;
      for (let l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++) {
        let c = this.top.children[l];
        if (c.matchesMark(e[o]) && !this.isLocked(c.dom)) {
          a = l;
          break;
        }
      }
      if (a > -1)
        a > this.index && (this.changed = !0, this.destroyBetween(this.index, a)), this.top = this.top.children[this.index];
      else {
        let l = so.create(this.top, e[o], n, r);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, o++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, n, r, i) {
    let o = -1, s;
    if (i >= this.preMatch.index && (s = this.preMatch.matches[i - this.preMatch.index]).parent == this.top && s.matchesNode(e, n, r))
      o = this.top.children.indexOf(s, this.index);
    else
      for (let a = this.index, l = Math.min(this.top.children.length, a + 5); a < l; a++) {
        let c = this.top.children[a];
        if (c.matchesNode(e, n, r) && !this.preMatch.matched.has(c)) {
          o = a;
          break;
        }
      }
    return o < 0 ? !1 : (this.destroyBetween(this.index, o), this.index++, !0);
  }
  updateNodeAt(e, n, r, i, o) {
    let s = this.top.children[i];
    return s.dirty == fr && s.dom == s.contentDOM && (s.dirty = Wi), s.update(e, n, r, o) ? (this.destroyBetween(this.index, i), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let n = e.parentNode;
      if (!n)
        return -1;
      if (n == this.top.contentDOM) {
        let r = e.pmViewDesc;
        if (r) {
          for (let i = this.index; i < this.top.children.length; i++)
            if (this.top.children[i] == r)
              return i;
        }
        return -1;
      }
      e = n;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, n, r, i, o, s) {
    for (let a = this.index; a < this.top.children.length; a++) {
      let l = this.top.children[a];
      if (l instanceof fi) {
        let c = this.preMatch.matched.get(l);
        if (c != null && c != o)
          return !1;
        let u = l.dom, d, f = this.isLocked(u) && !(e.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == e.text && l.dirty != fr && Xc(n, l.outerDeco));
        if (!f && l.update(e, n, r, i))
          return this.destroyBetween(this.index, a), l.dom != u && (this.changed = !0), this.index++, !0;
        if (!f && (d = this.recreateWrapper(l, e, n, r, i, s)))
          return this.destroyBetween(this.index, a), this.top.children[this.index] = d, d.contentDOM && (d.dirty = Wi, d.updateChildren(i, s + 1), d.dirty = Rn), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, n, r, i, o, s) {
    if (e.dirty || n.isAtom || !e.children.length || !e.node.content.eq(n.content) || !Xc(r, e.outerDeco) || !i.eq(e.innerDeco))
      return null;
    let a = fi.create(this.top, n, r, i, o, s);
    if (a.contentDOM) {
      a.children = e.children, e.children = [];
      for (let l of a.children)
        l.parent = a;
    }
    return e.destroy(), a;
  }
  // Insert the node as a newly created node desc.
  addNode(e, n, r, i, o) {
    let s = fi.create(this.top, e, n, r, i, o);
    s.contentDOM && s.updateChildren(i, o + 1), this.top.children.splice(this.index++, 0, s), this.changed = !0;
  }
  placeWidget(e, n, r) {
    let i = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (i && i.matchesWidget(e) && (e == i.widget || !i.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let o = new bN(this.top, e, n, r);
      this.top.children.splice(this.index++, 0, o), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], n = this.top;
    for (; e instanceof so; )
      n = e, e = n.children[n.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof Nd) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((Kt || It) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", n), this.addHackNode("BR", this.top));
  }
  addHackNode(e, n) {
    if (n == this.top && this.index < n.children.length && n.children[this.index].matchesHack(e))
      this.index++;
    else {
      let r = document.createElement(e);
      e == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), e == "BR" && (r.className = "ProseMirror-trailingBreak");
      let i = new yN(this.top, [], r, null);
      n != this.top ? n.children.push(i) : n.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function Wq(t, e) {
  let n = e, r = n.children.length, i = t.childCount, o = /* @__PURE__ */ new Map(), s = [];
  e: for (; i > 0; ) {
    let a;
    for (; ; )
      if (r) {
        let c = n.children[r - 1];
        if (c instanceof so)
          n = c, r = c.children.length;
        else {
          a = c, r--;
          break;
        }
      } else {
        if (n == e)
          break e;
        r = n.parent.children.indexOf(n), n = n.parent;
      }
    let l = a.node;
    if (l) {
      if (l != t.child(i - 1))
        break;
      --i, o.set(a, i), s.push(a);
    }
  }
  return { index: i, matched: o, matches: s.reverse() };
}
function jq(t, e) {
  return t.type.side - e.type.side;
}
function Uq(t, e, n, r) {
  let i = e.locals(t), o = 0;
  if (i.length == 0) {
    for (let c = 0; c < t.childCount; c++) {
      let u = t.child(c);
      r(u, i, e.forChild(o, u), c), o += u.nodeSize;
    }
    return;
  }
  let s = 0, a = [], l = null;
  for (let c = 0; ; ) {
    let u, d;
    for (; s < i.length && i[s].to == o; ) {
      let b = i[s++];
      b.widget && (u ? (d || (d = [u])).push(b) : u = b);
    }
    if (u)
      if (d) {
        d.sort(jq);
        for (let b = 0; b < d.length; b++)
          n(d[b], c, !!l);
      } else
        n(u, c, !!l);
    let f, h;
    if (l)
      h = -1, f = l, l = null;
    else if (c < t.childCount)
      h = c, f = t.child(c++);
    else
      break;
    for (let b = 0; b < a.length; b++)
      a[b].to <= o && a.splice(b--, 1);
    for (; s < i.length && i[s].from <= o && i[s].to > o; )
      a.push(i[s++]);
    let p = o + f.nodeSize;
    if (f.isText) {
      let b = p;
      s < i.length && i[s].from < b && (b = i[s].from);
      for (let y = 0; y < a.length; y++)
        a[y].to < b && (b = a[y].to);
      b < p && (l = f.cut(b - o), f = f.cut(0, b - o), p = b, h = -1);
    } else
      for (; s < i.length && i[s].to < p; )
        s++;
    let m = f.isInline && !f.isLeaf ? a.filter((b) => !b.inline) : a.slice();
    r(f, m, e.forChild(o, f), h), o = p;
  }
}
function qq(t) {
  if (t.nodeName == "UL" || t.nodeName == "OL") {
    let e = t.style.cssText;
    t.style.cssText = e + "; list-style: square !important", window.getComputedStyle(t).listStyle, t.style.cssText = e;
  }
}
function Kq(t, e, n, r) {
  for (let i = 0, o = 0; i < t.childCount && o <= r; ) {
    let s = t.child(i++), a = o;
    if (o += s.nodeSize, !s.isText)
      continue;
    let l = s.text;
    for (; i < t.childCount; ) {
      let c = t.child(i++);
      if (o += c.nodeSize, !c.isText)
        break;
      l += c.text;
    }
    if (o >= n) {
      if (o >= r && l.slice(r - e.length - a, r - a) == e)
        return r - e.length;
      let c = a < r ? l.lastIndexOf(e, r - a - 1) : -1;
      if (c >= 0 && c + e.length + a >= n)
        return a + c;
      if (n == r && l.length >= r + e.length - a && l.slice(r - a, r - a + e.length) == e)
        return r;
    }
  }
  return -1;
}
function qm(t, e, n, r, i) {
  let o = [];
  for (let s = 0, a = 0; s < t.length; s++) {
    let l = t[s], c = a, u = a += l.size;
    c >= n || u <= e ? o.push(l) : (c < e && o.push(l.slice(0, e - c, r)), i && (o.push(i), i = void 0), u > n && o.push(l.slice(n - c, l.size, r)));
  }
  return o;
}
function Hv(t, e = null) {
  let n = t.domSelectionRange(), r = t.state.doc;
  if (!n.focusNode)
    return null;
  let i = t.docView.nearestDesc(n.focusNode), o = i && i.size == 0, s = t.docView.posFromDOM(n.focusNode, n.focusOffset, 1);
  if (s < 0)
    return null;
  let a = r.resolve(s), l, c;
  if (Ad(n)) {
    for (l = s; i && !i.node; )
      i = i.parent;
    let d = i.node;
    if (i && d.isAtom && ye.isSelectable(d) && i.parent && !(d.isInline && yq(n.focusNode, n.focusOffset, i.dom))) {
      let f = i.posBefore;
      c = new ye(s == f ? a : r.resolve(f));
    }
  } else {
    if (n instanceof t.dom.ownerDocument.defaultView.Selection && n.rangeCount > 1) {
      let d = s, f = s;
      for (let h = 0; h < n.rangeCount; h++) {
        let p = n.getRangeAt(h);
        d = Math.min(d, t.docView.posFromDOM(p.startContainer, p.startOffset, 1)), f = Math.max(f, t.docView.posFromDOM(p.endContainer, p.endOffset, -1));
      }
      if (d < 0)
        return null;
      [l, s] = f == t.state.selection.anchor ? [f, d] : [d, f], a = r.resolve(s);
    } else
      l = t.docView.posFromDOM(n.anchorNode, n.anchorOffset, 1);
    if (l < 0)
      return null;
  }
  let u = r.resolve(l);
  if (!c) {
    let d = e == "pointer" || t.state.selection.head < a.pos && !o ? 1 : -1;
    c = Wv(t, u, a, d);
  }
  return c;
}
function CN(t) {
  return t.editable ? t.hasFocus() : TN(t) && document.activeElement && document.activeElement.contains(t.dom);
}
function _r(t, e = !1) {
  let n = t.state.selection;
  if (SN(t, n), !!CN(t)) {
    if (!e && t.input.mouseDown && t.input.mouseDown.allowDefault && It) {
      let r = t.domSelectionRange(), i = t.domObserver.currentSelection;
      if (r.anchorNode && i.anchorNode && oo(r.anchorNode, r.anchorOffset, i.anchorNode, i.anchorOffset)) {
        t.input.mouseDown.delayedSelectionSync = !0, t.domObserver.setCurSelection();
        return;
      }
    }
    if (t.domObserver.disconnectSelection(), t.cursorWrapper)
      Yq(t);
    else {
      let { anchor: r, head: i } = n, o, s;
      ok && !(n instanceof ge) && (n.$from.parent.inlineContent || (o = sk(t, n.from)), !n.empty && !n.$from.parent.inlineContent && (s = sk(t, n.to))), t.docView.setSelection(r, i, t, e), ok && (o && ak(o), s && ak(s)), n.visible ? t.dom.classList.remove("ProseMirror-hideselection") : (t.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && Gq(t));
    }
    t.domObserver.setCurSelection(), t.domObserver.connectSelection();
  }
}
const ok = Kt || It && dN < 63;
function sk(t, e) {
  let { node: n, offset: r } = t.docView.domFromPos(e, 0), i = r < n.childNodes.length ? n.childNodes[r] : null, o = r ? n.childNodes[r - 1] : null;
  if (Kt && i && i.contentEditable == "false")
    return sp(i);
  if ((!i || i.contentEditable == "false") && (!o || o.contentEditable == "false")) {
    if (i)
      return sp(i);
    if (o)
      return sp(o);
  }
}
function sp(t) {
  return t.contentEditable = "true", Kt && t.draggable && (t.draggable = !1, t.wasDraggable = !0), t;
}
function ak(t) {
  t.contentEditable = "false", t.wasDraggable && (t.draggable = !0, t.wasDraggable = null);
}
function Gq(t) {
  let e = t.dom.ownerDocument;
  e.removeEventListener("selectionchange", t.input.hideSelectionGuard);
  let n = t.domSelectionRange(), r = n.anchorNode, i = n.anchorOffset;
  e.addEventListener("selectionchange", t.input.hideSelectionGuard = () => {
    (n.anchorNode != r || n.anchorOffset != i) && (e.removeEventListener("selectionchange", t.input.hideSelectionGuard), setTimeout(() => {
      (!CN(t) || t.state.selection.visible) && t.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function Yq(t) {
  let e = t.domSelection(), n = document.createRange();
  if (!e)
    return;
  let r = t.cursorWrapper.dom, i = r.nodeName == "IMG";
  i ? n.setStart(r.parentNode, St(r) + 1) : n.setStart(r, 0), n.collapse(!0), e.removeAllRanges(), e.addRange(n), !i && !t.state.selection.visible && tn && di <= 11 && (r.disabled = !0, r.disabled = !1);
}
function SN(t, e) {
  if (e instanceof ye) {
    let n = t.docView.descAt(e.from);
    n != t.lastSelectedViewDesc && (lk(t), n && n.selectNode(), t.lastSelectedViewDesc = n);
  } else
    lk(t);
}
function lk(t) {
  t.lastSelectedViewDesc && (t.lastSelectedViewDesc.parent && t.lastSelectedViewDesc.deselectNode(), t.lastSelectedViewDesc = void 0);
}
function Wv(t, e, n, r) {
  return t.someProp("createSelectionBetween", (i) => i(t, e, n)) || ge.between(e, n, r);
}
function ck(t) {
  return t.editable && !t.hasFocus() ? !1 : TN(t);
}
function TN(t) {
  let e = t.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return t.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (t.editable || t.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function Zq(t) {
  let e = t.docView.domFromPos(t.state.selection.anchor, 0), n = t.domSelectionRange();
  return oo(e.node, e.offset, n.anchorNode, n.anchorOffset);
}
function Km(t, e) {
  let { $anchor: n, $head: r } = t.selection, i = e > 0 ? n.max(r) : n.min(r), o = i.parent.inlineContent ? i.depth ? t.doc.resolve(e > 0 ? i.after() : i.before()) : null : i;
  return o && be.findFrom(o, e);
}
function Zr(t, e) {
  return t.dispatch(t.state.tr.setSelection(e).scrollIntoView()), !0;
}
function uk(t, e, n) {
  let r = t.state.selection;
  if (r instanceof ge)
    if (n.indexOf("s") > -1) {
      let { $head: i } = r, o = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter;
      if (!o || o.isText || !o.isLeaf)
        return !1;
      let s = t.state.doc.resolve(i.pos + o.nodeSize * (e < 0 ? -1 : 1));
      return Zr(t, new ge(r.$anchor, s));
    } else if (r.empty) {
      if (t.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let i = Km(t.state, e);
        return i && i instanceof ye ? Zr(t, i) : !1;
      } else if (!(Cn && n.indexOf("m") > -1)) {
        let i = r.$head, o = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter, s;
        if (!o || o.isText)
          return !1;
        let a = e < 0 ? i.pos - o.nodeSize : i.pos;
        return o.isAtom || (s = t.docView.descAt(a)) && !s.contentDOM ? ye.isSelectable(o) ? Zr(t, new ye(e < 0 ? t.state.doc.resolve(i.pos - o.nodeSize) : i)) : il ? Zr(t, new ge(t.state.doc.resolve(e < 0 ? a : a + o.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (r instanceof ye && r.node.isInline)
      return Zr(t, new ge(e > 0 ? r.$to : r.$from));
    {
      let i = Km(t.state, e);
      return i ? Zr(t, i) : !1;
    }
  }
}
function Qc(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function Xs(t, e) {
  let n = t.pmViewDesc;
  return n && n.size == 0 && (e < 0 || t.nextSibling || t.nodeName != "BR");
}
function Ro(t, e) {
  return e < 0 ? Jq(t) : Xq(t);
}
function Jq(t) {
  let e = t.domSelectionRange(), n = e.focusNode, r = e.focusOffset;
  if (!n)
    return;
  let i, o, s = !1;
  for (Gn && n.nodeType == 1 && r < Qc(n) && Xs(n.childNodes[r], -1) && (s = !0); ; )
    if (r > 0) {
      if (n.nodeType != 1)
        break;
      {
        let a = n.childNodes[r - 1];
        if (Xs(a, -1))
          i = n, o = --r;
        else if (a.nodeType == 3)
          n = a, r = n.nodeValue.length;
        else
          break;
      }
    } else {
      if (EN(n))
        break;
      {
        let a = n.previousSibling;
        for (; a && Xs(a, -1); )
          i = n.parentNode, o = St(a), a = a.previousSibling;
        if (a)
          n = a, r = Qc(n);
        else {
          if (n = n.parentNode, n == t.dom)
            break;
          r = 0;
        }
      }
    }
  s ? Gm(t, n, r) : i && Gm(t, i, o);
}
function Xq(t) {
  let e = t.domSelectionRange(), n = e.focusNode, r = e.focusOffset;
  if (!n)
    return;
  let i = Qc(n), o, s;
  for (; ; )
    if (r < i) {
      if (n.nodeType != 1)
        break;
      let a = n.childNodes[r];
      if (Xs(a, 1))
        o = n, s = ++r;
      else
        break;
    } else {
      if (EN(n))
        break;
      {
        let a = n.nextSibling;
        for (; a && Xs(a, 1); )
          o = a.parentNode, s = St(a) + 1, a = a.nextSibling;
        if (a)
          n = a, r = 0, i = Qc(n);
        else {
          if (n = n.parentNode, n == t.dom)
            break;
          r = i = 0;
        }
      }
    }
  o && Gm(t, o, s);
}
function EN(t) {
  let e = t.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function Qq(t, e) {
  for (; t && e == t.childNodes.length && !rl(t); )
    e = St(t) + 1, t = t.parentNode;
  for (; t && e < t.childNodes.length; ) {
    let n = t.childNodes[e];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    t = n, e = 0;
  }
}
function eK(t, e) {
  for (; t && !e && !rl(t); )
    e = St(t), t = t.parentNode;
  for (; t && e; ) {
    let n = t.childNodes[e - 1];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    t = n, e = t.childNodes.length;
  }
}
function Gm(t, e, n) {
  if (e.nodeType != 3) {
    let o, s;
    (s = Qq(e, n)) ? (e = s, n = 0) : (o = eK(e, n)) && (e = o, n = o.nodeValue.length);
  }
  let r = t.domSelection();
  if (!r)
    return;
  if (Ad(r)) {
    let o = document.createRange();
    o.setEnd(e, n), o.setStart(e, n), r.removeAllRanges(), r.addRange(o);
  } else r.extend && r.extend(e, n);
  t.domObserver.setCurSelection();
  let { state: i } = t;
  setTimeout(() => {
    t.state == i && _r(t);
  }, 50);
}
function dk(t, e) {
  let n = t.state.doc.resolve(e);
  if (!(It || kq) && n.parent.inlineContent) {
    let i = t.coordsAtPos(e);
    if (e > n.start()) {
      let o = t.coordsAtPos(e - 1), s = (o.top + o.bottom) / 2;
      if (s > i.top && s < i.bottom && Math.abs(o.left - i.left) > 1)
        return o.left < i.left ? "ltr" : "rtl";
    }
    if (e < n.end()) {
      let o = t.coordsAtPos(e + 1), s = (o.top + o.bottom) / 2;
      if (s > i.top && s < i.bottom && Math.abs(o.left - i.left) > 1)
        return o.left > i.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(t.dom).direction == "rtl" ? "rtl" : "ltr";
}
function fk(t, e, n) {
  let r = t.state.selection;
  if (r instanceof ge && !r.empty || n.indexOf("s") > -1 || Cn && n.indexOf("m") > -1)
    return !1;
  let { $from: i, $to: o } = r;
  if (!i.parent.inlineContent || t.endOfTextblock(e < 0 ? "up" : "down")) {
    let s = Km(t.state, e);
    if (s && s instanceof ye)
      return Zr(t, s);
  }
  if (!i.parent.inlineContent) {
    let s = e < 0 ? i : o, a = r instanceof en ? be.near(s, e) : be.findFrom(s, e);
    return a ? Zr(t, a) : !1;
  }
  return !1;
}
function hk(t, e) {
  if (!(t.state.selection instanceof ge))
    return !0;
  let { $head: n, $anchor: r, empty: i } = t.state.selection;
  if (!n.sameParent(r))
    return !0;
  if (!i)
    return !1;
  if (t.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let o = !n.textOffset && (e < 0 ? n.nodeBefore : n.nodeAfter);
  if (o && !o.isText) {
    let s = t.state.tr;
    return e < 0 ? s.delete(n.pos - o.nodeSize, n.pos) : s.delete(n.pos, n.pos + o.nodeSize), t.dispatch(s), !0;
  }
  return !1;
}
function pk(t, e, n) {
  t.domObserver.stop(), e.contentEditable = n, t.domObserver.start();
}
function tK(t) {
  if (!Kt || t.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: n } = t.domSelectionRange();
  if (e && e.nodeType == 1 && n == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let r = e.firstChild;
    pk(t, r, "true"), setTimeout(() => pk(t, r, "false"), 20);
  }
  return !1;
}
function nK(t) {
  let e = "";
  return t.ctrlKey && (e += "c"), t.metaKey && (e += "m"), t.altKey && (e += "a"), t.shiftKey && (e += "s"), e;
}
function rK(t, e) {
  let n = e.keyCode, r = nK(e);
  if (n == 8 || Cn && n == 72 && r == "c")
    return hk(t, -1) || Ro(t, -1);
  if (n == 46 && !e.shiftKey || Cn && n == 68 && r == "c")
    return hk(t, 1) || Ro(t, 1);
  if (n == 13 || n == 27)
    return !0;
  if (n == 37 || Cn && n == 66 && r == "c") {
    let i = n == 37 ? dk(t, t.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return uk(t, i, r) || Ro(t, i);
  } else if (n == 39 || Cn && n == 70 && r == "c") {
    let i = n == 39 ? dk(t, t.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return uk(t, i, r) || Ro(t, i);
  } else {
    if (n == 38 || Cn && n == 80 && r == "c")
      return fk(t, -1, r) || Ro(t, -1);
    if (n == 40 || Cn && n == 78 && r == "c")
      return tK(t) || fk(t, 1, r) || Ro(t, 1);
    if (r == (Cn ? "m" : "c") && (n == 66 || n == 73 || n == 89 || n == 90))
      return !0;
  }
  return !1;
}
function jv(t, e) {
  t.someProp("transformCopied", (h) => {
    e = h(e, t);
  });
  let n = [], { content: r, openStart: i, openEnd: o } = e;
  for (; i > 1 && o > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    i--, o--;
    let h = r.firstChild;
    n.push(h.type.name, h.attrs != h.type.defaultAttrs ? h.attrs : null), r = h.content;
  }
  let s = t.someProp("clipboardSerializer") || vo.fromSchema(t.state.schema), a = DN(), l = a.createElement("div");
  l.appendChild(s.serializeFragment(r, { document: a }));
  let c = l.firstChild, u, d = 0;
  for (; c && c.nodeType == 1 && (u = RN[c.nodeName.toLowerCase()]); ) {
    for (let h = u.length - 1; h >= 0; h--) {
      let p = a.createElement(u[h]);
      for (; l.firstChild; )
        p.appendChild(l.firstChild);
      l.appendChild(p), d++;
    }
    c = l.firstChild;
  }
  c && c.nodeType == 1 && c.setAttribute("data-pm-slice", `${i} ${o}${d ? ` -${d}` : ""} ${JSON.stringify(n)}`);
  let f = t.someProp("clipboardTextSerializer", (h) => h(e, t)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: f, slice: e };
}
function MN(t, e, n, r, i) {
  let o = i.parent.type.spec.code, s, a;
  if (!n && !e)
    return null;
  let l = e && (r || o || !n);
  if (l) {
    if (t.someProp("transformPastedText", (f) => {
      e = f(e, o || r, t);
    }), o)
      return e ? new ee(U.from(t.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0) : ee.empty;
    let d = t.someProp("clipboardTextParser", (f) => f(e, i, r, t));
    if (d)
      a = d;
    else {
      let f = i.marks(), { schema: h } = t.state, p = vo.fromSchema(h);
      s = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((m) => {
        let b = s.appendChild(document.createElement("p"));
        m && b.appendChild(p.serializeNode(h.text(m, f)));
      });
    }
  } else
    t.someProp("transformPastedHTML", (d) => {
      n = d(n, t);
    }), s = aK(n), il && lK(s);
  let c = s && s.querySelector("[data-pm-slice]"), u = c && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(c.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let d = +u[3]; d > 0; d--) {
      let f = s.firstChild;
      for (; f && f.nodeType != 1; )
        f = f.nextSibling;
      if (!f)
        break;
      s = f;
    }
  if (a || (a = (t.someProp("clipboardParser") || t.someProp("domParser") || Wn.fromSchema(t.state.schema)).parseSlice(s, {
    preserveWhitespace: !!(l || u),
    context: i,
    ruleFromNode(f) {
      return f.nodeName == "BR" && !f.nextSibling && f.parentNode && !iK.test(f.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    a = cK(mk(a, +u[1], +u[2]), u[4]);
  else if (a = ee.maxOpen(oK(a.content, i), !0), a.openStart || a.openEnd) {
    let d = 0, f = 0;
    for (let h = a.content.firstChild; d < a.openStart && !h.type.spec.isolating; d++, h = h.firstChild)
      ;
    for (let h = a.content.lastChild; f < a.openEnd && !h.type.spec.isolating; f++, h = h.lastChild)
      ;
    a = mk(a, d, f);
  }
  return t.someProp("transformPasted", (d) => {
    a = d(a, t);
  }), a;
}
const iK = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function oK(t, e) {
  if (t.childCount < 2)
    return t;
  for (let n = e.depth; n >= 0; n--) {
    let i = e.node(n).contentMatchAt(e.index(n)), o, s = [];
    if (t.forEach((a) => {
      if (!s)
        return;
      let l = i.findWrapping(a.type), c;
      if (!l)
        return s = null;
      if (c = s.length && o.length && AN(l, o, a, s[s.length - 1], 0))
        s[s.length - 1] = c;
      else {
        s.length && (s[s.length - 1] = NN(s[s.length - 1], o.length));
        let u = ON(a, l);
        s.push(u), i = i.matchType(u.type), o = l;
      }
    }), s)
      return U.from(s);
  }
  return t;
}
function ON(t, e, n = 0) {
  for (let r = e.length - 1; r >= n; r--)
    t = e[r].create(null, U.from(t));
  return t;
}
function AN(t, e, n, r, i) {
  if (i < t.length && i < e.length && t[i] == e[i]) {
    let o = AN(t, e, n, r.lastChild, i + 1);
    if (o)
      return r.copy(r.content.replaceChild(r.childCount - 1, o));
    if (r.contentMatchAt(r.childCount).matchType(i == t.length - 1 ? n.type : t[i + 1]))
      return r.copy(r.content.append(U.from(ON(n, t, i + 1))));
  }
}
function NN(t, e) {
  if (e == 0)
    return t;
  let n = t.content.replaceChild(t.childCount - 1, NN(t.lastChild, e - 1)), r = t.contentMatchAt(t.childCount).fillBefore(U.empty, !0);
  return t.copy(n.append(r));
}
function Ym(t, e, n, r, i, o) {
  let s = e < 0 ? t.firstChild : t.lastChild, a = s.content;
  return t.childCount > 1 && (o = 0), i < r - 1 && (a = Ym(a, e, n, r, i + 1, o)), i >= n && (a = e < 0 ? s.contentMatchAt(0).fillBefore(a, o <= i).append(a) : a.append(s.contentMatchAt(s.childCount).fillBefore(U.empty, !0))), t.replaceChild(e < 0 ? 0 : t.childCount - 1, s.copy(a));
}
function mk(t, e, n) {
  return e < t.openStart && (t = new ee(Ym(t.content, -1, e, t.openStart, 0, t.openEnd), e, t.openEnd)), n < t.openEnd && (t = new ee(Ym(t.content, 1, n, t.openEnd, 0, 0), t.openStart, n)), t;
}
const RN = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let gk = null;
function DN() {
  return gk || (gk = document.implementation.createHTMLDocument("title"));
}
let ap = null;
function sK(t) {
  let e = window.trustedTypes;
  return e ? (ap || (ap = e.createPolicy("ProseMirrorClipboard", { createHTML: (n) => n })), ap.createHTML(t)) : t;
}
function aK(t) {
  let e = /^(\s*<meta [^>]*>)*/.exec(t);
  e && (t = t.slice(e[0].length));
  let n = DN().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(t), i;
  if ((i = r && RN[r[1].toLowerCase()]) && (t = i.map((o) => "<" + o + ">").join("") + t + i.map((o) => "</" + o + ">").reverse().join("")), n.innerHTML = sK(t), i)
    for (let o = 0; o < i.length; o++)
      n = n.querySelector(i[o]) || n;
  return n;
}
function lK(t) {
  let e = t.querySelectorAll(It ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let n = 0; n < e.length; n++) {
    let r = e[n];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(t.ownerDocument.createTextNode(" "), r);
  }
}
function cK(t, e) {
  if (!t.size)
    return t;
  let n = t.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(e);
  } catch {
    return t;
  }
  let { content: i, openStart: o, openEnd: s } = t;
  for (let a = r.length - 2; a >= 0; a -= 2) {
    let l = n.nodes[r[a]];
    if (!l || l.hasRequiredAttrs())
      break;
    i = U.from(l.create(r[a + 1], i)), o++, s++;
  }
  return new ee(i, o, s);
}
const Gt = {}, Yt = {}, uK = { touchstart: !0, touchmove: !0 };
class dK {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function fK(t) {
  for (let e in Gt) {
    let n = Gt[e];
    t.dom.addEventListener(e, t.input.eventHandlers[e] = (r) => {
      pK(t, r) && !Uv(t, r) && (t.editable || !(r.type in Yt)) && n(t, r);
    }, uK[e] ? { passive: !0 } : void 0);
  }
  Kt && t.dom.addEventListener("input", () => null), Zm(t);
}
function ai(t, e) {
  t.input.lastSelectionOrigin = e, t.input.lastSelectionTime = Date.now();
}
function hK(t) {
  t.domObserver.stop();
  for (let e in t.input.eventHandlers)
    t.dom.removeEventListener(e, t.input.eventHandlers[e]);
  clearTimeout(t.input.composingTimeout), clearTimeout(t.input.lastIOSEnterFallbackTimeout);
}
function Zm(t) {
  t.someProp("handleDOMEvents", (e) => {
    for (let n in e)
      t.input.eventHandlers[n] || t.dom.addEventListener(n, t.input.eventHandlers[n] = (r) => Uv(t, r));
  });
}
function Uv(t, e) {
  return t.someProp("handleDOMEvents", (n) => {
    let r = n[e.type];
    return r ? r(t, e) || e.defaultPrevented : !1;
  });
}
function pK(t, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let n = e.target; n != t.dom; n = n.parentNode)
    if (!n || n.nodeType == 11 || n.pmViewDesc && n.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function mK(t, e) {
  !Uv(t, e) && Gt[e.type] && (t.editable || !(e.type in Yt)) && Gt[e.type](t, e);
}
Yt.keydown = (t, e) => {
  let n = e;
  if (t.input.shiftKey = n.keyCode == 16 || n.shiftKey, !_N(t, n) && (t.input.lastKeyCode = n.keyCode, t.input.lastKeyCodeTime = Date.now(), !(Rr && It && n.keyCode == 13)))
    if (n.keyCode != 229 && t.domObserver.forceFlush(), is && n.keyCode == 13 && !n.ctrlKey && !n.altKey && !n.metaKey) {
      let r = Date.now();
      t.input.lastIOSEnter = r, t.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        t.input.lastIOSEnter == r && (t.someProp("handleKeyDown", (i) => i(t, Bi(13, "Enter"))), t.input.lastIOSEnter = 0);
      }, 200);
    } else t.someProp("handleKeyDown", (r) => r(t, n)) || rK(t, n) ? n.preventDefault() : ai(t, "key");
};
Yt.keyup = (t, e) => {
  e.keyCode == 16 && (t.input.shiftKey = !1);
};
Yt.keypress = (t, e) => {
  let n = e;
  if (_N(t, n) || !n.charCode || n.ctrlKey && !n.altKey || Cn && n.metaKey)
    return;
  if (t.someProp("handleKeyPress", (i) => i(t, n))) {
    n.preventDefault();
    return;
  }
  let r = t.state.selection;
  if (!(r instanceof ge) || !r.$from.sameParent(r.$to)) {
    let i = String.fromCharCode(n.charCode);
    !/[\r\n]/.test(i) && !t.someProp("handleTextInput", (o) => o(t, r.$from.pos, r.$to.pos, i)) && t.dispatch(t.state.tr.insertText(i).scrollIntoView()), n.preventDefault();
  }
};
function Rd(t) {
  return { left: t.clientX, top: t.clientY };
}
function gK(t, e) {
  let n = e.x - t.clientX, r = e.y - t.clientY;
  return n * n + r * r < 100;
}
function qv(t, e, n, r, i) {
  if (r == -1)
    return !1;
  let o = t.state.doc.resolve(r);
  for (let s = o.depth + 1; s > 0; s--)
    if (t.someProp(e, (a) => s > o.depth ? a(t, n, o.nodeAfter, o.before(s), i, !0) : a(t, n, o.node(s), o.before(s), i, !1)))
      return !0;
  return !1;
}
function Ko(t, e, n) {
  if (t.focused || t.focus(), t.state.selection.eq(e))
    return;
  let r = t.state.tr.setSelection(e);
  r.setMeta("pointer", !0), t.dispatch(r);
}
function vK(t, e) {
  if (e == -1)
    return !1;
  let n = t.state.doc.resolve(e), r = n.nodeAfter;
  return r && r.isAtom && ye.isSelectable(r) ? (Ko(t, new ye(n)), !0) : !1;
}
function bK(t, e) {
  if (e == -1)
    return !1;
  let n = t.state.selection, r, i;
  n instanceof ye && (r = n.node);
  let o = t.state.doc.resolve(e);
  for (let s = o.depth + 1; s > 0; s--) {
    let a = s > o.depth ? o.nodeAfter : o.node(s);
    if (ye.isSelectable(a)) {
      r && n.$from.depth > 0 && s >= n.$from.depth && o.before(n.$from.depth + 1) == n.$from.pos ? i = o.before(n.$from.depth) : i = o.before(s);
      break;
    }
  }
  return i != null ? (Ko(t, ye.create(t.state.doc, i)), !0) : !1;
}
function yK(t, e, n, r, i) {
  return qv(t, "handleClickOn", e, n, r) || t.someProp("handleClick", (o) => o(t, e, r)) || (i ? bK(t, n) : vK(t, n));
}
function wK(t, e, n, r) {
  return qv(t, "handleDoubleClickOn", e, n, r) || t.someProp("handleDoubleClick", (i) => i(t, e, r));
}
function xK(t, e, n, r) {
  return qv(t, "handleTripleClickOn", e, n, r) || t.someProp("handleTripleClick", (i) => i(t, e, r)) || kK(t, n, r);
}
function kK(t, e, n) {
  if (n.button != 0)
    return !1;
  let r = t.state.doc;
  if (e == -1)
    return r.inlineContent ? (Ko(t, ge.create(r, 0, r.content.size)), !0) : !1;
  let i = r.resolve(e);
  for (let o = i.depth + 1; o > 0; o--) {
    let s = o > i.depth ? i.nodeAfter : i.node(o), a = i.before(o);
    if (s.inlineContent)
      Ko(t, ge.create(r, a + 1, a + 1 + s.content.size));
    else if (ye.isSelectable(s))
      Ko(t, ye.create(r, a));
    else
      continue;
    return !0;
  }
}
function Kv(t) {
  return eu(t);
}
const IN = Cn ? "metaKey" : "ctrlKey";
Gt.mousedown = (t, e) => {
  let n = e;
  t.input.shiftKey = n.shiftKey;
  let r = Kv(t), i = Date.now(), o = "singleClick";
  i - t.input.lastClick.time < 500 && gK(n, t.input.lastClick) && !n[IN] && (t.input.lastClick.type == "singleClick" ? o = "doubleClick" : t.input.lastClick.type == "doubleClick" && (o = "tripleClick")), t.input.lastClick = { time: i, x: n.clientX, y: n.clientY, type: o };
  let s = t.posAtCoords(Rd(n));
  s && (o == "singleClick" ? (t.input.mouseDown && t.input.mouseDown.done(), t.input.mouseDown = new CK(t, s, n, !!r)) : (o == "doubleClick" ? wK : xK)(t, s.pos, s.inside, n) ? n.preventDefault() : ai(t, "pointer"));
};
class CK {
  constructor(e, n, r, i) {
    this.view = e, this.pos = n, this.event = r, this.flushed = i, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!r[IN], this.allowDefault = r.shiftKey;
    let o, s;
    if (n.inside > -1)
      o = e.state.doc.nodeAt(n.inside), s = n.inside;
    else {
      let u = e.state.doc.resolve(n.pos);
      o = u.parent, s = u.depth ? u.before() : 0;
    }
    const a = i ? null : r.target, l = a ? e.docView.nearestDesc(a, !0) : null;
    this.target = l && l.dom.nodeType == 1 ? l.dom : null;
    let { selection: c } = e.state;
    (r.button == 0 && o.type.spec.draggable && o.type.spec.selectable !== !1 || c instanceof ye && c.from <= s && c.to > s) && (this.mightDrag = {
      node: o,
      pos: s,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Gn && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), ai(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => _r(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let n = this.pos;
    this.view.state.doc != this.startDoc && (n = this.view.posAtCoords(Rd(e))), this.updateAllowDefault(e), this.allowDefault || !n ? ai(this.view, "pointer") : yK(this.view, n.pos, n.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Kt && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    It && !this.view.state.selection.visible && Math.min(Math.abs(n.pos - this.view.state.selection.from), Math.abs(n.pos - this.view.state.selection.to)) <= 2) ? (Ko(this.view, be.near(this.view.state.doc.resolve(n.pos))), e.preventDefault()) : ai(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), ai(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
Gt.touchstart = (t) => {
  t.input.lastTouch = Date.now(), Kv(t), ai(t, "pointer");
};
Gt.touchmove = (t) => {
  t.input.lastTouch = Date.now(), ai(t, "pointer");
};
Gt.contextmenu = (t) => Kv(t);
function _N(t, e) {
  return t.composing ? !0 : Kt && Math.abs(e.timeStamp - t.input.compositionEndedAt) < 500 ? (t.input.compositionEndedAt = -2e8, !0) : !1;
}
const SK = Rr ? 5e3 : -1;
Yt.compositionstart = Yt.compositionupdate = (t) => {
  if (!t.composing) {
    t.domObserver.flush();
    let { state: e } = t, n = e.selection.$to;
    if (e.selection instanceof ge && (e.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1)))
      t.markCursor = t.state.storedMarks || n.marks(), eu(t, !0), t.markCursor = null;
    else if (eu(t, !e.selection.empty), Gn && e.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length) {
      let r = t.domSelectionRange();
      for (let i = r.focusNode, o = r.focusOffset; i && i.nodeType == 1 && o != 0; ) {
        let s = o < 0 ? i.lastChild : i.childNodes[o - 1];
        if (!s)
          break;
        if (s.nodeType == 3) {
          let a = t.domSelection();
          a && a.collapse(s, s.nodeValue.length);
          break;
        } else
          i = s, o = -1;
      }
    }
    t.input.composing = !0;
  }
  PN(t, SK);
};
Yt.compositionend = (t, e) => {
  t.composing && (t.input.composing = !1, t.input.compositionEndedAt = e.timeStamp, t.input.compositionPendingChanges = t.domObserver.pendingRecords().length ? t.input.compositionID : 0, t.input.compositionNode = null, t.input.compositionPendingChanges && Promise.resolve().then(() => t.domObserver.flush()), t.input.compositionID++, PN(t, 20));
};
function PN(t, e) {
  clearTimeout(t.input.composingTimeout), e > -1 && (t.input.composingTimeout = setTimeout(() => eu(t), e));
}
function LN(t) {
  for (t.composing && (t.input.composing = !1, t.input.compositionEndedAt = EK()); t.input.compositionNodes.length > 0; )
    t.input.compositionNodes.pop().markParentsDirty();
}
function TK(t) {
  let e = t.domSelectionRange();
  if (!e.focusNode)
    return null;
  let n = vq(e.focusNode, e.focusOffset), r = bq(e.focusNode, e.focusOffset);
  if (n && r && n != r) {
    let i = r.pmViewDesc, o = t.domObserver.lastChangedTextNode;
    if (n == o || r == o)
      return o;
    if (!i || !i.isText(r.nodeValue))
      return r;
    if (t.input.compositionNode == r) {
      let s = n.pmViewDesc;
      if (!(!s || !s.isText(n.nodeValue)))
        return r;
    }
  }
  return n || r;
}
function EK() {
  let t = document.createEvent("Event");
  return t.initEvent("event", !0, !0), t.timeStamp;
}
function eu(t, e = !1) {
  if (!(Rr && t.domObserver.flushingSoon >= 0)) {
    if (t.domObserver.forceFlush(), LN(t), e || t.docView && t.docView.dirty) {
      let n = Hv(t);
      return n && !n.eq(t.state.selection) ? t.dispatch(t.state.tr.setSelection(n)) : (t.markCursor || e) && !t.state.selection.empty ? t.dispatch(t.state.tr.deleteSelection()) : t.updateState(t.state), !0;
    }
    return !1;
  }
}
function MK(t, e) {
  if (!t.dom.parentNode)
    return;
  let n = t.dom.parentNode.appendChild(document.createElement("div"));
  n.appendChild(e), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), i = document.createRange();
  i.selectNodeContents(e), t.dom.blur(), r.removeAllRanges(), r.addRange(i), setTimeout(() => {
    n.parentNode && n.parentNode.removeChild(n), t.focus();
  }, 50);
}
const ka = tn && di < 15 || is && Cq < 604;
Gt.copy = Yt.cut = (t, e) => {
  let n = e, r = t.state.selection, i = n.type == "cut";
  if (r.empty)
    return;
  let o = ka ? null : n.clipboardData, s = r.content(), { dom: a, text: l } = jv(t, s);
  o ? (n.preventDefault(), o.clearData(), o.setData("text/html", a.innerHTML), o.setData("text/plain", l)) : MK(t, a), i && t.dispatch(t.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function OK(t) {
  return t.openStart == 0 && t.openEnd == 0 && t.content.childCount == 1 ? t.content.firstChild : null;
}
function AK(t, e) {
  if (!t.dom.parentNode)
    return;
  let n = t.input.shiftKey || t.state.selection.$from.parent.type.spec.code, r = t.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
  n || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let i = t.input.shiftKey && t.input.lastKeyCode != 45;
  setTimeout(() => {
    t.focus(), r.parentNode && r.parentNode.removeChild(r), n ? Ca(t, r.value, null, i, e) : Ca(t, r.textContent, r.innerHTML, i, e);
  }, 50);
}
function Ca(t, e, n, r, i) {
  let o = MN(t, e, n, r, t.state.selection.$from);
  if (t.someProp("handlePaste", (l) => l(t, i, o || ee.empty)))
    return !0;
  if (!o)
    return !1;
  let s = OK(o), a = s ? t.state.tr.replaceSelectionWith(s, r) : t.state.tr.replaceSelection(o);
  return t.dispatch(a.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function FN(t) {
  let e = t.getData("text/plain") || t.getData("Text");
  if (e)
    return e;
  let n = t.getData("text/uri-list");
  return n ? n.replace(/\r?\n/g, " ") : "";
}
Yt.paste = (t, e) => {
  let n = e;
  if (t.composing && !Rr)
    return;
  let r = ka ? null : n.clipboardData, i = t.input.shiftKey && t.input.lastKeyCode != 45;
  r && Ca(t, FN(r), r.getData("text/html"), i, n) ? n.preventDefault() : AK(t, n);
};
class $N {
  constructor(e, n, r) {
    this.slice = e, this.move = n, this.node = r;
  }
}
const BN = Cn ? "altKey" : "ctrlKey";
Gt.dragstart = (t, e) => {
  let n = e, r = t.input.mouseDown;
  if (r && r.done(), !n.dataTransfer)
    return;
  let i = t.state.selection, o = i.empty ? null : t.posAtCoords(Rd(n)), s;
  if (!(o && o.pos >= i.from && o.pos <= (i instanceof ye ? i.to - 1 : i.to))) {
    if (r && r.mightDrag)
      s = ye.create(t.state.doc, r.mightDrag.pos);
    else if (n.target && n.target.nodeType == 1) {
      let d = t.docView.nearestDesc(n.target, !0);
      d && d.node.type.spec.draggable && d != t.docView && (s = ye.create(t.state.doc, d.posBefore));
    }
  }
  let a = (s || t.state.selection).content(), { dom: l, text: c, slice: u } = jv(t, a);
  (!n.dataTransfer.files.length || !It || dN > 120) && n.dataTransfer.clearData(), n.dataTransfer.setData(ka ? "Text" : "text/html", l.innerHTML), n.dataTransfer.effectAllowed = "copyMove", ka || n.dataTransfer.setData("text/plain", c), t.dragging = new $N(u, !n[BN], s);
};
Gt.dragend = (t) => {
  let e = t.dragging;
  window.setTimeout(() => {
    t.dragging == e && (t.dragging = null);
  }, 50);
};
Yt.dragover = Yt.dragenter = (t, e) => e.preventDefault();
Yt.drop = (t, e) => {
  let n = e, r = t.dragging;
  if (t.dragging = null, !n.dataTransfer)
    return;
  let i = t.posAtCoords(Rd(n));
  if (!i)
    return;
  let o = t.state.doc.resolve(i.pos), s = r && r.slice;
  s ? t.someProp("transformPasted", (p) => {
    s = p(s, t);
  }) : s = MN(t, FN(n.dataTransfer), ka ? null : n.dataTransfer.getData("text/html"), !1, o);
  let a = !!(r && !n[BN]);
  if (t.someProp("handleDrop", (p) => p(t, n, s || ee.empty, a))) {
    n.preventDefault();
    return;
  }
  if (!s)
    return;
  n.preventDefault();
  let l = s ? nN(t.state.doc, o.pos, s) : o.pos;
  l == null && (l = o.pos);
  let c = t.state.tr;
  if (a) {
    let { node: p } = r;
    p ? p.replace(c) : c.deleteSelection();
  }
  let u = c.mapping.map(l), d = s.openStart == 0 && s.openEnd == 0 && s.content.childCount == 1, f = c.doc;
  if (d ? c.replaceRangeWith(u, u, s.content.firstChild) : c.replaceRange(u, u, s), c.doc.eq(f))
    return;
  let h = c.doc.resolve(u);
  if (d && ye.isSelectable(s.content.firstChild) && h.nodeAfter && h.nodeAfter.sameMarkup(s.content.firstChild))
    c.setSelection(new ye(h));
  else {
    let p = c.mapping.map(l);
    c.mapping.maps[c.mapping.maps.length - 1].forEach((m, b, y, k) => p = k), c.setSelection(Wv(t, h, c.doc.resolve(p)));
  }
  t.focus(), t.dispatch(c.setMeta("uiEvent", "drop"));
};
Gt.focus = (t) => {
  t.input.lastFocus = Date.now(), t.focused || (t.domObserver.stop(), t.dom.classList.add("ProseMirror-focused"), t.domObserver.start(), t.focused = !0, setTimeout(() => {
    t.docView && t.hasFocus() && !t.domObserver.currentSelection.eq(t.domSelectionRange()) && _r(t);
  }, 20));
};
Gt.blur = (t, e) => {
  let n = e;
  t.focused && (t.domObserver.stop(), t.dom.classList.remove("ProseMirror-focused"), t.domObserver.start(), n.relatedTarget && t.dom.contains(n.relatedTarget) && t.domObserver.currentSelection.clear(), t.focused = !1);
};
Gt.beforeinput = (t, e) => {
  if (It && Rr && e.inputType == "deleteContentBackward") {
    t.domObserver.flushSoon();
    let { domChangeCount: r } = t.input;
    setTimeout(() => {
      if (t.input.domChangeCount != r || (t.dom.blur(), t.focus(), t.someProp("handleKeyDown", (o) => o(t, Bi(8, "Backspace")))))
        return;
      let { $cursor: i } = t.state.selection;
      i && i.pos > 0 && t.dispatch(t.state.tr.delete(i.pos - 1, i.pos).scrollIntoView());
    }, 50);
  }
};
for (let t in Yt)
  Gt[t] = Yt[t];
function Sa(t, e) {
  if (t == e)
    return !0;
  for (let n in t)
    if (t[n] !== e[n])
      return !1;
  for (let n in e)
    if (!(n in t))
      return !1;
  return !0;
}
class tu {
  constructor(e, n) {
    this.toDOM = e, this.spec = n || Zi, this.side = this.spec.side || 0;
  }
  map(e, n, r, i) {
    let { pos: o, deleted: s } = e.mapResult(n.from + i, this.side < 0 ? -1 : 1);
    return s ? null : new jt(o - r, o - r, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof tu && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && Sa(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class hi {
  constructor(e, n) {
    this.attrs = e, this.spec = n || Zi;
  }
  map(e, n, r, i) {
    let o = e.map(n.from + i, this.spec.inclusiveStart ? -1 : 1) - r, s = e.map(n.to + i, this.spec.inclusiveEnd ? 1 : -1) - r;
    return o >= s ? null : new jt(o, s, this);
  }
  valid(e, n) {
    return n.from < n.to;
  }
  eq(e) {
    return this == e || e instanceof hi && Sa(this.attrs, e.attrs) && Sa(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof hi;
  }
  destroy() {
  }
}
class Gv {
  constructor(e, n) {
    this.attrs = e, this.spec = n || Zi;
  }
  map(e, n, r, i) {
    let o = e.mapResult(n.from + i, 1);
    if (o.deleted)
      return null;
    let s = e.mapResult(n.to + i, -1);
    return s.deleted || s.pos <= o.pos ? null : new jt(o.pos - r, s.pos - r, this);
  }
  valid(e, n) {
    let { index: r, offset: i } = e.content.findIndex(n.from), o;
    return i == n.from && !(o = e.child(r)).isText && i + o.nodeSize == n.to;
  }
  eq(e) {
    return this == e || e instanceof Gv && Sa(this.attrs, e.attrs) && Sa(this.spec, e.spec);
  }
  destroy() {
  }
}
class jt {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.from = e, this.to = n, this.type = r;
  }
  /**
  @internal
  */
  copy(e, n) {
    return new jt(e, n, this.type);
  }
  /**
  @internal
  */
  eq(e, n = 0) {
    return this.type.eq(e.type) && this.from + n == e.from && this.to + n == e.to;
  }
  /**
  @internal
  */
  map(e, n, r) {
    return this.type.map(e, this, n, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, n, r) {
    return new jt(e, e, new tu(n, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, n, r, i) {
    return new jt(e, n, new hi(r, i));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, n, r, i) {
    return new jt(e, n, new Gv(r, i));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof hi;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof tu;
  }
}
const _o = [], Zi = {};
class ot {
  /**
  @internal
  */
  constructor(e, n) {
    this.local = e.length ? e : _o, this.children = n.length ? n : _o;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, n) {
    return n.length ? nu(n, e, 0, Zi) : Nt;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, n, r) {
    let i = [];
    return this.findInner(e ?? 0, n ?? 1e9, i, 0, r), i;
  }
  findInner(e, n, r, i, o) {
    for (let s = 0; s < this.local.length; s++) {
      let a = this.local[s];
      a.from <= n && a.to >= e && (!o || o(a.spec)) && r.push(a.copy(a.from + i, a.to + i));
    }
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] < n && this.children[s + 1] > e) {
        let a = this.children[s] + 1;
        this.children[s + 2].findInner(e - a, n - a, r, i + a, o);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, n, r) {
    return this == Nt || e.maps.length == 0 ? this : this.mapInner(e, n, 0, 0, r || Zi);
  }
  /**
  @internal
  */
  mapInner(e, n, r, i, o) {
    let s;
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a].map(e, r, i);
      l && l.type.valid(n, l) ? (s || (s = [])).push(l) : o.onRemove && o.onRemove(this.local[a].spec);
    }
    return this.children.length ? NK(this.children, s || [], e, n, r, i, o) : s ? new ot(s.sort(Ji), _o) : Nt;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, n) {
    return n.length ? this == Nt ? ot.create(e, n) : this.addInner(e, n, 0) : this;
  }
  addInner(e, n, r) {
    let i, o = 0;
    e.forEach((a, l) => {
      let c = l + r, u;
      if (u = zN(n, a, c)) {
        for (i || (i = this.children.slice()); o < i.length && i[o] < l; )
          o += 3;
        i[o] == l ? i[o + 2] = i[o + 2].addInner(a, u, c + 1) : i.splice(o, 0, l, l + a.nodeSize, nu(u, a, c + 1, Zi)), o += 3;
      }
    });
    let s = VN(o ? HN(n) : n, -r);
    for (let a = 0; a < s.length; a++)
      s[a].type.valid(e, s[a]) || s.splice(a--, 1);
    return new ot(s.length ? this.local.concat(s).sort(Ji) : this.local, i || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == Nt ? this : this.removeInner(e, 0);
  }
  removeInner(e, n) {
    let r = this.children, i = this.local;
    for (let o = 0; o < r.length; o += 3) {
      let s, a = r[o] + n, l = r[o + 1] + n;
      for (let u = 0, d; u < e.length; u++)
        (d = e[u]) && d.from > a && d.to < l && (e[u] = null, (s || (s = [])).push(d));
      if (!s)
        continue;
      r == this.children && (r = this.children.slice());
      let c = r[o + 2].removeInner(s, a + 1);
      c != Nt ? r[o + 2] = c : (r.splice(o, 3), o -= 3);
    }
    if (i.length) {
      for (let o = 0, s; o < e.length; o++)
        if (s = e[o])
          for (let a = 0; a < i.length; a++)
            i[a].eq(s, n) && (i == this.local && (i = this.local.slice()), i.splice(a--, 1));
    }
    return r == this.children && i == this.local ? this : i.length || r.length ? new ot(i, r) : Nt;
  }
  forChild(e, n) {
    if (this == Nt)
      return this;
    if (n.isLeaf)
      return ot.empty;
    let r, i;
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] >= e) {
        this.children[a] == e && (r = this.children[a + 2]);
        break;
      }
    let o = e + 1, s = o + n.content.size;
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a];
      if (l.from < s && l.to > o && l.type instanceof hi) {
        let c = Math.max(o, l.from) - o, u = Math.min(s, l.to) - o;
        c < u && (i || (i = [])).push(l.copy(c, u));
      }
    }
    if (i) {
      let a = new ot(i.sort(Ji), _o);
      return r ? new ti([a, r]) : a;
    }
    return r || Nt;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof ot) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let n = 0; n < this.local.length; n++)
      if (!this.local[n].eq(e.local[n]))
        return !1;
    for (let n = 0; n < this.children.length; n += 3)
      if (this.children[n] != e.children[n] || this.children[n + 1] != e.children[n + 1] || !this.children[n + 2].eq(e.children[n + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return Yv(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == Nt)
      return _o;
    if (e.inlineContent || !this.local.some(hi.is))
      return this.local;
    let n = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof hi || n.push(this.local[r]);
    return n;
  }
  forEachSet(e) {
    e(this);
  }
}
ot.empty = new ot([], []);
ot.removeOverlap = Yv;
const Nt = ot.empty;
class ti {
  constructor(e) {
    this.members = e;
  }
  map(e, n) {
    const r = this.members.map((i) => i.map(e, n, Zi));
    return ti.from(r);
  }
  forChild(e, n) {
    if (n.isLeaf)
      return ot.empty;
    let r = [];
    for (let i = 0; i < this.members.length; i++) {
      let o = this.members[i].forChild(e, n);
      o != Nt && (o instanceof ti ? r = r.concat(o.members) : r.push(o));
    }
    return ti.from(r);
  }
  eq(e) {
    if (!(e instanceof ti) || e.members.length != this.members.length)
      return !1;
    for (let n = 0; n < this.members.length; n++)
      if (!this.members[n].eq(e.members[n]))
        return !1;
    return !0;
  }
  locals(e) {
    let n, r = !0;
    for (let i = 0; i < this.members.length; i++) {
      let o = this.members[i].localsInner(e);
      if (o.length)
        if (!n)
          n = o;
        else {
          r && (n = n.slice(), r = !1);
          for (let s = 0; s < o.length; s++)
            n.push(o[s]);
        }
    }
    return n ? Yv(r ? n : n.sort(Ji)) : _o;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return Nt;
      case 1:
        return e[0];
      default:
        return new ti(e.every((n) => n instanceof ot) ? e : e.reduce((n, r) => n.concat(r instanceof ot ? r : r.members), []));
    }
  }
  forEachSet(e) {
    for (let n = 0; n < this.members.length; n++)
      this.members[n].forEachSet(e);
  }
}
function NK(t, e, n, r, i, o, s) {
  let a = t.slice();
  for (let c = 0, u = o; c < n.maps.length; c++) {
    let d = 0;
    n.maps[c].forEach((f, h, p, m) => {
      let b = m - p - (h - f);
      for (let y = 0; y < a.length; y += 3) {
        let k = a[y + 1];
        if (k < 0 || f > k + u - d)
          continue;
        let C = a[y] + u - d;
        h >= C ? a[y + 1] = f <= C ? -2 : -1 : f >= u && b && (a[y] += b, a[y + 1] += b);
      }
      d += b;
    }), u = n.maps[c].map(u, -1);
  }
  let l = !1;
  for (let c = 0; c < a.length; c += 3)
    if (a[c + 1] < 0) {
      if (a[c + 1] == -2) {
        l = !0, a[c + 1] = -1;
        continue;
      }
      let u = n.map(t[c] + o), d = u - i;
      if (d < 0 || d >= r.content.size) {
        l = !0;
        continue;
      }
      let f = n.map(t[c + 1] + o, -1), h = f - i, { index: p, offset: m } = r.content.findIndex(d), b = r.maybeChild(p);
      if (b && m == d && m + b.nodeSize == h) {
        let y = a[c + 2].mapInner(n, b, u + 1, t[c] + o + 1, s);
        y != Nt ? (a[c] = d, a[c + 1] = h, a[c + 2] = y) : (a[c + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let c = RK(a, t, e, n, i, o, s), u = nu(c, r, 0, s);
    e = u.local;
    for (let d = 0; d < a.length; d += 3)
      a[d + 1] < 0 && (a.splice(d, 3), d -= 3);
    for (let d = 0, f = 0; d < u.children.length; d += 3) {
      let h = u.children[d];
      for (; f < a.length && a[f] < h; )
        f += 3;
      a.splice(f, 0, u.children[d], u.children[d + 1], u.children[d + 2]);
    }
  }
  return new ot(e.sort(Ji), a);
}
function VN(t, e) {
  if (!e || !t.length)
    return t;
  let n = [];
  for (let r = 0; r < t.length; r++) {
    let i = t[r];
    n.push(new jt(i.from + e, i.to + e, i.type));
  }
  return n;
}
function RK(t, e, n, r, i, o, s) {
  function a(l, c) {
    for (let u = 0; u < l.local.length; u++) {
      let d = l.local[u].map(r, i, c);
      d ? n.push(d) : s.onRemove && s.onRemove(l.local[u].spec);
    }
    for (let u = 0; u < l.children.length; u += 3)
      a(l.children[u + 2], l.children[u] + c + 1);
  }
  for (let l = 0; l < t.length; l += 3)
    t[l + 1] == -1 && a(t[l + 2], e[l] + o + 1);
  return n;
}
function zN(t, e, n) {
  if (e.isLeaf)
    return null;
  let r = n + e.nodeSize, i = null;
  for (let o = 0, s; o < t.length; o++)
    (s = t[o]) && s.from > n && s.to < r && ((i || (i = [])).push(s), t[o] = null);
  return i;
}
function HN(t) {
  let e = [];
  for (let n = 0; n < t.length; n++)
    t[n] != null && e.push(t[n]);
  return e;
}
function nu(t, e, n, r) {
  let i = [], o = !1;
  e.forEach((a, l) => {
    let c = zN(t, a, l + n);
    if (c) {
      o = !0;
      let u = nu(c, a, n + l + 1, r);
      u != Nt && i.push(l, l + a.nodeSize, u);
    }
  });
  let s = VN(o ? HN(t) : t, -n).sort(Ji);
  for (let a = 0; a < s.length; a++)
    s[a].type.valid(e, s[a]) || (r.onRemove && r.onRemove(s[a].spec), s.splice(a--, 1));
  return s.length || i.length ? new ot(s, i) : Nt;
}
function Ji(t, e) {
  return t.from - e.from || t.to - e.to;
}
function Yv(t) {
  let e = t;
  for (let n = 0; n < e.length - 1; n++) {
    let r = e[n];
    if (r.from != r.to)
      for (let i = n + 1; i < e.length; i++) {
        let o = e[i];
        if (o.from == r.from) {
          o.to != r.to && (e == t && (e = t.slice()), e[i] = o.copy(o.from, r.to), vk(e, i + 1, o.copy(r.to, o.to)));
          continue;
        } else {
          o.from < r.to && (e == t && (e = t.slice()), e[n] = r.copy(r.from, o.from), vk(e, i, r.copy(o.from, r.to)));
          break;
        }
      }
  }
  return e;
}
function vk(t, e, n) {
  for (; e < t.length && Ji(n, t[e]) > 0; )
    e++;
  t.splice(e, 0, n);
}
function lp(t) {
  let e = [];
  return t.someProp("decorations", (n) => {
    let r = n(t.state);
    r && r != Nt && e.push(r);
  }), t.cursorWrapper && e.push(ot.create(t.state.doc, [t.cursorWrapper.deco])), ti.from(e);
}
const DK = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, IK = tn && di <= 11;
class _K {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class PK {
  constructor(e, n) {
    this.view = e, this.handleDOMChange = n, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new _K(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let i = 0; i < r.length; i++)
        this.queue.push(r[i]);
      tn && di <= 11 && r.some((i) => i.type == "childList" && i.removedNodes.length || i.type == "characterData" && i.oldValue.length > i.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), IK && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, DK)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let n = 0; n < e.length; n++)
          this.queue.push(e[n]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (ck(this.view)) {
      if (this.suppressingSelectionUpdates)
        return _r(this.view);
      if (tn && di <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && oo(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let n = /* @__PURE__ */ new Set(), r;
    for (let o = e.focusNode; o; o = rs(o))
      n.add(o);
    for (let o = e.anchorNode; o; o = rs(o))
      if (n.has(o)) {
        r = o;
        break;
      }
    let i = r && this.view.docView.nearestDesc(r);
    if (i && i.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let n = this.pendingRecords();
    n.length && (this.queue = []);
    let r = e.domSelectionRange(), i = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && ck(e) && !this.ignoreSelectionChange(r), o = -1, s = -1, a = !1, l = [];
    if (e.editable)
      for (let u = 0; u < n.length; u++) {
        let d = this.registerMutation(n[u], l);
        d && (o = o < 0 ? d.from : Math.min(d.from, o), s = s < 0 ? d.to : Math.max(d.to, s), d.typeOver && (a = !0));
      }
    if (Gn && l.length) {
      let u = l.filter((d) => d.nodeName == "BR");
      if (u.length == 2) {
        let [d, f] = u;
        d.parentNode && d.parentNode.parentNode == f.parentNode ? f.remove() : d.remove();
      } else {
        let { focusNode: d } = this.currentSelection;
        for (let f of u) {
          let h = f.parentNode;
          h && h.nodeName == "LI" && (!d || $K(e, d) != h) && f.remove();
        }
      }
    }
    let c = null;
    o < 0 && i && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && Ad(r) && (c = Hv(e)) && c.eq(be.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, _r(e), this.currentSelection.set(r), e.scrollToSelection()) : (o > -1 || i) && (o > -1 && (e.docView.markDirty(o, s), LK(e)), this.handleDOMChange(o, s, a, l), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(r) || _r(e), this.currentSelection.set(r));
  }
  registerMutation(e, n) {
    if (n.indexOf(e.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (r == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !r || r.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let u = 0; u < e.addedNodes.length; u++) {
        let d = e.addedNodes[u];
        n.push(d), d.nodeType == 3 && (this.lastChangedTextNode = d);
      }
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(e.target))
        return { from: r.posBefore, to: r.posAfter };
      let i = e.previousSibling, o = e.nextSibling;
      if (tn && di <= 11 && e.addedNodes.length)
        for (let u = 0; u < e.addedNodes.length; u++) {
          let { previousSibling: d, nextSibling: f } = e.addedNodes[u];
          (!d || Array.prototype.indexOf.call(e.addedNodes, d) < 0) && (i = d), (!f || Array.prototype.indexOf.call(e.addedNodes, f) < 0) && (o = f);
        }
      let s = i && i.parentNode == e.target ? St(i) + 1 : 0, a = r.localPosFromDOM(e.target, s, -1), l = o && o.parentNode == e.target ? St(o) : e.target.childNodes.length, c = r.localPosFromDOM(e.target, l, 1);
      return { from: a, to: c };
    } else return e.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : (this.lastChangedTextNode = e.target, {
      from: r.posAtStart,
      to: r.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}
let bk = /* @__PURE__ */ new WeakMap(), yk = !1;
function LK(t) {
  if (!bk.has(t) && (bk.set(t, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(t.dom).whiteSpace) !== -1)) {
    if (t.requiresGeckoHackNode = Gn, yk)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), yk = !0;
  }
}
function wk(t, e) {
  let n = e.startContainer, r = e.startOffset, i = e.endContainer, o = e.endOffset, s = t.domAtPos(t.state.selection.anchor);
  return oo(s.node, s.offset, i, o) && ([n, r, i, o] = [i, o, n, r]), { anchorNode: n, anchorOffset: r, focusNode: i, focusOffset: o };
}
function FK(t, e) {
  if (e.getComposedRanges) {
    let i = e.getComposedRanges(t.root)[0];
    if (i)
      return wk(t, i);
  }
  let n;
  function r(i) {
    i.preventDefault(), i.stopImmediatePropagation(), n = i.getTargetRanges()[0];
  }
  return t.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), t.dom.removeEventListener("beforeinput", r, !0), n ? wk(t, n) : null;
}
function $K(t, e) {
  for (let n = e.parentNode; n && n != t.dom; n = n.parentNode) {
    let r = t.docView.nearestDesc(n, !0);
    if (r && r.node.isBlock)
      return n;
  }
  return null;
}
function BK(t, e, n) {
  let { node: r, fromOffset: i, toOffset: o, from: s, to: a } = t.docView.parseRange(e, n), l = t.domSelectionRange(), c, u = l.anchorNode;
  if (u && t.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (c = [{ node: u, offset: l.anchorOffset }], Ad(l) || c.push({ node: l.focusNode, offset: l.focusOffset })), It && t.input.lastKeyCode === 8)
    for (let b = o; b > i; b--) {
      let y = r.childNodes[b - 1], k = y.pmViewDesc;
      if (y.nodeName == "BR" && !k) {
        o = b;
        break;
      }
      if (!k || k.size)
        break;
    }
  let d = t.state.doc, f = t.someProp("domParser") || Wn.fromSchema(t.state.schema), h = d.resolve(s), p = null, m = f.parse(r, {
    topNode: h.parent,
    topMatch: h.parent.contentMatchAt(h.index()),
    topOpen: !0,
    from: i,
    to: o,
    preserveWhitespace: h.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: c,
    ruleFromNode: VK,
    context: h
  });
  if (c && c[0].pos != null) {
    let b = c[0].pos, y = c[1] && c[1].pos;
    y == null && (y = b), p = { anchor: b + s, head: y + s };
  }
  return { doc: m, sel: p, from: s, to: a };
}
function VK(t) {
  let e = t.pmViewDesc;
  if (e)
    return e.parseRule();
  if (t.nodeName == "BR" && t.parentNode) {
    if (Kt && /^(ul|ol)$/i.test(t.parentNode.nodeName)) {
      let n = document.createElement("div");
      return n.appendChild(document.createElement("li")), { skip: n };
    } else if (t.parentNode.lastChild == t || Kt && /^(tr|table)$/i.test(t.parentNode.nodeName))
      return { ignore: !0 };
  } else if (t.nodeName == "IMG" && t.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const zK = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function HK(t, e, n, r, i) {
  let o = t.input.compositionPendingChanges || (t.composing ? t.input.compositionID : 0);
  if (t.input.compositionPendingChanges = 0, e < 0) {
    let O = t.input.lastSelectionTime > Date.now() - 50 ? t.input.lastSelectionOrigin : null, L = Hv(t, O);
    if (L && !t.state.selection.eq(L)) {
      if (It && Rr && t.input.lastKeyCode === 13 && Date.now() - 100 < t.input.lastKeyCodeTime && t.someProp("handleKeyDown", (z) => z(t, Bi(13, "Enter"))))
        return;
      let $ = t.state.tr.setSelection(L);
      O == "pointer" ? $.setMeta("pointer", !0) : O == "key" && $.scrollIntoView(), o && $.setMeta("composition", o), t.dispatch($);
    }
    return;
  }
  let s = t.state.doc.resolve(e), a = s.sharedDepth(n);
  e = s.before(a + 1), n = t.state.doc.resolve(n).after(a + 1);
  let l = t.state.selection, c = BK(t, e, n), u = t.state.doc, d = u.slice(c.from, c.to), f, h;
  t.input.lastKeyCode === 8 && Date.now() - 100 < t.input.lastKeyCodeTime ? (f = t.state.selection.to, h = "end") : (f = t.state.selection.from, h = "start"), t.input.lastKeyCode = null;
  let p = UK(d.content, c.doc.content, c.from, f, h);
  if (p && t.input.domChangeCount++, (is && t.input.lastIOSEnter > Date.now() - 225 || Rr) && i.some((O) => O.nodeType == 1 && !zK.test(O.nodeName)) && (!p || p.endA >= p.endB) && t.someProp("handleKeyDown", (O) => O(t, Bi(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (!p)
    if (r && l instanceof ge && !l.empty && l.$head.sameParent(l.$anchor) && !t.composing && !(c.sel && c.sel.anchor != c.sel.head))
      p = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (c.sel) {
        let O = xk(t, t.state.doc, c.sel);
        if (O && !O.eq(t.state.selection)) {
          let L = t.state.tr.setSelection(O);
          o && L.setMeta("composition", o), t.dispatch(L);
        }
      }
      return;
    }
  t.state.selection.from < t.state.selection.to && p.start == p.endB && t.state.selection instanceof ge && (p.start > t.state.selection.from && p.start <= t.state.selection.from + 2 && t.state.selection.from >= c.from ? p.start = t.state.selection.from : p.endA < t.state.selection.to && p.endA >= t.state.selection.to - 2 && t.state.selection.to <= c.to && (p.endB += t.state.selection.to - p.endA, p.endA = t.state.selection.to)), tn && di <= 11 && p.endB == p.start + 1 && p.endA == p.start && p.start > c.from && c.doc.textBetween(p.start - c.from - 1, p.start - c.from + 1) == "  " && (p.start--, p.endA--, p.endB--);
  let m = c.doc.resolveNoCache(p.start - c.from), b = c.doc.resolveNoCache(p.endB - c.from), y = u.resolve(p.start), k = m.sameParent(b) && m.parent.inlineContent && y.end() >= p.endA, C;
  if ((is && t.input.lastIOSEnter > Date.now() - 225 && (!k || i.some((O) => O.nodeName == "DIV" || O.nodeName == "P")) || !k && m.pos < c.doc.content.size && !m.sameParent(b) && (C = be.findFrom(c.doc.resolve(m.pos + 1), 1, !0)) && C.head == b.pos) && t.someProp("handleKeyDown", (O) => O(t, Bi(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (t.state.selection.anchor > p.start && jK(u, p.start, p.endA, m, b) && t.someProp("handleKeyDown", (O) => O(t, Bi(8, "Backspace")))) {
    Rr && It && t.domObserver.suppressSelectionUpdates();
    return;
  }
  It && p.endB == p.start && (t.input.lastChromeDelete = Date.now()), Rr && !k && m.start() != b.start() && b.parentOffset == 0 && m.depth == b.depth && c.sel && c.sel.anchor == c.sel.head && c.sel.head == p.endA && (p.endB -= 2, b = c.doc.resolveNoCache(p.endB - c.from), setTimeout(() => {
    t.someProp("handleKeyDown", function(O) {
      return O(t, Bi(13, "Enter"));
    });
  }, 20));
  let x = p.start, S = p.endA, T, E, M;
  if (k) {
    if (m.pos == b.pos)
      tn && di <= 11 && m.parentOffset == 0 && (t.domObserver.suppressSelectionUpdates(), setTimeout(() => _r(t), 20)), T = t.state.tr.delete(x, S), E = u.resolve(p.start).marksAcross(u.resolve(p.endA));
    else if (
      // Adding or removing a mark
      p.endA == p.endB && (M = WK(m.parent.content.cut(m.parentOffset, b.parentOffset), y.parent.content.cut(y.parentOffset, p.endA - y.start())))
    )
      T = t.state.tr, M.type == "add" ? T.addMark(x, S, M.mark) : T.removeMark(x, S, M.mark);
    else if (m.parent.child(m.index()).isText && m.index() == b.index() - (b.textOffset ? 0 : 1)) {
      let O = m.parent.textBetween(m.parentOffset, b.parentOffset);
      if (t.someProp("handleTextInput", (L) => L(t, x, S, O)))
        return;
      T = t.state.tr.insertText(O, x, S);
    }
  }
  if (T || (T = t.state.tr.replace(x, S, c.doc.slice(p.start - c.from, p.endB - c.from))), c.sel) {
    let O = xk(t, T.doc, c.sel);
    O && !(It && t.composing && O.empty && (p.start != p.endB || t.input.lastChromeDelete < Date.now() - 100) && (O.head == x || O.head == T.mapping.map(S) - 1) || tn && O.empty && O.head == x) && T.setSelection(O);
  }
  E && T.ensureMarks(E), o && T.setMeta("composition", o), t.dispatch(T.scrollIntoView());
}
function xk(t, e, n) {
  return Math.max(n.anchor, n.head) > e.content.size ? null : Wv(t, e.resolve(n.anchor), e.resolve(n.head));
}
function WK(t, e) {
  let n = t.firstChild.marks, r = e.firstChild.marks, i = n, o = r, s, a, l;
  for (let u = 0; u < r.length; u++)
    i = r[u].removeFromSet(i);
  for (let u = 0; u < n.length; u++)
    o = n[u].removeFromSet(o);
  if (i.length == 1 && o.length == 0)
    a = i[0], s = "add", l = (u) => u.mark(a.addToSet(u.marks));
  else if (i.length == 0 && o.length == 1)
    a = o[0], s = "remove", l = (u) => u.mark(a.removeFromSet(u.marks));
  else
    return null;
  let c = [];
  for (let u = 0; u < e.childCount; u++)
    c.push(l(e.child(u)));
  if (U.from(c).eq(t))
    return { mark: a, type: s };
}
function jK(t, e, n, r, i) {
  if (
    // The content must have shrunk
    n - e <= i.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    cp(r, !0, !1) < i.pos
  )
    return !1;
  let o = t.resolve(e);
  if (!r.parent.isTextblock) {
    let a = o.nodeAfter;
    return a != null && n == e + a.nodeSize;
  }
  if (o.parentOffset < o.parent.content.size || !o.parent.isTextblock)
    return !1;
  let s = t.resolve(cp(o, !0, !0));
  return !s.parent.isTextblock || s.pos > n || cp(s, !0, !1) < n ? !1 : r.parent.content.cut(r.parentOffset).eq(s.parent.content);
}
function cp(t, e, n) {
  let r = t.depth, i = e ? t.end() : t.pos;
  for (; r > 0 && (e || t.indexAfter(r) == t.node(r).childCount); )
    r--, i++, e = !1;
  if (n) {
    let o = t.node(r).maybeChild(t.indexAfter(r));
    for (; o && !o.isLeaf; )
      o = o.firstChild, i++;
  }
  return i;
}
function UK(t, e, n, r, i) {
  let o = t.findDiffStart(e, n);
  if (o == null)
    return null;
  let { a: s, b: a } = t.findDiffEnd(e, n + t.size, n + e.size);
  if (i == "end") {
    let l = Math.max(0, o - Math.min(s, a));
    r -= s + l - o;
  }
  if (s < o && t.size < e.size) {
    let l = r <= o && r >= s ? o - r : 0;
    o -= l, o && o < e.size && kk(e.textBetween(o - 1, o + 1)) && (o += l ? 1 : -1), a = o + (a - s), s = o;
  } else if (a < o) {
    let l = r <= o && r >= a ? o - r : 0;
    o -= l, o && o < t.size && kk(t.textBetween(o - 1, o + 1)) && (o += l ? 1 : -1), s = o + (s - a), a = o;
  }
  return { start: o, endA: s, endB: a };
}
function kk(t) {
  if (t.length != 2)
    return !1;
  let e = t.charCodeAt(0), n = t.charCodeAt(1);
  return e >= 56320 && e <= 57343 && n >= 55296 && n <= 56319;
}
class qK {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, n) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new dK(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = n, this.state = n.state, this.directPlugins = n.plugins || [], this.directPlugins.forEach(Mk), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = Tk(this), Sk(this), this.nodeViews = Ek(this), this.docView = rk(this.state.doc, Ck(this), lp(this), this.dom, this), this.domObserver = new PK(this, (r, i, o, s) => HK(this, r, i, o, s)), this.domObserver.start(), fK(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let n in e)
        this._props[n] = e[n];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && Zm(this);
    let n = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(Mk), this.directPlugins = e.plugins), this.updateStateInner(e.state, n);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let n = {};
    for (let r in this._props)
      n[r] = this._props[r];
    n.state = this.state;
    for (let r in e)
      n[r] = e[r];
    this.update(n);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, n) {
    var r;
    let i = this.state, o = !1, s = !1;
    e.storedMarks && this.composing && (LN(this), s = !0), this.state = e;
    let a = i.plugins != e.plugins || this._props.plugins != n.plugins;
    if (a || this._props.plugins != n.plugins || this._props.nodeViews != n.nodeViews) {
      let h = Ek(this);
      GK(h, this.nodeViews) && (this.nodeViews = h, o = !0);
    }
    (a || n.handleDOMEvents != this._props.handleDOMEvents) && Zm(this), this.editable = Tk(this), Sk(this);
    let l = lp(this), c = Ck(this), u = i.plugins != e.plugins && !i.doc.eq(e.doc) ? "reset" : e.scrollToSelection > i.scrollToSelection ? "to selection" : "preserve", d = o || !this.docView.matchesNode(e.doc, c, l);
    (d || !e.selection.eq(i.selection)) && (s = !0);
    let f = u == "preserve" && s && this.dom.style.overflowAnchor == null && Eq(this);
    if (s) {
      this.domObserver.stop();
      let h = d && (tn || It) && !this.composing && !i.selection.empty && !e.selection.empty && KK(i.selection, e.selection);
      if (d) {
        let p = It ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = TK(this)), (o || !this.docView.update(e.doc, c, l, this)) && (this.docView.updateOuterDeco(c), this.docView.destroy(), this.docView = rk(e.doc, c, l, this.dom, this)), p && !this.trackWrites && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && Zq(this)) ? _r(this, h) : (SN(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(i), !((r = this.dragging) === null || r === void 0) && r.node && !i.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, i), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : f && Mq(f);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (n) => n(this))) if (this.state.selection instanceof ye) {
        let n = this.docView.domAfterPos(this.state.selection.from);
        n.nodeType == 1 && Jx(this, n.getBoundingClientRect(), e);
      } else
        Jx(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let n = 0; n < this.directPlugins.length; n++) {
        let r = this.directPlugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let n = 0; n < this.state.plugins.length; n++) {
        let r = this.state.plugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let n = 0; n < this.pluginViews.length; n++) {
        let r = this.pluginViews[n];
        r.update && r.update(this, e);
      }
  }
  updateDraggedNode(e, n) {
    let r = e.node, i = -1;
    if (this.state.doc.nodeAt(r.from) == r.node)
      i = r.from;
    else {
      let o = r.from + (this.state.doc.content.size - n.doc.content.size);
      (o > 0 && this.state.doc.nodeAt(o)) == r.node && (i = o);
    }
    this.dragging = new $N(e.slice, e.move, i < 0 ? void 0 : ye.create(this.state.doc, i));
  }
  someProp(e, n) {
    let r = this._props && this._props[e], i;
    if (r != null && (i = n ? n(r) : r))
      return i;
    for (let s = 0; s < this.directPlugins.length; s++) {
      let a = this.directPlugins[s].props[e];
      if (a != null && (i = n ? n(a) : a))
        return i;
    }
    let o = this.state.plugins;
    if (o)
      for (let s = 0; s < o.length; s++) {
        let a = o[s].props[e];
        if (a != null && (i = n ? n(a) : a))
          return i;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (tn) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && Oq(this.dom), _r(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let n = this.dom.parentNode; n; n = n.parentNode)
        if (n.nodeType == 9 || n.nodeType == 11 && n.host)
          return n.getSelection || (Object.getPrototypeOf(n).getSelection = () => n.ownerDocument.getSelection()), this._root = n;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return Iq(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, n = 1) {
    return gN(this, e, n);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, n = 0) {
    return this.docView.domFromPos(e, n);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let n = this.docView.descAt(e);
    return n ? n.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, n, r = -1) {
    let i = this.docView.posFromDOM(e, n, r);
    if (i == null)
      throw new RangeError("DOM position not inside the editor");
    return i;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, n) {
    return $q(this, n || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, n) {
    return Ca(this, "", e, !1, n || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, n) {
    return Ca(this, e, null, !0, n || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return jv(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (hK(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], lp(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, mq());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return mK(this, e);
  }
  /**
  Dispatch a transaction. Will call
  [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
  when given, and otherwise defaults to applying the transaction to
  the current state and calling
  [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
  This method is bound to the view instance, so that it can be
  easily passed around.
  */
  dispatch(e) {
    let n = this._props.dispatchTransaction;
    n ? n.call(this, e) : this.updateState(this.state.apply(e));
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? Kt && this.root.nodeType === 11 && wq(this.dom.ownerDocument) == this.dom && FK(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
function Ck(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(t.editable), t.someProp("attributes", (n) => {
    if (typeof n == "function" && (n = n(t.state)), n)
      for (let r in n)
        r == "class" ? e.class += " " + n[r] : r == "style" ? e.style = (e.style ? e.style + ";" : "") + n[r] : !e[r] && r != "contenteditable" && r != "nodeName" && (e[r] = String(n[r]));
  }), e.translate || (e.translate = "no"), [jt.node(0, t.state.doc.content.size, e)];
}
function Sk(t) {
  if (t.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), t.cursorWrapper = { dom: e, deco: jt.widget(t.state.selection.from, e, { raw: !0, marks: t.markCursor }) };
  } else
    t.cursorWrapper = null;
}
function Tk(t) {
  return !t.someProp("editable", (e) => e(t.state) === !1);
}
function KK(t, e) {
  let n = Math.min(t.$anchor.sharedDepth(t.head), e.$anchor.sharedDepth(e.head));
  return t.$anchor.start(n) != e.$anchor.start(n);
}
function Ek(t) {
  let e = /* @__PURE__ */ Object.create(null);
  function n(r) {
    for (let i in r)
      Object.prototype.hasOwnProperty.call(e, i) || (e[i] = r[i]);
  }
  return t.someProp("nodeViews", n), t.someProp("markViews", n), e;
}
function GK(t, e) {
  let n = 0, r = 0;
  for (let i in t) {
    if (t[i] != e[i])
      return !0;
    n++;
  }
  for (let i in e)
    r++;
  return n != r;
}
function Mk(t) {
  if (t.spec.state || t.spec.filterTransaction || t.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var wi = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, ru = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, YK = typeof navigator < "u" && /Mac/.test(navigator.platform), ZK = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Tt = 0; Tt < 10; Tt++) wi[48 + Tt] = wi[96 + Tt] = String(Tt);
for (var Tt = 1; Tt <= 24; Tt++) wi[Tt + 111] = "F" + Tt;
for (var Tt = 65; Tt <= 90; Tt++)
  wi[Tt] = String.fromCharCode(Tt + 32), ru[Tt] = String.fromCharCode(Tt);
for (var up in wi) ru.hasOwnProperty(up) || (ru[up] = wi[up]);
function JK(t) {
  var e = YK && t.metaKey && t.shiftKey && !t.ctrlKey && !t.altKey || ZK && t.shiftKey && t.key && t.key.length == 1 || t.key == "Unidentified", n = !e && t.key || (t.shiftKey ? ru : wi)[t.keyCode] || t.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
const XK = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function QK(t) {
  let e = t.split(/-(?!$)/), n = e[e.length - 1];
  n == "Space" && (n = " ");
  let r, i, o, s;
  for (let a = 0; a < e.length - 1; a++) {
    let l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      s = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      o = !0;
    else if (/^mod$/i.test(l))
      XK ? s = !0 : i = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return r && (n = "Alt-" + n), i && (n = "Ctrl-" + n), s && (n = "Meta-" + n), o && (n = "Shift-" + n), n;
}
function eG(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t)
    e[QK(n)] = t[n];
  return e;
}
function dp(t, e, n = !0) {
  return e.altKey && (t = "Alt-" + t), e.ctrlKey && (t = "Ctrl-" + t), e.metaKey && (t = "Meta-" + t), n && e.shiftKey && (t = "Shift-" + t), t;
}
function tG(t) {
  return new Ge({ props: { handleKeyDown: Zv(t) } });
}
function Zv(t) {
  let e = eG(t);
  return function(n, r) {
    let i = JK(r), o, s = e[dp(i, r)];
    if (s && s(n.state, n.dispatch, n))
      return !0;
    if (i.length == 1 && i != " ") {
      if (r.shiftKey) {
        let a = e[dp(i, r, !1)];
        if (a && a(n.state, n.dispatch, n))
          return !0;
      }
      if ((r.shiftKey || r.altKey || r.metaKey || i.charCodeAt(0) > 127) && (o = wi[r.keyCode]) && o != i) {
        let a = e[dp(o, r)];
        if (a && a(n.state, n.dispatch, n))
          return !0;
      }
    }
    return !1;
  };
}
const Dd = (t, e) => t.selection.empty ? !1 : (e && e(t.tr.deleteSelection().scrollIntoView()), !0);
function WN(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("backward", t) : n.parentOffset > 0) ? null : n;
}
const Jv = (t, e, n) => {
  let r = WN(t, n);
  if (!r)
    return !1;
  let i = Qv(r);
  if (!i) {
    let s = r.blockRange(), a = s && bo(s);
    return a == null ? !1 : (e && e(t.tr.lift(s, a).scrollIntoView()), !0);
  }
  let o = i.nodeBefore;
  if (QN(t, i, e, -1))
    return !0;
  if (r.parent.content.size == 0 && (ss(o, "end") || ye.isSelectable(o)))
    for (let s = r.depth; ; s--) {
      let a = Md(t.doc, r.before(s), r.after(s), ee.empty);
      if (a && a.slice.size < a.to - a.from) {
        if (e) {
          let l = t.tr.step(a);
          l.setSelection(ss(o, "end") ? be.findFrom(l.doc.resolve(l.mapping.map(i.pos, -1)), -1) : ye.create(l.doc, i.pos - o.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (s == 1 || r.node(s - 1).childCount > 1)
        break;
    }
  return o.isAtom && i.depth == r.depth - 1 ? (e && e(t.tr.delete(i.pos - o.nodeSize, i.pos).scrollIntoView()), !0) : !1;
}, jN = (t, e, n) => {
  let r = WN(t, n);
  if (!r)
    return !1;
  let i = Qv(r);
  return i ? qN(t, i, e) : !1;
}, UN = (t, e, n) => {
  let r = KN(t, n);
  if (!r)
    return !1;
  let i = nb(r);
  return i ? qN(t, i, e) : !1;
};
function qN(t, e, n) {
  let r = e.nodeBefore, i = r, o = e.pos - 1;
  for (; !i.isTextblock; o--) {
    if (i.type.spec.isolating)
      return !1;
    let u = i.lastChild;
    if (!u)
      return !1;
    i = u;
  }
  let s = e.nodeAfter, a = s, l = e.pos + 1;
  for (; !a.isTextblock; l++) {
    if (a.type.spec.isolating)
      return !1;
    let u = a.firstChild;
    if (!u)
      return !1;
    a = u;
  }
  let c = Md(t.doc, o, l, ee.empty);
  if (!c || c.from != o || c instanceof ht && c.slice.size >= l - o)
    return !1;
  if (n) {
    let u = t.tr.step(c);
    u.setSelection(ge.create(u.doc, o)), n(u.scrollIntoView());
  }
  return !0;
}
function ss(t, e, n = !1) {
  for (let r = t; r; r = e == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (n && r.childCount != 1)
      return !1;
  }
  return !1;
}
const Xv = (t, e, n) => {
  let { $head: r, empty: i } = t.selection, o = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", t) : r.parentOffset > 0)
      return !1;
    o = Qv(r);
  }
  let s = o && o.nodeBefore;
  return !s || !ye.isSelectable(s) ? !1 : (e && e(t.tr.setSelection(ye.create(t.doc, o.pos - s.nodeSize)).scrollIntoView()), !0);
};
function Qv(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      if (t.index(e) > 0)
        return t.doc.resolve(t.before(e + 1));
      if (t.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function KN(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("forward", t) : n.parentOffset < n.parent.content.size) ? null : n;
}
const eb = (t, e, n) => {
  let r = KN(t, n);
  if (!r)
    return !1;
  let i = nb(r);
  if (!i)
    return !1;
  let o = i.nodeAfter;
  if (QN(t, i, e, 1))
    return !0;
  if (r.parent.content.size == 0 && (ss(o, "start") || ye.isSelectable(o))) {
    let s = Md(t.doc, r.before(), r.after(), ee.empty);
    if (s && s.slice.size < s.to - s.from) {
      if (e) {
        let a = t.tr.step(s);
        a.setSelection(ss(o, "start") ? be.findFrom(a.doc.resolve(a.mapping.map(i.pos)), 1) : ye.create(a.doc, a.mapping.map(i.pos))), e(a.scrollIntoView());
      }
      return !0;
    }
  }
  return o.isAtom && i.depth == r.depth - 1 ? (e && e(t.tr.delete(i.pos, i.pos + o.nodeSize).scrollIntoView()), !0) : !1;
}, tb = (t, e, n) => {
  let { $head: r, empty: i } = t.selection, o = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("forward", t) : r.parentOffset < r.parent.content.size)
      return !1;
    o = nb(r);
  }
  let s = o && o.nodeAfter;
  return !s || !ye.isSelectable(s) ? !1 : (e && e(t.tr.setSelection(ye.create(t.doc, o.pos)).scrollIntoView()), !0);
};
function nb(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      let n = t.node(e);
      if (t.index(e) + 1 < n.childCount)
        return t.doc.resolve(t.after(e + 1));
      if (n.type.spec.isolating)
        break;
    }
  return null;
}
const GN = (t, e) => {
  let n = t.selection, r = n instanceof ye, i;
  if (r) {
    if (n.node.isTextblock || !mr(t.doc, n.from))
      return !1;
    i = n.from;
  } else if (i = Ts(t.doc, n.from, -1), i == null)
    return !1;
  if (e) {
    let o = t.tr.join(i);
    r && o.setSelection(ye.create(o.doc, i - t.doc.resolve(i).nodeBefore.nodeSize)), e(o.scrollIntoView());
  }
  return !0;
}, YN = (t, e) => {
  let n = t.selection, r;
  if (n instanceof ye) {
    if (n.node.isTextblock || !mr(t.doc, n.to))
      return !1;
    r = n.to;
  } else if (r = Ts(t.doc, n.to, 1), r == null)
    return !1;
  return e && e(t.tr.join(r).scrollIntoView()), !0;
}, ZN = (t, e) => {
  let { $from: n, $to: r } = t.selection, i = n.blockRange(r), o = i && bo(i);
  return o == null ? !1 : (e && e(t.tr.lift(i, o).scrollIntoView()), !0);
}, rb = (t, e) => {
  let { $head: n, $anchor: r } = t.selection;
  return !n.parent.type.spec.code || !n.sameParent(r) ? !1 : (e && e(t.tr.insertText(`
`).scrollIntoView()), !0);
};
function ib(t) {
  for (let e = 0; e < t.edgeCount; e++) {
    let { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
const JN = (t, e) => {
  let { $head: n, $anchor: r } = t.selection;
  if (!n.parent.type.spec.code || !n.sameParent(r))
    return !1;
  let i = n.node(-1), o = n.indexAfter(-1), s = ib(i.contentMatchAt(o));
  if (!s || !i.canReplaceWith(o, o, s))
    return !1;
  if (e) {
    let a = n.after(), l = t.tr.replaceWith(a, a, s.createAndFill());
    l.setSelection(be.near(l.doc.resolve(a), 1)), e(l.scrollIntoView());
  }
  return !0;
}, ob = (t, e) => {
  let n = t.selection, { $from: r, $to: i } = n;
  if (n instanceof en || r.parent.inlineContent || i.parent.inlineContent)
    return !1;
  let o = ib(i.parent.contentMatchAt(i.indexAfter()));
  if (!o || !o.isTextblock)
    return !1;
  if (e) {
    let s = (!r.parentOffset && i.index() < i.parent.childCount ? r : i).pos, a = t.tr.insert(s, o.createAndFill());
    a.setSelection(ge.create(a.doc, s + 1)), e(a.scrollIntoView());
  }
  return !0;
}, sb = (t, e) => {
  let { $cursor: n } = t.selection;
  if (!n || n.parent.content.size)
    return !1;
  if (n.depth > 1 && n.after() != n.end(-1)) {
    let o = n.before();
    if (pn(t.doc, o))
      return e && e(t.tr.split(o).scrollIntoView()), !0;
  }
  let r = n.blockRange(), i = r && bo(r);
  return i == null ? !1 : (e && e(t.tr.lift(r, i).scrollIntoView()), !0);
};
function nG(t) {
  return (e, n) => {
    let { $from: r, $to: i } = e.selection;
    if (e.selection instanceof ye && e.selection.node.isBlock)
      return !r.parentOffset || !pn(e.doc, r.pos) ? !1 : (n && n(e.tr.split(r.pos).scrollIntoView()), !0);
    if (!r.depth)
      return !1;
    let o = [], s, a, l = !1, c = !1;
    for (let h = r.depth; ; h--)
      if (r.node(h).isBlock) {
        l = r.end(h) == r.pos + (r.depth - h), c = r.start(h) == r.pos - (r.depth - h), a = ib(r.node(h - 1).contentMatchAt(r.indexAfter(h - 1))), o.unshift(l && a ? { type: a } : null), s = h;
        break;
      } else {
        if (h == 1)
          return !1;
        o.unshift(null);
      }
    let u = e.tr;
    (e.selection instanceof ge || e.selection instanceof en) && u.deleteSelection();
    let d = u.mapping.map(r.pos), f = pn(u.doc, d, o.length, o);
    if (f || (o[0] = a ? { type: a } : null, f = pn(u.doc, d, o.length, o)), u.split(d, o.length, o), !l && c && r.node(s).type != a) {
      let h = u.mapping.map(r.before(s)), p = u.doc.resolve(h);
      a && r.node(s - 1).canReplaceWith(p.index(), p.index() + 1, a) && u.setNodeMarkup(u.mapping.map(r.before(s)), a);
    }
    return n && n(u.scrollIntoView()), !0;
  };
}
const rG = nG(), XN = (t, e) => {
  let { $from: n, to: r } = t.selection, i, o = n.sharedDepth(r);
  return o == 0 ? !1 : (i = n.before(o), e && e(t.tr.setSelection(ye.create(t.doc, i))), !0);
};
function iG(t, e, n) {
  let r = e.nodeBefore, i = e.nodeAfter, o = e.index();
  return !r || !i || !r.type.compatibleContent(i.type) ? !1 : !r.content.size && e.parent.canReplace(o - 1, o) ? (n && n(t.tr.delete(e.pos - r.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(o, o + 1) || !(i.isTextblock || mr(t.doc, e.pos)) ? !1 : (n && n(t.tr.join(e.pos).scrollIntoView()), !0);
}
function QN(t, e, n, r) {
  let i = e.nodeBefore, o = e.nodeAfter, s, a, l = i.type.spec.isolating || o.type.spec.isolating;
  if (!l && iG(t, e, n))
    return !0;
  let c = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (c && (s = (a = i.contentMatchAt(i.childCount)).findWrapping(o.type)) && a.matchType(s[0] || o.type).validEnd) {
    if (n) {
      let h = e.pos + o.nodeSize, p = U.empty;
      for (let y = s.length - 1; y >= 0; y--)
        p = U.from(s[y].create(null, p));
      p = U.from(i.copy(p));
      let m = t.tr.step(new pt(e.pos - 1, h, e.pos, h, new ee(p, 1, 0), s.length, !0)), b = m.doc.resolve(h + 2 * s.length);
      b.nodeAfter && b.nodeAfter.type == i.type && mr(m.doc, b.pos) && m.join(b.pos), n(m.scrollIntoView());
    }
    return !0;
  }
  let u = o.type.spec.isolating || r > 0 && l ? null : be.findFrom(e, 1), d = u && u.$from.blockRange(u.$to), f = d && bo(d);
  if (f != null && f >= e.depth)
    return n && n(t.tr.lift(d, f).scrollIntoView()), !0;
  if (c && ss(o, "start", !0) && ss(i, "end")) {
    let h = i, p = [];
    for (; p.push(h), !h.isTextblock; )
      h = h.lastChild;
    let m = o, b = 1;
    for (; !m.isTextblock; m = m.firstChild)
      b++;
    if (h.canReplace(h.childCount, h.childCount, m.content)) {
      if (n) {
        let y = U.empty;
        for (let C = p.length - 1; C >= 0; C--)
          y = U.from(p[C].copy(y));
        let k = t.tr.step(new pt(e.pos - p.length, e.pos + o.nodeSize, e.pos + b, e.pos + o.nodeSize - b, new ee(y, p.length, 0), 0, !0));
        n(k.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function e3(t) {
  return function(e, n) {
    let r = e.selection, i = t < 0 ? r.$from : r.$to, o = i.depth;
    for (; i.node(o).isInline; ) {
      if (!o)
        return !1;
      o--;
    }
    return i.node(o).isTextblock ? (n && n(e.tr.setSelection(ge.create(e.doc, t < 0 ? i.start(o) : i.end(o)))), !0) : !1;
  };
}
const t3 = e3(-1), n3 = e3(1);
function r3(t, e = null) {
  return function(n, r) {
    let { $from: i, $to: o } = n.selection, s = i.blockRange(o), a = s && $v(s, t, e);
    return a ? (r && r(n.tr.wrap(s, a).scrollIntoView()), !0) : !1;
  };
}
function iu(t, e = null) {
  return function(n, r) {
    let i = !1;
    for (let o = 0; o < n.selection.ranges.length && !i; o++) {
      let { $from: { pos: s }, $to: { pos: a } } = n.selection.ranges[o];
      n.doc.nodesBetween(s, a, (l, c) => {
        if (i)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(t, e)))
          if (l.type == t)
            i = !0;
          else {
            let u = n.doc.resolve(c), d = u.index();
            i = u.parent.canReplaceWith(d, d + 1, t);
          }
      });
    }
    if (!i)
      return !1;
    if (r) {
      let o = n.tr;
      for (let s = 0; s < n.selection.ranges.length; s++) {
        let { $from: { pos: a }, $to: { pos: l } } = n.selection.ranges[s];
        o.setBlockType(a, l, t, e);
      }
      r(o.scrollIntoView());
    }
    return !0;
  };
}
function ab(...t) {
  return function(e, n, r) {
    for (let i = 0; i < t.length; i++)
      if (t[i](e, n, r))
        return !0;
    return !1;
  };
}
ab(Dd, Jv, Xv);
ab(Dd, eb, tb);
ab(rb, ob, sb, rG);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function i3(t, e = null) {
  return function(n, r) {
    let { $from: i, $to: o } = n.selection, s = i.blockRange(o);
    if (!s)
      return !1;
    let a = r ? n.tr : null;
    return oG(a, s, t, e) ? (r && r(a.scrollIntoView()), !0) : !1;
  };
}
function oG(t, e, n, r = null) {
  let i = !1, o = e, s = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(n) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let l = s.resolve(e.start - 2);
    o = new Zc(l, l, e.depth), e.endIndex < e.parent.childCount && (e = new Zc(e.$from, s.resolve(e.$to.end(e.depth)), e.depth)), i = !0;
  }
  let a = $v(o, n, r, e);
  return a ? (t && sG(t, e, a, i, n), !0) : !1;
}
function sG(t, e, n, r, i) {
  let o = U.empty;
  for (let u = n.length - 1; u >= 0; u--)
    o = U.from(n[u].type.create(n[u].attrs, o));
  t.step(new pt(e.start - (r ? 2 : 0), e.end, e.start, e.end, new ee(o, 0, 0), n.length, !0));
  let s = 0;
  for (let u = 0; u < n.length; u++)
    n[u].type == i && (s = u + 1);
  let a = n.length - s, l = e.start + n.length - (r ? 2 : 0), c = e.parent;
  for (let u = e.startIndex, d = e.endIndex, f = !0; u < d; u++, f = !1)
    !f && pn(t.doc, l, a) && (t.split(l, a), l += 2 * a), l += c.child(u).nodeSize;
  return t;
}
function o3(t) {
  return function(e, n) {
    let { $from: r, $to: i } = e.selection, o = r.blockRange(i, (s) => s.childCount > 0 && s.firstChild.type == t);
    return o ? n ? r.node(o.depth - 1).type == t ? aG(e, n, t, o) : lG(e, n, o) : !0 : !1;
  };
}
function aG(t, e, n, r) {
  let i = t.tr, o = r.end, s = r.$to.end(r.depth);
  o < s && (i.step(new pt(o - 1, s, o, s, new ee(U.from(n.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new Zc(i.doc.resolve(r.$from.pos), i.doc.resolve(s), r.depth));
  const a = bo(r);
  if (a == null)
    return !1;
  i.lift(r, a);
  let l = i.doc.resolve(i.mapping.map(o, -1) - 1);
  return mr(i.doc, l.pos) && l.nodeBefore.type == l.nodeAfter.type && i.join(l.pos), e(i.scrollIntoView()), !0;
}
function lG(t, e, n) {
  let r = t.tr, i = n.parent;
  for (let h = n.end, p = n.endIndex - 1, m = n.startIndex; p > m; p--)
    h -= i.child(p).nodeSize, r.delete(h - 1, h + 1);
  let o = r.doc.resolve(n.start), s = o.nodeAfter;
  if (r.mapping.map(n.end) != n.start + o.nodeAfter.nodeSize)
    return !1;
  let a = n.startIndex == 0, l = n.endIndex == i.childCount, c = o.node(-1), u = o.index(-1);
  if (!c.canReplace(u + (a ? 0 : 1), u + 1, s.content.append(l ? U.empty : U.from(i))))
    return !1;
  let d = o.pos, f = d + s.nodeSize;
  return r.step(new pt(d - (a ? 1 : 0), f + (l ? 1 : 0), d + 1, f - 1, new ee((a ? U.empty : U.from(i.copy(U.empty))).append(l ? U.empty : U.from(i.copy(U.empty))), a ? 0 : 1, l ? 0 : 1), a ? 0 : 1)), e(r.scrollIntoView()), !0;
}
function s3(t) {
  return function(e, n) {
    let { $from: r, $to: i } = e.selection, o = r.blockRange(i, (c) => c.childCount > 0 && c.firstChild.type == t);
    if (!o)
      return !1;
    let s = o.startIndex;
    if (s == 0)
      return !1;
    let a = o.parent, l = a.child(s - 1);
    if (l.type != t)
      return !1;
    if (n) {
      let c = l.lastChild && l.lastChild.type == a.type, u = U.from(c ? t.create() : null), d = new ee(U.from(t.create(null, U.from(a.type.create(null, u)))), c ? 3 : 1, 0), f = o.start, h = o.end;
      n(e.tr.step(new pt(f - (c ? 3 : 1), h, f, h, d, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function Id(t) {
  const { state: e, transaction: n } = t;
  let { selection: r } = n, { doc: i } = n, { storedMarks: o } = n;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return o;
    },
    get selection() {
      return r;
    },
    get doc() {
      return i;
    },
    get tr() {
      return r = n.selection, i = n.doc, o = n.storedMarks, n;
    }
  };
}
let _d = class {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: n, state: r } = this, { view: i } = n, { tr: o } = r, s = this.buildProps(o);
    return Object.fromEntries(Object.entries(e).map(([a, l]) => [a, (...u) => {
      const d = l(...u)(s);
      return !o.getMeta("preventDispatch") && !this.hasCustomState && i.dispatch(o), d;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, n = !0) {
    const { rawCommands: r, editor: i, state: o } = this, { view: s } = i, a = [], l = !!e, c = e || o.tr, u = () => (!l && n && !c.getMeta("preventDispatch") && !this.hasCustomState && s.dispatch(c), a.every((f) => f === !0)), d = {
      ...Object.fromEntries(Object.entries(r).map(([f, h]) => [f, (...m) => {
        const b = this.buildProps(c, n), y = h(...m)(b);
        return a.push(y), d;
      }])),
      run: u
    };
    return d;
  }
  createCan(e) {
    const { rawCommands: n, state: r } = this, i = !1, o = e || r.tr, s = this.buildProps(o, i);
    return {
      ...Object.fromEntries(Object.entries(n).map(([l, c]) => [l, (...u) => c(...u)({ ...s, dispatch: void 0 })])),
      chain: () => this.createChain(o, i)
    };
  }
  buildProps(e, n = !0) {
    const { rawCommands: r, editor: i, state: o } = this, { view: s } = i, a = {
      tr: e,
      editor: i,
      view: s,
      state: Id({
        state: o,
        transaction: e
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(e, n),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([l, c]) => [l, (...u) => c(...u)(a)]));
      }
    };
    return a;
  }
};
class cG {
  constructor() {
    this.callbacks = {};
  }
  on(e, n) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(n), this;
  }
  emit(e, ...n) {
    const r = this.callbacks[e];
    return r && r.forEach((i) => i.apply(this, n)), this;
  }
  off(e, n) {
    const r = this.callbacks[e];
    return r && (n ? this.callbacks[e] = r.filter((i) => i !== n) : delete this.callbacks[e]), this;
  }
  once(e, n) {
    const r = (...i) => {
      this.off(e, r), n.apply(this, i);
    };
    return this.on(e, r);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function ue(t, e, n) {
  return t.config[e] === void 0 && t.parent ? ue(t.parent, e, n) : typeof t.config[e] == "function" ? t.config[e].bind({
    ...n,
    parent: t.parent ? ue(t.parent, e, n) : null
  }) : t.config[e];
}
function Pd(t) {
  const e = t.filter((i) => i.type === "extension"), n = t.filter((i) => i.type === "node"), r = t.filter((i) => i.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: n,
    markExtensions: r
  };
}
function a3(t) {
  const e = [], { nodeExtensions: n, markExtensions: r } = Pd(t), i = [...n, ...r], o = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return t.forEach((s) => {
    const a = {
      name: s.name,
      options: s.options,
      storage: s.storage,
      extensions: i
    }, l = ue(s, "addGlobalAttributes", a);
    if (!l)
      return;
    l().forEach((u) => {
      u.types.forEach((d) => {
        Object.entries(u.attributes).forEach(([f, h]) => {
          e.push({
            type: d,
            name: f,
            attribute: {
              ...o,
              ...h
            }
          });
        });
      });
    });
  }), i.forEach((s) => {
    const a = {
      name: s.name,
      options: s.options,
      storage: s.storage
    }, l = ue(s, "addAttributes", a);
    if (!l)
      return;
    const c = l();
    Object.entries(c).forEach(([u, d]) => {
      const f = {
        ...o,
        ...d
      };
      typeof (f == null ? void 0 : f.default) == "function" && (f.default = f.default()), f != null && f.isRequired && (f == null ? void 0 : f.default) === void 0 && delete f.default, e.push({
        type: s.name,
        name: u,
        attribute: f
      });
    });
  }), e;
}
function xt(t, e) {
  if (typeof t == "string") {
    if (!e.nodes[t])
      throw Error(`There is no node type named '${t}'. Maybe you forgot to add the extension?`);
    return e.nodes[t];
  }
  return t;
}
function Ke(...t) {
  return t.filter((e) => !!e).reduce((e, n) => {
    const r = { ...e };
    return Object.entries(n).forEach(([i, o]) => {
      if (!r[i]) {
        r[i] = o;
        return;
      }
      if (i === "class") {
        const a = o ? String(o).split(" ") : [], l = r[i] ? r[i].split(" ") : [], c = a.filter((u) => !l.includes(u));
        r[i] = [...l, ...c].join(" ");
      } else if (i === "style") {
        const a = o ? o.split(";").map((u) => u.trim()).filter(Boolean) : [], l = r[i] ? r[i].split(";").map((u) => u.trim()).filter(Boolean) : [], c = /* @__PURE__ */ new Map();
        l.forEach((u) => {
          const [d, f] = u.split(":").map((h) => h.trim());
          c.set(d, f);
        }), a.forEach((u) => {
          const [d, f] = u.split(":").map((h) => h.trim());
          c.set(d, f);
        }), r[i] = Array.from(c.entries()).map(([u, d]) => `${u}: ${d}`).join("; ");
      } else
        r[i] = o;
    }), r;
  }, {});
}
function Jm(t, e) {
  return e.filter((n) => n.type === t.type.name).filter((n) => n.attribute.rendered).map((n) => n.attribute.renderHTML ? n.attribute.renderHTML(t.attrs) || {} : {
    [n.name]: t.attrs[n.name]
  }).reduce((n, r) => Ke(n, r), {});
}
function l3(t) {
  return typeof t == "function";
}
function Ae(t, e = void 0, ...n) {
  return l3(t) ? e ? t.bind(e)(...n) : t(...n) : t;
}
function uG(t = {}) {
  return Object.keys(t).length === 0 && t.constructor === Object;
}
function dG(t) {
  return typeof t != "string" ? t : t.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(t) : t === "true" ? !0 : t === "false" ? !1 : t;
}
function Ok(t, e) {
  return "style" in t ? t : {
    ...t,
    getAttrs: (n) => {
      const r = t.getAttrs ? t.getAttrs(n) : t.attrs;
      if (r === !1)
        return !1;
      const i = e.reduce((o, s) => {
        const a = s.attribute.parseHTML ? s.attribute.parseHTML(n) : dG(n.getAttribute(s.name));
        return a == null ? o : {
          ...o,
          [s.name]: a
        };
      }, {});
      return { ...r, ...i };
    }
  };
}
function Ak(t) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(t).filter(([e, n]) => e === "attrs" && uG(n) ? !1 : n != null)
  );
}
function fG(t, e) {
  var n;
  const r = a3(t), { nodeExtensions: i, markExtensions: o } = Pd(t), s = (n = i.find((c) => ue(c, "topNode"))) === null || n === void 0 ? void 0 : n.name, a = Object.fromEntries(i.map((c) => {
    const u = r.filter((y) => y.type === c.name), d = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      editor: e
    }, f = t.reduce((y, k) => {
      const C = ue(k, "extendNodeSchema", d);
      return {
        ...y,
        ...C ? C(c) : {}
      };
    }, {}), h = Ak({
      ...f,
      content: Ae(ue(c, "content", d)),
      marks: Ae(ue(c, "marks", d)),
      group: Ae(ue(c, "group", d)),
      inline: Ae(ue(c, "inline", d)),
      atom: Ae(ue(c, "atom", d)),
      selectable: Ae(ue(c, "selectable", d)),
      draggable: Ae(ue(c, "draggable", d)),
      code: Ae(ue(c, "code", d)),
      whitespace: Ae(ue(c, "whitespace", d)),
      linebreakReplacement: Ae(ue(c, "linebreakReplacement", d)),
      defining: Ae(ue(c, "defining", d)),
      isolating: Ae(ue(c, "isolating", d)),
      attrs: Object.fromEntries(u.map((y) => {
        var k;
        return [y.name, { default: (k = y == null ? void 0 : y.attribute) === null || k === void 0 ? void 0 : k.default }];
      }))
    }), p = Ae(ue(c, "parseHTML", d));
    p && (h.parseDOM = p.map((y) => Ok(y, u)));
    const m = ue(c, "renderHTML", d);
    m && (h.toDOM = (y) => m({
      node: y,
      HTMLAttributes: Jm(y, u)
    }));
    const b = ue(c, "renderText", d);
    return b && (h.toText = b), [c.name, h];
  })), l = Object.fromEntries(o.map((c) => {
    const u = r.filter((b) => b.type === c.name), d = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      editor: e
    }, f = t.reduce((b, y) => {
      const k = ue(y, "extendMarkSchema", d);
      return {
        ...b,
        ...k ? k(c) : {}
      };
    }, {}), h = Ak({
      ...f,
      inclusive: Ae(ue(c, "inclusive", d)),
      excludes: Ae(ue(c, "excludes", d)),
      group: Ae(ue(c, "group", d)),
      spanning: Ae(ue(c, "spanning", d)),
      code: Ae(ue(c, "code", d)),
      attrs: Object.fromEntries(u.map((b) => {
        var y;
        return [b.name, { default: (y = b == null ? void 0 : b.attribute) === null || y === void 0 ? void 0 : y.default }];
      }))
    }), p = Ae(ue(c, "parseHTML", d));
    p && (h.parseDOM = p.map((b) => Ok(b, u)));
    const m = ue(c, "renderHTML", d);
    return m && (h.toDOM = (b) => m({
      mark: b,
      HTMLAttributes: Jm(b, u)
    })), [c.name, h];
  }));
  return new Pv({
    topNode: s,
    nodes: a,
    marks: l
  });
}
function fp(t, e) {
  return e.nodes[t] || e.marks[t] || null;
}
function Nk(t, e) {
  return Array.isArray(e) ? e.some((n) => (typeof n == "string" ? n : n.name) === t.name) : e;
}
function lb(t, e) {
  const n = vo.fromSchema(e).serializeFragment(t), i = document.implementation.createHTMLDocument().createElement("div");
  return i.appendChild(n), i.innerHTML;
}
const hG = (t, e = 500) => {
  let n = "";
  const r = t.parentOffset;
  return t.parent.nodesBetween(Math.max(0, r - e), r, (i, o, s, a) => {
    var l, c;
    const u = ((c = (l = i.type.spec).toText) === null || c === void 0 ? void 0 : c.call(l, {
      node: i,
      pos: o,
      parent: s,
      index: a
    })) || i.textContent || "%leaf%";
    n += i.isAtom && !i.isText ? u : u.slice(0, Math.max(0, r - o));
  }), n;
};
function cb(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}
let Ld = class {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
};
const pG = (t, e) => {
  if (cb(e))
    return e.exec(t);
  const n = e(t);
  if (!n)
    return null;
  const r = [n.text];
  return r.index = n.index, r.input = t, r.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(n.replaceWith)), r;
};
function Bl(t) {
  var e;
  const { editor: n, from: r, to: i, text: o, rules: s, plugin: a } = t, { view: l } = n;
  if (l.composing)
    return !1;
  const c = l.state.doc.resolve(r);
  if (
    // check for code node
    c.parent.type.spec.code || !((e = c.nodeBefore || c.nodeAfter) === null || e === void 0) && e.marks.find((f) => f.type.spec.code)
  )
    return !1;
  let u = !1;
  const d = hG(c) + o;
  return s.forEach((f) => {
    if (u)
      return;
    const h = pG(d, f.find);
    if (!h)
      return;
    const p = l.state.tr, m = Id({
      state: l.state,
      transaction: p
    }), b = {
      from: r - (h[0].length - o.length),
      to: i
    }, { commands: y, chain: k, can: C } = new _d({
      editor: n,
      state: m
    });
    f.handler({
      state: m,
      range: b,
      match: h,
      commands: y,
      chain: k,
      can: C
    }) === null || !p.steps.length || (p.setMeta(a, {
      transform: p,
      from: r,
      to: i,
      text: o
    }), l.dispatch(p), u = !0);
  }), u;
}
function mG(t) {
  const { editor: e, rules: n } = t, r = new Ge({
    state: {
      init() {
        return null;
      },
      apply(i, o, s) {
        const a = i.getMeta(r);
        if (a)
          return a;
        const l = i.getMeta("applyInputRules");
        return !!l && setTimeout(() => {
          let { text: u } = l;
          typeof u == "string" ? u = u : u = lb(U.from(u), s.schema);
          const { from: d } = l, f = d + u.length;
          Bl({
            editor: e,
            from: d,
            to: f,
            text: u,
            rules: n,
            plugin: r
          });
        }), i.selectionSet || i.docChanged ? null : o;
      }
    },
    props: {
      handleTextInput(i, o, s, a) {
        return Bl({
          editor: e,
          from: o,
          to: s,
          text: a,
          rules: n,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (i) => (setTimeout(() => {
          const { $cursor: o } = i.state.selection;
          o && Bl({
            editor: e,
            from: o.pos,
            to: o.pos,
            text: "",
            rules: n,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(i, o) {
        if (o.key !== "Enter")
          return !1;
        const { $cursor: s } = i.state.selection;
        return s ? Bl({
          editor: e,
          from: s.pos,
          to: s.pos,
          text: `
`,
          rules: n,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function gG(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function Vl(t) {
  return gG(t) !== "Object" ? !1 : t.constructor === Object && Object.getPrototypeOf(t) === Object.prototype;
}
function Fd(t, e) {
  const n = { ...t };
  return Vl(t) && Vl(e) && Object.keys(e).forEach((r) => {
    Vl(e[r]) && Vl(t[r]) ? n[r] = Fd(t[r], e[r]) : n[r] = e[r];
  }), n;
}
class gn {
  constructor(e = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ae(ue(this, "addOptions", {
      name: this.name
    }))), this.storage = Ae(ue(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new gn(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Fd(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new gn(e);
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Ae(ue(n, "addOptions", {
      name: n.name
    })), n.storage = Ae(ue(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  static handleExit({ editor: e, mark: n }) {
    const { tr: r } = e.state, i = e.state.selection.$from;
    if (i.pos === i.end()) {
      const s = i.marks();
      if (!!!s.find((c) => (c == null ? void 0 : c.type.name) === n.name))
        return !1;
      const l = s.find((c) => (c == null ? void 0 : c.type.name) === n.name);
      return l && r.removeStoredMark(l), r.insertText(" ", i.pos), e.view.dispatch(r), !0;
    }
    return !1;
  }
}
function vG(t) {
  return typeof t == "number";
}
class c3 {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const bG = (t, e, n) => {
  if (cb(e))
    return [...t.matchAll(e)];
  const r = e(t, n);
  return r ? r.map((i) => {
    const o = [i.text];
    return o.index = i.index, o.input = t, o.data = i.data, i.replaceWith && (i.text.includes(i.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), o.push(i.replaceWith)), o;
  }) : [];
};
function yG(t) {
  const { editor: e, state: n, from: r, to: i, rule: o, pasteEvent: s, dropEvent: a } = t, { commands: l, chain: c, can: u } = new _d({
    editor: e,
    state: n
  }), d = [];
  return n.doc.nodesBetween(r, i, (h, p) => {
    if (!h.isTextblock || h.type.spec.code)
      return;
    const m = Math.max(r, p), b = Math.min(i, p + h.content.size), y = h.textBetween(m - p, b - p, void 0, "￼");
    bG(y, o.find, s).forEach((C) => {
      if (C.index === void 0)
        return;
      const x = m + C.index + 1, S = x + C[0].length, T = {
        from: n.tr.mapping.map(x),
        to: n.tr.mapping.map(S)
      }, E = o.handler({
        state: n,
        range: T,
        match: C,
        commands: l,
        chain: c,
        can: u,
        pasteEvent: s,
        dropEvent: a
      });
      d.push(E);
    });
  }), d.every((h) => h !== null);
}
let zl = null;
const wG = (t) => {
  var e;
  const n = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = n.clipboardData) === null || e === void 0 || e.setData("text/html", t), n;
};
function xG(t) {
  const { editor: e, rules: n } = t;
  let r = null, i = !1, o = !1, s = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, a;
  try {
    a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    a = null;
  }
  const l = ({ state: u, from: d, to: f, rule: h, pasteEvt: p }) => {
    const m = u.tr, b = Id({
      state: u,
      transaction: m
    });
    if (!(!yG({
      editor: e,
      state: b,
      from: Math.max(d - 1, 0),
      to: f.b - 1,
      rule: h,
      pasteEvent: p,
      dropEvent: a
    }) || !m.steps.length)) {
      try {
        a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        a = null;
      }
      return s = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, m;
    }
  };
  return n.map((u) => new Ge({
    // we register a global drag handler to track the current drag source element
    view(d) {
      const f = (p) => {
        var m;
        r = !((m = d.dom.parentElement) === null || m === void 0) && m.contains(p.target) ? d.dom.parentElement : null, r && (zl = e);
      }, h = () => {
        zl && (zl = null);
      };
      return window.addEventListener("dragstart", f), window.addEventListener("dragend", h), {
        destroy() {
          window.removeEventListener("dragstart", f), window.removeEventListener("dragend", h);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (d, f) => {
          if (o = r === d.dom.parentElement, a = f, !o) {
            const h = zl;
            h && setTimeout(() => {
              const p = h.state.selection;
              p && h.commands.deleteRange({ from: p.from, to: p.to });
            }, 10);
          }
          return !1;
        },
        paste: (d, f) => {
          var h;
          const p = (h = f.clipboardData) === null || h === void 0 ? void 0 : h.getData("text/html");
          return s = f, i = !!(p != null && p.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (d, f, h) => {
      const p = d[0], m = p.getMeta("uiEvent") === "paste" && !i, b = p.getMeta("uiEvent") === "drop" && !o, y = p.getMeta("applyPasteRules"), k = !!y;
      if (!m && !b && !k)
        return;
      if (k) {
        let { text: S } = y;
        typeof S == "string" ? S = S : S = lb(U.from(S), h.schema);
        const { from: T } = y, E = T + S.length, M = wG(S);
        return l({
          rule: u,
          state: h,
          from: T,
          to: { b: E },
          pasteEvt: M
        });
      }
      const C = f.doc.content.findDiffStart(h.doc.content), x = f.doc.content.findDiffEnd(h.doc.content);
      if (!(!vG(C) || !x || C === x.b))
        return l({
          rule: u,
          state: h,
          from: C,
          to: x,
          pasteEvt: s
        });
    }
  }));
}
function kG(t) {
  const e = t.filter((n, r) => t.indexOf(n) !== r);
  return Array.from(new Set(e));
}
class Vo {
  constructor(e, n) {
    this.splittableMarks = [], this.editor = n, this.extensions = Vo.resolve(e), this.schema = fG(this.extensions, n), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(e) {
    const n = Vo.sort(Vo.flatten(e)), r = kG(n.map((i) => i.name));
    return r.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${r.map((i) => `'${i}'`).join(", ")}]. This can lead to issues.`), n;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(e) {
    return e.map((n) => {
      const r = {
        name: n.name,
        options: n.options,
        storage: n.storage
      }, i = ue(n, "addExtensions", r);
      return i ? [n, ...this.flatten(i())] : n;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(e) {
    return e.sort((r, i) => {
      const o = ue(r, "priority") || 100, s = ue(i, "priority") || 100;
      return o > s ? -1 : o < s ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, n) => {
      const r = {
        name: n.name,
        options: n.options,
        storage: n.storage,
        editor: this.editor,
        type: fp(n.name, this.schema)
      }, i = ue(n, "addCommands", r);
      return i ? {
        ...e,
        ...i()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this, n = Vo.sort([...this.extensions].reverse()), r = [], i = [], o = n.map((s) => {
      const a = {
        name: s.name,
        options: s.options,
        storage: s.storage,
        editor: e,
        type: fp(s.name, this.schema)
      }, l = [], c = ue(s, "addKeyboardShortcuts", a);
      let u = {};
      if (s.type === "mark" && ue(s, "exitable", a) && (u.ArrowRight = () => gn.handleExit({ editor: e, mark: s })), c) {
        const m = Object.fromEntries(Object.entries(c()).map(([b, y]) => [b, () => y({ editor: e })]));
        u = { ...u, ...m };
      }
      const d = tG(u);
      l.push(d);
      const f = ue(s, "addInputRules", a);
      Nk(s, e.options.enableInputRules) && f && r.push(...f());
      const h = ue(s, "addPasteRules", a);
      Nk(s, e.options.enablePasteRules) && h && i.push(...h());
      const p = ue(s, "addProseMirrorPlugins", a);
      if (p) {
        const m = p();
        l.push(...m);
      }
      return l;
    }).flat();
    return [
      mG({
        editor: e,
        rules: r
      }),
      ...xG({
        editor: e,
        rules: i
      }),
      ...o
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return a3(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: n } = Pd(this.extensions);
    return Object.fromEntries(n.filter((r) => !!ue(r, "addNodeView")).map((r) => {
      const i = this.attributes.filter((l) => l.type === r.name), o = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: e,
        type: xt(r.name, this.schema)
      }, s = ue(r, "addNodeView", o);
      if (!s)
        return [];
      const a = (l, c, u, d, f) => {
        const h = Jm(l, i);
        return s()({
          // pass-through
          node: l,
          view: c,
          getPos: u,
          decorations: d,
          innerDecorations: f,
          // tiptap-specific
          editor: e,
          extension: r,
          HTMLAttributes: h
        });
      };
      return [r.name, a];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((e) => {
      var n;
      this.editor.extensionStorage[e.name] = e.storage;
      const r = {
        name: e.name,
        options: e.options,
        storage: e.storage,
        editor: this.editor,
        type: fp(e.name, this.schema)
      };
      e.type === "mark" && (!((n = Ae(ue(e, "keepOnSplit", r))) !== null && n !== void 0) || n) && this.splittableMarks.push(e.name);
      const i = ue(e, "onBeforeCreate", r), o = ue(e, "onCreate", r), s = ue(e, "onUpdate", r), a = ue(e, "onSelectionUpdate", r), l = ue(e, "onTransaction", r), c = ue(e, "onFocus", r), u = ue(e, "onBlur", r), d = ue(e, "onDestroy", r);
      i && this.editor.on("beforeCreate", i), o && this.editor.on("create", o), s && this.editor.on("update", s), a && this.editor.on("selectionUpdate", a), l && this.editor.on("transaction", l), c && this.editor.on("focus", c), u && this.editor.on("blur", u), d && this.editor.on("destroy", d);
    });
  }
}
let gt = class Xm {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ae(ue(this, "addOptions", {
      name: this.name
    }))), this.storage = Ae(ue(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Xm(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Fd(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new Xm({ ...this.config, ...e });
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Ae(ue(n, "addOptions", {
      name: n.name
    })), n.storage = Ae(ue(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
};
function u3(t, e, n) {
  const { from: r, to: i } = e, { blockSeparator: o = `

`, textSerializers: s = {} } = n || {};
  let a = "";
  return t.nodesBetween(r, i, (l, c, u, d) => {
    var f;
    l.isBlock && c > r && (a += o);
    const h = s == null ? void 0 : s[l.type.name];
    if (h)
      return u && (a += h({
        node: l,
        pos: c,
        parent: u,
        index: d,
        range: e
      })), !1;
    l.isText && (a += (f = l == null ? void 0 : l.text) === null || f === void 0 ? void 0 : f.slice(Math.max(r, c) - c, i - c));
  }), a;
}
function d3(t) {
  return Object.fromEntries(Object.entries(t.nodes).filter(([, e]) => e.spec.toText).map(([e, n]) => [e, n.spec.toText]));
}
const CG = gt.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Ge({
        key: new tt("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: t } = this, { state: e, schema: n } = t, { doc: r, selection: i } = e, { ranges: o } = i, s = Math.min(...o.map((u) => u.$from.pos)), a = Math.max(...o.map((u) => u.$to.pos)), l = d3(n);
            return u3(r, { from: s, to: a }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), SG = () => ({ editor: t, view: e }) => (requestAnimationFrame(() => {
  var n;
  t.isDestroyed || (e.dom.blur(), (n = window == null ? void 0 : window.getSelection()) === null || n === void 0 || n.removeAllRanges());
}), !0), TG = (t = !1) => ({ commands: e }) => e.setContent("", t), EG = () => ({ state: t, tr: e, dispatch: n }) => {
  const { selection: r } = e, { ranges: i } = r;
  return n && i.forEach(({ $from: o, $to: s }) => {
    t.doc.nodesBetween(o.pos, s.pos, (a, l) => {
      if (a.type.isText)
        return;
      const { doc: c, mapping: u } = e, d = c.resolve(u.map(l)), f = c.resolve(u.map(l + a.nodeSize)), h = d.blockRange(f);
      if (!h)
        return;
      const p = bo(h);
      if (a.type.isTextblock) {
        const { defaultType: m } = d.parent.contentMatchAt(d.index());
        e.setNodeMarkup(h.start, m);
      }
      (p || p === 0) && e.lift(h, p);
    });
  }), !0;
}, MG = (t) => (e) => t(e), OG = () => ({ state: t, dispatch: e }) => ob(t, e), AG = (t, e) => ({ editor: n, tr: r }) => {
  const { state: i } = n, o = i.doc.slice(t.from, t.to);
  r.deleteRange(t.from, t.to);
  const s = r.mapping.map(e);
  return r.insert(s, o.content), r.setSelection(new ge(r.doc.resolve(s - 1))), !0;
}, NG = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, r = n.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const i = t.selection.$anchor;
  for (let o = i.depth; o > 0; o -= 1)
    if (i.node(o).type === r.type) {
      if (e) {
        const a = i.before(o), l = i.after(o);
        t.delete(a, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, RG = (t) => ({ tr: e, state: n, dispatch: r }) => {
  const i = xt(t, n.schema), o = e.selection.$anchor;
  for (let s = o.depth; s > 0; s -= 1)
    if (o.node(s).type === i) {
      if (r) {
        const l = o.before(s), c = o.after(s);
        e.delete(l, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, DG = (t) => ({ tr: e, dispatch: n }) => {
  const { from: r, to: i } = t;
  return n && e.delete(r, i), !0;
}, IG = () => ({ state: t, dispatch: e }) => Dd(t, e), _G = () => ({ commands: t }) => t.keyboardShortcut("Enter"), PG = () => ({ state: t, dispatch: e }) => JN(t, e);
function ou(t, e, n = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((i) => n.strict ? e[i] === t[i] : cb(e[i]) ? e[i].test(t[i]) : e[i] === t[i]) : !0;
}
function f3(t, e, n = {}) {
  return t.find((r) => r.type === e && ou(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(n).map((i) => [i, r.attrs[i]])),
    n
  ));
}
function Rk(t, e, n = {}) {
  return !!f3(t, e, n);
}
function ub(t, e, n) {
  var r;
  if (!t || !e)
    return;
  let i = t.parent.childAfter(t.parentOffset);
  if ((!i.node || !i.node.marks.some((u) => u.type === e)) && (i = t.parent.childBefore(t.parentOffset)), !i.node || !i.node.marks.some((u) => u.type === e) || (n = n || ((r = i.node.marks[0]) === null || r === void 0 ? void 0 : r.attrs), !f3([...i.node.marks], e, n)))
    return;
  let s = i.index, a = t.start() + i.offset, l = s + 1, c = a + i.node.nodeSize;
  for (; s > 0 && Rk([...t.parent.child(s - 1).marks], e, n); )
    s -= 1, a -= t.parent.child(s).nodeSize;
  for (; l < t.parent.childCount && Rk([...t.parent.child(l).marks], e, n); )
    c += t.parent.child(l).nodeSize, l += 1;
  return {
    from: a,
    to: c
  };
}
function Ai(t, e) {
  if (typeof t == "string") {
    if (!e.marks[t])
      throw Error(`There is no mark type named '${t}'. Maybe you forgot to add the extension?`);
    return e.marks[t];
  }
  return t;
}
const LG = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  const o = Ai(t, r.schema), { doc: s, selection: a } = n, { $from: l, from: c, to: u } = a;
  if (i) {
    const d = ub(l, o, e);
    if (d && d.from <= c && d.to >= u) {
      const f = ge.create(s, d.from, d.to);
      n.setSelection(f);
    }
  }
  return !0;
}, FG = (t) => (e) => {
  const n = typeof t == "function" ? t(e) : t;
  for (let r = 0; r < n.length; r += 1)
    if (n[r](e))
      return !0;
  return !1;
};
function db(t) {
  return t instanceof ge;
}
function Dr(t = 0, e = 0, n = 0) {
  return Math.min(Math.max(t, e), n);
}
function h3(t, e = null) {
  if (!e)
    return null;
  const n = be.atStart(t), r = be.atEnd(t);
  if (e === "start" || e === !0)
    return n;
  if (e === "end")
    return r;
  const i = n.from, o = r.to;
  return e === "all" ? ge.create(t, Dr(0, i, o), Dr(t.content.size, i, o)) : ge.create(t, Dr(e, i, o), Dr(e, i, o));
}
function $G() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function fb() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const BG = (t = null, e = {}) => ({ editor: n, view: r, tr: i, dispatch: o }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const s = () => {
    (fb() || $G()) && r.dom.focus(), requestAnimationFrame(() => {
      n.isDestroyed || (r.focus(), e != null && e.scrollIntoView && n.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && t === null || t === !1)
    return !0;
  if (o && t === null && !db(n.state.selection))
    return s(), !0;
  const a = h3(i.doc, t) || n.state.selection, l = n.state.selection.eq(a);
  return o && (l || i.setSelection(a), l && i.storedMarks && i.setStoredMarks(i.storedMarks), s()), !0;
}, VG = (t, e) => (n) => t.every((r, i) => e(r, { ...n, index: i })), zG = (t, e) => ({ tr: n, commands: r }) => r.insertContentAt({ from: n.selection.from, to: n.selection.to }, t, e), p3 = (t) => {
  const e = t.childNodes;
  for (let n = e.length - 1; n >= 0; n -= 1) {
    const r = e[n];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? t.removeChild(r) : r.nodeType === 1 && p3(r);
  }
  return t;
};
function Hl(t) {
  const e = `<body>${t}</body>`, n = new window.DOMParser().parseFromString(e, "text/html").body;
  return p3(n);
}
function su(t, e, n) {
  if (t instanceof Ir || t instanceof U)
    return t;
  n = {
    slice: !0,
    parseOptions: {},
    ...n
  };
  const r = typeof t == "object" && t !== null, i = typeof t == "string";
  if (r)
    try {
      if (Array.isArray(t) && t.length > 0)
        return U.fromArray(t.map((a) => e.nodeFromJSON(a)));
      const s = e.nodeFromJSON(t);
      return n.errorOnInvalidContent && s.check(), s;
    } catch (o) {
      if (n.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: o });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", t, "Error:", o), su("", e, n);
    }
  if (i) {
    if (n.errorOnInvalidContent) {
      let s = !1, a = "";
      const l = new Pv({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (s = !0, a = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (n.slice ? Wn.fromSchema(l).parseSlice(Hl(t), n.parseOptions) : Wn.fromSchema(l).parse(Hl(t), n.parseOptions), n.errorOnInvalidContent && s)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${a}`) });
    }
    const o = Wn.fromSchema(e);
    return n.slice ? o.parseSlice(Hl(t), n.parseOptions).content : o.parse(Hl(t), n.parseOptions);
  }
  return su("", e, n);
}
function HG(t, e, n) {
  const r = t.steps.length - 1;
  if (r < e)
    return;
  const i = t.steps[r];
  if (!(i instanceof ht || i instanceof pt))
    return;
  const o = t.mapping.maps[r];
  let s = 0;
  o.forEach((a, l, c, u) => {
    s === 0 && (s = u);
  }), t.setSelection(be.near(t.doc.resolve(s), n));
}
const WG = (t) => !("type" in t), jG = (t, e, n) => ({ tr: r, dispatch: i, editor: o }) => {
  var s;
  if (i) {
    n = {
      parseOptions: o.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...n
    };
    let a;
    try {
      a = su(e, o.schema, {
        parseOptions: {
          preserveWhitespace: "full",
          ...n.parseOptions
        },
        errorOnInvalidContent: (s = n.errorOnInvalidContent) !== null && s !== void 0 ? s : o.options.enableContentCheck
      });
    } catch (p) {
      return o.emit("contentError", {
        editor: o,
        error: p,
        disableCollaboration: () => {
          o.storage.collaboration && (o.storage.collaboration.isDisabled = !0);
        }
      }), !1;
    }
    let { from: l, to: c } = typeof t == "number" ? { from: t, to: t } : { from: t.from, to: t.to }, u = !0, d = !0;
    if ((WG(a) ? a : [a]).forEach((p) => {
      p.check(), u = u ? p.isText && p.marks.length === 0 : !1, d = d ? p.isBlock : !1;
    }), l === c && d) {
      const { parent: p } = r.doc.resolve(l);
      p.isTextblock && !p.type.spec.code && !p.childCount && (l -= 1, c += 1);
    }
    let h;
    if (u) {
      if (Array.isArray(e))
        h = e.map((p) => p.text || "").join("");
      else if (e instanceof U) {
        let p = "";
        e.forEach((m) => {
          m.text && (p += m.text);
        }), h = p;
      } else typeof e == "object" && e && e.text ? h = e.text : h = e;
      r.insertText(h, l, c);
    } else
      h = a, r.replaceWith(l, c, h);
    n.updateSelection && HG(r, r.steps.length - 1, -1), n.applyInputRules && r.setMeta("applyInputRules", { from: l, text: h }), n.applyPasteRules && r.setMeta("applyPasteRules", { from: l, text: h });
  }
  return !0;
}, UG = () => ({ state: t, dispatch: e }) => GN(t, e), qG = () => ({ state: t, dispatch: e }) => YN(t, e), KG = () => ({ state: t, dispatch: e }) => Jv(t, e), GG = () => ({ state: t, dispatch: e }) => eb(t, e), YG = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = Ts(t.doc, t.selection.$from.pos, -1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, ZG = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = Ts(t.doc, t.selection.$from.pos, 1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, JG = () => ({ state: t, dispatch: e }) => jN(t, e), XG = () => ({ state: t, dispatch: e }) => UN(t, e);
function m3() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function QG(t) {
  const e = t.split(/-(?!$)/);
  let n = e[e.length - 1];
  n === "Space" && (n = " ");
  let r, i, o, s;
  for (let a = 0; a < e.length - 1; a += 1) {
    const l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      s = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      o = !0;
    else if (/^mod$/i.test(l))
      fb() || m3() ? s = !0 : i = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return r && (n = `Alt-${n}`), i && (n = `Ctrl-${n}`), s && (n = `Meta-${n}`), o && (n = `Shift-${n}`), n;
}
const eY = (t) => ({ editor: e, view: n, tr: r, dispatch: i }) => {
  const o = QG(t).split(/-(?!$)/), s = o.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), a = new KeyboardEvent("keydown", {
    key: s === "Space" ? " " : s,
    altKey: o.includes("Alt"),
    ctrlKey: o.includes("Ctrl"),
    metaKey: o.includes("Meta"),
    shiftKey: o.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    n.someProp("handleKeyDown", (c) => c(n, a));
  });
  return l == null || l.steps.forEach((c) => {
    const u = c.map(r.mapping);
    u && i && r.maybeStep(u);
  }), !0;
};
function Ta(t, e, n = {}) {
  const { from: r, to: i, empty: o } = t.selection, s = e ? xt(e, t.schema) : null, a = [];
  t.doc.nodesBetween(r, i, (d, f) => {
    if (d.isText)
      return;
    const h = Math.max(r, f), p = Math.min(i, f + d.nodeSize);
    a.push({
      node: d,
      from: h,
      to: p
    });
  });
  const l = i - r, c = a.filter((d) => s ? s.name === d.node.type.name : !0).filter((d) => ou(d.node.attrs, n, { strict: !1 }));
  return o ? !!c.length : c.reduce((d, f) => d + f.to - f.from, 0) >= l;
}
const tY = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const i = xt(t, n.schema);
  return Ta(n, i, e) ? ZN(n, r) : !1;
}, nY = () => ({ state: t, dispatch: e }) => sb(t, e), rY = (t) => ({ state: e, dispatch: n }) => {
  const r = xt(t, e.schema);
  return o3(r)(e, n);
}, iY = () => ({ state: t, dispatch: e }) => rb(t, e);
function $d(t, e) {
  return e.nodes[t] ? "node" : e.marks[t] ? "mark" : null;
}
function Dk(t, e) {
  const n = typeof e == "string" ? [e] : e;
  return Object.keys(t).reduce((r, i) => (n.includes(i) || (r[i] = t[i]), r), {});
}
const oY = (t, e) => ({ tr: n, state: r, dispatch: i }) => {
  let o = null, s = null;
  const a = $d(typeof t == "string" ? t : t.name, r.schema);
  return a ? (a === "node" && (o = xt(t, r.schema)), a === "mark" && (s = Ai(t, r.schema)), i && n.selection.ranges.forEach((l) => {
    r.doc.nodesBetween(l.$from.pos, l.$to.pos, (c, u) => {
      o && o === c.type && n.setNodeMarkup(u, void 0, Dk(c.attrs, e)), s && c.marks.length && c.marks.forEach((d) => {
        s === d.type && n.addMark(u, u + c.nodeSize, s.create(Dk(d.attrs, e)));
      });
    });
  }), !0) : !1;
}, sY = () => ({ tr: t, dispatch: e }) => (e && t.scrollIntoView(), !0), aY = () => ({ tr: t, dispatch: e }) => {
  if (e) {
    const n = new en(t.doc);
    t.setSelection(n);
  }
  return !0;
}, lY = () => ({ state: t, dispatch: e }) => Xv(t, e), cY = () => ({ state: t, dispatch: e }) => tb(t, e), uY = () => ({ state: t, dispatch: e }) => XN(t, e), dY = () => ({ state: t, dispatch: e }) => n3(t, e), fY = () => ({ state: t, dispatch: e }) => t3(t, e);
function Qm(t, e, n = {}, r = {}) {
  return su(t, e, {
    slice: !1,
    parseOptions: n,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
const hY = (t, e = !1, n = {}, r = {}) => ({ editor: i, tr: o, dispatch: s, commands: a }) => {
  var l, c;
  const { doc: u } = o;
  if (n.preserveWhitespace !== "full") {
    const d = Qm(t, i.schema, n, {
      errorOnInvalidContent: (l = r.errorOnInvalidContent) !== null && l !== void 0 ? l : i.options.enableContentCheck
    });
    return s && o.replaceWith(0, u.content.size, d).setMeta("preventUpdate", !e), !0;
  }
  return s && o.setMeta("preventUpdate", !e), a.insertContentAt({ from: 0, to: u.content.size }, t, {
    parseOptions: n,
    errorOnInvalidContent: (c = r.errorOnInvalidContent) !== null && c !== void 0 ? c : i.options.enableContentCheck
  });
};
function g3(t, e) {
  const n = Ai(e, t.schema), { from: r, to: i, empty: o } = t.selection, s = [];
  o ? (t.storedMarks && s.push(...t.storedMarks), s.push(...t.selection.$head.marks())) : t.doc.nodesBetween(r, i, (l) => {
    s.push(...l.marks);
  });
  const a = s.find((l) => l.type.name === n.name);
  return a ? { ...a.attrs } : {};
}
function pY(t, e) {
  const n = new Bv(t);
  return e.forEach((r) => {
    r.steps.forEach((i) => {
      n.step(i);
    });
  }), n;
}
function mY(t) {
  for (let e = 0; e < t.edgeCount; e += 1) {
    const { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function gY(t, e, n) {
  const r = [];
  return t.nodesBetween(e.from, e.to, (i, o) => {
    n(i) && r.push({
      node: i,
      pos: o
    });
  }), r;
}
function v3(t, e) {
  for (let n = t.depth; n > 0; n -= 1) {
    const r = t.node(n);
    if (e(r))
      return {
        pos: n > 0 ? t.before(n) : 0,
        start: t.start(n),
        depth: n,
        node: r
      };
  }
}
function hb(t) {
  return (e) => v3(e.$from, t);
}
function vY(t, e) {
  const n = {
    from: 0,
    to: t.content.size
  };
  return u3(t, n, e);
}
function bY(t, e) {
  const n = xt(e, t.schema), { from: r, to: i } = t.selection, o = [];
  t.doc.nodesBetween(r, i, (a) => {
    o.push(a);
  });
  const s = o.reverse().find((a) => a.type.name === n.name);
  return s ? { ...s.attrs } : {};
}
function b3(t, e) {
  const n = $d(typeof e == "string" ? e : e.name, t.schema);
  return n === "node" ? bY(t, e) : n === "mark" ? g3(t, e) : {};
}
function yY(t, e = JSON.stringify) {
  const n = {};
  return t.filter((r) => {
    const i = e(r);
    return Object.prototype.hasOwnProperty.call(n, i) ? !1 : n[i] = !0;
  });
}
function wY(t) {
  const e = yY(t);
  return e.length === 1 ? e : e.filter((n, r) => !e.filter((o, s) => s !== r).some((o) => n.oldRange.from >= o.oldRange.from && n.oldRange.to <= o.oldRange.to && n.newRange.from >= o.newRange.from && n.newRange.to <= o.newRange.to));
}
function xY(t) {
  const { mapping: e, steps: n } = t, r = [];
  return e.maps.forEach((i, o) => {
    const s = [];
    if (i.ranges.length)
      i.forEach((a, l) => {
        s.push({ from: a, to: l });
      });
    else {
      const { from: a, to: l } = n[o];
      if (a === void 0 || l === void 0)
        return;
      s.push({ from: a, to: l });
    }
    s.forEach(({ from: a, to: l }) => {
      const c = e.slice(o).map(a, -1), u = e.slice(o).map(l), d = e.invert().map(c, -1), f = e.invert().map(u);
      r.push({
        oldRange: {
          from: d,
          to: f
        },
        newRange: {
          from: c,
          to: u
        }
      });
    });
  }), wY(r);
}
function pb(t, e, n) {
  const r = [];
  return t === e ? n.resolve(t).marks().forEach((i) => {
    const o = n.resolve(t), s = ub(o, i.type);
    s && r.push({
      mark: i,
      ...s
    });
  }) : n.nodesBetween(t, e, (i, o) => {
    !i || (i == null ? void 0 : i.nodeSize) === void 0 || r.push(...i.marks.map((s) => ({
      from: o,
      to: o + i.nodeSize,
      mark: s
    })));
  }), r;
}
function gc(t, e, n) {
  return Object.fromEntries(Object.entries(n).filter(([r]) => {
    const i = t.find((o) => o.type === e && o.name === r);
    return i ? i.attribute.keepOnSplit : !1;
  }));
}
function e0(t, e, n = {}) {
  const { empty: r, ranges: i } = t.selection, o = e ? Ai(e, t.schema) : null;
  if (r)
    return !!(t.storedMarks || t.selection.$from.marks()).filter((d) => o ? o.name === d.type.name : !0).find((d) => ou(d.attrs, n, { strict: !1 }));
  let s = 0;
  const a = [];
  if (i.forEach(({ $from: d, $to: f }) => {
    const h = d.pos, p = f.pos;
    t.doc.nodesBetween(h, p, (m, b) => {
      if (!m.isText && !m.marks.length)
        return;
      const y = Math.max(h, b), k = Math.min(p, b + m.nodeSize), C = k - y;
      s += C, a.push(...m.marks.map((x) => ({
        mark: x,
        from: y,
        to: k
      })));
    });
  }), s === 0)
    return !1;
  const l = a.filter((d) => o ? o.name === d.mark.type.name : !0).filter((d) => ou(d.mark.attrs, n, { strict: !1 })).reduce((d, f) => d + f.to - f.from, 0), c = a.filter((d) => o ? d.mark.type !== o && d.mark.type.excludes(o) : !0).reduce((d, f) => d + f.to - f.from, 0);
  return (l > 0 ? l + c : l) >= s;
}
function kY(t, e, n = {}) {
  if (!e)
    return Ta(t, null, n) || e0(t, null, n);
  const r = $d(e, t.schema);
  return r === "node" ? Ta(t, e, n) : r === "mark" ? e0(t, e, n) : !1;
}
function Ik(t, e) {
  const { nodeExtensions: n } = Pd(e), r = n.find((s) => s.name === t);
  if (!r)
    return !1;
  const i = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, o = Ae(ue(r, "group", i));
  return typeof o != "string" ? !1 : o.split(" ").includes("list");
}
function mb(t, { checkChildren: e = !0, ignoreWhitespace: n = !1 } = {}) {
  var r;
  if (n) {
    if (t.type.name === "hardBreak")
      return !0;
    if (t.isText)
      return /^\s*$/m.test((r = t.text) !== null && r !== void 0 ? r : "");
  }
  if (t.isText)
    return !t.text;
  if (t.isAtom || t.isLeaf)
    return !1;
  if (t.content.childCount === 0)
    return !0;
  if (e) {
    let i = !0;
    return t.content.forEach((o) => {
      i !== !1 && (mb(o, { ignoreWhitespace: n, checkChildren: e }) || (i = !1));
    }), i;
  }
  return !1;
}
function y3(t) {
  return t instanceof ye;
}
function CY(t, e, n) {
  const i = t.state.doc.content.size, o = Dr(e, 0, i), s = Dr(n, 0, i), a = t.coordsAtPos(o), l = t.coordsAtPos(s, -1), c = Math.min(a.top, l.top), u = Math.max(a.bottom, l.bottom), d = Math.min(a.left, l.left), f = Math.max(a.right, l.right), h = f - d, p = u - c, y = {
    top: c,
    bottom: u,
    left: d,
    right: f,
    width: h,
    height: p,
    x: d,
    y: c
  };
  return {
    ...y,
    toJSON: () => y
  };
}
function SY(t, e, n) {
  var r;
  const { selection: i } = e;
  let o = null;
  if (db(i) && (o = i.$cursor), o) {
    const a = (r = t.storedMarks) !== null && r !== void 0 ? r : o.marks();
    return !!n.isInSet(a) || !a.some((l) => l.type.excludes(n));
  }
  const { ranges: s } = i;
  return s.some(({ $from: a, $to: l }) => {
    let c = a.depth === 0 ? t.doc.inlineContent && t.doc.type.allowsMarkType(n) : !1;
    return t.doc.nodesBetween(a.pos, l.pos, (u, d, f) => {
      if (c)
        return !1;
      if (u.isInline) {
        const h = !f || f.type.allowsMarkType(n), p = !!n.isInSet(u.marks) || !u.marks.some((m) => m.type.excludes(n));
        c = h && p;
      }
      return !c;
    }), c;
  });
}
const TY = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  const { selection: o } = n, { empty: s, ranges: a } = o, l = Ai(t, r.schema);
  if (i)
    if (s) {
      const c = g3(r, l);
      n.addStoredMark(l.create({
        ...c,
        ...e
      }));
    } else
      a.forEach((c) => {
        const u = c.$from.pos, d = c.$to.pos;
        r.doc.nodesBetween(u, d, (f, h) => {
          const p = Math.max(h, u), m = Math.min(h + f.nodeSize, d);
          f.marks.find((y) => y.type === l) ? f.marks.forEach((y) => {
            l === y.type && n.addMark(p, m, l.create({
              ...y.attrs,
              ...e
            }));
          }) : n.addMark(p, m, l.create(e));
        });
      });
  return SY(r, n, l);
}, EY = (t, e) => ({ tr: n }) => (n.setMeta(t, e), !0), MY = (t, e = {}) => ({ state: n, dispatch: r, chain: i }) => {
  const o = xt(t, n.schema);
  let s;
  return n.selection.$anchor.sameParent(n.selection.$head) && (s = n.selection.$anchor.parent.attrs), o.isTextblock ? i().command(({ commands: a }) => iu(o, { ...s, ...e })(n) ? !0 : a.clearNodes()).command(({ state: a }) => iu(o, { ...s, ...e })(a, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, OY = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, i = Dr(t, 0, r.content.size), o = ye.create(r, i);
    e.setSelection(o);
  }
  return !0;
}, AY = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, { from: i, to: o } = typeof t == "number" ? { from: t, to: t } : t, s = ge.atStart(r).from, a = ge.atEnd(r).to, l = Dr(i, s, a), c = Dr(o, s, a), u = ge.create(r, l, c);
    e.setSelection(u);
  }
  return !0;
}, NY = (t) => ({ state: e, dispatch: n }) => {
  const r = xt(t, e.schema);
  return s3(r)(e, n);
};
function _k(t, e) {
  const n = t.storedMarks || t.selection.$to.parentOffset && t.selection.$from.marks();
  if (n) {
    const r = n.filter((i) => e == null ? void 0 : e.includes(i.type.name));
    t.tr.ensureMarks(r);
  }
}
const RY = ({ keepMarks: t = !0 } = {}) => ({ tr: e, state: n, dispatch: r, editor: i }) => {
  const { selection: o, doc: s } = e, { $from: a, $to: l } = o, c = i.extensionManager.attributes, u = gc(c, a.node().type.name, a.node().attrs);
  if (o instanceof ye && o.node.isBlock)
    return !a.parentOffset || !pn(s, a.pos) ? !1 : (r && (t && _k(n, i.extensionManager.splittableMarks), e.split(a.pos).scrollIntoView()), !0);
  if (!a.parent.isBlock)
    return !1;
  const d = l.parentOffset === l.parent.content.size, f = a.depth === 0 ? void 0 : mY(a.node(-1).contentMatchAt(a.indexAfter(-1)));
  let h = d && f ? [
    {
      type: f,
      attrs: u
    }
  ] : void 0, p = pn(e.doc, e.mapping.map(a.pos), 1, h);
  if (!h && !p && pn(e.doc, e.mapping.map(a.pos), 1, f ? [{ type: f }] : void 0) && (p = !0, h = f ? [
    {
      type: f,
      attrs: u
    }
  ] : void 0), r) {
    if (p && (o instanceof ge && e.deleteSelection(), e.split(e.mapping.map(a.pos), 1, h), f && !d && !a.parentOffset && a.parent.type !== f)) {
      const m = e.mapping.map(a.before()), b = e.doc.resolve(m);
      a.node(-1).canReplaceWith(b.index(), b.index() + 1, f) && e.setNodeMarkup(e.mapping.map(a.before()), f);
    }
    t && _k(n, i.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return p;
}, DY = (t, e = {}) => ({ tr: n, state: r, dispatch: i, editor: o }) => {
  var s;
  const a = xt(t, r.schema), { $from: l, $to: c } = r.selection, u = r.selection.node;
  if (u && u.isBlock || l.depth < 2 || !l.sameParent(c))
    return !1;
  const d = l.node(-1);
  if (d.type !== a)
    return !1;
  const f = o.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== a || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (i) {
      let y = U.empty;
      const k = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let M = l.depth - k; M >= l.depth - 3; M -= 1)
        y = U.from(l.node(M).copy(y));
      const C = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, x = {
        ...gc(f, l.node().type.name, l.node().attrs),
        ...e
      }, S = ((s = a.contentMatch.defaultType) === null || s === void 0 ? void 0 : s.createAndFill(x)) || void 0;
      y = y.append(U.from(a.createAndFill(null, S) || void 0));
      const T = l.before(l.depth - (k - 1));
      n.replace(T, l.after(-C), new ee(y, 4 - k, 0));
      let E = -1;
      n.doc.nodesBetween(T, n.doc.content.size, (M, O) => {
        if (E > -1)
          return !1;
        M.isTextblock && M.content.size === 0 && (E = O + 1);
      }), E > -1 && n.setSelection(ge.near(n.doc.resolve(E))), n.scrollIntoView();
    }
    return !0;
  }
  const h = c.pos === l.end() ? d.contentMatchAt(0).defaultType : null, p = {
    ...gc(f, d.type.name, d.attrs),
    ...e
  }, m = {
    ...gc(f, l.node().type.name, l.node().attrs),
    ...e
  };
  n.delete(l.pos, c.pos);
  const b = h ? [
    { type: a, attrs: p },
    { type: h, attrs: m }
  ] : [{ type: a, attrs: p }];
  if (!pn(n.doc, l.pos, 2))
    return !1;
  if (i) {
    const { selection: y, storedMarks: k } = r, { splittableMarks: C } = o.extensionManager, x = k || y.$to.parentOffset && y.$from.marks();
    if (n.split(l.pos, 2, b).scrollIntoView(), !x || !i)
      return !0;
    const S = x.filter((T) => C.includes(T.type.name));
    n.ensureMarks(S);
  }
  return !0;
}, hp = (t, e) => {
  const n = hb((s) => s.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (r === void 0)
    return !0;
  const i = t.doc.nodeAt(r);
  return n.node.type === (i == null ? void 0 : i.type) && mr(t.doc, n.pos) && t.join(n.pos), !0;
}, pp = (t, e) => {
  const n = hb((s) => s.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(n.start).after(n.depth);
  if (r === void 0)
    return !0;
  const i = t.doc.nodeAt(r);
  return n.node.type === (i == null ? void 0 : i.type) && mr(t.doc, r) && t.join(r), !0;
}, IY = (t, e, n, r = {}) => ({ editor: i, tr: o, state: s, dispatch: a, chain: l, commands: c, can: u }) => {
  const { extensions: d, splittableMarks: f } = i.extensionManager, h = xt(t, s.schema), p = xt(e, s.schema), { selection: m, storedMarks: b } = s, { $from: y, $to: k } = m, C = y.blockRange(k), x = b || m.$to.parentOffset && m.$from.marks();
  if (!C)
    return !1;
  const S = hb((T) => Ik(T.type.name, d))(m);
  if (C.depth >= 1 && S && C.depth - S.depth <= 1) {
    if (S.node.type === h)
      return c.liftListItem(p);
    if (Ik(S.node.type.name, d) && h.validContent(S.node.content) && a)
      return l().command(() => (o.setNodeMarkup(S.pos, h), !0)).command(() => hp(o, h)).command(() => pp(o, h)).run();
  }
  return !n || !x || !a ? l().command(() => u().wrapInList(h, r) ? !0 : c.clearNodes()).wrapInList(h, r).command(() => hp(o, h)).command(() => pp(o, h)).run() : l().command(() => {
    const T = u().wrapInList(h, r), E = x.filter((M) => f.includes(M.type.name));
    return o.ensureMarks(E), T ? !0 : c.clearNodes();
  }).wrapInList(h, r).command(() => hp(o, h)).command(() => pp(o, h)).run();
}, _Y = (t, e = {}, n = {}) => ({ state: r, commands: i }) => {
  const { extendEmptyMarkRange: o = !1 } = n, s = Ai(t, r.schema);
  return e0(r, s, e) ? i.unsetMark(s, { extendEmptyMarkRange: o }) : i.setMark(s, e);
}, PY = (t, e, n = {}) => ({ state: r, commands: i }) => {
  const o = xt(t, r.schema), s = xt(e, r.schema), a = Ta(r, o, n);
  let l;
  return r.selection.$anchor.sameParent(r.selection.$head) && (l = r.selection.$anchor.parent.attrs), a ? i.setNode(s, l) : i.setNode(o, { ...l, ...n });
}, LY = (t, e = {}) => ({ state: n, commands: r }) => {
  const i = xt(t, n.schema);
  return Ta(n, i, e) ? r.lift(i) : r.wrapIn(i, e);
}, FY = () => ({ state: t, dispatch: e }) => {
  const n = t.plugins;
  for (let r = 0; r < n.length; r += 1) {
    const i = n[r];
    let o;
    if (i.spec.isInputRules && (o = i.getState(t))) {
      if (e) {
        const s = t.tr, a = o.transform;
        for (let l = a.steps.length - 1; l >= 0; l -= 1)
          s.step(a.steps[l].invert(a.docs[l]));
        if (o.text) {
          const l = s.doc.resolve(o.from).marks();
          s.replaceWith(o.from, o.to, t.schema.text(o.text, l));
        } else
          s.delete(o.from, o.to);
      }
      return !0;
    }
  }
  return !1;
}, $Y = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, { empty: r, ranges: i } = n;
  return r || e && i.forEach((o) => {
    t.removeMark(o.$from.pos, o.$to.pos);
  }), !0;
}, BY = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  var o;
  const { extendEmptyMarkRange: s = !1 } = e, { selection: a } = n, l = Ai(t, r.schema), { $from: c, empty: u, ranges: d } = a;
  if (!i)
    return !0;
  if (u && s) {
    let { from: f, to: h } = a;
    const p = (o = c.marks().find((b) => b.type === l)) === null || o === void 0 ? void 0 : o.attrs, m = ub(c, l, p);
    m && (f = m.from, h = m.to), n.removeMark(f, h, l);
  } else
    d.forEach((f) => {
      n.removeMark(f.$from.pos, f.$to.pos, l);
    });
  return n.removeStoredMark(l), !0;
}, VY = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  let o = null, s = null;
  const a = $d(typeof t == "string" ? t : t.name, r.schema);
  return a ? (a === "node" && (o = xt(t, r.schema)), a === "mark" && (s = Ai(t, r.schema)), i && n.selection.ranges.forEach((l) => {
    const c = l.$from.pos, u = l.$to.pos;
    let d, f, h, p;
    n.selection.empty ? r.doc.nodesBetween(c, u, (m, b) => {
      o && o === m.type && (h = Math.max(b, c), p = Math.min(b + m.nodeSize, u), d = b, f = m);
    }) : r.doc.nodesBetween(c, u, (m, b) => {
      b < c && o && o === m.type && (h = Math.max(b, c), p = Math.min(b + m.nodeSize, u), d = b, f = m), b >= c && b <= u && (o && o === m.type && n.setNodeMarkup(b, void 0, {
        ...m.attrs,
        ...e
      }), s && m.marks.length && m.marks.forEach((y) => {
        if (s === y.type) {
          const k = Math.max(b, c), C = Math.min(b + m.nodeSize, u);
          n.addMark(k, C, s.create({
            ...y.attrs,
            ...e
          }));
        }
      }));
    }), f && (d !== void 0 && n.setNodeMarkup(d, void 0, {
      ...f.attrs,
      ...e
    }), s && f.marks.length && f.marks.forEach((m) => {
      s === m.type && n.addMark(h, p, s.create({
        ...m.attrs,
        ...e
      }));
    }));
  }), !0) : !1;
}, zY = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const i = xt(t, n.schema);
  return r3(i, e)(n, r);
}, HY = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const i = xt(t, n.schema);
  return i3(i, e)(n, r);
};
var WY = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: SG,
  clearContent: TG,
  clearNodes: EG,
  command: MG,
  createParagraphNear: OG,
  cut: AG,
  deleteCurrentNode: NG,
  deleteNode: RG,
  deleteRange: DG,
  deleteSelection: IG,
  enter: _G,
  exitCode: PG,
  extendMarkRange: LG,
  first: FG,
  focus: BG,
  forEach: VG,
  insertContent: zG,
  insertContentAt: jG,
  joinBackward: KG,
  joinDown: qG,
  joinForward: GG,
  joinItemBackward: YG,
  joinItemForward: ZG,
  joinTextblockBackward: JG,
  joinTextblockForward: XG,
  joinUp: UG,
  keyboardShortcut: eY,
  lift: tY,
  liftEmptyBlock: nY,
  liftListItem: rY,
  newlineInCode: iY,
  resetAttributes: oY,
  scrollIntoView: sY,
  selectAll: aY,
  selectNodeBackward: lY,
  selectNodeForward: cY,
  selectParentNode: uY,
  selectTextblockEnd: dY,
  selectTextblockStart: fY,
  setContent: hY,
  setMark: TY,
  setMeta: EY,
  setNode: MY,
  setNodeSelection: OY,
  setTextSelection: AY,
  sinkListItem: NY,
  splitBlock: RY,
  splitListItem: DY,
  toggleList: IY,
  toggleMark: _Y,
  toggleNode: PY,
  toggleWrap: LY,
  undoInputRule: FY,
  unsetAllMarks: $Y,
  unsetMark: BY,
  updateAttributes: VY,
  wrapIn: zY,
  wrapInList: HY
});
const jY = gt.create({
  name: "commands",
  addCommands() {
    return {
      ...WY
    };
  }
}), UY = gt.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Ge({
        key: new tt("tiptapDrop"),
        props: {
          handleDrop: (t, e, n, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: n,
              moved: r
            });
          }
        }
      })
    ];
  }
}), qY = gt.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Ge({
        key: new tt("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), KY = new tt("focusEvents"), GY = gt.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: t } = this;
    return [
      new Ge({
        key: KY,
        props: {
          handleDOMEvents: {
            focus: (e, n) => {
              t.isFocused = !0;
              const r = t.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, n) => {
              t.isFocused = !1;
              const r = t.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), YY = gt.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const t = () => this.editor.commands.first(({ commands: s }) => [
      () => s.undoInputRule(),
      // maybe convert first text block node to default node
      () => s.command(({ tr: a }) => {
        const { selection: l, doc: c } = a, { empty: u, $anchor: d } = l, { pos: f, parent: h } = d, p = d.parent.isTextblock && f > 0 ? a.doc.resolve(f - 1) : d, m = p.parent.type.spec.isolating, b = d.pos - d.parentOffset, y = m && p.parent.childCount === 1 ? b === d.pos : be.atStart(c).from === f;
        return !u || !h.type.isTextblock || h.textContent.length || !y || y && d.parent.type.name === "paragraph" ? !1 : s.clearNodes();
      }),
      () => s.deleteSelection(),
      () => s.joinBackward(),
      () => s.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: s }) => [
      () => s.deleteSelection(),
      () => s.deleteCurrentNode(),
      () => s.joinForward(),
      () => s.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: s }) => [
        () => s.newlineInCode(),
        () => s.createParagraphNear(),
        () => s.liftEmptyBlock(),
        () => s.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: t,
      "Mod-Backspace": t,
      "Shift-Backspace": t,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, i = {
      ...r
    }, o = {
      ...r,
      "Ctrl-h": t,
      "Alt-Backspace": t,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return fb() || m3() ? o : i;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Ge({
        key: new tt("clearDocument"),
        appendTransaction: (t, e, n) => {
          if (t.some((m) => m.getMeta("composition")))
            return;
          const r = t.some((m) => m.docChanged) && !e.doc.eq(n.doc), i = t.some((m) => m.getMeta("preventClearDocument"));
          if (!r || i)
            return;
          const { empty: o, from: s, to: a } = e.selection, l = be.atStart(e.doc).from, c = be.atEnd(e.doc).to;
          if (o || !(s === l && a === c) || !mb(n.doc))
            return;
          const f = n.tr, h = Id({
            state: n,
            transaction: f
          }), { commands: p } = new _d({
            editor: this.editor,
            state: h
          });
          if (p.clearNodes(), !!f.steps.length)
            return f;
        }
      })
    ];
  }
}), ZY = gt.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Ge({
        key: new tt("tiptapPaste"),
        props: {
          handlePaste: (t, e, n) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: n
            });
          }
        }
      })
    ];
  }
}), JY = gt.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new Ge({
        key: new tt("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class Vi {
  get name() {
    return this.node.type.name;
  }
  constructor(e, n, r = !1, i = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = e, this.editor = n, this.currentNode = i;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) !== null && e !== void 0 ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let n = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      n = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: n, to: r }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), n = this.resolvedPos.doc.resolve(e);
    return new Vi(n, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new Vi(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new Vi(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((n, r) => {
      const i = n.isBlock && !n.isTextblock, o = n.isAtom && !n.isText, s = this.pos + r + (o ? 0 : 1), a = this.resolvedPos.doc.resolve(s);
      if (!i && a.depth <= this.depth)
        return;
      const l = new Vi(a, this.editor, i, i ? n : null);
      i && (l.actualDepth = this.depth + 1), e.push(new Vi(a, this.editor, i, i ? n : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, n = {}) {
    let r = null, i = this.parent;
    for (; i && !r; ) {
      if (i.node.type.name === e)
        if (Object.keys(n).length > 0) {
          const o = i.node.attrs, s = Object.keys(n);
          for (let a = 0; a < s.length; a += 1) {
            const l = s[a];
            if (o[l] !== n[l])
              break;
          }
        } else
          r = i;
      i = i.parent;
    }
    return r;
  }
  querySelector(e, n = {}) {
    return this.querySelectorAll(e, n, !0)[0] || null;
  }
  querySelectorAll(e, n = {}, r = !1) {
    let i = [];
    if (!this.children || this.children.length === 0)
      return i;
    const o = Object.keys(n);
    return this.children.forEach((s) => {
      r && i.length > 0 || (s.node.type.name === e && o.every((l) => n[l] === s.node.attrs[l]) && i.push(s), !(r && i.length > 0) && (i = i.concat(s.querySelectorAll(e, n, r))));
    }), i;
  }
  setAttribute(e) {
    const { tr: n } = this.editor.state;
    n.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(n);
  }
}
const XY = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function QY(t, e, n) {
  const r = document.querySelector("style[data-tiptap-style]");
  if (r !== null)
    return r;
  const i = document.createElement("style");
  return e && i.setAttribute("nonce", e), i.setAttribute("data-tiptap-style", ""), i.innerHTML = t, document.getElementsByTagName("head")[0].appendChild(i), i;
}
class eZ extends cG {
  constructor(e = {}) {
    super(), this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: n }) => {
        throw n;
      },
      onPaste: () => null,
      onDrop: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: n, slice: r, moved: i }) => this.options.onDrop(n, r, i)), this.on("paste", ({ event: n, slice: r }) => this.options.onPaste(n, r)), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = QY(XY, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, n = !0) {
    this.setOptions({ editable: e }), n && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, n) {
    const r = l3(n) ? n(e, [...this.state.plugins]) : [...this.state.plugins, e], i = this.state.reconfigure({ plugins: r });
    return this.view.updateState(i), i;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const n = this.state.plugins;
    let r = n;
    if ([].concat(e).forEach((o) => {
      const s = typeof o == "string" ? `${o}$` : o.key;
      r = n.filter((a) => !a.key.startsWith(s));
    }), n.length === r.length)
      return;
    const i = this.state.reconfigure({
      plugins: r
    });
    return this.view.updateState(i), i;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, n;
    const i = [...this.options.enableCoreExtensions ? [
      qY,
      CG.configure({
        blockSeparator: (n = (e = this.options.coreExtensionOptions) === null || e === void 0 ? void 0 : e.clipboardTextSerializer) === null || n === void 0 ? void 0 : n.blockSeparator
      }),
      jY,
      GY,
      YY,
      JY,
      UY,
      ZY
    ].filter((o) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[o.name] !== !1 : !0) : [], ...this.options.extensions].filter((o) => ["extension", "node", "mark"].includes(o == null ? void 0 : o.type));
    this.extensionManager = new Vo(i, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new _d({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    var e;
    let n;
    try {
      n = Qm(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (s) {
      if (!(s instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(s.message))
        throw s;
      this.emit("contentError", {
        editor: this,
        error: s,
        disableCollaboration: () => {
          this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((a) => a.name !== "collaboration"), this.createExtensionManager();
        }
      }), n = Qm(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
    }
    const r = h3(n, this.options.autofocus);
    this.view = new qK(this.options.element, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(e = this.options.editorProps) === null || e === void 0 ? void 0 : e.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: Bo.create({
        doc: n,
        selection: r || void 0
      })
    });
    const i = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(i), this.createNodeViews(), this.prependClass();
    const o = this.view.dom;
    o.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const n = this.capturedTransaction;
    return this.capturedTransaction = null, n;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((s) => {
        var a;
        return (a = this.capturedTransaction) === null || a === void 0 ? void 0 : a.step(s);
      });
      return;
    }
    const n = this.state.apply(e), r = !this.state.selection.eq(n.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: n
    }), this.view.updateState(n), this.emit("transaction", {
      editor: this,
      transaction: e
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const i = e.getMeta("focus"), o = e.getMeta("blur");
    i && this.emit("focus", {
      editor: this,
      event: i.event,
      transaction: e
    }), o && this.emit("blur", {
      editor: this,
      event: o.event,
      transaction: e
    }), !(!e.docChanged || e.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: e
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return b3(this.state, e);
  }
  isActive(e, n) {
    const r = typeof e == "string" ? e : null, i = typeof e == "string" ? n : e;
    return kY(this.state, r, i);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return lb(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: n = `

`, textSerializers: r = {} } = e || {};
    return vY(this.state.doc, {
      blockSeparator: n,
      textSerializers: {
        ...d3(this.schema),
        ...r
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return mb(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    if (this.emit("destroy"), this.view) {
      const e = this.view.dom;
      e && e.editor && delete e.editor, this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e;
    return !(!((e = this.view) === null || e === void 0) && e.docView);
  }
  $node(e, n) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelector(e, n)) || null;
  }
  $nodes(e, n) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelectorAll(e, n)) || null;
  }
  $pos(e) {
    const n = this.state.doc.resolve(e);
    return new Vi(n, this);
  }
  get $doc() {
    return this.$pos(0);
  }
}
function ao(t) {
  return new Ld({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const i = Ae(t.getAttributes, void 0, r);
      if (i === !1 || i === null)
        return null;
      const { tr: o } = e, s = r[r.length - 1], a = r[0];
      if (s) {
        const l = a.search(/\S/), c = n.from + a.indexOf(s), u = c + s.length;
        if (pb(n.from, n.to, e.doc).filter((h) => h.mark.type.excluded.find((m) => m === t.type && m !== h.mark.type)).filter((h) => h.to > c).length)
          return null;
        u < n.to && o.delete(u, n.to), c > n.from && o.delete(n.from + l, c);
        const f = n.from + l + s.length;
        o.addMark(n.from + l, f, t.type.create(i || {})), o.removeStoredMark(t.type);
      }
    }
  });
}
function w3(t) {
  return new Ld({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const i = Ae(t.getAttributes, void 0, r) || {}, { tr: o } = e, s = n.from;
      let a = n.to;
      const l = t.type.create(i);
      if (r[1]) {
        const c = r[0].lastIndexOf(r[1]);
        let u = s + c;
        u > a ? u = a : a = u + r[1].length;
        const d = r[0][r[0].length - 1];
        o.insertText(d, s + r[0].length - 1), o.replaceWith(u, a, l);
      } else if (r[0]) {
        const c = t.type.isInline ? s : s - 1;
        o.insert(c, t.type.create(i)).delete(o.mapping.map(s), o.mapping.map(a));
      }
      o.scrollIntoView();
    }
  });
}
function t0(t) {
  return new Ld({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const i = e.doc.resolve(n.from), o = Ae(t.getAttributes, void 0, r) || {};
      if (!i.node(-1).canReplaceWith(i.index(-1), i.indexAfter(-1), t.type))
        return null;
      e.tr.delete(n.from, n.to).setBlockType(n.from, n.from, t.type, o);
    }
  });
}
function Ea(t) {
  return new Ld({
    find: t.find,
    handler: ({ state: e, range: n, match: r, chain: i }) => {
      const o = Ae(t.getAttributes, void 0, r) || {}, s = e.tr.delete(n.from, n.to), l = s.doc.resolve(n.from).blockRange(), c = l && $v(l, t.type, o);
      if (!c)
        return null;
      if (s.wrap(l, c), t.keepMarks && t.editor) {
        const { selection: d, storedMarks: f } = e, { splittableMarks: h } = t.editor.extensionManager, p = f || d.$to.parentOffset && d.$from.marks();
        if (p) {
          const m = p.filter((b) => h.includes(b.type.name));
          s.ensureMarks(m);
        }
      }
      if (t.keepAttributes) {
        const d = t.type.name === "bulletList" || t.type.name === "orderedList" ? "listItem" : "taskList";
        i().updateAttributes(d, o).run();
      }
      const u = s.doc.resolve(n.from - 1).nodeBefore;
      u && u.type === t.type && mr(s.doc, n.from - 1) && (!t.joinPredicate || t.joinPredicate(r, u)) && s.join(n.from - 1);
    }
  });
}
let vt = class n0 {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ae(ue(this, "addOptions", {
      name: this.name
    }))), this.storage = Ae(ue(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new n0(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Fd(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new n0(e);
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Ae(ue(n, "addOptions", {
      name: n.name
    })), n.storage = Ae(ue(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
};
function xi(t) {
  return new c3({
    find: t.find,
    handler: ({ state: e, range: n, match: r, pasteEvent: i }) => {
      const o = Ae(t.getAttributes, void 0, r, i);
      if (o === !1 || o === null)
        return null;
      const { tr: s } = e, a = r[r.length - 1], l = r[0];
      let c = n.to;
      if (a) {
        const u = l.search(/\S/), d = n.from + l.indexOf(a), f = d + a.length;
        if (pb(n.from, n.to, e.doc).filter((p) => p.mark.type.excluded.find((b) => b === t.type && b !== p.mark.type)).filter((p) => p.to > d).length)
          return null;
        f < n.to && s.delete(f, n.to), d > n.from && s.delete(n.from + u, d), c = n.from + u + a.length, s.addMark(n.from + u, c, t.type.create(o || {})), s.removeStoredMark(t.type);
      }
    }
  });
}
function tZ(t) {
  return new c3({
    find: t.find,
    handler({ match: e, chain: n, range: r, pasteEvent: i }) {
      const o = Ae(t.getAttributes, void 0, e, i), s = Ae(t.getContent, void 0, o);
      if (o === !1 || o === null)
        return null;
      const a = { type: t.type.name, attrs: o };
      s && (a.content = s), e.input && n().deleteRange(r).insertContentAt(r.from, a);
    }
  });
}
var nn = "top", In = "bottom", _n = "right", rn = "left", gb = "auto", sl = [nn, In, _n, rn], as = "start", Ma = "end", nZ = "clippingParents", x3 = "viewport", Is = "popper", rZ = "reference", Pk = /* @__PURE__ */ sl.reduce(function(t, e) {
  return t.concat([e + "-" + as, e + "-" + Ma]);
}, []), k3 = /* @__PURE__ */ [].concat(sl, [gb]).reduce(function(t, e) {
  return t.concat([e, e + "-" + as, e + "-" + Ma]);
}, []), iZ = "beforeRead", oZ = "read", sZ = "afterRead", aZ = "beforeMain", lZ = "main", cZ = "afterMain", uZ = "beforeWrite", dZ = "write", fZ = "afterWrite", hZ = [iZ, oZ, sZ, aZ, lZ, cZ, uZ, dZ, fZ];
function hr(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function vn(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function lo(t) {
  var e = vn(t).Element;
  return t instanceof e || t instanceof Element;
}
function Dn(t) {
  var e = vn(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function vb(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = vn(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function pZ(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var r = e.styles[n] || {}, i = e.attributes[n] || {}, o = e.elements[n];
    !Dn(o) || !hr(o) || (Object.assign(o.style, r), Object.keys(i).forEach(function(s) {
      var a = i[s];
      a === !1 ? o.removeAttribute(s) : o.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function mZ(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var i = e.elements[r], o = e.attributes[r] || {}, s = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : n[r]), a = s.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Dn(i) || !hr(i) || (Object.assign(i.style, a), Object.keys(o).forEach(function(l) {
        i.removeAttribute(l);
      }));
    });
  };
}
const C3 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: pZ,
  effect: mZ,
  requires: ["computeStyles"]
};
function lr(t) {
  return t.split("-")[0];
}
var Xi = Math.max, au = Math.min, ls = Math.round;
function r0() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function S3() {
  return !/^((?!chrome|android).)*safari/i.test(r0());
}
function cs(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var r = t.getBoundingClientRect(), i = 1, o = 1;
  e && Dn(t) && (i = t.offsetWidth > 0 && ls(r.width) / t.offsetWidth || 1, o = t.offsetHeight > 0 && ls(r.height) / t.offsetHeight || 1);
  var s = lo(t) ? vn(t) : window, a = s.visualViewport, l = !S3() && n, c = (r.left + (l && a ? a.offsetLeft : 0)) / i, u = (r.top + (l && a ? a.offsetTop : 0)) / o, d = r.width / i, f = r.height / o;
  return {
    width: d,
    height: f,
    top: u,
    right: c + d,
    bottom: u + f,
    left: c,
    x: c,
    y: u
  };
}
function bb(t) {
  var e = cs(t), n = t.offsetWidth, r = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: r
  };
}
function T3(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && vb(n)) {
    var r = e;
    do {
      if (r && t.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Br(t) {
  return vn(t).getComputedStyle(t);
}
function gZ(t) {
  return ["table", "td", "th"].indexOf(hr(t)) >= 0;
}
function Ni(t) {
  return ((lo(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function Bd(t) {
  return hr(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (vb(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Ni(t)
  );
}
function Lk(t) {
  return !Dn(t) || // https://github.com/popperjs/popper-core/issues/837
  Br(t).position === "fixed" ? null : t.offsetParent;
}
function vZ(t) {
  var e = /firefox/i.test(r0()), n = /Trident/i.test(r0());
  if (n && Dn(t)) {
    var r = Br(t);
    if (r.position === "fixed")
      return null;
  }
  var i = Bd(t);
  for (vb(i) && (i = i.host); Dn(i) && ["html", "body"].indexOf(hr(i)) < 0; ) {
    var o = Br(i);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || e && o.willChange === "filter" || e && o.filter && o.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function al(t) {
  for (var e = vn(t), n = Lk(t); n && gZ(n) && Br(n).position === "static"; )
    n = Lk(n);
  return n && (hr(n) === "html" || hr(n) === "body" && Br(n).position === "static") ? e : n || vZ(t) || e;
}
function yb(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function Qs(t, e, n) {
  return Xi(t, au(e, n));
}
function bZ(t, e, n) {
  var r = Qs(t, e, n);
  return r > n ? n : r;
}
function E3() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function M3(t) {
  return Object.assign({}, E3(), t);
}
function O3(t, e) {
  return e.reduce(function(n, r) {
    return n[r] = t, n;
  }, {});
}
var yZ = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, M3(typeof e != "number" ? e : O3(e, sl));
};
function wZ(t) {
  var e, n = t.state, r = t.name, i = t.options, o = n.elements.arrow, s = n.modifiersData.popperOffsets, a = lr(n.placement), l = yb(a), c = [rn, _n].indexOf(a) >= 0, u = c ? "height" : "width";
  if (!(!o || !s)) {
    var d = yZ(i.padding, n), f = bb(o), h = l === "y" ? nn : rn, p = l === "y" ? In : _n, m = n.rects.reference[u] + n.rects.reference[l] - s[l] - n.rects.popper[u], b = s[l] - n.rects.reference[l], y = al(o), k = y ? l === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0, C = m / 2 - b / 2, x = d[h], S = k - f[u] - d[p], T = k / 2 - f[u] / 2 + C, E = Qs(x, T, S), M = l;
    n.modifiersData[r] = (e = {}, e[M] = E, e.centerOffset = E - T, e);
  }
}
function xZ(t) {
  var e = t.state, n = t.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = e.elements.popper.querySelector(i), !i) || T3(e.elements.popper, i) && (e.elements.arrow = i));
}
const kZ = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: wZ,
  effect: xZ,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function us(t) {
  return t.split("-")[1];
}
var CZ = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function SZ(t, e) {
  var n = t.x, r = t.y, i = e.devicePixelRatio || 1;
  return {
    x: ls(n * i) / i || 0,
    y: ls(r * i) / i || 0
  };
}
function Fk(t) {
  var e, n = t.popper, r = t.popperRect, i = t.placement, o = t.variation, s = t.offsets, a = t.position, l = t.gpuAcceleration, c = t.adaptive, u = t.roundOffsets, d = t.isFixed, f = s.x, h = f === void 0 ? 0 : f, p = s.y, m = p === void 0 ? 0 : p, b = typeof u == "function" ? u({
    x: h,
    y: m
  }) : {
    x: h,
    y: m
  };
  h = b.x, m = b.y;
  var y = s.hasOwnProperty("x"), k = s.hasOwnProperty("y"), C = rn, x = nn, S = window;
  if (c) {
    var T = al(n), E = "clientHeight", M = "clientWidth";
    if (T === vn(n) && (T = Ni(n), Br(T).position !== "static" && a === "absolute" && (E = "scrollHeight", M = "scrollWidth")), T = T, i === nn || (i === rn || i === _n) && o === Ma) {
      x = In;
      var O = d && T === S && S.visualViewport ? S.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        T[E]
      );
      m -= O - r.height, m *= l ? 1 : -1;
    }
    if (i === rn || (i === nn || i === In) && o === Ma) {
      C = _n;
      var L = d && T === S && S.visualViewport ? S.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        T[M]
      );
      h -= L - r.width, h *= l ? 1 : -1;
    }
  }
  var $ = Object.assign({
    position: a
  }, c && CZ), z = u === !0 ? SZ({
    x: h,
    y: m
  }, vn(n)) : {
    x: h,
    y: m
  };
  if (h = z.x, m = z.y, l) {
    var B;
    return Object.assign({}, $, (B = {}, B[x] = k ? "0" : "", B[C] = y ? "0" : "", B.transform = (S.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + m + "px)" : "translate3d(" + h + "px, " + m + "px, 0)", B));
  }
  return Object.assign({}, $, (e = {}, e[x] = k ? m + "px" : "", e[C] = y ? h + "px" : "", e.transform = "", e));
}
function TZ(t) {
  var e = t.state, n = t.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, o = n.adaptive, s = o === void 0 ? !0 : o, a = n.roundOffsets, l = a === void 0 ? !0 : a, c = {
    placement: lr(e.placement),
    variation: us(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: i,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, Fk(Object.assign({}, c, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, Fk(Object.assign({}, c, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const EZ = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: TZ,
  data: {}
};
var Wl = {
  passive: !0
};
function MZ(t) {
  var e = t.state, n = t.instance, r = t.options, i = r.scroll, o = i === void 0 ? !0 : i, s = r.resize, a = s === void 0 ? !0 : s, l = vn(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return o && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, Wl);
  }), a && l.addEventListener("resize", n.update, Wl), function() {
    o && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, Wl);
    }), a && l.removeEventListener("resize", n.update, Wl);
  };
}
const OZ = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: MZ,
  data: {}
};
var AZ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function vc(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return AZ[e];
  });
}
var NZ = {
  start: "end",
  end: "start"
};
function $k(t) {
  return t.replace(/start|end/g, function(e) {
    return NZ[e];
  });
}
function wb(t) {
  var e = vn(t), n = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function xb(t) {
  return cs(Ni(t)).left + wb(t).scrollLeft;
}
function RZ(t, e) {
  var n = vn(t), r = Ni(t), i = n.visualViewport, o = r.clientWidth, s = r.clientHeight, a = 0, l = 0;
  if (i) {
    o = i.width, s = i.height;
    var c = S3();
    (c || !c && e === "fixed") && (a = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: a + xb(t),
    y: l
  };
}
function DZ(t) {
  var e, n = Ni(t), r = wb(t), i = (e = t.ownerDocument) == null ? void 0 : e.body, o = Xi(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), s = Xi(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), a = -r.scrollLeft + xb(t), l = -r.scrollTop;
  return Br(i || n).direction === "rtl" && (a += Xi(n.clientWidth, i ? i.clientWidth : 0) - o), {
    width: o,
    height: s,
    x: a,
    y: l
  };
}
function kb(t) {
  var e = Br(t), n = e.overflow, r = e.overflowX, i = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function A3(t) {
  return ["html", "body", "#document"].indexOf(hr(t)) >= 0 ? t.ownerDocument.body : Dn(t) && kb(t) ? t : A3(Bd(t));
}
function ea(t, e) {
  var n;
  e === void 0 && (e = []);
  var r = A3(t), i = r === ((n = t.ownerDocument) == null ? void 0 : n.body), o = vn(r), s = i ? [o].concat(o.visualViewport || [], kb(r) ? r : []) : r, a = e.concat(s);
  return i ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(ea(Bd(s)))
  );
}
function i0(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function IZ(t, e) {
  var n = cs(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Bk(t, e, n) {
  return e === x3 ? i0(RZ(t, n)) : lo(e) ? IZ(e, n) : i0(DZ(Ni(t)));
}
function _Z(t) {
  var e = ea(Bd(t)), n = ["absolute", "fixed"].indexOf(Br(t).position) >= 0, r = n && Dn(t) ? al(t) : t;
  return lo(r) ? e.filter(function(i) {
    return lo(i) && T3(i, r) && hr(i) !== "body";
  }) : [];
}
function PZ(t, e, n, r) {
  var i = e === "clippingParents" ? _Z(t) : [].concat(e), o = [].concat(i, [n]), s = o[0], a = o.reduce(function(l, c) {
    var u = Bk(t, c, r);
    return l.top = Xi(u.top, l.top), l.right = au(u.right, l.right), l.bottom = au(u.bottom, l.bottom), l.left = Xi(u.left, l.left), l;
  }, Bk(t, s, r));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function N3(t) {
  var e = t.reference, n = t.element, r = t.placement, i = r ? lr(r) : null, o = r ? us(r) : null, s = e.x + e.width / 2 - n.width / 2, a = e.y + e.height / 2 - n.height / 2, l;
  switch (i) {
    case nn:
      l = {
        x: s,
        y: e.y - n.height
      };
      break;
    case In:
      l = {
        x: s,
        y: e.y + e.height
      };
      break;
    case _n:
      l = {
        x: e.x + e.width,
        y: a
      };
      break;
    case rn:
      l = {
        x: e.x - n.width,
        y: a
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var c = i ? yb(i) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (o) {
      case as:
        l[c] = l[c] - (e[u] / 2 - n[u] / 2);
        break;
      case Ma:
        l[c] = l[c] + (e[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function Oa(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, i = r === void 0 ? t.placement : r, o = n.strategy, s = o === void 0 ? t.strategy : o, a = n.boundary, l = a === void 0 ? nZ : a, c = n.rootBoundary, u = c === void 0 ? x3 : c, d = n.elementContext, f = d === void 0 ? Is : d, h = n.altBoundary, p = h === void 0 ? !1 : h, m = n.padding, b = m === void 0 ? 0 : m, y = M3(typeof b != "number" ? b : O3(b, sl)), k = f === Is ? rZ : Is, C = t.rects.popper, x = t.elements[p ? k : f], S = PZ(lo(x) ? x : x.contextElement || Ni(t.elements.popper), l, u, s), T = cs(t.elements.reference), E = N3({
    reference: T,
    element: C,
    placement: i
  }), M = i0(Object.assign({}, C, E)), O = f === Is ? M : T, L = {
    top: S.top - O.top + y.top,
    bottom: O.bottom - S.bottom + y.bottom,
    left: S.left - O.left + y.left,
    right: O.right - S.right + y.right
  }, $ = t.modifiersData.offset;
  if (f === Is && $) {
    var z = $[i];
    Object.keys(L).forEach(function(B) {
      var A = [_n, In].indexOf(B) >= 0 ? 1 : -1, N = [nn, In].indexOf(B) >= 0 ? "y" : "x";
      L[B] += z[N] * A;
    });
  }
  return L;
}
function LZ(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, i = n.boundary, o = n.rootBoundary, s = n.padding, a = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? k3 : l, u = us(r), d = u ? a ? Pk : Pk.filter(function(p) {
    return us(p) === u;
  }) : sl, f = d.filter(function(p) {
    return c.indexOf(p) >= 0;
  });
  f.length === 0 && (f = d);
  var h = f.reduce(function(p, m) {
    return p[m] = Oa(t, {
      placement: m,
      boundary: i,
      rootBoundary: o,
      padding: s
    })[lr(m)], p;
  }, {});
  return Object.keys(h).sort(function(p, m) {
    return h[p] - h[m];
  });
}
function FZ(t) {
  if (lr(t) === gb)
    return [];
  var e = vc(t);
  return [$k(t), e, $k(e)];
}
function $Z(t) {
  var e = t.state, n = t.options, r = t.name;
  if (!e.modifiersData[r]._skip) {
    for (var i = n.mainAxis, o = i === void 0 ? !0 : i, s = n.altAxis, a = s === void 0 ? !0 : s, l = n.fallbackPlacements, c = n.padding, u = n.boundary, d = n.rootBoundary, f = n.altBoundary, h = n.flipVariations, p = h === void 0 ? !0 : h, m = n.allowedAutoPlacements, b = e.options.placement, y = lr(b), k = y === b, C = l || (k || !p ? [vc(b)] : FZ(b)), x = [b].concat(C).reduce(function(te, le) {
      return te.concat(lr(le) === gb ? LZ(e, {
        placement: le,
        boundary: u,
        rootBoundary: d,
        padding: c,
        flipVariations: p,
        allowedAutoPlacements: m
      }) : le);
    }, []), S = e.rects.reference, T = e.rects.popper, E = /* @__PURE__ */ new Map(), M = !0, O = x[0], L = 0; L < x.length; L++) {
      var $ = x[L], z = lr($), B = us($) === as, A = [nn, In].indexOf(z) >= 0, N = A ? "width" : "height", R = Oa(e, {
        placement: $,
        boundary: u,
        rootBoundary: d,
        altBoundary: f,
        padding: c
      }), _ = A ? B ? _n : rn : B ? In : nn;
      S[N] > T[N] && (_ = vc(_));
      var D = vc(_), q = [];
      if (o && q.push(R[z] <= 0), a && q.push(R[_] <= 0, R[D] <= 0), q.every(function(te) {
        return te;
      })) {
        O = $, M = !1;
        break;
      }
      E.set($, q);
    }
    if (M)
      for (var V = p ? 3 : 1, H = function(le) {
        var se = x.find(function(j) {
          var X = E.get(j);
          if (X)
            return X.slice(0, le).every(function(ie) {
              return ie;
            });
        });
        if (se)
          return O = se, "break";
      }, G = V; G > 0; G--) {
        var Q = H(G);
        if (Q === "break") break;
      }
    e.placement !== O && (e.modifiersData[r]._skip = !0, e.placement = O, e.reset = !0);
  }
}
const BZ = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: $Z,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Vk(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function zk(t) {
  return [nn, _n, In, rn].some(function(e) {
    return t[e] >= 0;
  });
}
function VZ(t) {
  var e = t.state, n = t.name, r = e.rects.reference, i = e.rects.popper, o = e.modifiersData.preventOverflow, s = Oa(e, {
    elementContext: "reference"
  }), a = Oa(e, {
    altBoundary: !0
  }), l = Vk(s, r), c = Vk(a, i, o), u = zk(l), d = zk(c);
  e.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
const zZ = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: VZ
};
function HZ(t, e, n) {
  var r = lr(t), i = [rn, nn].indexOf(r) >= 0 ? -1 : 1, o = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, s = o[0], a = o[1];
  return s = s || 0, a = (a || 0) * i, [rn, _n].indexOf(r) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function WZ(t) {
  var e = t.state, n = t.options, r = t.name, i = n.offset, o = i === void 0 ? [0, 0] : i, s = k3.reduce(function(u, d) {
    return u[d] = HZ(d, e.rects, o), u;
  }, {}), a = s[e.placement], l = a.x, c = a.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[r] = s;
}
const jZ = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: WZ
};
function UZ(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = N3({
    reference: e.rects.reference,
    element: e.rects.popper,
    placement: e.placement
  });
}
const qZ = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: UZ,
  data: {}
};
function KZ(t) {
  return t === "x" ? "y" : "x";
}
function GZ(t) {
  var e = t.state, n = t.options, r = t.name, i = n.mainAxis, o = i === void 0 ? !0 : i, s = n.altAxis, a = s === void 0 ? !1 : s, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, d = n.padding, f = n.tether, h = f === void 0 ? !0 : f, p = n.tetherOffset, m = p === void 0 ? 0 : p, b = Oa(e, {
    boundary: l,
    rootBoundary: c,
    padding: d,
    altBoundary: u
  }), y = lr(e.placement), k = us(e.placement), C = !k, x = yb(y), S = KZ(x), T = e.modifiersData.popperOffsets, E = e.rects.reference, M = e.rects.popper, O = typeof m == "function" ? m(Object.assign({}, e.rects, {
    placement: e.placement
  })) : m, L = typeof O == "number" ? {
    mainAxis: O,
    altAxis: O
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, O), $ = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, z = {
    x: 0,
    y: 0
  };
  if (T) {
    if (o) {
      var B, A = x === "y" ? nn : rn, N = x === "y" ? In : _n, R = x === "y" ? "height" : "width", _ = T[x], D = _ + b[A], q = _ - b[N], V = h ? -M[R] / 2 : 0, H = k === as ? E[R] : M[R], G = k === as ? -M[R] : -E[R], Q = e.elements.arrow, te = h && Q ? bb(Q) : {
        width: 0,
        height: 0
      }, le = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : E3(), se = le[A], j = le[N], X = Qs(0, E[R], te[R]), ie = C ? E[R] / 2 - V - X - se - L.mainAxis : H - X - se - L.mainAxis, ne = C ? -E[R] / 2 + V + X + j + L.mainAxis : G + X + j + L.mainAxis, we = e.elements.arrow && al(e.elements.arrow), K = we ? x === "y" ? we.clientTop || 0 : we.clientLeft || 0 : 0, Fe = (B = $ == null ? void 0 : $[x]) != null ? B : 0, oe = _ + ie - Fe - K, kt = _ + ne - Fe, Ot = Qs(h ? au(D, oe) : D, _, h ? Xi(q, kt) : q);
      T[x] = Ot, z[x] = Ot - _;
    }
    if (a) {
      var Zt, yo = x === "x" ? nn : rn, br = x === "x" ? In : _n, yr = T[S], zr = S === "y" ? "height" : "width", Ms = yr + b[yo], Di = yr - b[br], Os = [nn, rn].indexOf(y) !== -1, ul = (Zt = $ == null ? void 0 : $[S]) != null ? Zt : 0, dl = Os ? Ms : yr - E[zr] - M[zr] - ul + L.altAxis, fl = Os ? yr + E[zr] + M[zr] - ul - L.altAxis : Di, hl = h && Os ? bZ(dl, yr, fl) : Qs(h ? dl : Ms, yr, h ? fl : Di);
      T[S] = hl, z[S] = hl - yr;
    }
    e.modifiersData[r] = z;
  }
}
const YZ = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: GZ,
  requiresIfExists: ["offset"]
};
function ZZ(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function JZ(t) {
  return t === vn(t) || !Dn(t) ? wb(t) : ZZ(t);
}
function XZ(t) {
  var e = t.getBoundingClientRect(), n = ls(e.width) / t.offsetWidth || 1, r = ls(e.height) / t.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function QZ(t, e, n) {
  n === void 0 && (n = !1);
  var r = Dn(e), i = Dn(e) && XZ(e), o = Ni(e), s = cs(t, i, n), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((hr(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  kb(o)) && (a = JZ(e)), Dn(e) ? (l = cs(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : o && (l.x = xb(o))), {
    x: s.left + a.scrollLeft - l.x,
    y: s.top + a.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function eJ(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  t.forEach(function(o) {
    e.set(o.name, o);
  });
  function i(o) {
    n.add(o.name);
    var s = [].concat(o.requires || [], o.requiresIfExists || []);
    s.forEach(function(a) {
      if (!n.has(a)) {
        var l = e.get(a);
        l && i(l);
      }
    }), r.push(o);
  }
  return t.forEach(function(o) {
    n.has(o.name) || i(o);
  }), r;
}
function tJ(t) {
  var e = eJ(t);
  return hZ.reduce(function(n, r) {
    return n.concat(e.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function nJ(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function rJ(t) {
  var e = t.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var Hk = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Wk() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function iJ(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, r = n === void 0 ? [] : n, i = e.defaultOptions, o = i === void 0 ? Hk : i;
  return function(a, l, c) {
    c === void 0 && (c = o);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Hk, o),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, h = {
      state: u,
      setOptions: function(y) {
        var k = typeof y == "function" ? y(u.options) : y;
        m(), u.options = Object.assign({}, o, u.options, k), u.scrollParents = {
          reference: lo(a) ? ea(a) : a.contextElement ? ea(a.contextElement) : [],
          popper: ea(l)
        };
        var C = tJ(rJ([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = C.filter(function(x) {
          return x.enabled;
        }), p(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var y = u.elements, k = y.reference, C = y.popper;
          if (Wk(k, C)) {
            u.rects = {
              reference: QZ(k, al(C), u.options.strategy === "fixed"),
              popper: bb(C)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(L) {
              return u.modifiersData[L.name] = Object.assign({}, L.data);
            });
            for (var x = 0; x < u.orderedModifiers.length; x++) {
              if (u.reset === !0) {
                u.reset = !1, x = -1;
                continue;
              }
              var S = u.orderedModifiers[x], T = S.fn, E = S.options, M = E === void 0 ? {} : E, O = S.name;
              typeof T == "function" && (u = T({
                state: u,
                options: M,
                name: O,
                instance: h
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: nJ(function() {
        return new Promise(function(b) {
          h.forceUpdate(), b(u);
        });
      }),
      destroy: function() {
        m(), f = !0;
      }
    };
    if (!Wk(a, l))
      return h;
    h.setOptions(c).then(function(b) {
      !f && c.onFirstUpdate && c.onFirstUpdate(b);
    });
    function p() {
      u.orderedModifiers.forEach(function(b) {
        var y = b.name, k = b.options, C = k === void 0 ? {} : k, x = b.effect;
        if (typeof x == "function") {
          var S = x({
            state: u,
            name: y,
            instance: h,
            options: C
          }), T = function() {
          };
          d.push(S || T);
        }
      });
    }
    function m() {
      d.forEach(function(b) {
        return b();
      }), d = [];
    }
    return h;
  };
}
var oJ = [OZ, qZ, EZ, C3, jZ, BZ, YZ, kZ, zZ], sJ = /* @__PURE__ */ iJ({
  defaultModifiers: oJ
}), aJ = "tippy-box", R3 = "tippy-content", lJ = "tippy-backdrop", D3 = "tippy-arrow", I3 = "tippy-svg-arrow", $i = {
  passive: !0,
  capture: !0
}, _3 = function() {
  return document.body;
};
function cJ(t, e) {
  return {}.hasOwnProperty.call(t, e);
}
function mp(t, e, n) {
  if (Array.isArray(t)) {
    var r = t[e];
    return r ?? (Array.isArray(n) ? n[e] : n);
  }
  return t;
}
function Cb(t, e) {
  var n = {}.toString.call(t);
  return n.indexOf("[object") === 0 && n.indexOf(e + "]") > -1;
}
function P3(t, e) {
  return typeof t == "function" ? t.apply(void 0, e) : t;
}
function jk(t, e) {
  if (e === 0)
    return t;
  var n;
  return function(r) {
    clearTimeout(n), n = setTimeout(function() {
      t(r);
    }, e);
  };
}
function uJ(t, e) {
  var n = Object.assign({}, t);
  return e.forEach(function(r) {
    delete n[r];
  }), n;
}
function dJ(t) {
  return t.split(/\s+/).filter(Boolean);
}
function Po(t) {
  return [].concat(t);
}
function Uk(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function fJ(t) {
  return t.filter(function(e, n) {
    return t.indexOf(e) === n;
  });
}
function hJ(t) {
  return t.split("-")[0];
}
function lu(t) {
  return [].slice.call(t);
}
function qk(t) {
  return Object.keys(t).reduce(function(e, n) {
    return t[n] !== void 0 && (e[n] = t[n]), e;
  }, {});
}
function ta() {
  return document.createElement("div");
}
function Aa(t) {
  return ["Element", "Fragment"].some(function(e) {
    return Cb(t, e);
  });
}
function pJ(t) {
  return Cb(t, "NodeList");
}
function mJ(t) {
  return Cb(t, "MouseEvent");
}
function gJ(t) {
  return !!(t && t._tippy && t._tippy.reference === t);
}
function vJ(t) {
  return Aa(t) ? [t] : pJ(t) ? lu(t) : Array.isArray(t) ? t : lu(document.querySelectorAll(t));
}
function gp(t, e) {
  t.forEach(function(n) {
    n && (n.style.transitionDuration = e + "ms");
  });
}
function Kk(t, e) {
  t.forEach(function(n) {
    n && n.setAttribute("data-state", e);
  });
}
function bJ(t) {
  var e, n = Po(t), r = n[0];
  return r != null && (e = r.ownerDocument) != null && e.body ? r.ownerDocument : document;
}
function yJ(t, e) {
  var n = e.clientX, r = e.clientY;
  return t.every(function(i) {
    var o = i.popperRect, s = i.popperState, a = i.props, l = a.interactiveBorder, c = hJ(s.placement), u = s.modifiersData.offset;
    if (!u)
      return !0;
    var d = c === "bottom" ? u.top.y : 0, f = c === "top" ? u.bottom.y : 0, h = c === "right" ? u.left.x : 0, p = c === "left" ? u.right.x : 0, m = o.top - r + d > l, b = r - o.bottom - f > l, y = o.left - n + h > l, k = n - o.right - p > l;
    return m || b || y || k;
  });
}
function vp(t, e, n) {
  var r = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(i) {
    t[r](i, n);
  });
}
function Gk(t, e) {
  for (var n = e; n; ) {
    var r;
    if (t.contains(n))
      return !0;
    n = n.getRootNode == null || (r = n.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var tr = {
  isTouch: !1
}, Yk = 0;
function wJ() {
  tr.isTouch || (tr.isTouch = !0, window.performance && document.addEventListener("mousemove", L3));
}
function L3() {
  var t = performance.now();
  t - Yk < 20 && (tr.isTouch = !1, document.removeEventListener("mousemove", L3)), Yk = t;
}
function xJ() {
  var t = document.activeElement;
  if (gJ(t)) {
    var e = t._tippy;
    t.blur && !e.state.isVisible && t.blur();
  }
}
function kJ() {
  document.addEventListener("touchstart", wJ, $i), window.addEventListener("blur", xJ);
}
var CJ = typeof window < "u" && typeof document < "u", SJ = CJ ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function Do(t) {
  var e = t === "destroy" ? "n already-" : " ";
  return [t + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function Zk(t) {
  var e = /[ \t]{2,}/g, n = /^[ \t]*/gm;
  return t.replace(e, " ").replace(n, "").trim();
}
function TJ(t) {
  return Zk(`
  %ctippy.js

  %c` + Zk(t) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function F3(t) {
  return [
    TJ(t),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var Na;
process.env.NODE_ENV !== "production" && EJ();
function EJ() {
  Na = /* @__PURE__ */ new Set();
}
function Ar(t, e) {
  if (t && !Na.has(e)) {
    var n;
    Na.add(e), (n = console).warn.apply(n, F3(e));
  }
}
function o0(t, e) {
  if (t && !Na.has(e)) {
    var n;
    Na.add(e), (n = console).error.apply(n, F3(e));
  }
}
function MJ(t) {
  var e = !t, n = Object.prototype.toString.call(t) === "[object Object]" && !t.addEventListener;
  o0(e, ["tippy() was passed", "`" + String(t) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), o0(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var $3 = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, OJ = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, cn = Object.assign({
  appendTo: _3,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, $3, OJ), AJ = Object.keys(cn), NJ = function(e) {
  process.env.NODE_ENV !== "production" && V3(e, []);
  var n = Object.keys(e);
  n.forEach(function(r) {
    cn[r] = e[r];
  });
};
function B3(t) {
  var e = t.plugins || [], n = e.reduce(function(r, i) {
    var o = i.name, s = i.defaultValue;
    if (o) {
      var a;
      r[o] = t[o] !== void 0 ? t[o] : (a = cn[o]) != null ? a : s;
    }
    return r;
  }, {});
  return Object.assign({}, t, n);
}
function RJ(t, e) {
  var n = e ? Object.keys(B3(Object.assign({}, cn, {
    plugins: e
  }))) : AJ, r = n.reduce(function(i, o) {
    var s = (t.getAttribute("data-tippy-" + o) || "").trim();
    if (!s)
      return i;
    if (o === "content")
      i[o] = s;
    else
      try {
        i[o] = JSON.parse(s);
      } catch {
        i[o] = s;
      }
    return i;
  }, {});
  return r;
}
function Jk(t, e) {
  var n = Object.assign({}, e, {
    content: P3(e.content, [t])
  }, e.ignoreAttributes ? {} : RJ(t, e.plugins));
  return n.aria = Object.assign({}, cn.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? e.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? e.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function V3(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = []);
  var n = Object.keys(t);
  n.forEach(function(r) {
    var i = uJ(cn, Object.keys($3)), o = !cJ(i, r);
    o && (o = e.filter(function(s) {
      return s.name === r;
    }).length === 0), Ar(o, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var DJ = function() {
  return "innerHTML";
};
function s0(t, e) {
  t[DJ()] = e;
}
function Xk(t) {
  var e = ta();
  return t === !0 ? e.className = D3 : (e.className = I3, Aa(t) ? e.appendChild(t) : s0(e, t)), e;
}
function Qk(t, e) {
  Aa(e.content) ? (s0(t, ""), t.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? s0(t, e.content) : t.textContent = e.content);
}
function a0(t) {
  var e = t.firstElementChild, n = lu(e.children);
  return {
    box: e,
    content: n.find(function(r) {
      return r.classList.contains(R3);
    }),
    arrow: n.find(function(r) {
      return r.classList.contains(D3) || r.classList.contains(I3);
    }),
    backdrop: n.find(function(r) {
      return r.classList.contains(lJ);
    })
  };
}
function z3(t) {
  var e = ta(), n = ta();
  n.className = aJ, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var r = ta();
  r.className = R3, r.setAttribute("data-state", "hidden"), Qk(r, t.props), e.appendChild(n), n.appendChild(r), i(t.props, t.props);
  function i(o, s) {
    var a = a0(e), l = a.box, c = a.content, u = a.arrow;
    s.theme ? l.setAttribute("data-theme", s.theme) : l.removeAttribute("data-theme"), typeof s.animation == "string" ? l.setAttribute("data-animation", s.animation) : l.removeAttribute("data-animation"), s.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof s.maxWidth == "number" ? s.maxWidth + "px" : s.maxWidth, s.role ? l.setAttribute("role", s.role) : l.removeAttribute("role"), (o.content !== s.content || o.allowHTML !== s.allowHTML) && Qk(c, t.props), s.arrow ? u ? o.arrow !== s.arrow && (l.removeChild(u), l.appendChild(Xk(s.arrow))) : l.appendChild(Xk(s.arrow)) : u && l.removeChild(u);
  }
  return {
    popper: e,
    onUpdate: i
  };
}
z3.$$tippy = !0;
var IJ = 1, jl = [], bp = [];
function _J(t, e) {
  var n = Jk(t, Object.assign({}, cn, B3(qk(e)))), r, i, o, s = !1, a = !1, l = !1, c = !1, u, d, f, h = [], p = jk(oe, n.interactiveDebounce), m, b = IJ++, y = null, k = fJ(n.plugins), C = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, x = {
    // properties
    id: b,
    reference: t,
    popper: ta(),
    popperInstance: y,
    props: n,
    state: C,
    plugins: k,
    // methods
    clearDelayTimeouts: dl,
    setProps: fl,
    setContent: hl,
    show: mD,
    hide: gD,
    hideWithInteractivity: vD,
    enable: Os,
    disable: ul,
    unmount: bD,
    destroy: yD
  };
  if (!n.render)
    return process.env.NODE_ENV !== "production" && o0(!0, "render() function has not been supplied."), x;
  var S = n.render(x), T = S.popper, E = S.onUpdate;
  T.setAttribute("data-tippy-root", ""), T.id = "tippy-" + x.id, x.popper = T, t._tippy = x, T._tippy = x;
  var M = k.map(function(W) {
    return W.fn(x);
  }), O = t.hasAttribute("aria-expanded");
  return we(), V(), _(), D("onCreate", [x]), n.showOnCreate && Ms(), T.addEventListener("mouseenter", function() {
    x.props.interactive && x.state.isVisible && x.clearDelayTimeouts();
  }), T.addEventListener("mouseleave", function() {
    x.props.interactive && x.props.trigger.indexOf("mouseenter") >= 0 && A().addEventListener("mousemove", p);
  }), x;
  function L() {
    var W = x.props.touch;
    return Array.isArray(W) ? W : [W, 0];
  }
  function $() {
    return L()[0] === "hold";
  }
  function z() {
    var W;
    return !!((W = x.props.render) != null && W.$$tippy);
  }
  function B() {
    return m || t;
  }
  function A() {
    var W = B().parentNode;
    return W ? bJ(W) : document;
  }
  function N() {
    return a0(T);
  }
  function R(W) {
    return x.state.isMounted && !x.state.isVisible || tr.isTouch || u && u.type === "focus" ? 0 : mp(x.props.delay, W ? 0 : 1, cn.delay);
  }
  function _(W) {
    W === void 0 && (W = !1), T.style.pointerEvents = x.props.interactive && !W ? "" : "none", T.style.zIndex = "" + x.props.zIndex;
  }
  function D(W, fe, Se) {
    if (Se === void 0 && (Se = !0), M.forEach(function(_e) {
      _e[W] && _e[W].apply(_e, fe);
    }), Se) {
      var Ue;
      (Ue = x.props)[W].apply(Ue, fe);
    }
  }
  function q() {
    var W = x.props.aria;
    if (W.content) {
      var fe = "aria-" + W.content, Se = T.id, Ue = Po(x.props.triggerTarget || t);
      Ue.forEach(function(_e) {
        var Vt = _e.getAttribute(fe);
        if (x.state.isVisible)
          _e.setAttribute(fe, Vt ? Vt + " " + Se : Se);
        else {
          var bn = Vt && Vt.replace(Se, "").trim();
          bn ? _e.setAttribute(fe, bn) : _e.removeAttribute(fe);
        }
      });
    }
  }
  function V() {
    if (!(O || !x.props.aria.expanded)) {
      var W = Po(x.props.triggerTarget || t);
      W.forEach(function(fe) {
        x.props.interactive ? fe.setAttribute("aria-expanded", x.state.isVisible && fe === B() ? "true" : "false") : fe.removeAttribute("aria-expanded");
      });
    }
  }
  function H() {
    A().removeEventListener("mousemove", p), jl = jl.filter(function(W) {
      return W !== p;
    });
  }
  function G(W) {
    if (!(tr.isTouch && (l || W.type === "mousedown"))) {
      var fe = W.composedPath && W.composedPath()[0] || W.target;
      if (!(x.props.interactive && Gk(T, fe))) {
        if (Po(x.props.triggerTarget || t).some(function(Se) {
          return Gk(Se, fe);
        })) {
          if (tr.isTouch || x.state.isVisible && x.props.trigger.indexOf("click") >= 0)
            return;
        } else
          D("onClickOutside", [x, W]);
        x.props.hideOnClick === !0 && (x.clearDelayTimeouts(), x.hide(), a = !0, setTimeout(function() {
          a = !1;
        }), x.state.isMounted || se());
      }
    }
  }
  function Q() {
    l = !0;
  }
  function te() {
    l = !1;
  }
  function le() {
    var W = A();
    W.addEventListener("mousedown", G, !0), W.addEventListener("touchend", G, $i), W.addEventListener("touchstart", te, $i), W.addEventListener("touchmove", Q, $i);
  }
  function se() {
    var W = A();
    W.removeEventListener("mousedown", G, !0), W.removeEventListener("touchend", G, $i), W.removeEventListener("touchstart", te, $i), W.removeEventListener("touchmove", Q, $i);
  }
  function j(W, fe) {
    ie(W, function() {
      !x.state.isVisible && T.parentNode && T.parentNode.contains(T) && fe();
    });
  }
  function X(W, fe) {
    ie(W, fe);
  }
  function ie(W, fe) {
    var Se = N().box;
    function Ue(_e) {
      _e.target === Se && (vp(Se, "remove", Ue), fe());
    }
    if (W === 0)
      return fe();
    vp(Se, "remove", d), vp(Se, "add", Ue), d = Ue;
  }
  function ne(W, fe, Se) {
    Se === void 0 && (Se = !1);
    var Ue = Po(x.props.triggerTarget || t);
    Ue.forEach(function(_e) {
      _e.addEventListener(W, fe, Se), h.push({
        node: _e,
        eventType: W,
        handler: fe,
        options: Se
      });
    });
  }
  function we() {
    $() && (ne("touchstart", Fe, {
      passive: !0
    }), ne("touchend", kt, {
      passive: !0
    })), dJ(x.props.trigger).forEach(function(W) {
      if (W !== "manual")
        switch (ne(W, Fe), W) {
          case "mouseenter":
            ne("mouseleave", kt);
            break;
          case "focus":
            ne(SJ ? "focusout" : "blur", Ot);
            break;
          case "focusin":
            ne("focusout", Ot);
            break;
        }
    });
  }
  function K() {
    h.forEach(function(W) {
      var fe = W.node, Se = W.eventType, Ue = W.handler, _e = W.options;
      fe.removeEventListener(Se, Ue, _e);
    }), h = [];
  }
  function Fe(W) {
    var fe, Se = !1;
    if (!(!x.state.isEnabled || Zt(W) || a)) {
      var Ue = ((fe = u) == null ? void 0 : fe.type) === "focus";
      u = W, m = W.currentTarget, V(), !x.state.isVisible && mJ(W) && jl.forEach(function(_e) {
        return _e(W);
      }), W.type === "click" && (x.props.trigger.indexOf("mouseenter") < 0 || s) && x.props.hideOnClick !== !1 && x.state.isVisible ? Se = !0 : Ms(W), W.type === "click" && (s = !Se), Se && !Ue && Di(W);
    }
  }
  function oe(W) {
    var fe = W.target, Se = B().contains(fe) || T.contains(fe);
    if (!(W.type === "mousemove" && Se)) {
      var Ue = zr().concat(T).map(function(_e) {
        var Vt, bn = _e._tippy, wo = (Vt = bn.popperInstance) == null ? void 0 : Vt.state;
        return wo ? {
          popperRect: _e.getBoundingClientRect(),
          popperState: wo,
          props: n
        } : null;
      }).filter(Boolean);
      yJ(Ue, W) && (H(), Di(W));
    }
  }
  function kt(W) {
    var fe = Zt(W) || x.props.trigger.indexOf("click") >= 0 && s;
    if (!fe) {
      if (x.props.interactive) {
        x.hideWithInteractivity(W);
        return;
      }
      Di(W);
    }
  }
  function Ot(W) {
    x.props.trigger.indexOf("focusin") < 0 && W.target !== B() || x.props.interactive && W.relatedTarget && T.contains(W.relatedTarget) || Di(W);
  }
  function Zt(W) {
    return tr.isTouch ? $() !== W.type.indexOf("touch") >= 0 : !1;
  }
  function yo() {
    br();
    var W = x.props, fe = W.popperOptions, Se = W.placement, Ue = W.offset, _e = W.getReferenceClientRect, Vt = W.moveTransition, bn = z() ? a0(T).arrow : null, wo = _e ? {
      getBoundingClientRect: _e,
      contextElement: _e.contextElement || B()
    } : t, Hb = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(pl) {
        var xo = pl.state;
        if (z()) {
          var wD = N(), Kd = wD.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(ml) {
            ml === "placement" ? Kd.setAttribute("data-placement", xo.placement) : xo.attributes.popper["data-popper-" + ml] ? Kd.setAttribute("data-" + ml, "") : Kd.removeAttribute("data-" + ml);
          }), xo.attributes.popper = {};
        }
      }
    }, Ii = [{
      name: "offset",
      options: {
        offset: Ue
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !Vt
      }
    }, Hb];
    z() && bn && Ii.push({
      name: "arrow",
      options: {
        element: bn,
        padding: 3
      }
    }), Ii.push.apply(Ii, (fe == null ? void 0 : fe.modifiers) || []), x.popperInstance = sJ(wo, T, Object.assign({}, fe, {
      placement: Se,
      onFirstUpdate: f,
      modifiers: Ii
    }));
  }
  function br() {
    x.popperInstance && (x.popperInstance.destroy(), x.popperInstance = null);
  }
  function yr() {
    var W = x.props.appendTo, fe, Se = B();
    x.props.interactive && W === _3 || W === "parent" ? fe = Se.parentNode : fe = P3(W, [Se]), fe.contains(T) || fe.appendChild(T), x.state.isMounted = !0, yo(), process.env.NODE_ENV !== "production" && Ar(x.props.interactive && W === cn.appendTo && Se.nextElementSibling !== T, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function zr() {
    return lu(T.querySelectorAll("[data-tippy-root]"));
  }
  function Ms(W) {
    x.clearDelayTimeouts(), W && D("onTrigger", [x, W]), le();
    var fe = R(!0), Se = L(), Ue = Se[0], _e = Se[1];
    tr.isTouch && Ue === "hold" && _e && (fe = _e), fe ? r = setTimeout(function() {
      x.show();
    }, fe) : x.show();
  }
  function Di(W) {
    if (x.clearDelayTimeouts(), D("onUntrigger", [x, W]), !x.state.isVisible) {
      se();
      return;
    }
    if (!(x.props.trigger.indexOf("mouseenter") >= 0 && x.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(W.type) >= 0 && s)) {
      var fe = R(!1);
      fe ? i = setTimeout(function() {
        x.state.isVisible && x.hide();
      }, fe) : o = requestAnimationFrame(function() {
        x.hide();
      });
    }
  }
  function Os() {
    x.state.isEnabled = !0;
  }
  function ul() {
    x.hide(), x.state.isEnabled = !1;
  }
  function dl() {
    clearTimeout(r), clearTimeout(i), cancelAnimationFrame(o);
  }
  function fl(W) {
    if (process.env.NODE_ENV !== "production" && Ar(x.state.isDestroyed, Do("setProps")), !x.state.isDestroyed) {
      D("onBeforeUpdate", [x, W]), K();
      var fe = x.props, Se = Jk(t, Object.assign({}, fe, qk(W), {
        ignoreAttributes: !0
      }));
      x.props = Se, we(), fe.interactiveDebounce !== Se.interactiveDebounce && (H(), p = jk(oe, Se.interactiveDebounce)), fe.triggerTarget && !Se.triggerTarget ? Po(fe.triggerTarget).forEach(function(Ue) {
        Ue.removeAttribute("aria-expanded");
      }) : Se.triggerTarget && t.removeAttribute("aria-expanded"), V(), _(), E && E(fe, Se), x.popperInstance && (yo(), zr().forEach(function(Ue) {
        requestAnimationFrame(Ue._tippy.popperInstance.forceUpdate);
      })), D("onAfterUpdate", [x, W]);
    }
  }
  function hl(W) {
    x.setProps({
      content: W
    });
  }
  function mD() {
    process.env.NODE_ENV !== "production" && Ar(x.state.isDestroyed, Do("show"));
    var W = x.state.isVisible, fe = x.state.isDestroyed, Se = !x.state.isEnabled, Ue = tr.isTouch && !x.props.touch, _e = mp(x.props.duration, 0, cn.duration);
    if (!(W || fe || Se || Ue) && !B().hasAttribute("disabled") && (D("onShow", [x], !1), x.props.onShow(x) !== !1)) {
      if (x.state.isVisible = !0, z() && (T.style.visibility = "visible"), _(), le(), x.state.isMounted || (T.style.transition = "none"), z()) {
        var Vt = N(), bn = Vt.box, wo = Vt.content;
        gp([bn, wo], 0);
      }
      f = function() {
        var Ii;
        if (!(!x.state.isVisible || c)) {
          if (c = !0, T.offsetHeight, T.style.transition = x.props.moveTransition, z() && x.props.animation) {
            var qd = N(), pl = qd.box, xo = qd.content;
            gp([pl, xo], _e), Kk([pl, xo], "visible");
          }
          q(), V(), Uk(bp, x), (Ii = x.popperInstance) == null || Ii.forceUpdate(), D("onMount", [x]), x.props.animation && z() && X(_e, function() {
            x.state.isShown = !0, D("onShown", [x]);
          });
        }
      }, yr();
    }
  }
  function gD() {
    process.env.NODE_ENV !== "production" && Ar(x.state.isDestroyed, Do("hide"));
    var W = !x.state.isVisible, fe = x.state.isDestroyed, Se = !x.state.isEnabled, Ue = mp(x.props.duration, 1, cn.duration);
    if (!(W || fe || Se) && (D("onHide", [x], !1), x.props.onHide(x) !== !1)) {
      if (x.state.isVisible = !1, x.state.isShown = !1, c = !1, s = !1, z() && (T.style.visibility = "hidden"), H(), se(), _(!0), z()) {
        var _e = N(), Vt = _e.box, bn = _e.content;
        x.props.animation && (gp([Vt, bn], Ue), Kk([Vt, bn], "hidden"));
      }
      q(), V(), x.props.animation ? z() && j(Ue, x.unmount) : x.unmount();
    }
  }
  function vD(W) {
    process.env.NODE_ENV !== "production" && Ar(x.state.isDestroyed, Do("hideWithInteractivity")), A().addEventListener("mousemove", p), Uk(jl, p), p(W);
  }
  function bD() {
    process.env.NODE_ENV !== "production" && Ar(x.state.isDestroyed, Do("unmount")), x.state.isVisible && x.hide(), x.state.isMounted && (br(), zr().forEach(function(W) {
      W._tippy.unmount();
    }), T.parentNode && T.parentNode.removeChild(T), bp = bp.filter(function(W) {
      return W !== x;
    }), x.state.isMounted = !1, D("onHidden", [x]));
  }
  function yD() {
    process.env.NODE_ENV !== "production" && Ar(x.state.isDestroyed, Do("destroy")), !x.state.isDestroyed && (x.clearDelayTimeouts(), x.unmount(), K(), delete t._tippy, x.state.isDestroyed = !0, D("onDestroy", [x]));
  }
}
function ll(t, e) {
  e === void 0 && (e = {});
  var n = cn.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (MJ(t), V3(e, n)), kJ();
  var r = Object.assign({}, e, {
    plugins: n
  }), i = vJ(t);
  if (process.env.NODE_ENV !== "production") {
    var o = Aa(r.content), s = i.length > 1;
    Ar(o && s, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var a = i.reduce(function(l, c) {
    var u = c && _J(c, r);
    return u && l.push(u), l;
  }, []);
  return Aa(t) ? a[0] : a;
}
ll.defaultProps = cn;
ll.setDefaultProps = NJ;
ll.currentInput = tr;
Object.assign({}, C3, {
  effect: function(e) {
    var n = e.state, r = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, r.popper), n.styles = r, n.elements.arrow && Object.assign(n.elements.arrow.style, r.arrow);
  }
});
ll.setDefaultProps({
  render: z3
});
class PJ {
  constructor({ editor: e, element: n, view: r, tippyOptions: i = {}, updateDelay: o = 250, shouldShow: s }) {
    this.preventHide = !1, this.shouldShow = ({ view: a, state: l, from: c, to: u }) => {
      const { doc: d, selection: f } = l, { empty: h } = f, p = !d.textBetween(c, u).length && db(l.selection), m = this.element.contains(document.activeElement);
      return !(!(a.hasFocus() || m) || h || p || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: a }) => {
      var l;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      a != null && a.relatedTarget && (!((l = this.element.parentNode) === null || l === void 0) && l.contains(a.relatedTarget)) || (a == null ? void 0 : a.relatedTarget) !== this.editor.view.dom && this.hide();
    }, this.tippyBlurHandler = (a) => {
      this.blurHandler({ event: a });
    }, this.handleDebouncedUpdate = (a, l) => {
      const c = !(l != null && l.selection.eq(a.state.selection)), u = !(l != null && l.doc.eq(a.state.doc));
      !c && !u || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(a, c, u, l);
      }, this.updateDelay));
    }, this.updateHandler = (a, l, c, u) => {
      var d, f, h;
      const { state: p, composing: m } = a, { selection: b } = p;
      if (m || !l && !c)
        return;
      this.createTooltip();
      const { ranges: k } = b, C = Math.min(...k.map((T) => T.$from.pos)), x = Math.max(...k.map((T) => T.$to.pos));
      if (!((d = this.shouldShow) === null || d === void 0 ? void 0 : d.call(this, {
        editor: this.editor,
        element: this.element,
        view: a,
        state: p,
        oldState: u,
        from: C,
        to: x
      }))) {
        this.hide();
        return;
      }
      (f = this.tippy) === null || f === void 0 || f.setProps({
        getReferenceClientRect: ((h = this.tippyOptions) === null || h === void 0 ? void 0 : h.getReferenceClientRect) || (() => {
          if (y3(p.selection)) {
            let T = a.nodeDOM(C);
            if (T) {
              const E = T.dataset.nodeViewWrapper ? T : T.querySelector("[data-node-view-wrapper]");
              if (E && (T = E.firstChild), T)
                return T.getBoundingClientRect();
            }
          }
          return CY(a, C, x);
        })
      }), this.show();
    }, this.editor = e, this.element = n, this.view = r, this.updateDelay = o, s && (this.shouldShow = s), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = i, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: e } = this.editor.options, n = !!e.parentElement;
    this.tippy || !n || (this.tippy = ll(e, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "top",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(e, n) {
    const { state: r } = e, i = r.selection.from !== r.selection.to;
    if (this.updateDelay > 0 && i) {
      this.handleDebouncedUpdate(e, n);
      return;
    }
    const o = !(n != null && n.selection.eq(e.state.selection)), s = !(n != null && n.doc.eq(e.state.doc));
    this.updateHandler(e, o, s, n);
  }
  show() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.show();
  }
  hide() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.hide();
  }
  destroy() {
    var e, n;
    !((e = this.tippy) === null || e === void 0) && e.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (n = this.tippy) === null || n === void 0 || n.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const H3 = (t) => new Ge({
  key: typeof t.pluginKey == "string" ? new tt(t.pluginKey) : t.pluginKey,
  view: (e) => new PJ({ view: e, ...t })
}), LJ = gt.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      H3({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        updateDelay: this.options.updateDelay,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
}), FJ = gt.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      mode: "textSize",
      textCounter: (t) => t.length,
      wordCounter: (t) => t.split(" ").filter((e) => e !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (t) => {
      const e = (t == null ? void 0 : t.node) || this.editor.state.doc;
      if (((t == null ? void 0 : t.mode) || this.options.mode) === "textSize") {
        const r = e.textBetween(0, e.content.size, void 0, " ");
        return this.options.textCounter(r);
      }
      return e.nodeSize;
    }, this.storage.words = (t) => {
      const e = (t == null ? void 0 : t.node) || this.editor.state.doc, n = e.textBetween(0, e.content.size, " ", " ");
      return this.options.wordCounter(n);
    };
  },
  addProseMirrorPlugins() {
    let t = !1;
    return [
      new Ge({
        key: new tt("characterCount"),
        appendTransaction: (e, n, r) => {
          if (t)
            return;
          const i = this.options.limit;
          if (i == null || i === 0) {
            t = !0;
            return;
          }
          const o = this.storage.characters({ node: r.doc });
          if (o > i) {
            const s = o - i, a = 0, l = s;
            console.warn(`[CharacterCount] Initial content exceeded limit of ${i} characters. Content was automatically trimmed.`);
            const c = r.tr.deleteRange(a, l);
            return t = !0, c;
          }
          t = !0;
        },
        filterTransaction: (e, n) => {
          const r = this.options.limit;
          if (!e.docChanged || r === 0 || r === null || r === void 0)
            return !0;
          const i = this.storage.characters({ node: n.doc }), o = this.storage.characters({ node: e.doc });
          if (o <= r || i > r && o > r && o <= i)
            return !0;
          if (i > r && o > r && o > i || !e.getMeta("paste"))
            return !1;
          const a = e.selection.$head.pos, l = o - r, c = a - l, u = a;
          return e.deleteRange(c, u), !(this.storage.characters({ node: e.doc }) > r);
        }
      })
    ];
  }
}), $J = (t) => {
  if (!t.children.length)
    return;
  const e = t.querySelectorAll("span");
  e && e.forEach((n) => {
    var r, i;
    const o = n.getAttribute("style"), s = (i = (r = n.parentElement) === null || r === void 0 ? void 0 : r.closest("span")) === null || i === void 0 ? void 0 : i.getAttribute("style");
    n.setAttribute("style", `${s};${o}`);
  });
}, eC = gn.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !1
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (t) => t.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && $J(t), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["span", Ke(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ tr: t }) => {
        const { selection: e } = t;
        return t.doc.nodesBetween(e.from, e.to, (n, r) => {
          if (n.isTextblock)
            return !0;
          n.marks.filter((i) => i.type === this.type).some((i) => Object.values(i.attrs).some((o) => !!o)) || t.removeMark(r, r + n.nodeSize, this.type);
        }), !0;
      }
    };
  }
}), BJ = gt.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (t) => {
              var e;
              return (e = t.style.color) === null || e === void 0 ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (t) => t.color ? {
              style: `color: ${t.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (t) => ({ chain: e }) => e().setMark("textStyle", { color: t }).run(),
      unsetColor: () => ({ chain: t }) => t().setMark("textStyle", { color: null }).removeEmptyTextStyle().run()
    };
  }
}), VJ = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))$/, zJ = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))/g, tC = gn.create({
  name: "highlight",
  addOptions() {
    return {
      multicolor: !1,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return this.options.multicolor ? {
      color: {
        default: null,
        parseHTML: (t) => t.getAttribute("data-color") || t.style.backgroundColor,
        renderHTML: (t) => t.color ? {
          "data-color": t.color,
          style: `background-color: ${t.color}; color: inherit`
        } : {}
      }
    } : {};
  },
  parseHTML() {
    return [
      {
        tag: "mark"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["mark", Ke(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setHighlight: (t) => ({ commands: e }) => e.setMark(this.name, t),
      toggleHighlight: (t) => ({ commands: e }) => e.toggleMark(this.name, t),
      unsetHighlight: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-h": () => this.editor.commands.toggleHighlight()
    };
  },
  addInputRules() {
    return [
      ao({
        find: VJ,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      xi({
        find: zJ,
        type: this.type
      })
    ];
  }
}), HJ = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, WJ = vt.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {}
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["img", Ke(this.options.HTMLAttributes, t)];
  },
  addCommands() {
    return {
      setImage: (t) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: t
      })
    };
  },
  addInputRules() {
    return [
      w3({
        find: HJ,
        type: this.type,
        getAttributes: (t) => {
          const [, , e, n, r] = t;
          return { src: n, alt: e, title: r };
        }
      })
    ];
  }
}), jJ = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster6d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", UJ = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", ds = (t, e) => {
  for (const n in e)
    t[n] = e[n];
  return t;
}, l0 = "numeric", c0 = "ascii", u0 = "alpha", na = "asciinumeric", Us = "alphanumeric", d0 = "domain", W3 = "emoji", qJ = "scheme", KJ = "slashscheme", yp = "whitespace";
function GJ(t, e) {
  return t in e || (e[t] = []), e[t];
}
function Ui(t, e, n) {
  e[l0] && (e[na] = !0, e[Us] = !0), e[c0] && (e[na] = !0, e[u0] = !0), e[na] && (e[Us] = !0), e[u0] && (e[Us] = !0), e[Us] && (e[d0] = !0), e[W3] && (e[d0] = !0);
  for (const r in e) {
    const i = GJ(r, n);
    i.indexOf(t) < 0 && i.push(t);
  }
}
function YJ(t, e) {
  const n = {};
  for (const r in e)
    e[r].indexOf(t) >= 0 && (n[r] = !0);
  return n;
}
function Jt(t = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = t;
}
Jt.groups = {};
Jt.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(t) {
    const e = this, n = e.j[t];
    if (n)
      return n;
    for (let r = 0; r < e.jr.length; r++) {
      const i = e.jr[r][0], o = e.jr[r][1];
      if (o && i.test(t))
        return o;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(t, e = !1) {
    return e ? t in this.j : !!this.go(t);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(t, e, n, r) {
    for (let i = 0; i < t.length; i++)
      this.tt(t[i], e, n, r);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(t, e, n, r) {
    r = r || Jt.groups;
    let i;
    return e && e.j ? i = e : (i = new Jt(e), n && r && Ui(e, n, r)), this.jr.push([t, i]), i;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(t, e, n, r) {
    let i = this;
    const o = t.length;
    if (!o)
      return i;
    for (let s = 0; s < o - 1; s++)
      i = i.tt(t[s]);
    return i.tt(t[o - 1], e, n, r);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(t, e, n, r) {
    r = r || Jt.groups;
    const i = this;
    if (e && e.j)
      return i.j[t] = e, e;
    const o = e;
    let s, a = i.go(t);
    if (a ? (s = new Jt(), ds(s.j, a.j), s.jr.push.apply(s.jr, a.jr), s.jd = a.jd, s.t = a.t) : s = new Jt(), o) {
      if (r)
        if (s.t && typeof s.t == "string") {
          const l = ds(YJ(s.t, r), n);
          Ui(o, l, r);
        } else n && Ui(o, n, r);
      s.t = o;
    }
    return i.j[t] = s, s;
  }
};
const Ne = (t, e, n, r, i) => t.ta(e, n, r, i), nt = (t, e, n, r, i) => t.tr(e, n, r, i), nC = (t, e, n, r, i) => t.ts(e, n, r, i), Y = (t, e, n, r, i) => t.tt(e, n, r, i), Tr = "WORD", f0 = "UWORD", j3 = "ASCIINUMERICAL", U3 = "ALPHANUMERICAL", Ra = "LOCALHOST", h0 = "TLD", p0 = "UTLD", bc = "SCHEME", Lo = "SLASH_SCHEME", Sb = "NUM", m0 = "WS", Tb = "NL", ra = "OPENBRACE", ia = "CLOSEBRACE", cu = "OPENBRACKET", uu = "CLOSEBRACKET", du = "OPENPAREN", fu = "CLOSEPAREN", hu = "OPENANGLEBRACKET", pu = "CLOSEANGLEBRACKET", mu = "FULLWIDTHLEFTPAREN", gu = "FULLWIDTHRIGHTPAREN", vu = "LEFTCORNERBRACKET", bu = "RIGHTCORNERBRACKET", yu = "LEFTWHITECORNERBRACKET", wu = "RIGHTWHITECORNERBRACKET", xu = "FULLWIDTHLESSTHAN", ku = "FULLWIDTHGREATERTHAN", Cu = "AMPERSAND", Eb = "APOSTROPHE", Su = "ASTERISK", Jr = "AT", Tu = "BACKSLASH", Eu = "BACKTICK", Mu = "CARET", ni = "COLON", Mb = "COMMA", Ou = "DOLLAR", Xn = "DOT", Au = "EQUALS", Ob = "EXCLAMATION", xn = "HYPHEN", oa = "PERCENT", Nu = "PIPE", Ru = "PLUS", Du = "POUND", sa = "QUERY", Ab = "QUOTE", q3 = "FULLWIDTHMIDDLEDOT", Nb = "SEMI", Qn = "SLASH", aa = "TILDE", Iu = "UNDERSCORE", K3 = "EMOJI", _u = "SYM";
var G3 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WORD: Tr,
  UWORD: f0,
  ASCIINUMERICAL: j3,
  ALPHANUMERICAL: U3,
  LOCALHOST: Ra,
  TLD: h0,
  UTLD: p0,
  SCHEME: bc,
  SLASH_SCHEME: Lo,
  NUM: Sb,
  WS: m0,
  NL: Tb,
  OPENBRACE: ra,
  CLOSEBRACE: ia,
  OPENBRACKET: cu,
  CLOSEBRACKET: uu,
  OPENPAREN: du,
  CLOSEPAREN: fu,
  OPENANGLEBRACKET: hu,
  CLOSEANGLEBRACKET: pu,
  FULLWIDTHLEFTPAREN: mu,
  FULLWIDTHRIGHTPAREN: gu,
  LEFTCORNERBRACKET: vu,
  RIGHTCORNERBRACKET: bu,
  LEFTWHITECORNERBRACKET: yu,
  RIGHTWHITECORNERBRACKET: wu,
  FULLWIDTHLESSTHAN: xu,
  FULLWIDTHGREATERTHAN: ku,
  AMPERSAND: Cu,
  APOSTROPHE: Eb,
  ASTERISK: Su,
  AT: Jr,
  BACKSLASH: Tu,
  BACKTICK: Eu,
  CARET: Mu,
  COLON: ni,
  COMMA: Mb,
  DOLLAR: Ou,
  DOT: Xn,
  EQUALS: Au,
  EXCLAMATION: Ob,
  HYPHEN: xn,
  PERCENT: oa,
  PIPE: Nu,
  PLUS: Ru,
  POUND: Du,
  QUERY: sa,
  QUOTE: Ab,
  FULLWIDTHMIDDLEDOT: q3,
  SEMI: Nb,
  SLASH: Qn,
  TILDE: aa,
  UNDERSCORE: Iu,
  EMOJI: K3,
  SYM: _u
});
const Cr = /[a-z]/, _s = new RegExp("\\p{L}", "u"), wp = new RegExp("\\p{Emoji}", "u"), Sr = /\d/, xp = /\s/, rC = "\r", kp = `
`, ZJ = "️", JJ = "‍", Cp = "￼";
let Ul = null, ql = null;
function XJ(t = []) {
  const e = {};
  Jt.groups = e;
  const n = new Jt();
  Ul == null && (Ul = iC(jJ)), ql == null && (ql = iC(UJ)), Y(n, "'", Eb), Y(n, "{", ra), Y(n, "}", ia), Y(n, "[", cu), Y(n, "]", uu), Y(n, "(", du), Y(n, ")", fu), Y(n, "<", hu), Y(n, ">", pu), Y(n, "（", mu), Y(n, "）", gu), Y(n, "「", vu), Y(n, "」", bu), Y(n, "『", yu), Y(n, "』", wu), Y(n, "＜", xu), Y(n, "＞", ku), Y(n, "&", Cu), Y(n, "*", Su), Y(n, "@", Jr), Y(n, "`", Eu), Y(n, "^", Mu), Y(n, ":", ni), Y(n, ",", Mb), Y(n, "$", Ou), Y(n, ".", Xn), Y(n, "=", Au), Y(n, "!", Ob), Y(n, "-", xn), Y(n, "%", oa), Y(n, "|", Nu), Y(n, "+", Ru), Y(n, "#", Du), Y(n, "?", sa), Y(n, '"', Ab), Y(n, "/", Qn), Y(n, ";", Nb), Y(n, "~", aa), Y(n, "_", Iu), Y(n, "\\", Tu), Y(n, "・", q3);
  const r = nt(n, Sr, Sb, {
    [l0]: !0
  });
  nt(r, Sr, r);
  const i = nt(r, Cr, j3, {
    [na]: !0
  }), o = nt(r, _s, U3, {
    [Us]: !0
  }), s = nt(n, Cr, Tr, {
    [c0]: !0
  });
  nt(s, Sr, i), nt(s, Cr, s), nt(i, Sr, i), nt(i, Cr, i);
  const a = nt(n, _s, f0, {
    [u0]: !0
  });
  nt(a, Cr), nt(a, Sr, o), nt(a, _s, a), nt(o, Sr, o), nt(o, Cr), nt(o, _s, o);
  const l = Y(n, kp, Tb, {
    [yp]: !0
  }), c = Y(n, rC, m0, {
    [yp]: !0
  }), u = nt(n, xp, m0, {
    [yp]: !0
  });
  Y(n, Cp, u), Y(c, kp, l), Y(c, Cp, u), nt(c, xp, u), Y(u, rC), Y(u, kp), nt(u, xp, u), Y(u, Cp, u);
  const d = nt(n, wp, K3, {
    [W3]: !0
  });
  Y(d, "#"), nt(d, wp, d), Y(d, ZJ, d);
  const f = Y(d, JJ);
  Y(f, "#"), nt(f, wp, d);
  const h = [[Cr, s], [Sr, i]], p = [[Cr, null], [_s, a], [Sr, o]];
  for (let m = 0; m < Ul.length; m++)
    Ur(n, Ul[m], h0, Tr, h);
  for (let m = 0; m < ql.length; m++)
    Ur(n, ql[m], p0, f0, p);
  Ui(h0, {
    tld: !0,
    ascii: !0
  }, e), Ui(p0, {
    utld: !0,
    alpha: !0
  }, e), Ur(n, "file", bc, Tr, h), Ur(n, "mailto", bc, Tr, h), Ur(n, "http", Lo, Tr, h), Ur(n, "https", Lo, Tr, h), Ur(n, "ftp", Lo, Tr, h), Ur(n, "ftps", Lo, Tr, h), Ui(bc, {
    scheme: !0,
    ascii: !0
  }, e), Ui(Lo, {
    slashscheme: !0,
    ascii: !0
  }, e), t = t.sort((m, b) => m[0] > b[0] ? 1 : -1);
  for (let m = 0; m < t.length; m++) {
    const b = t[m][0], k = t[m][1] ? {
      [qJ]: !0
    } : {
      [KJ]: !0
    };
    b.indexOf("-") >= 0 ? k[d0] = !0 : Cr.test(b) ? Sr.test(b) ? k[na] = !0 : k[c0] = !0 : k[l0] = !0, nC(n, b, b, k);
  }
  return nC(n, "localhost", Ra, {
    ascii: !0
  }), n.jd = new Jt(_u), {
    start: n,
    tokens: ds({
      groups: e
    }, G3)
  };
}
function Y3(t, e) {
  const n = QJ(e.replace(/[A-Z]/g, (a) => a.toLowerCase())), r = n.length, i = [];
  let o = 0, s = 0;
  for (; s < r; ) {
    let a = t, l = null, c = 0, u = null, d = -1, f = -1;
    for (; s < r && (l = a.go(n[s])); )
      a = l, a.accepts() ? (d = 0, f = 0, u = a) : d >= 0 && (d += n[s].length, f++), c += n[s].length, o += n[s].length, s++;
    o -= d, s -= f, c -= d, i.push({
      t: u.t,
      // token type/name
      v: e.slice(o - c, o),
      // string value
      s: o - c,
      // start index
      e: o
      // end index (excluding)
    });
  }
  return i;
}
function QJ(t) {
  const e = [], n = t.length;
  let r = 0;
  for (; r < n; ) {
    let i = t.charCodeAt(r), o, s = i < 55296 || i > 56319 || r + 1 === n || (o = t.charCodeAt(r + 1)) < 56320 || o > 57343 ? t[r] : t.slice(r, r + 2);
    e.push(s), r += s.length;
  }
  return e;
}
function Ur(t, e, n, r, i) {
  let o;
  const s = e.length;
  for (let a = 0; a < s - 1; a++) {
    const l = e[a];
    t.j[l] ? o = t.j[l] : (o = new Jt(r), o.jr = i.slice(), t.j[l] = o), t = o;
  }
  return o = new Jt(n), o.jr = i.slice(), t.j[e[s - 1]] = o, o;
}
function iC(t) {
  const e = [], n = [];
  let r = 0, i = "0123456789";
  for (; r < t.length; ) {
    let o = 0;
    for (; i.indexOf(t[r + o]) >= 0; )
      o++;
    if (o > 0) {
      e.push(n.join(""));
      for (let s = parseInt(t.substring(r, r + o), 10); s > 0; s--)
        n.pop();
      r += o;
    } else
      n.push(t[r]), r++;
  }
  return e;
}
const Da = {
  defaultProtocol: "http",
  events: null,
  format: oC,
  formatHref: oC,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function Rb(t, e = null) {
  let n = ds({}, Da);
  t && (n = ds(n, t instanceof Rb ? t.o : t));
  const r = n.ignoreTags, i = [];
  for (let o = 0; o < r.length; o++)
    i.push(r[o].toUpperCase());
  this.o = n, e && (this.defaultRender = e), this.ignoreTags = i;
}
Rb.prototype = {
  o: Da,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(t) {
    return t;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(t) {
    return this.get("validate", t.toString(), t);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(t, e, n) {
    const r = e != null;
    let i = this.o[t];
    return i && (typeof i == "object" ? (i = n.t in i ? i[n.t] : Da[t], typeof i == "function" && r && (i = i(e, n))) : typeof i == "function" && r && (i = i(e, n.t, n)), i);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(t, e, n) {
    let r = this.o[t];
    return typeof r == "function" && e != null && (r = r(e, n.t, n)), r;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(t) {
    const e = t.render(this);
    return (this.get("render", null, t) || this.defaultRender)(e, t.t, t);
  }
};
function oC(t) {
  return t;
}
function Z3(t, e) {
  this.t = "token", this.v = t, this.tk = e;
}
Z3.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(t) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(t) {
    const e = this.toString(), n = t.get("truncate", e, this), r = t.get("format", e, this);
    return n && r.length > n ? r.substring(0, n) + "…" : r;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(t) {
    return t.get("formatHref", this.toHref(t.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(t = Da.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(t),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(t) {
    return {
      type: this.t,
      value: this.toFormattedString(t),
      isLink: this.isLink,
      href: this.toFormattedHref(t),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(t) {
    return t.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(t) {
    const e = this, n = this.toHref(t.get("defaultProtocol")), r = t.get("formatHref", n, this), i = t.get("tagName", n, e), o = this.toFormattedString(t), s = {}, a = t.get("className", n, e), l = t.get("target", n, e), c = t.get("rel", n, e), u = t.getObj("attributes", n, e), d = t.getObj("events", n, e);
    return s.href = r, a && (s.class = a), l && (s.target = l), c && (s.rel = c), u && ds(s, u), {
      tagName: i,
      attributes: s,
      content: o,
      eventListeners: d
    };
  }
};
function Vd(t, e) {
  class n extends Z3 {
    constructor(i, o) {
      super(i, o), this.t = t;
    }
  }
  for (const r in e)
    n.prototype[r] = e[r];
  return n.t = t, n;
}
const sC = Vd("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), aC = Vd("text"), eX = Vd("nl"), Kl = Vd("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(t = Da.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${t}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const t = this.tk;
    return t.length >= 2 && t[0].t !== Ra && t[1].t === ni;
  }
}), wn = (t) => new Jt(t);
function tX({
  groups: t
}) {
  const e = t.domain.concat([Cu, Su, Jr, Tu, Eu, Mu, Ou, Au, xn, Sb, oa, Nu, Ru, Du, Qn, _u, aa, Iu]), n = [ni, Mb, Xn, Ob, oa, sa, Ab, Nb, hu, pu, ra, ia, uu, cu, du, fu, mu, gu, vu, bu, yu, wu, xu, ku], r = [Cu, Eb, Su, Tu, Eu, Mu, Ou, Au, xn, ra, ia, oa, Nu, Ru, Du, sa, Qn, _u, aa, Iu], i = wn(), o = Y(i, aa);
  Ne(o, r, o), Ne(o, t.domain, o);
  const s = wn(), a = wn(), l = wn();
  Ne(i, t.domain, s), Ne(i, t.scheme, a), Ne(i, t.slashscheme, l), Ne(s, r, o), Ne(s, t.domain, s);
  const c = Y(s, Jr);
  Y(o, Jr, c), Y(a, Jr, c), Y(l, Jr, c);
  const u = Y(o, Xn);
  Ne(u, r, o), Ne(u, t.domain, o);
  const d = wn();
  Ne(c, t.domain, d), Ne(d, t.domain, d);
  const f = Y(d, Xn);
  Ne(f, t.domain, d);
  const h = wn(sC);
  Ne(f, t.tld, h), Ne(f, t.utld, h), Y(c, Ra, h);
  const p = Y(d, xn);
  Y(p, xn, p), Ne(p, t.domain, d), Ne(h, t.domain, d), Y(h, Xn, f), Y(h, xn, p);
  const m = Y(h, ni);
  Ne(m, t.numeric, sC);
  const b = Y(s, xn), y = Y(s, Xn);
  Y(b, xn, b), Ne(b, t.domain, s), Ne(y, r, o), Ne(y, t.domain, s);
  const k = wn(Kl);
  Ne(y, t.tld, k), Ne(y, t.utld, k), Ne(k, t.domain, s), Ne(k, r, o), Y(k, Xn, y), Y(k, xn, b), Y(k, Jr, c);
  const C = Y(k, ni), x = wn(Kl);
  Ne(C, t.numeric, x);
  const S = wn(Kl), T = wn();
  Ne(S, e, S), Ne(S, n, T), Ne(T, e, S), Ne(T, n, T), Y(k, Qn, S), Y(x, Qn, S);
  const E = Y(a, ni), M = Y(l, ni), O = Y(M, Qn), L = Y(O, Qn);
  Ne(a, t.domain, s), Y(a, Xn, y), Y(a, xn, b), Ne(l, t.domain, s), Y(l, Xn, y), Y(l, xn, b), Ne(E, t.domain, S), Y(E, Qn, S), Y(E, sa, S), Ne(L, t.domain, S), Ne(L, e, S), Y(L, Qn, S);
  const $ = [
    [ra, ia],
    // {}
    [cu, uu],
    // []
    [du, fu],
    // ()
    [hu, pu],
    // <>
    [mu, gu],
    // （）
    [vu, bu],
    // 「」
    [yu, wu],
    // 『』
    [xu, ku]
    // ＜＞
  ];
  for (let z = 0; z < $.length; z++) {
    const [B, A] = $[z], N = Y(S, B);
    Y(T, B, N), Y(N, A, S);
    const R = wn(Kl);
    Ne(N, e, R);
    const _ = wn();
    Ne(N, n), Ne(R, e, R), Ne(R, n, _), Ne(_, e, R), Ne(_, n, _), Y(R, A, S), Y(_, A, S);
  }
  return Y(i, Ra, k), Y(i, Tb, eX), {
    start: i,
    tokens: G3
  };
}
function nX(t, e, n) {
  let r = n.length, i = 0, o = [], s = [];
  for (; i < r; ) {
    let a = t, l = null, c = null, u = 0, d = null, f = -1;
    for (; i < r && !(l = a.go(n[i].t)); )
      s.push(n[i++]);
    for (; i < r && (c = l || a.go(n[i].t)); )
      l = null, a = c, a.accepts() ? (f = 0, d = a) : f >= 0 && f++, i++, u++;
    if (f < 0)
      i -= u, i < r && (s.push(n[i]), i++);
    else {
      s.length > 0 && (o.push(Sp(aC, e, s)), s = []), i -= f, u -= f;
      const h = d.t, p = n.slice(i - u, i);
      o.push(Sp(h, e, p));
    }
  }
  return s.length > 0 && o.push(Sp(aC, e, s)), o;
}
function Sp(t, e, n) {
  const r = n[0].s, i = n[n.length - 1].e, o = e.slice(r, i);
  return new t(o, n);
}
const rX = typeof console < "u" && console && console.warn || (() => {
}), iX = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", et = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function oX() {
  return Jt.groups = {}, et.scanner = null, et.parser = null, et.tokenQueue = [], et.pluginQueue = [], et.customSchemes = [], et.initialized = !1, et;
}
function lC(t, e = !1) {
  if (et.initialized && rX(`linkifyjs: already initialized - will not register custom scheme "${t}" ${iX}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(t))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  et.customSchemes.push([t, e]);
}
function sX() {
  et.scanner = XJ(et.customSchemes);
  for (let t = 0; t < et.tokenQueue.length; t++)
    et.tokenQueue[t][1]({
      scanner: et.scanner
    });
  et.parser = tX(et.scanner.tokens);
  for (let t = 0; t < et.pluginQueue.length; t++)
    et.pluginQueue[t][1]({
      scanner: et.scanner,
      parser: et.parser
    });
  return et.initialized = !0, et;
}
function Db(t) {
  return et.initialized || sX(), nX(et.parser.start, t, Y3(et.scanner.start, t));
}
Db.scan = Y3;
function J3(t, e = null, n = null) {
  if (e && typeof e == "object") {
    if (n)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    n = e, e = null;
  }
  const r = new Rb(n), i = Db(t), o = [];
  for (let s = 0; s < i.length; s++) {
    const a = i[s];
    a.isLink && (!e || a.t === e) && r.check(a) && o.push(a.toFormattedObject(r));
  }
  return o;
}
function aX(t) {
  return t.length === 1 ? t[0].isLink : t.length === 3 && t[1].isLink ? ["()", "[]"].includes(t[0].value + t[2].value) : !1;
}
function lX(t) {
  return new Ge({
    key: new tt("autolink"),
    appendTransaction: (e, n, r) => {
      const i = e.some((c) => c.docChanged) && !n.doc.eq(r.doc), o = e.some((c) => c.getMeta("preventAutolink"));
      if (!i || o)
        return;
      const { tr: s } = r, a = pY(n.doc, [...e]);
      if (xY(a).forEach(({ newRange: c }) => {
        const u = gY(r.doc, c, (h) => h.isTextblock);
        let d, f;
        if (u.length > 1 ? (d = u[0], f = r.doc.textBetween(d.pos, d.pos + d.node.nodeSize, void 0, " ")) : u.length && r.doc.textBetween(c.from, c.to, " ", " ").endsWith(" ") && (d = u[0], f = r.doc.textBetween(d.pos, c.to, void 0, " ")), d && f) {
          const h = f.split(" ").filter((y) => y !== "");
          if (h.length <= 0)
            return !1;
          const p = h[h.length - 1], m = d.pos + f.lastIndexOf(p);
          if (!p)
            return !1;
          const b = Db(p).map((y) => y.toObject(t.defaultProtocol));
          if (!aX(b))
            return !1;
          b.filter((y) => y.isLink).map((y) => ({
            ...y,
            from: m + y.start + 1,
            to: m + y.end + 1
          })).filter((y) => r.schema.marks.code ? !r.doc.rangeHasMark(y.from, y.to, r.schema.marks.code) : !0).filter((y) => t.validate(y.value)).filter((y) => t.shouldAutoLink(y.value)).forEach((y) => {
            pb(y.from, y.to, r.doc).some((k) => k.mark.type === t.type) || s.addMark(y.from, y.to, t.type.create({
              href: y.href
            }));
          });
        }
      }), !!s.steps.length)
        return s;
    }
  });
}
function cX(t) {
  return new Ge({
    key: new tt("handleClickLink"),
    props: {
      handleClick: (e, n, r) => {
        var i, o;
        if (r.button !== 0 || !e.editable)
          return !1;
        let s = r.target;
        const a = [];
        for (; s.nodeName !== "DIV"; )
          a.push(s), s = s.parentNode;
        if (!a.find((f) => f.nodeName === "A"))
          return !1;
        const l = b3(e.state, t.type.name), c = r.target, u = (i = c == null ? void 0 : c.href) !== null && i !== void 0 ? i : l.href, d = (o = c == null ? void 0 : c.target) !== null && o !== void 0 ? o : l.target;
        return c && u ? (window.open(u, d), !0) : !1;
      }
    }
  });
}
function uX(t) {
  return new Ge({
    key: new tt("handlePasteLink"),
    props: {
      handlePaste: (e, n, r) => {
        const { state: i } = e, { selection: o } = i, { empty: s } = o;
        if (s)
          return !1;
        let a = "";
        r.content.forEach((c) => {
          a += c.textContent;
        });
        const l = J3(a, { defaultProtocol: t.defaultProtocol }).find((c) => c.isLink && c.value === a);
        return !a || !l ? !1 : t.editor.commands.setMark(t.type, {
          href: l.href
        });
      }
    }
  });
}
const dX = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g;
function Li(t, e) {
  const n = [
    "http",
    "https",
    "ftp",
    "ftps",
    "mailto",
    "tel",
    "callto",
    "sms",
    "cid",
    "xmpp"
  ];
  return e && e.forEach((r) => {
    const i = typeof r == "string" ? r : r.scheme;
    i && n.push(i);
  }), !t || t.replace(dX, "").match(new RegExp(
    // eslint-disable-next-line no-useless-escape
    `^(?:(?:${n.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
    "i"
  ));
}
const fX = gn.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((t) => {
      if (typeof t == "string") {
        lC(t);
        return;
      }
      lC(t.scheme, t.optionalSlashes);
    });
  },
  onDestroy() {
    oX();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (t, e) => !!Li(t, e.protocols),
      validate: (t) => !!t,
      shouldAutoLink: (t) => !!t
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(t) {
          return t.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (t) => {
          const e = t.getAttribute("href");
          return !e || !this.options.isAllowedUri(e, {
            defaultValidate: (n) => !!Li(n, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return this.options.isAllowedUri(t.href, {
      defaultValidate: (e) => !!Li(e, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", Ke(this.options.HTMLAttributes, t), 0] : [
      "a",
      Ke(this.options.HTMLAttributes, { ...t, href: "" }),
      0
    ];
  },
  addCommands() {
    return {
      setLink: (t) => ({ chain: e }) => {
        const { href: n } = t;
        return this.options.isAllowedUri(n, {
          defaultValidate: (r) => !!Li(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().setMark(this.name, t).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (t) => ({ chain: e }) => {
        const { href: n } = t;
        return this.options.isAllowedUri(n, {
          defaultValidate: (r) => !!Li(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().toggleMark(this.name, t, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run() : !1;
      },
      unsetLink: () => ({ chain: t }) => t().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      xi({
        find: (t) => {
          const e = [];
          if (t) {
            const { protocols: n, defaultProtocol: r } = this.options, i = J3(t).filter((o) => o.isLink && this.options.isAllowedUri(o.value, {
              defaultValidate: (s) => !!Li(s, n),
              protocols: n,
              defaultProtocol: r
            }));
            i.length && i.forEach((o) => e.push({
              text: o.value,
              data: {
                href: o.href
              },
              index: o.start
            }));
          }
          return e;
        },
        type: this.type,
        getAttributes: (t) => {
          var e;
          return {
            href: (e = t.data) === null || e === void 0 ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const t = [], { protocols: e, defaultProtocol: n } = this.options;
    return this.options.autolink && t.push(lX({
      type: this.type,
      defaultProtocol: this.options.defaultProtocol,
      validate: (r) => this.options.isAllowedUri(r, {
        defaultValidate: (i) => !!Li(i, e),
        protocols: e,
        defaultProtocol: n
      }),
      shouldAutoLink: this.options.shouldAutoLink
    })), this.options.openOnClick === !0 && t.push(cX({
      type: this.type
    })), this.options.linkOnPaste && t.push(uX({
      editor: this.editor,
      defaultProtocol: this.options.defaultProtocol,
      type: this.type
    })), t;
  }
}), X3 = vt.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["li", Ke(this.options.HTMLAttributes, t), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
});
var g0, v0;
if (typeof WeakMap < "u") {
  let t = /* @__PURE__ */ new WeakMap();
  g0 = (e) => t.get(e), v0 = (e, n) => (t.set(e, n), n);
} else {
  const t = [];
  let n = 0;
  g0 = (r) => {
    for (let i = 0; i < t.length; i += 2)
      if (t[i] == r) return t[i + 1];
  }, v0 = (r, i) => (n == 10 && (n = 0), t[n++] = r, t[n++] = i);
}
var at = class {
  constructor(t, e, n, r) {
    this.width = t, this.height = e, this.map = n, this.problems = r;
  }
  // Find the dimensions of the cell at the given position.
  findCell(t) {
    for (let e = 0; e < this.map.length; e++) {
      const n = this.map[e];
      if (n != t) continue;
      const r = e % this.width, i = e / this.width | 0;
      let o = r + 1, s = i + 1;
      for (let a = 1; o < this.width && this.map[e + a] == n; a++)
        o++;
      for (let a = 1; s < this.height && this.map[e + this.width * a] == n; a++)
        s++;
      return { left: r, top: i, right: o, bottom: s };
    }
    throw new RangeError(`No cell with offset ${t} found`);
  }
  // Find the left side of the cell at the given position.
  colCount(t) {
    for (let e = 0; e < this.map.length; e++)
      if (this.map[e] == t)
        return e % this.width;
    throw new RangeError(`No cell with offset ${t} found`);
  }
  // Find the next cell in the given direction, starting from the cell
  // at `pos`, if any.
  nextCell(t, e, n) {
    const { left: r, right: i, top: o, bottom: s } = this.findCell(t);
    return e == "horiz" ? (n < 0 ? r == 0 : i == this.width) ? null : this.map[o * this.width + (n < 0 ? r - 1 : i)] : (n < 0 ? o == 0 : s == this.height) ? null : this.map[r + this.width * (n < 0 ? o - 1 : s)];
  }
  // Get the rectangle spanning the two given cells.
  rectBetween(t, e) {
    const {
      left: n,
      right: r,
      top: i,
      bottom: o
    } = this.findCell(t), {
      left: s,
      right: a,
      top: l,
      bottom: c
    } = this.findCell(e);
    return {
      left: Math.min(n, s),
      top: Math.min(i, l),
      right: Math.max(r, a),
      bottom: Math.max(o, c)
    };
  }
  // Return the position of all cells that have the top left corner in
  // the given rectangle.
  cellsInRect(t) {
    const e = [], n = {};
    for (let r = t.top; r < t.bottom; r++)
      for (let i = t.left; i < t.right; i++) {
        const o = r * this.width + i, s = this.map[o];
        n[s] || (n[s] = !0, !(i == t.left && i && this.map[o - 1] == s || r == t.top && r && this.map[o - this.width] == s) && e.push(s));
      }
    return e;
  }
  // Return the position at which the cell at the given row and column
  // starts, or would start, if a cell started there.
  positionAt(t, e, n) {
    for (let r = 0, i = 0; ; r++) {
      const o = i + n.child(r).nodeSize;
      if (r == t) {
        let s = e + t * this.width;
        const a = (t + 1) * this.width;
        for (; s < a && this.map[s] < i; ) s++;
        return s == a ? o - 1 : this.map[s];
      }
      i = o;
    }
  }
  // Find the table map for the given table node.
  static get(t) {
    return g0(t) || v0(t, hX(t));
  }
};
function hX(t) {
  if (t.type.spec.tableRole != "table")
    throw new RangeError("Not a table node: " + t.type.name);
  const e = pX(t), n = t.childCount, r = [];
  let i = 0, o = null;
  const s = [];
  for (let c = 0, u = e * n; c < u; c++) r[c] = 0;
  for (let c = 0, u = 0; c < n; c++) {
    const d = t.child(c);
    u++;
    for (let p = 0; ; p++) {
      for (; i < r.length && r[i] != 0; ) i++;
      if (p == d.childCount) break;
      const m = d.child(p), { colspan: b, rowspan: y, colwidth: k } = m.attrs;
      for (let C = 0; C < y; C++) {
        if (C + c >= n) {
          (o || (o = [])).push({
            type: "overlong_rowspan",
            pos: u,
            n: y - C
          });
          break;
        }
        const x = i + C * e;
        for (let S = 0; S < b; S++) {
          r[x + S] == 0 ? r[x + S] = u : (o || (o = [])).push({
            type: "collision",
            row: c,
            pos: u,
            n: b - S
          });
          const T = k && k[S];
          if (T) {
            const E = (x + S) % e * 2, M = s[E];
            M == null || M != T && s[E + 1] == 1 ? (s[E] = T, s[E + 1] = 1) : M == T && s[E + 1]++;
          }
        }
      }
      i += b, u += m.nodeSize;
    }
    const f = (c + 1) * e;
    let h = 0;
    for (; i < f; ) r[i++] == 0 && h++;
    h && (o || (o = [])).push({ type: "missing", row: c, n: h }), u++;
  }
  (e === 0 || n === 0) && (o || (o = [])).push({ type: "zero_sized" });
  const a = new at(e, n, r, o);
  let l = !1;
  for (let c = 0; !l && c < s.length; c += 2)
    s[c] != null && s[c + 1] < n && (l = !0);
  return l && mX(a, s, t), a;
}
function pX(t) {
  let e = -1, n = !1;
  for (let r = 0; r < t.childCount; r++) {
    const i = t.child(r);
    let o = 0;
    if (n)
      for (let s = 0; s < r; s++) {
        const a = t.child(s);
        for (let l = 0; l < a.childCount; l++) {
          const c = a.child(l);
          s + c.attrs.rowspan > r && (o += c.attrs.colspan);
        }
      }
    for (let s = 0; s < i.childCount; s++) {
      const a = i.child(s);
      o += a.attrs.colspan, a.attrs.rowspan > 1 && (n = !0);
    }
    e == -1 ? e = o : e != o && (e = Math.max(e, o));
  }
  return e;
}
function mX(t, e, n) {
  t.problems || (t.problems = []);
  const r = {};
  for (let i = 0; i < t.map.length; i++) {
    const o = t.map[i];
    if (r[o]) continue;
    r[o] = !0;
    const s = n.nodeAt(o);
    if (!s)
      throw new RangeError(`No cell with offset ${o} found`);
    let a = null;
    const l = s.attrs;
    for (let c = 0; c < l.colspan; c++) {
      const u = (i + c) % t.width, d = e[u * 2];
      d != null && (!l.colwidth || l.colwidth[c] != d) && ((a || (a = gX(l)))[c] = d);
    }
    a && t.problems.unshift({
      type: "colwidth mismatch",
      pos: o,
      colwidth: a
    });
  }
}
function gX(t) {
  if (t.colwidth) return t.colwidth.slice();
  const e = [];
  for (let n = 0; n < t.colspan; n++) e.push(0);
  return e;
}
function Lt(t) {
  let e = t.cached.tableNodeTypes;
  if (!e) {
    e = t.cached.tableNodeTypes = {};
    for (const n in t.nodes) {
      const r = t.nodes[n], i = r.spec.tableRole;
      i && (e[i] = r);
    }
  }
  return e;
}
var ri = new tt("selectingCells");
function Es(t) {
  for (let e = t.depth - 1; e > 0; e--)
    if (t.node(e).type.spec.tableRole == "row")
      return t.node(0).resolve(t.before(e + 1));
  return null;
}
function vX(t) {
  for (let e = t.depth; e > 0; e--) {
    const n = t.node(e).type.spec.tableRole;
    if (n === "cell" || n === "header_cell") return t.node(e);
  }
  return null;
}
function Jn(t) {
  const e = t.selection.$head;
  for (let n = e.depth; n > 0; n--)
    if (e.node(n).type.spec.tableRole == "row") return !0;
  return !1;
}
function zd(t) {
  const e = t.selection;
  if ("$anchorCell" in e && e.$anchorCell)
    return e.$anchorCell.pos > e.$headCell.pos ? e.$anchorCell : e.$headCell;
  if ("node" in e && e.node && e.node.type.spec.tableRole == "cell")
    return e.$anchor;
  const n = Es(e.$head) || bX(e.$head);
  if (n)
    return n;
  throw new RangeError(`No cell found around position ${e.head}`);
}
function bX(t) {
  for (let e = t.nodeAfter, n = t.pos; e; e = e.firstChild, n++) {
    const r = e.type.spec.tableRole;
    if (r == "cell" || r == "header_cell") return t.doc.resolve(n);
  }
  for (let e = t.nodeBefore, n = t.pos; e; e = e.lastChild, n--) {
    const r = e.type.spec.tableRole;
    if (r == "cell" || r == "header_cell")
      return t.doc.resolve(n - e.nodeSize);
  }
}
function b0(t) {
  return t.parent.type.spec.tableRole == "row" && !!t.nodeAfter;
}
function yX(t) {
  return t.node(0).resolve(t.pos + t.nodeAfter.nodeSize);
}
function Ib(t, e) {
  return t.depth == e.depth && t.pos >= e.start(-1) && t.pos <= e.end(-1);
}
function Q3(t, e, n) {
  const r = t.node(-1), i = at.get(r), o = t.start(-1), s = i.nextCell(t.pos - o, e, n);
  return s == null ? null : t.node(0).resolve(o + s);
}
function co(t, e, n = 1) {
  const r = { ...t, colspan: t.colspan - n };
  return r.colwidth && (r.colwidth = r.colwidth.slice(), r.colwidth.splice(e, n), r.colwidth.some((i) => i > 0) || (r.colwidth = null)), r;
}
function eR(t, e, n = 1) {
  const r = { ...t, colspan: t.colspan + n };
  if (r.colwidth) {
    r.colwidth = r.colwidth.slice();
    for (let i = 0; i < n; i++) r.colwidth.splice(e, 0, 0);
  }
  return r;
}
function wX(t, e, n) {
  const r = Lt(e.type.schema).header_cell;
  for (let i = 0; i < t.height; i++)
    if (e.nodeAt(t.map[n + i * t.width]).type != r)
      return !1;
  return !0;
}
var Xe = class Er extends be {
  // A table selection is identified by its anchor and head cells. The
  // positions given to this constructor should point _before_ two
  // cells in the same table. They may be the same, to select a single
  // cell.
  constructor(e, n = e) {
    const r = e.node(-1), i = at.get(r), o = e.start(-1), s = i.rectBetween(
      e.pos - o,
      n.pos - o
    ), a = e.node(0), l = i.cellsInRect(s).filter((u) => u != n.pos - o);
    l.unshift(n.pos - o);
    const c = l.map((u) => {
      const d = r.nodeAt(u);
      if (!d)
        throw RangeError(`No cell with offset ${u} found`);
      const f = o + u + 1;
      return new aN(
        a.resolve(f),
        a.resolve(f + d.content.size)
      );
    });
    super(c[0].$from, c[0].$to, c), this.$anchorCell = e, this.$headCell = n;
  }
  map(e, n) {
    const r = e.resolve(n.map(this.$anchorCell.pos)), i = e.resolve(n.map(this.$headCell.pos));
    if (b0(r) && b0(i) && Ib(r, i)) {
      const o = this.$anchorCell.node(-1) != r.node(-1);
      return o && this.isRowSelection() ? Er.rowSelection(r, i) : o && this.isColSelection() ? Er.colSelection(r, i) : new Er(r, i);
    }
    return ge.between(r, i);
  }
  // Returns a rectangular slice of table rows containing the selected
  // cells.
  content() {
    const e = this.$anchorCell.node(-1), n = at.get(e), r = this.$anchorCell.start(-1), i = n.rectBetween(
      this.$anchorCell.pos - r,
      this.$headCell.pos - r
    ), o = {}, s = [];
    for (let l = i.top; l < i.bottom; l++) {
      const c = [];
      for (let u = l * n.width + i.left, d = i.left; d < i.right; d++, u++) {
        const f = n.map[u];
        if (o[f]) continue;
        o[f] = !0;
        const h = n.findCell(f);
        let p = e.nodeAt(f);
        if (!p)
          throw RangeError(`No cell with offset ${f} found`);
        const m = i.left - h.left, b = h.right - i.right;
        if (m > 0 || b > 0) {
          let y = p.attrs;
          if (m > 0 && (y = co(y, 0, m)), b > 0 && (y = co(
            y,
            y.colspan - b,
            b
          )), h.left < i.left) {
            if (p = p.type.createAndFill(y), !p)
              throw RangeError(
                `Could not create cell with attrs ${JSON.stringify(y)}`
              );
          } else
            p = p.type.create(y, p.content);
        }
        if (h.top < i.top || h.bottom > i.bottom) {
          const y = {
            ...p.attrs,
            rowspan: Math.min(h.bottom, i.bottom) - Math.max(h.top, i.top)
          };
          h.top < i.top ? p = p.type.createAndFill(y) : p = p.type.create(y, p.content);
        }
        c.push(p);
      }
      s.push(e.child(l).copy(U.from(c)));
    }
    const a = this.isColSelection() && this.isRowSelection() ? e : s;
    return new ee(U.from(a), 1, 1);
  }
  replace(e, n = ee.empty) {
    const r = e.steps.length, i = this.ranges;
    for (let s = 0; s < i.length; s++) {
      const { $from: a, $to: l } = i[s], c = e.mapping.slice(r);
      e.replace(
        c.map(a.pos),
        c.map(l.pos),
        s ? ee.empty : n
      );
    }
    const o = be.findFrom(
      e.doc.resolve(e.mapping.slice(r).map(this.to)),
      -1
    );
    o && e.setSelection(o);
  }
  replaceWith(e, n) {
    this.replace(e, new ee(U.from(n), 0, 0));
  }
  forEachCell(e) {
    const n = this.$anchorCell.node(-1), r = at.get(n), i = this.$anchorCell.start(-1), o = r.cellsInRect(
      r.rectBetween(
        this.$anchorCell.pos - i,
        this.$headCell.pos - i
      )
    );
    for (let s = 0; s < o.length; s++)
      e(n.nodeAt(o[s]), i + o[s]);
  }
  // True if this selection goes all the way from the top to the
  // bottom of the table.
  isColSelection() {
    const e = this.$anchorCell.index(-1), n = this.$headCell.index(-1);
    if (Math.min(e, n) > 0) return !1;
    const r = e + this.$anchorCell.nodeAfter.attrs.rowspan, i = n + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(r, i) == this.$headCell.node(-1).childCount;
  }
  // Returns the smallest column selection that covers the given anchor
  // and head cell.
  static colSelection(e, n = e) {
    const r = e.node(-1), i = at.get(r), o = e.start(-1), s = i.findCell(e.pos - o), a = i.findCell(n.pos - o), l = e.node(0);
    return s.top <= a.top ? (s.top > 0 && (e = l.resolve(o + i.map[s.left])), a.bottom < i.height && (n = l.resolve(
      o + i.map[i.width * (i.height - 1) + a.right - 1]
    ))) : (a.top > 0 && (n = l.resolve(o + i.map[a.left])), s.bottom < i.height && (e = l.resolve(
      o + i.map[i.width * (i.height - 1) + s.right - 1]
    ))), new Er(e, n);
  }
  // True if this selection goes all the way from the left to the
  // right of the table.
  isRowSelection() {
    const e = this.$anchorCell.node(-1), n = at.get(e), r = this.$anchorCell.start(-1), i = n.colCount(this.$anchorCell.pos - r), o = n.colCount(this.$headCell.pos - r);
    if (Math.min(i, o) > 0) return !1;
    const s = i + this.$anchorCell.nodeAfter.attrs.colspan, a = o + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(s, a) == n.width;
  }
  eq(e) {
    return e instanceof Er && e.$anchorCell.pos == this.$anchorCell.pos && e.$headCell.pos == this.$headCell.pos;
  }
  // Returns the smallest row selection that covers the given anchor
  // and head cell.
  static rowSelection(e, n = e) {
    const r = e.node(-1), i = at.get(r), o = e.start(-1), s = i.findCell(e.pos - o), a = i.findCell(n.pos - o), l = e.node(0);
    return s.left <= a.left ? (s.left > 0 && (e = l.resolve(
      o + i.map[s.top * i.width]
    )), a.right < i.width && (n = l.resolve(
      o + i.map[i.width * (a.top + 1) - 1]
    ))) : (a.left > 0 && (n = l.resolve(o + i.map[a.top * i.width])), s.right < i.width && (e = l.resolve(
      o + i.map[i.width * (s.top + 1) - 1]
    ))), new Er(e, n);
  }
  toJSON() {
    return {
      type: "cell",
      anchor: this.$anchorCell.pos,
      head: this.$headCell.pos
    };
  }
  static fromJSON(e, n) {
    return new Er(e.resolve(n.anchor), e.resolve(n.head));
  }
  static create(e, n, r = n) {
    return new Er(e.resolve(n), e.resolve(r));
  }
  getBookmark() {
    return new xX(this.$anchorCell.pos, this.$headCell.pos);
  }
};
Xe.prototype.visible = !1;
be.jsonID("cell", Xe);
var xX = class tR {
  constructor(e, n) {
    this.anchor = e, this.head = n;
  }
  map(e) {
    return new tR(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    const n = e.resolve(this.anchor), r = e.resolve(this.head);
    return n.parent.type.spec.tableRole == "row" && r.parent.type.spec.tableRole == "row" && n.index() < n.parent.childCount && r.index() < r.parent.childCount && Ib(n, r) ? new Xe(n, r) : be.near(r, 1);
  }
};
function kX(t) {
  if (!(t.selection instanceof Xe)) return null;
  const e = [];
  return t.selection.forEachCell((n, r) => {
    e.push(
      jt.node(r, r + n.nodeSize, { class: "selectedCell" })
    );
  }), ot.create(t.doc, e);
}
function CX({ $from: t, $to: e }) {
  if (t.pos == e.pos || t.pos < e.pos - 6) return !1;
  let n = t.pos, r = e.pos, i = t.depth;
  for (; i >= 0 && !(t.after(i + 1) < t.end(i)); i--, n++)
    ;
  for (let o = e.depth; o >= 0 && !(e.before(o + 1) > e.start(o)); o--, r--)
    ;
  return n == r && /row|table/.test(t.node(i).type.spec.tableRole);
}
function SX({ $from: t, $to: e }) {
  let n, r;
  for (let i = t.depth; i > 0; i--) {
    const o = t.node(i);
    if (o.type.spec.tableRole === "cell" || o.type.spec.tableRole === "header_cell") {
      n = o;
      break;
    }
  }
  for (let i = e.depth; i > 0; i--) {
    const o = e.node(i);
    if (o.type.spec.tableRole === "cell" || o.type.spec.tableRole === "header_cell") {
      r = o;
      break;
    }
  }
  return n !== r && e.parentOffset === 0;
}
function TX(t, e, n) {
  const r = (e || t).selection, i = (e || t).doc;
  let o, s;
  if (r instanceof ye && (s = r.node.type.spec.tableRole)) {
    if (s == "cell" || s == "header_cell")
      o = Xe.create(i, r.from);
    else if (s == "row") {
      const a = i.resolve(r.from + 1);
      o = Xe.rowSelection(a, a);
    } else if (!n) {
      const a = at.get(r.node), l = r.from + 1, c = l + a.map[a.width * a.height - 1];
      o = Xe.create(i, l + 1, c);
    }
  } else r instanceof ge && CX(r) ? o = ge.create(i, r.from) : r instanceof ge && SX(r) && (o = ge.create(i, r.$from.start(), r.$from.end()));
  return o && (e || (e = t.tr)).setSelection(o), e;
}
var EX = new tt("fix-tables");
function nR(t, e, n, r) {
  const i = t.childCount, o = e.childCount;
  e: for (let s = 0, a = 0; s < o; s++) {
    const l = e.child(s);
    for (let c = a, u = Math.min(i, s + 3); c < u; c++)
      if (t.child(c) == l) {
        a = c + 1, n += l.nodeSize;
        continue e;
      }
    r(l, n), a < i && t.child(a).sameMarkup(l) ? nR(t.child(a), l, n + 1, r) : l.nodesBetween(0, l.content.size, r, n + 1), n += l.nodeSize;
  }
}
function rR(t, e) {
  let n;
  const r = (i, o) => {
    i.type.spec.tableRole == "table" && (n = MX(t, i, o, n));
  };
  return e ? e.doc != t.doc && nR(e.doc, t.doc, 0, r) : t.doc.descendants(r), n;
}
function MX(t, e, n, r) {
  const i = at.get(e);
  if (!i.problems) return r;
  r || (r = t.tr);
  const o = [];
  for (let l = 0; l < i.height; l++) o.push(0);
  for (let l = 0; l < i.problems.length; l++) {
    const c = i.problems[l];
    if (c.type == "collision") {
      const u = e.nodeAt(c.pos);
      if (!u) continue;
      const d = u.attrs;
      for (let f = 0; f < d.rowspan; f++) o[c.row + f] += c.n;
      r.setNodeMarkup(
        r.mapping.map(n + 1 + c.pos),
        null,
        co(d, d.colspan - c.n, c.n)
      );
    } else if (c.type == "missing")
      o[c.row] += c.n;
    else if (c.type == "overlong_rowspan") {
      const u = e.nodeAt(c.pos);
      if (!u) continue;
      r.setNodeMarkup(r.mapping.map(n + 1 + c.pos), null, {
        ...u.attrs,
        rowspan: u.attrs.rowspan - c.n
      });
    } else if (c.type == "colwidth mismatch") {
      const u = e.nodeAt(c.pos);
      if (!u) continue;
      r.setNodeMarkup(r.mapping.map(n + 1 + c.pos), null, {
        ...u.attrs,
        colwidth: c.colwidth
      });
    } else if (c.type == "zero_sized") {
      const u = r.mapping.map(n);
      r.delete(u, u + e.nodeSize);
    }
  }
  let s, a;
  for (let l = 0; l < o.length; l++)
    o[l] && (s == null && (s = l), a = l);
  for (let l = 0, c = n + 1; l < i.height; l++) {
    const u = e.child(l), d = c + u.nodeSize, f = o[l];
    if (f > 0) {
      let h = "cell";
      u.firstChild && (h = u.firstChild.type.spec.tableRole);
      const p = [];
      for (let b = 0; b < f; b++) {
        const y = Lt(t.schema)[h].createAndFill();
        y && p.push(y);
      }
      const m = (l == 0 || s == l - 1) && a == l ? c + 1 : d - 1;
      r.insert(r.mapping.map(m), p);
    }
    c = d;
  }
  return r.setMeta(EX, { fixTables: !0 });
}
function gr(t) {
  const e = t.selection, n = zd(t), r = n.node(-1), i = n.start(-1), o = at.get(r);
  return { ...e instanceof Xe ? o.rectBetween(
    e.$anchorCell.pos - i,
    e.$headCell.pos - i
  ) : o.findCell(n.pos - i), tableStart: i, map: o, table: r };
}
function iR(t, { map: e, tableStart: n, table: r }, i) {
  let o = i > 0 ? -1 : 0;
  wX(e, r, i + o) && (o = i == 0 || i == e.width ? null : 0);
  for (let s = 0; s < e.height; s++) {
    const a = s * e.width + i;
    if (i > 0 && i < e.width && e.map[a - 1] == e.map[a]) {
      const l = e.map[a], c = r.nodeAt(l);
      t.setNodeMarkup(
        t.mapping.map(n + l),
        null,
        eR(c.attrs, i - e.colCount(l))
      ), s += c.attrs.rowspan - 1;
    } else {
      const l = o == null ? Lt(r.type.schema).cell : r.nodeAt(e.map[a + o]).type, c = e.positionAt(s, i, r);
      t.insert(t.mapping.map(n + c), l.createAndFill());
    }
  }
  return t;
}
function OX(t, e) {
  if (!Jn(t)) return !1;
  if (e) {
    const n = gr(t);
    e(iR(t.tr, n, n.left));
  }
  return !0;
}
function AX(t, e) {
  if (!Jn(t)) return !1;
  if (e) {
    const n = gr(t);
    e(iR(t.tr, n, n.right));
  }
  return !0;
}
function NX(t, { map: e, table: n, tableStart: r }, i) {
  const o = t.mapping.maps.length;
  for (let s = 0; s < e.height; ) {
    const a = s * e.width + i, l = e.map[a], c = n.nodeAt(l), u = c.attrs;
    if (i > 0 && e.map[a - 1] == l || i < e.width - 1 && e.map[a + 1] == l)
      t.setNodeMarkup(
        t.mapping.slice(o).map(r + l),
        null,
        co(u, i - e.colCount(l))
      );
    else {
      const d = t.mapping.slice(o).map(r + l);
      t.delete(d, d + c.nodeSize);
    }
    s += u.rowspan;
  }
}
function RX(t, e) {
  if (!Jn(t)) return !1;
  if (e) {
    const n = gr(t), r = t.tr;
    if (n.left == 0 && n.right == n.map.width) return !1;
    for (let i = n.right - 1; NX(r, n, i), i != n.left; i--) {
      const o = n.tableStart ? r.doc.nodeAt(n.tableStart - 1) : r.doc;
      if (!o)
        throw RangeError("No table found");
      n.table = o, n.map = at.get(o);
    }
    e(r);
  }
  return !0;
}
function DX(t, e, n) {
  var r;
  const i = Lt(e.type.schema).header_cell;
  for (let o = 0; o < t.width; o++)
    if (((r = e.nodeAt(t.map[o + n * t.width])) == null ? void 0 : r.type) != i)
      return !1;
  return !0;
}
function oR(t, { map: e, tableStart: n, table: r }, i) {
  var o;
  let s = n;
  for (let c = 0; c < i; c++) s += r.child(c).nodeSize;
  const a = [];
  let l = i > 0 ? -1 : 0;
  DX(e, r, i + l) && (l = i == 0 || i == e.height ? null : 0);
  for (let c = 0, u = e.width * i; c < e.width; c++, u++)
    if (i > 0 && i < e.height && e.map[u] == e.map[u - e.width]) {
      const d = e.map[u], f = r.nodeAt(d).attrs;
      t.setNodeMarkup(n + d, null, {
        ...f,
        rowspan: f.rowspan + 1
      }), c += f.colspan - 1;
    } else {
      const d = l == null ? Lt(r.type.schema).cell : (o = r.nodeAt(e.map[u + l * e.width])) == null ? void 0 : o.type, f = d == null ? void 0 : d.createAndFill();
      f && a.push(f);
    }
  return t.insert(s, Lt(r.type.schema).row.create(null, a)), t;
}
function IX(t, e) {
  if (!Jn(t)) return !1;
  if (e) {
    const n = gr(t);
    e(oR(t.tr, n, n.top));
  }
  return !0;
}
function _X(t, e) {
  if (!Jn(t)) return !1;
  if (e) {
    const n = gr(t);
    e(oR(t.tr, n, n.bottom));
  }
  return !0;
}
function PX(t, { map: e, table: n, tableStart: r }, i) {
  let o = 0;
  for (let c = 0; c < i; c++) o += n.child(c).nodeSize;
  const s = o + n.child(i).nodeSize, a = t.mapping.maps.length;
  t.delete(o + r, s + r);
  const l = /* @__PURE__ */ new Set();
  for (let c = 0, u = i * e.width; c < e.width; c++, u++) {
    const d = e.map[u];
    if (!l.has(d)) {
      if (l.add(d), i > 0 && d == e.map[u - e.width]) {
        const f = n.nodeAt(d).attrs;
        t.setNodeMarkup(t.mapping.slice(a).map(d + r), null, {
          ...f,
          rowspan: f.rowspan - 1
        }), c += f.colspan - 1;
      } else if (i < e.height && d == e.map[u + e.width]) {
        const f = n.nodeAt(d), h = f.attrs, p = f.type.create(
          { ...h, rowspan: f.attrs.rowspan - 1 },
          f.content
        ), m = e.positionAt(i + 1, c, n);
        t.insert(t.mapping.slice(a).map(r + m), p), c += h.colspan - 1;
      }
    }
  }
}
function LX(t, e) {
  if (!Jn(t)) return !1;
  if (e) {
    const n = gr(t), r = t.tr;
    if (n.top == 0 && n.bottom == n.map.height) return !1;
    for (let i = n.bottom - 1; PX(r, n, i), i != n.top; i--) {
      const o = n.tableStart ? r.doc.nodeAt(n.tableStart - 1) : r.doc;
      if (!o)
        throw RangeError("No table found");
      n.table = o, n.map = at.get(n.table);
    }
    e(r);
  }
  return !0;
}
function cC(t) {
  const e = t.content;
  return e.childCount == 1 && e.child(0).isTextblock && e.child(0).childCount == 0;
}
function FX({ width: t, height: e, map: n }, r) {
  let i = r.top * t + r.left, o = i, s = (r.bottom - 1) * t + r.left, a = i + (r.right - r.left - 1);
  for (let l = r.top; l < r.bottom; l++) {
    if (r.left > 0 && n[o] == n[o - 1] || r.right < t && n[a] == n[a + 1])
      return !0;
    o += t, a += t;
  }
  for (let l = r.left; l < r.right; l++) {
    if (r.top > 0 && n[i] == n[i - t] || r.bottom < e && n[s] == n[s + t])
      return !0;
    i++, s++;
  }
  return !1;
}
function uC(t, e) {
  const n = t.selection;
  if (!(n instanceof Xe) || n.$anchorCell.pos == n.$headCell.pos)
    return !1;
  const r = gr(t), { map: i } = r;
  if (FX(i, r)) return !1;
  if (e) {
    const o = t.tr, s = {};
    let a = U.empty, l, c;
    for (let u = r.top; u < r.bottom; u++)
      for (let d = r.left; d < r.right; d++) {
        const f = i.map[u * i.width + d], h = r.table.nodeAt(f);
        if (!(s[f] || !h))
          if (s[f] = !0, l == null)
            l = f, c = h;
          else {
            cC(h) || (a = a.append(h.content));
            const p = o.mapping.map(f + r.tableStart);
            o.delete(p, p + h.nodeSize);
          }
      }
    if (l == null || c == null)
      return !0;
    if (o.setNodeMarkup(l + r.tableStart, null, {
      ...eR(
        c.attrs,
        c.attrs.colspan,
        r.right - r.left - c.attrs.colspan
      ),
      rowspan: r.bottom - r.top
    }), a.size) {
      const u = l + 1 + c.content.size, d = cC(c) ? l + 1 : u;
      o.replaceWith(d + r.tableStart, u + r.tableStart, a);
    }
    o.setSelection(
      new Xe(o.doc.resolve(l + r.tableStart))
    ), e(o);
  }
  return !0;
}
function dC(t, e) {
  const n = Lt(t.schema);
  return $X(({ node: r }) => n[r.type.spec.tableRole])(t, e);
}
function $X(t) {
  return (e, n) => {
    var r;
    const i = e.selection;
    let o, s;
    if (i instanceof Xe) {
      if (i.$anchorCell.pos != i.$headCell.pos) return !1;
      o = i.$anchorCell.nodeAfter, s = i.$anchorCell.pos;
    } else {
      if (o = vX(i.$from), !o) return !1;
      s = (r = Es(i.$from)) == null ? void 0 : r.pos;
    }
    if (o == null || s == null || o.attrs.colspan == 1 && o.attrs.rowspan == 1)
      return !1;
    if (n) {
      let a = o.attrs;
      const l = [], c = a.colwidth;
      a.rowspan > 1 && (a = { ...a, rowspan: 1 }), a.colspan > 1 && (a = { ...a, colspan: 1 });
      const u = gr(e), d = e.tr;
      for (let h = 0; h < u.right - u.left; h++)
        l.push(
          c ? {
            ...a,
            colwidth: c && c[h] ? [c[h]] : null
          } : a
        );
      let f;
      for (let h = u.top; h < u.bottom; h++) {
        let p = u.map.positionAt(h, u.left, u.table);
        h == u.top && (p += o.nodeSize);
        for (let m = u.left, b = 0; m < u.right; m++, b++)
          m == u.left && h == u.top || d.insert(
            f = d.mapping.map(p + u.tableStart, 1),
            t({ node: o, row: h, col: m }).createAndFill(l[b])
          );
      }
      d.setNodeMarkup(
        s,
        t({ node: o, row: u.top, col: u.left }),
        l[0]
      ), i instanceof Xe && d.setSelection(
        new Xe(
          d.doc.resolve(i.$anchorCell.pos),
          f ? d.doc.resolve(f) : void 0
        )
      ), n(d);
    }
    return !0;
  };
}
function BX(t, e) {
  return function(n, r) {
    if (!Jn(n)) return !1;
    const i = zd(n);
    if (i.nodeAfter.attrs[t] === e) return !1;
    if (r) {
      const o = n.tr;
      n.selection instanceof Xe ? n.selection.forEachCell((s, a) => {
        s.attrs[t] !== e && o.setNodeMarkup(a, null, {
          ...s.attrs,
          [t]: e
        });
      }) : o.setNodeMarkup(i.pos, null, {
        ...i.nodeAfter.attrs,
        [t]: e
      }), r(o);
    }
    return !0;
  };
}
function VX(t) {
  return function(e, n) {
    if (!Jn(e)) return !1;
    if (n) {
      const r = Lt(e.schema), i = gr(e), o = e.tr, s = i.map.cellsInRect(
        t == "column" ? {
          left: i.left,
          top: 0,
          right: i.right,
          bottom: i.map.height
        } : t == "row" ? {
          left: 0,
          top: i.top,
          right: i.map.width,
          bottom: i.bottom
        } : i
      ), a = s.map((l) => i.table.nodeAt(l));
      for (let l = 0; l < s.length; l++)
        a[l].type == r.header_cell && o.setNodeMarkup(
          i.tableStart + s[l],
          r.cell,
          a[l].attrs
        );
      if (o.steps.length == 0)
        for (let l = 0; l < s.length; l++)
          o.setNodeMarkup(
            i.tableStart + s[l],
            r.header_cell,
            a[l].attrs
          );
      n(o);
    }
    return !0;
  };
}
function fC(t, e, n) {
  const r = e.map.cellsInRect({
    left: 0,
    top: 0,
    right: t == "row" ? e.map.width : 1,
    bottom: t == "column" ? e.map.height : 1
  });
  for (let i = 0; i < r.length; i++) {
    const o = e.table.nodeAt(r[i]);
    if (o && o.type !== n.header_cell)
      return !1;
  }
  return !0;
}
function Ia(t, e) {
  return e = e || { useDeprecatedLogic: !1 }, e.useDeprecatedLogic ? VX(t) : function(n, r) {
    if (!Jn(n)) return !1;
    if (r) {
      const i = Lt(n.schema), o = gr(n), s = n.tr, a = fC("row", o, i), l = fC(
        "column",
        o,
        i
      ), u = (t === "column" ? a : t === "row" ? l : !1) ? 1 : 0, d = t == "column" ? {
        left: 0,
        top: u,
        right: 1,
        bottom: o.map.height
      } : t == "row" ? {
        left: u,
        top: 0,
        right: o.map.width,
        bottom: 1
      } : o, f = t == "column" ? l ? i.cell : i.header_cell : t == "row" ? a ? i.cell : i.header_cell : i.cell;
      o.map.cellsInRect(d).forEach((h) => {
        const p = h + o.tableStart, m = s.doc.nodeAt(p);
        m && s.setNodeMarkup(p, f, m.attrs);
      }), r(s);
    }
    return !0;
  };
}
Ia("row", {
  useDeprecatedLogic: !0
});
Ia("column", {
  useDeprecatedLogic: !0
});
var zX = Ia("cell", {
  useDeprecatedLogic: !0
});
function HX(t, e) {
  if (e < 0) {
    const n = t.nodeBefore;
    if (n) return t.pos - n.nodeSize;
    for (let r = t.index(-1) - 1, i = t.before(); r >= 0; r--) {
      const o = t.node(-1).child(r), s = o.lastChild;
      if (s)
        return i - 1 - s.nodeSize;
      i -= o.nodeSize;
    }
  } else {
    if (t.index() < t.parent.childCount - 1)
      return t.pos + t.nodeAfter.nodeSize;
    const n = t.node(-1);
    for (let r = t.indexAfter(-1), i = t.after(); r < n.childCount; r++) {
      const o = n.child(r);
      if (o.childCount) return i + 1;
      i += o.nodeSize;
    }
  }
  return null;
}
function hC(t) {
  return function(e, n) {
    if (!Jn(e)) return !1;
    const r = HX(zd(e), t);
    if (r == null) return !1;
    if (n) {
      const i = e.doc.resolve(r);
      n(
        e.tr.setSelection(ge.between(i, yX(i))).scrollIntoView()
      );
    }
    return !0;
  };
}
function WX(t, e) {
  const n = t.selection.$anchor;
  for (let r = n.depth; r > 0; r--)
    if (n.node(r).type.spec.tableRole == "table")
      return e && e(
        t.tr.delete(n.before(r), n.after(r)).scrollIntoView()
      ), !0;
  return !1;
}
function Gl(t, e) {
  const n = t.selection;
  if (!(n instanceof Xe)) return !1;
  if (e) {
    const r = t.tr, i = Lt(t.schema).cell.createAndFill().content;
    n.forEachCell((o, s) => {
      o.content.eq(i) || r.replace(
        r.mapping.map(s + 1),
        r.mapping.map(s + o.nodeSize - 1),
        new ee(i, 0, 0)
      );
    }), r.docChanged && e(r);
  }
  return !0;
}
function jX(t) {
  if (!t.size) return null;
  let { content: e, openStart: n, openEnd: r } = t;
  for (; e.childCount == 1 && (n > 0 && r > 0 || e.child(0).type.spec.tableRole == "table"); )
    n--, r--, e = e.child(0).content;
  const i = e.child(0), o = i.type.spec.tableRole, s = i.type.schema, a = [];
  if (o == "row")
    for (let l = 0; l < e.childCount; l++) {
      let c = e.child(l).content;
      const u = l ? 0 : Math.max(0, n - 1), d = l < e.childCount - 1 ? 0 : Math.max(0, r - 1);
      (u || d) && (c = y0(
        Lt(s).row,
        new ee(c, u, d)
      ).content), a.push(c);
    }
  else if (o == "cell" || o == "header_cell")
    a.push(
      n || r ? y0(
        Lt(s).row,
        new ee(e, n, r)
      ).content : e
    );
  else
    return null;
  return UX(s, a);
}
function UX(t, e) {
  const n = [];
  for (let i = 0; i < e.length; i++) {
    const o = e[i];
    for (let s = o.childCount - 1; s >= 0; s--) {
      const { rowspan: a, colspan: l } = o.child(s).attrs;
      for (let c = i; c < i + a; c++)
        n[c] = (n[c] || 0) + l;
    }
  }
  let r = 0;
  for (let i = 0; i < n.length; i++) r = Math.max(r, n[i]);
  for (let i = 0; i < n.length; i++)
    if (i >= e.length && e.push(U.empty), n[i] < r) {
      const o = Lt(t).cell.createAndFill(), s = [];
      for (let a = n[i]; a < r; a++)
        s.push(o);
      e[i] = e[i].append(U.from(s));
    }
  return { height: e.length, width: r, rows: e };
}
function y0(t, e) {
  const n = t.createAndFill();
  return new Bv(n).replace(0, n.content.size, e).doc;
}
function qX({ width: t, height: e, rows: n }, r, i) {
  if (t != r) {
    const o = [], s = [];
    for (let a = 0; a < n.length; a++) {
      const l = n[a], c = [];
      for (let u = o[a] || 0, d = 0; u < r; d++) {
        let f = l.child(d % l.childCount);
        u + f.attrs.colspan > r && (f = f.type.createChecked(
          co(
            f.attrs,
            f.attrs.colspan,
            u + f.attrs.colspan - r
          ),
          f.content
        )), c.push(f), u += f.attrs.colspan;
        for (let h = 1; h < f.attrs.rowspan; h++)
          o[a + h] = (o[a + h] || 0) + f.attrs.colspan;
      }
      s.push(U.from(c));
    }
    n = s, t = r;
  }
  if (e != i) {
    const o = [];
    for (let s = 0, a = 0; s < i; s++, a++) {
      const l = [], c = n[a % e];
      for (let u = 0; u < c.childCount; u++) {
        let d = c.child(u);
        s + d.attrs.rowspan > i && (d = d.type.create(
          {
            ...d.attrs,
            rowspan: Math.max(1, i - d.attrs.rowspan)
          },
          d.content
        )), l.push(d);
      }
      o.push(U.from(l));
    }
    n = o, e = i;
  }
  return { width: t, height: e, rows: n };
}
function KX(t, e, n, r, i, o, s) {
  const a = t.doc.type.schema, l = Lt(a);
  let c, u;
  if (i > e.width)
    for (let d = 0, f = 0; d < e.height; d++) {
      const h = n.child(d);
      f += h.nodeSize;
      const p = [];
      let m;
      h.lastChild == null || h.lastChild.type == l.cell ? m = c || (c = l.cell.createAndFill()) : m = u || (u = l.header_cell.createAndFill());
      for (let b = e.width; b < i; b++) p.push(m);
      t.insert(t.mapping.slice(s).map(f - 1 + r), p);
    }
  if (o > e.height) {
    const d = [];
    for (let p = 0, m = (e.height - 1) * e.width; p < Math.max(e.width, i); p++) {
      const b = p >= e.width ? !1 : n.nodeAt(e.map[m + p]).type == l.header_cell;
      d.push(
        b ? u || (u = l.header_cell.createAndFill()) : c || (c = l.cell.createAndFill())
      );
    }
    const f = l.row.create(null, U.from(d)), h = [];
    for (let p = e.height; p < o; p++) h.push(f);
    t.insert(t.mapping.slice(s).map(r + n.nodeSize - 2), h);
  }
  return !!(c || u);
}
function pC(t, e, n, r, i, o, s, a) {
  if (s == 0 || s == e.height) return !1;
  let l = !1;
  for (let c = i; c < o; c++) {
    const u = s * e.width + c, d = e.map[u];
    if (e.map[u - e.width] == d) {
      l = !0;
      const f = n.nodeAt(d), { top: h, left: p } = e.findCell(d);
      t.setNodeMarkup(t.mapping.slice(a).map(d + r), null, {
        ...f.attrs,
        rowspan: s - h
      }), t.insert(
        t.mapping.slice(a).map(e.positionAt(s, p, n)),
        f.type.createAndFill({
          ...f.attrs,
          rowspan: h + f.attrs.rowspan - s
        })
      ), c += f.attrs.colspan - 1;
    }
  }
  return l;
}
function mC(t, e, n, r, i, o, s, a) {
  if (s == 0 || s == e.width) return !1;
  let l = !1;
  for (let c = i; c < o; c++) {
    const u = c * e.width + s, d = e.map[u];
    if (e.map[u - 1] == d) {
      l = !0;
      const f = n.nodeAt(d), h = e.colCount(d), p = t.mapping.slice(a).map(d + r);
      t.setNodeMarkup(
        p,
        null,
        co(
          f.attrs,
          s - h,
          f.attrs.colspan - (s - h)
        )
      ), t.insert(
        p + f.nodeSize,
        f.type.createAndFill(
          co(f.attrs, 0, s - h)
        )
      ), c += f.attrs.rowspan - 1;
    }
  }
  return l;
}
function gC(t, e, n, r, i) {
  let o = n ? t.doc.nodeAt(n - 1) : t.doc;
  if (!o)
    throw new Error("No table found");
  let s = at.get(o);
  const { top: a, left: l } = r, c = l + i.width, u = a + i.height, d = t.tr;
  let f = 0;
  function h() {
    if (o = n ? d.doc.nodeAt(n - 1) : d.doc, !o)
      throw new Error("No table found");
    s = at.get(o), f = d.mapping.maps.length;
  }
  KX(d, s, o, n, c, u, f) && h(), pC(d, s, o, n, l, c, a, f) && h(), pC(d, s, o, n, l, c, u, f) && h(), mC(d, s, o, n, a, u, l, f) && h(), mC(d, s, o, n, a, u, c, f) && h();
  for (let p = a; p < u; p++) {
    const m = s.positionAt(p, l, o), b = s.positionAt(p, c, o);
    d.replace(
      d.mapping.slice(f).map(m + n),
      d.mapping.slice(f).map(b + n),
      new ee(i.rows[p - a], 0, 0)
    );
  }
  h(), d.setSelection(
    new Xe(
      d.doc.resolve(n + s.positionAt(a, l, o)),
      d.doc.resolve(n + s.positionAt(u - 1, c - 1, o))
    )
  ), e(d);
}
var GX = Zv({
  ArrowLeft: Yl("horiz", -1),
  ArrowRight: Yl("horiz", 1),
  ArrowUp: Yl("vert", -1),
  ArrowDown: Yl("vert", 1),
  "Shift-ArrowLeft": Zl("horiz", -1),
  "Shift-ArrowRight": Zl("horiz", 1),
  "Shift-ArrowUp": Zl("vert", -1),
  "Shift-ArrowDown": Zl("vert", 1),
  Backspace: Gl,
  "Mod-Backspace": Gl,
  Delete: Gl,
  "Mod-Delete": Gl
});
function yc(t, e, n) {
  return n.eq(t.selection) ? !1 : (e && e(t.tr.setSelection(n).scrollIntoView()), !0);
}
function Yl(t, e) {
  return (n, r, i) => {
    if (!i) return !1;
    const o = n.selection;
    if (o instanceof Xe)
      return yc(
        n,
        r,
        be.near(o.$headCell, e)
      );
    if (t != "horiz" && !o.empty) return !1;
    const s = sR(i, t, e);
    if (s == null) return !1;
    if (t == "horiz")
      return yc(
        n,
        r,
        be.near(n.doc.resolve(o.head + e), e)
      );
    {
      const a = n.doc.resolve(s), l = Q3(a, t, e);
      let c;
      return l ? c = be.near(l, 1) : e < 0 ? c = be.near(n.doc.resolve(a.before(-1)), -1) : c = be.near(n.doc.resolve(a.after(-1)), 1), yc(n, r, c);
    }
  };
}
function Zl(t, e) {
  return (n, r, i) => {
    if (!i) return !1;
    const o = n.selection;
    let s;
    if (o instanceof Xe)
      s = o;
    else {
      const l = sR(i, t, e);
      if (l == null) return !1;
      s = new Xe(n.doc.resolve(l));
    }
    const a = Q3(s.$headCell, t, e);
    return a ? yc(
      n,
      r,
      new Xe(s.$anchorCell, a)
    ) : !1;
  };
}
function YX(t, e) {
  const n = t.state.doc, r = Es(n.resolve(e));
  return r ? (t.dispatch(t.state.tr.setSelection(new Xe(r))), !0) : !1;
}
function ZX(t, e, n) {
  if (!Jn(t.state)) return !1;
  let r = jX(n);
  const i = t.state.selection;
  if (i instanceof Xe) {
    r || (r = {
      width: 1,
      height: 1,
      rows: [
        U.from(
          y0(Lt(t.state.schema).cell, n)
        )
      ]
    });
    const o = i.$anchorCell.node(-1), s = i.$anchorCell.start(-1), a = at.get(o).rectBetween(
      i.$anchorCell.pos - s,
      i.$headCell.pos - s
    );
    return r = qX(r, a.right - a.left, a.bottom - a.top), gC(t.state, t.dispatch, s, a, r), !0;
  } else if (r) {
    const o = zd(t.state), s = o.start(-1);
    return gC(
      t.state,
      t.dispatch,
      s,
      at.get(o.node(-1)).findCell(o.pos - s),
      r
    ), !0;
  } else
    return !1;
}
function JX(t, e) {
  var n;
  if (e.ctrlKey || e.metaKey) return;
  const r = vC(t, e.target);
  let i;
  if (e.shiftKey && t.state.selection instanceof Xe)
    o(t.state.selection.$anchorCell, e), e.preventDefault();
  else if (e.shiftKey && r && (i = Es(t.state.selection.$anchor)) != null && ((n = Tp(t, e)) == null ? void 0 : n.pos) != i.pos)
    o(i, e), e.preventDefault();
  else if (!r)
    return;
  function o(l, c) {
    let u = Tp(t, c);
    const d = ri.getState(t.state) == null;
    if (!u || !Ib(l, u))
      if (d) u = l;
      else return;
    const f = new Xe(l, u);
    if (d || !t.state.selection.eq(f)) {
      const h = t.state.tr.setSelection(f);
      d && h.setMeta(ri, l.pos), t.dispatch(h);
    }
  }
  function s() {
    t.root.removeEventListener("mouseup", s), t.root.removeEventListener("dragstart", s), t.root.removeEventListener("mousemove", a), ri.getState(t.state) != null && t.dispatch(t.state.tr.setMeta(ri, -1));
  }
  function a(l) {
    const c = l, u = ri.getState(t.state);
    let d;
    if (u != null)
      d = t.state.doc.resolve(u);
    else if (vC(t, c.target) != r && (d = Tp(t, e), !d))
      return s();
    d && o(d, c);
  }
  t.root.addEventListener("mouseup", s), t.root.addEventListener("dragstart", s), t.root.addEventListener("mousemove", a);
}
function sR(t, e, n) {
  if (!(t.state.selection instanceof ge)) return null;
  const { $head: r } = t.state.selection;
  for (let i = r.depth - 1; i >= 0; i--) {
    const o = r.node(i);
    if ((n < 0 ? r.index(i) : r.indexAfter(i)) != (n < 0 ? 0 : o.childCount)) return null;
    if (o.type.spec.tableRole == "cell" || o.type.spec.tableRole == "header_cell") {
      const a = r.before(i), l = e == "vert" ? n > 0 ? "down" : "up" : n > 0 ? "right" : "left";
      return t.endOfTextblock(l) ? a : null;
    }
  }
  return null;
}
function vC(t, e) {
  for (; e && e != t.dom; e = e.parentNode)
    if (e.nodeName == "TD" || e.nodeName == "TH")
      return e;
  return null;
}
function Tp(t, e) {
  const n = t.posAtCoords({
    left: e.clientX,
    top: e.clientY
  });
  return n && n ? Es(t.state.doc.resolve(n.pos)) : null;
}
var XX = class {
  constructor(e, n) {
    this.node = e, this.defaultCellMinWidth = n, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), this.table.style.setProperty(
      "--default-cell-min-width",
      `${n}px`
    ), this.colgroup = this.table.appendChild(document.createElement("colgroup")), w0(e, this.colgroup, this.table, n), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(e) {
    return e.type != this.node.type ? !1 : (this.node = e, w0(
      e,
      this.colgroup,
      this.table,
      this.defaultCellMinWidth
    ), !0);
  }
  ignoreMutation(e) {
    return e.type == "attributes" && (e.target == this.table || this.colgroup.contains(e.target));
  }
};
function w0(t, e, n, r, i, o) {
  var s;
  let a = 0, l = !0, c = e.firstChild;
  const u = t.firstChild;
  if (u) {
    for (let d = 0, f = 0; d < u.childCount; d++) {
      const { colspan: h, colwidth: p } = u.child(d).attrs;
      for (let m = 0; m < h; m++, f++) {
        const b = i == f ? o : p && p[m], y = b ? b + "px" : "";
        if (a += b || r, b || (l = !1), c)
          c.style.width != y && (c.style.width = y), c = c.nextSibling;
        else {
          const k = document.createElement("col");
          k.style.width = y, e.appendChild(k);
        }
      }
    }
    for (; c; ) {
      const d = c.nextSibling;
      (s = c.parentNode) == null || s.removeChild(c), c = d;
    }
    l ? (n.style.width = a + "px", n.style.minWidth = "") : (n.style.width = "", n.style.minWidth = a + "px");
  }
}
var un = new tt(
  "tableColumnResizing"
);
function QX({
  handleWidth: t = 5,
  cellMinWidth: e = 25,
  defaultCellMinWidth: n = 100,
  View: r = XX,
  lastColumnResizable: i = !0
} = {}) {
  const o = new Ge({
    key: un,
    state: {
      init(s, a) {
        var l, c;
        const u = (c = (l = o.spec) == null ? void 0 : l.props) == null ? void 0 : c.nodeViews, d = Lt(a.schema).table.name;
        return r && u && (u[d] = (f, h) => new r(f, n, h)), new eQ(-1, !1);
      },
      apply(s, a) {
        return a.apply(s);
      }
    },
    props: {
      attributes: (s) => {
        const a = un.getState(s);
        return a && a.activeHandle > -1 ? { class: "resize-cursor" } : {};
      },
      handleDOMEvents: {
        mousemove: (s, a) => {
          tQ(s, a, t, i);
        },
        mouseleave: (s) => {
          nQ(s);
        },
        mousedown: (s, a) => {
          rQ(s, a, e, n);
        }
      },
      decorations: (s) => {
        const a = un.getState(s);
        if (a && a.activeHandle > -1)
          return lQ(s, a.activeHandle);
      },
      nodeViews: {}
    }
  });
  return o;
}
var eQ = class wc {
  constructor(e, n) {
    this.activeHandle = e, this.dragging = n;
  }
  apply(e) {
    const n = this, r = e.getMeta(un);
    if (r && r.setHandle != null)
      return new wc(r.setHandle, !1);
    if (r && r.setDragging !== void 0)
      return new wc(n.activeHandle, r.setDragging);
    if (n.activeHandle > -1 && e.docChanged) {
      let i = e.mapping.map(n.activeHandle, -1);
      return b0(e.doc.resolve(i)) || (i = -1), new wc(i, n.dragging);
    }
    return n;
  }
};
function tQ(t, e, n, r) {
  if (!t.editable) return;
  const i = un.getState(t.state);
  if (i && !i.dragging) {
    const o = oQ(e.target);
    let s = -1;
    if (o) {
      const { left: a, right: l } = o.getBoundingClientRect();
      e.clientX - a <= n ? s = bC(t, e, "left", n) : l - e.clientX <= n && (s = bC(t, e, "right", n));
    }
    if (s != i.activeHandle) {
      if (!r && s !== -1) {
        const a = t.state.doc.resolve(s), l = a.node(-1), c = at.get(l), u = a.start(-1);
        if (c.colCount(a.pos - u) + a.nodeAfter.attrs.colspan - 1 == c.width - 1)
          return;
      }
      aR(t, s);
    }
  }
}
function nQ(t) {
  if (!t.editable) return;
  const e = un.getState(t.state);
  e && e.activeHandle > -1 && !e.dragging && aR(t, -1);
}
function rQ(t, e, n, r) {
  var i;
  if (!t.editable) return !1;
  const o = (i = t.dom.ownerDocument.defaultView) != null ? i : window, s = un.getState(t.state);
  if (!s || s.activeHandle == -1 || s.dragging)
    return !1;
  const a = t.state.doc.nodeAt(s.activeHandle), l = iQ(t, s.activeHandle, a.attrs);
  t.dispatch(
    t.state.tr.setMeta(un, {
      setDragging: { startX: e.clientX, startWidth: l }
    })
  );
  function c(d) {
    o.removeEventListener("mouseup", c), o.removeEventListener("mousemove", u);
    const f = un.getState(t.state);
    f != null && f.dragging && (sQ(
      t,
      f.activeHandle,
      yC(f.dragging, d, n)
    ), t.dispatch(
      t.state.tr.setMeta(un, { setDragging: null })
    ));
  }
  function u(d) {
    if (!d.which) return c(d);
    const f = un.getState(t.state);
    if (f && f.dragging) {
      const h = yC(f.dragging, d, n);
      wC(
        t,
        f.activeHandle,
        h,
        r
      );
    }
  }
  return wC(
    t,
    s.activeHandle,
    l,
    r
  ), o.addEventListener("mouseup", c), o.addEventListener("mousemove", u), e.preventDefault(), !0;
}
function iQ(t, e, { colspan: n, colwidth: r }) {
  const i = r && r[r.length - 1];
  if (i) return i;
  const o = t.domAtPos(e);
  let a = o.node.childNodes[o.offset].offsetWidth, l = n;
  if (r)
    for (let c = 0; c < n; c++)
      r[c] && (a -= r[c], l--);
  return a / l;
}
function oQ(t) {
  for (; t && t.nodeName != "TD" && t.nodeName != "TH"; )
    t = t.classList && t.classList.contains("ProseMirror") ? null : t.parentNode;
  return t;
}
function bC(t, e, n, r) {
  const i = n == "right" ? -r : r, o = t.posAtCoords({
    left: e.clientX + i,
    top: e.clientY
  });
  if (!o) return -1;
  const { pos: s } = o, a = Es(t.state.doc.resolve(s));
  if (!a) return -1;
  if (n == "right") return a.pos;
  const l = at.get(a.node(-1)), c = a.start(-1), u = l.map.indexOf(a.pos - c);
  return u % l.width == 0 ? -1 : c + l.map[u - 1];
}
function yC(t, e, n) {
  const r = e.clientX - t.startX;
  return Math.max(n, t.startWidth + r);
}
function aR(t, e) {
  t.dispatch(
    t.state.tr.setMeta(un, { setHandle: e })
  );
}
function sQ(t, e, n) {
  const r = t.state.doc.resolve(e), i = r.node(-1), o = at.get(i), s = r.start(-1), a = o.colCount(r.pos - s) + r.nodeAfter.attrs.colspan - 1, l = t.state.tr;
  for (let c = 0; c < o.height; c++) {
    const u = c * o.width + a;
    if (c && o.map[u] == o.map[u - o.width]) continue;
    const d = o.map[u], f = i.nodeAt(d).attrs, h = f.colspan == 1 ? 0 : a - o.colCount(d);
    if (f.colwidth && f.colwidth[h] == n) continue;
    const p = f.colwidth ? f.colwidth.slice() : aQ(f.colspan);
    p[h] = n, l.setNodeMarkup(s + d, null, { ...f, colwidth: p });
  }
  l.docChanged && t.dispatch(l);
}
function wC(t, e, n, r) {
  const i = t.state.doc.resolve(e), o = i.node(-1), s = i.start(-1), a = at.get(o).colCount(i.pos - s) + i.nodeAfter.attrs.colspan - 1;
  let l = t.domAtPos(i.start(-1)).node;
  for (; l && l.nodeName != "TABLE"; )
    l = l.parentNode;
  l && w0(
    o,
    l.firstChild,
    l,
    r,
    a,
    n
  );
}
function aQ(t) {
  return Array(t).fill(0);
}
function lQ(t, e) {
  var n;
  const r = [], i = t.doc.resolve(e), o = i.node(-1);
  if (!o)
    return ot.empty;
  const s = at.get(o), a = i.start(-1), l = s.colCount(i.pos - a) + i.nodeAfter.attrs.colspan - 1;
  for (let c = 0; c < s.height; c++) {
    const u = l + c * s.width;
    if ((l == s.width - 1 || s.map[u] != s.map[u + 1]) && (c == 0 || s.map[u] != s.map[u - s.width])) {
      const d = s.map[u], f = a + d + o.nodeAt(d).nodeSize - 1, h = document.createElement("div");
      h.className = "column-resize-handle", (n = un.getState(t)) != null && n.dragging && r.push(
        jt.node(
          a + d,
          a + d + o.nodeAt(d).nodeSize,
          {
            class: "column-resize-dragging"
          }
        )
      ), r.push(jt.widget(f, h));
    }
  }
  return ot.create(t.doc, r);
}
function cQ({
  allowTableNodeSelection: t = !1
} = {}) {
  return new Ge({
    key: ri,
    // This piece of state is used to remember when a mouse-drag
    // cell-selection is happening, so that it can continue even as
    // transactions (which might move its anchor cell) come in.
    state: {
      init() {
        return null;
      },
      apply(e, n) {
        const r = e.getMeta(ri);
        if (r != null) return r == -1 ? null : r;
        if (n == null || !e.docChanged) return n;
        const { deleted: i, pos: o } = e.mapping.mapResult(n);
        return i ? null : o;
      }
    },
    props: {
      decorations: kX,
      handleDOMEvents: {
        mousedown: JX
      },
      createSelectionBetween(e) {
        return ri.getState(e.state) != null ? e.state.selection : null;
      },
      handleTripleClick: YX,
      handleKeyDown: GX,
      handlePaste: ZX
    },
    appendTransaction(e, n, r) {
      return TX(
        r,
        rR(r, n),
        t
      );
    }
  });
}
function x0(t, e) {
  return e ? ["width", `${Math.max(e, t)}px`] : ["min-width", `${t}px`];
}
function xC(t, e, n, r, i, o) {
  var s;
  let a = 0, l = !0, c = e.firstChild;
  const u = t.firstChild;
  if (u !== null)
    for (let d = 0, f = 0; d < u.childCount; d += 1) {
      const { colspan: h, colwidth: p } = u.child(d).attrs;
      for (let m = 0; m < h; m += 1, f += 1) {
        const b = i === f ? o : p && p[m], y = b ? `${b}px` : "";
        if (a += b || r, b || (l = !1), c) {
          if (c.style.width !== y) {
            const [k, C] = x0(r, b);
            c.style.setProperty(k, C);
          }
          c = c.nextSibling;
        } else {
          const k = document.createElement("col"), [C, x] = x0(r, b);
          k.style.setProperty(C, x), e.appendChild(k);
        }
      }
    }
  for (; c; ) {
    const d = c.nextSibling;
    (s = c.parentNode) === null || s === void 0 || s.removeChild(c), c = d;
  }
  l ? (n.style.width = `${a}px`, n.style.minWidth = "") : (n.style.width = "", n.style.minWidth = `${a}px`);
}
class uQ {
  constructor(e, n) {
    this.node = e, this.cellMinWidth = n, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), this.colgroup = this.table.appendChild(document.createElement("colgroup")), xC(e, this.colgroup, this.table, n), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(e) {
    return e.type !== this.node.type ? !1 : (this.node = e, xC(e, this.colgroup, this.table, this.cellMinWidth), !0);
  }
  ignoreMutation(e) {
    return e.type === "attributes" && (e.target === this.table || this.colgroup.contains(e.target));
  }
}
function dQ(t, e, n, r) {
  let i = 0, o = !0;
  const s = [], a = t.firstChild;
  if (!a)
    return {};
  for (let d = 0, f = 0; d < a.childCount; d += 1) {
    const { colspan: h, colwidth: p } = a.child(d).attrs;
    for (let m = 0; m < h; m += 1, f += 1) {
      const b = n === f ? r : p && p[m];
      i += b || e, b || (o = !1);
      const [y, k] = x0(e, b);
      s.push([
        "col",
        { style: `${y}: ${k}` }
      ]);
    }
  }
  const l = o ? `${i}px` : "", c = o ? "" : `${i}px`;
  return { colgroup: ["colgroup", {}, ...s], tableWidth: l, tableMinWidth: c };
}
function kC(t, e) {
  return t.createAndFill();
}
function fQ(t) {
  if (t.cached.tableNodeTypes)
    return t.cached.tableNodeTypes;
  const e = {};
  return Object.keys(t.nodes).forEach((n) => {
    const r = t.nodes[n];
    r.spec.tableRole && (e[r.spec.tableRole] = r);
  }), t.cached.tableNodeTypes = e, e;
}
function hQ(t, e, n, r, i) {
  const o = fQ(t), s = [], a = [];
  for (let c = 0; c < n; c += 1) {
    const u = kC(o.cell);
    if (u && a.push(u), r) {
      const d = kC(o.header_cell);
      d && s.push(d);
    }
  }
  const l = [];
  for (let c = 0; c < e; c += 1)
    l.push(o.row.createChecked(null, r && c === 0 ? s : a));
  return o.table.createChecked(null, l);
}
function pQ(t) {
  return t instanceof Xe;
}
const Jl = ({ editor: t }) => {
  const { selection: e } = t.state;
  if (!pQ(e))
    return !1;
  let n = 0;
  const r = v3(e.ranges[0].$from, (o) => o.type.name === "table");
  return r == null || r.node.descendants((o) => {
    if (o.type.name === "table")
      return !1;
    ["tableCell", "tableHeader"].includes(o.type.name) && (n += 1);
  }), n === e.ranges.length ? (t.commands.deleteTable(), !0) : !1;
}, mQ = vt.create({
  name: "table",
  // @ts-ignore
  addOptions() {
    return {
      HTMLAttributes: {},
      resizable: !1,
      handleWidth: 5,
      cellMinWidth: 25,
      // TODO: fix
      View: uQ,
      lastColumnResizable: !0,
      allowTableNodeSelection: !1
    };
  },
  content: "tableRow+",
  tableRole: "table",
  isolating: !0,
  group: "block",
  parseHTML() {
    return [{ tag: "table" }];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    const { colgroup: n, tableWidth: r, tableMinWidth: i } = dQ(t, this.options.cellMinWidth);
    return [
      "table",
      Ke(this.options.HTMLAttributes, e, {
        style: r ? `width: ${r}` : `min-width: ${i}`
      }),
      n,
      ["tbody", 0]
    ];
  },
  addCommands() {
    return {
      insertTable: ({ rows: t = 3, cols: e = 3, withHeaderRow: n = !0 } = {}) => ({ tr: r, dispatch: i, editor: o }) => {
        const s = hQ(o.schema, t, e, n);
        if (i) {
          const a = r.selection.from + 1;
          r.replaceSelectionWith(s).scrollIntoView().setSelection(ge.near(r.doc.resolve(a)));
        }
        return !0;
      },
      addColumnBefore: () => ({ state: t, dispatch: e }) => OX(t, e),
      addColumnAfter: () => ({ state: t, dispatch: e }) => AX(t, e),
      deleteColumn: () => ({ state: t, dispatch: e }) => RX(t, e),
      addRowBefore: () => ({ state: t, dispatch: e }) => IX(t, e),
      addRowAfter: () => ({ state: t, dispatch: e }) => _X(t, e),
      deleteRow: () => ({ state: t, dispatch: e }) => LX(t, e),
      deleteTable: () => ({ state: t, dispatch: e }) => WX(t, e),
      mergeCells: () => ({ state: t, dispatch: e }) => uC(t, e),
      splitCell: () => ({ state: t, dispatch: e }) => dC(t, e),
      toggleHeaderColumn: () => ({ state: t, dispatch: e }) => Ia("column")(t, e),
      toggleHeaderRow: () => ({ state: t, dispatch: e }) => Ia("row")(t, e),
      toggleHeaderCell: () => ({ state: t, dispatch: e }) => zX(t, e),
      mergeOrSplit: () => ({ state: t, dispatch: e }) => uC(t, e) ? !0 : dC(t, e),
      setCellAttribute: (t, e) => ({ state: n, dispatch: r }) => BX(t, e)(n, r),
      goToNextCell: () => ({ state: t, dispatch: e }) => hC(1)(t, e),
      goToPreviousCell: () => ({ state: t, dispatch: e }) => hC(-1)(t, e),
      fixTables: () => ({ state: t, dispatch: e }) => (e && rR(t), !0),
      setCellSelection: (t) => ({ tr: e, dispatch: n }) => {
        if (n) {
          const r = Xe.create(e.doc, t.anchorCell, t.headCell);
          e.setSelection(r);
        }
        return !0;
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      Tab: () => this.editor.commands.goToNextCell() ? !0 : this.editor.can().addRowAfter() ? this.editor.chain().addRowAfter().goToNextCell().run() : !1,
      "Shift-Tab": () => this.editor.commands.goToPreviousCell(),
      Backspace: Jl,
      "Mod-Backspace": Jl,
      Delete: Jl,
      "Mod-Delete": Jl
    };
  },
  addProseMirrorPlugins() {
    return [
      ...this.options.resizable && this.editor.isEditable ? [
        QX({
          handleWidth: this.options.handleWidth,
          cellMinWidth: this.options.cellMinWidth,
          defaultCellMinWidth: this.options.cellMinWidth,
          View: this.options.View,
          lastColumnResizable: this.options.lastColumnResizable
        })
      ] : [],
      cQ({
        allowTableNodeSelection: this.options.allowTableNodeSelection
      })
    ];
  },
  extendNodeSchema(t) {
    const e = {
      name: t.name,
      options: t.options,
      storage: t.storage
    };
    return {
      tableRole: Ae(ue(t, "tableRole", e))
    };
  }
}), gQ = vt.create({
  name: "tableCell",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (t) => {
          const e = t.getAttribute("colwidth");
          return e ? e.split(",").map((r) => parseInt(r, 10)) : null;
        }
      }
    };
  },
  tableRole: "cell",
  isolating: !0,
  parseHTML() {
    return [
      { tag: "td" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["td", Ke(this.options.HTMLAttributes, t), 0];
  }
}), vQ = vt.create({
  name: "tableHeader",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (t) => {
          const e = t.getAttribute("colwidth");
          return e ? e.split(",").map((r) => parseInt(r, 10)) : null;
        }
      }
    };
  },
  tableRole: "header_cell",
  isolating: !0,
  parseHTML() {
    return [
      { tag: "th" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["th", Ke(this.options.HTMLAttributes, t), 0];
  }
}), bQ = vt.create({
  name: "tableRow",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "(tableCell | tableHeader)*",
  tableRole: "row",
  parseHTML() {
    return [
      { tag: "tr" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["tr", Ke(this.options.HTMLAttributes, t), 0];
  }
}), yQ = gt.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (t) => {
              const e = t.style.textAlign;
              return this.options.alignments.includes(e) ? e : this.options.defaultAlignment;
            },
            renderHTML: (t) => t.textAlign ? { style: `text-align: ${t.textAlign}` } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (t) => ({ commands: e }) => this.options.alignments.includes(t) ? this.options.types.map((n) => e.updateAttributes(n, { textAlign: t })).every((n) => n) : !1,
      unsetTextAlign: () => ({ commands: t }) => this.options.types.map((e) => t.resetAttributes(e, "textAlign")).every((e) => e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), wQ = gn.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (t) => t.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["u", Ke(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: t }) => t.setMark(this.name),
      toggleUnderline: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetUnderline: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
}), xQ = /^((?:https?:)?\/\/)?((?:www|m|music)\.)?((?:youtube\.com|youtu.be|youtube-nocookie\.com))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/, kQ = /^((?:https?:)?\/\/)?((?:www|m|music)\.)?((?:youtube\.com|youtu.be|youtube-nocookie\.com))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/g, lR = (t) => t.match(xQ), CC = (t, e) => e ? "https://www.youtube-nocookie.com/embed/videoseries?list=" : t ? "https://www.youtube-nocookie.com/embed/" : "https://www.youtube.com/embed/", CQ = (t) => {
  const { url: e, allowFullscreen: n, autoplay: r, ccLanguage: i, ccLoadPolicy: o, controls: s, disableKBcontrols: a, enableIFrameApi: l, endTime: c, interfaceLanguage: u, ivLoadPolicy: d, loop: f, modestBranding: h, nocookie: p, origin: m, playlist: b, progressBarColor: y, startAt: k, rel: C } = t;
  if (!lR(e))
    return null;
  if (e.includes("/embed/"))
    return e;
  if (e.includes("youtu.be")) {
    const M = e.split("/").pop();
    return M ? `${CC(p)}${M}` : null;
  }
  const S = /(?:(v|list)=|shorts\/)([-\w]+)/gm.exec(e);
  if (!S || !S[2])
    return null;
  let T = `${CC(p, S[1] === "list")}${S[2]}`;
  const E = [];
  return n === !1 && E.push("fs=0"), r && E.push("autoplay=1"), i && E.push(`cc_lang_pref=${i}`), o && E.push("cc_load_policy=1"), s || E.push("controls=0"), a && E.push("disablekb=1"), l && E.push("enablejsapi=1"), c && E.push(`end=${c}`), u && E.push(`hl=${u}`), d && E.push(`iv_load_policy=${d}`), f && E.push("loop=1"), h && E.push("modestbranding=1"), m && E.push(`origin=${m}`), b && E.push(`playlist=${b}`), k && E.push(`start=${k}`), y && E.push(`color=${y}`), C !== void 0 && E.push(`rel=${C}`), E.length && (T += `${S[1] === "v" ? "?" : "&"}${E.join("&")}`), T;
}, SQ = vt.create({
  name: "youtube",
  addOptions() {
    return {
      addPasteHandler: !0,
      allowFullscreen: !0,
      autoplay: !1,
      ccLanguage: void 0,
      ccLoadPolicy: void 0,
      controls: !0,
      disableKBcontrols: !1,
      enableIFrameApi: !1,
      endTime: 0,
      height: 480,
      interfaceLanguage: void 0,
      ivLoadPolicy: 0,
      loop: !1,
      modestBranding: !1,
      HTMLAttributes: {},
      inline: !1,
      nocookie: !1,
      origin: "",
      playlist: "",
      progressBarColor: void 0,
      width: 640,
      rel: 1
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      start: {
        default: 0
      },
      width: {
        default: this.options.width
      },
      height: {
        default: this.options.height
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "div[data-youtube-video] iframe"
      }
    ];
  },
  addCommands() {
    return {
      setYoutubeVideo: (t) => ({ commands: e }) => lR(t.src) ? e.insertContent({
        type: this.name,
        attrs: t
      }) : !1
    };
  },
  addPasteRules() {
    return this.options.addPasteHandler ? [
      tZ({
        find: kQ,
        type: this.type,
        getAttributes: (t) => ({ src: t.input })
      })
    ] : [];
  },
  renderHTML({ HTMLAttributes: t }) {
    const e = CQ({
      url: t.src,
      allowFullscreen: this.options.allowFullscreen,
      autoplay: this.options.autoplay,
      ccLanguage: this.options.ccLanguage,
      ccLoadPolicy: this.options.ccLoadPolicy,
      controls: this.options.controls,
      disableKBcontrols: this.options.disableKBcontrols,
      enableIFrameApi: this.options.enableIFrameApi,
      endTime: this.options.endTime,
      interfaceLanguage: this.options.interfaceLanguage,
      ivLoadPolicy: this.options.ivLoadPolicy,
      loop: this.options.loop,
      modestBranding: this.options.modestBranding,
      nocookie: this.options.nocookie,
      origin: this.options.origin,
      playlist: this.options.playlist,
      progressBarColor: this.options.progressBarColor,
      startAt: t.start || 0,
      rel: this.options.rel
    });
    return t.src = e, [
      "div",
      { "data-youtube-video": "" },
      [
        "iframe",
        Ke(this.options.HTMLAttributes, {
          width: this.options.width,
          height: this.options.height,
          allowfullscreen: this.options.allowFullscreen,
          autoplay: this.options.autoplay,
          ccLanguage: this.options.ccLanguage,
          ccLoadPolicy: this.options.ccLoadPolicy,
          disableKBcontrols: this.options.disableKBcontrols,
          enableIFrameApi: this.options.enableIFrameApi,
          endTime: this.options.endTime,
          interfaceLanguage: this.options.interfaceLanguage,
          ivLoadPolicy: this.options.ivLoadPolicy,
          loop: this.options.loop,
          modestBranding: this.options.modestBranding,
          origin: this.options.origin,
          playlist: this.options.playlist,
          progressBarColor: this.options.progressBarColor,
          rel: this.options.rel
        }, t)
      ]
    ];
  }
});
function TQ(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var k0 = { exports: {} }, Ep = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var SC;
function EQ() {
  if (SC) return Ep;
  SC = 1;
  var t = he;
  function e(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : e, r = t.useState, i = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
  function a(d, f) {
    var h = f(), p = r({ inst: { value: h, getSnapshot: f } }), m = p[0].inst, b = p[1];
    return o(function() {
      m.value = h, m.getSnapshot = f, l(m) && b({ inst: m });
    }, [d, h, f]), i(function() {
      return l(m) && b({ inst: m }), d(function() {
        l(m) && b({ inst: m });
      });
    }, [d]), s(h), h;
  }
  function l(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var h = f();
      return !n(d, h);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : a;
  return Ep.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, Ep;
}
var Mp = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var TC;
function MQ() {
  return TC || (TC = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = he, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(C) {
      {
        for (var x = arguments.length, S = new Array(x > 1 ? x - 1 : 0), T = 1; T < x; T++)
          S[T - 1] = arguments[T];
        r("error", C, S);
      }
    }
    function r(C, x, S) {
      {
        var T = e.ReactDebugCurrentFrame, E = T.getStackAddendum();
        E !== "" && (x += "%s", S = S.concat([E]));
        var M = S.map(function(O) {
          return String(O);
        });
        M.unshift("Warning: " + x), Function.prototype.apply.call(console[C], console, M);
      }
    }
    function i(C, x) {
      return C === x && (C !== 0 || 1 / C === 1 / x) || C !== C && x !== x;
    }
    var o = typeof Object.is == "function" ? Object.is : i, s = t.useState, a = t.useEffect, l = t.useLayoutEffect, c = t.useDebugValue, u = !1, d = !1;
    function f(C, x, S) {
      u || t.startTransition !== void 0 && (u = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var T = x();
      if (!d) {
        var E = x();
        o(T, E) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), d = !0);
      }
      var M = s({
        inst: {
          value: T,
          getSnapshot: x
        }
      }), O = M[0].inst, L = M[1];
      return l(function() {
        O.value = T, O.getSnapshot = x, h(O) && L({
          inst: O
        });
      }, [C, T, x]), a(function() {
        h(O) && L({
          inst: O
        });
        var $ = function() {
          h(O) && L({
            inst: O
          });
        };
        return C($);
      }, [C]), c(T), T;
    }
    function h(C) {
      var x = C.getSnapshot, S = C.value;
      try {
        var T = x();
        return !o(S, T);
      } catch {
        return !0;
      }
    }
    function p(C, x, S) {
      return x();
    }
    var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", b = !m, y = b ? p : f, k = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : y;
    Mp.useSyncExternalStore = k, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Mp;
}
process.env.NODE_ENV === "production" ? k0.exports = EQ() : k0.exports = MQ();
var Hd = k0.exports;
const OQ = (...t) => (e) => {
  t.forEach((n) => {
    typeof n == "function" ? n(e) : n && (n.current = e);
  });
}, AQ = ({ contentComponent: t }) => {
  const e = Hd.useSyncExternalStore(t.subscribe, t.getSnapshot, t.getServerSnapshot);
  return he.createElement(he.Fragment, null, Object.values(e));
};
function NQ() {
  const t = /* @__PURE__ */ new Set();
  let e = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(n) {
      return t.add(n), () => {
        t.delete(n);
      };
    },
    getSnapshot() {
      return e;
    },
    getServerSnapshot() {
      return e;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(n, r) {
      e = {
        ...e,
        [n]: wS.createPortal(r.reactElement, r.element, n)
      }, t.forEach((i) => i());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(n) {
      const r = { ...e };
      delete r[n], e = r, t.forEach((i) => i());
    }
  };
}
class RQ extends he.Component {
  constructor(e) {
    var n;
    super(e), this.editorContentRef = he.createRef(), this.initialized = !1, this.state = {
      hasContentComponentInitialized: !!(!((n = e.editor) === null || n === void 0) && n.contentComponent)
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const e = this.props.editor;
    if (e && !e.isDestroyed && e.options.element) {
      if (e.contentComponent)
        return;
      const n = this.editorContentRef.current;
      n.append(...e.options.element.childNodes), e.setOptions({
        element: n
      }), e.contentComponent = NQ(), this.state.hasContentComponentInitialized || (this.unsubscribeToContentComponent = e.contentComponent.subscribe(() => {
        this.setState((r) => r.hasContentComponentInitialized ? r : {
          hasContentComponentInitialized: !0
        }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent();
      })), e.createNodeViews(), this.initialized = !0;
    }
  }
  componentWillUnmount() {
    const e = this.props.editor;
    if (!e || (this.initialized = !1, e.isDestroyed || e.view.setProps({
      nodeViews: {}
    }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent(), e.contentComponent = null, !e.options.element.firstChild))
      return;
    const n = document.createElement("div");
    n.append(...e.options.element.childNodes), e.setOptions({
      element: n
    });
  }
  render() {
    const { editor: e, innerRef: n, ...r } = this.props;
    return he.createElement(
      he.Fragment,
      null,
      he.createElement("div", { ref: OQ(n, this.editorContentRef), ...r }),
      (e == null ? void 0 : e.contentComponent) && he.createElement(AQ, { contentComponent: e.contentComponent })
    );
  }
}
const DQ = ce((t, e) => {
  const n = he.useMemo(() => Math.floor(Math.random() * 4294967295).toString(), [t.editor]);
  return he.createElement(RQ, {
    key: n,
    innerRef: e,
    ...t
  });
}), IQ = he.memo(DQ);
var _Q = function t(e, n) {
  if (e === n) return !0;
  if (e && n && typeof e == "object" && typeof n == "object") {
    if (e.constructor !== n.constructor) return !1;
    var r, i, o;
    if (Array.isArray(e)) {
      if (r = e.length, r != n.length) return !1;
      for (i = r; i-- !== 0; )
        if (!t(e[i], n[i])) return !1;
      return !0;
    }
    if (e instanceof Map && n instanceof Map) {
      if (e.size !== n.size) return !1;
      for (i of e.entries())
        if (!n.has(i[0])) return !1;
      for (i of e.entries())
        if (!t(i[1], n.get(i[0]))) return !1;
      return !0;
    }
    if (e instanceof Set && n instanceof Set) {
      if (e.size !== n.size) return !1;
      for (i of e.entries())
        if (!n.has(i[0])) return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(n)) {
      if (r = e.length, r != n.length) return !1;
      for (i = r; i-- !== 0; )
        if (e[i] !== n[i]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === n.source && e.flags === n.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === n.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === n.toString();
    if (o = Object.keys(e), r = o.length, r !== Object.keys(n).length) return !1;
    for (i = r; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, o[i])) return !1;
    for (i = r; i-- !== 0; ) {
      var s = o[i];
      if (!(s === "_owner" && e.$$typeof) && !t(e[s], n[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && n !== n;
}, PQ = /* @__PURE__ */ TQ(_Q), C0 = { exports: {} }, Op = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var EC;
function LQ() {
  if (EC) return Op;
  EC = 1;
  var t = he, e = Hd;
  function n(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : n, i = e.useSyncExternalStore, o = t.useRef, s = t.useEffect, a = t.useMemo, l = t.useDebugValue;
  return Op.useSyncExternalStoreWithSelector = function(c, u, d, f, h) {
    var p = o(null);
    if (p.current === null) {
      var m = { hasValue: !1, value: null };
      p.current = m;
    } else m = p.current;
    p = a(function() {
      function y(T) {
        if (!k) {
          if (k = !0, C = T, T = f(T), h !== void 0 && m.hasValue) {
            var E = m.value;
            if (h(E, T)) return x = E;
          }
          return x = T;
        }
        if (E = x, r(C, T)) return E;
        var M = f(T);
        return h !== void 0 && h(E, M) ? E : (C = T, x = M);
      }
      var k = !1, C, x, S = d === void 0 ? null : d;
      return [function() {
        return y(u());
      }, S === null ? void 0 : function() {
        return y(S());
      }];
    }, [u, d, f, h]);
    var b = i(c, p[0], p[1]);
    return s(function() {
      m.hasValue = !0, m.value = b;
    }, [b]), l(b), b;
  }, Op;
}
var Ap = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var MC;
function FQ() {
  return MC || (MC = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = he, e = Hd;
    function n(u, d) {
      return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
    }
    var r = typeof Object.is == "function" ? Object.is : n, i = e.useSyncExternalStore, o = t.useRef, s = t.useEffect, a = t.useMemo, l = t.useDebugValue;
    function c(u, d, f, h, p) {
      var m = o(null), b;
      m.current === null ? (b = {
        hasValue: !1,
        value: null
      }, m.current = b) : b = m.current;
      var y = a(function() {
        var S = !1, T, E, M = function(z) {
          if (!S) {
            S = !0, T = z;
            var B = h(z);
            if (p !== void 0 && b.hasValue) {
              var A = b.value;
              if (p(A, B))
                return E = A, A;
            }
            return E = B, B;
          }
          var N = T, R = E;
          if (r(N, z))
            return R;
          var _ = h(z);
          return p !== void 0 && p(R, _) ? R : (T = z, E = _, _);
        }, O = f === void 0 ? null : f, L = function() {
          return M(d());
        }, $ = O === null ? void 0 : function() {
          return M(O());
        };
        return [L, $];
      }, [d, f, h, p]), k = y[0], C = y[1], x = i(u, k, C);
      return s(function() {
        b.hasValue = !0, b.value = x;
      }, [x]), l(x), x;
    }
    Ap.useSyncExternalStoreWithSelector = c, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Ap;
}
process.env.NODE_ENV === "production" ? C0.exports = LQ() : C0.exports = FQ();
var $Q = C0.exports;
const BQ = typeof window < "u" ? uo : De;
class VQ {
  constructor(e) {
    this.transactionNumber = 0, this.lastTransactionNumber = 0, this.subscribers = /* @__PURE__ */ new Set(), this.editor = e, this.lastSnapshot = { editor: e, transactionNumber: 0 }, this.getSnapshot = this.getSnapshot.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.watch = this.watch.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    return this.transactionNumber === this.lastTransactionNumber ? this.lastSnapshot : (this.lastTransactionNumber = this.transactionNumber, this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber }, this.lastSnapshot);
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscribers.add(e), () => {
      this.subscribers.delete(e);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(e) {
    if (this.editor = e, this.editor) {
      const n = () => {
        this.transactionNumber += 1, this.subscribers.forEach((i) => i());
      }, r = this.editor;
      return r.on("transaction", n), () => {
        r.off("transaction", n);
      };
    }
  }
}
function zQ(t) {
  var e;
  const [n] = pe(() => new VQ(t.editor)), r = $Q.useSyncExternalStoreWithSelector(n.subscribe, n.getSnapshot, n.getServerSnapshot, t.selector, (e = t.equalityFn) !== null && e !== void 0 ? e : PQ);
  return BQ(() => n.watch(t.editor), [t.editor, n]), yS(r), r;
}
const OC = process.env.NODE_ENV !== "production", S0 = typeof window > "u", HQ = S0 || !!(typeof window < "u" && window.next);
class _b {
  constructor(e) {
    this.editor = null, this.subscriptions = /* @__PURE__ */ new Set(), this.isComponentMounted = !1, this.previousDeps = null, this.instanceId = "", this.options = e, this.subscriptions = /* @__PURE__ */ new Set(), this.setEditor(this.getInitialEditor()), this.scheduleDestroy(), this.getEditor = this.getEditor.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.subscribe = this.subscribe.bind(this), this.refreshEditorInstance = this.refreshEditorInstance.bind(this), this.scheduleDestroy = this.scheduleDestroy.bind(this), this.onRender = this.onRender.bind(this), this.createEditor = this.createEditor.bind(this);
  }
  setEditor(e) {
    this.editor = e, this.instanceId = Math.random().toString(36).slice(2, 9), this.subscriptions.forEach((n) => n());
  }
  getInitialEditor() {
    if (this.options.current.immediatelyRender === void 0)
      return S0 || HQ ? (OC && console.warn("Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches."), null) : this.createEditor();
    if (this.options.current.immediatelyRender && S0 && OC)
      throw new Error("Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.");
    return this.options.current.immediatelyRender ? this.createEditor() : null;
  }
  /**
   * Create a new editor instance. And attach event listeners.
   */
  createEditor() {
    const e = {
      ...this.options.current,
      // Always call the most recent version of the callback function by default
      onBeforeCreate: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onBeforeCreate) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onBlur: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onBlur) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onCreate: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onCreate) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onDestroy: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onDestroy) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onFocus: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onFocus) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onSelectionUpdate: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onSelectionUpdate) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onTransaction: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onTransaction) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onUpdate: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onUpdate) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onContentError: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onContentError) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onDrop: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onDrop) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onPaste: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onPaste) === null || o === void 0 ? void 0 : o.call(i, ...r);
      }
    };
    return new eZ(e);
  }
  /**
   * Get the current editor instance.
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return null;
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscriptions.add(e), () => {
      this.subscriptions.delete(e);
    };
  }
  static compareOptions(e, n) {
    return Object.keys(e).every((r) => ["onCreate", "onBeforeCreate", "onDestroy", "onUpdate", "onTransaction", "onFocus", "onBlur", "onSelectionUpdate", "onContentError", "onDrop", "onPaste"].includes(r) ? !0 : r === "extensions" && e.extensions && n.extensions ? e.extensions.length !== n.extensions.length ? !1 : e.extensions.every((i, o) => {
      var s;
      return i === ((s = n.extensions) === null || s === void 0 ? void 0 : s[o]);
    }) : e[r] === n[r]);
  }
  /**
   * On each render, we will create, update, or destroy the editor instance.
   * @param deps The dependencies to watch for changes
   * @returns A cleanup function
   */
  onRender(e) {
    return () => (this.isComponentMounted = !0, clearTimeout(this.scheduledDestructionTimeout), this.editor && !this.editor.isDestroyed && e.length === 0 ? _b.compareOptions(this.options.current, this.editor.options) || this.editor.setOptions({
      ...this.options.current,
      editable: this.editor.isEditable
    }) : this.refreshEditorInstance(e), () => {
      this.isComponentMounted = !1, this.scheduleDestroy();
    });
  }
  /**
   * Recreate the editor instance if the dependencies have changed.
   */
  refreshEditorInstance(e) {
    if (this.editor && !this.editor.isDestroyed) {
      if (this.previousDeps === null) {
        this.previousDeps = e;
        return;
      }
      if (this.previousDeps.length === e.length && this.previousDeps.every((r, i) => r === e[i]))
        return;
    }
    this.editor && !this.editor.isDestroyed && this.editor.destroy(), this.setEditor(this.createEditor()), this.previousDeps = e;
  }
  /**
   * Schedule the destruction of the editor instance.
   * This will only destroy the editor if it was not mounted on the next tick.
   * This is to avoid destroying the editor instance when it's actually still mounted.
   */
  scheduleDestroy() {
    const e = this.instanceId, n = this.editor;
    this.scheduledDestructionTimeout = setTimeout(() => {
      if (this.isComponentMounted && this.instanceId === e) {
        n && n.setOptions(this.options.current);
        return;
      }
      n && !n.isDestroyed && (n.destroy(), this.instanceId === e && this.setEditor(null));
    }, 1);
  }
}
function WQ(t = {}, e = []) {
  const n = Me(t);
  n.current = t;
  const [r] = pe(() => new _b(n)), i = Hd.useSyncExternalStore(r.subscribe, r.getEditor, r.getServerSnapshot);
  return yS(i), De(r.onRender(e)), zQ({
    editor: i,
    selector: ({ transactionNumber: o }) => t.shouldRerenderOnTransaction === !1 ? null : t.immediatelyRender && o === 0 ? 0 : o + 1
  }), i;
}
const Pb = Pn({
  editor: null
}), jQ = Pb.Consumer, vr = () => Ln(Pb);
function UQ({ children: t, slotAfter: e, slotBefore: n, editorContainerProps: r = {}, ...i }) {
  const o = WQ(i);
  return o ? he.createElement(
    Pb.Provider,
    { value: { editor: o } },
    n,
    he.createElement(jQ, null, ({ editor: s }) => he.createElement(IQ, { editor: s, ...r })),
    t,
    e
  ) : null;
}
const qQ = (t) => {
  const [e, n] = pe(null), { editor: r } = vr();
  return De(() => {
    var i;
    if (!e || !((i = t.editor) === null || i === void 0) && i.isDestroyed || r != null && r.isDestroyed)
      return;
    const { pluginKey: o = "bubbleMenu", editor: s, tippyOptions: a = {}, updateDelay: l, shouldShow: c = null } = t, u = s || r;
    if (!u) {
      console.warn("BubbleMenu component is not rendered inside of an editor component or does not have editor prop.");
      return;
    }
    const d = H3({
      updateDelay: l,
      editor: u,
      element: e,
      pluginKey: o,
      shouldShow: c,
      tippyOptions: a
    });
    return u.registerPlugin(d), () => {
      u.unregisterPlugin(o);
    };
  }, [t.editor, r, e]), he.createElement("div", { ref: n, className: t.className, style: { visibility: "hidden" } }, t.children);
}, KQ = Pn({
  onDragStart: void 0
}), GQ = () => Ln(KQ);
he.forwardRef((t, e) => {
  const { onDragStart: n } = GQ(), r = t.as || "div";
  return (
    // @ts-ignore
    he.createElement(r, { ...t, ref: e, "data-node-view-wrapper": "", onDragStart: n, style: {
      whiteSpace: "normal",
      ...t.style
    } })
  );
});
const YQ = /^\s*>\s$/, ZQ = vt.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["blockquote", Ke(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: t }) => t.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: t }) => t.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: t }) => t.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      Ea({
        find: YQ,
        type: this.type
      })
    ];
  }
}), JQ = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, XQ = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, QQ = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, eee = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, tee = gn.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (t) => t.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (t) => /^(bold(er)?|[5-9]\d{2,})$/.test(t) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["strong", Ke(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: t }) => t.setMark(this.name),
      toggleBold: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetBold: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      ao({
        find: JQ,
        type: this.type
      }),
      ao({
        find: QQ,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      xi({
        find: XQ,
        type: this.type
      }),
      xi({
        find: eee,
        type: this.type
      })
    ];
  }
}), nee = "listItem", AC = "textStyle", NC = /^\s*([-+*])\s$/, ree = vt.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["ul", Ke(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(nee, this.editor.getAttributes(AC)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let t = Ea({
      find: NC,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = Ea({
      find: NC,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(AC),
      editor: this.editor
    })), [
      t
    ];
  }
}), iee = /(^|[^`])`([^`]+)`(?!`)/, oee = /(^|[^`])`([^`]+)`(?!`)/g, see = gn.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["code", Ke(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: t }) => t.setMark(this.name),
      toggleCode: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetCode: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      ao({
        find: iee,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      xi({
        find: oee,
        type: this.type
      })
    ];
  }
}), aee = /^```([a-z]+)?[\s\n]$/, lee = /^~~~([a-z]+)?[\s\n]$/, cee = vt.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (t) => {
          var e;
          const { languageClassPrefix: n } = this.options, o = [...((e = t.firstElementChild) === null || e === void 0 ? void 0 : e.classList) || []].filter((s) => s.startsWith(n)).map((s) => s.replace(n, ""))[0];
          return o || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [
      "pre",
      Ke(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: t.attrs.language ? this.options.languageClassPrefix + t.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (t) => ({ commands: e }) => e.setNode(this.name, t),
      toggleCodeBlock: (t) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", t)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: t, $anchor: e } = this.editor.state.selection, n = e.pos === 1;
        return !t || e.parent.type.name !== this.name ? !1 : n || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: t }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = t, { selection: n } = e, { $from: r, empty: i } = n;
        if (!i || r.parent.type !== this.type)
          return !1;
        const o = r.parentOffset === r.parent.nodeSize - 2, s = r.parent.textContent.endsWith(`

`);
        return !o || !s ? !1 : t.chain().command(({ tr: a }) => (a.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: t }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = t, { selection: n, doc: r } = e, { $from: i, empty: o } = n;
        if (!o || i.parent.type !== this.type || !(i.parentOffset === i.parent.nodeSize - 2))
          return !1;
        const a = i.after();
        return a === void 0 ? !1 : r.nodeAt(a) ? t.commands.command(({ tr: c }) => (c.setSelection(be.near(r.resolve(a))), !0)) : t.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      t0({
        find: aee,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      }),
      t0({
        find: lee,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new Ge({
        key: new tt("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (t, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const n = e.clipboardData.getData("text/plain"), r = e.clipboardData.getData("vscode-editor-data"), i = r ? JSON.parse(r) : void 0, o = i == null ? void 0 : i.mode;
            if (!n || !o)
              return !1;
            const { tr: s, schema: a } = t.state, l = a.text(n.replace(/\r\n?/g, `
`));
            return s.replaceSelectionWith(this.type.create({ language: o }, l)), s.selection.$from.parent.type !== this.type && s.setSelection(ge.near(s.doc.resolve(Math.max(0, s.selection.from - 2)))), s.setMeta("paste", !0), t.dispatch(s), !0;
          }
        }
      })
    ];
  }
}), uee = vt.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function dee(t = {}) {
  return new Ge({
    view(e) {
      return new fee(e, t);
    }
  });
}
class fee {
  constructor(e, n) {
    var r;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = n.width) !== null && r !== void 0 ? r : 1, this.color = n.color === !1 ? void 0 : n.color || "black", this.class = n.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((i) => {
      let o = (s) => {
        this[i](s);
      };
      return e.dom.addEventListener(i, o), { name: i, handler: o };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: n }) => this.editorView.dom.removeEventListener(e, n));
  }
  update(e, n) {
    this.cursorPos != null && n.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), n = !e.parent.inlineContent, r;
    if (n) {
      let a = e.nodeBefore, l = e.nodeAfter;
      if (a || l) {
        let c = this.editorView.nodeDOM(this.cursorPos - (a ? a.nodeSize : 0));
        if (c) {
          let u = c.getBoundingClientRect(), d = a ? u.bottom : u.top;
          a && l && (d = (d + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), r = { left: u.left, right: u.right, top: d - this.width / 2, bottom: d + this.width / 2 };
        }
      }
    }
    if (!r) {
      let a = this.editorView.coordsAtPos(this.cursorPos);
      r = { left: a.left - this.width / 2, right: a.left + this.width / 2, top: a.top, bottom: a.bottom };
    }
    let i = this.editorView.dom.offsetParent;
    this.element || (this.element = i.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", n), this.element.classList.toggle("prosemirror-dropcursor-inline", !n);
    let o, s;
    if (!i || i == document.body && getComputedStyle(i).position == "static")
      o = -pageXOffset, s = -pageYOffset;
    else {
      let a = i.getBoundingClientRect();
      o = a.left - i.scrollLeft, s = a.top - i.scrollTop;
    }
    this.element.style.left = r.left - o + "px", this.element.style.top = r.top - s + "px", this.element.style.width = r.right - r.left + "px", this.element.style.height = r.bottom - r.top + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let n = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), r = n && n.inside >= 0 && this.editorView.state.doc.nodeAt(n.inside), i = r && r.type.spec.disableDropCursor, o = typeof i == "function" ? i(this.editorView, n, e) : i;
    if (n && !o) {
      let s = n.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let a = nN(this.editorView.state.doc, s, this.editorView.dragging.slice);
        a != null && (s = a);
      }
      this.setCursor(s), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    (e.target == this.editorView.dom || !this.editorView.dom.contains(e.relatedTarget)) && this.setCursor(null);
  }
}
const hee = gt.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      dee(this.options)
    ];
  }
});
class st extends be {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, n) {
    let r = e.resolve(n.map(this.head));
    return st.valid(r) ? new st(r) : be.near(r);
  }
  content() {
    return ee.empty;
  }
  eq(e) {
    return e instanceof st && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new st(e.resolve(n.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new Lb(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let n = e.parent;
    if (n.isTextblock || !pee(e) || !mee(e))
      return !1;
    let r = n.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let i = n.contentMatchAt(e.index()).defaultType;
    return i && i.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, n, r = !1) {
    e: for (; ; ) {
      if (!r && st.valid(e))
        return e;
      let i = e.pos, o = null;
      for (let s = e.depth; ; s--) {
        let a = e.node(s);
        if (n > 0 ? e.indexAfter(s) < a.childCount : e.index(s) > 0) {
          o = a.child(n > 0 ? e.indexAfter(s) : e.index(s) - 1);
          break;
        } else if (s == 0)
          return null;
        i += n;
        let l = e.doc.resolve(i);
        if (st.valid(l))
          return l;
      }
      for (; ; ) {
        let s = n > 0 ? o.firstChild : o.lastChild;
        if (!s) {
          if (o.isAtom && !o.isText && !ye.isSelectable(o)) {
            e = e.doc.resolve(i + o.nodeSize * n), r = !1;
            continue e;
          }
          break;
        }
        o = s, i += n;
        let a = e.doc.resolve(i);
        if (st.valid(a))
          return a;
      }
      return null;
    }
  }
}
st.prototype.visible = !1;
st.findFrom = st.findGapCursorFrom;
be.jsonID("gapcursor", st);
class Lb {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new Lb(e.map(this.pos));
  }
  resolve(e) {
    let n = e.resolve(this.pos);
    return st.valid(n) ? new st(n) : be.near(n);
  }
}
function pee(t) {
  for (let e = t.depth; e >= 0; e--) {
    let n = t.index(e), r = t.node(e);
    if (n == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(n - 1); ; i = i.lastChild) {
      if (i.childCount == 0 && !i.inlineContent || i.isAtom || i.type.spec.isolating)
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function mee(t) {
  for (let e = t.depth; e >= 0; e--) {
    let n = t.indexAfter(e), r = t.node(e);
    if (n == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(n); ; i = i.firstChild) {
      if (i.childCount == 0 && !i.inlineContent || i.isAtom || i.type.spec.isolating)
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function gee() {
  return new Ge({
    props: {
      decorations: wee,
      createSelectionBetween(t, e, n) {
        return e.pos == n.pos && st.valid(n) ? new st(n) : null;
      },
      handleClick: bee,
      handleKeyDown: vee,
      handleDOMEvents: { beforeinput: yee }
    }
  });
}
const vee = Zv({
  ArrowLeft: Xl("horiz", -1),
  ArrowRight: Xl("horiz", 1),
  ArrowUp: Xl("vert", -1),
  ArrowDown: Xl("vert", 1)
});
function Xl(t, e) {
  const n = t == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(r, i, o) {
    let s = r.selection, a = e > 0 ? s.$to : s.$from, l = s.empty;
    if (s instanceof ge) {
      if (!o.endOfTextblock(n) || a.depth == 0)
        return !1;
      l = !1, a = r.doc.resolve(e > 0 ? a.after() : a.before());
    }
    let c = st.findGapCursorFrom(a, e, l);
    return c ? (i && i(r.tr.setSelection(new st(c))), !0) : !1;
  };
}
function bee(t, e, n) {
  if (!t || !t.editable)
    return !1;
  let r = t.state.doc.resolve(e);
  if (!st.valid(r))
    return !1;
  let i = t.posAtCoords({ left: n.clientX, top: n.clientY });
  return i && i.inside > -1 && ye.isSelectable(t.state.doc.nodeAt(i.inside)) ? !1 : (t.dispatch(t.state.tr.setSelection(new st(r))), !0);
}
function yee(t, e) {
  if (e.inputType != "insertCompositionText" || !(t.state.selection instanceof st))
    return !1;
  let { $from: n } = t.state.selection, r = n.parent.contentMatchAt(n.index()).findWrapping(t.state.schema.nodes.text);
  if (!r)
    return !1;
  let i = U.empty;
  for (let s = r.length - 1; s >= 0; s--)
    i = U.from(r[s].createAndFill(null, i));
  let o = t.state.tr.replace(n.pos, n.pos, new ee(i, 0, 0));
  return o.setSelection(ge.near(o.doc.resolve(n.pos + 1))), t.dispatch(o), !1;
}
function wee(t) {
  if (!(t.selection instanceof st))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", ot.create(t.doc, [jt.widget(t.selection.head, e, { key: "gapcursor" })]);
}
const xee = gt.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      gee()
    ];
  },
  extendNodeSchema(t) {
    var e;
    const n = {
      name: t.name,
      options: t.options,
      storage: t.storage
    };
    return {
      allowGapCursor: (e = Ae(ue(t, "allowGapCursor", n))) !== null && e !== void 0 ? e : null
    };
  }
}), kee = vt.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["br", Ke(this.options.HTMLAttributes, t)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: t, chain: e, state: n, editor: r }) => t.first([
        () => t.exitCode(),
        () => t.command(() => {
          const { selection: i, storedMarks: o } = n;
          if (i.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: s } = this.options, { splittableMarks: a } = r.extensionManager, l = o || i.$to.parentOffset && i.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: c, dispatch: u }) => {
            if (u && l && s) {
              const d = l.filter((f) => a.includes(f.type.name));
              c.ensureMarks(d);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), Cee = vt.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((t) => ({
      tag: `h${t}`,
      attrs: { level: t }
    }));
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(t.attrs.level) ? t.attrs.level : this.options.levels[0]}`, Ke(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.setNode(this.name, t) : !1,
      toggleHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.toggleNode(this.name, "paragraph", t) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((t, e) => ({
      ...t,
      [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((t) => t0({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${t}})\\s$`),
      type: this.type,
      getAttributes: {
        level: t
      }
    }));
  }
});
var Pu = 200, yt = function() {
};
yt.prototype.append = function(e) {
  return e.length ? (e = yt.from(e), !this.length && e || e.length < Pu && this.leafAppend(e) || this.length < Pu && e.leafPrepend(this) || this.appendInner(e)) : this;
};
yt.prototype.prepend = function(e) {
  return e.length ? yt.from(e).append(this) : this;
};
yt.prototype.appendInner = function(e) {
  return new See(this, e);
};
yt.prototype.slice = function(e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = this.length), e >= n ? yt.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, n));
};
yt.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
yt.prototype.forEach = function(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length), n <= r ? this.forEachInner(e, n, r, 0) : this.forEachInvertedInner(e, n, r, 0);
};
yt.prototype.map = function(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length);
  var i = [];
  return this.forEach(function(o, s) {
    return i.push(e(o, s));
  }, n, r), i;
};
yt.from = function(e) {
  return e instanceof yt ? e : e && e.length ? new cR(e) : yt.empty;
};
var cR = /* @__PURE__ */ function(t) {
  function e(r) {
    t.call(this), this.values = r;
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var n = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(i, o) {
    return i == 0 && o == this.length ? this : new e(this.values.slice(i, o));
  }, e.prototype.getInner = function(i) {
    return this.values[i];
  }, e.prototype.forEachInner = function(i, o, s, a) {
    for (var l = o; l < s; l++)
      if (i(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(i, o, s, a) {
    for (var l = o - 1; l >= s; l--)
      if (i(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(i) {
    if (this.length + i.length <= Pu)
      return new e(this.values.concat(i.flatten()));
  }, e.prototype.leafPrepend = function(i) {
    if (this.length + i.length <= Pu)
      return new e(i.flatten().concat(this.values));
  }, n.length.get = function() {
    return this.values.length;
  }, n.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, n), e;
}(yt);
yt.empty = new cR([]);
var See = /* @__PURE__ */ function(t) {
  function e(n, r) {
    t.call(this), this.left = n, this.right = r, this.length = n.length + r.length, this.depth = Math.max(n.depth, r.depth) + 1;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, e.prototype.forEachInner = function(r, i, o, s) {
    var a = this.left.length;
    if (i < a && this.left.forEachInner(r, i, Math.min(o, a), s) === !1 || o > a && this.right.forEachInner(r, Math.max(i - a, 0), Math.min(this.length, o) - a, s + a) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(r, i, o, s) {
    var a = this.left.length;
    if (i > a && this.right.forEachInvertedInner(r, i - a, Math.max(o, a) - a, s + a) === !1 || o < a && this.left.forEachInvertedInner(r, Math.min(i, a), o, s) === !1)
      return !1;
  }, e.prototype.sliceInner = function(r, i) {
    if (r == 0 && i == this.length)
      return this;
    var o = this.left.length;
    return i <= o ? this.left.slice(r, i) : r >= o ? this.right.slice(r - o, i - o) : this.left.slice(r, o).append(this.right.slice(0, i - o));
  }, e.prototype.leafAppend = function(r) {
    var i = this.right.leafAppend(r);
    if (i)
      return new e(this.left, i);
  }, e.prototype.leafPrepend = function(r) {
    var i = this.left.leafPrepend(r);
    if (i)
      return new e(i, this.right);
  }, e.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new e(this.left, new e(this.right, r)) : new e(this, r);
  }, e;
}(yt);
const Tee = 500;
class Vn {
  constructor(e, n) {
    this.items = e, this.eventCount = n;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, n) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let i, o;
    n && (i = this.remapping(r, this.items.length), o = i.maps.length);
    let s = e.tr, a, l, c = [], u = [];
    return this.items.forEach((d, f) => {
      if (!d.step) {
        i || (i = this.remapping(r, f + 1), o = i.maps.length), o--, u.push(d);
        return;
      }
      if (i) {
        u.push(new er(d.map));
        let h = d.step.map(i.slice(o)), p;
        h && s.maybeStep(h).doc && (p = s.mapping.maps[s.mapping.maps.length - 1], c.push(new er(p, void 0, void 0, c.length + u.length))), o--, p && i.appendMap(p, o);
      } else
        s.maybeStep(d.step);
      if (d.selection)
        return a = i ? d.selection.map(i.slice(o)) : d.selection, l = new Vn(this.items.slice(0, r).append(u.reverse().concat(c)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: s, selection: a };
  }
  // Create a new branch with the given transform added.
  addTransform(e, n, r, i) {
    let o = [], s = this.eventCount, a = this.items, l = !i && a.length ? a.get(a.length - 1) : null;
    for (let u = 0; u < e.steps.length; u++) {
      let d = e.steps[u].invert(e.docs[u]), f = new er(e.mapping.maps[u], d, n), h;
      (h = l && l.merge(f)) && (f = h, u ? o.pop() : a = a.slice(0, a.length - 1)), o.push(f), n && (s++, n = void 0), i || (l = f);
    }
    let c = s - r.depth;
    return c > Mee && (a = Eee(a, c), s -= c), new Vn(a.append(o), s);
  }
  remapping(e, n) {
    let r = new wa();
    return this.items.forEach((i, o) => {
      let s = i.mirrorOffset != null && o - i.mirrorOffset >= e ? r.maps.length - i.mirrorOffset : void 0;
      r.appendMap(i.map, s);
    }, e, n), r;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new Vn(this.items.append(e.map((n) => new er(n))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, n) {
    if (!this.eventCount)
      return this;
    let r = [], i = Math.max(0, this.items.length - n), o = e.mapping, s = e.steps.length, a = this.eventCount;
    this.items.forEach((f) => {
      f.selection && a--;
    }, i);
    let l = n;
    this.items.forEach((f) => {
      let h = o.getMirror(--l);
      if (h == null)
        return;
      s = Math.min(s, h);
      let p = o.maps[h];
      if (f.step) {
        let m = e.steps[h].invert(e.docs[h]), b = f.selection && f.selection.map(o.slice(l + 1, h));
        b && a++, r.push(new er(p, m, b));
      } else
        r.push(new er(p));
    }, i);
    let c = [];
    for (let f = n; f < s; f++)
      c.push(new er(o.maps[f]));
    let u = this.items.slice(0, i).append(c).append(r), d = new Vn(u, a);
    return d.emptyItemCount() > Tee && (d = d.compress(this.items.length - r.length)), d;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((n) => {
      n.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let n = this.remapping(0, e), r = n.maps.length, i = [], o = 0;
    return this.items.forEach((s, a) => {
      if (a >= e)
        i.push(s), s.selection && o++;
      else if (s.step) {
        let l = s.step.map(n.slice(r)), c = l && l.getMap();
        if (r--, c && n.appendMap(c, r), l) {
          let u = s.selection && s.selection.map(n.slice(r));
          u && o++;
          let d = new er(c.invert(), l, u), f, h = i.length - 1;
          (f = i.length && i[h].merge(d)) ? i[h] = f : i.push(d);
        }
      } else s.map && r--;
    }, this.items.length, 0), new Vn(yt.from(i.reverse()), o);
  }
}
Vn.empty = new Vn(yt.empty, 0);
function Eee(t, e) {
  let n;
  return t.forEach((r, i) => {
    if (r.selection && e-- == 0)
      return n = i, !1;
  }), t.slice(n);
}
class er {
  constructor(e, n, r, i) {
    this.map = e, this.step = n, this.selection = r, this.mirrorOffset = i;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let n = e.step.merge(this.step);
      if (n)
        return new er(n.getMap().invert(), n, this.selection);
    }
  }
}
class Xr {
  constructor(e, n, r, i, o) {
    this.done = e, this.undone = n, this.prevRanges = r, this.prevTime = i, this.prevComposition = o;
  }
}
const Mee = 20;
function Oee(t, e, n, r) {
  let i = n.getMeta(Qi), o;
  if (i)
    return i.historyState;
  n.getMeta(Ree) && (t = new Xr(t.done, t.undone, null, 0, -1));
  let s = n.getMeta("appendedTransaction");
  if (n.steps.length == 0)
    return t;
  if (s && s.getMeta(Qi))
    return s.getMeta(Qi).redo ? new Xr(t.done.addTransform(n, void 0, r, xc(e)), t.undone, RC(n.mapping.maps), t.prevTime, t.prevComposition) : new Xr(t.done, t.undone.addTransform(n, void 0, r, xc(e)), null, t.prevTime, t.prevComposition);
  if (n.getMeta("addToHistory") !== !1 && !(s && s.getMeta("addToHistory") === !1)) {
    let a = n.getMeta("composition"), l = t.prevTime == 0 || !s && t.prevComposition != a && (t.prevTime < (n.time || 0) - r.newGroupDelay || !Aee(n, t.prevRanges)), c = s ? Np(t.prevRanges, n.mapping) : RC(n.mapping.maps);
    return new Xr(t.done.addTransform(n, l ? e.selection.getBookmark() : void 0, r, xc(e)), Vn.empty, c, n.time, a ?? t.prevComposition);
  } else return (o = n.getMeta("rebased")) ? new Xr(t.done.rebased(n, o), t.undone.rebased(n, o), Np(t.prevRanges, n.mapping), t.prevTime, t.prevComposition) : new Xr(t.done.addMaps(n.mapping.maps), t.undone.addMaps(n.mapping.maps), Np(t.prevRanges, n.mapping), t.prevTime, t.prevComposition);
}
function Aee(t, e) {
  if (!e)
    return !1;
  if (!t.docChanged)
    return !0;
  let n = !1;
  return t.mapping.maps[0].forEach((r, i) => {
    for (let o = 0; o < e.length; o += 2)
      r <= e[o + 1] && i >= e[o] && (n = !0);
  }), n;
}
function RC(t) {
  let e = [];
  for (let n = t.length - 1; n >= 0 && e.length == 0; n--)
    t[n].forEach((r, i, o, s) => e.push(o, s));
  return e;
}
function Np(t, e) {
  if (!t)
    return null;
  let n = [];
  for (let r = 0; r < t.length; r += 2) {
    let i = e.map(t[r], 1), o = e.map(t[r + 1], -1);
    i <= o && n.push(i, o);
  }
  return n;
}
function Nee(t, e, n) {
  let r = xc(e), i = Qi.get(e).spec.config, o = (n ? t.undone : t.done).popEvent(e, r);
  if (!o)
    return null;
  let s = o.selection.resolve(o.transform.doc), a = (n ? t.done : t.undone).addTransform(o.transform, e.selection.getBookmark(), i, r), l = new Xr(n ? a : o.remaining, n ? o.remaining : a, null, 0, -1);
  return o.transform.setSelection(s).setMeta(Qi, { redo: n, historyState: l });
}
let Rp = !1, DC = null;
function xc(t) {
  let e = t.plugins;
  if (DC != e) {
    Rp = !1, DC = e;
    for (let n = 0; n < e.length; n++)
      if (e[n].spec.historyPreserveItems) {
        Rp = !0;
        break;
      }
  }
  return Rp;
}
const Qi = new tt("history"), Ree = new tt("closeHistory");
function Dee(t = {}) {
  return t = {
    depth: t.depth || 100,
    newGroupDelay: t.newGroupDelay || 500
  }, new Ge({
    key: Qi,
    state: {
      init() {
        return new Xr(Vn.empty, Vn.empty, null, 0, -1);
      },
      apply(e, n, r) {
        return Oee(n, r, e, t);
      }
    },
    config: t,
    props: {
      handleDOMEvents: {
        beforeinput(e, n) {
          let r = n.inputType, i = r == "historyUndo" ? dR : r == "historyRedo" ? fR : null;
          return i ? (n.preventDefault(), i(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
function uR(t, e) {
  return (n, r) => {
    let i = Qi.getState(n);
    if (!i || (t ? i.undone : i.done).eventCount == 0)
      return !1;
    if (r) {
      let o = Nee(i, n, t);
      o && r(e ? o.scrollIntoView() : o);
    }
    return !0;
  };
}
const dR = uR(!1, !0), fR = uR(!0, !0), Iee = gt.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: t, dispatch: e }) => dR(t, e),
      redo: () => ({ state: t, dispatch: e }) => fR(t, e)
    };
  },
  addProseMirrorPlugins() {
    return [
      Dee(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), _ee = vt.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["hr", Ke(this.options.HTMLAttributes, t)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: t, state: e }) => {
        const { selection: n } = e, { $from: r, $to: i } = n, o = t();
        return r.parentOffset === 0 ? o.insertContentAt({
          from: Math.max(r.pos - 1, 0),
          to: i.pos
        }, {
          type: this.name
        }) : y3(n) ? o.insertContentAt(i.pos, {
          type: this.name
        }) : o.insertContent({ type: this.name }), o.command(({ tr: s, dispatch: a }) => {
          var l;
          if (a) {
            const { $to: c } = s.selection, u = c.end();
            if (c.nodeAfter)
              c.nodeAfter.isTextblock ? s.setSelection(ge.create(s.doc, c.pos + 1)) : c.nodeAfter.isBlock ? s.setSelection(ye.create(s.doc, c.pos)) : s.setSelection(ge.create(s.doc, c.pos));
            else {
              const d = (l = c.parent.type.contentMatch.defaultType) === null || l === void 0 ? void 0 : l.create();
              d && (s.insert(u, d), s.setSelection(ge.create(s.doc, u + 1)));
            }
            s.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      w3({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), Pee = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, Lee = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, Fee = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, $ee = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, Bee = gn.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (t) => t.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["em", Ke(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: t }) => t.setMark(this.name),
      toggleItalic: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetItalic: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      ao({
        find: Pee,
        type: this.type
      }),
      ao({
        find: Fee,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      xi({
        find: Lee,
        type: this.type
      }),
      xi({
        find: $ee,
        type: this.type
      })
    ];
  }
}), Vee = "listItem", IC = "textStyle", _C = /^(\d+)\.\s$/, zee = vt.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (t) => t.hasAttribute("start") ? parseInt(t.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (t) => t.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    const { start: e, ...n } = t;
    return e === 1 ? ["ol", Ke(this.options.HTMLAttributes, n), 0] : ["ol", Ke(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(Vee, this.editor.getAttributes(IC)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let t = Ea({
      find: _C,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, n) => n.childCount + n.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = Ea({
      find: _C,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(IC) }),
      joinPredicate: (e, n) => n.childCount + n.attrs.start === +e[1],
      editor: this.editor
    })), [
      t
    ];
  }
}), hR = vt.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["p", Ke(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: t }) => t.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), Hee = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, Wee = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, jee = gn.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (t) => t.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["s", Ke(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: t }) => t.setMark(this.name),
      toggleStrike: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetStrike: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      ao({
        find: Hee,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      xi({
        find: Wee,
        type: this.type
      })
    ];
  }
}), Uee = vt.create({
  name: "text",
  group: "inline"
}), qee = gt.create({
  name: "starterKit",
  addExtensions() {
    const t = [];
    return this.options.bold !== !1 && t.push(tee.configure(this.options.bold)), this.options.blockquote !== !1 && t.push(ZQ.configure(this.options.blockquote)), this.options.bulletList !== !1 && t.push(ree.configure(this.options.bulletList)), this.options.code !== !1 && t.push(see.configure(this.options.code)), this.options.codeBlock !== !1 && t.push(cee.configure(this.options.codeBlock)), this.options.document !== !1 && t.push(uee.configure(this.options.document)), this.options.dropcursor !== !1 && t.push(hee.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && t.push(xee.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && t.push(kee.configure(this.options.hardBreak)), this.options.heading !== !1 && t.push(Cee.configure(this.options.heading)), this.options.history !== !1 && t.push(Iee.configure(this.options.history)), this.options.horizontalRule !== !1 && t.push(_ee.configure(this.options.horizontalRule)), this.options.italic !== !1 && t.push(Bee.configure(this.options.italic)), this.options.listItem !== !1 && t.push(X3.configure(this.options.listItem)), this.options.orderedList !== !1 && t.push(zee.configure(this.options.orderedList)), this.options.paragraph !== !1 && t.push(hR.configure(this.options.paragraph)), this.options.strike !== !1 && t.push(jee.configure(this.options.strike)), this.options.text !== !1 && t.push(Uee.configure(this.options.text)), t;
  }
});
function pR(t) {
  const { state: e, transaction: n } = t;
  let { selection: r } = n, { doc: i } = n, { storedMarks: o } = n;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return o;
    },
    get selection() {
      return r;
    },
    get doc() {
      return i;
    },
    get tr() {
      return r = n.selection, i = n.doc, o = n.storedMarks, n;
    }
  };
}
class Kee {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: n, state: r } = this, { view: i } = n, { tr: o } = r, s = this.buildProps(o);
    return Object.fromEntries(Object.entries(e).map(([a, l]) => [a, (...u) => {
      const d = l(...u)(s);
      return !o.getMeta("preventDispatch") && !this.hasCustomState && i.dispatch(o), d;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, n = !0) {
    const { rawCommands: r, editor: i, state: o } = this, { view: s } = i, a = [], l = !!e, c = e || o.tr, u = () => (!l && n && !c.getMeta("preventDispatch") && !this.hasCustomState && s.dispatch(c), a.every((f) => f === !0)), d = {
      ...Object.fromEntries(Object.entries(r).map(([f, h]) => [f, (...m) => {
        const b = this.buildProps(c, n), y = h(...m)(b);
        return a.push(y), d;
      }])),
      run: u
    };
    return d;
  }
  createCan(e) {
    const { rawCommands: n, state: r } = this, i = !1, o = e || r.tr, s = this.buildProps(o, i);
    return {
      ...Object.fromEntries(Object.entries(n).map(([l, c]) => [l, (...u) => c(...u)({ ...s, dispatch: void 0 })])),
      chain: () => this.createChain(o, i)
    };
  }
  buildProps(e, n = !0) {
    const { rawCommands: r, editor: i, state: o } = this, { view: s } = i, a = {
      tr: e,
      editor: i,
      view: s,
      state: pR({
        state: o,
        transaction: e
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(e, n),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([l, c]) => [l, (...u) => c(...u)(a)]));
      }
    };
    return a;
  }
}
function Hn(t, e, n) {
  return t.config[e] === void 0 && t.parent ? Hn(t.parent, e, n) : typeof t.config[e] == "function" ? t.config[e].bind({
    ...n,
    parent: t.parent ? Hn(t.parent, e, n) : null
  }) : t.config[e];
}
function Gee(t) {
  const e = t.filter((i) => i.type === "extension"), n = t.filter((i) => i.type === "node"), r = t.filter((i) => i.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: n,
    markExtensions: r
  };
}
function Ft(t, e) {
  if (typeof t == "string") {
    if (!e.nodes[t])
      throw Error(`There is no node type named '${t}'. Maybe you forgot to add the extension?`);
    return e.nodes[t];
  }
  return t;
}
function Yee(...t) {
  return t.filter((e) => !!e).reduce((e, n) => {
    const r = { ...e };
    return Object.entries(n).forEach(([i, o]) => {
      if (!r[i]) {
        r[i] = o;
        return;
      }
      if (i === "class") {
        const a = o ? String(o).split(" ") : [], l = r[i] ? r[i].split(" ") : [], c = a.filter((u) => !l.includes(u));
        r[i] = [...l, ...c].join(" ");
      } else if (i === "style") {
        const a = o ? o.split(";").map((u) => u.trim()).filter(Boolean) : [], l = r[i] ? r[i].split(";").map((u) => u.trim()).filter(Boolean) : [], c = /* @__PURE__ */ new Map();
        l.forEach((u) => {
          const [d, f] = u.split(":").map((h) => h.trim());
          c.set(d, f);
        }), a.forEach((u) => {
          const [d, f] = u.split(":").map((h) => h.trim());
          c.set(d, f);
        }), r[i] = Array.from(c.entries()).map(([u, d]) => `${u}: ${d}`).join("; ");
      } else
        r[i] = o;
    }), r;
  }, {});
}
function Zee(t) {
  return typeof t == "function";
}
function sr(t, e = void 0, ...n) {
  return Zee(t) ? e ? t.bind(e)(...n) : t(...n) : t;
}
function Jee(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}
class Xee {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
function Qee(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function Ql(t) {
  return Qee(t) !== "Object" ? !1 : t.constructor === Object && Object.getPrototypeOf(t) === Object.prototype;
}
function Fb(t, e) {
  const n = { ...t };
  return Ql(t) && Ql(e) && Object.keys(e).forEach((r) => {
    Ql(e[r]) && Ql(t[r]) ? n[r] = Fb(t[r], e[r]) : n[r] = e[r];
  }), n;
}
class Yn {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = sr(Hn(this, "addOptions", {
      name: this.name
    }))), this.storage = sr(Hn(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Yn(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Fb(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new Yn({ ...this.config, ...e });
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = sr(Hn(n, "addOptions", {
      name: n.name
    })), n.storage = sr(Hn(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
}
function ete(t, e, n) {
  const { from: r, to: i } = e, { blockSeparator: o = `

`, textSerializers: s = {} } = n || {};
  let a = "";
  return t.nodesBetween(r, i, (l, c, u, d) => {
    var f;
    l.isBlock && c > r && (a += o);
    const h = s == null ? void 0 : s[l.type.name];
    if (h)
      return u && (a += h({
        node: l,
        pos: c,
        parent: u,
        index: d,
        range: e
      })), !1;
    l.isText && (a += (f = l == null ? void 0 : l.text) === null || f === void 0 ? void 0 : f.slice(Math.max(r, c) - c, i - c));
  }), a;
}
function tte(t) {
  return Object.fromEntries(Object.entries(t.nodes).filter(([, e]) => e.spec.toText).map(([e, n]) => [e, n.spec.toText]));
}
Yn.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Ge({
        key: new tt("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: t } = this, { state: e, schema: n } = t, { doc: r, selection: i } = e, { ranges: o } = i, s = Math.min(...o.map((u) => u.$from.pos)), a = Math.max(...o.map((u) => u.$to.pos)), l = tte(n);
            return ete(r, { from: s, to: a }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
});
const nte = () => ({ editor: t, view: e }) => (requestAnimationFrame(() => {
  var n;
  t.isDestroyed || (e.dom.blur(), (n = window == null ? void 0 : window.getSelection()) === null || n === void 0 || n.removeAllRanges());
}), !0), rte = (t = !1) => ({ commands: e }) => e.setContent("", t), ite = () => ({ state: t, tr: e, dispatch: n }) => {
  const { selection: r } = e, { ranges: i } = r;
  return n && i.forEach(({ $from: o, $to: s }) => {
    t.doc.nodesBetween(o.pos, s.pos, (a, l) => {
      if (a.type.isText)
        return;
      const { doc: c, mapping: u } = e, d = c.resolve(u.map(l)), f = c.resolve(u.map(l + a.nodeSize)), h = d.blockRange(f);
      if (!h)
        return;
      const p = bo(h);
      if (a.type.isTextblock) {
        const { defaultType: m } = d.parent.contentMatchAt(d.index());
        e.setNodeMarkup(h.start, m);
      }
      (p || p === 0) && e.lift(h, p);
    });
  }), !0;
}, ote = (t) => (e) => t(e), ste = () => ({ state: t, dispatch: e }) => ob(t, e), ate = (t, e) => ({ editor: n, tr: r }) => {
  const { state: i } = n, o = i.doc.slice(t.from, t.to);
  r.deleteRange(t.from, t.to);
  const s = r.mapping.map(e);
  return r.insert(s, o.content), r.setSelection(new ge(r.doc.resolve(s - 1))), !0;
}, lte = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, r = n.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const i = t.selection.$anchor;
  for (let o = i.depth; o > 0; o -= 1)
    if (i.node(o).type === r.type) {
      if (e) {
        const a = i.before(o), l = i.after(o);
        t.delete(a, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, cte = (t) => ({ tr: e, state: n, dispatch: r }) => {
  const i = Ft(t, n.schema), o = e.selection.$anchor;
  for (let s = o.depth; s > 0; s -= 1)
    if (o.node(s).type === i) {
      if (r) {
        const l = o.before(s), c = o.after(s);
        e.delete(l, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, ute = (t) => ({ tr: e, dispatch: n }) => {
  const { from: r, to: i } = t;
  return n && e.delete(r, i), !0;
}, dte = () => ({ state: t, dispatch: e }) => Dd(t, e), fte = () => ({ commands: t }) => t.keyboardShortcut("Enter"), hte = () => ({ state: t, dispatch: e }) => JN(t, e);
function Lu(t, e, n = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((i) => n.strict ? e[i] === t[i] : Jee(e[i]) ? e[i].test(t[i]) : e[i] === t[i]) : !0;
}
function mR(t, e, n = {}) {
  return t.find((r) => r.type === e && Lu(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(n).map((i) => [i, r.attrs[i]])),
    n
  ));
}
function PC(t, e, n = {}) {
  return !!mR(t, e, n);
}
function gR(t, e, n) {
  var r;
  if (!t || !e)
    return;
  let i = t.parent.childAfter(t.parentOffset);
  if ((!i.node || !i.node.marks.some((u) => u.type === e)) && (i = t.parent.childBefore(t.parentOffset)), !i.node || !i.node.marks.some((u) => u.type === e) || (n = n || ((r = i.node.marks[0]) === null || r === void 0 ? void 0 : r.attrs), !mR([...i.node.marks], e, n)))
    return;
  let s = i.index, a = t.start() + i.offset, l = s + 1, c = a + i.node.nodeSize;
  for (; s > 0 && PC([...t.parent.child(s - 1).marks], e, n); )
    s -= 1, a -= t.parent.child(s).nodeSize;
  for (; l < t.parent.childCount && PC([...t.parent.child(l).marks], e, n); )
    c += t.parent.child(l).nodeSize, l += 1;
  return {
    from: a,
    to: c
  };
}
function Ri(t, e) {
  if (typeof t == "string") {
    if (!e.marks[t])
      throw Error(`There is no mark type named '${t}'. Maybe you forgot to add the extension?`);
    return e.marks[t];
  }
  return t;
}
const pte = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  const o = Ri(t, r.schema), { doc: s, selection: a } = n, { $from: l, from: c, to: u } = a;
  if (i) {
    const d = gR(l, o, e);
    if (d && d.from <= c && d.to >= u) {
      const f = ge.create(s, d.from, d.to);
      n.setSelection(f);
    }
  }
  return !0;
}, mte = (t) => (e) => {
  const n = typeof t == "function" ? t(e) : t;
  for (let r = 0; r < n.length; r += 1)
    if (n[r](e))
      return !0;
  return !1;
};
function vR(t) {
  return t instanceof ge;
}
function qi(t = 0, e = 0, n = 0) {
  return Math.min(Math.max(t, e), n);
}
function gte(t, e = null) {
  if (!e)
    return null;
  const n = be.atStart(t), r = be.atEnd(t);
  if (e === "start" || e === !0)
    return n;
  if (e === "end")
    return r;
  const i = n.from, o = r.to;
  return e === "all" ? ge.create(t, qi(0, i, o), qi(t.content.size, i, o)) : ge.create(t, qi(e, i, o), qi(e, i, o));
}
const vte = (t = null, e = {}) => ({ editor: n, view: r, tr: i, dispatch: o }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const s = () => {
    r.dom.focus(), requestAnimationFrame(() => {
      n.isDestroyed || (r.focus(), e != null && e.scrollIntoView && n.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && t === null || t === !1)
    return !0;
  if (o && t === null && !vR(n.state.selection))
    return s(), !0;
  const a = gte(i.doc, t) || n.state.selection, l = n.state.selection.eq(a);
  return o && (l || i.setSelection(a), l && i.storedMarks && i.setStoredMarks(i.storedMarks), s()), !0;
}, bte = (t, e) => (n) => t.every((r, i) => e(r, { ...n, index: i })), yte = (t, e) => ({ tr: n, commands: r }) => r.insertContentAt({ from: n.selection.from, to: n.selection.to }, t, e), bR = (t) => {
  const e = t.childNodes;
  for (let n = e.length - 1; n >= 0; n -= 1) {
    const r = e[n];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? t.removeChild(r) : r.nodeType === 1 && bR(r);
  }
  return t;
};
function ec(t) {
  const e = `<body>${t}</body>`, n = new window.DOMParser().parseFromString(e, "text/html").body;
  return bR(n);
}
function Fu(t, e, n) {
  if (t instanceof Ir || t instanceof U)
    return t;
  n = {
    slice: !0,
    parseOptions: {},
    ...n
  };
  const r = typeof t == "object" && t !== null, i = typeof t == "string";
  if (r)
    try {
      if (Array.isArray(t) && t.length > 0)
        return U.fromArray(t.map((a) => e.nodeFromJSON(a)));
      const s = e.nodeFromJSON(t);
      return n.errorOnInvalidContent && s.check(), s;
    } catch (o) {
      if (n.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: o });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", t, "Error:", o), Fu("", e, n);
    }
  if (i) {
    if (n.errorOnInvalidContent) {
      let s = !1, a = "";
      const l = new Pv({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (s = !0, a = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (n.slice ? Wn.fromSchema(l).parseSlice(ec(t), n.parseOptions) : Wn.fromSchema(l).parse(ec(t), n.parseOptions), n.errorOnInvalidContent && s)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${a}`) });
    }
    const o = Wn.fromSchema(e);
    return n.slice ? o.parseSlice(ec(t), n.parseOptions).content : o.parse(ec(t), n.parseOptions);
  }
  return Fu("", e, n);
}
function wte(t, e, n) {
  const r = t.steps.length - 1;
  if (r < e)
    return;
  const i = t.steps[r];
  if (!(i instanceof ht || i instanceof pt))
    return;
  const o = t.mapping.maps[r];
  let s = 0;
  o.forEach((a, l, c, u) => {
    s === 0 && (s = u);
  }), t.setSelection(be.near(t.doc.resolve(s), n));
}
const xte = (t) => !("type" in t), kte = (t, e, n) => ({ tr: r, dispatch: i, editor: o }) => {
  var s;
  if (i) {
    n = {
      parseOptions: o.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...n
    };
    let a;
    try {
      a = Fu(e, o.schema, {
        parseOptions: {
          preserveWhitespace: "full",
          ...n.parseOptions
        },
        errorOnInvalidContent: (s = n.errorOnInvalidContent) !== null && s !== void 0 ? s : o.options.enableContentCheck
      });
    } catch (p) {
      return o.emit("contentError", {
        editor: o,
        error: p,
        disableCollaboration: () => {
          o.storage.collaboration && (o.storage.collaboration.isDisabled = !0);
        }
      }), !1;
    }
    let { from: l, to: c } = typeof t == "number" ? { from: t, to: t } : { from: t.from, to: t.to }, u = !0, d = !0;
    if ((xte(a) ? a : [a]).forEach((p) => {
      p.check(), u = u ? p.isText && p.marks.length === 0 : !1, d = d ? p.isBlock : !1;
    }), l === c && d) {
      const { parent: p } = r.doc.resolve(l);
      p.isTextblock && !p.type.spec.code && !p.childCount && (l -= 1, c += 1);
    }
    let h;
    if (u) {
      if (Array.isArray(e))
        h = e.map((p) => p.text || "").join("");
      else if (e instanceof U) {
        let p = "";
        e.forEach((m) => {
          m.text && (p += m.text);
        }), h = p;
      } else typeof e == "object" && e && e.text ? h = e.text : h = e;
      r.insertText(h, l, c);
    } else
      h = a, r.replaceWith(l, c, h);
    n.updateSelection && wte(r, r.steps.length - 1, -1), n.applyInputRules && r.setMeta("applyInputRules", { from: l, text: h }), n.applyPasteRules && r.setMeta("applyPasteRules", { from: l, text: h });
  }
  return !0;
}, Cte = () => ({ state: t, dispatch: e }) => GN(t, e), Ste = () => ({ state: t, dispatch: e }) => YN(t, e), Tte = () => ({ state: t, dispatch: e }) => Jv(t, e), Ete = () => ({ state: t, dispatch: e }) => eb(t, e), Mte = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = Ts(t.doc, t.selection.$from.pos, -1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, Ote = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = Ts(t.doc, t.selection.$from.pos, 1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, Ate = () => ({ state: t, dispatch: e }) => jN(t, e), Nte = () => ({ state: t, dispatch: e }) => UN(t, e);
function yR() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function wR() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function Rte(t) {
  const e = t.split(/-(?!$)/);
  let n = e[e.length - 1];
  n === "Space" && (n = " ");
  let r, i, o, s;
  for (let a = 0; a < e.length - 1; a += 1) {
    const l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      s = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      o = !0;
    else if (/^mod$/i.test(l))
      yR() || wR() ? s = !0 : i = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return r && (n = `Alt-${n}`), i && (n = `Ctrl-${n}`), s && (n = `Meta-${n}`), o && (n = `Shift-${n}`), n;
}
const Dte = (t) => ({ editor: e, view: n, tr: r, dispatch: i }) => {
  const o = Rte(t).split(/-(?!$)/), s = o.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), a = new KeyboardEvent("keydown", {
    key: s === "Space" ? " " : s,
    altKey: o.includes("Alt"),
    ctrlKey: o.includes("Ctrl"),
    metaKey: o.includes("Meta"),
    shiftKey: o.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    n.someProp("handleKeyDown", (c) => c(n, a));
  });
  return l == null || l.steps.forEach((c) => {
    const u = c.map(r.mapping);
    u && i && r.maybeStep(u);
  }), !0;
};
function $b(t, e, n = {}) {
  const { from: r, to: i, empty: o } = t.selection, s = e ? Ft(e, t.schema) : null, a = [];
  t.doc.nodesBetween(r, i, (d, f) => {
    if (d.isText)
      return;
    const h = Math.max(r, f), p = Math.min(i, f + d.nodeSize);
    a.push({
      node: d,
      from: h,
      to: p
    });
  });
  const l = i - r, c = a.filter((d) => s ? s.name === d.node.type.name : !0).filter((d) => Lu(d.node.attrs, n, { strict: !1 }));
  return o ? !!c.length : c.reduce((d, f) => d + f.to - f.from, 0) >= l;
}
const Ite = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const i = Ft(t, n.schema);
  return $b(n, i, e) ? ZN(n, r) : !1;
}, _te = () => ({ state: t, dispatch: e }) => sb(t, e), Pte = (t) => ({ state: e, dispatch: n }) => {
  const r = Ft(t, e.schema);
  return o3(r)(e, n);
}, Lte = () => ({ state: t, dispatch: e }) => rb(t, e);
function xR(t, e) {
  return e.nodes[t] ? "node" : e.marks[t] ? "mark" : null;
}
function LC(t, e) {
  const n = typeof e == "string" ? [e] : e;
  return Object.keys(t).reduce((r, i) => (n.includes(i) || (r[i] = t[i]), r), {});
}
const Fte = (t, e) => ({ tr: n, state: r, dispatch: i }) => {
  let o = null, s = null;
  const a = xR(typeof t == "string" ? t : t.name, r.schema);
  return a ? (a === "node" && (o = Ft(t, r.schema)), a === "mark" && (s = Ri(t, r.schema)), i && n.selection.ranges.forEach((l) => {
    r.doc.nodesBetween(l.$from.pos, l.$to.pos, (c, u) => {
      o && o === c.type && n.setNodeMarkup(u, void 0, LC(c.attrs, e)), s && c.marks.length && c.marks.forEach((d) => {
        s === d.type && n.addMark(u, u + c.nodeSize, s.create(LC(d.attrs, e)));
      });
    });
  }), !0) : !1;
}, $te = () => ({ tr: t, dispatch: e }) => (e && t.scrollIntoView(), !0), Bte = () => ({ tr: t, dispatch: e }) => {
  if (e) {
    const n = new en(t.doc);
    t.setSelection(n);
  }
  return !0;
}, Vte = () => ({ state: t, dispatch: e }) => Xv(t, e), zte = () => ({ state: t, dispatch: e }) => tb(t, e), Hte = () => ({ state: t, dispatch: e }) => XN(t, e), Wte = () => ({ state: t, dispatch: e }) => n3(t, e), jte = () => ({ state: t, dispatch: e }) => t3(t, e);
function Ute(t, e, n = {}, r = {}) {
  return Fu(t, e, {
    slice: !1,
    parseOptions: n,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
const qte = (t, e = !1, n = {}, r = {}) => ({ editor: i, tr: o, dispatch: s, commands: a }) => {
  var l, c;
  const { doc: u } = o;
  if (n.preserveWhitespace !== "full") {
    const d = Ute(t, i.schema, n, {
      errorOnInvalidContent: (l = r.errorOnInvalidContent) !== null && l !== void 0 ? l : i.options.enableContentCheck
    });
    return s && o.replaceWith(0, u.content.size, d).setMeta("preventUpdate", !e), !0;
  }
  return s && o.setMeta("preventUpdate", !e), a.insertContentAt({ from: 0, to: u.content.size }, t, {
    parseOptions: n,
    errorOnInvalidContent: (c = r.errorOnInvalidContent) !== null && c !== void 0 ? c : i.options.enableContentCheck
  });
};
function Kte(t, e) {
  const n = Ri(e, t.schema), { from: r, to: i, empty: o } = t.selection, s = [];
  o ? (t.storedMarks && s.push(...t.storedMarks), s.push(...t.selection.$head.marks())) : t.doc.nodesBetween(r, i, (l) => {
    s.push(...l.marks);
  });
  const a = s.find((l) => l.type.name === n.name);
  return a ? { ...a.attrs } : {};
}
function Gte(t) {
  for (let e = 0; e < t.edgeCount; e += 1) {
    const { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function Yte(t, e) {
  for (let n = t.depth; n > 0; n -= 1) {
    const r = t.node(n);
    if (e(r))
      return {
        pos: n > 0 ? t.before(n) : 0,
        start: t.start(n),
        depth: n,
        node: r
      };
  }
}
function Bb(t) {
  return (e) => Yte(e.$from, t);
}
function kc(t, e, n) {
  return Object.fromEntries(Object.entries(n).filter(([r]) => {
    const i = t.find((o) => o.type === e && o.name === r);
    return i ? i.attribute.keepOnSplit : !1;
  }));
}
function Zte(t, e, n = {}) {
  const { empty: r, ranges: i } = t.selection, o = e ? Ri(e, t.schema) : null;
  if (r)
    return !!(t.storedMarks || t.selection.$from.marks()).filter((d) => o ? o.name === d.type.name : !0).find((d) => Lu(d.attrs, n, { strict: !1 }));
  let s = 0;
  const a = [];
  if (i.forEach(({ $from: d, $to: f }) => {
    const h = d.pos, p = f.pos;
    t.doc.nodesBetween(h, p, (m, b) => {
      if (!m.isText && !m.marks.length)
        return;
      const y = Math.max(h, b), k = Math.min(p, b + m.nodeSize), C = k - y;
      s += C, a.push(...m.marks.map((x) => ({
        mark: x,
        from: y,
        to: k
      })));
    });
  }), s === 0)
    return !1;
  const l = a.filter((d) => o ? o.name === d.mark.type.name : !0).filter((d) => Lu(d.mark.attrs, n, { strict: !1 })).reduce((d, f) => d + f.to - f.from, 0), c = a.filter((d) => o ? d.mark.type !== o && d.mark.type.excludes(o) : !0).reduce((d, f) => d + f.to - f.from, 0);
  return (l > 0 ? l + c : l) >= s;
}
function FC(t, e) {
  const { nodeExtensions: n } = Gee(e), r = n.find((s) => s.name === t);
  if (!r)
    return !1;
  const i = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, o = sr(Hn(r, "group", i));
  return typeof o != "string" ? !1 : o.split(" ").includes("list");
}
function kR(t, { checkChildren: e = !0, ignoreWhitespace: n = !1 } = {}) {
  var r;
  if (n) {
    if (t.type.name === "hardBreak")
      return !0;
    if (t.isText)
      return /^\s*$/m.test((r = t.text) !== null && r !== void 0 ? r : "");
  }
  if (t.isText)
    return !t.text;
  if (t.isAtom || t.isLeaf)
    return !1;
  if (t.content.childCount === 0)
    return !0;
  if (e) {
    let i = !0;
    return t.content.forEach((o) => {
      i !== !1 && (kR(o, { ignoreWhitespace: n, checkChildren: e }) || (i = !1));
    }), i;
  }
  return !1;
}
function Jte(t, e, n) {
  var r;
  const { selection: i } = e;
  let o = null;
  if (vR(i) && (o = i.$cursor), o) {
    const a = (r = t.storedMarks) !== null && r !== void 0 ? r : o.marks();
    return !!n.isInSet(a) || !a.some((l) => l.type.excludes(n));
  }
  const { ranges: s } = i;
  return s.some(({ $from: a, $to: l }) => {
    let c = a.depth === 0 ? t.doc.inlineContent && t.doc.type.allowsMarkType(n) : !1;
    return t.doc.nodesBetween(a.pos, l.pos, (u, d, f) => {
      if (c)
        return !1;
      if (u.isInline) {
        const h = !f || f.type.allowsMarkType(n), p = !!n.isInSet(u.marks) || !u.marks.some((m) => m.type.excludes(n));
        c = h && p;
      }
      return !c;
    }), c;
  });
}
const Xte = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  const { selection: o } = n, { empty: s, ranges: a } = o, l = Ri(t, r.schema);
  if (i)
    if (s) {
      const c = Kte(r, l);
      n.addStoredMark(l.create({
        ...c,
        ...e
      }));
    } else
      a.forEach((c) => {
        const u = c.$from.pos, d = c.$to.pos;
        r.doc.nodesBetween(u, d, (f, h) => {
          const p = Math.max(h, u), m = Math.min(h + f.nodeSize, d);
          f.marks.find((y) => y.type === l) ? f.marks.forEach((y) => {
            l === y.type && n.addMark(p, m, l.create({
              ...y.attrs,
              ...e
            }));
          }) : n.addMark(p, m, l.create(e));
        });
      });
  return Jte(r, n, l);
}, Qte = (t, e) => ({ tr: n }) => (n.setMeta(t, e), !0), ene = (t, e = {}) => ({ state: n, dispatch: r, chain: i }) => {
  const o = Ft(t, n.schema);
  let s;
  return n.selection.$anchor.sameParent(n.selection.$head) && (s = n.selection.$anchor.parent.attrs), o.isTextblock ? i().command(({ commands: a }) => iu(o, { ...s, ...e })(n) ? !0 : a.clearNodes()).command(({ state: a }) => iu(o, { ...s, ...e })(a, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, tne = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, i = qi(t, 0, r.content.size), o = ye.create(r, i);
    e.setSelection(o);
  }
  return !0;
}, nne = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, { from: i, to: o } = typeof t == "number" ? { from: t, to: t } : t, s = ge.atStart(r).from, a = ge.atEnd(r).to, l = qi(i, s, a), c = qi(o, s, a), u = ge.create(r, l, c);
    e.setSelection(u);
  }
  return !0;
}, rne = (t) => ({ state: e, dispatch: n }) => {
  const r = Ft(t, e.schema);
  return s3(r)(e, n);
};
function $C(t, e) {
  const n = t.storedMarks || t.selection.$to.parentOffset && t.selection.$from.marks();
  if (n) {
    const r = n.filter((i) => e == null ? void 0 : e.includes(i.type.name));
    t.tr.ensureMarks(r);
  }
}
const ine = ({ keepMarks: t = !0 } = {}) => ({ tr: e, state: n, dispatch: r, editor: i }) => {
  const { selection: o, doc: s } = e, { $from: a, $to: l } = o, c = i.extensionManager.attributes, u = kc(c, a.node().type.name, a.node().attrs);
  if (o instanceof ye && o.node.isBlock)
    return !a.parentOffset || !pn(s, a.pos) ? !1 : (r && (t && $C(n, i.extensionManager.splittableMarks), e.split(a.pos).scrollIntoView()), !0);
  if (!a.parent.isBlock)
    return !1;
  const d = l.parentOffset === l.parent.content.size, f = a.depth === 0 ? void 0 : Gte(a.node(-1).contentMatchAt(a.indexAfter(-1)));
  let h = d && f ? [
    {
      type: f,
      attrs: u
    }
  ] : void 0, p = pn(e.doc, e.mapping.map(a.pos), 1, h);
  if (!h && !p && pn(e.doc, e.mapping.map(a.pos), 1, f ? [{ type: f }] : void 0) && (p = !0, h = f ? [
    {
      type: f,
      attrs: u
    }
  ] : void 0), r) {
    if (p && (o instanceof ge && e.deleteSelection(), e.split(e.mapping.map(a.pos), 1, h), f && !d && !a.parentOffset && a.parent.type !== f)) {
      const m = e.mapping.map(a.before()), b = e.doc.resolve(m);
      a.node(-1).canReplaceWith(b.index(), b.index() + 1, f) && e.setNodeMarkup(e.mapping.map(a.before()), f);
    }
    t && $C(n, i.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return p;
}, one = (t, e = {}) => ({ tr: n, state: r, dispatch: i, editor: o }) => {
  var s;
  const a = Ft(t, r.schema), { $from: l, $to: c } = r.selection, u = r.selection.node;
  if (u && u.isBlock || l.depth < 2 || !l.sameParent(c))
    return !1;
  const d = l.node(-1);
  if (d.type !== a)
    return !1;
  const f = o.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== a || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (i) {
      let y = U.empty;
      const k = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let M = l.depth - k; M >= l.depth - 3; M -= 1)
        y = U.from(l.node(M).copy(y));
      const C = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, x = {
        ...kc(f, l.node().type.name, l.node().attrs),
        ...e
      }, S = ((s = a.contentMatch.defaultType) === null || s === void 0 ? void 0 : s.createAndFill(x)) || void 0;
      y = y.append(U.from(a.createAndFill(null, S) || void 0));
      const T = l.before(l.depth - (k - 1));
      n.replace(T, l.after(-C), new ee(y, 4 - k, 0));
      let E = -1;
      n.doc.nodesBetween(T, n.doc.content.size, (M, O) => {
        if (E > -1)
          return !1;
        M.isTextblock && M.content.size === 0 && (E = O + 1);
      }), E > -1 && n.setSelection(ge.near(n.doc.resolve(E))), n.scrollIntoView();
    }
    return !0;
  }
  const h = c.pos === l.end() ? d.contentMatchAt(0).defaultType : null, p = {
    ...kc(f, d.type.name, d.attrs),
    ...e
  }, m = {
    ...kc(f, l.node().type.name, l.node().attrs),
    ...e
  };
  n.delete(l.pos, c.pos);
  const b = h ? [
    { type: a, attrs: p },
    { type: h, attrs: m }
  ] : [{ type: a, attrs: p }];
  if (!pn(n.doc, l.pos, 2))
    return !1;
  if (i) {
    const { selection: y, storedMarks: k } = r, { splittableMarks: C } = o.extensionManager, x = k || y.$to.parentOffset && y.$from.marks();
    if (n.split(l.pos, 2, b).scrollIntoView(), !x || !i)
      return !0;
    const S = x.filter((T) => C.includes(T.type.name));
    n.ensureMarks(S);
  }
  return !0;
}, Dp = (t, e) => {
  const n = Bb((s) => s.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (r === void 0)
    return !0;
  const i = t.doc.nodeAt(r);
  return n.node.type === (i == null ? void 0 : i.type) && mr(t.doc, n.pos) && t.join(n.pos), !0;
}, Ip = (t, e) => {
  const n = Bb((s) => s.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(n.start).after(n.depth);
  if (r === void 0)
    return !0;
  const i = t.doc.nodeAt(r);
  return n.node.type === (i == null ? void 0 : i.type) && mr(t.doc, r) && t.join(r), !0;
}, sne = (t, e, n, r = {}) => ({ editor: i, tr: o, state: s, dispatch: a, chain: l, commands: c, can: u }) => {
  const { extensions: d, splittableMarks: f } = i.extensionManager, h = Ft(t, s.schema), p = Ft(e, s.schema), { selection: m, storedMarks: b } = s, { $from: y, $to: k } = m, C = y.blockRange(k), x = b || m.$to.parentOffset && m.$from.marks();
  if (!C)
    return !1;
  const S = Bb((T) => FC(T.type.name, d))(m);
  if (C.depth >= 1 && S && C.depth - S.depth <= 1) {
    if (S.node.type === h)
      return c.liftListItem(p);
    if (FC(S.node.type.name, d) && h.validContent(S.node.content) && a)
      return l().command(() => (o.setNodeMarkup(S.pos, h), !0)).command(() => Dp(o, h)).command(() => Ip(o, h)).run();
  }
  return !n || !x || !a ? l().command(() => u().wrapInList(h, r) ? !0 : c.clearNodes()).wrapInList(h, r).command(() => Dp(o, h)).command(() => Ip(o, h)).run() : l().command(() => {
    const T = u().wrapInList(h, r), E = x.filter((M) => f.includes(M.type.name));
    return o.ensureMarks(E), T ? !0 : c.clearNodes();
  }).wrapInList(h, r).command(() => Dp(o, h)).command(() => Ip(o, h)).run();
}, ane = (t, e = {}, n = {}) => ({ state: r, commands: i }) => {
  const { extendEmptyMarkRange: o = !1 } = n, s = Ri(t, r.schema);
  return Zte(r, s, e) ? i.unsetMark(s, { extendEmptyMarkRange: o }) : i.setMark(s, e);
}, lne = (t, e, n = {}) => ({ state: r, commands: i }) => {
  const o = Ft(t, r.schema), s = Ft(e, r.schema), a = $b(r, o, n);
  let l;
  return r.selection.$anchor.sameParent(r.selection.$head) && (l = r.selection.$anchor.parent.attrs), a ? i.setNode(s, l) : i.setNode(o, { ...l, ...n });
}, cne = (t, e = {}) => ({ state: n, commands: r }) => {
  const i = Ft(t, n.schema);
  return $b(n, i, e) ? r.lift(i) : r.wrapIn(i, e);
}, une = () => ({ state: t, dispatch: e }) => {
  const n = t.plugins;
  for (let r = 0; r < n.length; r += 1) {
    const i = n[r];
    let o;
    if (i.spec.isInputRules && (o = i.getState(t))) {
      if (e) {
        const s = t.tr, a = o.transform;
        for (let l = a.steps.length - 1; l >= 0; l -= 1)
          s.step(a.steps[l].invert(a.docs[l]));
        if (o.text) {
          const l = s.doc.resolve(o.from).marks();
          s.replaceWith(o.from, o.to, t.schema.text(o.text, l));
        } else
          s.delete(o.from, o.to);
      }
      return !0;
    }
  }
  return !1;
}, dne = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, { empty: r, ranges: i } = n;
  return r || e && i.forEach((o) => {
    t.removeMark(o.$from.pos, o.$to.pos);
  }), !0;
}, fne = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  var o;
  const { extendEmptyMarkRange: s = !1 } = e, { selection: a } = n, l = Ri(t, r.schema), { $from: c, empty: u, ranges: d } = a;
  if (!i)
    return !0;
  if (u && s) {
    let { from: f, to: h } = a;
    const p = (o = c.marks().find((b) => b.type === l)) === null || o === void 0 ? void 0 : o.attrs, m = gR(c, l, p);
    m && (f = m.from, h = m.to), n.removeMark(f, h, l);
  } else
    d.forEach((f) => {
      n.removeMark(f.$from.pos, f.$to.pos, l);
    });
  return n.removeStoredMark(l), !0;
}, hne = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  let o = null, s = null;
  const a = xR(typeof t == "string" ? t : t.name, r.schema);
  return a ? (a === "node" && (o = Ft(t, r.schema)), a === "mark" && (s = Ri(t, r.schema)), i && n.selection.ranges.forEach((l) => {
    const c = l.$from.pos, u = l.$to.pos;
    let d, f, h, p;
    n.selection.empty ? r.doc.nodesBetween(c, u, (m, b) => {
      o && o === m.type && (h = Math.max(b, c), p = Math.min(b + m.nodeSize, u), d = b, f = m);
    }) : r.doc.nodesBetween(c, u, (m, b) => {
      b < c && o && o === m.type && (h = Math.max(b, c), p = Math.min(b + m.nodeSize, u), d = b, f = m), b >= c && b <= u && (o && o === m.type && n.setNodeMarkup(b, void 0, {
        ...m.attrs,
        ...e
      }), s && m.marks.length && m.marks.forEach((y) => {
        if (s === y.type) {
          const k = Math.max(b, c), C = Math.min(b + m.nodeSize, u);
          n.addMark(k, C, s.create({
            ...y.attrs,
            ...e
          }));
        }
      }));
    }), f && (d !== void 0 && n.setNodeMarkup(d, void 0, {
      ...f.attrs,
      ...e
    }), s && f.marks.length && f.marks.forEach((m) => {
      s === m.type && n.addMark(h, p, s.create({
        ...m.attrs,
        ...e
      }));
    }));
  }), !0) : !1;
}, pne = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const i = Ft(t, n.schema);
  return r3(i, e)(n, r);
}, mne = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const i = Ft(t, n.schema);
  return i3(i, e)(n, r);
};
var gne = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: nte,
  clearContent: rte,
  clearNodes: ite,
  command: ote,
  createParagraphNear: ste,
  cut: ate,
  deleteCurrentNode: lte,
  deleteNode: cte,
  deleteRange: ute,
  deleteSelection: dte,
  enter: fte,
  exitCode: hte,
  extendMarkRange: pte,
  first: mte,
  focus: vte,
  forEach: bte,
  insertContent: yte,
  insertContentAt: kte,
  joinBackward: Tte,
  joinDown: Ste,
  joinForward: Ete,
  joinItemBackward: Mte,
  joinItemForward: Ote,
  joinTextblockBackward: Ate,
  joinTextblockForward: Nte,
  joinUp: Cte,
  keyboardShortcut: Dte,
  lift: Ite,
  liftEmptyBlock: _te,
  liftListItem: Pte,
  newlineInCode: Lte,
  resetAttributes: Fte,
  scrollIntoView: $te,
  selectAll: Bte,
  selectNodeBackward: Vte,
  selectNodeForward: zte,
  selectParentNode: Hte,
  selectTextblockEnd: Wte,
  selectTextblockStart: jte,
  setContent: qte,
  setMark: Xte,
  setMeta: Qte,
  setNode: ene,
  setNodeSelection: tne,
  setTextSelection: nne,
  sinkListItem: rne,
  splitBlock: ine,
  splitListItem: one,
  toggleList: sne,
  toggleMark: ane,
  toggleNode: lne,
  toggleWrap: cne,
  undoInputRule: une,
  unsetAllMarks: dne,
  unsetMark: fne,
  updateAttributes: hne,
  wrapIn: pne,
  wrapInList: mne
});
Yn.create({
  name: "commands",
  addCommands() {
    return {
      ...gne
    };
  }
});
Yn.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Ge({
        key: new tt("tiptapDrop"),
        props: {
          handleDrop: (t, e, n, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: n,
              moved: r
            });
          }
        }
      })
    ];
  }
});
Yn.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Ge({
        key: new tt("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
});
Yn.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: t } = this;
    return [
      new Ge({
        key: new tt("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (e, n) => {
              t.isFocused = !0;
              const r = t.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, n) => {
              t.isFocused = !1;
              const r = t.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
});
Yn.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const t = () => this.editor.commands.first(({ commands: s }) => [
      () => s.undoInputRule(),
      // maybe convert first text block node to default node
      () => s.command(({ tr: a }) => {
        const { selection: l, doc: c } = a, { empty: u, $anchor: d } = l, { pos: f, parent: h } = d, p = d.parent.isTextblock && f > 0 ? a.doc.resolve(f - 1) : d, m = p.parent.type.spec.isolating, b = d.pos - d.parentOffset, y = m && p.parent.childCount === 1 ? b === d.pos : be.atStart(c).from === f;
        return !u || !h.type.isTextblock || h.textContent.length || !y || y && d.parent.type.name === "paragraph" ? !1 : s.clearNodes();
      }),
      () => s.deleteSelection(),
      () => s.joinBackward(),
      () => s.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: s }) => [
      () => s.deleteSelection(),
      () => s.deleteCurrentNode(),
      () => s.joinForward(),
      () => s.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: s }) => [
        () => s.newlineInCode(),
        () => s.createParagraphNear(),
        () => s.liftEmptyBlock(),
        () => s.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: t,
      "Mod-Backspace": t,
      "Shift-Backspace": t,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, i = {
      ...r
    }, o = {
      ...r,
      "Ctrl-h": t,
      "Alt-Backspace": t,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return yR() || wR() ? o : i;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Ge({
        key: new tt("clearDocument"),
        appendTransaction: (t, e, n) => {
          const r = t.some((m) => m.docChanged) && !e.doc.eq(n.doc), i = t.some((m) => m.getMeta("preventClearDocument"));
          if (!r || i)
            return;
          const { empty: o, from: s, to: a } = e.selection, l = be.atStart(e.doc).from, c = be.atEnd(e.doc).to;
          if (o || !(s === l && a === c) || !kR(n.doc))
            return;
          const f = n.tr, h = pR({
            state: n,
            transaction: f
          }), { commands: p } = new Kee({
            editor: this.editor,
            state: h
          });
          if (p.clearNodes(), !!f.steps.length)
            return f;
        }
      })
    ];
  }
});
Yn.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Ge({
        key: new tt("tiptapPaste"),
        props: {
          handlePaste: (t, e, n) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: n
            });
          }
        }
      })
    ];
  }
});
Yn.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new Ge({
        key: new tt("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
function vne(t) {
  return new Xee({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const i = sr(t.getAttributes, void 0, r) || {}, { tr: o } = e, s = n.from;
      let a = n.to;
      const l = t.type.create(i);
      if (r[1]) {
        const c = r[0].lastIndexOf(r[1]);
        let u = s + c;
        u > a ? u = a : a = u + r[1].length;
        const d = r[0][r[0].length - 1];
        o.insertText(d, s + r[0].length - 1), o.replaceWith(u, a, l);
      } else if (r[0]) {
        const c = t.type.isInline ? s : s - 1;
        o.insert(c, t.type.create(i)).delete(o.mapping.map(s), o.mapping.map(a));
      }
      o.scrollIntoView();
    }
  });
}
let bne = class T0 {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = sr(Hn(this, "addOptions", {
      name: this.name
    }))), this.storage = sr(Hn(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new T0(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Fb(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new T0(e);
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = sr(Hn(n, "addOptions", {
      name: n.name
    })), n.storage = sr(Hn(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
};
const yne = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, wne = bne.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {}
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["img", Yee(this.options.HTMLAttributes, t)];
  },
  addCommands() {
    return {
      setImage: (t) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: t
      })
    };
  },
  addInputRules() {
    return [
      vne({
        find: yne,
        type: this.type,
        getAttributes: (t) => {
          const [, , e, n, r] = t;
          return { src: n, alt: e, title: r };
        }
      })
    ];
  }
}), xne = wne.extend({
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      style: {
        default: "width: 100%; height: auto; cursor: pointer;",
        parseHTML: (t) => {
          const e = t.getAttribute("width");
          return e ? `width: ${e}px; height: auto; cursor: pointer;` : `${t.style.cssText}`;
        }
      },
      title: {
        default: null
      },
      loading: {
        default: null
      },
      srcset: {
        default: null
      },
      sizes: {
        default: null
      },
      crossorigin: {
        default: null
      },
      usemap: {
        default: null
      },
      ismap: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      },
      referrerpolicy: {
        default: null
      },
      longdesc: {
        default: null
      },
      decoding: {
        default: null
      },
      class: {
        default: null
      },
      id: {
        default: null
      },
      name: {
        default: null
      },
      draggable: {
        default: !0
      },
      tabindex: {
        default: null
      },
      "aria-label": {
        default: null
      },
      "aria-labelledby": {
        default: null
      },
      "aria-describedby": {
        default: null
      }
    };
  },
  addNodeView() {
    return ({ node: t, editor: e, getPos: n }) => {
      const { view: r, options: { editable: i } } = e, { style: o } = t.attrs, s = document.createElement("div"), a = document.createElement("div"), l = document.createElement("img"), c = "width: 24px; height: 24px; cursor: pointer;", u = () => {
        if (typeof n == "function") {
          const k = Object.assign(Object.assign({}, t.attrs), { style: `${l.style.cssText}` });
          r.dispatch(r.state.tr.setNodeMarkup(n(), null, k));
        }
      }, d = () => {
        const k = document.createElement("div"), C = document.createElement("img"), x = document.createElement("img"), S = document.createElement("img"), T = (M) => {
          M.target.style.opacity = 0.3;
        }, E = (M) => {
          M.target.style.opacity = 1;
        };
        k.setAttribute("style", "position: absolute; top: 0%; left: 50%; width: 100px; height: 25px; z-index: 999; background-color: rgba(255, 255, 255, 0.7); border-radius: 4px; border: 2px solid #6C6C6C; cursor: pointer; transform: translate(-50%, -50%); display: flex; justify-content: space-between; align-items: center; padding: 0 10px;"), C.setAttribute("src", "https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsoutlined/format_align_left/default/20px.svg"), C.setAttribute("style", c), C.addEventListener("mouseover", T), C.addEventListener("mouseout", E), x.setAttribute("src", "https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsoutlined/format_align_center/default/20px.svg"), x.setAttribute("style", c), x.addEventListener("mouseover", T), x.addEventListener("mouseout", E), S.setAttribute("src", "https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsoutlined/format_align_right/default/20px.svg"), S.setAttribute("style", c), S.addEventListener("mouseover", T), S.addEventListener("mouseout", E), C.addEventListener("click", () => {
          l.setAttribute("style", `${l.style.cssText} margin: 0 auto 0 0;`), u();
        }), x.addEventListener("click", () => {
          l.setAttribute("style", `${l.style.cssText} margin: 0 auto;`), u();
        }), S.addEventListener("click", () => {
          l.setAttribute("style", `${l.style.cssText} margin: 0 0 0 auto;`), u();
        }), k.appendChild(C), k.appendChild(x), k.appendChild(S), a.appendChild(k);
      };
      if (s.setAttribute("style", "display: flex;"), s.appendChild(a), a.setAttribute("style", `${o}`), a.appendChild(l), Object.entries(t.attrs).forEach(([k, C]) => {
        C != null && l.setAttribute(k, C);
      }), !i)
        return { dom: l };
      const h = document.documentElement.clientWidth < 768 ? "-8px" : "-4px", p = [
        `top: ${h}; left: ${h}; cursor: nwse-resize;`,
        `top: ${h}; right: ${h}; cursor: nesw-resize;`,
        `bottom: ${h}; left: ${h}; cursor: nesw-resize;`,
        `bottom: ${h}; right: ${h}; cursor: nwse-resize;`
      ];
      let m = !1, b, y;
      return a.addEventListener("click", (k) => {
        var C;
        const x = document.documentElement.clientWidth < 768;
        if (x && ((C = document.querySelector(".ProseMirror-focused")) === null || C === void 0 || C.blur()), a.childElementCount > 3)
          for (let S = 0; S < 5; S++)
            a.removeChild(a.lastChild);
        d(), a.setAttribute("style", `position: relative; border: 1px dashed #6C6C6C; ${o} cursor: pointer;`), Array.from({ length: 4 }, (S, T) => {
          const E = document.createElement("div");
          E.setAttribute("style", `position: absolute; width: ${x ? 16 : 9}px; height: ${x ? 16 : 9}px; border: 1.5px solid #6C6C6C; border-radius: 50%; ${p[T]}`), E.addEventListener("mousedown", (M) => {
            M.preventDefault(), m = !0, b = M.clientX, y = a.offsetWidth;
            const O = ($) => {
              if (!m)
                return;
              const z = T % 2 === 0 ? -($.clientX - b) : $.clientX - b, B = y + z;
              a.style.width = B + "px", l.style.width = B + "px";
            }, L = () => {
              m && (m = !1), u(), document.removeEventListener("mousemove", O), document.removeEventListener("mouseup", L);
            };
            document.addEventListener("mousemove", O), document.addEventListener("mouseup", L);
          }), E.addEventListener("touchstart", (M) => {
            M.cancelable && M.preventDefault(), m = !0, b = M.touches[0].clientX, y = a.offsetWidth;
            const O = ($) => {
              if (!m)
                return;
              const z = T % 2 === 0 ? -($.touches[0].clientX - b) : $.touches[0].clientX - b, B = y + z;
              a.style.width = B + "px", l.style.width = B + "px";
            }, L = () => {
              m && (m = !1), u(), document.removeEventListener("touchmove", O), document.removeEventListener("touchend", L);
            };
            document.addEventListener("touchmove", O), document.addEventListener("touchend", L);
          }, { passive: !1 }), a.appendChild(E);
        });
      }), document.addEventListener("click", (k) => {
        const C = k.target;
        if (!(a.contains(C) || C.style.cssText === c)) {
          const S = a.getAttribute("style"), T = S == null ? void 0 : S.replace("border: 1px dashed #6C6C6C;", "");
          if (a.setAttribute("style", T), a.childElementCount > 3)
            for (let E = 0; E < 5; E++)
              a.removeChild(a.lastChild);
        }
      }), {
        dom: s
      };
    };
  }
});
function CR({ children: t, className: e, ...n }) {
  return /* @__PURE__ */ v(
    "div",
    {
      className: I("kn-rich-text-renderer rich-text-renderer break-words", e),
      "data-testid": "asterisk-rich-text-renderer",
      ...n,
      children: t
    }
  );
}
CR.displayName = "RichTextRenderer";
const kne = vt.create({
  name: "div",
  // Node name
  group: "block",
  // Acts like a block element
  content: "block*",
  // Can contain multiple block-level elements
  addAttributes() {
    return {
      class: {
        default: null,
        parseHTML: (t) => t.getAttribute("class") || null,
        renderHTML: (t) => t.class ? { class: t.class } : {}
      },
      style: {
        default: null,
        parseHTML: (t) => t.getAttribute("style") || null,
        renderHTML: (t) => t.style ? { style: t.style } : {}
      }
    };
  },
  parseHTML() {
    return [{ tag: "div" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["div", Ke(t), 0];
  }
}), Cne = vt.create({
  name: "iframe",
  group: "block",
  atom: !0,
  addOptions() {
    return {
      allowFullscreen: !0,
      HTMLAttributes: {
        class: "iframe-wrapper"
      }
    };
  },
  addAttributes() {
    return {
      src: {
        default: null
      },
      frameborder: {
        default: 0
      },
      allowfullscreen: {
        default: this.options.allowFullscreen,
        parseHTML: () => this.options.allowFullscreen
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "iframe"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["div", this.options.HTMLAttributes, ["iframe", t]];
  },
  addCommands() {
    return {
      setIframe: (t) => ({ tr: e, dispatch: n }) => {
        const { selection: r } = e, i = this.type.create(t);
        return n && e.replaceRangeWith(r.from, r.to, i), !0;
      }
    };
  }
}), Sne = hR.extend({
  addAttributes() {
    return {
      class: {
        default: null,
        parseHTML: (t) => t.getAttribute("class") || null,
        renderHTML: (t) => t.class ? { class: t.class } : {}
      },
      style: {
        default: null,
        parseHTML: (t) => t.getAttribute("style") || null,
        renderHTML: (t) => t.style ? { style: t.style } : {}
      }
    };
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["p", Ke(t), 0];
  }
}), Tne = gt.create({
  name: "textClass",
  addOptions() {
    return {
      className: ""
    };
  },
  addCommands() {
    return {
      addClass: (t) => ({ state: e, commands: n }) => {
        const { from: r, to: i } = e.selection, o = e.schema.marks.styledText;
        return e.doc.nodesBetween(r, i, (s) => {
          s.marks.some((a) => a.type === o) && n.unsetMark("styledText");
        }), n.setMark("styledText", { class: t });
      },
      hasClass: (t) => ({ state: e }) => {
        const { from: n, to: r } = e.selection, i = e.schema.marks.styledText;
        let o = !1;
        return e.doc.nodesBetween(n, r, (s) => s.marks.some((a) => a.type === i && a.attrs.class === t) ? (o = !0, !1) : !0), o;
      }
    };
  }
}), Ene = gn.create({
  name: "styledText",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span[class]"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["span", { ...t }, 0];
  },
  addAttributes() {
    return {
      class: {
        default: null
      }
    };
  }
}), Mne = gt.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (t) => t.style.fontSize.replace(/['"]+/g, ""),
            renderHTML: (t) => t.fontSize ? {
              style: `font-size: ${t.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (t) => ({ chain: e }) => e().setMark("textStyle", { fontSize: t }).run(),
      unsetFontSize: () => ({ chain: t }) => t().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run()
    };
  }
});
function Sn({
  children: t,
  onClick: e,
  disabled: n,
  className: r,
  tooltipText: i,
  ...o
}) {
  return /* @__PURE__ */ F(Wt, { children: [
    /* @__PURE__ */ v(Wt.Trigger, { asChild: !0, children: /* @__PURE__ */ v(
      Ze,
      {
        intent: "minimal",
        size: "xs",
        onClick: e,
        disabled: n,
        className: I(
          "text-default flex size-4 items-center justify-center p-4 font-semibold",
          r
        ),
        ...o,
        children: t
      }
    ) }),
    /* @__PURE__ */ v(Wt.Portal, { children: i && /* @__PURE__ */ v(Wt.Content, { className: "z-20", children: i }) })
  ] });
}
function One({
  className: t,
  options: e,
  isHtmlMode: n = !1,
  setIsHtmlMode: r,
  setCurrentEditorContent: i,
  characterLimit: o,
  showOverflowGradient: s = !0
}) {
  const { editor: a } = vr(), l = xe();
  return !a || !(e != null && e.includes("edit_html")) && !o ? null : /* @__PURE__ */ F("div", { className: I("relative flex flex-row items-center justify-between px-2 py-1", t), children: [
    s && /* @__PURE__ */ v("div", { className: "text-inverted pointer-events-none absolute -top-4 left-0 h-4 w-full bg-gradient-to-t from-current to-transparent" }),
    (e == null ? void 0 : e.includes("edit_html")) && /* @__PURE__ */ v(
      Sn,
      {
        tooltipText: "Edit in HTML",
        onClick: () => {
          i(a.getHTML()), r((c) => !c);
        },
        children: /* @__PURE__ */ v(zS, { size: 16, className: "shrink-0" })
      }
    ),
    o && !n && /* @__PURE__ */ v(
      "span",
      {
        className: I("text-subtle bg-input my-2 ml-auto mr-2 px-1 text-xs", {
          "bg-destructive text-destructive": a.storage.characterCount.characters() > o,
          rounded: l.theme.appearance.corners === "rounded"
        }),
        children: `${a.storage.characterCount.characters()}/${o}`
      }
    )
  ] });
}
function Ane(t) {
  return Ee({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M13 4v16" }, child: [] }, { tag: "path", attr: { d: "M17 4v16" }, child: [] }, { tag: "path", attr: { d: "M19 4h-9.5a4.5 4.5 0 0 0 0 9h3.5" }, child: [] }] })(t);
}
function Nne(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function BC(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function VC(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? BC(Object(n), !0).forEach(function(r) {
      Nne(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : BC(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Rne(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(e.indexOf(i) >= 0) && (n[i] = t[i]);
  return n;
}
function Dne(t, e) {
  if (t == null) return {};
  var n = Rne(t, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (i = 0; i < o.length; i++)
      r = o[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function Ine(t, e) {
  return _ne(t) || Pne(t, e) || Lne(t, e) || Fne();
}
function _ne(t) {
  if (Array.isArray(t)) return t;
}
function Pne(t, e) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(t)))) {
    var n = [], r = !0, i = !1, o = void 0;
    try {
      for (var s = t[Symbol.iterator](), a; !(r = (a = s.next()).done) && (n.push(a.value), !(e && n.length === e)); r = !0)
        ;
    } catch (l) {
      i = !0, o = l;
    } finally {
      try {
        !r && s.return != null && s.return();
      } finally {
        if (i) throw o;
      }
    }
    return n;
  }
}
function Lne(t, e) {
  if (t) {
    if (typeof t == "string") return zC(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return zC(t, e);
  }
}
function zC(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function Fne() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $ne(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function HC(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function WC(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? HC(Object(n), !0).forEach(function(r) {
      $ne(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : HC(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Bne() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function(r) {
    return e.reduceRight(function(i, o) {
      return o(i);
    }, r);
  };
}
function qs(t) {
  return function e() {
    for (var n = this, r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return i.length >= t.length ? t.apply(this, i) : function() {
      for (var s = arguments.length, a = new Array(s), l = 0; l < s; l++)
        a[l] = arguments[l];
      return e.apply(n, [].concat(i, a));
    };
  };
}
function $u(t) {
  return {}.toString.call(t).includes("Object");
}
function Vne(t) {
  return !Object.keys(t).length;
}
function _a(t) {
  return typeof t == "function";
}
function zne(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function Hne(t, e) {
  return $u(e) || pi("changeType"), Object.keys(e).some(function(n) {
    return !zne(t, n);
  }) && pi("changeField"), e;
}
function Wne(t) {
  _a(t) || pi("selectorType");
}
function jne(t) {
  _a(t) || $u(t) || pi("handlerType"), $u(t) && Object.values(t).some(function(e) {
    return !_a(e);
  }) && pi("handlersType");
}
function Une(t) {
  t || pi("initialIsRequired"), $u(t) || pi("initialType"), Vne(t) && pi("initialContent");
}
function qne(t, e) {
  throw new Error(t[e] || t.default);
}
var Kne = {
  initialIsRequired: "initial state is required",
  initialType: "initial state should be an object",
  initialContent: "initial state shouldn't be an empty object",
  handlerType: "handler should be an object or a function",
  handlersType: "all handlers should be a functions",
  selectorType: "selector should be a function",
  changeType: "provided value of changes should be an object",
  changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state',
  default: "an unknown error accured in `state-local` package"
}, pi = qs(qne)(Kne), tc = {
  changes: Hne,
  selector: Wne,
  handler: jne,
  initial: Une
};
function Gne(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  tc.initial(t), tc.handler(e);
  var n = {
    current: t
  }, r = qs(Jne)(n, e), i = qs(Zne)(n), o = qs(tc.changes)(t), s = qs(Yne)(n);
  function a() {
    var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(u) {
      return u;
    };
    return tc.selector(c), c(n.current);
  }
  function l(c) {
    Bne(r, i, o, s)(c);
  }
  return [a, l];
}
function Yne(t, e) {
  return _a(e) ? e(t.current) : e;
}
function Zne(t, e) {
  return t.current = WC(WC({}, t.current), e), e;
}
function Jne(t, e, n) {
  return _a(e) ? e(t.current) : Object.keys(n).forEach(function(r) {
    var i;
    return (i = e[r]) === null || i === void 0 ? void 0 : i.call(e, t.current[r]);
  }), n;
}
var Xne = {
  create: Gne
}, Qne = {
  paths: {
    vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.52.2/min/vs"
  }
};
function ere(t) {
  return function e() {
    for (var n = this, r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return i.length >= t.length ? t.apply(this, i) : function() {
      for (var s = arguments.length, a = new Array(s), l = 0; l < s; l++)
        a[l] = arguments[l];
      return e.apply(n, [].concat(i, a));
    };
  };
}
function tre(t) {
  return {}.toString.call(t).includes("Object");
}
function nre(t) {
  return t || jC("configIsRequired"), tre(t) || jC("configType"), t.urls ? (rre(), {
    paths: {
      vs: t.urls.monacoBase
    }
  }) : t;
}
function rre() {
  console.warn(SR.deprecation);
}
function ire(t, e) {
  throw new Error(t[e] || t.default);
}
var SR = {
  configIsRequired: "the configuration object is required",
  configType: "the configuration object should be an object",
  default: "an unknown error accured in `@monaco-editor/loader` package",
  deprecation: `Deprecation warning!
    You are using deprecated way of configuration.

    Instead of using
      monaco.config({ urls: { monacoBase: '...' } })
    use
      monaco.config({ paths: { vs: '...' } })

    For more please check the link https://github.com/suren-atoyan/monaco-loader#config
  `
}, jC = ere(ire)(SR), ore = {
  config: nre
}, sre = function() {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  return function(i) {
    return n.reduceRight(function(o, s) {
      return s(o);
    }, i);
  };
};
function TR(t, e) {
  return Object.keys(e).forEach(function(n) {
    e[n] instanceof Object && t[n] && Object.assign(e[n], TR(t[n], e[n]));
  }), VC(VC({}, t), e);
}
var are = {
  type: "cancelation",
  msg: "operation is manually canceled"
};
function _p(t) {
  var e = !1, n = new Promise(function(r, i) {
    t.then(function(o) {
      return e ? i(are) : r(o);
    }), t.catch(i);
  });
  return n.cancel = function() {
    return e = !0;
  }, n;
}
var lre = Xne.create({
  config: Qne,
  isInitialized: !1,
  resolve: null,
  reject: null,
  monaco: null
}), ER = Ine(lre, 2), cl = ER[0], Wd = ER[1];
function cre(t) {
  var e = ore.config(t), n = e.monaco, r = Dne(e, ["monaco"]);
  Wd(function(i) {
    return {
      config: TR(i.config, r),
      monaco: n
    };
  });
}
function ure() {
  var t = cl(function(e) {
    var n = e.monaco, r = e.isInitialized, i = e.resolve;
    return {
      monaco: n,
      isInitialized: r,
      resolve: i
    };
  });
  if (!t.isInitialized) {
    if (Wd({
      isInitialized: !0
    }), t.monaco)
      return t.resolve(t.monaco), _p(Pp);
    if (window.monaco && window.monaco.editor)
      return MR(window.monaco), t.resolve(window.monaco), _p(Pp);
    sre(dre, hre)(pre);
  }
  return _p(Pp);
}
function dre(t) {
  return document.body.appendChild(t);
}
function fre(t) {
  var e = document.createElement("script");
  return t && (e.src = t), e;
}
function hre(t) {
  var e = cl(function(r) {
    var i = r.config, o = r.reject;
    return {
      config: i,
      reject: o
    };
  }), n = fre("".concat(e.config.paths.vs, "/loader.js"));
  return n.onload = function() {
    return t();
  }, n.onerror = e.reject, n;
}
function pre() {
  var t = cl(function(n) {
    var r = n.config, i = n.resolve, o = n.reject;
    return {
      config: r,
      resolve: i,
      reject: o
    };
  }), e = window.require;
  e.config(t.config), e(["vs/editor/editor.main"], function(n) {
    MR(n), t.resolve(n);
  }, function(n) {
    t.reject(n);
  });
}
function MR(t) {
  cl().monaco || Wd({
    monaco: t
  });
}
function mre() {
  return cl(function(t) {
    var e = t.monaco;
    return e;
  });
}
var Pp = new Promise(function(t, e) {
  return Wd({
    resolve: t,
    reject: e
  });
}), OR = {
  config: cre,
  init: ure,
  __getMonacoInstance: mre
}, gre = { wrapper: { display: "flex", position: "relative", textAlign: "initial" }, fullWidth: { width: "100%" }, hide: { display: "none" } }, Lp = gre, vre = { container: { display: "flex", height: "100%", width: "100%", justifyContent: "center", alignItems: "center" } }, bre = vre;
function yre({ children: t }) {
  return he.createElement("div", { style: bre.container }, t);
}
var wre = yre, xre = wre;
function kre({ width: t, height: e, isEditorReady: n, loading: r, _ref: i, className: o, wrapperProps: s }) {
  return he.createElement("section", { style: { ...Lp.wrapper, width: t, height: e }, ...s }, !n && he.createElement(xre, null, r), he.createElement("div", { ref: i, style: { ...Lp.fullWidth, ...!n && Lp.hide }, className: o }));
}
var Cre = kre, AR = E0(Cre);
function Sre(t) {
  De(t, []);
}
var NR = Sre;
function Tre(t, e, n = !0) {
  let r = Me(!0);
  De(r.current || !n ? () => {
    r.current = !1;
  } : t, e);
}
var sn = Tre;
function la() {
}
function zo(t, e, n, r) {
  return Ere(t, r) || Mre(t, e, n, r);
}
function Ere(t, e) {
  return t.editor.getModel(RR(t, e));
}
function Mre(t, e, n, r) {
  return t.editor.createModel(e, n, r ? RR(t, r) : void 0);
}
function RR(t, e) {
  return t.Uri.parse(e);
}
function Ore({ original: t, modified: e, language: n, originalLanguage: r, modifiedLanguage: i, originalModelPath: o, modifiedModelPath: s, keepCurrentOriginalModel: a = !1, keepCurrentModifiedModel: l = !1, theme: c = "light", loading: u = "Loading...", options: d = {}, height: f = "100%", width: h = "100%", className: p, wrapperProps: m = {}, beforeMount: b = la, onMount: y = la }) {
  let [k, C] = pe(!1), [x, S] = pe(!0), T = Me(null), E = Me(null), M = Me(null), O = Me(y), L = Me(b), $ = Me(!1);
  NR(() => {
    let N = OR.init();
    return N.then((R) => (E.current = R) && S(!1)).catch((R) => (R == null ? void 0 : R.type) !== "cancelation" && console.error("Monaco initialization: error:", R)), () => T.current ? A() : N.cancel();
  }), sn(() => {
    if (T.current && E.current) {
      let N = T.current.getOriginalEditor(), R = zo(E.current, t || "", r || n || "text", o || "");
      R !== N.getModel() && N.setModel(R);
    }
  }, [o], k), sn(() => {
    if (T.current && E.current) {
      let N = T.current.getModifiedEditor(), R = zo(E.current, e || "", i || n || "text", s || "");
      R !== N.getModel() && N.setModel(R);
    }
  }, [s], k), sn(() => {
    let N = T.current.getModifiedEditor();
    N.getOption(E.current.editor.EditorOption.readOnly) ? N.setValue(e || "") : e !== N.getValue() && (N.executeEdits("", [{ range: N.getModel().getFullModelRange(), text: e || "", forceMoveMarkers: !0 }]), N.pushUndoStop());
  }, [e], k), sn(() => {
    var N, R;
    (R = (N = T.current) == null ? void 0 : N.getModel()) == null || R.original.setValue(t || "");
  }, [t], k), sn(() => {
    let { original: N, modified: R } = T.current.getModel();
    E.current.editor.setModelLanguage(N, r || n || "text"), E.current.editor.setModelLanguage(R, i || n || "text");
  }, [n, r, i], k), sn(() => {
    var N;
    (N = E.current) == null || N.editor.setTheme(c);
  }, [c], k), sn(() => {
    var N;
    (N = T.current) == null || N.updateOptions(d);
  }, [d], k);
  let z = ct(() => {
    var _;
    if (!E.current) return;
    L.current(E.current);
    let N = zo(E.current, t || "", r || n || "text", o || ""), R = zo(E.current, e || "", i || n || "text", s || "");
    (_ = T.current) == null || _.setModel({ original: N, modified: R });
  }, [n, e, i, t, r, o, s]), B = ct(() => {
    var N;
    !$.current && M.current && (T.current = E.current.editor.createDiffEditor(M.current, { automaticLayout: !0, ...d }), z(), (N = E.current) == null || N.editor.setTheme(c), C(!0), $.current = !0);
  }, [d, c, z]);
  De(() => {
    k && O.current(T.current, E.current);
  }, [k]), De(() => {
    !x && !k && B();
  }, [x, k, B]);
  function A() {
    var R, _, D, q;
    let N = (R = T.current) == null ? void 0 : R.getModel();
    a || ((_ = N == null ? void 0 : N.original) == null || _.dispose()), l || ((D = N == null ? void 0 : N.modified) == null || D.dispose()), (q = T.current) == null || q.dispose();
  }
  return he.createElement(AR, { width: h, height: f, isEditorReady: k, loading: u, _ref: M, className: p, wrapperProps: m });
}
var Are = Ore;
E0(Are);
function Nre(t) {
  let e = Me();
  return De(() => {
    e.current = t;
  }, [t]), e.current;
}
var Rre = Nre, nc = /* @__PURE__ */ new Map();
function Dre({ defaultValue: t, defaultLanguage: e, defaultPath: n, value: r, language: i, path: o, theme: s = "light", line: a, loading: l = "Loading...", options: c = {}, overrideServices: u = {}, saveViewState: d = !0, keepCurrentModel: f = !1, width: h = "100%", height: p = "100%", className: m, wrapperProps: b = {}, beforeMount: y = la, onMount: k = la, onChange: C, onValidate: x = la }) {
  let [S, T] = pe(!1), [E, M] = pe(!0), O = Me(null), L = Me(null), $ = Me(null), z = Me(k), B = Me(y), A = Me(), N = Me(r), R = Rre(o), _ = Me(!1), D = Me(!1);
  NR(() => {
    let H = OR.init();
    return H.then((G) => (O.current = G) && M(!1)).catch((G) => (G == null ? void 0 : G.type) !== "cancelation" && console.error("Monaco initialization: error:", G)), () => L.current ? V() : H.cancel();
  }), sn(() => {
    var G, Q, te, le;
    let H = zo(O.current, t || r || "", e || i || "", o || n || "");
    H !== ((G = L.current) == null ? void 0 : G.getModel()) && (d && nc.set(R, (Q = L.current) == null ? void 0 : Q.saveViewState()), (te = L.current) == null || te.setModel(H), d && ((le = L.current) == null || le.restoreViewState(nc.get(o))));
  }, [o], S), sn(() => {
    var H;
    (H = L.current) == null || H.updateOptions(c);
  }, [c], S), sn(() => {
    !L.current || r === void 0 || (L.current.getOption(O.current.editor.EditorOption.readOnly) ? L.current.setValue(r) : r !== L.current.getValue() && (D.current = !0, L.current.executeEdits("", [{ range: L.current.getModel().getFullModelRange(), text: r, forceMoveMarkers: !0 }]), L.current.pushUndoStop(), D.current = !1));
  }, [r], S), sn(() => {
    var G, Q;
    let H = (G = L.current) == null ? void 0 : G.getModel();
    H && i && ((Q = O.current) == null || Q.editor.setModelLanguage(H, i));
  }, [i], S), sn(() => {
    var H;
    a !== void 0 && ((H = L.current) == null || H.revealLine(a));
  }, [a], S), sn(() => {
    var H;
    (H = O.current) == null || H.editor.setTheme(s);
  }, [s], S);
  let q = ct(() => {
    var H;
    if (!(!$.current || !O.current) && !_.current) {
      B.current(O.current);
      let G = o || n, Q = zo(O.current, r || t || "", e || i || "", G || "");
      L.current = (H = O.current) == null ? void 0 : H.editor.create($.current, { model: Q, automaticLayout: !0, ...c }, u), d && L.current.restoreViewState(nc.get(G)), O.current.editor.setTheme(s), a !== void 0 && L.current.revealLine(a), T(!0), _.current = !0;
    }
  }, [t, e, n, r, i, o, c, u, d, s, a]);
  De(() => {
    S && z.current(L.current, O.current);
  }, [S]), De(() => {
    !E && !S && q();
  }, [E, S, q]), N.current = r, De(() => {
    var H, G;
    S && C && ((H = A.current) == null || H.dispose(), A.current = (G = L.current) == null ? void 0 : G.onDidChangeModelContent((Q) => {
      D.current || C(L.current.getValue(), Q);
    }));
  }, [S, C]), De(() => {
    if (S) {
      let H = O.current.editor.onDidChangeMarkers((G) => {
        var te;
        let Q = (te = L.current.getModel()) == null ? void 0 : te.uri;
        if (Q && G.find((le) => le.path === Q.path)) {
          let le = O.current.editor.getModelMarkers({ resource: Q });
          x == null || x(le);
        }
      });
      return () => {
        H == null || H.dispose();
      };
    }
    return () => {
    };
  }, [S, x]);
  function V() {
    var H, G;
    (H = A.current) == null || H.dispose(), f ? d && nc.set(o, L.current.saveViewState()) : (G = L.current.getModel()) == null || G.dispose(), L.current.dispose();
  }
  return he.createElement(AR, { width: h, height: p, isEditorReady: S, loading: l, _ref: $, className: m, wrapperProps: b });
}
var Ire = Dre, _re = E0(Ire), Pre = _re;
function Lre({
  monacoEditor: t,
  characterLimit: e,
  setIsHtmlMode: n,
  currentEditorContent: r,
  height: i,
  onUpdate: o,
  ...s
}) {
  const a = xe(), l = Me(null), c = (d) => {
    t.current = d, setTimeout(() => {
      var f;
      (f = d == null ? void 0 : d.getAction("editor.action.formatDocument")) == null || f.run();
    }, 100);
  }, u = (d) => {
    o(d || "");
  };
  return /* @__PURE__ */ F(
    "div",
    {
      ref: l,
      className: I(
        "bg-input border-subtle flex flex-col border",
        {
          "rounded-lg": a.theme.appearance.corners === "rounded"
        },
        s.className
      ),
      children: [
        /* @__PURE__ */ v(
          "div",
          {
            className: I("h-2 bg-[#1e1e1e]", {
              "rounded-t-md": a.theme.appearance.corners === "rounded"
            })
          }
        ),
        /* @__PURE__ */ v(
          Pre,
          {
            className: "absolute left-0 top-0 h-[calc(100%+1px)] w-full",
            defaultLanguage: "html",
            theme: "vs-dark",
            value: r,
            onMount: c,
            onChange: u,
            options: {
              minimap: {
                enabled: !1
              },
              formatOnType: !0,
              formatOnPaste: !0
            }
          }
        ),
        /* @__PURE__ */ v(
          "div",
          {
            className: I("bg-[#1e1e1e] px-2 py-1", {
              "rounded-b-md": a.theme.appearance.corners === "rounded"
            }),
            children: /* @__PURE__ */ v(
              Sn,
              {
                className: "bg-transparent text-gray-100 hover:bg-slate-200 hover:bg-opacity-25 focus:bg-slate-200 focus:bg-opacity-25",
                tooltipText: "Visual Editor",
                onClick: () => {
                  n((d) => !d);
                },
                children: /* @__PURE__ */ v(Ane, { size: 16, className: "shrink-0" })
              }
            )
          }
        )
      ]
    }
  );
}
const Fre = gt.create({
  name: "getSelectedText",
  addCommands() {
    return {
      getSelectedText: () => ({ editor: t }) => {
        const { from: e, to: n, empty: r } = t.state.selection;
        return r ? "" : t.state.doc.textBetween(e, n, " ");
      },
      getAllTextStyleColors: () => ({ editor: t }) => {
        const { from: e, to: n } = t.state.selection, r = [];
        return t.state.doc.nodesBetween(e, n, (i) => {
          i.isText && i.marks.length > 0 && i.marks.forEach((o) => {
            o.type.name === "textStyle" && o.attrs.color && r.push(o.attrs.color);
          });
        }), r;
      }
    };
  }
});
function $re(t) {
  return Ee({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "m11.307 4-6 16h2.137l1.875-5h6.363l1.875 5h2.137l-6-16h-2.387zm-1.239 9L12.5 6.515 14.932 13h-4.864z" }, child: [] }] })(t);
}
function Bre(t) {
  return Ee({ attr: { viewBox: "0 0 15 15", fill: "none" }, child: [{ tag: "path", attr: { fillRule: "evenodd", clipRule: "evenodd", d: "M2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5Z", fill: "currentColor" }, child: [] }] })(t);
}
function Vre(t) {
  return Ee({ attr: { viewBox: "0 0 15 15", fill: "none" }, child: [{ tag: "path", attr: { fillRule: "evenodd", clipRule: "evenodd", d: "M5.67494 3.50017C5.67494 3.25164 5.87641 3.05017 6.12494 3.05017H10.6249C10.8735 3.05017 11.0749 3.25164 11.0749 3.50017C11.0749 3.7487 10.8735 3.95017 10.6249 3.95017H9.00587L7.2309 11.05H8.87493C9.12345 11.05 9.32493 11.2515 9.32493 11.5C9.32493 11.7486 9.12345 11.95 8.87493 11.95H4.37493C4.1264 11.95 3.92493 11.7486 3.92493 11.5C3.92493 11.2515 4.1264 11.05 4.37493 11.05H5.99397L7.76894 3.95017H6.12494C5.87641 3.95017 5.67494 3.7487 5.67494 3.50017Z", fill: "currentColor" }, child: [] }] })(t);
}
const zre = {
  base: ["break-words", "w-full", "text-start", "overflow-hidden", "text-ellipsis", "line-clamp-3"]
};
function jd({ children: t, className: e }) {
  return /* @__PURE__ */ F(Wt, { children: [
    /* @__PURE__ */ v(Wt.Trigger, { asChild: !0, children: /* @__PURE__ */ v("span", { className: I(zre.base.join(" "), e), children: t }) }),
    /* @__PURE__ */ v(Wt.Content, { className: "max-w-md break-words text-start", children: t })
  ] });
}
jd.displayName = "Select.ItemContent";
const Hre = {
  intent: {
    default: ["border", "border-default", "hover:border-emphasis"],
    outline: ["border-b", "border-subtle", "hover:bg-muted"],
    subtle: ["bg-muted", "text-emphasis", "hover:bg-subtle"],
    destructive: [
      "border",
      "border-destructive",
      "hover:border-destructive",
      "focus:border-destructive",
      "focus:outline-destructive"
    ]
  },
  size: {
    default: ["h-auto", "p-2"],
    sm: ["h-6", "p-1"],
    lg: ["h-11", "px-3", "py-2.5"]
  }
}, UC = {
  name: "select",
  base: [
    "bg-input",
    "text-emphasis",
    "flex",
    "outline-none",
    "justify-between",
    "items-center",
    "focus:outline-default",
    "disabled:cursor-not-allowed",
    "disabled:bg-muted",
    "disabled:border-default",
    "disabled:text-subtle",
    "[&>[data-select-value]]:truncate",
    "data-[placeholder]:text-muted"
  ],
  config: {
    variants: Hre,
    defaultVariants: {
      intent: "default",
      size: "default"
    }
  }
}, Wre = {
  name: "select-content",
  base: [
    "data-[state=open]:animate-slideDownAndFade",
    "border-subtle",
    "text-default",
    "bg-menu",
    "relative",
    "z-50",
    "max-h-[600px]",
    "border",
    "shadow-md"
  ],
  config: {}
}, jre = {
  name: "select-label",
  base: ["text-emphasis", "px-2", "py-1.5", "font-semibold"],
  config: {}
}, Ure = {
  name: "select-item",
  base: [
    "focus-within:bg-emphasis",
    "focus-within:text-emphasis",
    "hover:bg-brand-muted",
    "data-[state=checked]:bg-brand-subtle",
    "relative",
    "flex",
    "flex-row",
    "items-start",
    "cursor-default",
    "select-none",
    "gap-1",
    "px-2",
    "py-1.5",
    "outline-none",
    "data-[disabled]:opacity-50"
  ],
  config: {}
}, qre = {
  name: "select-separator",
  base: ["bg-muted", "-mx-1", "my-1", "h-px"],
  config: {}
}, dse = {
  name: "select-container",
  base: ["relative"],
  config: {}
}, Kre = {
  name: "select-hint",
  base: ["text-subtle", "mt-2", "text-xs"],
  config: {}
}, Gre = Ie(UC.base, UC.config);
function DR({
  children: t,
  className: e,
  placeholder: n = "",
  shouldHideChevron: r = !1,
  shouldHideValue: i = !1,
  intent: o,
  size: s,
  ...a
}, l) {
  const c = xe();
  return /* @__PURE__ */ F(
    h5,
    {
      ref: l,
      className: I(
        "kn-select-trigger line-clamp-1 text-ellipsis",
        Gre({ intent: o, size: s }),
        {
          "rounded-lg": (!o || o === "default" || o === "destructive") && c.theme.appearance.corners === "rounded"
        },
        e
      ),
      "data-testid": "asterisk-select-trigger",
      ...a,
      children: [
        !i && /* @__PURE__ */ v(p5, { "data-select-value": !0, placeholder: n }),
        t,
        !r && /* @__PURE__ */ v(Vu, { size: 16, className: "ml-2 shrink-0" })
      ]
    }
  );
}
function IR({ className: t, children: e, ...n }, r) {
  const i = xe();
  return /* @__PURE__ */ v(m5, { children: /* @__PURE__ */ F(
    g5,
    {
      position: "popper",
      ref: r,
      className: I(
        "kn-select-content",
        Wre.base.join(" "),
        {
          "rounded-md": i.theme.appearance.corners === "rounded"
        },
        t
      ),
      "data-testid": "asterisk-select-content",
      style: {
        width: "var(--radix-select-trigger-width)",
        maxHeight: "var(--radix-select-content-available-height)"
      },
      ...n,
      children: [
        /* @__PURE__ */ v(x5, { className: "flex h-4 justify-center", children: /* @__PURE__ */ v(CI, { size: 20 }) }),
        /* @__PURE__ */ v(v5, { className: "h-52 p-2", children: e }),
        /* @__PURE__ */ v(k5, { className: "flex h-4 justify-center", children: /* @__PURE__ */ v(Vu, { size: 20 }) })
      ]
    }
  ) });
}
function _R({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    b5,
    {
      ref: n,
      className: I("kn-select-label", jre.base.join(" "), t),
      "data-testid": "asterisk-select-label",
      ...e
    }
  );
}
function Vb({ className: t }) {
  return /* @__PURE__ */ v(w5, { className: t, children: /* @__PURE__ */ v(M0, { size: 16 }) });
}
function PR({ className: t, asChild: e, children: n, ...r }, i) {
  const o = xe(), s = /* @__PURE__ */ v(jd, { children: n });
  return /* @__PURE__ */ v(
    y5,
    {
      ref: i,
      className: I(
        "kn-select-item data-[disabled]:pointers-event-none",
        Ure.base.join(" "),
        {
          "rounded-lg": o.theme.appearance.corners === "rounded"
        },
        t
      ),
      "data-testid": "asterisk-select-item",
      ...r,
      children: e ? n : /* @__PURE__ */ F(je, { children: [
        /* @__PURE__ */ v(kv, { children: s }),
        /* @__PURE__ */ v(Vb, { className: "text-default ml-auto shrink-0" })
      ] })
    }
  );
}
function LR({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    C5,
    {
      ref: n,
      className: I("kn-select-separator", qre.base.join(" "), t),
      "data-testid": "asterisk-select-separator",
      ...e
    }
  );
}
function FR({
  children: t,
  className: e
}) {
  return /* @__PURE__ */ v("div", { className: I("kn-select-container", e), "data-testid": "asterisk-select-container", children: t });
}
function $R({ className: t, children: e }) {
  return /* @__PURE__ */ v(
    "div",
    {
      className: I("kn-select-hint", Kre.base.join(" "), t),
      "data-testid": "asterisk-select-hint",
      children: e
    }
  );
}
const { Group: BR } = yV, qr = Object.assign(f5, {
  Label: ce(_R),
  Separator: ce(LR),
  Item: ce(PR),
  ItemIndicator: Vb,
  ItemContent: jd,
  ItemText: kv,
  Trigger: ce(DR),
  Content: ce(IR),
  Container: FR,
  Hint: $R,
  Group: BR
});
_R.displayName = "Select.Label";
LR.displayName = "Select.Separator";
PR.displayName = "Select.Item";
Vb.displayName = "Select.ItemIndicator";
jd.displayName = "Select.ItemContent";
DR.displayName = "Select.Trigger";
IR.displayName = "Select.Content";
FR.displayName = "Select.Container";
$R.displayName = "Select.Hint";
BR.displayName = "Select.Group";
function VR(t) {
  return Ee({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M416 128 192 384l-96-96" }, child: [] }] })(t);
}
function Yre(t) {
  return Ee({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M408 480H184a72 72 0 0 1-72-72V184a72 72 0 0 1 72-72h224a72 72 0 0 1 72 72v224a72 72 0 0 1-72 72z" }, child: [] }, { tag: "path", attr: { d: "M160 80h235.88A72.12 72.12 0 0 0 328 32H104a72 72 0 0 0-72 72v224a72.12 72.12 0 0 0 48 67.88V160a80 80 0 0 1 80-80z" }, child: [] }] })(t);
}
function Zre(t) {
  return Ee({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71" }, child: [] }, { tag: "path", attr: { d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71" }, child: [] }, { tag: "line", attr: { x1: "8", x2: "8", y1: "2", y2: "5" }, child: [] }, { tag: "line", attr: { x1: "2", x2: "5", y1: "8", y2: "8" }, child: [] }, { tag: "line", attr: { x1: "16", x2: "16", y1: "19", y2: "22" }, child: [] }, { tag: "line", attr: { x1: "19", x2: "22", y1: "16", y2: "16" }, child: [] }] })(t);
}
const Jre = /^(https?:\/\/)?(www\.)?youtube\.com\/watch\?v=([A-Za-z0-9_-]+)(&[A-Za-z0-9_-]+=[A-Za-z0-9_-]+)*/, Xre = /^(https?:\/\/)?(www\.)?youtube\.com\/embed\/([A-Za-z0-9_-]+)(\?[A-Za-z0-9_-]+=[A-Za-z0-9_-]+)*/, Qre = /^(https?:\/\/)?(www\.)?vimeo\.com\/(\d+)(\?[A-Za-z0-9_-]+=[A-Za-z0-9_-]+)*/, eie = /^(https?:\/\/)?(player\.)?vimeo\.com\/video\/(\d+)(\?[A-Za-z0-9_-]+=[A-Za-z0-9_-]+)*/;
function zR(t, e, n, r) {
  if (n.test(t))
    return t;
  const i = t.match(e);
  return i && i[3] ? `${r}/${i[3]}` : null;
}
function tie(t) {
  return zR(
    t,
    Jre,
    Xre,
    "https://www.youtube.com/embed"
  );
}
function nie(t) {
  return zR(
    t,
    Qre,
    eie,
    "https://player.vimeo.com/video"
  );
}
function rie(t) {
  return tie(t) || nie(t);
}
function qC(t, e, n = null) {
  const r = () => Array(e).fill(n);
  return Array.from({ length: t }, r);
}
function KC(t, e, n) {
  return Math.min(Math.max(t, e), n);
}
function HR(t) {
  const e = t.getAttributes("link").href, { from: n, to: r } = t.state.selection;
  let i = 0, o = "";
  if (t.state.doc.nodesBetween(n, r, (s) => {
    o = s.text || (t == null ? void 0 : t.commands.getSelectedText()), s.marks.some((a) => a.type.name === "link") && (i += 1);
  }), !o && e) {
    const a = t.view.domAtPos(n).node.querySelector(`[href='${e}']`);
    o = "", a && (o = a.textContent || "");
  }
  return {
    linkCount: i,
    linkText: o,
    linkUrl: e
  };
}
function iie({ onEdit: t }) {
  const e = xe(), { editor: n } = vr(), { presentToast: r } = Rv(), [i, o] = pe(""), [s, a] = pe("https://"), [l, c] = pe(!1);
  return n ? /* @__PURE__ */ v(
    qQ,
    {
      editor: n,
      updateDelay: 200,
      shouldShow: () => {
        c(!1);
        const { linkCount: d, linkText: f, linkUrl: h } = HR(n), p = n.commands.getSelectedText(), m = p || f, b = d === 1 && h && f === p;
        return o(m), a(h), b;
      },
      tippyOptions: {
        zIndex: 10,
        placement: "right"
      },
      children: !l && /* @__PURE__ */ F(
        "div",
        {
          className: I(
            "bg-card border-default flex origin-center justify-between border p-2 shadow-md",
            {
              "rounded-md": e.theme.appearance.corners === "rounded"
            }
          ),
          children: [
            /* @__PURE__ */ F("div", { className: "gap- flex max-w-[15ch] flex-col", children: [
              /* @__PURE__ */ v("span", { className: "text-emphasis truncate", children: i }),
              /* @__PURE__ */ v("span", { className: "text-subtle truncate", children: s })
            ] }),
            /* @__PURE__ */ F("div", { className: "flex gap-1", children: [
              /* @__PURE__ */ v(
                Sn,
                {
                  tooltipText: "Edit",
                  onClick: () => {
                    c(!0), t();
                  },
                  children: /* @__PURE__ */ v(yH, { size: 16, className: "text-default shrink-0" })
                }
              ),
              /* @__PURE__ */ v(
                Sn,
                {
                  tooltipText: "Copy",
                  onClick: () => navigator.clipboard.writeText(n.getAttributes("link").href).then(() => r({ title: "Link copied to clipboard" })).catch(
                    () => r({
                      title: "Failed to copy link to clipboard",
                      intent: "destructive"
                    })
                  ),
                  children: /* @__PURE__ */ v(Yre, { size: 16, className: "text-default shrink-0" })
                }
              ),
              /* @__PURE__ */ v(
                Sn,
                {
                  tooltipText: "Clear link",
                  onClick: () => n.chain().focus().unsetLink().run(),
                  children: /* @__PURE__ */ v(Zre, { size: 16, className: "text-default shrink-0" })
                }
              )
            ] })
          ]
        }
      )
    }
  ) : null;
}
function WR(t) {
  return Ee({ attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" }, child: [] }] })(t);
}
function oie({ setIsOpen: t }) {
  const { editor: e } = vr(), [n, r] = pe("");
  return e ? /* @__PURE__ */ F("div", { className: "flex w-[336px] flex-col gap-2 p-2", children: [
    /* @__PURE__ */ F("div", { className: "flex w-full justify-between", children: [
      /* @__PURE__ */ v(yi, { htmlFor: "insert-image", className: "text-default pb-1 align-bottom", children: "Insert web link" }),
      /* @__PURE__ */ v(Ze, { intent: "minimal", onClick: () => {
        t(!1);
      }, className: "h-auto p-1", children: /* @__PURE__ */ v(Vr, { className: "text-subtle" }) })
    ] }),
    /* @__PURE__ */ F("div", { className: "flex flex-row gap-2", children: [
      /* @__PURE__ */ v(
        hn,
        {
          id: "insert-image",
          className: "flex-1",
          type: "url",
          placeholder: "https://example.com/file.png",
          value: n,
          onChange: (s) => r(s.target.value)
        }
      ),
      /* @__PURE__ */ v(Ze, { onClick: () => {
        e.chain().focus().setImage({ src: n }).run(), t(!1);
      }, disabled: !(n != null && n.trim()), children: /* @__PURE__ */ v(WR, {}) })
    ] })
  ] }) : null;
}
const sie = ["http:", "http://", "https:", "https://", "mailto:", "tel:", "sms:"];
function aie({ setIsOpen: t }) {
  const { editor: e } = vr(), [n, r] = pe(""), [i, o] = pe("https://");
  return De(() => {
    if (!e)
      return;
    const { linkText: l, linkUrl: c } = HR(e), d = e.commands.getSelectedText() || (c ? l : "");
    r(d), o(c);
  }, [e]), e ? /* @__PURE__ */ F(je, { children: [
    /* @__PURE__ */ F("div", { className: "flex w-[336px] flex-col gap-2 p-2", children: [
      /* @__PURE__ */ F("div", { children: [
        /* @__PURE__ */ F("div", { className: "flex w-full justify-between", children: [
          /* @__PURE__ */ v(yi, { htmlFor: "display-text", className: "text-default pb-1 align-bottom", children: "Display text (optional)" }),
          /* @__PURE__ */ v(Ze, { intent: "minimal", onClick: () => t(!1), className: "h-auto p-1", children: /* @__PURE__ */ v(Vr, { className: "text-subtle" }) })
        ] }),
        /* @__PURE__ */ v(
          hn,
          {
            id: "display-text",
            type: "text",
            value: n || "",
            onChange: (l) => r(l.target.value)
          }
        )
      ] }),
      /* @__PURE__ */ F("div", { children: [
        /* @__PURE__ */ v(yi, { htmlFor: "url", className: "text-default pb-1", children: "Web link" }),
        /* @__PURE__ */ v(
          hn,
          {
            id: "url",
            type: "url",
            placeholder: "https://example.com",
            value: i || "",
            onChange: (l) => o(l.target.value)
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ F("div", { className: "flex justify-end gap-2 p-2", children: [
      /* @__PURE__ */ v(Ze, { size: "sm", intent: "minimal", onClick: () => {
        e.chain().focus().extendMarkRange("link").unsetLink().command(({ tr: l }) => (l.insertText(n), !0)).run(), t(!1);
      }, className: "mr-auto", children: "Clear Link" }),
      /* @__PURE__ */ v(Ze, { size: "sm", intent: "minimal", onClick: () => t(!1), children: "Cancel" }),
      /* @__PURE__ */ v(Ze, { size: "sm", onClick: () => {
        const c = sie.some((u) => i.startsWith(u)) ? i : `https://${i}`;
        e.chain().focus().extendMarkRange("link").setLink({ href: c }).command(({ tr: u }) => (u.insertText(n || c), !0)).run(), t(!1);
      }, disabled: !(i != null && i.trim()), children: "Save changes" })
    ] })
  ] }) : null;
}
const rc = 8, GC = 20;
function lie() {
  const t = xe(), { editor: e } = vr(), [n, r] = pe({ row: 0, column: 0 }), [i, o] = pe(qC(rc, rc));
  if (!e)
    return null;
  const s = (c) => {
    const u = Number(c.currentTarget.dataset.column || 0), d = Number(c.currentTarget.dataset.row || 0);
    r({ row: d - 1, column: u - 1 });
    const f = KC(u + 1, rc, GC), h = KC(d + 1, rc, GC);
    o(qC(h, f));
  }, a = (c) => {
    const u = Number(c.currentTarget.dataset.column || 0), d = Number(c.currentTarget.dataset.row || 0);
    e.chain().focus().insertTable({ rows: d, cols: u, withHeaderRow: !0 }).run();
  }, l = {
    gridTemplateColumns: `repeat(${i[0].length}, 1fr)`
  };
  return /* @__PURE__ */ F("div", { children: [
    /* @__PURE__ */ v("div", { className: "grid p-2 hover:cursor-pointer", style: l, children: i.map((c, u) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ v(kD, { children: c.map((d, f) => (
        // eslint-disable-next-line jsx-a11y/control-has-associated-label
        /* @__PURE__ */ v(
          "div",
          {
            className: I("bg-subtle m-px size-4", {
              "bg-brand-100 border-brand-500 border": u <= n.row && f <= n.column,
              "rounded-[1px]": t.theme.appearance.corners === "rounded"
            }),
            "data-column": f + 1,
            "data-row": u + 1,
            onMouseEnter: s,
            onMouseDown: a,
            role: "button",
            tabIndex: 0
          },
          `cell-${f}x${u}`
        )
      )) }, `row-${u}`)
    )) }),
    /* @__PURE__ */ F("p", { className: "text-subtle w-full text-center", children: [
      n.column + 1,
      "x",
      n.row + 1
    ] })
  ] });
}
function cie({ setIsOpen: t }) {
  const { editor: e } = vr(), [n, r] = pe("");
  return e ? /* @__PURE__ */ F("div", { className: "flex w-[336px] flex-col gap-2 p-2", children: [
    /* @__PURE__ */ F("div", { className: "flex w-full justify-between", children: [
      /* @__PURE__ */ v(yi, { htmlFor: "insert-image", className: "text-default pb-1 align-bottom", children: "Insert YouTube/Vimeo url" }),
      /* @__PURE__ */ v(Ze, { intent: "minimal", onClick: () => {
        t(!1);
      }, className: "h-auto p-1", children: /* @__PURE__ */ v(Vr, { className: "text-subtle" }) })
    ] }),
    /* @__PURE__ */ F("div", { className: "flex flex-row gap-2", children: [
      /* @__PURE__ */ v(
        hn,
        {
          id: "insert-image",
          className: "flex-1",
          type: "url",
          placeholder: "Video URL",
          value: n || "",
          onChange: (s) => r(s.target.value)
        }
      ),
      /* @__PURE__ */ v(Ze, { onClick: () => {
        const s = rie(n);
        s ? e.commands.insertContent(
          `<iframe
          src="${s}"
          width="500"
          height="281"
          frameborder="0"
          allowfullscreen
        >
        </iframe>`
        ) : e.commands.insertContent("<img src='INVALID_URL' alt='Invalid video URL' />"), t(!1);
      }, disabled: !(n != null && n.trim()), children: /* @__PURE__ */ v(WR, {}) })
    ] })
  ] }) : null;
}
const uie = [
  { value: g.red[500], checkmarkColor: "#fff" },
  { value: g.orange[600], checkmarkColor: "#fff" },
  { value: g.emerald[600], checkmarkColor: "#fff" },
  { value: g.blue[600], checkmarkColor: "#fff" },
  { value: g.purple[600], checkmarkColor: "#fff" },
  { value: g.pink[600], checkmarkColor: "#fff" },
  { value: g.red[200], checkmarkColor: "#000" },
  { value: g.orange[200], checkmarkColor: "#000" },
  { value: g.emerald[200], checkmarkColor: "#000" },
  { value: g.blue[200], checkmarkColor: "#000" },
  { value: g.purple[200], checkmarkColor: "#000" },
  { value: g.pink[200], checkmarkColor: "#000" }
];
function die() {
  const t = xe(), { editor: e } = vr();
  return e ? /* @__PURE__ */ F("div", { className: "flex flex-col flex-wrap gap-2", children: [
    /* @__PURE__ */ v("div", { className: "grid grid-cols-6 items-center justify-center gap-2", children: uie.map((n) => /* @__PURE__ */ v(
      fd,
      {
        className: I(
          "border-subtle m-auto flex aspect-square size-8 cursor-pointer items-center justify-center border",
          {
            "rounded-full": t.theme.appearance.corners === "rounded"
          }
        ),
        style: { backgroundColor: n.value },
        onClick: () => e.chain().focus().toggleHighlight({ color: n.value }).run(),
        children: e.getAttributes("highlight").color === n.value && /* @__PURE__ */ v(VR, { color: n.checkmarkColor })
      },
      `key-${n.value}`
    )) }),
    /* @__PURE__ */ v(
      Ze,
      {
        size: "sm",
        onClick: () => e.chain().focus().unsetHighlight().run(),
        intent: "minimal",
        children: "None"
      }
    )
  ] }) : null;
}
const Cc = [
  "text-rte-6",
  "text-rte-5",
  "text-rte-4",
  "text-rte-3",
  "text-rte-2",
  "text-rte-1",
  "text-rte-red",
  "text-rte-orange",
  "text-rte-green",
  "text-rte-blue",
  "text-rte-purple",
  "text-rte-pink"
], YC = Cc[0];
function fie({ currentColor: t, showCheckmark: e }) {
  const r = ["text-rte-1", "text-rte-2"].includes(t) ? "text-emphasis" : "text-inverted";
  return /* @__PURE__ */ F("div", { className: "relative flex items-center justify-center", children: [
    e && /* @__PURE__ */ v("span", { className: "absolute", children: /* @__PURE__ */ v(VR, { className: r }) }),
    /* @__PURE__ */ v("svg", { width: "30", height: "30", children: /* @__PURE__ */ v("circle", { cx: "15", cy: "15", r: "15", fill: "currentColor" }) })
  ] });
}
function hie({ setColor: t }) {
  const e = xe(), { editor: n } = vr(), [r, i] = pe(YC);
  if (De(() => {
    const s = Cc.filter((a) => n == null ? void 0 : n.commands.hasClass(a))[0];
    i(s);
  }, [n]), !n)
    return null;
  n.on("selectionUpdate", () => {
    const s = Cc.filter((a) => n == null ? void 0 : n.commands.hasClass(a));
    s.length > 1 ? t("text-default") : t(s[0]);
  });
  const o = (s) => {
    n.commands.addClass(s), t(s);
  };
  return /* @__PURE__ */ F("div", { className: "text-emphasis flex flex-col flex-wrap gap-2", children: [
    /* @__PURE__ */ v("div", { className: "grid grid-cols-6 items-center justify-center gap-2", children: Cc.map((s) => /* @__PURE__ */ v(
      fd,
      {
        className: I(
          "border-subtle m-auto flex aspect-square size-8 cursor-pointer items-center justify-center border",
          s,
          {
            "rounded-full": e.theme.appearance.corners === "rounded"
          }
        ),
        onClick: () => o(s),
        children: /* @__PURE__ */ v(
          fie,
          {
            currentColor: s,
            showCheckmark: r === s || !r && s === YC
          }
        )
      },
      s
    )) }),
    /* @__PURE__ */ v("p", { className: "text-subtle max-w-56 text-xs", children: "Non-gray text colors are consistent in both Light and Dark Modes." })
  ] });
}
function ic({
  children: t,
  disabled: e,
  className: n,
  tooltipText: r,
  ...i
}) {
  const o = xe();
  return /* @__PURE__ */ F(Wt, { children: [
    /* @__PURE__ */ v(Wt.Trigger, { asChild: !0, children: /* @__PURE__ */ v(Qe.Trigger, { asChild: !0, children: /* @__PURE__ */ v(
      Ze,
      {
        intent: "minimal",
        size: "xs",
        disabled: e,
        className: I(
          "text-default hover:bg-subtle flex size-4 items-center justify-center p-4 font-semibold",
          {
            "rounded-md": o.theme.appearance.corners === "rounded"
          },
          n
        ),
        ...i,
        children: t
      }
    ) }) }),
    /* @__PURE__ */ v(Wt.Portal, { children: r && /* @__PURE__ */ v(Wt.Content, { className: "z-20", children: r }) })
  ] });
}
function pie({ className: t, options: e, children: n }) {
  const r = xe(), { editor: i } = vr(), [o, s] = pe(!1), [a, l] = pe("image"), [c, u] = pe(!1), [d, f] = pe("text-default");
  if (!i)
    return null;
  const h = i.isActive("underline") || i.isActive("strike") || i.isActive("code"), p = () => i.isActive("heading", { level: 1 }) ? "heading" : i.isActive("heading", { level: 2 }) ? "heading-2" : i.isActive("heading", { level: 3 }) ? "heading-3" : i.isActive({ fontSize: "12px" }) ? "small" : i.isActive("paragraph") ? "normal" : "heading", m = (y) => {
    switch (y !== "small" && i.commands.unsetFontSize(), y) {
      case "heading":
        i.chain().focus().toggleHeading({ level: 1 }).run();
        break;
      case "heading-2":
        i.chain().focus().toggleHeading({ level: 2 }).run();
        break;
      case "heading-3":
        i.chain().focus().toggleHeading({ level: 3 }).run();
        break;
      case "normal":
        i.chain().focus().setParagraph().selectParentNode().setFontSize("16px").run();
        break;
      case "small":
        i.chain().focus().setParagraph().selectParentNode().setFontSize("12px").run();
        break;
    }
  }, b = {
    onCloseAutoFocus: (y) => {
      y.preventDefault();
    },
    onFocusOutside: (y) => {
      y.preventDefault();
    }
  };
  return /* @__PURE__ */ F(
    "div",
    {
      className: I(
        {
          "rounded-tl-lg rounded-tr-lg": r.theme.appearance.corners === "rounded"
        },
        "bg-default border-subtle flex shrink-0 flex-wrap items-center gap-1 overflow-auto border-b border-t p-2 pb-2",
        t
      ),
      children: [
        /* @__PURE__ */ v(iie, { onEdit: () => u(!0) }),
        (e == null ? void 0 : e.includes("heading")) && /* @__PURE__ */ F(
          qr,
          {
            value: p(),
            defaultValue: "heading",
            onValueChange: m,
            children: [
              /* @__PURE__ */ v(qr.Trigger, { size: "sm", className: "h-6 w-[110px] whitespace-nowrap p-1" }),
              /* @__PURE__ */ F(qr.Content, { className: "min-w-[173px]", children: [
                /* @__PURE__ */ v(qr.Item, { value: "heading", className: "text-2xl font-semibold", children: "Heading 1" }),
                /* @__PURE__ */ v(qr.Item, { value: "heading-2", className: "text-xl font-medium", children: "Heading 2" }),
                /* @__PURE__ */ v(qr.Item, { value: "heading-3", className: "text-lg font-medium", children: "Heading 3" }),
                /* @__PURE__ */ v(qr.Item, { value: "normal", children: "Normal text" }),
                /* @__PURE__ */ v(qr.Item, { value: "small", children: "Small" })
              ] })
            ]
          }
        ),
        (e == null ? void 0 : e.includes("bold")) && /* @__PURE__ */ v(
          Sn,
          {
            tooltipText: "Bold",
            onClick: () => i.chain().focus().toggleBold().run(),
            disabled: !i.can().chain().focus().toggleBold().run(),
            className: i.isActive("bold") ? "bg-subtle" : "",
            children: "B"
          }
        ),
        (e == null ? void 0 : e.includes("italic")) && /* @__PURE__ */ v(
          Sn,
          {
            tooltipText: "Italic",
            onClick: () => i.chain().focus().toggleItalic().run(),
            disabled: !i.can().chain().focus().toggleItalic().run(),
            className: i.isActive("italic") ? "bg-subtle" : "",
            children: /* @__PURE__ */ v(Vre, { size: 16, className: "shrink-0" })
          }
        ),
        ((e == null ? void 0 : e.includes("underline")) || (e == null ? void 0 : e.includes("strikethrough")) || (e == null ? void 0 : e.includes("link")) || (e == null ? void 0 : e.includes("code")) || (e == null ? void 0 : e.includes("clear_formatting"))) && /* @__PURE__ */ F(lt, { open: c, onOpenChange: u, children: [
          /* @__PURE__ */ v(lt.Anchor, {}),
          /* @__PURE__ */ v(lt.Content, { align: "start", sideOffset: 34, ...b, children: /* @__PURE__ */ v(aie, { setIsOpen: u }) }),
          /* @__PURE__ */ F(Qe, { children: [
            /* @__PURE__ */ v(
              ic,
              {
                tooltipText: "More Formatting",
                className: I({
                  "bg-subtle": h
                }),
                children: /* @__PURE__ */ v(VS, { size: 16, className: "shrink-0" })
              }
            ),
            /* @__PURE__ */ F(Qe.Content, { className: "space-y-2", align: "start", ...b, children: [
              e.includes("underline") && /* @__PURE__ */ F(
                Qe.Item,
                {
                  onSelect: () => i.chain().focus().toggleUnderline().run(),
                  className: I("items-center", {
                    "bg-subtle": i.isActive("underline")
                  }),
                  children: [
                    /* @__PURE__ */ v(bH, { size: 16, className: "mt-px" }),
                    " ",
                    /* @__PURE__ */ v("span", { children: "Underline" })
                  ]
                }
              ),
              e.includes("strikethrough") && /* @__PURE__ */ F(
                Qe.Item,
                {
                  onSelect: () => i.chain().focus().toggleStrike().run(),
                  className: I("items-center", {
                    "bg-subtle": i.isActive("strike")
                  }),
                  children: [
                    /* @__PURE__ */ v(kH, { size: 16, className: "mt-px" }),
                    " ",
                    /* @__PURE__ */ v("span", { children: "Strikethrough" })
                  ]
                }
              ),
              /* @__PURE__ */ v(lt.Trigger, { className: "w-full", asChild: !0, children: e.includes("link") && /* @__PURE__ */ F(
                Qe.Item,
                {
                  className: I("w-full", {
                    "bg-subtle": i.isActive("link")
                  }),
                  children: [
                    /* @__PURE__ */ v(SI, { size: 16, className: "shrink-0" }),
                    /* @__PURE__ */ v("span", { children: "Link" })
                  ]
                }
              ) }),
              e.includes("code") && /* @__PURE__ */ F(
                Qe.Item,
                {
                  onSelect: () => i.chain().focus().toggleCode().run(),
                  className: I("items-center", {
                    "bg-subtle": i.isActive("code")
                  }),
                  children: [
                    /* @__PURE__ */ v(zS, { size: 16, className: "mt-px" }),
                    " ",
                    /* @__PURE__ */ v("span", { children: "Code" })
                  ]
                }
              ),
              e.includes("clear_formatting") && /* @__PURE__ */ F(
                Qe.Item,
                {
                  onSelect: () => i.chain().focus().clearNodes().unsetAllMarks().run(),
                  className: "items-center",
                  children: [
                    /* @__PURE__ */ v(xH, { size: 16, className: "mt-px" }),
                    " ",
                    /* @__PURE__ */ v("span", { children: "Clear formatting" })
                  ]
                }
              )
            ] })
          ] })
        ] }),
        (e == null ? void 0 : e.includes("text_color")) && /* @__PURE__ */ F(je, { children: [
          /* @__PURE__ */ v("div", { className: "bg-subtle h-6 w-px" }),
          /* @__PURE__ */ F(Qe, { children: [
            /* @__PURE__ */ v(
              ic,
              {
                tooltipText: "Text Color",
                className: I({ "bg-subtle": i.isActive("textStyle") }),
                children: /* @__PURE__ */ F("span", { className: "text-default flex flex-col items-center justify-center", children: [
                  /* @__PURE__ */ v($re, { size: 12, className: "shrink-0" }),
                  /* @__PURE__ */ v(
                    "svg",
                    {
                      className: d,
                      width: "14",
                      height: "4",
                      xmlns: "http://www.w3.org/2000/svg",
                      children: /* @__PURE__ */ v("rect", { width: "14", height: "3", fill: "currentColor" })
                    }
                  )
                ] })
              }
            ),
            /* @__PURE__ */ v(Qe.Content, { align: "center", ...b, children: /* @__PURE__ */ v(hie, { setColor: f }) })
          ] })
        ] }),
        (e == null ? void 0 : e.includes("highlight_color")) && /* @__PURE__ */ F(Qe, { children: [
          /* @__PURE__ */ v(
            ic,
            {
              tooltipText: "Highlight Color",
              className: I({ "bg-subtle": i.isActive("textStyle") }),
              children: /* @__PURE__ */ F("span", { className: "text-default flex flex-col items-center justify-center gap-0.5", children: [
                /* @__PURE__ */ v(Ij, { size: 10, className: "shrink-0" }),
                /* @__PURE__ */ v("svg", { width: "14", height: "4", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ v(
                  "rect",
                  {
                    width: "14",
                    height: "3",
                    fill: i.getAttributes("highlight").color || "currentColor"
                  }
                ) })
              ] })
            }
          ),
          /* @__PURE__ */ v(Qe.Content, { align: "center", ...b, children: /* @__PURE__ */ v(die, {}) })
        ] }),
        ((e == null ? void 0 : e.includes("align_left")) || (e == null ? void 0 : e.includes("align_center")) || (e == null ? void 0 : e.includes("align_right"))) && /* @__PURE__ */ v("div", { className: "bg-subtle h-6 w-px" }),
        (e == null ? void 0 : e.includes("align_left")) && /* @__PURE__ */ v(
          Sn,
          {
            tooltipText: "Align Left",
            onClick: () => i.chain().focus().setTextAlign("left").run(),
            className: i.isActive({ textAlign: "left" }) ? "bg-subtle" : "",
            children: /* @__PURE__ */ v(OI, { size: 16, className: "text-default shrink-0" })
          }
        ),
        (e == null ? void 0 : e.includes("align_center")) && /* @__PURE__ */ v(
          Sn,
          {
            tooltipText: "Align Center",
            onClick: () => i.chain().focus().setTextAlign("center").run(),
            className: i.isActive({ textAlign: "center" }) ? "bg-subtle" : "",
            children: /* @__PURE__ */ v(NI, { size: 16, className: "text-default shrink-0" })
          }
        ),
        (e == null ? void 0 : e.includes("align_right")) && /* @__PURE__ */ v(
          Sn,
          {
            tooltipText: "Align Right",
            onClick: () => i.chain().focus().setTextAlign("right").run(),
            className: i.isActive({ textAlign: "right" }) ? "bg-subtle" : "",
            children: /* @__PURE__ */ v(AI, { size: 16, className: "text-default shrink-0" })
          }
        ),
        ((e == null ? void 0 : e.includes("bullet_list")) || (e == null ? void 0 : e.includes("numbered_list"))) && /* @__PURE__ */ v("div", { className: "bg-subtle h-6 w-px" }),
        (e == null ? void 0 : e.includes("bullet_list")) && /* @__PURE__ */ v(
          Sn,
          {
            tooltipText: "Bullet List",
            onClick: () => i.chain().focus().toggleBulletList().run(),
            className: i.isActive("bulletList") ? "bg-subtle" : "",
            children: /* @__PURE__ */ v(RI, { size: 16, className: "text-default shrink-0" })
          }
        ),
        (e == null ? void 0 : e.includes("numbered_list")) && /* @__PURE__ */ v(
          Sn,
          {
            tooltipText: "Numbered List",
            onClick: () => i.chain().focus().toggleOrderedList().run(),
            className: i.isActive("orderedList") ? "bg-subtle" : "",
            children: /* @__PURE__ */ v(gH, { size: 16, className: "text-default shrink-0" })
          }
        ),
        ((e == null ? void 0 : e.includes("quote_block")) || (e == null ? void 0 : e.includes("table")) || (e == null ? void 0 : e.includes("divider")) || (e == null ? void 0 : e.includes("image")) || (e == null ? void 0 : e.includes("video"))) && /* @__PURE__ */ F(je, { children: [
          /* @__PURE__ */ v("div", { className: "bg-subtle h-6 w-px" }),
          /* @__PURE__ */ F(lt, { open: o, onOpenChange: s, children: [
            /* @__PURE__ */ v(lt.Anchor, {}),
            /* @__PURE__ */ F(lt.Content, { align: "start", sideOffset: 14, ...b, children: [
              a === "image" && /* @__PURE__ */ v(oie, { setIsOpen: s }),
              a === "video" && /* @__PURE__ */ v(cie, { setIsOpen: s })
            ] }),
            /* @__PURE__ */ F(Qe, { children: [
              /* @__PURE__ */ v(ic, { tooltipText: "Insert", children: /* @__PURE__ */ v(EI, { size: 16, className: "text-default shrink-0" }) }),
              /* @__PURE__ */ F(Qe.Content, { align: "start", className: "space-y-2", ...b, children: [
                (e == null ? void 0 : e.includes("quote_block")) && /* @__PURE__ */ v(
                  Qe.Item,
                  {
                    className: I({
                      "bg-subtle": i.isActive("blockquote")
                    }),
                    onSelect: () => i.chain().focus().toggleBlockquote().run(),
                    children: /* @__PURE__ */ F("div", { className: "flex items-center gap-2", children: [
                      /* @__PURE__ */ v(vH, { size: 16 }),
                      /* @__PURE__ */ v("span", { children: "Quote Block" })
                    ] })
                  }
                ),
                (e == null ? void 0 : e.includes("table")) && /* @__PURE__ */ F(Qe.SubMenu, { children: [
                  /* @__PURE__ */ v(Qe.SubTrigger, { children: /* @__PURE__ */ F("div", { className: "flex w-full cursor-pointer items-center gap-2", children: [
                    /* @__PURE__ */ v(MI, { size: 16 }),
                    /* @__PURE__ */ v("span", { children: "Table" })
                  ] }) }),
                  /* @__PURE__ */ v(Qe.Portal, { children: /* @__PURE__ */ v(Qe.SubContent, { sideOffset: 10, children: /* @__PURE__ */ v(lie, {}) }) })
                ] }),
                (e == null ? void 0 : e.includes("divider")) && /* @__PURE__ */ v(
                  Qe.Item,
                  {
                    onSelect: () => i.chain().focus().setHorizontalRule().run(),
                    className: I({
                      "bg-subtle": i.isActive("horizontalRule")
                    }),
                    children: /* @__PURE__ */ F("div", { className: "flex items-center gap-2", children: [
                      /* @__PURE__ */ v(Bre, { size: 16, className: "shrink-0" }),
                      /* @__PURE__ */ v("span", { children: "Divider" })
                    ] })
                  }
                ),
                (e == null ? void 0 : e.includes("image")) && /* @__PURE__ */ v(lt.Trigger, { asChild: !0, children: /* @__PURE__ */ v(Qe.Item, { onSelect: () => l("image"), children: /* @__PURE__ */ F("div", { className: "flex items-center gap-2", children: [
                  /* @__PURE__ */ v(DI, { size: 16, className: "shrink-0" }),
                  /* @__PURE__ */ v("span", { children: "Image" })
                ] }) }) }),
                (e == null ? void 0 : e.includes("video")) && /* @__PURE__ */ v(lt.Trigger, { asChild: !0, children: /* @__PURE__ */ v(Qe.Item, { onSelect: () => l("video"), children: /* @__PURE__ */ F("div", { className: "flex items-center gap-2", children: [
                  /* @__PURE__ */ v(II, { size: 16, className: "shrink-0" }),
                  /* @__PURE__ */ v("span", { children: "Video" })
                ] }) }) })
              ] })
            ] })
          ] })
        ] }),
        n
      ]
    }
  );
}
const mie = 250, gie = [
  BJ.configure({ types: [eC.name, tC.name, X3.name] }),
  eC.configure(),
  tC.configure({
    multicolor: !0
  }),
  Mne.configure(),
  Fre.configure(),
  wQ.configure(),
  fX.configure({
    HTMLAttributes: { target: "_blank" }
  }),
  yQ.configure({
    types: ["heading", "paragraph"]
  }),
  qee.configure({
    paragraph: !1,
    bulletList: {
      keepMarks: !0,
      keepAttributes: !1
    },
    orderedList: {
      keepMarks: !0,
      keepAttributes: !1
    }
  }),
  mQ.configure({
    resizable: !0
  }),
  vQ,
  bQ,
  gQ,
  WJ.configure({
    inline: !0
  }),
  SQ.configure({
    HTMLAttributes: {
      target: "_blank",
      rel: "noreferrer"
    }
  }),
  Cne,
  LJ,
  Tne,
  Ene,
  FJ.configure(),
  xne,
  // This plugin doesn't have the proper type, but it works
  Sne,
  kne
], vie = [
  "heading",
  "bold",
  "italic",
  "link",
  "underline",
  "strikethrough",
  "code",
  "clear_formatting",
  "text_color",
  "highlight_color",
  "align_left",
  "align_center",
  "align_right",
  "bullet_list",
  "numbered_list",
  "quote_block",
  "table",
  "divider",
  "image",
  "video",
  "edit_html"
];
function bie({
  className: t,
  intent: e = "default",
  menuBarClassName: n,
  footerClassName: r,
  monacoEditorClassName: i,
  richTextClassName: o,
  extensions: s,
  slotBefore: a,
  slotAfter: l,
  children: c,
  toolBarOptions: u = [...vie],
  characterLimit: d,
  content: f,
  showOverflowGradient: h,
  toolbarChildren: p,
  ...m
}) {
  const b = xe(), y = Me(null), [k, C] = pe(!1), [x, S] = pe(f), T = Me(null), E = Me(null);
  return /* @__PURE__ */ F(
    "div",
    {
      ref: y,
      className: I(`relative flex w-fit h-[${mie}px]`, t),
      children: [
        k ? /* @__PURE__ */ v(
          Lre,
          {
            monacoEditor: T,
            setIsHtmlMode: C,
            currentEditorContent: x,
            className: I("absolute left-0 top-0 size-full", i),
            onUpdate: (M) => {
              var O;
              (O = E.current) == null || O.commands.setContent(M, !1), m.onUpdate && E.current && m.onUpdate({ editor: E.current });
            }
          }
        ) : null,
        /* @__PURE__ */ v(
          CR,
          {
            "data-testid": m["data-testid"],
            style: { wordBreak: "break-word" },
            className: I(
              "kn-rich-text-editor border-subtle bg-input flex w-full flex-col content-stretch items-stretch overflow-hidden border border-t-0 [&>*:nth-child(2)>:first-child]:p-2",
              // To customize the editor wrapper, we have to use either the hook or use a css selector like this one
              // With this we ensure that if the rich text is inside a container with a fixed width/height, the editor will fill the space and show a scrollbar if needed
              "[&>*:nth-child(2)>:first-child]:h-full [&>*:nth-child(2)>:first-child]:overflow-auto [&>*:nth-child(2)]:flex-grow [&>*:nth-child(2)]:overflow-hidden [&>*>*:focus]:outline-none",
              // Allow the consumer to override the rounded corners
              { "rounded-lg": b.theme.appearance.corners === "rounded" },
              {
                "border-destructive": e === "destructive",
                // Keep the RichTextEditor mounted as the OnUpdate callback used by consumers needs the TipTap reference alive.
                // Instead of hiding the editor, we make it invisible and unclickable.
                // This way it can dictate the size of the parent div.
                "pointer-events-none opacity-0 [&_*_]:pointer-events-none": k
              },
              o
            ),
            children: /* @__PURE__ */ v(
              UQ,
              {
                extensions: s || gie,
                content: x,
                slotBefore: a || /* @__PURE__ */ v(
                  pie,
                  {
                    className: I(n, {
                      "border-t-destructive": e === "destructive"
                    }),
                    options: u,
                    children: p
                  }
                ),
                slotAfter: l || /* @__PURE__ */ v(
                  One,
                  {
                    className: I(r, {
                      "border-t-destructive": e === "destructive"
                    }),
                    options: u,
                    isHtmlMode: k,
                    setIsHtmlMode: C,
                    setCurrentEditorContent: S,
                    characterLimit: d,
                    showOverflowGradient: h
                  }
                ),
                ...m,
                onUpdate: async ({ editor: M }) => {
                  const O = M.getHTML();
                  S(O), m.onUpdate && m.onUpdate({ editor: M });
                },
                onCreate: (M) => {
                  E.current = M.editor, m.onCreate && m.onCreate(M);
                },
                children: c
              }
            )
          }
        )
      ]
    }
  );
}
bie.displayName = "RichTextEditor";
const yie = {}, ZC = {
  name: "skeleton",
  base: ["animate-pulse", "bg-subtle"],
  config: {
    variants: yie
  }
}, wie = {
  name: "skeleton-image",
  base: ["bg-emphasis", "flex", "aspect-video", "animate-pulse", "items-center", "justify-center"],
  config: {}
}, xie = {
  name: "skeleton-video",
  base: ["bg-emphasis", "flex", "aspect-video", "animate-pulse", "items-center", "justify-center"],
  config: {}
}, kie = Ie(ZC.base, ZC.config);
function Cie({ className: t, ...e }) {
  const n = xe();
  return /* @__PURE__ */ v(
    "div",
    {
      "data-testid": "asterisk-skeleton",
      className: I(
        "kn-skeleton",
        kie(),
        {
          "rounded-md": n.theme.appearance.corners === "rounded"
        },
        t
      ),
      ...e
    }
  );
}
function jR({ className: t, ...e }) {
  const n = xe();
  return /* @__PURE__ */ v(
    "div",
    {
      "data-testid": "asterisk-skeleton-image",
      className: I(
        "kn-skeleton-image",
        wie.base.join(" "),
        {
          "rounded-md": n.theme.appearance.corners === "rounded"
        },
        t
      ),
      ...e,
      children: /* @__PURE__ */ v(
        "svg",
        {
          className: "max-h-12 max-w-12 p-2 text-gray-200",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-hidden": "true",
          fill: "currentColor",
          viewBox: "0 0 640 512",
          children: /* @__PURE__ */ v("path", { d: "M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" })
        }
      )
    }
  );
}
function UR({ className: t, ...e }) {
  const n = xe();
  return /* @__PURE__ */ F(
    "div",
    {
      "data-testid": "asterisk-skeleton-video",
      className: I(
        "kn-skeleton-video",
        xie.base.join(" "),
        {
          "rounded-md": n.theme.appearance.corners === "rounded"
        },
        t
      ),
      ...e,
      children: [
        /* @__PURE__ */ v(
          "svg",
          {
            className: "max-h-12 max-w-12 p-2 text-gray-200",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true",
            fill: "currentColor",
            viewBox: "0 0 384 512",
            children: /* @__PURE__ */ v("path", { d: "M361 215C375.3 223.8 384 239.3 384 256C384 272.7 375.3 288.2 361 296.1L73.03 472.1C58.21 482 39.66 482.4 24.52 473.9C9.377 465.4 0 449.4 0 432V80C0 62.64 9.377 46.63 24.52 38.13C39.66 29.64 58.21 29.99 73.03 39.04L361 215z" })
          }
        ),
        /* @__PURE__ */ v("span", { className: "sr-only", children: "Loading..." })
      ]
    }
  );
}
const fse = Object.assign(Cie, {
  Image: jR,
  Video: UR
});
jR.displayName = "Skeleton.Image";
UR.displayName = "Skeleton.Video";
const Sie = {
  intent: {
    default: ["border-default"],
    destructive: ["border-destructive", "hover:border-destructive"]
  }
}, JC = {
  name: "multiselect-trigger",
  base: [
    "focus:border-default",
    "focus:outline-default",
    "focus:hover:border-emphasis",
    "hover:border-emphasis",
    "bg-input",
    "flex",
    "w-full",
    "items-center",
    "justify-between",
    "border",
    "p-1",
    "text-left",
    "disabled:cursor-not-allowed",
    "disabled:bg-muted",
    "disabled:border-default",
    "disabled:text-subtle"
  ],
  config: {
    variants: Sie,
    defaultVariants: {
      intent: "default"
    }
  }
}, Tie = Ie(
  JC.base,
  JC.config
), XC = {
  name: "multiselect-content",
  base: [
    "data-[state=open]:animate-slideDownAndFade",
    "border-subtle",
    "text-default",
    "bg-menu",
    "relative",
    "overflow-hidden",
    "border",
    "p-2",
    "shadow-md"
  ],
  config: {}
};
function QC({
  isSearchEnabled: t = !1,
  searchPlaceholder: e = "Search...",
  selectAllText: n = "Select all",
  selectedText: r = "selected",
  options: i,
  filteredOptions: o,
  selectedOptions: s,
  optionsClassName: a = "",
  itemClassName: l = "",
  searchValue: c,
  addOptionText: u = "Add",
  handleSelectOption: d,
  onAddOption: f,
  setSearchValue: h,
  onSelectOptions: p,
  onSearchChange: m,
  description: b,
  isSelectAllEnabled: y = !0,
  virtualizerEstimateSize: k = 40,
  virtualizerGap: C = 2,
  virtualizerPaddingEnd: x = 4
}) {
  const S = xe(), T = Me(null), E = i.filter(($) => !$.isDisabled), M = f && c && !o.some(($) => $.label === c), O = xA({
    count: o.length,
    getScrollElement: () => T.current,
    estimateSize: () => k,
    gap: C,
    paddingEnd: x
  }), L = () => {
    let $;
    return s.length === E.length ? $ = [] : $ = E, p($), $;
  };
  return /* @__PURE__ */ F("div", { children: [
    t && /* @__PURE__ */ F(je, { children: [
      /* @__PURE__ */ F(
        "div",
        {
          className: "flex items-center justify-between p-2",
          "data-testid": "asterisk-multiselect-search",
          children: [
            /* @__PURE__ */ v(
              hn,
              {
                "data-testid": "asterisk-multiselect-search-input",
                placeholder: e,
                onChange: ($) => {
                  const z = $.target.value;
                  h(z), m && m(z);
                },
                className: "focus:ring-none ml-1 h-auto border-none p-0 focus:border-none focus:outline-0 focus:outline-offset-0 focus:ring-offset-0"
              }
            ),
            M ? /* @__PURE__ */ v(
              Ze,
              {
                intent: "minimal",
                onClick: () => h(""),
                className: "h-auto p-1",
                "data-testid": "asterisk-multiselect-clear-search",
                children: /* @__PURE__ */ v(Vr, { className: "text-subtle flex-shrink-0" })
              }
            ) : /* @__PURE__ */ v(HS, { size: 16, className: "text-subtle flex-shrink-0" })
          ]
        }
      ),
      /* @__PURE__ */ v(um, { className: "mb-2" }),
      M && /* @__PURE__ */ F(
        Ze,
        {
          "data-testid": "asterisk-multiselect-add-option-button",
          intent: "minimal",
          className: "w-full justify-start font-normal",
          onClick: () => {
            f(c);
          },
          children: [
            u,
            " '",
            c,
            "'"
          ]
        }
      )
    ] }),
    b && /* @__PURE__ */ v("div", { className: "mb-2 ml-3", "data-testid": "asterisk-multiselect-description", children: /* @__PURE__ */ v("span", { className: "text-subtle", children: b }) }),
    y && /* @__PURE__ */ F(je, { children: [
      /* @__PURE__ */ F(
        "div",
        {
          className: "mb-2 flex items-center justify-between p-2",
          "data-testid": "asterisk-multiselect-select-all",
          children: [
            /* @__PURE__ */ F("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ v(
                wx,
                {
                  "data-testid": "asterisk-multiselect-select-all-checkbox",
                  id: "select-all-checkbox",
                  checked: s.length === E.length && E.length > 0,
                  onClick: L
                }
              ),
              /* @__PURE__ */ v(yi, { htmlFor: "select-all-checkbox", children: n })
            ] }),
            /* @__PURE__ */ F("span", { className: "text-muted", "data-testid": "asterisk-multiselect-selected-count", children: [
              s.length,
              " ",
              r
            ] })
          ]
        }
      ),
      /* @__PURE__ */ v(um, { className: "mb-2" })
    ] }),
    /* @__PURE__ */ v(
      "div",
      {
        "data-testid": "asterisk-multiselect-options-container",
        className: "relative w-full overflow-auto",
        ref: T,
        style: { maxHeight: 360 },
        "data-virtualizer-container": !0,
        children: /* @__PURE__ */ v(
          "div",
          {
            "data-testid": "asterisk-multiselect-options",
            className: I("w-full", a),
            style: { height: `${O.getTotalSize()}px` },
            children: O.getVirtualItems().map(($) => {
              const z = o[$.index], B = o[$.index - 1], A = !!(s != null && s.find((N) => N.key === z.key));
              return /* @__PURE__ */ v(
                "div",
                {
                  "data-testid": "asterisk-multiselect-option",
                  className: "absolute w-full pr-2",
                  style: {
                    transform: `translateY(${B != null && B.description ? $.start + 6 : $.start}px)`
                  },
                  children: /* @__PURE__ */ v(
                    Ze,
                    {
                      "data-testid": `asterisk-multiselect-option-${z.key}`,
                      intent: "minimal",
                      className: I(
                        "hover:bg-subtle flex w-full justify-start gap-2 p-2 focus:bg-transparent focus-visible:bg-transparent",
                        {
                          "rounded-lg": S.theme.appearance.corners === "rounded"
                        },
                        l
                      ),
                      asChild: !0,
                      children: /* @__PURE__ */ F(
                        yi,
                        {
                          className: I("flex w-full gap-2", {
                            "cursor-not-allowed": z.isDisabled,
                            "h-12 items-start": z.description
                          }),
                          children: [
                            /* @__PURE__ */ v(
                              wx,
                              {
                                "data-testid": `asterisk-multiselect-option-checkbox-${z.key}`,
                                checked: A,
                                disabled: z.isDisabled,
                                onCheckedChange: () => d(z)
                              }
                            ),
                            /* @__PURE__ */ F("div", { className: "flex flex-col leading-none", children: [
                              /* @__PURE__ */ v("span", { className: "w-full overflow-hidden truncate text-ellipsis whitespace-nowrap font-medium", children: z.label }),
                              z.description && /* @__PURE__ */ v(
                                "p",
                                {
                                  className: "text-muted w-full overflow-hidden truncate text-ellipsis whitespace-nowrap text-sm font-normal",
                                  "data-testid": `asterisk-multiselect-option-description-${z.key}`,
                                  children: z.description
                                }
                              )
                            ] })
                          ]
                        }
                      )
                    }
                  )
                },
                $.key
              );
            })
          }
        )
      }
    )
  ] });
}
function hse(t) {
  const {
    id: e,
    options: n = [],
    disabled: r = !1,
    selectedOptions: i,
    intent: o,
    align: s = "end",
    placeholder: a = "Select...",
    maxVisibleChips: l = 1,
    shouldRenderInline: c = !1,
    triggerClassName: u = "",
    contentClassName: d = "",
    chipTextClassName: f = "",
    onSelectOptions: h,
    onSearchChange: p,
    shouldIgnoreFiltering: m = !1
  } = t, b = xe(), [y, k] = pe(""), C = i.length, x = C > l, S = En(
    () => m ? n : n.filter(
      (M) => M.label.toLowerCase().includes(y.toLowerCase())
    ),
    [n, y, m]
  ), T = (M) => {
    let O;
    i.some((L) => L.key === M.key) ? O = i.filter((L) => L.key !== M.key) : O = [...i, M], h(O);
  }, E = /* @__PURE__ */ F(je, { children: [
    C === 0 && /* @__PURE__ */ v("span", { className: "text-subtle flex h-8 flex-col justify-center", children: a }),
    x ? /* @__PURE__ */ F("div", { className: "flex flex-wrap gap-2", children: [
      i == null ? void 0 : i.slice(0, l).map((M) => /* @__PURE__ */ v(
        Zh,
        {
          text: M.label,
          className: "text-subtle m-0",
          textClassName: f,
          onClose: (O) => {
            O.preventDefault(), T(M);
          }
        },
        M.key
      )),
      /* @__PURE__ */ v(
        Zh,
        {
          text: `+${C - l} more`,
          className: "text-subtle m-0",
          textClassName: f
        }
      )
    ] }) : /* @__PURE__ */ v("div", { className: "flex flex-wrap gap-2", children: i == null ? void 0 : i.map((M) => /* @__PURE__ */ v(
      Zh,
      {
        text: M.label,
        className: "text-subtle m-0",
        textClassName: f,
        onClose: (O) => {
          O.preventDefault(), T(M);
        }
      },
      M.key
    )) }),
    /* @__PURE__ */ F("div", { className: "flex gap-2", children: [
      /* @__PURE__ */ v("div", { className: "bg-subtle w-[1px]" }),
      /* @__PURE__ */ v(Vu, { size: 16 })
    ] })
  ] });
  return c ? /* @__PURE__ */ v(
    "div",
    {
      className: I(
        XC.base.join(" "),
        {
          "rounded-xl": b.theme.appearance.corners === "rounded"
        },
        d
      ),
      children: /* @__PURE__ */ v(
        QC,
        {
          filteredOptions: S,
          searchValue: y,
          setSearchValue: k,
          handleSelectOption: T,
          ...t
        }
      )
    }
  ) : /* @__PURE__ */ F(
    lt,
    {
      onOpenChange: () => {
        k(""), p && p("");
      },
      children: [
        /* @__PURE__ */ v(
          lt.Trigger,
          {
            id: e,
            disabled: r,
            className: I(
              "kn-multiselect-trigger",
              Tie({ intent: o }),
              {
                "rounded-lg": b.theme.appearance.corners === "rounded",
                "px-2": C === 0
              },
              u
            ),
            children: E
          }
        ),
        /* @__PURE__ */ v(
          lt.Content,
          {
            sideOffset: 4,
            style: {
              width: "var(--radix-popover-trigger-width)"
            },
            align: s,
            className: I(
              "kn-multiselect-content",
              XC.base.join(" "),
              d
            ),
            children: /* @__PURE__ */ v(
              QC,
              {
                searchValue: y,
                filteredOptions: S,
                setSearchValue: k,
                handleSelectOption: T,
                ...t
              }
            )
          }
        )
      ]
    }
  );
}
const Eie = {
  size: {
    default: ["h-5", "w-8"],
    sm: ["h-4", "w-7"],
    lg: ["h-6", "w-10"]
  }
}, eS = {
  name: "switch",
  base: [
    "inline-flex",
    "shrink-0",
    "cursor-pointer",
    "items-center",
    "border",
    "p-0.5",
    "border-subtle",
    "transition-colors",
    "group",
    "data-[state=unchecked]:bg-default",
    "data-[state=checked]:bg-inverted",
    "data-[state=unchecked]:hover:bg-emphasis",
    "data-[state=checked]:hover:bg-intense",
    "data-[state=unchecked]:disabled:bg-muted",
    "data-[state=checked]:disabled:bg-action",
    "focus-visible:outline-none",
    "focus-visible:ring-2",
    "focus-visible:ring-default",
    "focus-visible:ring-offset-2",
    "disabled:cursor-not-allowed",
    "disabled:opacity-50",
    "disabled:border-0"
  ],
  config: {
    variants: Eie,
    defaultVariants: {
      size: "default"
    }
  }
}, Mie = Ie(eS.base, eS.config), Oie = {
  size: {
    default: ["h-4", "w-4", "data-[state=checked]:translate-x-2.5"],
    sm: ["h-3", "w-3", "data-[state=checked]:translate-x-2.5"],
    lg: ["h-5", "w-5", "data-[state=checked]:translate-x-3.5"]
  }
}, tS = {
  name: "switch-thumb",
  base: [
    "bg-intense",
    "group-hover:bg-inverted",
    "data-[state=checked]:bg-default",
    "data-[state=checked]:translate-x-[13px]",
    "data-[state=checked]:group-hover:bg-default",
    "data-[state=checked]:group-disabled:bg-default",
    "group-disabled:bg-emphasis",
    "block",
    "shadow-lg",
    "ring-0",
    "transition-transform",
    "data-[state=unchecked]:translate-x-0"
  ],
  config: {
    variants: Oie,
    defaultVariants: {
      size: "default"
    }
  }
}, Aie = Ie(tS.base, tS.config);
function Nie({ className: t, size: e, ...n }, r) {
  const i = xe();
  return /* @__PURE__ */ v(
    WV,
    {
      "data-testid": "asterisk-switch",
      className: I(
        "kn-switch",
        Mie({ size: e }),
        {
          "rounded-full": i.theme.appearance.corners === "rounded"
        },
        t
      ),
      ...n,
      ref: r,
      children: /* @__PURE__ */ v(
        jV,
        {
          "data-testid": "asterisk-switch-thumb",
          className: I(
            Aie({ size: e }),
            {
              "rounded-full": i.theme.appearance.corners === "rounded"
            },
            t
          )
        }
      )
    }
  );
}
const pse = ce(Nie), Rie = {
  name: "table-wrapper",
  base: ["w-full", "overflow-auto", "border", "border-subtle"],
  config: {}
}, Die = {
  name: "table",
  base: ["w-full", "table", "border-collapse", "border-none"],
  config: {}
}, Iie = {
  name: "table-header",
  base: ["border-none", "bg-muted"],
  config: {}
}, _ie = {
  name: "table-row",
  base: [
    "text-default",
    "transition-colors",
    "[&>td:first-child]:border-l-0",
    "[&>td:last-child]:border-r-0",
    "[&>th:last-child]:border-r-0",
    "[&:last-child>td]:border-b-0",
    "border-b-0",
    "border-t-0"
  ],
  config: {}
}, Pie = {
  name: "table-head",
  base: [
    "text-emphasis",
    "h-12",
    "px-4",
    "text-left",
    "align-middle",
    "font-medium",
    "[&:has([role=checkbox])]:pr-0",
    "border-subtle",
    "border-r",
    "border-b",
    "border-l-0",
    "border-t-0"
  ],
  config: {}
}, Lie = {
  name: "table-cell",
  base: [
    "p-4",
    "align-middle",
    "[&:has([role=checkbox])]:pr-0",
    "border-subtle",
    "border-r",
    "border-b",
    "border-l-0",
    "border-t-0"
  ],
  config: {}
}, qR = he.forwardRef(
  ({ className: t, ...e }, n) => {
    const r = xe();
    return /* @__PURE__ */ v(
      "div",
      {
        "data-testid": "asterisk-table-wrapper",
        ref: n,
        className: I(
          "kn-table-wrapper",
          Rie.base.join(" "),
          {
            "rounded-md": r.theme.appearance.corners === "rounded"
          },
          t
        ),
        ...e
      }
    );
  }
), KR = he.forwardRef(
  ({ className: t, ...e }, n) => /* @__PURE__ */ v(
    "table",
    {
      "data-testid": "asterisk-table",
      ref: n,
      className: I("kn-table", Die.base.join(" "), t),
      ...e
    }
  )
), GR = he.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ v(
  "thead",
  {
    "data-testid": "asterisk-table-header",
    ref: n,
    className: I("kn-table-header", Iie.base.join(" "), t),
    ...e
  }
)), YR = he.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ v("tbody", { ref: n, className: t, ...e })), ZR = he.forwardRef(
  ({ className: t, ...e }, n) => /* @__PURE__ */ v(
    "tr",
    {
      "data-testid": "asterisk-table-row",
      ref: n,
      className: I("kn-table-body", _ie.base.join(" "), t),
      ...e
    }
  )
), JR = he.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ v(
  "th",
  {
    "data-testid": "asterisk-table-head",
    ref: n,
    className: I("kn-table-head", Pie.base.join(" "), t),
    ...e
  }
)), XR = he.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ v(
  "td",
  {
    "data-testid": "asterisk-table-cell",
    ref: n,
    className: I("kn-table-cell", Lie.base.join(" "), t),
    ...e
  }
)), mse = Object.assign(KR, {
  Header: GR,
  Body: YR,
  Row: ZR,
  Head: JR,
  Cell: XR,
  Wrapper: qR
});
KR.displayName = "Table";
qR.displayName = "Table.Wrapper";
GR.displayName = "Table.Header";
YR.displayName = "Table.Body";
ZR.displayName = "Table.Row";
JR.displayName = "Table.Head";
XR.displayName = "Table.Cell";
const Fie = {
  intent: {
    default: ["items-center", "border", "border-subtle"],
    page: ["items-start", "w-full"]
  }
}, nS = {
  base: ["inline-flex", "overflow-x-hidden", "justify-between"],
  config: {
    variants: Fie,
    defaultVariants: {
      intent: "default"
    }
  }
}, $ie = {
  intent: {
    default: ["gap-1", "p-1", "text-subtle"],
    page: ["mb-6", "w-full", "border-b-2", "border-b-subtle"]
  }
}, rS = {
  name: "tabs-list",
  base: ["flex"],
  config: {
    variants: $ie,
    defaultVariants: {
      intent: "default"
    }
  }
}, Bie = {
  intent: {
    default: [
      "inline-flex",
      "items-center",
      "justify-center",
      "whitespace-nowrap",
      "px-3",
      "py-1",
      "gap-1",
      "font-medium",
      "transition-all",
      "hover:bg-brand-muted",
      "focus-visible:outline-none",
      "focus-visible:ring-2",
      "focus-visible:ring-default",
      "focus-visible:ring-offset-2",
      "data-[state=active]:bg-brand-subtle",
      "data-[state=active]:text-emphasis"
    ],
    page: [
      "relative",
      "px-4",
      "py-2",
      "data-[state=active]:before:absolute",
      "data-[state=active]:before:left-0",
      "data-[state=active]:before:top-full",
      "data-[state=active]:before:h-[2px]",
      "data-[state=active]:before:w-full"
    ]
  }
}, iS = {
  name: "tabs-trigger",
  base: [
    "group",
    "disabled:opacity-50",
    "disabled:pointer-events-none",
    "disabled:text-subtle",
    "hover:text-emphasis"
  ],
  config: {
    variants: Bie,
    defaultVariants: {
      intent: "default"
    }
  }
}, Vie = {
  intent: {
    default: [],
    page: ["focus-visible:outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-2"]
  }
}, oS = {
  name: "tabs-content",
  base: [],
  config: {
    variants: Vie,
    defaultVariants: {
      intent: "default"
    }
  }
}, zie = Ie(nS.base, nS.config), Hie = Ie(rS.base, rS.config), Wie = Ie(iS.base, iS.config);
function QR({ className: t, intent: e, items: n, shouldDisableResponsive: r, shouldUseGradient: i, ...o }, s) {
  var E;
  const a = xe(), l = Me(null), c = Me(null), u = e === "page" ? 0 : 4, d = 300, [f, h] = pe(n), [p, m] = pe([]), [b, y] = pe(!1), [k, C] = pe(!r), [{ width: x }, S] = pe({
    width: void 0,
    height: void 0
  }), T = bj((M) => {
    r || (S(M), C(!0));
  }, d);
  return xj({
    ref: l,
    onResize: T
  }), uo(() => {
    k && (() => {
      var N;
      if (!l.current || !c.current || ((N = c.current) == null ? void 0 : N.children.length) === 0)
        return;
      const O = x || l.current.clientWidth;
      let L = 0;
      const $ = [], z = [];
      let B = !1;
      const A = c.current.children;
      Array.from(A).forEach((R, _) => {
        const D = R.clientWidth + u, q = n[_], H = _ === n.length - 1 && z.length === 0 ? 0 : 32;
        L + D < O - H ? ($.push(q), L += D) : (z.push(q), R.getAttribute("data-state") === "active" && (B = !0));
      }), h($), m(z), y(B), C(!1);
    })();
  }, [n, k, l, c, x, u]), /* @__PURE__ */ v("div", { ref: s, children: /* @__PURE__ */ F(
    "div",
    {
      "data-testid": "asterisk-tabs-list-container",
      ref: l,
      className: I("kn-tabs-list", zie({ intent: e }), {
        "w-full": !r,
        "rounded-lg": a.theme.appearance.corners === "rounded"
      }),
      children: [
        /* @__PURE__ */ v(
          Vw,
          {
            "data-testid": "asterisk-tabs-list",
            ref: c,
            className: I(Hie({ intent: e, className: t })),
            ...o,
            children: (k ? n : f).map((M, O) => /* @__PURE__ */ v(
              zw,
              {
                "data-testid": "asterisk-tabs-trigger",
                className: I(Wie({ intent: e }), {
                  "data-[state=active]:border-b-gradient dark:data-[state=active]:border-b-gradient2 data-[state=active]:text-brand-gradient dark:data-[state=active]:text-brand-gradient2": i && e === "page",
                  "data-[state=active]:text-brand-default data-[state=active]:before:bg-brand-accent data-[state=active]:hover:text-brand-default": !i && e === "page",
                  "rounded-md": (!e || e === "default") && a.theme.appearance.corners === "rounded",
                  "data-[state=active]:before:rounded-sm": e === "page" && a.theme.appearance.corners === "rounded"
                }),
                value: M.value,
                onClick: () => {
                  M.onClick && M.onClick(), C(!0);
                },
                disabled: M.isDisabled || void 0,
                children: M.children
              },
              `${M.value}-${O}`
            ))
          }
        ),
        !k && p.length > 0 && /* @__PURE__ */ F(Qe, { children: [
          /* @__PURE__ */ v(Qe.Trigger, { asChild: !0, children: /* @__PURE__ */ v(
            Ze,
            {
              "data-testid": "asterisk-tabs-hidden-items-trigger",
              intent: "minimal",
              size: "sm",
              className: I("hover:bg-brand-muted data-[state=open]:bg-brand-muted mr-1", {
                "bg-brand-subtle": b
              }),
              children: /* @__PURE__ */ v(Ze.Icon, { icon: oW })
            }
          ) }),
          /* @__PURE__ */ v(
            Qe.Content,
            {
              "data-testid": "asterisk-tabs-hidden-items-content",
              align: "end",
              alignOffset: -4,
              sideOffset: 4,
              style: { maxWidth: (E = l.current) == null ? void 0 : E.offsetWidth },
              children: /* @__PURE__ */ v(Vw, { "data-testid": "asterisk-tabs-hidden-items-list", children: p.map((M) => {
                var O;
                return /* @__PURE__ */ v(zw, { value: M.value, asChild: !0, children: /* @__PURE__ */ v(
                  Ze,
                  {
                    "data-testid": "asterisk-tabs-hidden-item-trigger",
                    intent: "minimal",
                    className: "data-[state=active]:bg-brand-subtle w-full justify-start",
                    style: { maxWidth: (O = l.current) == null ? void 0 : O.offsetWidth },
                    onClick: () => {
                      M.onClick && M.onClick(), C(!0);
                    },
                    children: /* @__PURE__ */ v("span", { className: "truncate", children: M.children })
                  }
                ) }, M.value);
              }) })
            }
          )
        ] })
      ]
    }
  ) });
}
const jie = Ie(oS.base, oS.config);
function eD({ className: t, intent: e, ...n }, r) {
  return /* @__PURE__ */ v(
    GV,
    {
      "data-testid": "asterisk-tabs-content",
      ref: r,
      className: I("kn-tabs-content", jie({ intent: e, className: t })),
      ...n
    }
  );
}
const gse = Object.assign(KV, {
  List: ce(QR),
  Content: ce(eD)
});
QR.displayName = "Tabs.List";
eD.displayName = "Tabs.Content";
const { Trigger: Uie, Content: qie } = wF, vse = Object.assign(SE, {
  Trigger: ed,
  Content: td
});
Uie.displayName = "Collapsible.Trigger";
qie.displayName = "Collapsible.Content";
function tD({
  percentage: t,
  width: e = 100,
  strokeWidth: n = 5,
  className: r = "",
  foregroundColor: i = [P.brand[400], P.pink[400]],
  backgroundColor: o = "stroke-subtle",
  fillColor: s = "transparent",
  strokeLinecap: a = "round",
  children: l
}, c) {
  const d = e / 2 - n, f = 2 * 3.14 * d, h = f - t / 100 * f;
  let p, m;
  typeof i == "string" ? (p = i, m = i) : [p, m] = i;
  const b = Array.isArray(i) ? `${p}${m}`.replace(/#/g, "") : `${p}`.replace(/#/g, "");
  return /* @__PURE__ */ F(
    "div",
    {
      className: I("kn-progress-ring relative", r),
      style: {
        height: `${e}px`,
        width: `${e}px`
      },
      "data-testid": "asterisk-progress-ring",
      ref: c,
      children: [
        l,
        /* @__PURE__ */ F(
          "svg",
          {
            width: "100%",
            height: "100%",
            version: "1.1",
            viewBox: `0 0 ${e} ${e}`,
            xmlns: "http://www.w3.org/2000/svg",
            children: [
              /* @__PURE__ */ F("linearGradient", { id: b, x1: "0%", y1: "0%", x2: "100%", y2: "100%", children: [
                /* @__PURE__ */ v("stop", { offset: "0%", stopColor: p }),
                /* @__PURE__ */ v("stop", { offset: "100%", stopColor: m })
              ] }),
              /* @__PURE__ */ v(
                "circle",
                {
                  strokeWidth: n,
                  fill: "transparent",
                  className: o,
                  r: d,
                  cx: "50%",
                  cy: "50%",
                  strokeDasharray: `${f} ${f}`
                }
              ),
              /* @__PURE__ */ v(
                "circle",
                {
                  className: "origin-[50%_50%] -rotate-90",
                  strokeWidth: n,
                  fill: s,
                  r: d,
                  cx: "50%",
                  cy: "50%",
                  stroke: `url(#${b})`,
                  strokeLinecap: a,
                  strokeDasharray: `${f} ${f}`,
                  strokeDashoffset: h
                }
              )
            ]
          }
        )
      ]
    }
  );
}
function nD({ children: t, className: e }, n) {
  return /* @__PURE__ */ v(
    "div",
    {
      className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
      "data-testid": "asterisk-progress-ring-text",
      ref: n,
      children: /* @__PURE__ */ v("span", { className: I("font-sm text-emphasis font-medium", e), children: t })
    }
  );
}
const Kie = ce(tD), bse = Object.assign(Kie, {
  Text: ce(nD)
});
tD.displayName = "ProgressRing";
nD.displayName = "ProgressRing.Text";
function yse({ gradientId: t }) {
  const e = Gp[t];
  return e ? /* @__PURE__ */ v(
    "svg",
    {
      style: { width: "0", height: "0", position: "absolute" },
      "aria-hidden": "true",
      focusable: "false",
      "data-testid": "asterisk-svg-gradient",
      children: /* @__PURE__ */ v("linearGradient", { id: `svg-${t}`, x1: "100%", y1: "100%", x2: "0%", y2: "0%", children: e.colors.map((n, r) => /* @__PURE__ */ v("stop", { stopColor: n, offset: e.offsets[r] }, n)) })
    }
  ) : null;
}
const Gie = {
  name: "form",
  base: ["space-y-4"],
  config: {}
}, Yie = {
  name: "form-legend",
  base: ["mb-2", "font-medium", "leading-4"],
  config: {}
}, Zie = {
  name: "form-label",
  base: ["mb-2", "inline-block", "font-medium", "leading-4"],
  config: {}
}, Jie = {
  name: "form-message",
  base: ["mt-2"],
  config: {}
};
function Xie({ children: t, className: e = "", ...n }, r) {
  return /* @__PURE__ */ v(
    "form",
    {
      "data-testid": "asterisk-form",
      ref: r,
      className: I("kn-form", Gie.base.join(" "), e),
      ...n,
      children: t
    }
  );
}
function rD({ ...t }) {
  return /* @__PURE__ */ v("section", { "data-testid": "asterisk-form-section", ...t });
}
function iD({ children: t, ...e }, n) {
  return /* @__PURE__ */ v("fieldset", { "data-testid": "asterisk-form-fieldset", ref: n, ...e, children: t });
}
function oD({ children: t, className: e = "", ...n }) {
  return /* @__PURE__ */ v(
    "legend",
    {
      "data-testid": "asterisk-form-legend",
      className: I("kn-form-legend", Yie.base.join(" "), e),
      ...n,
      children: t
    }
  );
}
function sD({ htmlFor: t, children: e, className: n = "", isRequired: r = !1, ...i }) {
  return /* @__PURE__ */ v(
    yi,
    {
      htmlFor: t,
      className: I("kn-form-label", Zie.base.join(" "), n),
      isRequired: r,
      ...i,
      children: e
    }
  );
}
function aD({ children: t, className: e = "", type: n = "default", ...r }) {
  const i = [Jie.base.join(" "), e];
  return n === "error" ? i.push("text-destructive") : n === "success" ? i.push("success-default") : n === "warning" && i.push("warning-default"), /* @__PURE__ */ v(
    "p",
    {
      "data-testid": "asterisk-form-message",
      className: I("kn-form-message", i),
      ...r,
      children: t
    }
  );
}
const Qie = ce(Xie), wse = Object.assign(Qie, {
  Section: rD,
  Fieldset: ce(iD),
  Legend: oD,
  Label: sD,
  Message: aD
});
rD.displayName = "Form.Section";
iD.displayName = "Form.Fieldset";
oD.displayName = "Form.Legend";
sD.displayName = "Form.Label";
aD.displayName = "Form.Message";
const eoe = {
  name: "pagination-link",
  base: ["size-8", "p-0", "font-medium", "duration-500", "text-default"],
  config: {}
}, toe = {
  name: "pagination-content",
  base: ["flex", "flex-row", "items-center", "gap-1"],
  config: {}
}, noe = {
  name: "pagination-ellipsis",
  base: ["flex", "size-9", "items-center", "justify-center"],
  config: {}
};
function lD({ className: t, ...e }) {
  return /* @__PURE__ */ v(
    "nav",
    {
      "data-testid": "asterisk-pagination",
      role: "navigation",
      "aria-label": "pagination",
      className: I("kn-pagination w-full", t),
      ...e
    }
  );
}
function cD({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    "ul",
    {
      "data-testid": "asterisk-pagination-content",
      ref: n,
      className: I("kn-pagination-content", toe.base.join(" "), t),
      ...e
    }
  );
}
function uD({ className: t, ...e }, n) {
  return /* @__PURE__ */ v(
    "li",
    {
      "data-testid": "asterisk-pagination-item",
      ref: n,
      className: I("kn-pagination-item list-none", t),
      ...e
    }
  );
}
function Ud({ className: t, isActive: e, ...n }) {
  return /* @__PURE__ */ v(
    Ze,
    {
      "data-testid": "asterisk-pagination-link",
      intent: "minimal",
      className: I(eoe.base.join(" "), t, {
        "bg-brand-subtle pointer-events-none": e
      }),
      asChild: !0,
      children: /* @__PURE__ */ v("a", { "aria-label": "Pagination Link", "aria-current": e ? "page" : void 0, ...n })
    }
  );
}
function dD({ className: t, ...e }) {
  return /* @__PURE__ */ v(
    Ud,
    {
      ...e,
      "aria-label": "Go to previous page",
      className: I(t),
      "data-testid": "asterisk-pagination-previous",
      children: /* @__PURE__ */ v(BS, { size: 16 })
    }
  );
}
function fD({ className: t, ...e }) {
  return /* @__PURE__ */ v(
    Ud,
    {
      ...e,
      className: I(t),
      "aria-label": "Go to next page",
      "data-testid": "asterisk-pagination-next",
      children: /* @__PURE__ */ v(BS, { size: 16, className: "rotate-180" })
    }
  );
}
function hD({ className: t, ...e }) {
  return /* @__PURE__ */ F(
    "span",
    {
      "aria-hidden": !0,
      className: I(noe.base.join(" "), t),
      ...e,
      "data-testid": "asterisk-pagination-ellipsis",
      children: [
        /* @__PURE__ */ v(VS, { size: 16, className: "text-default" }),
        /* @__PURE__ */ v("span", { className: "sr-only", children: "More pages" })
      ]
    }
  );
}
const At = Object.assign(lD, {
  Content: ce(cD),
  Item: ce(uD),
  Link: Ud,
  Previous: dD,
  Next: fD,
  Ellipsis: hD
});
uD.displayName = "Pagination.Item";
cD.displayName = "Pagination.Content";
Ud.displayName = "Pagination.Link";
dD.displayName = "Pagination.Previous";
fD.displayName = "Pagination.Next";
hD.displayName = "Pagination.Ellipsis";
lD.displayName = "Pagination";
function xse({
  totalPages: t,
  currentPage: e,
  onPageChange: n,
  maxVisiblePages: r = 5
}) {
  const o = (() => {
    let a = Math.max(1, e - Math.floor(r / 2)), l = a + r - 1;
    return l > t && (l = t, a = Math.max(1, l - r + 1)), t <= r && (a = 1, l = t), Array.from({ length: l - a + 1 }, (c, u) => a + u);
  })(), s = (a) => {
    a !== e && n(a);
  };
  return /* @__PURE__ */ v(At, { children: /* @__PURE__ */ F(At.Content, { children: [
    /* @__PURE__ */ v(At.Item, { children: /* @__PURE__ */ v(
      At.Previous,
      {
        onClick: () => {
          e > 1 && s(e - 1);
        }
      }
    ) }),
    o[0] > 1 && /* @__PURE__ */ F(je, { children: [
      /* @__PURE__ */ v(At.Item, { children: /* @__PURE__ */ v(At.Link, { isActive: e === 1, onClick: () => s(1), children: "1" }) }),
      o[0] > 2 && /* @__PURE__ */ v(At.Item, { children: /* @__PURE__ */ v(At.Ellipsis, {}) })
    ] }),
    o.map((a) => /* @__PURE__ */ v(At.Item, { children: /* @__PURE__ */ v(At.Link, { isActive: a === e, onClick: () => s(a), children: a }) }, a)),
    o[o.length - 1] < t && /* @__PURE__ */ F(je, { children: [
      o[o.length - 1] < t - 1 && /* @__PURE__ */ v(At.Item, { children: /* @__PURE__ */ v(At.Ellipsis, {}) }),
      /* @__PURE__ */ v(At.Item, { children: /* @__PURE__ */ v(
        At.Link,
        {
          isActive: e === t,
          onClick: () => s(t),
          children: t
        }
      ) })
    ] }),
    /* @__PURE__ */ v(At.Item, { children: /* @__PURE__ */ v(
      At.Next,
      {
        onClick: () => {
          e < t && s(e + 1);
        }
      }
    ) })
  ] }) });
}
var Fp, sS;
function roe() {
  return sS || (sS = 1, Fp = {
    aqua: /#00ffff(ff)?(?!\w)|#0ff(f)?(?!\w)/gi,
    azure: /#f0ffff(ff)?(?!\w)/gi,
    beige: /#f5f5dc(ff)?(?!\w)/gi,
    bisque: /#ffe4c4(ff)?(?!\w)/gi,
    black: /#000000(ff)?(?!\w)|#000(f)?(?!\w)/gi,
    blue: /#0000ff(ff)?(?!\w)|#00f(f)?(?!\w)/gi,
    brown: /#a52a2a(ff)?(?!\w)/gi,
    coral: /#ff7f50(ff)?(?!\w)/gi,
    cornsilk: /#fff8dc(ff)?(?!\w)/gi,
    crimson: /#dc143c(ff)?(?!\w)/gi,
    cyan: /#00ffff(ff)?(?!\w)|#0ff(f)?(?!\w)/gi,
    darkblue: /#00008b(ff)?(?!\w)/gi,
    darkcyan: /#008b8b(ff)?(?!\w)/gi,
    darkgrey: /#a9a9a9(ff)?(?!\w)/gi,
    darkred: /#8b0000(ff)?(?!\w)/gi,
    deeppink: /#ff1493(ff)?(?!\w)/gi,
    dimgrey: /#696969(ff)?(?!\w)/gi,
    gold: /#ffd700(ff)?(?!\w)/gi,
    green: /#008000(ff)?(?!\w)/gi,
    grey: /#808080(ff)?(?!\w)/gi,
    honeydew: /#f0fff0(ff)?(?!\w)/gi,
    hotpink: /#ff69b4(ff)?(?!\w)/gi,
    indigo: /#4b0082(ff)?(?!\w)/gi,
    ivory: /#fffff0(ff)?(?!\w)/gi,
    khaki: /#f0e68c(ff)?(?!\w)/gi,
    lavender: /#e6e6fa(ff)?(?!\w)/gi,
    lime: /#00ff00(ff)?(?!\w)|#0f0(f)?(?!\w)/gi,
    linen: /#faf0e6(ff)?(?!\w)/gi,
    maroon: /#800000(ff)?(?!\w)/gi,
    moccasin: /#ffe4b5(ff)?(?!\w)/gi,
    navy: /#000080(ff)?(?!\w)/gi,
    oldlace: /#fdf5e6(ff)?(?!\w)/gi,
    olive: /#808000(ff)?(?!\w)/gi,
    orange: /#ffa500(ff)?(?!\w)/gi,
    orchid: /#da70d6(ff)?(?!\w)/gi,
    peru: /#cd853f(ff)?(?!\w)/gi,
    pink: /#ffc0cb(ff)?(?!\w)/gi,
    plum: /#dda0dd(ff)?(?!\w)/gi,
    purple: /#800080(ff)?(?!\w)/gi,
    red: /#ff0000(ff)?(?!\w)|#f00(f)?(?!\w)/gi,
    salmon: /#fa8072(ff)?(?!\w)/gi,
    seagreen: /#2e8b57(ff)?(?!\w)/gi,
    seashell: /#fff5ee(ff)?(?!\w)/gi,
    sienna: /#a0522d(ff)?(?!\w)/gi,
    silver: /#c0c0c0(ff)?(?!\w)/gi,
    skyblue: /#87ceeb(ff)?(?!\w)/gi,
    snow: /#fffafa(ff)?(?!\w)/gi,
    tan: /#d2b48c(ff)?(?!\w)/gi,
    teal: /#008080(ff)?(?!\w)/gi,
    thistle: /#d8bfd8(ff)?(?!\w)/gi,
    tomato: /#ff6347(ff)?(?!\w)/gi,
    violet: /#ee82ee(ff)?(?!\w)/gi,
    wheat: /#f5deb3(ff)?(?!\w)/gi,
    white: /#ffffff(ff)?(?!\w)|#fff(f)?(?!\w)/gi
  }), Fp;
}
var $p, aS;
function ioe() {
  if (aS) return $p;
  aS = 1;
  var t = roe(), e = {
    whitespace: /\s+/g,
    urlHexPairs: /%[\dA-F]{2}/g,
    quotes: /"/g
  };
  function n(a) {
    return a.trim().replace(e.whitespace, " ");
  }
  function r(a) {
    return encodeURIComponent(a).replace(e.urlHexPairs, o);
  }
  function i(a) {
    return Object.keys(t).forEach(function(l) {
      t[l].test(a) && (a = a.replace(t[l], l));
    }), a;
  }
  function o(a) {
    switch (a) {
      // Browsers tolerate these characters, and they're frequent
      case "%20":
        return " ";
      case "%3D":
        return "=";
      case "%3A":
        return ":";
      case "%2F":
        return "/";
      default:
        return a.toLowerCase();
    }
  }
  function s(a) {
    if (typeof a != "string")
      throw new TypeError("Expected a string, but received " + typeof a);
    a.charCodeAt(0) === 65279 && (a = a.slice(1));
    var l = i(n(a)).replace(e.quotes, "'");
    return "data:image/svg+xml," + r(l);
  }
  return s.toSrcset = function(l) {
    return s(l).replace(/ /g, "%20");
  }, $p = s, $p;
}
var Bp = {}, Vp = {}, lS;
function ooe() {
  return lS || (lS = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    function e(r, i) {
      return {
        handler: r,
        config: i
      };
    }
    e.withOptions = function(r, i = () => ({})) {
      const o = function(s) {
        return {
          __options: s,
          handler: r(s),
          config: i(s)
        };
      };
      return o.__isOptionsFunction = !0, o.__pluginFunction = r, o.__configFunction = i, o;
    };
    const n = e;
  }(Vp)), Vp;
}
var cS;
function soe() {
  return cS || (cS = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const e = /* @__PURE__ */ n(ooe());
    function n(i) {
      return i && i.__esModule ? i : {
        default: i
      };
    }
    const r = e.default;
  }(Bp)), Bp;
}
var zp, uS;
function zb() {
  if (uS) return zp;
  uS = 1;
  let t = soe();
  return zp = (t.__esModule ? t : { default: t }).default, zp;
}
var Hp = {}, Wp = {}, dS;
function aoe() {
  return dS || (dS = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "cloneDeep", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(n) {
      return Array.isArray(n) ? n.map((r) => e(r)) : typeof n == "object" && n !== null ? Object.fromEntries(Object.entries(n).map(([r, i]) => [
        r,
        e(i)
      ])) : n;
    }
  }(Wp)), Wp;
}
var jp, fS;
function loe() {
  return fS || (fS = 1, jp = {
    content: [],
    presets: [],
    darkMode: "media",
    // or 'class'
    theme: {
      accentColor: ({ theme: t }) => ({
        ...t("colors"),
        auto: "auto"
      }),
      animation: {
        none: "none",
        spin: "spin 1s linear infinite",
        ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
        pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
        bounce: "bounce 1s infinite"
      },
      aria: {
        busy: 'busy="true"',
        checked: 'checked="true"',
        disabled: 'disabled="true"',
        expanded: 'expanded="true"',
        hidden: 'hidden="true"',
        pressed: 'pressed="true"',
        readonly: 'readonly="true"',
        required: 'required="true"',
        selected: 'selected="true"'
      },
      aspectRatio: {
        auto: "auto",
        square: "1 / 1",
        video: "16 / 9"
      },
      backdropBlur: ({ theme: t }) => t("blur"),
      backdropBrightness: ({ theme: t }) => t("brightness"),
      backdropContrast: ({ theme: t }) => t("contrast"),
      backdropGrayscale: ({ theme: t }) => t("grayscale"),
      backdropHueRotate: ({ theme: t }) => t("hueRotate"),
      backdropInvert: ({ theme: t }) => t("invert"),
      backdropOpacity: ({ theme: t }) => t("opacity"),
      backdropSaturate: ({ theme: t }) => t("saturate"),
      backdropSepia: ({ theme: t }) => t("sepia"),
      backgroundColor: ({ theme: t }) => t("colors"),
      backgroundImage: {
        none: "none",
        "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
        "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
        "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
        "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
        "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
        "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
        "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
        "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
      },
      backgroundOpacity: ({ theme: t }) => t("opacity"),
      backgroundPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      backgroundSize: {
        auto: "auto",
        cover: "cover",
        contain: "contain"
      },
      blur: {
        0: "0",
        none: "",
        sm: "4px",
        DEFAULT: "8px",
        md: "12px",
        lg: "16px",
        xl: "24px",
        "2xl": "40px",
        "3xl": "64px"
      },
      borderColor: ({ theme: t }) => ({
        ...t("colors"),
        DEFAULT: t("colors.gray.200", "currentColor")
      }),
      borderOpacity: ({ theme: t }) => t("opacity"),
      borderRadius: {
        none: "0px",
        sm: "0.125rem",
        DEFAULT: "0.25rem",
        md: "0.375rem",
        lg: "0.5rem",
        xl: "0.75rem",
        "2xl": "1rem",
        "3xl": "1.5rem",
        full: "9999px"
      },
      borderSpacing: ({ theme: t }) => ({
        ...t("spacing")
      }),
      borderWidth: {
        DEFAULT: "1px",
        0: "0px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      boxShadow: {
        sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
        DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
        md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
        xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
        "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
        inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
        none: "none"
      },
      boxShadowColor: ({ theme: t }) => t("colors"),
      brightness: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      caretColor: ({ theme: t }) => t("colors"),
      colors: ({ colors: t }) => ({
        inherit: t.inherit,
        current: t.current,
        transparent: t.transparent,
        black: t.black,
        white: t.white,
        slate: t.slate,
        gray: t.gray,
        zinc: t.zinc,
        neutral: t.neutral,
        stone: t.stone,
        red: t.red,
        orange: t.orange,
        amber: t.amber,
        yellow: t.yellow,
        lime: t.lime,
        green: t.green,
        emerald: t.emerald,
        teal: t.teal,
        cyan: t.cyan,
        sky: t.sky,
        blue: t.blue,
        indigo: t.indigo,
        violet: t.violet,
        purple: t.purple,
        fuchsia: t.fuchsia,
        pink: t.pink,
        rose: t.rose
      }),
      columns: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        "3xs": "16rem",
        "2xs": "18rem",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem"
      },
      container: {},
      content: {
        none: "none"
      },
      contrast: {
        0: "0",
        50: ".5",
        75: ".75",
        100: "1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      cursor: {
        auto: "auto",
        default: "default",
        pointer: "pointer",
        wait: "wait",
        text: "text",
        move: "move",
        help: "help",
        "not-allowed": "not-allowed",
        none: "none",
        "context-menu": "context-menu",
        progress: "progress",
        cell: "cell",
        crosshair: "crosshair",
        "vertical-text": "vertical-text",
        alias: "alias",
        copy: "copy",
        "no-drop": "no-drop",
        grab: "grab",
        grabbing: "grabbing",
        "all-scroll": "all-scroll",
        "col-resize": "col-resize",
        "row-resize": "row-resize",
        "n-resize": "n-resize",
        "e-resize": "e-resize",
        "s-resize": "s-resize",
        "w-resize": "w-resize",
        "ne-resize": "ne-resize",
        "nw-resize": "nw-resize",
        "se-resize": "se-resize",
        "sw-resize": "sw-resize",
        "ew-resize": "ew-resize",
        "ns-resize": "ns-resize",
        "nesw-resize": "nesw-resize",
        "nwse-resize": "nwse-resize",
        "zoom-in": "zoom-in",
        "zoom-out": "zoom-out"
      },
      divideColor: ({ theme: t }) => t("borderColor"),
      divideOpacity: ({ theme: t }) => t("borderOpacity"),
      divideWidth: ({ theme: t }) => t("borderWidth"),
      dropShadow: {
        sm: "0 1px 1px rgb(0 0 0 / 0.05)",
        DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
        md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
        lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
        xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
        "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
        none: "0 0 #0000"
      },
      fill: ({ theme: t }) => ({
        none: "none",
        ...t("colors")
      }),
      flex: {
        1: "1 1 0%",
        auto: "1 1 auto",
        initial: "0 1 auto",
        none: "none"
      },
      flexBasis: ({ theme: t }) => ({
        auto: "auto",
        ...t("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%"
      }),
      flexGrow: {
        0: "0",
        DEFAULT: "1"
      },
      flexShrink: {
        0: "0",
        DEFAULT: "1"
      },
      fontFamily: {
        sans: [
          "ui-sans-serif",
          "system-ui",
          "sans-serif",
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
          '"Noto Color Emoji"'
        ],
        serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
        mono: [
          "ui-monospace",
          "SFMono-Regular",
          "Menlo",
          "Monaco",
          "Consolas",
          '"Liberation Mono"',
          '"Courier New"',
          "monospace"
        ]
      },
      fontSize: {
        xs: ["0.75rem", { lineHeight: "1rem" }],
        sm: ["0.875rem", { lineHeight: "1.25rem" }],
        base: ["1rem", { lineHeight: "1.5rem" }],
        lg: ["1.125rem", { lineHeight: "1.75rem" }],
        xl: ["1.25rem", { lineHeight: "1.75rem" }],
        "2xl": ["1.5rem", { lineHeight: "2rem" }],
        "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
        "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
        "5xl": ["3rem", { lineHeight: "1" }],
        "6xl": ["3.75rem", { lineHeight: "1" }],
        "7xl": ["4.5rem", { lineHeight: "1" }],
        "8xl": ["6rem", { lineHeight: "1" }],
        "9xl": ["8rem", { lineHeight: "1" }]
      },
      fontWeight: {
        thin: "100",
        extralight: "200",
        light: "300",
        normal: "400",
        medium: "500",
        semibold: "600",
        bold: "700",
        extrabold: "800",
        black: "900"
      },
      gap: ({ theme: t }) => t("spacing"),
      gradientColorStops: ({ theme: t }) => t("colors"),
      gradientColorStopPositions: {
        "0%": "0%",
        "5%": "5%",
        "10%": "10%",
        "15%": "15%",
        "20%": "20%",
        "25%": "25%",
        "30%": "30%",
        "35%": "35%",
        "40%": "40%",
        "45%": "45%",
        "50%": "50%",
        "55%": "55%",
        "60%": "60%",
        "65%": "65%",
        "70%": "70%",
        "75%": "75%",
        "80%": "80%",
        "85%": "85%",
        "90%": "90%",
        "95%": "95%",
        "100%": "100%"
      },
      grayscale: {
        0: "0",
        DEFAULT: "100%"
      },
      gridAutoColumns: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridAutoRows: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridColumn: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridColumnEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridColumnStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRow: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridRowEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRowStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridTemplateColumns: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      gridTemplateRows: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      height: ({ theme: t }) => ({
        auto: "auto",
        ...t("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      hueRotate: {
        0: "0deg",
        15: "15deg",
        30: "30deg",
        60: "60deg",
        90: "90deg",
        180: "180deg"
      },
      inset: ({ theme: t }) => ({
        auto: "auto",
        ...t("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      invert: {
        0: "0",
        DEFAULT: "100%"
      },
      keyframes: {
        spin: {
          to: {
            transform: "rotate(360deg)"
          }
        },
        ping: {
          "75%, 100%": {
            transform: "scale(2)",
            opacity: "0"
          }
        },
        pulse: {
          "50%": {
            opacity: ".5"
          }
        },
        bounce: {
          "0%, 100%": {
            transform: "translateY(-25%)",
            animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
          },
          "50%": {
            transform: "none",
            animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
          }
        }
      },
      letterSpacing: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0em",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
      },
      lineHeight: {
        none: "1",
        tight: "1.25",
        snug: "1.375",
        normal: "1.5",
        relaxed: "1.625",
        loose: "2",
        3: ".75rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem"
      },
      listStyleType: {
        none: "none",
        disc: "disc",
        decimal: "decimal"
      },
      listStyleImage: {
        none: "none"
      },
      margin: ({ theme: t }) => ({
        auto: "auto",
        ...t("spacing")
      }),
      lineClamp: {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6"
      },
      maxHeight: ({ theme: t }) => ({
        ...t("spacing"),
        none: "none",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      maxWidth: ({ theme: t, breakpoints: e }) => ({
        ...t("spacing"),
        none: "none",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content",
        prose: "65ch",
        ...e(t("screens"))
      }),
      minHeight: ({ theme: t }) => ({
        ...t("spacing"),
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      minWidth: ({ theme: t }) => ({
        ...t("spacing"),
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      objectPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      opacity: {
        0: "0",
        5: "0.05",
        10: "0.1",
        15: "0.15",
        20: "0.2",
        25: "0.25",
        30: "0.3",
        35: "0.35",
        40: "0.4",
        45: "0.45",
        50: "0.5",
        55: "0.55",
        60: "0.6",
        65: "0.65",
        70: "0.7",
        75: "0.75",
        80: "0.8",
        85: "0.85",
        90: "0.9",
        95: "0.95",
        100: "1"
      },
      order: {
        first: "-9999",
        last: "9999",
        none: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12"
      },
      outlineColor: ({ theme: t }) => t("colors"),
      outlineOffset: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      outlineWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      padding: ({ theme: t }) => t("spacing"),
      placeholderColor: ({ theme: t }) => t("colors"),
      placeholderOpacity: ({ theme: t }) => t("opacity"),
      ringColor: ({ theme: t }) => ({
        DEFAULT: t("colors.blue.500", "#3b82f6"),
        ...t("colors")
      }),
      ringOffsetColor: ({ theme: t }) => t("colors"),
      ringOffsetWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      ringOpacity: ({ theme: t }) => ({
        DEFAULT: "0.5",
        ...t("opacity")
      }),
      ringWidth: {
        DEFAULT: "3px",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      rotate: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg",
        45: "45deg",
        90: "90deg",
        180: "180deg"
      },
      saturate: {
        0: "0",
        50: ".5",
        100: "1",
        150: "1.5",
        200: "2"
      },
      scale: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5"
      },
      screens: {
        sm: "640px",
        md: "768px",
        lg: "1024px",
        xl: "1280px",
        "2xl": "1536px"
      },
      scrollMargin: ({ theme: t }) => ({
        ...t("spacing")
      }),
      scrollPadding: ({ theme: t }) => t("spacing"),
      sepia: {
        0: "0",
        DEFAULT: "100%"
      },
      skew: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg"
      },
      space: ({ theme: t }) => ({
        ...t("spacing")
      }),
      spacing: {
        px: "1px",
        0: "0px",
        0.5: "0.125rem",
        1: "0.25rem",
        1.5: "0.375rem",
        2: "0.5rem",
        2.5: "0.625rem",
        3: "0.75rem",
        3.5: "0.875rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem",
        11: "2.75rem",
        12: "3rem",
        14: "3.5rem",
        16: "4rem",
        20: "5rem",
        24: "6rem",
        28: "7rem",
        32: "8rem",
        36: "9rem",
        40: "10rem",
        44: "11rem",
        48: "12rem",
        52: "13rem",
        56: "14rem",
        60: "15rem",
        64: "16rem",
        72: "18rem",
        80: "20rem",
        96: "24rem"
      },
      stroke: ({ theme: t }) => ({
        none: "none",
        ...t("colors")
      }),
      strokeWidth: {
        0: "0",
        1: "1",
        2: "2"
      },
      supports: {},
      data: {},
      textColor: ({ theme: t }) => t("colors"),
      textDecorationColor: ({ theme: t }) => t("colors"),
      textDecorationThickness: {
        auto: "auto",
        "from-font": "from-font",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      textIndent: ({ theme: t }) => ({
        ...t("spacing")
      }),
      textOpacity: ({ theme: t }) => t("opacity"),
      textUnderlineOffset: {
        auto: "auto",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      transformOrigin: {
        center: "center",
        top: "top",
        "top-right": "top right",
        right: "right",
        "bottom-right": "bottom right",
        bottom: "bottom",
        "bottom-left": "bottom left",
        left: "left",
        "top-left": "top left"
      },
      transitionDelay: {
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionDuration: {
        DEFAULT: "150ms",
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionProperty: {
        none: "none",
        all: "all",
        DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
        colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
        opacity: "opacity",
        shadow: "box-shadow",
        transform: "transform"
      },
      transitionTimingFunction: {
        DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
        linear: "linear",
        in: "cubic-bezier(0.4, 0, 1, 1)",
        out: "cubic-bezier(0, 0, 0.2, 1)",
        "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
      },
      translate: ({ theme: t }) => ({
        ...t("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      size: ({ theme: t }) => ({
        auto: "auto",
        ...t("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      width: ({ theme: t }) => ({
        auto: "auto",
        ...t("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        screen: "100vw",
        svw: "100svw",
        lvw: "100lvw",
        dvw: "100dvw",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      willChange: {
        auto: "auto",
        scroll: "scroll-position",
        contents: "contents",
        transform: "transform"
      },
      zIndex: {
        auto: "auto",
        0: "0",
        10: "10",
        20: "20",
        30: "30",
        40: "40",
        50: "50"
      }
    },
    plugins: []
  }), jp;
}
var hS;
function coe() {
  return hS || (hS = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const e = aoe(), n = /* @__PURE__ */ r(loe());
    function r(o) {
      return o && o.__esModule ? o : {
        default: o
      };
    }
    const i = (0, e.cloneDeep)(n.default.theme);
  }(Hp)), Hp;
}
var Up, pS;
function uoe() {
  if (pS) return Up;
  pS = 1;
  let t = coe();
  return Up = (t.__esModule ? t : { default: t }).default, Up;
}
var qp, mS;
function doe() {
  if (mS) return qp;
  mS = 1;
  const t = ioe(), e = zb(), n = uoe(), r = OS(), [i, { lineHeight: o }] = n.fontSize.base, { spacing: s, borderWidth: a, borderRadius: l } = n;
  function c(d, f) {
    return d.replace("<alpha-value>", `var(${f}, 1)`);
  }
  return qp = e.withOptions(function(d = { strategy: void 0 }) {
    return function({ addBase: f, addComponents: h, theme: p }) {
      function m(C, x) {
        let S = p(C);
        return !S || S.includes("var(") ? x : S.replace("<alpha-value>", "1");
      }
      const b = d.strategy === void 0 ? ["base", "class"] : [d.strategy], y = [
        {
          base: [
            "[type='text']",
            "input:where(:not([type]))",
            "[type='email']",
            "[type='url']",
            "[type='password']",
            "[type='number']",
            "[type='date']",
            "[type='datetime-local']",
            "[type='month']",
            "[type='search']",
            "[type='tel']",
            "[type='time']",
            "[type='week']",
            "[multiple]",
            "textarea",
            "select"
          ],
          class: [".form-input", ".form-textarea", ".form-select", ".form-multiselect"],
          styles: {
            appearance: "none",
            "background-color": "#fff",
            "border-color": c(
              p("colors.gray.500", r.gray[500]),
              "--tw-border-opacity"
            ),
            "border-width": a.DEFAULT,
            "border-radius": l.none,
            "padding-top": s[2],
            "padding-right": s[3],
            "padding-bottom": s[2],
            "padding-left": s[3],
            "font-size": i,
            "line-height": o,
            "--tw-shadow": "0 0 #0000",
            "&:focus": {
              outline: "2px solid transparent",
              "outline-offset": "2px",
              "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
              "--tw-ring-offset-width": "0px",
              "--tw-ring-offset-color": "#fff",
              "--tw-ring-color": c(
                p("colors.blue.600", r.blue[600]),
                "--tw-ring-opacity"
              ),
              "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
              "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
              "box-shadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)",
              "border-color": c(
                p("colors.blue.600", r.blue[600]),
                "--tw-border-opacity"
              )
            }
          }
        },
        {
          base: ["input::placeholder", "textarea::placeholder"],
          class: [".form-input::placeholder", ".form-textarea::placeholder"],
          styles: {
            color: c(p("colors.gray.500", r.gray[500]), "--tw-text-opacity"),
            opacity: "1"
          }
        },
        {
          base: ["::-webkit-datetime-edit-fields-wrapper"],
          class: [".form-input::-webkit-datetime-edit-fields-wrapper"],
          styles: {
            padding: "0"
          }
        },
        {
          // Unfortunate hack until https://bugs.webkit.org/show_bug.cgi?id=198959 is fixed.
          // This sucks because users can't change line-height with a utility on date inputs now.
          // Reference: https://github.com/twbs/bootstrap/pull/31993
          base: ["::-webkit-date-and-time-value"],
          class: [".form-input::-webkit-date-and-time-value"],
          styles: {
            "min-height": "1.5em"
          }
        },
        {
          // In Safari on iOS date and time inputs are centered instead of left-aligned and can't be
          // changed with `text-align` utilities on the input by default. Resetting this to `inherit`
          // makes them left-aligned by default and makes it possible to override the alignment with
          // utility classes without using an arbitrary variant to target the pseudo-elements.
          base: ["::-webkit-date-and-time-value"],
          class: [".form-input::-webkit-date-and-time-value"],
          styles: {
            "text-align": "inherit"
          }
        },
        {
          // In Safari on macOS date time inputs that are set to `display: block` have unexpected
          // extra bottom spacing. This can be corrected by setting the `::-webkit-datetime-edit`
          // pseudo-element to `display: inline-flex`, instead of the browser default of
          // `display: inline-block`.
          base: ["::-webkit-datetime-edit"],
          class: [".form-input::-webkit-datetime-edit"],
          styles: {
            display: "inline-flex"
          }
        },
        {
          // In Safari on macOS date time inputs are 4px taller than normal inputs
          // This is because there is extra padding on the datetime-edit and datetime-edit-{part}-field pseudo elements
          // See https://github.com/tailwindlabs/tailwindcss-forms/issues/95
          base: [
            "::-webkit-datetime-edit",
            "::-webkit-datetime-edit-year-field",
            "::-webkit-datetime-edit-month-field",
            "::-webkit-datetime-edit-day-field",
            "::-webkit-datetime-edit-hour-field",
            "::-webkit-datetime-edit-minute-field",
            "::-webkit-datetime-edit-second-field",
            "::-webkit-datetime-edit-millisecond-field",
            "::-webkit-datetime-edit-meridiem-field"
          ],
          class: [
            ".form-input::-webkit-datetime-edit",
            ".form-input::-webkit-datetime-edit-year-field",
            ".form-input::-webkit-datetime-edit-month-field",
            ".form-input::-webkit-datetime-edit-day-field",
            ".form-input::-webkit-datetime-edit-hour-field",
            ".form-input::-webkit-datetime-edit-minute-field",
            ".form-input::-webkit-datetime-edit-second-field",
            ".form-input::-webkit-datetime-edit-millisecond-field",
            ".form-input::-webkit-datetime-edit-meridiem-field"
          ],
          styles: {
            "padding-top": 0,
            "padding-bottom": 0
          }
        },
        {
          base: ["select"],
          class: [".form-select"],
          styles: {
            "background-image": `url("${t(
              `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path stroke="${m(
                "colors.gray.500",
                r.gray[500]
              )}" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 8l4 4 4-4"/></svg>`
            )}")`,
            "background-position": `right ${s[2]} center`,
            "background-repeat": "no-repeat",
            "background-size": "1.5em 1.5em",
            "padding-right": s[10],
            "print-color-adjust": "exact"
          }
        },
        {
          base: ["[multiple]", '[size]:where(select:not([size="1"]))'],
          class: ['.form-select:where([size]:not([size="1"]))'],
          styles: {
            "background-image": "initial",
            "background-position": "initial",
            "background-repeat": "unset",
            "background-size": "initial",
            "padding-right": s[3],
            "print-color-adjust": "unset"
          }
        },
        {
          base: ["[type='checkbox']", "[type='radio']"],
          class: [".form-checkbox", ".form-radio"],
          styles: {
            appearance: "none",
            padding: "0",
            "print-color-adjust": "exact",
            display: "inline-block",
            "vertical-align": "middle",
            "background-origin": "border-box",
            "user-select": "none",
            "flex-shrink": "0",
            height: s[4],
            width: s[4],
            color: c(p("colors.blue.600", r.blue[600]), "--tw-text-opacity"),
            "background-color": "#fff",
            "border-color": c(
              p("colors.gray.500", r.gray[500]),
              "--tw-border-opacity"
            ),
            "border-width": a.DEFAULT,
            "--tw-shadow": "0 0 #0000"
          }
        },
        {
          base: ["[type='checkbox']"],
          class: [".form-checkbox"],
          styles: {
            "border-radius": l.none
          }
        },
        {
          base: ["[type='radio']"],
          class: [".form-radio"],
          styles: {
            "border-radius": "100%"
          }
        },
        {
          base: ["[type='checkbox']:focus", "[type='radio']:focus"],
          class: [".form-checkbox:focus", ".form-radio:focus"],
          styles: {
            outline: "2px solid transparent",
            "outline-offset": "2px",
            "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
            "--tw-ring-offset-width": "2px",
            "--tw-ring-offset-color": "#fff",
            "--tw-ring-color": c(
              p("colors.blue.600", r.blue[600]),
              "--tw-ring-opacity"
            ),
            "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
            "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
            "box-shadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)"
          }
        },
        {
          base: ["[type='checkbox']:checked", "[type='radio']:checked"],
          class: [".form-checkbox:checked", ".form-radio:checked"],
          styles: {
            "border-color": "transparent",
            "background-color": "currentColor",
            "background-size": "100% 100%",
            "background-position": "center",
            "background-repeat": "no-repeat"
          }
        },
        {
          base: ["[type='checkbox']:checked"],
          class: [".form-checkbox:checked"],
          styles: {
            "background-image": `url("${t(
              '<svg viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><path d="M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z"/></svg>'
            )}")`,
            "@media (forced-colors: active) ": {
              appearance: "auto"
            }
          }
        },
        {
          base: ["[type='radio']:checked"],
          class: [".form-radio:checked"],
          styles: {
            "background-image": `url("${t(
              '<svg viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="3"/></svg>'
            )}")`,
            "@media (forced-colors: active) ": {
              appearance: "auto"
            }
          }
        },
        {
          base: [
            "[type='checkbox']:checked:hover",
            "[type='checkbox']:checked:focus",
            "[type='radio']:checked:hover",
            "[type='radio']:checked:focus"
          ],
          class: [
            ".form-checkbox:checked:hover",
            ".form-checkbox:checked:focus",
            ".form-radio:checked:hover",
            ".form-radio:checked:focus"
          ],
          styles: {
            "border-color": "transparent",
            "background-color": "currentColor"
          }
        },
        {
          base: ["[type='checkbox']:indeterminate"],
          class: [".form-checkbox:indeterminate"],
          styles: {
            "background-image": `url("${t(
              '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h8"/></svg>'
            )}")`,
            "border-color": "transparent",
            "background-color": "currentColor",
            "background-size": "100% 100%",
            "background-position": "center",
            "background-repeat": "no-repeat",
            "@media (forced-colors: active) ": {
              appearance: "auto"
            }
          }
        },
        {
          base: ["[type='checkbox']:indeterminate:hover", "[type='checkbox']:indeterminate:focus"],
          class: [".form-checkbox:indeterminate:hover", ".form-checkbox:indeterminate:focus"],
          styles: {
            "border-color": "transparent",
            "background-color": "currentColor"
          }
        },
        {
          base: ["[type='file']"],
          class: null,
          styles: {
            background: "unset",
            "border-color": "inherit",
            "border-width": "0",
            "border-radius": "0",
            padding: "0",
            "font-size": "unset",
            "line-height": "inherit"
          }
        },
        {
          base: ["[type='file']:focus"],
          class: null,
          styles: {
            outline: ["1px solid ButtonText", "1px auto -webkit-focus-ring-color"]
          }
        }
      ], k = (C) => y.map((x) => x[C] === null ? null : { [x[C]]: x.styles }).filter(Boolean);
      b.includes("base") && f(k("base")), b.includes("class") && h(k("class"));
    };
  }), qp;
}
var foe = doe();
const hoe = /* @__PURE__ */ ki(foe);
var Kp, gS;
function poe() {
  if (gS) return Kp;
  gS = 1;
  const t = zb();
  function e(n) {
    return Object.fromEntries(
      Object.entries(n).filter(([r]) => r !== "DEFAULT")
    );
  }
  return Kp = t(
    ({ addUtilities: n, matchUtilities: r, theme: i }) => {
      n({
        "@keyframes enter": i("keyframes.enter"),
        "@keyframes exit": i("keyframes.exit"),
        ".animate-in": {
          animationName: "enter",
          animationDuration: i("animationDuration.DEFAULT"),
          "--tw-enter-opacity": "initial",
          "--tw-enter-scale": "initial",
          "--tw-enter-rotate": "initial",
          "--tw-enter-translate-x": "initial",
          "--tw-enter-translate-y": "initial"
        },
        ".animate-out": {
          animationName: "exit",
          animationDuration: i("animationDuration.DEFAULT"),
          "--tw-exit-opacity": "initial",
          "--tw-exit-scale": "initial",
          "--tw-exit-rotate": "initial",
          "--tw-exit-translate-x": "initial",
          "--tw-exit-translate-y": "initial"
        }
      }), r(
        {
          "fade-in": (o) => ({ "--tw-enter-opacity": o }),
          "fade-out": (o) => ({ "--tw-exit-opacity": o })
        },
        { values: i("animationOpacity") }
      ), r(
        {
          "zoom-in": (o) => ({ "--tw-enter-scale": o }),
          "zoom-out": (o) => ({ "--tw-exit-scale": o })
        },
        { values: i("animationScale") }
      ), r(
        {
          "spin-in": (o) => ({ "--tw-enter-rotate": o }),
          "spin-out": (o) => ({ "--tw-exit-rotate": o })
        },
        { values: i("animationRotate") }
      ), r(
        {
          "slide-in-from-top": (o) => ({
            "--tw-enter-translate-y": `-${o}`
          }),
          "slide-in-from-bottom": (o) => ({
            "--tw-enter-translate-y": o
          }),
          "slide-in-from-left": (o) => ({
            "--tw-enter-translate-x": `-${o}`
          }),
          "slide-in-from-right": (o) => ({
            "--tw-enter-translate-x": o
          }),
          "slide-out-to-top": (o) => ({
            "--tw-exit-translate-y": `-${o}`
          }),
          "slide-out-to-bottom": (o) => ({
            "--tw-exit-translate-y": o
          }),
          "slide-out-to-left": (o) => ({
            "--tw-exit-translate-x": `-${o}`
          }),
          "slide-out-to-right": (o) => ({
            "--tw-exit-translate-x": o
          })
        },
        { values: i("animationTranslate") }
      ), r(
        { duration: (o) => ({ animationDuration: o }) },
        { values: e(i("animationDuration")) }
      ), r(
        { delay: (o) => ({ animationDelay: o }) },
        { values: i("animationDelay") }
      ), r(
        { ease: (o) => ({ animationTimingFunction: o }) },
        { values: e(i("animationTimingFunction")) }
      ), n({
        ".running": { animationPlayState: "running" },
        ".paused": { animationPlayState: "paused" }
      }), r(
        { "fill-mode": (o) => ({ animationFillMode: o }) },
        { values: i("animationFillMode") }
      ), r(
        { direction: (o) => ({ animationDirection: o }) },
        { values: i("animationDirection") }
      ), r(
        { repeat: (o) => ({ animationIterationCount: o }) },
        { values: i("animationRepeat") }
      );
    },
    {
      theme: {
        extend: {
          animationDelay: ({ theme: n }) => ({
            ...n("transitionDelay")
          }),
          animationDuration: ({ theme: n }) => ({
            0: "0ms",
            ...n("transitionDuration")
          }),
          animationTimingFunction: ({ theme: n }) => ({
            ...n("transitionTimingFunction")
          }),
          animationFillMode: {
            none: "none",
            forwards: "forwards",
            backwards: "backwards",
            both: "both"
          },
          animationDirection: {
            normal: "normal",
            reverse: "reverse",
            alternate: "alternate",
            "alternate-reverse": "alternate-reverse"
          },
          animationOpacity: ({ theme: n }) => ({
            DEFAULT: 0,
            ...n("opacity")
          }),
          animationTranslate: ({ theme: n }) => ({
            DEFAULT: "100%",
            ...n("translate")
          }),
          animationScale: ({ theme: n }) => ({
            DEFAULT: 0,
            ...n("scale")
          }),
          animationRotate: ({ theme: n }) => ({
            DEFAULT: "30deg",
            ...n("rotate")
          }),
          animationRepeat: {
            0: "0",
            1: "1",
            infinite: "infinite"
          },
          keyframes: {
            enter: {
              from: {
                opacity: "var(--tw-enter-opacity, 1)",
                transform: "translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0))"
              }
            },
            exit: {
              to: {
                opacity: "var(--tw-exit-opacity, 1)",
                transform: "translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0))"
              }
            }
          }
        }
      }
    }
  ), Kp;
}
var moe = poe();
const goe = /* @__PURE__ */ ki(moe);
var voe = zb();
const pD = /* @__PURE__ */ ki(voe);
function Mr(t, e = []) {
  return Object.fromEntries(
    Object.entries(t).reduce(
      (n, [r, i], o, s) => {
        const a = e.concat(r);
        if (r === "DEFAULT" && typeof i == "string") {
          const l = s.find((u) => u.length > 0 && u[1] === i);
          if (!l || !l.length) return n;
          const c = `var(--${a[0]}-${l[0]})`;
          return Yp(i) ? n.push([r, `rgb(${c} / <alpha-value>)`]) : n.push([r, c]), n;
        }
        return typeof i != "string" ? n.push([r, Mr(i, a)]) : Yp(i) ? n.push([r, `rgb(var(--${a.join("-")}) / <alpha-value>)`]) : n.push([r, `var(--${a.join("-")})`]), n;
      },
      []
    )
  );
}
const boe = pD.withOptions(
  // eslint-disable-next-line func-names
  () => function() {
  },
  (t) => {
    const { colorTokens: e } = t;
    return {
      theme: {
        extend: {
          colors: {
            ...Mr(P)
          },
          backgroundColor: {
            ...Mr(e.light).bg
          },
          backgroundImage: {
            ...Mr(e.gradients)
          },
          textColor: {
            ...Mr(e.light).content
          },
          borderColor: {
            ...Mr(e.light).border
          },
          ringColor: {
            ...Mr(e.light).ring
          },
          stroke: {
            ...Mr(e.light).stroke
          },
          outlineColor: {
            ...Mr(e.light).ring
          }
        }
      }
    };
  }
), kse = {
  content: [],
  darkMode: ["selector", '[data-theme="dark"]'],
  theme: {
    extend: {
      keyframes: {
        slideDownAndFade: {
          from: { opacity: "0", transform: "translateY(-5px)" },
          to: { opacity: "1", transform: "translateY(0)" }
        },
        slideLeftAndFade: {
          from: { opacity: "0", transform: "translateX(5px)" },
          to: { opacity: "1", transform: "translateX(0)" }
        },
        slideUpAndFade: {
          from: { opacity: "0", transform: "translateY(5px)" },
          to: { opacity: "1", transform: "translateY(0)" }
        },
        slideRightAndFade: {
          from: { opacity: "0", transform: "translateX(5px)" },
          to: { opacity: "1", transform: "translateX(0)" }
        }
      },
      animation: {
        slideDownAndFade: "slideDownAndFade 400ms cubic-bezier(0.16, 1, 0.3, 1)",
        slideLeftAndFade: "slideLeftAndFade 400ms cubic-bezier(0.16, 1, 0.3, 1)",
        slideUpAndFade: "slideUpAndFade 400ms cubic-bezier(0.16, 1, 0.3, 1)",
        slideRightAndFade: "slideRightAndFade 400ms cubic-bezier(0.16, 1, 0.3, 1)"
      },
      transitionDuration: {
        400: "400ms"
      },
      borderRadius: {
        md: "5px"
      },
      backgroundPosition: {
        animation: "100% 0"
      },
      backgroundSize: {
        "action-gradient": "300% 100%"
      },
      fontSize: {
        // sm is no longer needed, as it's now the same as the default/base size
        base: ["0.875rem", { lineHeight: "1.25rem" }],
        // Override the default 'base' size to 14px
        md: ["1rem", { lineHeight: "1.5rem" }]
      }
    },
    fontFamily: {
      body: ["Inter", "sans-serif"]
    }
  },
  plugins: [
    // The order matters. Ensure `themePlugin` is always the first plugin
    boe({ colorTokens: J }),
    hoe,
    goe,
    pD(({ addBase: t, theme: e, addUtilities: n }) => {
      var s;
      const r = (s = e("fontSize")) == null ? void 0 : s.base, [i, { lineHeight: o }] = r;
      t({
        "textarea, input, select": {
          fontSize: i,
          lineHeight: o
        }
      }), n({
        ".border-b-gradient": {
          "@apply from-brand-600 before:from-brand-600 to-pink-400 before:to-pink-400 text-brand relative bg-gradient-to-r bg-clip-text text-transparent before:absolute before:left-0 before:top-full before:h-[2px] before:w-full before:rounded-sm before:bg-gradient-to-r": {}
        },
        ".border-b-gradient2": {
          "@apply from-brand-400 before:from-brand-400 to-pink-400 before:to-pink-400 text-brand relative bg-gradient-to-r bg-clip-text text-transparent before:absolute before:left-0 before:top-full before:h-[2px] before:w-full before:rounded-sm before:bg-gradient-to-r": {}
        },
        ".text-brand-gradient": {
          "@apply from-brand-600 to-pink-400 text-brand relative bg-gradient-to-r bg-clip-text text-transparent": {}
        },
        ".text-brand-gradient2": {
          "@apply from-brand-400 to-pink-400 text-brand relative bg-gradient-to-r bg-clip-text text-transparent": {}
        }
      });
    })
  ]
};
function Cse(t) {
  return t.version === Go.version;
}
function Sse(t) {
  const e = { ...t };
  return e.version === Go.version || (e.version === 1 && (e.version = 2, e.updatedOn = (/* @__PURE__ */ new Date()).toISOString(), e.shouldAllowModeToggle = !0, e.colors = {
    preset: t.colors.preset,
    customTokens: null
  }, e.background = {
    light: "",
    dark: ""
  }, e.font = Go.font, e.tables = {
    border: "rows-only",
    hasMaxHeight: !1,
    maxHeightPx: 600,
    rowSpacing: "default",
    hasAlternateRowColor: !0,
    hasHoverRowColor: !0
  }, e.appearance = {
    corners: "rounded",
    shadowsInCards: !0
  }), e.version === 2 && (e.version = 3, delete e.mainNavContainer.showOnlyAllowedPages), e.version === 3 && (e.version = 4, e.mainNavContainer.appTitle.size = "small")), e;
}
export {
  Soe as AsteriskLogo,
  qw as Avatar,
  hI as Badge,
  Ioe as Banner,
  Ze as Button,
  G0 as Calendar,
  jS as Card,
  kE as Chart,
  wx as Checkbox,
  Zh as Chip,
  vse as Collapsible,
  ise as Combobox,
  Xoe as DatePicker,
  es as DateTimeInput,
  nse as DateTimePicker,
  Joe as Dialog,
  um as Divider,
  Qe as DropdownMenu,
  wse as Form,
  hn as Input,
  qoe as InputPassword,
  Koe as InputSearch,
  Goe as InputWithDisabledText,
  Toe as KnackLogo,
  yi as Label,
  hse as MultiSelect,
  At as Pagination,
  lt as Popover,
  Yoe as Progress,
  bse as ProgressRing,
  sse as RadioCardGroup,
  ose as RadioGroup,
  ase as Rating,
  bie as RichTextEditor,
  CR as RichTextRenderer,
  qr as Select,
  xse as SimplePagination,
  fse as Skeleton,
  Zoe as Slider,
  IS as Spinner,
  yse as SvgGradient,
  pse as Switch,
  mse as Table,
  gse as Tabs,
  rse as Textarea,
  Doe as ThemeProvider,
  DS as ThemeProviderContext,
  Ll as Toast,
  joe as Toaster,
  Wt as Tooltip,
  QD as amberTokens,
  Ooe as appWidth,
  Gz as avatarFallbackStyle,
  Kz as avatarImageStyle,
  Uw as avatarStyle,
  sy as badgeStyle,
  cy as bannerStyle,
  eI as blueTokens,
  _D as buttonIconLeftStyle,
  PD as buttonIconRightStyle,
  ID as buttonIconStyle,
  DD as buttonOutlineGradientContentStyle,
  jb as buttonStyle,
  Ub as buttonVariants,
  uy as cardStyle,
  yx as checkboxStyle,
  yU as chipStyle,
  P as colorPalette,
  Jj as comboBoxContentStyle,
  Sx as comboBoxTriggerStyle,
  aI as customAppTheme,
  tI as cyanTokens,
  tse as datePickerDateFormats,
  ese as datePickerTimeFormats,
  Go as defaultAppTheme,
  kse as defaultPreset,
  Roe as defaultTheming,
  J as defaultTokens,
  GH as dialogCloseStyle,
  Qw as dialogContentStyle,
  ZH as dialogDescriptionStyle,
  ex as dialogFooterStyle,
  JH as dialogHeaderStyle,
  KH as dialogOverlayStyle,
  YH as dialogTitleStyle,
  tF as dividerCenterStyle,
  QL as dividerLeftSideStyle,
  eF as dividerRightSideStyle,
  XL as dividerWrapperStyle,
  nH as dropdownMenuCheckboxItemStyle,
  tH as dropdownMenuItemStyle,
  rH as dropdownMenuLabelStyle,
  iH as dropdownMenuSeparatorStyle,
  Uoe as dropdownMenuShortcutStyle,
  Xz as dropdownMenuStyle,
  eH as dropdownMenuSubContentStyle,
  Qz as dropdownMenuSubTriggerStyle,
  oH as dropdownMenuTriggerStyle,
  Zie as formLabelStyle,
  Yie as formLegendStyle,
  Jie as formMessageStyle,
  Gie as formStyle,
  nI as fuchsiaTokens,
  iy as generateCssVariables,
  rI as greenTokens,
  Kw as inputStyle,
  MH as inputWithDisabledTextLeftStyle,
  OH as inputWithDisabledTextRightStyle,
  EH as inputWithDisabledTextStyle,
  Cse as isThemeUpToDate,
  Tx as labelStyle,
  iI as limeTokens,
  Sse as migrateTheme,
  XC as multiSelectContentStyle,
  JC as multiSelectTriggerStyle,
  Moe as navigationLayout,
  toe as paginationContentStyle,
  noe as paginationEllipsisStyle,
  eoe as paginationLinkStyle,
  oI as pinkTokens,
  Zw as popoverStyle,
  Eoe as presetNames,
  RH as progressRootStyle,
  Yw as progressStyle,
  aU as radioCardGroupItemStyle,
  kA as radioGroupItemStyle,
  pU as ratingContainerStyle,
  Mx as ratingStarStyle,
  dse as selectContainerStyle,
  Wre as selectContentStyle,
  Kre as selectHintStyle,
  Ure as selectItemStyle,
  jre as selectLabelStyle,
  qre as selectSeparatorStyle,
  UC as selectStyle,
  wie as skeletonImageStyle,
  ZC as skeletonStyle,
  xie as skeletonVideoStyle,
  VH as sliderRootStyle,
  Jw as sliderStyle,
  Xw as sliderThumbStyle,
  zH as sliderTrackStyle,
  oy as spinnerStyle,
  eS as switchRootStyle,
  tS as switchThumbStyle,
  Lie as tableCellStyle,
  Pie as tableHeadStyle,
  Iie as tableHeaderStyle,
  _ie as tableRowStyle,
  Die as tableStyle,
  Rie as tableWrapperStyle,
  oS as tabsContentStyle,
  rS as tabsListStyle,
  iS as tabsTriggerStyle,
  vx as textareaStyle,
  Noe as themeModeStorageKey,
  Aoe as themeModes,
  Wz as toastViewportStyle,
  Ox as tooltipStyle,
  Rv as useToast,
  sI as violetTokens
};
